webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(399);
	module.exports = __webpack_require__(361);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.analyticsConfig = undefined;
	
	var _assign = __webpack_require__(76);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.initializeAnalytics = initializeAnalytics;
	exports.currentTime = currentTime;
	exports.setUserId = setUserId;
	
	var _vue = __webpack_require__(74);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _router = __webpack_require__(75);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var analytics = {
	  currentTime: currentTime,
	  setUserId: setUserId
	};
	
	var analyticsConfig = exports.analyticsConfig = {
	  router: _router2.default,
	  autoTracking: {
	    exception: true
	  },
	  onReady: initializeAnalytics
	};
	
	function initializeAnalytics() {
	  _vue2.default.$ga.time('Initialization', 'analytics', currentTime());
	  analytics = (0, _assign2.default)(analytics, _vue2.default.$ga);
	}
	
	function currentTime() {
	  return Math.round(window.performance.now());
	}
	
	function setUserId(userId) {
	  _vue2.default.$ga.set('userId', userId);
	}
	
	exports.default = analytics;

/***/ },
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendMessage = exports.userAddressServiceUpdate = exports.userAddressServiceRetrieve = exports.userAddressUpdate = exports.userAddressRetrieve = exports.userAccountUpdate = exports.userAccountRegister = exports.apigClientFactory = exports.AWS = undefined;
	
	var _awsSdk = __webpack_require__(289);
	
	var _awsSdk2 = _interopRequireDefault(_awsSdk);
	
	var _awsApiGatewayClient = __webpack_require__(226);
	
	var _awsApiGatewayClient2 = _interopRequireDefault(_awsApiGatewayClient);
	
	var _user = __webpack_require__(360);
	
	var _address = __webpack_require__(357);
	
	var _service = __webpack_require__(359);
	
	var _message = __webpack_require__(358);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AWS = _awsSdk2.default;
	exports.apigClientFactory = _awsApiGatewayClient2.default;
	exports.userAccountRegister = _user.userAccountRegister;
	exports.userAccountUpdate = _user.userAccountUpdate;
	exports.userAddressRetrieve = _address.userAddressRetrieve;
	exports.userAddressUpdate = _address.userAddressUpdate;
	exports.userAddressServiceRetrieve = _service.userAddressServiceRetrieve;
	exports.userAddressServiceUpdate = _service.userAddressServiceUpdate;
	exports.sendMessage = _message.sendMessage;

/***/ },
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFirstRoute = exports.router = exports.mainPage = exports.loginPage = exports.landingPage = undefined;
	
	var _routes = __webpack_require__(163);
	
	Object.defineProperty(exports, 'landingPage', {
	  enumerable: true,
	  get: function get() {
	    return _routes.landingPage;
	  }
	});
	Object.defineProperty(exports, 'loginPage', {
	  enumerable: true,
	  get: function get() {
	    return _routes.loginPage;
	  }
	});
	Object.defineProperty(exports, 'mainPage', {
	  enumerable: true,
	  get: function get() {
	    return _routes.mainPage;
	  }
	});
	
	var _workflow = __webpack_require__(364);
	
	Object.defineProperty(exports, 'getFirstRoute', {
	  enumerable: true,
	  get: function get() {
	    return _workflow.getFirstRoute;
	  }
	});
	
	var _vue = __webpack_require__(74);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(865);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _authGuard = __webpack_require__(362);
	
	var _authGuard2 = _interopRequireDefault(_authGuard);
	
	var _profileGuard = __webpack_require__(363);
	
	var _profileGuard2 = _interopRequireDefault(_profileGuard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var appRouter = new _vueRouter2.default({
	  'mode': 'history',
	  'routes': _routes2.default
	});
	
	var router = exports.router = appRouter;
	exports.default = appRouter;
	
	
	appRouter.beforeEach(_authGuard2.default);
	appRouter.beforeEach(_profileGuard2.default);

/***/ },
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = undefined;
	
	var _vue = __webpack_require__(74);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(45);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _auth = __webpack_require__(376);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _api = __webpack_require__(367);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _app = __webpack_require__(369);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _config = __webpack_require__(378);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = ("production") !== 'production';
	
	_vue2.default.use(_vuex2.default);
	
	var state = {};
	
	var getters = {};
	
	var actions = {};
	
	var mutations = {};
	
	var store = exports.store = new _vuex2.default.Store({
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations,
	  modules: {
	    'auth': _auth2.default,
	    'api': _api2.default,
	    'app': _app2.default,
	    'config': _config2.default
	  },
	  strict: debug
	});
	
	exports.default = store;

/***/ },
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var MaskedInput = exports.MaskedInput = {
	  name: 'mask',
	
	  bind: function bind(el, binding, vnode) {
	    var config = binding.value;
	
	    if (config.returnUnmasked === undefined) config.returnUnmasked = false;
	
	    function forwardComplete() {
	      if (vnode.data.on.maskinput) {
	        if (config.returnUnmasked) {
	          vnode.data.on.maskinput(el.inputmask.unmaskedvalue());
	        } else {
	          vnode.data.on.maskinput(el.value);
	        }
	      }
	    }
	
	    config.oncomplete = forwardComplete;
	
	    window.Inputmask(config).mask(el);
	  }
	};
	
	exports.default = MaskedInput;

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routes = exports.loginPage = exports.mainPage = exports.landingPage = undefined;
	
	var _Login = __webpack_require__(840);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Account = __webpack_require__(839);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _newUser = __webpack_require__(365);
	
	var _newUser2 = _interopRequireDefault(_newUser);
	
	var _sendMessage = __webpack_require__(366);
	
	var _sendMessage2 = _interopRequireDefault(_sendMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routeList = [{ path: '/login', name: 'login', component: _Login2.default, alias: '/', meta: { requiresAuth: false } }, { path: '/account', name: 'account', component: _Account2.default, meta: { requiresAuth: true } }, _newUser2.default, _sendMessage2.default, { path: '*', name: '404', redirect: { name: 'account' } }];
	
	var landingPage = exports.landingPage = '/newUser';
	var mainPage = exports.mainPage = '/account';
	var loginPage = exports.loginPage = '/login';
	var routes = exports.routes = routeList;
	exports.default = routeList;

/***/ },
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(626)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(386),
	  /* template */
	  __webpack_require__(858),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(616)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(392),
	  /* template */
	  __webpack_require__(848),
	  /* scopeId */
	  "data-v-05dccc13",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userAddressRetrieve = userAddressRetrieve;
	exports.userAddressUpdate = userAddressUpdate;
	
	var _analytics = __webpack_require__(35);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function userAddressRetrieve(apiClient, userId, addressIndex) {
	  var pathTemplate = '/address';
	  var method = 'GET';
	  var params = {};
	  var additionalParams = {
	    queryParams: {
	      userId: userId,
	      addressIndex: addressIndex
	    }
	  };
	  var body = {};
	
	  console.log('Calling %s on %s', method, pathTemplate);
	  var start = _analytics2.default.currentTime();
	  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body).then(function (result) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'retrieve-address', end - start, 'success');
	    return result.data;
	  }).catch(function (error) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'retrieve-address', end - start, 'error');
	    console.log('Error retrieving user address %j', error);
	    throw error;
	  });
	}
	
	function userAddressUpdate(apiClient, userId, addressInfo) {
	  var pathTemplate = '/address';
	  var method = 'POST';
	  var params = {};
	  var additionalParams = {};
	  var body = addressInfo;
	
	  body.userId = userId;
	
	  console.log('Calling %s on %s', method, pathTemplate);
	  var start = _analytics2.default.currentTime();
	  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body).then(function (result) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'update-address', end - start, 'success');
	    return result.data;
	  }).catch(function (error) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'update-address', end - start, 'error');
	    console.log('Error retrieving address %j', error);
	    throw error;
	  });
	}

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendMessage = sendMessage;
	
	var _analytics = __webpack_require__(35);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function sendMessage(apiClient, userId, emailAddress, fullName, serviceYear, address, selected, notes, message) {
	  var pathTemplate = '/message';
	  var method = 'POST';
	  var params = {};
	  var additionalParams = {};
	  var body = {
	    userId: userId,
	    emailAddress: emailAddress,
	    fullName: fullName,
	    serviceYear: serviceYear,
	    address: address,
	    selected: selected,
	    notes: notes
	  };
	
	  if (message) body.message = message;
	
	  console.log('Calling %s on %s', method, pathTemplate);
	  var start = _analytics2.default.currentTime();
	  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body).then(function (result) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'send-message', end - start, 'success');
	    return result.data;
	  }).catch(function (error) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'send-message', end - start, 'error');
	    console.log('Error sending message %j', error);
	    throw error;
	  });
	}

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userAddressServiceRetrieve = userAddressServiceRetrieve;
	exports.userAddressServiceUpdate = userAddressServiceUpdate;
	
	var _analytics = __webpack_require__(35);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function userAddressServiceRetrieve(apiClient, userId, addressIndex, serviceYear) {
	  var pathTemplate = '/service';
	  var method = 'GET';
	  var params = {};
	  var additionalParams = {
	    queryParams: {
	      userId: userId,
	      addressIndex: addressIndex,
	      serviceYear: serviceYear
	    }
	  };
	  var body = {};
	
	  console.log('Calling %s on %s', method, pathTemplate);
	  var start = _analytics2.default.currentTime();
	  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body).then(function (result) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'retrieve-service', end - start, 'success');
	    return result.data;
	  }).catch(function (error) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'retrieve-service', end - start, 'error');
	    throw error;
	  });
	}
	
	function userAddressServiceUpdate(apiClient, userId, serviceInfo) {
	  var pathTemplate = '/service';
	  var method = 'POST';
	  var params = {};
	  var additionalParams = {};
	  var body = serviceInfo;
	
	  body.userId = userId;
	
	  console.log('Calling %s on %s', method, pathTemplate);
	  var start = _analytics2.default.currentTime();
	  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body).then(function (result) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'update-service', end - start, 'success');
	    return result.data;
	  }).catch(function (error) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'update-service', end - start, 'error');
	    console.log('Error retrieving service %j', error);
	    throw error;
	  });
	}

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userAccountRegister = userAccountRegister;
	exports.userAccountUpdate = userAccountUpdate;
	
	var _analytics = __webpack_require__(35);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function userAccountRegister(apiClient, cognitoId, emailAddress) {
	  var pathTemplate = '/register';
	  var method = 'POST';
	  var params = {};
	  var additionalParams = {};
	  var body = {
	    cognitoId: cognitoId,
	    emailAddress: emailAddress
	  };
	
	  console.log('Calling %s on %s', method, pathTemplate);
	  var start = _analytics2.default.currentTime();
	  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body).then(function (result) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'retrieve-user', end - start, 'success');
	    return result.data;
	  }).catch(function (error) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'retrieve-user', end - start, 'error');
	    console.log('Error retrieving user account %j', error);
	    throw error;
	  });
	}
	
	function userAccountUpdate(apiClient, accountInfo) {
	  var pathTemplate = '/user';
	  var method = 'POST';
	  var params = {};
	  var additionalParams = {};
	  var body = accountInfo;
	
	  console.log('Calling %s on %s', method, pathTemplate);
	  var start = _analytics2.default.currentTime();
	  return apiClient.invokeApi(params, pathTemplate, method, additionalParams, body).then(function (result) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'update-user', end - start, 'success');
	    return result.data;
	  }).catch(function (error) {
	    var end = _analytics2.default.currentTime();
	    _analytics2.default.time('API', 'update-user', end - start, 'success');
	    console.log('Error retrieving user account %j', error);
	    throw error;
	  });
	}

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(41);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(74);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueAnalytics = __webpack_require__(830);
	
	var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);
	
	var _vuexRouterSync = __webpack_require__(866);
	
	__webpack_require__(633);
	
	__webpack_require__(614);
	
	var _App = __webpack_require__(831);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(96);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(75);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _analytics = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _vuexRouterSync.sync)(_store2.default, _router2.default);
	
	_vue2.default.use(_vueAnalytics2.default, (0, _extends3.default)({
	  id: _store2.default.getters.googleAnalyticsId,
	  samepleRate: _store2.default.getters.googleAnalyticsSampleRate,
	  siteSpeedSampleRate: _store2.default.getters.googleAnalyticsSpeedSampleRate
	}, _analytics.analyticsConfig));
	
	window.vm = new _vue2.default({
	  el: '#app',
	  store: _store2.default,
	  router: _router2.default,
	  template: '<App/>',
	  components: { App: _App2.default },
	  beforeCreate: _analytics.initializeAnalytics
	});

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (to, from, next) {
	  var store = _store2.default;
	
	  if (to.matched.some(function (record) {
	    return record.meta.requiresAuth;
	  })) {
	    if (!store.getters.loggedIn) {
	      next({
	        path: '/login',
	        query: { redirect: to.fullPath }
	      });
	    } else {
	      next();
	    }
	  } else {
	    next();
	  }
	};
	
	var _store = __webpack_require__(96);
	
	var _store2 = _interopRequireDefault(_store);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (to, from, next) {
	  var store = _store2.default;
	
	  if (to.matched.some(function (record) {
	    return record.meta.requiresAuth;
	  })) {
	    if (!store.getters.accountRetrieved) {
	      console.log('Need to retrieve account details here!');
	      store.dispatch('userAccountRegister').then(function () {
	        next();
	      }).catch(function () {
	        next(false);
	      });
	    } else {
	      next();
	    }
	  } else {
	    next();
	  }
	};
	
	var _store = __webpack_require__(96);
	
	var _store2 = _interopRequireDefault(_store);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFirstRoute = getFirstRoute;
	
	var _routes = __webpack_require__(163);
	
	function getFirstRoute(validationRequired, newUser, redirectPage) {
	  if (validationRequired || newUser) return _routes.landingPage;
	  if (redirectPage) return redirectPage;
	  return _routes.mainPage;
	}
	
	exports.default = getFirstRoute;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newUserRoute = undefined;
	
	var _Workflow = __webpack_require__(212);
	
	var _Workflow2 = _interopRequireDefault(_Workflow);
	
	var _Welcome = __webpack_require__(846);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _UserInfo = __webpack_require__(845);
	
	var _UserInfo2 = _interopRequireDefault(_UserInfo);
	
	var _AddressInfo = __webpack_require__(841);
	
	var _AddressInfo2 = _interopRequireDefault(_AddressInfo);
	
	var _ServiceChoices = __webpack_require__(843);
	
	var _ServiceChoices2 = _interopRequireDefault(_ServiceChoices);
	
	var _ServiceNotes = __webpack_require__(844);
	
	var _ServiceNotes2 = _interopRequireDefault(_ServiceNotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workflowSteps = 5;
	
	var newUserRoute = exports.newUserRoute = {
	  path: '/newUser',
	  name: 'newUser',
	  component: _Workflow2.default,
	  meta: {
	    requiresAuth: true
	  },
	  children: [{
	    path: 'welcome',
	    component: _Welcome2.default,
	    alias: '',
	    meta: {
	      requiresAuth: true,
	      nextRoute: '/newUser/userInfo',
	      workflowSteps: workflowSteps,
	      currentStep: 1,
	      navButton: 'Continue',
	      inputValid: true
	    }
	  }, {
	    path: 'userInfo',
	    component: _UserInfo2.default,
	    meta: {
	      requiresAuth: true,
	      nextRoute: '/newUser/addressInfo',
	      workflowSteps: workflowSteps,
	      currentStep: 2,
	      navButton: 'Looks Good!',
	      inputValid: 'userInputValid'
	    }
	  }, {
	    path: 'addressInfo',
	    component: _AddressInfo2.default,
	    meta: {
	      requiresAuth: true,
	      nextRoute: 'service',
	      workflowSteps: workflowSteps,
	      currentStep: 3,
	      navButton: 'Show Me My Choices',
	      inputValid: 'addressInputValid'
	    }
	  }, {
	    path: 'service',
	    component: _ServiceChoices2.default,
	    meta: {
	      requiresAuth: true,
	      nextRoute: 'notes',
	      workflowSteps: workflowSteps,
	      currentStep: 4,
	      navButton: 'On to Notes',
	      inputValid: true
	    }
	  }, {
	    path: 'notes',
	    component: _ServiceNotes2.default,
	    meta: {
	      requiresAuth: true,
	      nextRoute: '/account?submit=true',
	      workflowSteps: workflowSteps,
	      currentStep: 5,
	      navButton: 'Submit',
	      inputValid: true,
	      beforeRouteLeave: workflowExit
	    }
	  }]
	};
	
	function workflowExit(to, from, next, context) {
	  if (to.name === 'account' && to.query.submit) {
	    context.setLoading();
	
	    context.$store.commit('updateNewUser', false);
	    context.$store.commit('updateValidationRequired', false);
	
	    context.$store.dispatch('userAccountUpdate').then(function (result) {
	      console.log('Successfully updated account data: %j', result);
	      next();
	    }).catch(function (reason) {
	      console.log('Updating account data failed: %j', reason);
	
	      context.clearLoading();
	      next(false);
	    });
	
	    context.$store.dispatch('userAddressUpdate').then(function (result) {
	      console.log('Successfully updated address data: %j', result);
	      next();
	    }).catch(function (reason) {
	      console.log('Updating address data failed: %j', reason);
	
	      context.clearLoading();
	      next(false);
	    });
	
	    context.$store.dispatch('userServiceUpdate').then(function (result) {
	      console.log('Successfully updated service data: %j', result);
	      next();
	    }).catch(function (reason) {
	      console.log('Updating service data failed: %j', reason);
	
	      context.clearLoading();
	      next(false);
	    });
	
	    context.$store.dispatch('messageSend').then(function (result) {
	      console.log('Successfully sent the service submission message');
	      next();
	    }).catch(function (reason) {
	      console.log('Sending service submission message failed: %j', reason);
	
	      context.clearLoading();
	      next(false);
	    });
	  } else {
	    next();
	  }
	}
	
	exports.default = newUserRoute;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sendMessageRoute = undefined;
	
	var _Workflow = __webpack_require__(212);
	
	var _Workflow2 = _interopRequireDefault(_Workflow);
	
	var _SendMessage = __webpack_require__(842);
	
	var _SendMessage2 = _interopRequireDefault(_SendMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workflowSteps = 1;
	
	var sendMessageRoute = exports.sendMessageRoute = {
	  path: '/sendMessage',
	  name: 'sendMessage',
	  component: _Workflow2.default,
	  meta: {
	    requiresAuth: true
	  },
	  children: [{
	    path: 'message',
	    alias: '',
	    component: _SendMessage2.default,
	    meta: {
	      requiresAuth: true,
	      nextRoute: '/account?submit=true',
	      backRoute: '/account',
	      workflowSteps: workflowSteps,
	      currentStep: 1,
	      navButton: 'Send Message',
	      backNavLink: 'Back to Account',
	      heading: 'Send Us a Message',
	      inputValid: 'messageInputValid',
	      beforeRouteLeave: workflowExit
	    }
	  }]
	};
	
	function workflowExit(to, from, next, context) {
	  if (to.query.submit) {
	    context.setLoading();
	
	    context.$store.dispatch('messageSend').then(function (result) {
	      console.log('Successfully sent the message');
	      next();
	    }).catch(function (reason) {
	      console.log('Sending message failed: %j', reason);
	      context.clearLoading();
	      next(false);
	    });
	  } else {
	    context.$store.commit('clearMessage');
	    next();
	  }
	}
	
	exports.default = sendMessageRoute;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _analytics = __webpack_require__(35);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _api = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultCredentials = {
	  identityId: '',
	  accessKeyId: '',
	  secretAccessKey: '',
	  sessionToken: '',
	  expireTime: ''
	};
	
	var defaultApiClient = {};
	
	var apiStore = {
	  state: {
	    credentials: defaultCredentials,
	    apiClient: defaultApiClient
	  },
	  getters: {
	    loggedIn: function loggedIn(state) {
	      return state.credentials.identityId;
	    },
	    apiClient: function apiClient(state) {
	      return state.apiClient;
	    },
	    credentials: function credentials(state) {
	      return state.credentials;
	    }
	  },
	  mutations: {
	    updateCognitoCredentials: function updateCognitoCredentials(state, credentials) {
	      state.credentials.identityId = credentials.identityId;
	      state.credentials.accessKeyId = credentials.accessKeyId;
	      state.credentials.secretAccessKey = credentials.secretAccessKey;
	      state.credentials.sessionToken = credentials.sessionToken;
	      state.credentials.expireTime = credentials.expireTime;
	    },
	    createAPIClient: function createAPIClient(state, additionalConfig) {
	      var config = {
	        invokeUrl: additionalConfig.apiEndpoint,
	        accessKey: state.credentials.accessKeyId,
	        secretKey: state.credentials.secretAccessKey,
	        sessionToken: state.credentials.sessionToken
	      };
	
	      state.apiClient = _api.apigClientFactory.newClient(config);
	    },
	    resetAPIClient: function resetAPIClient(state) {
	      state.apiClient = defaultApiClient;
	    }
	  },
	  actions: {
	    getCognitoCredentials: function getCognitoCredentials(context) {
	      _api.AWS.config.region = context.getters.awsRegion;
	
	      _api.AWS.config.credentials = new _api.AWS.CognitoIdentityCredentials({
	        IdentityPoolId: context.getters.cognitoIdentityPoolId,
	        Logins: context.getters.loginTokens
	      });
	      console.log('AWS Credentials updated: %O', _api.AWS.config.credentials.params);
	      _analytics2.default.setUserId(_api.AWS.config.credentials.params.IdentityId);
	
	      var start = _analytics2.default.currentTime();
	      _api.AWS.config.credentials.get(function (err) {
	        var end = _analytics2.default.currentTime();
	        if (err) {
	          _analytics2.default.time('API', 'retrieve-credentials', end - start, 'error');
	          console.log('Error occurred retrieving credentials: %O', err);
	
	          _api.AWS.config.credentials.clearCachedId();
	
	          context.commit('updateCognitoCredentials', defaultCredentials);
	          context.commit('resetAPIClient');
	        } else {
	          _analytics2.default.time('API', 'credentials', end - start, 'success');
	          console.log('Successfully retrieved AWS Cognito credentials: %O', _api.AWS.config.credentials);
	
	          context.commit('updateGivenName', context.getters.authFirstName);
	          context.commit('updateSurName', context.getters.authLastName);
	          context.commit('updateEmailAddress', context.getters.authEmailAddress);
	
	          context.commit('updateCognitoCredentials', _api.AWS.config.credentials);
	          context.commit('createAPIClient', {
	            apiEndpoint: context.getters.apiGatewayEndpoint
	          });
	          context.dispatch('onLogin');
	        }
	      });
	    }
	  }
	};
	
	exports.default = apiStore;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _validator = __webpack_require__(199);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _api = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addressApiStore = {
	  state: {
	    addressIndex: 0,
	    line1: '',
	    line2: '',
	    city: '',
	    state: '',
	    zip: '',
	    lastModified: 0
	  },
	  getters: {
	    address: function address(state) {
	      return state;
	    },
	    addressIndex: function addressIndex(state) {
	      return state.addressIndex;
	    },
	    addressLastModified: function addressLastModified(state) {
	      var timestamp = new Date(state.lastModifiedDate);
	      return timestamp.toString();
	    },
	    line1: function line1(state) {
	      return state.line1;
	    },
	    line2: function line2(state) {
	      return state.line2;
	    },
	    city: function city(state) {
	      return state.city;
	    },
	    state: function state(_state) {
	      return _state.state;
	    },
	    zip: function zip(state) {
	      return state.zip;
	    },
	    line1Valid: function line1Valid(state, getters) {
	      return getters.line1.length > 0;
	    },
	    line2Valid: function line2Valid(state, getters) {
	      return true;
	    },
	    cityValid: function cityValid(state, getters) {
	      return getters.city.length > 0;
	    },
	    stateValid: function stateValid(state, getters) {
	      return getters.state.length > 0;
	    },
	    zipValid: function zipValid(state, getters) {
	      var zip = getters.zip;
	      return zip.length > 0 && _validator2.default.matches(zip, getters.zipRegex);
	    },
	    addressInputValid: function addressInputValid(state, getters) {
	      return getters.line1Valid && getters.line2Valid && getters.cityValid && getters.stateValid && getters.zipValid;
	    }
	  },
	  mutations: {
	    updateAddressIndex: function updateAddressIndex(state, addressIndex) {
	      state.addressIndex = addressIndex;
	    },
	    updateAddress1: function updateAddress1(state, line1) {
	      state.line1 = line1 || '';
	    },
	    updateAddress2: function updateAddress2(state, line2) {
	      state.line2 = line2 || '';
	    },
	    updateCity: function updateCity(state, city) {
	      state.city = city || '';
	    },
	    updateState: function updateState(state, province) {
	      state.state = province || '';
	    },
	    updateZip: function updateZip(state, zip) {
	      state.zip = zip || '';
	    },
	    updateAddressLastModified: function updateAddressLastModified(state, lastModified) {
	      state.lastModified = lastModified;
	    }
	  },
	  actions: {
	    updateAddressState: function updateAddressState(context, addressInfo) {
	      context.commit('updateAddressIndex', addressInfo.addressIndex);
	      context.commit('updateAddress1', addressInfo.line1);
	      context.commit('updateAddress2', addressInfo.line2);
	      context.commit('updateCity', addressInfo.city);
	      context.commit('updateState', addressInfo.state);
	      context.commit('updateZip', addressInfo.zip);
	      context.commit('updateAddressLastModified', addressInfo.lastModified);
	    },
	    userAddressRetrieve: function userAddressRetrieve(context) {
	      var apiClient = context.getters.apiClient;
	      var userId = context.getters.userId;
	      var addressIndex = context.getters.addressIndex;
	
	      return (0, _api.userAddressRetrieve)(apiClient, userId, addressIndex).then(function (addressInfo) {
	        context.dispatch('updateAddressState', addressInfo);
	        console.log('Retrieved address data: %j', addressInfo);
	        return addressInfo;
	      }).catch(function (error) {
	        throw error;
	      });
	    },
	    userAddressUpdate: function userAddressUpdate(context) {
	      var apiClient = context.getters.apiClient;
	      var addressInfo = context.getters.address;
	      var userId = context.getters.userId;
	
	      return (0, _api.userAddressUpdate)(apiClient, userId, addressInfo).then(function (addressInfo) {
	        context.dispatch('updateAddressState', addressInfo);
	        console.log('Retrieved address data: %j', addressInfo);
	        return addressInfo;
	      }).catch(function (error) {
	        throw error;
	      });
	    }
	  }
	};
	
	exports.default = addressApiStore;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(75);
	
	var _user = __webpack_require__(372);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _address = __webpack_require__(368);
	
	var _address2 = _interopRequireDefault(_address);
	
	var _service = __webpack_require__(371);
	
	var _service2 = _interopRequireDefault(_service);
	
	var _message = __webpack_require__(370);
	
	var _message2 = _interopRequireDefault(_message);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appStore = {
	  modules: {
	    'address': _address2.default,
	    'message': _message2.default,
	    'service': _service2.default,
	    'user': _user2.default
	  },
	  actions: {
	    onLogin: function onLogin(context) {
	      var redirectPage = context.rootState.route.query.redirect;
	      if (context.getters.loggedIn) {
	        context.dispatch('userAccountRegister').then(function () {
	          var targetPage = (0, _router.getFirstRoute)(context.getters.validationRequired, context.getters.newUser, redirectPage);
	          console.log('Logged in now! Redirect to %s', targetPage);
	          _router.router.push(targetPage);
	        });
	      } else {
	        console.log('Logged out now :( Redirect to the Login page (%s)', _router.loginPage);
	        _router.router.push(_router.loginPage);
	      }
	    }
	  }
	};
	
	exports.default = appStore;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _api = __webpack_require__(69);
	
	var userApiStore = {
	  state: {
	    message: ''
	  },
	  getters: {
	    message: function message(state) {
	      return state.message;
	    },
	    messageValid: function messageValid(state) {
	      return state.message.length > 0;
	    },
	    messageInputValid: function messageInputValid(state, getters) {
	      return getters.messageValid;
	    }
	  },
	  mutations: {
	    updateMessage: function updateMessage(state, message) {
	      state.message = message;
	    },
	    clearMessage: function clearMessage(state) {
	      state.message = '';
	    }
	  },
	  actions: {
	    messageSend: function messageSend(context) {
	      var apiClient = context.getters.apiClient;
	      var userId = context.getters.userId;
	      var emailAddress = context.getters.emailAddress;
	      var fullName = context.getters.fullName;
	      var serviceYear = context.getters.serviceYear;
	      var address = context.getters.address;
	      var selected = context.getters.services;
	      var notes = context.getters.notes;
	      var messageIncluded = context.getters.message !== undefined;
	      var message = messageIncluded ? context.getters.message : undefined;
	
	      return (0, _api.sendMessage)(apiClient, userId, emailAddress, fullName, serviceYear, address, selected, notes, message).then(function (result) {
	        if (messageIncluded) context.commit('clearMessage');
	        console.log('Send message result: %j', result);
	        return result;
	      }).catch(function (error) {
	        throw error;
	      });
	    }
	  }
	};
	
	exports.default = userApiStore;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(76);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _api = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var serviceApiStore = {
	  state: {
	    selected: [],
	    notes: '',
	    addressIndex: 0,
	    serviceYear: new Date().getFullYear(),
	    lastModified: 0
	  },
	  getters: {
	    springCleanup: function springCleanup(state) {
	      return state.selected.includes('springCleanup');
	    },
	    summerMaintenance: function summerMaintenance(state) {
	      return state.selected.includes('summerMaintenance');
	    },
	    fallCleanup: function fallCleanup(state) {
	      return state.selected.includes('fallCleanup');
	    },
	    notes: function notes(state) {
	      return state.notes;
	    },
	    services: function services(state) {
	      return state.selected;
	    },
	    serviceAddressIndex: function serviceAddressIndex(state) {
	      return state.addressIndex;
	    },
	    serviceYear: function serviceYear(state) {
	      return state.serviceYear;
	    },
	    serviceLastModified: function serviceLastModified(state) {
	      var timestamp = new Date(state.lastModifiedDate);
	      return timestamp.toString();
	    },
	    service: function service(state, getters) {
	      var service = (0, _assign2.default)({}, state);
	      service.springCleanup = getters.springCleanup;
	      service.summerMaintenance = getters.summerMaintenance;
	      service.fallCleanup = getters.fallCleanup;
	      return service;
	    }
	  },
	  mutations: {
	    updateSelectedServices: function updateSelectedServices(state, selected) {
	      state.selected = selected;
	    },
	    updateServiceLastModified: function updateServiceLastModified(state, lastModified) {
	      state.lastModified = lastModified;
	    },
	    updateAddressIndexServiceYear: function updateAddressIndexServiceYear(state, addressIndexserviceYear) {
	      var parts = addressIndexserviceYear.split('-');
	
	      if (parts.length !== 2) throw new Error('AddressIndex-ServiceYear incorrectly formatted');
	
	      state.addressIndex = parts[0];
	      state.serviceYear = parts[1];
	    },
	    updateServiceSelection: function updateServiceSelection(state, serviceStatus) {
	      for (var key in serviceStatus) {
	        if (serviceStatus[key]) {
	          state.selected.push(key);
	        } else {
	          var index = state.selected.indexOf(key);
	          if (index >= 0) {
	            state.selected.splice(index, 1);
	          }
	        }
	      }
	    },
	    updateNotes: function updateNotes(state, notes) {
	      state.notes = notes;
	    }
	  },
	  actions: {
	    updateServiceState: function updateServiceState(context, data) {
	      context.commit('updateSelectedServices', data.selected);
	      context.commit('updateNotes', data.notes);
	      context.commit('updateServiceLastModified', data.lastModified);
	    },
	    serviceRetrieve: function serviceRetrieve(context) {
	      var apiClient = context.getters.apiClient;
	      var userId = context.getters.userId;
	      var addressIndex = context.getters.serviceAddressIndex;
	      var serviceYear = context.getters.serviceYear;
	
	      return (0, _api.userAddressServiceRetrieve)(apiClient, userId, addressIndex, serviceYear).then(function (serviceInfo) {
	        context.dispatch('updateServiceState', serviceInfo);
	        console.log('Retrieved service data: %j', serviceInfo);
	        return serviceInfo;
	      }).catch(function (error) {
	        throw error;
	      });
	    },
	    userServiceUpdate: function userServiceUpdate(context) {
	      var apiClient = context.getters.apiClient;
	      var userId = context.getters.userId;
	      var serviceInfo = context.getters.service;
	
	      return (0, _api.userAddressServiceUpdate)(apiClient, userId, serviceInfo).then(function (serviceInfo) {
	        context.dispatch('updateServiceState', serviceInfo);
	        console.log('Retrieved service data: %j', serviceInfo);
	        return serviceInfo;
	      }).catch(function (error) {
	        throw error;
	      });
	    }
	  }
	};
	
	exports.default = serviceApiStore;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(76);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _validator = __webpack_require__(199);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _api = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userApiStore = {
	  state: {
	    cognitoId: '',
	    givenName: '',
	    surName: '',
	    emailAddress: '',
	    lastModified: 0,
	    phoneNumberMobile: '',
	    phoneNumberHome: '',
	    unprocessedChange: '',
	    userId: '',
	    newUser: true,
	    validationRequired: true
	  },
	  getters: {
	    accountRetrieved: function accountRetrieved(state) {
	      return state.userId !== '';
	    },
	    userId: function userId(state) {
	      return state.userId || '';
	    },
	    givenName: function givenName(state, getters) {
	      return state.givenName || '';
	    },
	    surName: function surName(state, getters) {
	      return state.surName || '';
	    },
	    fullName: function fullName(state) {
	      return (state.givenName || '') + ' ' + (state.surName || '');
	    },
	    emailAddress: function emailAddress(state, getters) {
	      return state.emailAddress || '';
	    },
	    userLastModified: function userLastModified(state) {
	      var timestamp = new Date(state.lastModifiedDate);
	      return timestamp.toString();
	    },
	    mobilePhoneNumber: function mobilePhoneNumber(state) {
	      return state.phoneNumberMobile || '';
	    },
	    homePhoneNumber: function homePhoneNumber(state) {
	      return state.phoneNumberHome || '';
	    },
	    userAccountUnprocessedChange: function userAccountUnprocessedChange(state) {
	      return state.unprocessedChange;
	    },
	    newUser: function newUser(state) {
	      return state.newUser;
	    },
	    validationRequired: function validationRequired(state) {
	      return state.validationRequired;
	    },
	    user: function user(state, getters) {
	      var account = (0, _assign2.default)({}, state);
	
	      account.fullName = getters.fullName;
	      account.lastModified = getters.lastModified;
	
	      return account;
	    },
	    givenNameValid: function givenNameValid(state, getters) {
	      return getters.givenName.length > 0;
	    },
	    surNameValid: function surNameValid(state, getters) {
	      return getters.surName.length > 0;
	    },
	    emailAddressValid: function emailAddressValid(state, getters) {
	      var emailAddress = getters.emailAddress;
	      return emailAddress.length > 0 && _validator2.default.isEmail(emailAddress);
	    },
	    mobilePhoneNumberValid: function mobilePhoneNumberValid(state, getters) {
	      var mobilePhoneNumber = getters.mobilePhoneNumber;
	      return mobilePhoneNumber.length === 0 || _validator2.default.isMobilePhone(mobilePhoneNumber, getters.locale);
	    },
	    homePhoneNumberValid: function homePhoneNumberValid(state, getters) {
	      var homePhoneNumber = getters.homePhoneNumber;
	      return homePhoneNumber.length === 0 || _validator2.default.isMobilePhone(homePhoneNumber, getters.locale);
	    },
	    phoneNumberValid: function phoneNumberValid(state, getters) {
	      return getters.mobilePhoneNumberValid && getters.homePhoneNumberValid && (getters.mobilePhoneNumber.length > 0 || getters.homePhoneNumber.length > 0);
	    },
	    userInputValid: function userInputValid(state, getters) {
	      return getters.givenNameValid && getters.surNameValid && getters.emailAddressValid && getters.phoneNumberValid;
	    }
	  },
	  mutations: {
	    updateUserId: function updateUserId(state, userId) {
	      state.userId = userId;
	    },
	    updateCognitoId: function updateCognitoId(state, cognitoId) {
	      state.cognitoId = cognitoId;
	    },
	    updateGivenName: function updateGivenName(state, givenName) {
	      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (givenName !== undefined || override) {
	        state.givenName = givenName;
	      }
	    },
	    updateSurName: function updateSurName(state, surName) {
	      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (surName !== undefined || override) {
	        state.surName = surName;
	      }
	    },
	    updateEmailAddress: function updateEmailAddress(state, emailAddress) {
	      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (emailAddress !== undefined || override) {
	        state.emailAddress = emailAddress;
	      }
	    },
	    updateUserLastModified: function updateUserLastModified(state, lastModified) {
	      state.lastModified = lastModified;
	    },
	    updatePhoneNumberHome: function updatePhoneNumberHome(state, phoneNumberHome) {
	      state.phoneNumberHome = phoneNumberHome;
	    },
	    updatePhoneNumberMobile: function updatePhoneNumberMobile(state, phoneNumberMobile) {
	      state.phoneNumberMobile = phoneNumberMobile;
	    },
	    updateNewUser: function updateNewUser(state, newUser) {
	      state.newUser = newUser;
	    },
	    updateValidationRequired: function updateValidationRequired(state, validationRequired) {
	      state.validationRequired = validationRequired;
	    }
	  },
	  actions: {
	    updateUserState: function updateUserState(context, accountInfo) {
	      context.commit('updateUserId', accountInfo.userId);
	      context.commit('updateCognitoId', accountInfo.cognitoId);
	      context.commit('updateGivenName', accountInfo.givenName);
	      context.commit('updateSurName', accountInfo.surName);
	      context.commit('updateEmailAddress', accountInfo.emailAddress);
	      context.commit('updateUserLastModified', accountInfo.lastModified);
	      context.commit('updatePhoneNumberMobile', accountInfo.phoneNumberMobile);
	      context.commit('updatePhoneNumberHome', accountInfo.phoneNumberHome);
	      context.commit('updateNewUser', accountInfo.newUser);
	      context.commit('updateValidationRequired', accountInfo.validationRequired);
	    },
	    userAccountRegister: function userAccountRegister(context) {
	      var apiClient = context.getters.apiClient;
	      var cognitoId = context.getters.credentials.identityId;
	      var emailAddress = context.getters.authEmailAddress;
	
	      return (0, _api.userAccountRegister)(apiClient, cognitoId, emailAddress).then(function (accountInfo) {
	        context.dispatch('updateUserState', accountInfo).then(function () {
	          context.dispatch('userAddressRetrieve');
	          context.dispatch('serviceRetrieve');
	        });
	        console.log('Retrieved account data: %j', accountInfo);
	        return accountInfo;
	      }).catch(function (error) {
	        throw error;
	      });
	    },
	    userAccountUpdate: function userAccountUpdate(context) {
	      var apiClient = context.getters.apiClient;
	      var accountInfo = context.getters.user;
	
	      return (0, _api.userAccountUpdate)(apiClient, accountInfo).then(function (accountInfo) {
	        context.dispatch('updateUserState', accountInfo);
	        console.log('Retrieved account data: %j', accountInfo);
	        return accountInfo;
	      }).catch(function (error) {
	        throw error;
	      });
	    }
	  }
	};
	
	exports.default = userApiStore;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.amazonModule = exports.amazonProviderId = undefined;
	
	var _defineProperty2 = __webpack_require__(97);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _analytics = __webpack_require__(35);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var amazonProviderId = exports.amazonProviderId = 'www.amazon.com';
	
	var authDefault = {
	  status: '',
	  access_token: '',
	  token_type: '',
	  scope: '',
	  expires_in: ''
	};
	
	var profileDefault = {
	  CustomerId: '',
	  Name: '',
	  PrimaryEmail: ''
	};
	
	var amazonModule = exports.amazonModule = {
	  state: {
	    authResponse: authDefault,
	    profile: profileDefault,
	    loading: false
	  },
	  getters: {
	    amazonLoginEntry: function amazonLoginEntry(state) {
	      return (0, _defineProperty3.default)({}, amazonProviderId, state.authResponse.access_token);
	    },
	    amazonEmailAddress: function amazonEmailAddress(state) {
	      return state.profile.PrimaryEmail;
	    },
	    amazonName: function amazonName(state) {
	      return state.profile.Name;
	    },
	    amazonSigninLoading: function amazonSigninLoading(state) {
	      return state.loading;
	    }
	  },
	  mutations: {
	    setAmazonSigninLoading: function setAmazonSigninLoading(state, amazonSigninLoading) {
	      state.loading = amazonSigninLoading;
	    },
	    updateAmazonAuthResponse: function updateAmazonAuthResponse(state, response) {
	      state.authResponse.access_token = response.access_token;
	      state.authResponse.token_type = response.token_type;
	      state.authResponse.status = response.status;
	      state.authResponse.scope = response.scope;
	      state.authResponse.expires_in = response.expires_in;
	
	      console.log('Amazon Sign-In Success: %O', response);
	    },
	    updateAmazonProfile: function updateAmazonProfile(state, response) {
	      state.profile.PrimaryEmail = response.profile.PrimaryEmail;
	      state.profile.CustomerId = response.profile.CustomerId;
	      state.profile.Name = response.profile.Name;
	
	      console.log('Retrieved Amazon profile: %O', response);
	    },
	    onAmazonSignInError: function onAmazonSignInError(state, response) {
	      state.loading = false;
	      console.log('Amazon Sign-In authorization failed: ' + response.error_description);
	    },
	    onAmazonSignOut: function onAmazonSignOut(state, response) {
	      state.authResponse = authDefault;
	      state.profile = profileDefault;
	
	      console.log('Amazon Sign-Out Success');
	    }
	  },
	  actions: {
	    onAmazonSignInSuccess: function onAmazonSignInSuccess(context, response) {
	      context.commit('updateAmazonAuthResponse', response);
	
	      var start = _analytics2.default.currentTime();
	      window.amazon.Login.retrieveProfile(context.state.authResponse.access_token, function (response) {
	        var end = _analytics2.default.currentTime();
	        _analytics2.default.time('API', 'signin-amazon', end - start, 'success');
	        context.commit('updateAmazonProfile', response);
	      });
	    },
	    onLogin: function onLogin(context) {
	      context.commit('setAmazonSigninLoading', false);
	    }
	  }
	};
	
	exports.default = amazonModule;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.facebookModule = exports.facebookProviderId = undefined;
	
	var _defineProperty2 = __webpack_require__(97);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _analytics = __webpack_require__(35);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var facebookProviderId = exports.facebookProviderId = 'graph.facebook.com';
	
	var authDefault = {
	  status: '',
	  accessToken: '',
	  expiresIn: ''
	};
	
	var profileDefault = {
	  id: '',
	  name: '',
	  email: ''
	};
	
	var facebookModule = exports.facebookModule = {
	  state: {
	    authResponse: authDefault,
	    profile: profileDefault,
	    loading: false
	  },
	  getters: {
	    facebookLoginEntry: function facebookLoginEntry(state) {
	      return (0, _defineProperty3.default)({}, facebookProviderId, state.authResponse.accessToken);
	    },
	    facebookEmailAddress: function facebookEmailAddress(state) {
	      return state.profile.email;
	    },
	    facebookName: function facebookName(state) {
	      return state.profile.name;
	    },
	    facebookSigninLoading: function facebookSigninLoading(state) {
	      return state.loading;
	    }
	  },
	  mutations: {
	    setFacebookSigninLoading: function setFacebookSigninLoading(state, facebookSigninLoading) {
	      state.loading = facebookSigninLoading;
	    },
	    updateFacebookAuthResponse: function updateFacebookAuthResponse(state, response) {
	      state.profile.id = response.authResponse.userID;
	      state.authResponse = response.authResponse;
	
	      console.log('Facebook Sign-In Success: %O', response);
	    },
	    updateFacebookProfile: function updateFacebookProfile(state, response) {
	      state.profile.name = response.name;
	      state.profile.email = response.email;
	
	      console.log('Retrieved Facebook profile: %O', response);
	    },
	    onFacebookSignInError: function onFacebookSignInError(state, response) {
	      state.loading = false;
	      console.log('Facebook Sign-In authorization failed: ' + response);
	    },
	    onFacebookSignOut: function onFacebookSignOut(state, response) {
	      state.profile = profileDefault;
	      state.authResponse = authDefault;
	
	      console.log('Facebook Sign-Out Success');
	    }
	  },
	  actions: {
	    onFacebookSignInSuccess: function onFacebookSignInSuccess(context, response) {
	      context.commit('updateFacebookAuthResponse', response);
	
	      var start = _analytics2.default.currentTime();
	      window.FB.api('/me?locale=en_US&fields=name,email', function (response) {
	        var end = _analytics2.default.currentTime();
	        _analytics2.default.time('API', 'signin-facebook', end - start, 'success');
	        context.commit('updateFacebookProfile', response);
	      });
	    },
	    facebookSignOut: function facebookSignOut(context) {
	      var start = _analytics2.default.currentTime();
	      window.FB.logout(function (response) {
	        var end = _analytics2.default.currentTime();
	        _analytics2.default.time('API', 'signout-facebook', end - start, 'success');
	        context.commit('onFacebookSignOut', response);
	      });
	    },
	    onLogin: function onLogin(context) {
	      context.commit('setFacebookSigninLoading', false);
	    }
	  }
	};
	
	exports.default = facebookModule;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.googleModule = exports.googleProviderId = undefined;
	
	var _defineProperty2 = __webpack_require__(97);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _analytics = __webpack_require__(35);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var googleProviderId = exports.googleProviderId = 'accounts.google.com';
	
	var authDefault = {
	  id_token: '',
	  token_type: '',
	  idpId: '',
	  expires_in: '',
	  expires_at: '',
	  first_issued_at: '',
	  login_hint: ''
	};
	
	var profileDefault = {
	  id: '',
	  name: '',
	  givenName: '',
	  familyName: '',
	  imageUrl: '',
	  email: ''
	};
	
	var googleModule = exports.googleModule = {
	  state: {
	    authResponse: authDefault,
	    profile: profileDefault,
	    loading: false
	  },
	  getters: {
	    googleLoginEntry: function googleLoginEntry(state) {
	      return (0, _defineProperty3.default)({}, googleProviderId, state.authResponse.id_token);
	    },
	    googleEmailAddress: function googleEmailAddress(state) {
	      return state.profile.email;
	    },
	    googleName: function googleName(state) {
	      return state.profile.name;
	    },
	    googleSigninLoading: function googleSigninLoading(state) {
	      return state.loading;
	    }
	  },
	  mutations: {
	    setGoogleSigninLoading: function setGoogleSigninLoading(state, googleSigninLoading) {
	      state.loading = googleSigninLoading;
	    },
	    onGoogleSignInSuccess: function onGoogleSignInSuccess(state, googleUser) {
	      var basicProfile = googleUser.getBasicProfile();
	      var authResponse = googleUser.getAuthResponse();
	
	      state.profile.id = basicProfile.getId();
	      state.profile.name = basicProfile.getName();
	      state.profile.givenName = basicProfile.getGivenName();
	      state.profile.familyName = basicProfile.getFamilyName();
	      state.profile.imageUrl = basicProfile.getImageUrl();
	      state.profile.email = basicProfile.getEmail();
	
	      state.authResponse.id_token = authResponse.id_token;
	      state.authResponse.token_type = authResponse.token_type;
	      state.authResponse.idpId = authResponse.idpId;
	      state.authResponse.expires_in = authResponse.expires_in;
	      state.authResponse.expires_at = authResponse.expires_at;
	      state.authResponse.first_issued_at = authResponse.first_issued_at;
	      state.authResponse.login_hint = authResponse.login_hint;
	
	      console.log('Google Sign-In Success: %O', googleUser);
	    },
	    onGoogleSignInError: function onGoogleSignInError(state, error) {
	      state.loading = false;
	      console.log('Google Sign-In authorization failed: ', error.reason);
	    },
	    onGoogleSignOut: function onGoogleSignOut(state) {
	      state.profile = profileDefault;
	      state.authResponse = authDefault;
	
	      console.log('Google Sign-Out Success');
	    }
	  },
	  actions: {
	    googleSignOut: function googleSignOut(context) {
	      var start = _analytics2.default.currentTime();
	      window.gapi.auth2.getAuthInstance().signOut(function () {
	        var end = _analytics2.default.currentTime();
	        _analytics2.default.time('API', 'signout-google', end - start, 'success');
	        context.commit('onGoogleSignOut');
	      });
	    },
	    onLogin: function onLogin(context) {
	      context.commit('setGoogleSigninLoading', false);
	    }
	  }
	};
	
	exports.default = googleModule;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _amazon = __webpack_require__(373);
	
	var _facebook = __webpack_require__(374);
	
	var _google = __webpack_require__(375);
	
	var providerIds = [_amazon.amazonProviderId, _facebook.facebookProviderId, _google.googleProviderId];
	
	var account = {
	  state: {
	    tokens: {}
	  },
	  getters: {
	    loginTokens: function loginTokens(state) {
	      return state.tokens;
	    },
	    authEmailAddress: function authEmailAddress(state, getters) {
	      return getters.googleEmailAddress || getters.facebookEmailAddress || getters.amazonEmailAddress;
	    },
	    authName: function authName(state, getters) {
	      return getters.googleName || getters.facebookName || getters.amazonName;
	    },
	    authFirstName: function authFirstName(state, getters) {
	      return getters.authName.split(' ')[0] || '';
	    },
	    authLastName: function authLastName(state, getters) {
	      var parts = getters.authName.split(' ');
	
	      if (parts.length > 0) {
	        return parts[parts.length - 1];
	      }
	      return '';
	    }
	  },
	  mutations: {
	    updateLoginEntry: function updateLoginEntry(state, entry) {
	      providerIds.forEach(function (providerId) {
	        if (entry[providerId]) {
	          state.tokens[providerId] = entry[providerId];
	          console.log('Added Login provider: %s : %s', providerId, entry[providerId]);
	        } else if (entry[providerId] === '' && state.tokens[providerId]) {
	          delete state.tokens[providerId];
	          console.log('Deleted Login provider: %s : %s', providerId, entry[providerId]);
	        } else {}
	      });
	    }
	  },
	  actions: {
	    loginEntryChange: function loginEntryChange(context, entry) {
	      context.commit('updateLoginEntry', entry);
	
	      context.dispatch('getCognitoCredentials');
	    }
	  },
	  modules: {
	    'idp': {
	      modules: {
	        'amazon': _amazon.amazonModule,
	        'facebook': _facebook.facebookModule,
	        'google': _google.googleModule
	      }
	    }
	  }
	};
	
	exports.default = account;

/***/ },
/* 377 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var dev = {
	  awsRegion: 'us-east-1',
	  googleAnalyticsId: 'UA-47128313-3',
	  googleAnalyticsSampleRate: 100,
	  googleAnalyticsSpeedSampleRate: 100,
	  cognitoIdentityPoolId: 'us-east-1:26b613b0-4102-4fc8-b1a7-671d45c4fc55',
	  apiGatewayEndpoint: 'https://csp-api-dev.courtyardstone.com/dev',
	  googleSignInParams: {
	    client_id: '138058417459-22ti90ahel84u8ck2uh67c1dpoa7i1v0.apps.googleusercontent.com'
	  },
	  facebookSignInParams: {
	    init: {
	      appId: '1731673160466541',
	      cookie: true,
	      xfbml: false,
	      version: 'v2.9'
	    },
	    login: {
	      scope: 'public_profile,email'
	    }
	  },
	  amazonSignInParams: {
	    clientId: 'amzn1.application-oa2-client.d3a14687e98945abb7e67372131d204b',
	    scope: 'profile'
	  },
	  signinTimeout: 5000,
	  website: 'https://www-dev.courtyardstone.com'
	};
	
	exports.default = dev;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _proto = __webpack_require__(380);
	
	var _proto2 = _interopRequireDefault(_proto);
	
	var _dev = __webpack_require__(377);
	
	var _dev2 = _interopRequireDefault(_dev);
	
	var _prod = __webpack_require__(379);
	
	var _prod2 = _interopRequireDefault(_prod);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var environmentMap = {
	  'csp-dev.courtyardstone.com': 'dev',
	  'portal.courtyardstone.com': 'prod'
	};
	
	var detectedEnvironment = environmentMap[window.location.hostname];
	var fallbackEnvironment = 'proto';
	
	console.log('Utilizing %s config', detectedEnvironment || fallbackEnvironment);
	
	var config = {
	  state: {
	    company: 'Courtyard Stone & Landscape Inc.',
	    companyPhoneNumber: '2483093136',
	
	    copyrightStart: '2014',
	
	    socialLinks: {
	      'Houzz': {
	        'link': 'http://www.houzz.com/pro/ben-reinhold/courtyard-stone-landscape-inc',
	        'fa': 'houzz'
	      },
	      'Facebook': {
	        'link': 'http://www.facebook.com/courtyardstone',
	        'fa': 'facebook'
	      },
	      'Flicker': {
	        'link': 'http://www.flickr.com/photos/courtyardstone/',
	        'fa': 'flickr'
	      },
	      'Pintrest': {
	        'link': 'http://www.pinterest.com/courtyardstone/',
	        'fa': 'pinterest-p'
	      }
	    },
	    locale: 'en-US',
	    phoneNumberMask: '(999) 999-9999',
	    zipMask: '99999[-9999]',
	    zipRegex: /^\d{5}(?:-\d{4})?$/,
	
	    environment: {
	      proto: _proto2.default,
	      dev: _dev2.default,
	      prod: _prod2.default
	    }
	  },
	  getters: {
	    environmentName: function environmentName(state) {
	      return detectedEnvironment || fallbackEnvironment;
	    },
	
	    amazonSignInParams: function amazonSignInParams(state, getters) {
	      return state.environment[getters.environmentName].amazonSignInParams;
	    },
	
	    facebookSignInParams: function facebookSignInParams(state, getters) {
	      return state.environment[getters.environmentName].facebookSignInParams;
	    },
	
	    googleSignInParams: function googleSignInParams(state, getters) {
	      return state.environment[getters.environmentName].googleSignInParams;
	    },
	
	    cognitoIdentityPoolId: function cognitoIdentityPoolId(state, getters) {
	      return state.environment[getters.environmentName].cognitoIdentityPoolId;
	    },
	
	    apiGatewayEndpoint: function apiGatewayEndpoint(state, getters) {
	      return state.environment[getters.environmentName].apiGatewayEndpoint;
	    },
	
	    awsRegion: function awsRegion(state, getters) {
	      return state.environment[getters.environmentName].awsRegion;
	    },
	
	    signinTimeout: function signinTimeout(state, getters) {
	      return state.environment[getters.environmentName].signinTimeout;
	    },
	
	    googleAnalyticsId: function googleAnalyticsId(state, getters) {
	      return state.environment[getters.environmentName].googleAnalyticsId;
	    },
	
	    googleAnalyticsSampleRate: function googleAnalyticsSampleRate(state, getters) {
	      return state.environment[getters.environmentName].googleAnalyticsSampleRate;
	    },
	
	    googleAnalyticsSpeedSampleRate: function googleAnalyticsSpeedSampleRate(state, getters) {
	      return state.environment[getters.environmentName].googleAnalyticsSpeedSampleRate;
	    },
	
	    website: function website(state, getters) {
	      return state.environment[getters.environmentName].website;
	    },
	
	    zipMask: function zipMask(state, getters) {
	      return state.zipMask;
	    },
	
	    zipRegex: function zipRegex(state, getters) {
	      return state.zipRegex;
	    },
	
	    copyrightYear: function copyrightYear(state) {
	      return state.copyrightStart + ' - ' + new Date().getFullYear();
	    },
	
	    company: function company(state) {
	      return state.company;
	    },
	
	    companyPhoneNumber: function companyPhoneNumber(state) {
	      return state.companyPhoneNumber;
	    },
	
	    socialLinks: function socialLinks(state) {
	      return state.socialLinks;
	    },
	
	    locale: function locale(state) {
	      return state.locale;
	    },
	
	    phoneNumberMask: function phoneNumberMask(state) {
	      return state.phoneNumberMask;
	    }
	  }
	};
	
	exports.default = config;

/***/ },
/* 379 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prod = exports.prod = {
	  awsRegion: 'us-east-1',
	  googleAnalyticsId: 'UA-47128313-2',
	  googleAnalyticsSampleRate: 100,
	  googleAnalyticsSpeedSampleRate: 100,
	  cognitoIdentityPoolId: 'us-east-1:b8a397d8-2c9d-42d0-8cce-712fbf6aeea4',
	  apiGatewayEndpoint: 'https://lljikgfqtd.execute-api.us-east-1.amazonaws.com/prod',
	  googleSignInParams: {
	    client_id: '138058417459-6d5tchbvg2v288q2856b39givtjm807d.apps.googleusercontent.com'
	  },
	  facebookSignInParams: {
	    init: {
	      appId: '1511800565507703',
	      cookie: true,
	      xfbml: false,
	      version: 'v2.9'
	    },
	    login: {
	      scope: 'public_profile,email'
	    }
	  },
	  amazonSignInParams: {
	    clientId: 'amzn1.application-oa2-client.7635a40a61bc4d129d5a679ddc4e8019',
	    scope: 'profile'
	  },
	  signinTimeout: 5000,
	  website: 'https://www.courtyardstone.com'
	};
	
	exports.default = prod;

/***/ },
/* 380 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var proto = exports.proto = {
	  awsRegion: 'us-east-1',
	  googleAnalyticsId: 'UA-47128313-3',
	  googleAnalyticsSampleRate: 100,
	  googleAnalyticsSpeedSampleRate: 100,
	  cognitoIdentityPoolId: 'us-east-1:b2ad414c-6ed9-41f6-a644-29d664b20917',
	  apiGatewayEndpoint: 'https://csp-api-dev.courtyardstone.com/dev',
	  googleSignInParams: {
	    client_id: '138058417459-dmrnk76c307n3hek4vodurvkognquvan.apps.googleusercontent.com'
	  },
	  facebookSignInParams: {
	    init: {
	      appId: '1587134934639684',
	      cookie: true,
	      xfbml: false,
	      version: 'v2.9'
	    },
	    login: {
	      scope: 'public_profile,email'
	    }
	  },
	  amazonSignInParams: {
	    clientId: 'amzn1.application-oa2-client.8f382628b91c471b89fa0f845021d5e3',
	    scope: 'profile'
	  },
	  signinTimeout: 5000,
	  website: 'https://www-dev.courtyardstone.com'
	};
	
	exports.default = proto;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Masthead = __webpack_require__(833);
	
	var _Masthead2 = _interopRequireDefault(_Masthead);
	
	var _Trailer = __webpack_require__(211);
	
	var _Trailer2 = _interopRequireDefault(_Trailer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Masthead: _Masthead2.default,
	    Trailer: _Trailer2.default
	  }
	};

/***/ },
/* 382 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Loading',
	  props: {
	    loading: {
	      type: Boolean,
	      required: true
	    }
	  }
	};

/***/ },
/* 383 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 384 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ProgressDots',
	  props: {
	    totalSteps: {
	      type: Number,
	      required: true
	    },
	    currentStep: {
	      type: Number,
	      required: true
	    }
	  }
	};

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(41);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'socialIcon',
	  props: ['object', 'name'],
	  computed: (0, _extends3.default)({
	    title: function title() {
	      return this.company + ' on ' + this.name;
	    },
	    fa_class: function fa_class() {
	      return 'socialicons fa fa-' + this.object.fa + ' fa-lg';
	    },
	    link: function link() {
	      return this.object.link;
	    },
	    alt: function alt() {
	      return this.company + ' ' + this.name + ' Page';
	    }
	  }, (0, _vuex.mapState)({
	    company: function company(state) {
	      return state.config.company;
	    }
	  }))
	};

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(41);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(45);
	
	var _SocialIcon = __webpack_require__(835);
	
	var _SocialIcon2 = _interopRequireDefault(_SocialIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'trailer',
	  components: {
	    SocialIcon: _SocialIcon2.default
	  },
	  props: {
	    socialIcons: {
	      type: Boolean,
	      default: true
	    }
	  },
	  computed: (0, _extends3.default)({
	    phonelink: function phonelink() {
	      return 'tel:+1' + this.companyPhoneNumber;
	    }
	  }, (0, _vuex.mapGetters)(['company', 'companyPhoneNumber', 'copyrightYear', 'socialLinks', 'website']))
	};

/***/ },
/* 387 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'amz-signin-button',
	  props: {
	    params: {
	      type: Object,
	      required: true,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  computed: {
	    amazonSigninLoading: {
	      get: function get() {
	        return this.$store.getters.amazonSigninLoading;
	      },
	      set: function set(newValue) {
	        this.$store.commit('setAmazonSigninLoading', newValue);
	      }
	    }
	  },
	  methods: {
	    clicked: function clicked() {
	      var _this = this;
	
	      this.amazonSigninLoading = true;
	      var options = {
	        scope: this.params.scope
	      };
	
	      var authRequest = window.amazon.Login.authorize(options, function (response) {
	        if (response.error) {
	          _this.$emit('failure', response);
	          _this.$emit('error', response);
	        } else {
	          _this.$emit('success', response);
	        }
	      });
	
	      setTimeout(function () {
	        console.log('Did not complete Amazon login within the expected timeframe: %j', authRequest);
	        _this.amazonSigninLoading = false;
	      }, this.$store.getters.signinTimeout);
	    }
	  },
	  mounted: function mounted() {
	    var amzClientId = this.params.clientId;
	
	    window.onAmazonLoginReady = function () {
	      if (!window.amazon) {
	        console.err('Amazon SDK not present.');
	        return;
	      }
	
	      if (!amzClientId) {
	        console.err('params.clientId must be specified.');
	        return;
	      }
	
	      window.amazon.Login.setClientId(amzClientId);
	    };
	
	    (function (d) {
	      var a = d.createElement('script');
	      a.type = 'text/javascript';
	      a.async = true;
	      a.id = 'amazon-login-sdk';
	      a.src = 'https://api-cdn.amazon.com/sdk/login1.js';
	      d.getElementById('amazon-root').appendChild(a);
	    })(document);
	  }
	};

/***/ },
/* 388 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	(function (d, s, id) {
	  var fjs = d.getElementsByTagName(s)[0];
	
	  if (d.getElementById(id)) {
	    return;
	  }
	
	  var js = d.createElement(s);
	  js.id = id;
	  js.src = '//connect.facebook.net/en_US/sdk.js';
	  fjs.parentNode.insertBefore(js, fjs);
	})(document, 'script', 'facebook-jssdk');
	
	exports.default = {
	  name: 'fb-signin-button',
	  props: {
	    params: {
	      type: Object,
	      required: true,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  computed: {
	    facebookSigninLoading: {
	      get: function get() {
	        return this.$store.getters.facebookSigninLoading;
	      },
	      set: function set(newValue) {
	        this.$store.commit('setFacebookSigninLoading', newValue);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var fbParams = this.params.init;
	
	    window.fbAsyncInit = function () {
	      if (!window.FB) {
	        console.err('Facebook SDK not present.');
	        return;
	      }
	
	      if (!fbParams.appId) {
	        console.err('params.init.appId must be specified.');
	        return;
	      }
	
	      window.FB.init(fbParams);
	      window.FB.AppEvents.logPageView();
	    };
	  },
	  methods: {
	    clicked: function clicked() {
	      var _this = this;
	
	      this.facebookSigninLoading = true;
	      window.FB.login(function (response) {
	        if (response.authResponse && response.status === 'connected') {
	          _this.$emit('success', response);
	        } else {
	          _this.$emit('failure', response);
	          _this.$emit('error', response);
	        }
	      }, this.params.login);
	    }
	  }
	};

/***/ },
/* 389 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'g-signin-button',
	  props: {
	    params: {
	      type: Object,
	      required: true,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  computed: {
	    googleSigninLoading: {
	      get: function get() {
	        return this.$store.getters.googleSigninLoading;
	      },
	      set: function set(nevValue) {
	        this.$store.commit('setGoogleSigninLoading', nevValue);
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (!window.gapi) {
	      console.error('"https://apis.google.com/js/api:client.js" needs to be included as a <script>.');
	      return;
	    }
	
	    if (!this.params.client_id) {
	      console.error('params.client_id must be specified.');
	      return;
	    }
	
	    window.gapi.load('auth2', function () {
	      var auth2 = window.gapi.auth2.init(_this.params);
	      auth2.attachClickHandler(_this.$refs.GSignInBtn, {}, function (googleUser) {
	        _this.$emit('success', googleUser);
	      }, function (error) {
	        _this.$emit('error', error);
	        _this.$emit('failure', error);
	      });
	    });
	  }
	};

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(41);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(74);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(45);
	
	var _Trailer = __webpack_require__(211);
	
	var _Trailer2 = _interopRequireDefault(_Trailer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.filter('phone', function (phone) {
	  return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
	});
	
	exports.default = {
	  name: 'Account',
	  components: {
	    Trailer: _Trailer2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['user', 'address', 'service', 'company', 'companyPhoneNumber', 'copyrightYear', 'website']), {
	    ready: function ready() {
	      return this.address.city !== '';
	    }
	  })
	};

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(41);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(45);
	
	var _Amazon = __webpack_require__(836);
	
	var _Amazon2 = _interopRequireDefault(_Amazon);
	
	var _Facebook = __webpack_require__(837);
	
	var _Facebook2 = _interopRequireDefault(_Facebook);
	
	var _Google = __webpack_require__(838);
	
	var _Google2 = _interopRequireDefault(_Google);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Login',
	  components: {
	    'amz-signin-button': _Amazon2.default,
	    'fb-signin-button': _Facebook2.default,
	    'g-signin-button': _Google2.default
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['amazonLoginEntry', 'facebookLoginEntry', 'googleLoginEntry', 'amazonSignInParams', 'facebookSignInParams', 'googleSignInParams'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['onAmazonSigninError', 'onFacebookSignInError', 'onGoogleSignInSuccess', 'onGoogleSignInError']), (0, _vuex.mapActions)(['onAmazonSignInSuccess', 'onFacebookSignInSuccess'])),
	  watch: {
	    amazonLoginEntry: function amazonLoginEntry(newVal) {
	      console.log('Amazon login entry changed: %O', newVal);
	      this.$store.dispatch('loginEntryChange', newVal);
	    },
	    facebookLoginEntry: function facebookLoginEntry(newVal) {
	      console.log('Facebook login entry changed: %O', newVal);
	      this.$store.dispatch('loginEntryChange', newVal);
	    },
	    googleLoginEntry: function googleLoginEntry(newVal) {
	      console.log('Google login entry changed: %O', newVal);
	      this.$store.dispatch('loginEntryChange', newVal);
	    }
	  }
	};

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProgressDots = __webpack_require__(834);
	
	var _ProgressDots2 = _interopRequireDefault(_ProgressDots);
	
	var _Loading = __webpack_require__(832);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _router = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Workflow',
	  components: {
	    ProgressDots: _ProgressDots2.default,
	    Loading: _Loading2.default
	  },
	  data: function data() {
	    return {
	      loading: false
	    };
	  },
	  computed: {
	    nextRoute: function nextRoute() {
	      return this.$route.meta.nextRoute || _router.mainPage;
	    },
	    backRoute: function backRoute() {
	      return this.$route.meta.backRoute;
	    },
	    workflowSteps: function workflowSteps() {
	      return this.$route.meta.workflowSteps;
	    },
	    currentStep: function currentStep() {
	      return this.$route.meta.currentStep;
	    },
	    navButton: function navButton() {
	      return this.$route.meta.navButton;
	    },
	    backNavLink: function backNavLink() {
	      return this.$route.meta.backNavLink;
	    },
	    heading: function heading() {
	      return this.$route.meta.heading;
	    },
	    allInputValid: function allInputValid() {
	      var inputValid = this.$route.meta.inputValid;
	
	      if (inputValid === undefined) return true;
	      if (typeof inputValid === 'boolean') return inputValid;
	      if (typeof inputValid === 'string') return this.$store.getters[inputValid];
	
	      console.warn('Unexpected input validation type: %s', inputValid);
	      return true;
	    }
	  },
	  methods: {
	    clearLoading: function clearLoading() {
	      this.loading = false;
	    },
	    setLoading: function setLoading() {
	      this.loading = true;
	    }
	  },
	  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
	    if (typeof this.$route.meta.beforeRouteLeave === 'function') this.$route.meta.beforeRouteLeave(to, from, next, this);else next();
	  }
	};

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(41);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(45);
	
	var _MaskedInput = __webpack_require__(162);
	
	var _MaskedInput2 = _interopRequireDefault(_MaskedInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AddressInfo',
	  directives: {
	    mask: _MaskedInput2.default
	  },
	  methods: {
	    updateZip: function updateZip(value) {
	      this.zip = value;
	    }
	  },
	  computed: (0, _extends3.default)({
	    line1: {
	      get: function get() {
	        return this.$store.getters.address.line1;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateAddress1', newValue);
	      }
	    },
	    line2: {
	      get: function get() {
	        return this.$store.getters.address.line2;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateAddress2', newValue);
	      }
	    },
	    city: {
	      get: function get() {
	        return this.$store.getters.address.city;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateCity', newValue);
	      }
	    },
	    state: {
	      get: function get() {
	        return this.$store.getters.address.state;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateState', newValue);
	      }
	    },
	    zip: {
	      get: function get() {
	        return this.$store.getters.address.zip;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateZip', newValue);
	      }
	    }
	  }, (0, _vuex.mapGetters)(['line1Valid', 'line2Valid', 'cityValid', 'stateValid', 'zipValid', 'addressInputValid', 'zipMask']))
	};

/***/ },
/* 394 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'SendMessage',
	  computed: {
	    message: {
	      get: function get() {
	        return this.$store.getters.message;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateMessage', newValue);
	      }
	    }
	  }
	};

/***/ },
/* 395 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ServiceChoices',
	  computed: {
	    springCleanup: {
	      get: function get() {
	        return this.$store.getters.springCleanup;
	      },
	      set: function set(newValue) {
	        if (!newValue) this.summerMaintenance = newValue;
	        this.$store.commit('updateServiceSelection', { 'springCleanup': newValue });
	      }
	    },
	    summerMaintenance: {
	      get: function get() {
	        return this.$store.getters.summerMaintenance;
	      },
	      set: function set(newValue) {
	        if (!newValue) this.fallCleanup = newValue;
	        this.$store.commit('updateServiceSelection', { 'summerMaintenance': newValue });
	      }
	    },
	    fallCleanup: {
	      get: function get() {
	        return this.$store.getters.fallCleanup;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateServiceSelection', { 'fallCleanup': newValue });
	      }
	    }
	  }
	};

/***/ },
/* 396 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'Notes',
	  computed: {
	    notes: {
	      get: function get() {
	        return this.$store.getters.notes;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateNotes', newValue);
	      }
	    }
	  }
	};

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(41);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(45);
	
	var _MaskedInput = __webpack_require__(162);
	
	var _MaskedInput2 = _interopRequireDefault(_MaskedInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UserInfo',
	  directives: {
	    mask: _MaskedInput2.default
	  },
	  methods: {
	    updateMobilePhoneNumber: function updateMobilePhoneNumber(value) {
	      this.mobilePhoneNumber = value;
	    },
	    updateHomePhoneNumber: function updateHomePhoneNumber(value) {
	      this.homePhoneNumber = value;
	    },
	    updateEmailAddress: function updateEmailAddress(value) {
	      this.emailAddress = value;
	    }
	  },
	  computed: (0, _extends3.default)({
	    phoneNumberMask: function phoneNumberMask() {
	      return this.$store.getters.phoneNumberMask;
	    },
	    givenName: {
	      get: function get() {
	        return this.$store.getters.givenName;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateGivenName', newValue);
	      }
	    },
	    surName: {
	      get: function get() {
	        return this.$store.getters.surName;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateSurName', newValue);
	      }
	    },
	    emailAddress: {
	      get: function get() {
	        return this.$store.getters.emailAddress;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updateEmailAddress', newValue);
	      }
	    },
	    homePhoneNumber: {
	      get: function get() {
	        return this.$store.getters.homePhoneNumber;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updatePhoneNumberHome', newValue);
	      }
	    },
	    mobilePhoneNumber: {
	      get: function get() {
	        return this.$store.getters.mobilePhoneNumber;
	      },
	      set: function set(newValue) {
	        this.$store.commit('updatePhoneNumberMobile', newValue);
	      }
	    }
	  }, (0, _vuex.mapGetters)(['givenNameValid', 'surNameValid', 'emailAddressValid', 'mobilePhoneNumberValid', 'homePhoneNumberValid', 'phoneNumberValid', 'userInputValid']))
	};

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(41);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(45);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Welcome',
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['authName', 'givenName']))
	};

/***/ },
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 615 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 616 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 617 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 618 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 619 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 620 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 621 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 622 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 623 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 624 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 625 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 626 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 627 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 628 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 629 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 630 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 631 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 632 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 633 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 634 */,
/* 635 */,
/* 636 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-12-08",
			"endpointPrefix": "acm",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "ACM",
			"serviceFullName": "AWS Certificate Manager",
			"signatureVersion": "v4",
			"targetPrefix": "CertificateManager",
			"uid": "acm-2015-12-08"
		},
		"operations": {
			"AddTagsToCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn",
						"Tags"
					],
					"members": {
						"CertificateArn": {},
						"Tags": {
							"shape": "S3"
						}
					}
				}
			},
			"DeleteCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn"
					],
					"members": {
						"CertificateArn": {}
					}
				}
			},
			"DescribeCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn"
					],
					"members": {
						"CertificateArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Certificate": {
							"type": "structure",
							"members": {
								"CertificateArn": {},
								"DomainName": {},
								"SubjectAlternativeNames": {
									"shape": "Sc"
								},
								"DomainValidationOptions": {
									"shape": "Sd"
								},
								"Serial": {},
								"Subject": {},
								"Issuer": {},
								"CreatedAt": {
									"type": "timestamp"
								},
								"IssuedAt": {
									"type": "timestamp"
								},
								"ImportedAt": {
									"type": "timestamp"
								},
								"Status": {},
								"RevokedAt": {
									"type": "timestamp"
								},
								"RevocationReason": {},
								"NotBefore": {
									"type": "timestamp"
								},
								"NotAfter": {
									"type": "timestamp"
								},
								"KeyAlgorithm": {},
								"SignatureAlgorithm": {},
								"InUseBy": {
									"type": "list",
									"member": {}
								},
								"FailureReason": {},
								"Type": {},
								"RenewalSummary": {
									"type": "structure",
									"required": [
										"RenewalStatus",
										"DomainValidationOptions"
									],
									"members": {
										"RenewalStatus": {},
										"DomainValidationOptions": {
											"shape": "Sd"
										}
									}
								}
							}
						}
					}
				}
			},
			"GetCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn"
					],
					"members": {
						"CertificateArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Certificate": {},
						"CertificateChain": {}
					}
				}
			},
			"ImportCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"Certificate",
						"PrivateKey"
					],
					"members": {
						"CertificateArn": {},
						"Certificate": {
							"type": "blob"
						},
						"PrivateKey": {
							"type": "blob",
							"sensitive": true
						},
						"CertificateChain": {
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CertificateArn": {}
					}
				}
			},
			"ListCertificates": {
				"input": {
					"type": "structure",
					"members": {
						"CertificateStatuses": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"CertificateSummaryList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"CertificateArn": {},
									"DomainName": {}
								}
							}
						}
					}
				}
			},
			"ListTagsForCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn"
					],
					"members": {
						"CertificateArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S3"
						}
					}
				}
			},
			"RemoveTagsFromCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn",
						"Tags"
					],
					"members": {
						"CertificateArn": {},
						"Tags": {
							"shape": "S3"
						}
					}
				}
			},
			"RequestCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"SubjectAlternativeNames": {
							"shape": "Sc"
						},
						"IdempotencyToken": {},
						"DomainValidationOptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"DomainName",
									"ValidationDomain"
								],
								"members": {
									"DomainName": {},
									"ValidationDomain": {}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CertificateArn": {}
					}
				}
			},
			"ResendValidationEmail": {
				"input": {
					"type": "structure",
					"required": [
						"CertificateArn",
						"Domain",
						"ValidationDomain"
					],
					"members": {
						"CertificateArn": {},
						"Domain": {},
						"ValidationDomain": {}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sc": {
				"type": "list",
				"member": {}
			},
			"Sd": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"ValidationEmails": {
							"type": "list",
							"member": {}
						},
						"ValidationDomain": {},
						"ValidationStatus": {}
					}
				}
			}
		}
	};

/***/ },
/* 637 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListCertificates": {
				"input_token": "NextToken",
				"limit_key": "MaxItems",
				"output_token": "NextToken",
				"result_key": "CertificateSummaryList"
			}
		}
	};

/***/ },
/* 638 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-07-09",
			"endpointPrefix": "apigateway",
			"protocol": "rest-json",
			"serviceFullName": "Amazon API Gateway",
			"signatureVersion": "v4",
			"uid": "apigateway-2015-07-09"
		},
		"operations": {
			"CreateApiKey": {
				"http": {
					"requestUri": "/apikeys",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"members": {
						"name": {},
						"description": {},
						"enabled": {
							"type": "boolean"
						},
						"generateDistinctId": {
							"type": "boolean"
						},
						"value": {},
						"stageKeys": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"restApiId": {},
									"stageName": {}
								}
							}
						},
						"customerId": {}
					}
				},
				"output": {
					"shape": "S6"
				}
			},
			"CreateAuthorizer": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/authorizers",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"name",
						"type",
						"identitySource"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"name": {},
						"type": {},
						"providerARNs": {
							"shape": "Sb"
						},
						"authType": {},
						"authorizerUri": {},
						"authorizerCredentials": {},
						"identitySource": {},
						"identityValidationExpression": {},
						"authorizerResultTtlInSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "Se"
				}
			},
			"CreateBasePathMapping": {
				"http": {
					"requestUri": "/domainnames/{domain_name}/basepathmappings",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName",
						"restApiId"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"basePath": {},
						"restApiId": {},
						"stage": {}
					}
				},
				"output": {
					"shape": "Sg"
				}
			},
			"CreateDeployment": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/deployments",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {},
						"stageDescription": {},
						"description": {},
						"cacheClusterEnabled": {
							"type": "boolean"
						},
						"cacheClusterSize": {},
						"variables": {
							"shape": "Sk"
						}
					}
				},
				"output": {
					"shape": "Sl"
				}
			},
			"CreateDocumentationPart": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/documentation/parts",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"location",
						"properties"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"location": {
							"shape": "Sq"
						},
						"properties": {}
					}
				},
				"output": {
					"shape": "St"
				}
			},
			"CreateDocumentationVersion": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/documentation/versions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationVersion"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationVersion": {},
						"stageName": {},
						"description": {}
					}
				},
				"output": {
					"shape": "Sv"
				}
			},
			"CreateDomainName": {
				"http": {
					"requestUri": "/domainnames",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName",
						"certificateName",
						"certificateBody",
						"certificatePrivateKey",
						"certificateChain"
					],
					"members": {
						"domainName": {},
						"certificateName": {},
						"certificateBody": {},
						"certificatePrivateKey": {},
						"certificateChain": {}
					}
				},
				"output": {
					"shape": "Sx"
				}
			},
			"CreateModel": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/models",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"name",
						"contentType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"name": {},
						"description": {},
						"schema": {},
						"contentType": {}
					}
				},
				"output": {
					"shape": "Sz"
				}
			},
			"CreateResource": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/resources/{parent_id}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"parentId",
						"pathPart"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"parentId": {
							"location": "uri",
							"locationName": "parent_id"
						},
						"pathPart": {}
					}
				},
				"output": {
					"shape": "S11"
				}
			},
			"CreateRestApi": {
				"http": {
					"requestUri": "/restapis",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"description": {},
						"version": {},
						"cloneFrom": {},
						"binaryMediaTypes": {
							"shape": "S8"
						}
					}
				},
				"output": {
					"shape": "S1e"
				}
			},
			"CreateStage": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/stages",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName",
						"deploymentId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {},
						"deploymentId": {},
						"description": {},
						"cacheClusterEnabled": {
							"type": "boolean"
						},
						"cacheClusterSize": {},
						"variables": {
							"shape": "Sk"
						},
						"documentationVersion": {}
					}
				},
				"output": {
					"shape": "S1g"
				}
			},
			"CreateUsagePlan": {
				"http": {
					"requestUri": "/usageplans",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"description": {},
						"apiStages": {
							"shape": "S1o"
						},
						"throttle": {
							"shape": "S1q"
						},
						"quota": {
							"shape": "S1r"
						}
					}
				},
				"output": {
					"shape": "S1t"
				}
			},
			"CreateUsagePlanKey": {
				"http": {
					"requestUri": "/usageplans/{usageplanId}/keys",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"keyId",
						"keyType"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {},
						"keyType": {}
					}
				},
				"output": {
					"shape": "S1v"
				}
			},
			"DeleteApiKey": {
				"http": {
					"method": "DELETE",
					"requestUri": "/apikeys/{api_Key}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"apiKey"
					],
					"members": {
						"apiKey": {
							"location": "uri",
							"locationName": "api_Key"
						}
					}
				}
			},
			"DeleteAuthorizer": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"authorizerId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"authorizerId": {
							"location": "uri",
							"locationName": "authorizer_id"
						}
					}
				}
			},
			"DeleteBasePathMapping": {
				"http": {
					"method": "DELETE",
					"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName",
						"basePath"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"basePath": {
							"location": "uri",
							"locationName": "base_path"
						}
					}
				}
			},
			"DeleteClientCertificate": {
				"http": {
					"method": "DELETE",
					"requestUri": "/clientcertificates/{clientcertificate_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"clientCertificateId"
					],
					"members": {
						"clientCertificateId": {
							"location": "uri",
							"locationName": "clientcertificate_id"
						}
					}
				}
			},
			"DeleteDeployment": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"deploymentId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"deploymentId": {
							"location": "uri",
							"locationName": "deployment_id"
						}
					}
				}
			},
			"DeleteDocumentationPart": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationPartId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationPartId": {
							"location": "uri",
							"locationName": "part_id"
						}
					}
				}
			},
			"DeleteDocumentationVersion": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationVersion"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationVersion": {
							"location": "uri",
							"locationName": "doc_version"
						}
					}
				}
			},
			"DeleteDomainName": {
				"http": {
					"method": "DELETE",
					"requestUri": "/domainnames/{domain_name}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						}
					}
				}
			},
			"DeleteIntegration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						}
					}
				}
			},
			"DeleteIntegrationResponse": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						}
					}
				}
			},
			"DeleteMethod": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						}
					}
				}
			},
			"DeleteMethodResponse": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						}
					}
				}
			},
			"DeleteModel": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/models/{model_name}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"modelName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"modelName": {
							"location": "uri",
							"locationName": "model_name"
						}
					}
				}
			},
			"DeleteResource": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						}
					}
				}
			},
			"DeleteRestApi": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						}
					}
				}
			},
			"DeleteStage": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						}
					}
				}
			},
			"DeleteUsagePlan": {
				"http": {
					"method": "DELETE",
					"requestUri": "/usageplans/{usageplanId}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						}
					}
				}
			},
			"DeleteUsagePlanKey": {
				"http": {
					"method": "DELETE",
					"requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"keyId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {
							"location": "uri",
							"locationName": "keyId"
						}
					}
				}
			},
			"FlushStageAuthorizersCache": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						}
					}
				}
			},
			"FlushStageCache": {
				"http": {
					"method": "DELETE",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/cache/data",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						}
					}
				}
			},
			"GenerateClientCertificate": {
				"http": {
					"requestUri": "/clientcertificates",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"members": {
						"description": {}
					}
				},
				"output": {
					"shape": "S2h"
				}
			},
			"GetAccount": {
				"http": {
					"method": "GET",
					"requestUri": "/account"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"shape": "S2j"
				}
			},
			"GetApiKey": {
				"http": {
					"method": "GET",
					"requestUri": "/apikeys/{api_Key}"
				},
				"input": {
					"type": "structure",
					"required": [
						"apiKey"
					],
					"members": {
						"apiKey": {
							"location": "uri",
							"locationName": "api_Key"
						},
						"includeValue": {
							"location": "querystring",
							"locationName": "includeValue",
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "S6"
				}
			},
			"GetApiKeys": {
				"http": {
					"method": "GET",
					"requestUri": "/apikeys"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"nameQuery": {
							"location": "querystring",
							"locationName": "name"
						},
						"customerId": {
							"location": "querystring",
							"locationName": "customerId"
						},
						"includeValues": {
							"location": "querystring",
							"locationName": "includeValues",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"warnings": {
							"shape": "S8"
						},
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S6"
							}
						}
					}
				}
			},
			"GetAuthorizer": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"authorizerId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"authorizerId": {
							"location": "uri",
							"locationName": "authorizer_id"
						}
					}
				},
				"output": {
					"shape": "Se"
				}
			},
			"GetAuthorizers": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/authorizers"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Se"
							}
						}
					}
				}
			},
			"GetBasePathMapping": {
				"http": {
					"method": "GET",
					"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName",
						"basePath"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"basePath": {
							"location": "uri",
							"locationName": "base_path"
						}
					}
				},
				"output": {
					"shape": "Sg"
				}
			},
			"GetBasePathMappings": {
				"http": {
					"method": "GET",
					"requestUri": "/domainnames/{domain_name}/basepathmappings"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sg"
							}
						}
					}
				}
			},
			"GetClientCertificate": {
				"http": {
					"method": "GET",
					"requestUri": "/clientcertificates/{clientcertificate_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"clientCertificateId"
					],
					"members": {
						"clientCertificateId": {
							"location": "uri",
							"locationName": "clientcertificate_id"
						}
					}
				},
				"output": {
					"shape": "S2h"
				}
			},
			"GetClientCertificates": {
				"http": {
					"method": "GET",
					"requestUri": "/clientcertificates"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S2h"
							}
						}
					}
				}
			},
			"GetDeployment": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"deploymentId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"deploymentId": {
							"location": "uri",
							"locationName": "deployment_id"
						}
					}
				},
				"output": {
					"shape": "Sl"
				}
			},
			"GetDeployments": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/deployments"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sl"
							}
						}
					}
				}
			},
			"GetDocumentationPart": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationPartId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationPartId": {
							"location": "uri",
							"locationName": "part_id"
						}
					}
				},
				"output": {
					"shape": "St"
				}
			},
			"GetDocumentationParts": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/documentation/parts"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"type": {
							"location": "querystring",
							"locationName": "type"
						},
						"nameQuery": {
							"location": "querystring",
							"locationName": "name"
						},
						"path": {
							"location": "querystring",
							"locationName": "path"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "St"
							}
						}
					}
				}
			},
			"GetDocumentationVersion": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationVersion"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationVersion": {
							"location": "uri",
							"locationName": "doc_version"
						}
					}
				},
				"output": {
					"shape": "Sv"
				}
			},
			"GetDocumentationVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/documentation/versions"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sv"
							}
						}
					}
				}
			},
			"GetDomainName": {
				"http": {
					"method": "GET",
					"requestUri": "/domainnames/{domain_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						}
					}
				},
				"output": {
					"shape": "Sx"
				}
			},
			"GetDomainNames": {
				"http": {
					"method": "GET",
					"requestUri": "/domainnames"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sx"
							}
						}
					}
				}
			},
			"GetExport": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName",
						"exportType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						},
						"exportType": {
							"location": "uri",
							"locationName": "export_type"
						},
						"parameters": {
							"shape": "Sk",
							"location": "querystring"
						},
						"accepts": {
							"location": "header",
							"locationName": "Accept"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"contentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				}
			},
			"GetIntegration": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						}
					}
				},
				"output": {
					"shape": "S18"
				}
			},
			"GetIntegrationResponse": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"GetMethod": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						}
					}
				},
				"output": {
					"shape": "S13"
				}
			},
			"GetMethodResponse": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						}
					}
				},
				"output": {
					"shape": "S16"
				}
			},
			"GetModel": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/models/{model_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"modelName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"modelName": {
							"location": "uri",
							"locationName": "model_name"
						},
						"flatten": {
							"location": "querystring",
							"locationName": "flatten",
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "Sz"
				}
			},
			"GetModelTemplate": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/models/{model_name}/default_template"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"modelName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"modelName": {
							"location": "uri",
							"locationName": "model_name"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"value": {}
					}
				}
			},
			"GetModels": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/models"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "Sz"
							}
						}
					}
				}
			},
			"GetResource": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						}
					}
				},
				"output": {
					"shape": "S11"
				}
			},
			"GetResources": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/resources"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S11"
							}
						}
					}
				}
			},
			"GetRestApi": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						}
					}
				},
				"output": {
					"shape": "S1e"
				}
			},
			"GetRestApis": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S1e"
							}
						}
					}
				}
			},
			"GetSdk": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName",
						"sdkType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						},
						"sdkType": {
							"location": "uri",
							"locationName": "sdk_type"
						},
						"parameters": {
							"shape": "Sk",
							"location": "querystring"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"contentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"contentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				}
			},
			"GetSdkType": {
				"http": {
					"method": "GET",
					"requestUri": "/sdktypes/{sdktype_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"id"
					],
					"members": {
						"id": {
							"location": "uri",
							"locationName": "sdktype_id"
						}
					}
				},
				"output": {
					"shape": "S44"
				}
			},
			"GetSdkTypes": {
				"http": {
					"method": "GET",
					"requestUri": "/sdktypes"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S44"
							}
						}
					}
				}
			},
			"GetStage": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						}
					}
				},
				"output": {
					"shape": "S1g"
				}
			},
			"GetStages": {
				"http": {
					"method": "GET",
					"requestUri": "/restapis/{restapi_id}/stages"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"deploymentId": {
							"location": "querystring",
							"locationName": "deploymentId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"item": {
							"type": "list",
							"member": {
								"shape": "S1g"
							}
						}
					}
				}
			},
			"GetUsage": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans/{usageplanId}/usage"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"startDate",
						"endDate"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {
							"location": "querystring",
							"locationName": "keyId"
						},
						"startDate": {
							"location": "querystring",
							"locationName": "startDate"
						},
						"endDate": {
							"location": "querystring",
							"locationName": "endDate"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "S4f"
				}
			},
			"GetUsagePlan": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans/{usageplanId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						}
					}
				},
				"output": {
					"shape": "S1t"
				}
			},
			"GetUsagePlanKey": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans/{usageplanId}/keys/{keyId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"keyId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {
							"location": "uri",
							"locationName": "keyId"
						}
					}
				},
				"output": {
					"shape": "S1v"
				}
			},
			"GetUsagePlanKeys": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans/{usageplanId}/keys"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						},
						"nameQuery": {
							"location": "querystring",
							"locationName": "name"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S1v"
							}
						}
					}
				}
			},
			"GetUsagePlans": {
				"http": {
					"method": "GET",
					"requestUri": "/usageplans"
				},
				"input": {
					"type": "structure",
					"members": {
						"position": {
							"location": "querystring",
							"locationName": "position"
						},
						"keyId": {
							"location": "querystring",
							"locationName": "keyId"
						},
						"limit": {
							"location": "querystring",
							"locationName": "limit",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"position": {},
						"items": {
							"locationName": "item",
							"type": "list",
							"member": {
								"shape": "S1t"
							}
						}
					}
				}
			},
			"ImportApiKeys": {
				"http": {
					"requestUri": "/apikeys?mode=import",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"body",
						"format"
					],
					"members": {
						"body": {
							"type": "blob"
						},
						"format": {
							"location": "querystring",
							"locationName": "format"
						},
						"failOnWarnings": {
							"location": "querystring",
							"locationName": "failonwarnings",
							"type": "boolean"
						}
					},
					"payload": "body"
				},
				"output": {
					"type": "structure",
					"members": {
						"ids": {
							"shape": "S8"
						},
						"warnings": {
							"shape": "S8"
						}
					}
				}
			},
			"ImportDocumentationParts": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/documentation/parts"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"body"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"mode": {
							"location": "querystring",
							"locationName": "mode"
						},
						"failOnWarnings": {
							"location": "querystring",
							"locationName": "failonwarnings",
							"type": "boolean"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				},
				"output": {
					"type": "structure",
					"members": {
						"ids": {
							"shape": "S8"
						},
						"warnings": {
							"shape": "S8"
						}
					}
				}
			},
			"ImportRestApi": {
				"http": {
					"requestUri": "/restapis?mode=import",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"body"
					],
					"members": {
						"failOnWarnings": {
							"location": "querystring",
							"locationName": "failonwarnings",
							"type": "boolean"
						},
						"parameters": {
							"shape": "Sk",
							"location": "querystring"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				},
				"output": {
					"shape": "S1e"
				}
			},
			"PutIntegration": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"type"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"type": {},
						"integrationHttpMethod": {
							"locationName": "httpMethod"
						},
						"uri": {},
						"credentials": {},
						"requestParameters": {
							"shape": "Sk"
						},
						"requestTemplates": {
							"shape": "Sk"
						},
						"passthroughBehavior": {},
						"cacheNamespace": {},
						"cacheKeyParameters": {
							"shape": "S8"
						},
						"contentHandling": {}
					}
				},
				"output": {
					"shape": "S18"
				}
			},
			"PutIntegrationResponse": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						},
						"selectionPattern": {},
						"responseParameters": {
							"shape": "Sk"
						},
						"responseTemplates": {
							"shape": "Sk"
						},
						"contentHandling": {}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"PutMethod": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"authorizationType"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"authorizationType": {},
						"authorizerId": {},
						"apiKeyRequired": {
							"type": "boolean"
						},
						"operationName": {},
						"requestParameters": {
							"shape": "S14"
						},
						"requestModels": {
							"shape": "Sk"
						}
					}
				},
				"output": {
					"shape": "S13"
				}
			},
			"PutMethodResponse": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						},
						"responseParameters": {
							"shape": "S14"
						},
						"responseModels": {
							"shape": "Sk"
						}
					}
				},
				"output": {
					"shape": "S16"
				}
			},
			"PutRestApi": {
				"http": {
					"method": "PUT",
					"requestUri": "/restapis/{restapi_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"body"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"mode": {
							"location": "querystring",
							"locationName": "mode"
						},
						"failOnWarnings": {
							"location": "querystring",
							"locationName": "failonwarnings",
							"type": "boolean"
						},
						"parameters": {
							"shape": "Sk",
							"location": "querystring"
						},
						"body": {
							"type": "blob"
						}
					},
					"payload": "body"
				},
				"output": {
					"shape": "S1e"
				}
			},
			"TestInvokeAuthorizer": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"authorizerId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"authorizerId": {
							"location": "uri",
							"locationName": "authorizer_id"
						},
						"headers": {
							"shape": "S55"
						},
						"pathWithQueryString": {},
						"body": {},
						"stageVariables": {
							"shape": "Sk"
						},
						"additionalContext": {
							"shape": "Sk"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"clientStatus": {
							"type": "integer"
						},
						"log": {},
						"latency": {
							"type": "long"
						},
						"principalId": {},
						"policy": {},
						"authorization": {
							"type": "map",
							"key": {},
							"value": {
								"shape": "S8"
							}
						},
						"claims": {
							"shape": "Sk"
						}
					}
				}
			},
			"TestInvokeMethod": {
				"http": {
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"pathWithQueryString": {},
						"body": {},
						"headers": {
							"shape": "S55"
						},
						"clientCertificateId": {},
						"stageVariables": {
							"shape": "Sk"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"status": {
							"type": "integer"
						},
						"body": {},
						"headers": {
							"shape": "S55"
						},
						"log": {},
						"latency": {
							"type": "long"
						}
					}
				}
			},
			"UpdateAccount": {
				"http": {
					"method": "PATCH",
					"requestUri": "/account"
				},
				"input": {
					"type": "structure",
					"members": {
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S2j"
				}
			},
			"UpdateApiKey": {
				"http": {
					"method": "PATCH",
					"requestUri": "/apikeys/{api_Key}"
				},
				"input": {
					"type": "structure",
					"required": [
						"apiKey"
					],
					"members": {
						"apiKey": {
							"location": "uri",
							"locationName": "api_Key"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S6"
				}
			},
			"UpdateAuthorizer": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/authorizers/{authorizer_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"authorizerId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"authorizerId": {
							"location": "uri",
							"locationName": "authorizer_id"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "Se"
				}
			},
			"UpdateBasePathMapping": {
				"http": {
					"method": "PATCH",
					"requestUri": "/domainnames/{domain_name}/basepathmappings/{base_path}"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName",
						"basePath"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"basePath": {
							"location": "uri",
							"locationName": "base_path"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "Sg"
				}
			},
			"UpdateClientCertificate": {
				"http": {
					"method": "PATCH",
					"requestUri": "/clientcertificates/{clientcertificate_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"clientCertificateId"
					],
					"members": {
						"clientCertificateId": {
							"location": "uri",
							"locationName": "clientcertificate_id"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S2h"
				}
			},
			"UpdateDeployment": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/deployments/{deployment_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"deploymentId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"deploymentId": {
							"location": "uri",
							"locationName": "deployment_id"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "Sl"
				}
			},
			"UpdateDocumentationPart": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/documentation/parts/{part_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationPartId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationPartId": {
							"location": "uri",
							"locationName": "part_id"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "St"
				}
			},
			"UpdateDocumentationVersion": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/documentation/versions/{doc_version}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"documentationVersion"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"documentationVersion": {
							"location": "uri",
							"locationName": "doc_version"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "Sv"
				}
			},
			"UpdateDomainName": {
				"http": {
					"method": "PATCH",
					"requestUri": "/domainnames/{domain_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"domainName"
					],
					"members": {
						"domainName": {
							"location": "uri",
							"locationName": "domain_name"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "Sx"
				}
			},
			"UpdateIntegration": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S18"
				}
			},
			"UpdateIntegrationResponse": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"UpdateMethod": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S13"
				}
			},
			"UpdateMethodResponse": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId",
						"httpMethod",
						"statusCode"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"httpMethod": {
							"location": "uri",
							"locationName": "http_method"
						},
						"statusCode": {
							"location": "uri",
							"locationName": "status_code"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S16"
				}
			},
			"UpdateModel": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/models/{model_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"modelName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"modelName": {
							"location": "uri",
							"locationName": "model_name"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "Sz"
				}
			},
			"UpdateResource": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/resources/{resource_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"resourceId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"resourceId": {
							"location": "uri",
							"locationName": "resource_id"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S11"
				}
			},
			"UpdateRestApi": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S1e"
				}
			},
			"UpdateStage": {
				"http": {
					"method": "PATCH",
					"requestUri": "/restapis/{restapi_id}/stages/{stage_name}"
				},
				"input": {
					"type": "structure",
					"required": [
						"restApiId",
						"stageName"
					],
					"members": {
						"restApiId": {
							"location": "uri",
							"locationName": "restapi_id"
						},
						"stageName": {
							"location": "uri",
							"locationName": "stage_name"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S1g"
				}
			},
			"UpdateUsage": {
				"http": {
					"method": "PATCH",
					"requestUri": "/usageplans/{usageplanId}/keys/{keyId}/usage"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId",
						"keyId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"keyId": {
							"location": "uri",
							"locationName": "keyId"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S4f"
				}
			},
			"UpdateUsagePlan": {
				"http": {
					"method": "PATCH",
					"requestUri": "/usageplans/{usageplanId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"usagePlanId"
					],
					"members": {
						"usagePlanId": {
							"location": "uri",
							"locationName": "usageplanId"
						},
						"patchOperations": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"shape": "S1t"
				}
			}
		},
		"shapes": {
			"S6": {
				"type": "structure",
				"members": {
					"id": {},
					"value": {},
					"name": {},
					"customerId": {},
					"description": {},
					"enabled": {
						"type": "boolean"
					},
					"createdDate": {
						"type": "timestamp"
					},
					"lastUpdatedDate": {
						"type": "timestamp"
					},
					"stageKeys": {
						"shape": "S8"
					}
				}
			},
			"S8": {
				"type": "list",
				"member": {}
			},
			"Sb": {
				"type": "list",
				"member": {}
			},
			"Se": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"type": {},
					"providerARNs": {
						"shape": "Sb"
					},
					"authType": {},
					"authorizerUri": {},
					"authorizerCredentials": {},
					"identitySource": {},
					"identityValidationExpression": {},
					"authorizerResultTtlInSeconds": {
						"type": "integer"
					}
				}
			},
			"Sg": {
				"type": "structure",
				"members": {
					"basePath": {},
					"restApiId": {},
					"stage": {}
				}
			},
			"Sk": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sl": {
				"type": "structure",
				"members": {
					"id": {},
					"description": {},
					"createdDate": {
						"type": "timestamp"
					},
					"apiSummary": {
						"type": "map",
						"key": {},
						"value": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"authorizationType": {},
									"apiKeyRequired": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"Sq": {
				"type": "structure",
				"required": [
					"type"
				],
				"members": {
					"type": {},
					"path": {},
					"method": {},
					"statusCode": {},
					"name": {}
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"id": {},
					"location": {
						"shape": "Sq"
					},
					"properties": {}
				}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"version": {},
					"createdDate": {
						"type": "timestamp"
					},
					"description": {}
				}
			},
			"Sx": {
				"type": "structure",
				"members": {
					"domainName": {},
					"certificateName": {},
					"certificateUploadDate": {
						"type": "timestamp"
					},
					"distributionDomainName": {}
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"description": {},
					"schema": {},
					"contentType": {}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"id": {},
					"parentId": {},
					"pathPart": {},
					"path": {},
					"resourceMethods": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S13"
						}
					}
				}
			},
			"S13": {
				"type": "structure",
				"members": {
					"httpMethod": {},
					"authorizationType": {},
					"authorizerId": {},
					"apiKeyRequired": {
						"type": "boolean"
					},
					"operationName": {},
					"requestParameters": {
						"shape": "S14"
					},
					"requestModels": {
						"shape": "Sk"
					},
					"methodResponses": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S16"
						}
					},
					"methodIntegration": {
						"shape": "S18"
					}
				}
			},
			"S14": {
				"type": "map",
				"key": {},
				"value": {
					"type": "boolean"
				}
			},
			"S16": {
				"type": "structure",
				"members": {
					"statusCode": {},
					"responseParameters": {
						"shape": "S14"
					},
					"responseModels": {
						"shape": "Sk"
					}
				}
			},
			"S18": {
				"type": "structure",
				"members": {
					"type": {},
					"httpMethod": {},
					"uri": {},
					"credentials": {},
					"requestParameters": {
						"shape": "Sk"
					},
					"requestTemplates": {
						"shape": "Sk"
					},
					"passthroughBehavior": {},
					"contentHandling": {},
					"cacheNamespace": {},
					"cacheKeyParameters": {
						"shape": "S8"
					},
					"integrationResponses": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S1c"
						}
					}
				}
			},
			"S1c": {
				"type": "structure",
				"members": {
					"statusCode": {},
					"selectionPattern": {},
					"responseParameters": {
						"shape": "Sk"
					},
					"responseTemplates": {
						"shape": "Sk"
					},
					"contentHandling": {}
				}
			},
			"S1e": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"description": {},
					"createdDate": {
						"type": "timestamp"
					},
					"version": {},
					"warnings": {
						"shape": "S8"
					},
					"binaryMediaTypes": {
						"shape": "S8"
					}
				}
			},
			"S1g": {
				"type": "structure",
				"members": {
					"deploymentId": {},
					"clientCertificateId": {},
					"stageName": {},
					"description": {},
					"cacheClusterEnabled": {
						"type": "boolean"
					},
					"cacheClusterSize": {},
					"cacheClusterStatus": {},
					"methodSettings": {
						"type": "map",
						"key": {},
						"value": {
							"type": "structure",
							"members": {
								"metricsEnabled": {
									"type": "boolean"
								},
								"loggingLevel": {},
								"dataTraceEnabled": {
									"type": "boolean"
								},
								"throttlingBurstLimit": {
									"type": "integer"
								},
								"throttlingRateLimit": {
									"type": "double"
								},
								"cachingEnabled": {
									"type": "boolean"
								},
								"cacheTtlInSeconds": {
									"type": "integer"
								},
								"cacheDataEncrypted": {
									"type": "boolean"
								},
								"requireAuthorizationForCacheControl": {
									"type": "boolean"
								},
								"unauthorizedCacheControlHeaderStrategy": {}
							}
						}
					},
					"variables": {
						"shape": "Sk"
					},
					"documentationVersion": {},
					"createdDate": {
						"type": "timestamp"
					},
					"lastUpdatedDate": {
						"type": "timestamp"
					}
				}
			},
			"S1o": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"apiId": {},
						"stage": {}
					}
				}
			},
			"S1q": {
				"type": "structure",
				"members": {
					"burstLimit": {
						"type": "integer"
					},
					"rateLimit": {
						"type": "double"
					}
				}
			},
			"S1r": {
				"type": "structure",
				"members": {
					"limit": {
						"type": "integer"
					},
					"offset": {
						"type": "integer"
					},
					"period": {}
				}
			},
			"S1t": {
				"type": "structure",
				"members": {
					"id": {},
					"name": {},
					"description": {},
					"apiStages": {
						"shape": "S1o"
					},
					"throttle": {
						"shape": "S1q"
					},
					"quota": {
						"shape": "S1r"
					},
					"productCode": {}
				}
			},
			"S1v": {
				"type": "structure",
				"members": {
					"id": {},
					"type": {},
					"value": {},
					"name": {}
				}
			},
			"S2h": {
				"type": "structure",
				"members": {
					"clientCertificateId": {},
					"description": {},
					"pemEncodedCertificate": {},
					"createdDate": {
						"type": "timestamp"
					},
					"expirationDate": {
						"type": "timestamp"
					}
				}
			},
			"S2j": {
				"type": "structure",
				"members": {
					"cloudwatchRoleArn": {},
					"throttleSettings": {
						"shape": "S1q"
					},
					"features": {
						"shape": "S8"
					},
					"apiKeyVersion": {}
				}
			},
			"S44": {
				"type": "structure",
				"members": {
					"id": {},
					"friendlyName": {},
					"description": {},
					"configurationProperties": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {},
								"friendlyName": {},
								"description": {},
								"required": {
									"type": "boolean"
								},
								"defaultValue": {}
							}
						}
					}
				}
			},
			"S4f": {
				"type": "structure",
				"members": {
					"usagePlanId": {},
					"startDate": {},
					"endDate": {},
					"position": {},
					"items": {
						"locationName": "values",
						"type": "map",
						"key": {},
						"value": {
							"type": "list",
							"member": {
								"type": "list",
								"member": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S55": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S5b": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"op": {},
						"path": {},
						"value": {},
						"from": {}
					}
				}
			}
		}
	};

/***/ },
/* 639 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetApiKeys": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetBasePathMappings": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetClientCertificates": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetDeployments": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetDomainNames": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetModels": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetResources": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetRestApis": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetUsage": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetUsagePlans": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			},
			"GetUsagePlanKeys": {
				"input_token": "position",
				"output_token": "position",
				"limit_key": "limit",
				"result_key": "items"
			}
		}
	};

/***/ },
/* 640 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-02-06",
			"endpointPrefix": "autoscaling",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Application Auto Scaling",
			"signatureVersion": "v4",
			"signingName": "application-autoscaling",
			"targetPrefix": "AnyScaleFrontendService",
			"uid": "application-autoscaling-2016-02-06"
		},
		"operations": {
			"DeleteScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyName",
						"ServiceNamespace",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"PolicyName": {},
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterScalableTarget": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeScalableTargets": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace"
					],
					"members": {
						"ServiceNamespace": {},
						"ResourceIds": {
							"shape": "S9"
						},
						"ScalableDimension": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScalableTargets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ServiceNamespace",
									"ResourceId",
									"ScalableDimension",
									"MinCapacity",
									"MaxCapacity",
									"RoleARN",
									"CreationTime"
								],
								"members": {
									"ServiceNamespace": {},
									"ResourceId": {},
									"ScalableDimension": {},
									"MinCapacity": {
										"type": "integer"
									},
									"MaxCapacity": {
										"type": "integer"
									},
									"RoleARN": {},
									"CreationTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScalingActivities": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace"
					],
					"members": {
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScalingActivities": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ActivityId",
									"ServiceNamespace",
									"ResourceId",
									"ScalableDimension",
									"Description",
									"Cause",
									"StartTime",
									"StatusCode"
								],
								"members": {
									"ActivityId": {},
									"ServiceNamespace": {},
									"ResourceId": {},
									"ScalableDimension": {},
									"Description": {},
									"Cause": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"StatusCode": {},
									"StatusMessage": {},
									"Details": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScalingPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace"
					],
					"members": {
						"PolicyNames": {
							"shape": "S9"
						},
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScalingPolicies": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"PolicyARN",
									"PolicyName",
									"ServiceNamespace",
									"ResourceId",
									"ScalableDimension",
									"PolicyType",
									"CreationTime"
								],
								"members": {
									"PolicyARN": {},
									"PolicyName": {},
									"ServiceNamespace": {},
									"ResourceId": {},
									"ScalableDimension": {},
									"PolicyType": {},
									"StepScalingPolicyConfiguration": {
										"shape": "St"
									},
									"Alarms": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"AlarmName",
												"AlarmARN"
											],
											"members": {
												"AlarmName": {},
												"AlarmARN": {}
											}
										}
									},
									"CreationTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"PutScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyName",
						"ServiceNamespace",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"PolicyName": {},
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"PolicyType": {},
						"StepScalingPolicyConfiguration": {
							"shape": "St"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"PolicyARN"
					],
					"members": {
						"PolicyARN": {}
					}
				}
			},
			"RegisterScalableTarget": {
				"input": {
					"type": "structure",
					"required": [
						"ServiceNamespace",
						"ResourceId",
						"ScalableDimension"
					],
					"members": {
						"ServiceNamespace": {},
						"ResourceId": {},
						"ScalableDimension": {},
						"MinCapacity": {
							"type": "integer"
						},
						"MaxCapacity": {
							"type": "integer"
						},
						"RoleARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S9": {
				"type": "list",
				"member": {}
			},
			"St": {
				"type": "structure",
				"members": {
					"AdjustmentType": {},
					"StepAdjustments": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"ScalingAdjustment"
							],
							"members": {
								"MetricIntervalLowerBound": {
									"type": "double"
								},
								"MetricIntervalUpperBound": {
									"type": "double"
								},
								"ScalingAdjustment": {
									"type": "integer"
								}
							}
						}
					},
					"MinAdjustmentMagnitude": {
						"type": "integer"
					},
					"Cooldown": {
						"type": "integer"
					},
					"MetricAggregationType": {}
				}
			}
		}
	};

/***/ },
/* 641 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeScalableTargets": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "ScalableTargets"
			},
			"DescribeScalingPolicies": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "ScalingPolicies"
			},
			"DescribeScalingActivities": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "ScalingActivities"
			}
		}
	};

/***/ },
/* 642 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2011-01-01",
			"endpointPrefix": "autoscaling",
			"protocol": "query",
			"serviceFullName": "Auto Scaling",
			"signatureVersion": "v4",
			"uid": "autoscaling-2011-01-01",
			"xmlNamespace": "http://autoscaling.amazonaws.com/doc/2011-01-01/"
		},
		"operations": {
			"AttachInstances": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {}
					}
				}
			},
			"AttachLoadBalancerTargetGroups": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"TargetGroupARNs"
					],
					"members": {
						"AutoScalingGroupName": {},
						"TargetGroupARNs": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"resultWrapper": "AttachLoadBalancerTargetGroupsResult",
					"type": "structure",
					"members": {}
				}
			},
			"AttachLoadBalancers": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"LoadBalancerNames"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LoadBalancerNames": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "AttachLoadBalancersResult",
					"type": "structure",
					"members": {}
				}
			},
			"CompleteLifecycleAction": {
				"input": {
					"type": "structure",
					"required": [
						"LifecycleHookName",
						"AutoScalingGroupName",
						"LifecycleActionResult"
					],
					"members": {
						"LifecycleHookName": {},
						"AutoScalingGroupName": {},
						"LifecycleActionToken": {},
						"LifecycleActionResult": {},
						"InstanceId": {}
					}
				},
				"output": {
					"resultWrapper": "CompleteLifecycleActionResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateAutoScalingGroup": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"MinSize",
						"MaxSize"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LaunchConfigurationName": {},
						"InstanceId": {},
						"MinSize": {
							"type": "integer"
						},
						"MaxSize": {
							"type": "integer"
						},
						"DesiredCapacity": {
							"type": "integer"
						},
						"DefaultCooldown": {
							"type": "integer"
						},
						"AvailabilityZones": {
							"shape": "Sn"
						},
						"LoadBalancerNames": {
							"shape": "Sa"
						},
						"TargetGroupARNs": {
							"shape": "S6"
						},
						"HealthCheckType": {},
						"HealthCheckGracePeriod": {
							"type": "integer"
						},
						"PlacementGroup": {},
						"VPCZoneIdentifier": {},
						"TerminationPolicies": {
							"shape": "Sr"
						},
						"NewInstancesProtectedFromScaleIn": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Su"
						}
					}
				}
			},
			"CreateLaunchConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"LaunchConfigurationName"
					],
					"members": {
						"LaunchConfigurationName": {},
						"ImageId": {},
						"KeyName": {},
						"SecurityGroups": {
							"shape": "S11"
						},
						"ClassicLinkVPCId": {},
						"ClassicLinkVPCSecurityGroups": {
							"shape": "S12"
						},
						"UserData": {},
						"InstanceId": {},
						"InstanceType": {},
						"KernelId": {},
						"RamdiskId": {},
						"BlockDeviceMappings": {
							"shape": "S14"
						},
						"InstanceMonitoring": {
							"shape": "S1d"
						},
						"SpotPrice": {},
						"IamInstanceProfile": {},
						"EbsOptimized": {
							"type": "boolean"
						},
						"AssociatePublicIpAddress": {
							"type": "boolean"
						},
						"PlacementTenancy": {}
					}
				}
			},
			"CreateOrUpdateTags": {
				"input": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "Su"
						}
					}
				}
			},
			"DeleteAutoScalingGroup": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"ForceDelete": {
							"type": "boolean"
						}
					}
				}
			},
			"DeleteLaunchConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"LaunchConfigurationName"
					],
					"members": {
						"LaunchConfigurationName": {}
					}
				}
			},
			"DeleteLifecycleHook": {
				"input": {
					"type": "structure",
					"required": [
						"LifecycleHookName",
						"AutoScalingGroupName"
					],
					"members": {
						"LifecycleHookName": {},
						"AutoScalingGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteLifecycleHookResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteNotificationConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"TopicARN"
					],
					"members": {
						"AutoScalingGroupName": {},
						"TopicARN": {}
					}
				}
			},
			"DeletePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"PolicyName": {}
					}
				}
			},
			"DeleteScheduledAction": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ScheduledActionName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"ScheduledActionName": {}
					}
				}
			},
			"DeleteTags": {
				"input": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "Su"
						}
					}
				}
			},
			"DescribeAccountLimits": {
				"output": {
					"resultWrapper": "DescribeAccountLimitsResult",
					"type": "structure",
					"members": {
						"MaxNumberOfAutoScalingGroups": {
							"type": "integer"
						},
						"MaxNumberOfLaunchConfigurations": {
							"type": "integer"
						},
						"NumberOfAutoScalingGroups": {
							"type": "integer"
						},
						"NumberOfLaunchConfigurations": {
							"type": "integer"
						}
					}
				}
			},
			"DescribeAdjustmentTypes": {
				"output": {
					"resultWrapper": "DescribeAdjustmentTypesResult",
					"type": "structure",
					"members": {
						"AdjustmentTypes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AdjustmentType": {}
								}
							}
						}
					}
				}
			},
			"DescribeAutoScalingGroups": {
				"input": {
					"type": "structure",
					"members": {
						"AutoScalingGroupNames": {
							"shape": "S22"
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeAutoScalingGroupsResult",
					"type": "structure",
					"required": [
						"AutoScalingGroups"
					],
					"members": {
						"AutoScalingGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"AutoScalingGroupName",
									"MinSize",
									"MaxSize",
									"DesiredCapacity",
									"DefaultCooldown",
									"AvailabilityZones",
									"HealthCheckType",
									"CreatedTime"
								],
								"members": {
									"AutoScalingGroupName": {},
									"AutoScalingGroupARN": {},
									"LaunchConfigurationName": {},
									"MinSize": {
										"type": "integer"
									},
									"MaxSize": {
										"type": "integer"
									},
									"DesiredCapacity": {
										"type": "integer"
									},
									"DefaultCooldown": {
										"type": "integer"
									},
									"AvailabilityZones": {
										"shape": "Sn"
									},
									"LoadBalancerNames": {
										"shape": "Sa"
									},
									"TargetGroupARNs": {
										"shape": "S6"
									},
									"HealthCheckType": {},
									"HealthCheckGracePeriod": {
										"type": "integer"
									},
									"Instances": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"InstanceId",
												"AvailabilityZone",
												"LifecycleState",
												"HealthStatus",
												"LaunchConfigurationName",
												"ProtectedFromScaleIn"
											],
											"members": {
												"InstanceId": {},
												"AvailabilityZone": {},
												"LifecycleState": {},
												"HealthStatus": {},
												"LaunchConfigurationName": {},
												"ProtectedFromScaleIn": {
													"type": "boolean"
												}
											}
										}
									},
									"CreatedTime": {
										"type": "timestamp"
									},
									"SuspendedProcesses": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"ProcessName": {},
												"SuspensionReason": {}
											}
										}
									},
									"PlacementGroup": {},
									"VPCZoneIdentifier": {},
									"EnabledMetrics": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Metric": {},
												"Granularity": {}
											}
										}
									},
									"Status": {},
									"Tags": {
										"shape": "S2f"
									},
									"TerminationPolicies": {
										"shape": "Sr"
									},
									"NewInstancesProtectedFromScaleIn": {
										"type": "boolean"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAutoScalingInstances": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAutoScalingInstancesResult",
					"type": "structure",
					"members": {
						"AutoScalingInstances": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"InstanceId",
									"AutoScalingGroupName",
									"AvailabilityZone",
									"LifecycleState",
									"HealthStatus",
									"LaunchConfigurationName",
									"ProtectedFromScaleIn"
								],
								"members": {
									"InstanceId": {},
									"AutoScalingGroupName": {},
									"AvailabilityZone": {},
									"LifecycleState": {},
									"HealthStatus": {},
									"LaunchConfigurationName": {},
									"ProtectedFromScaleIn": {
										"type": "boolean"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAutoScalingNotificationTypes": {
				"output": {
					"resultWrapper": "DescribeAutoScalingNotificationTypesResult",
					"type": "structure",
					"members": {
						"AutoScalingNotificationTypes": {
							"shape": "S2m"
						}
					}
				}
			},
			"DescribeLaunchConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"LaunchConfigurationNames": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLaunchConfigurationsResult",
					"type": "structure",
					"required": [
						"LaunchConfigurations"
					],
					"members": {
						"LaunchConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"LaunchConfigurationName",
									"ImageId",
									"InstanceType",
									"CreatedTime"
								],
								"members": {
									"LaunchConfigurationName": {},
									"LaunchConfigurationARN": {},
									"ImageId": {},
									"KeyName": {},
									"SecurityGroups": {
										"shape": "S11"
									},
									"ClassicLinkVPCId": {},
									"ClassicLinkVPCSecurityGroups": {
										"shape": "S12"
									},
									"UserData": {},
									"InstanceType": {},
									"KernelId": {},
									"RamdiskId": {},
									"BlockDeviceMappings": {
										"shape": "S14"
									},
									"InstanceMonitoring": {
										"shape": "S1d"
									},
									"SpotPrice": {},
									"IamInstanceProfile": {},
									"CreatedTime": {
										"type": "timestamp"
									},
									"EbsOptimized": {
										"type": "boolean"
									},
									"AssociatePublicIpAddress": {
										"type": "boolean"
									},
									"PlacementTenancy": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeLifecycleHookTypes": {
				"output": {
					"resultWrapper": "DescribeLifecycleHookTypesResult",
					"type": "structure",
					"members": {
						"LifecycleHookTypes": {
							"shape": "S2m"
						}
					}
				}
			},
			"DescribeLifecycleHooks": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LifecycleHookNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLifecycleHooksResult",
					"type": "structure",
					"members": {
						"LifecycleHooks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LifecycleHookName": {},
									"AutoScalingGroupName": {},
									"LifecycleTransition": {},
									"NotificationTargetARN": {},
									"RoleARN": {},
									"NotificationMetadata": {},
									"HeartbeatTimeout": {
										"type": "integer"
									},
									"GlobalTimeout": {
										"type": "integer"
									},
									"DefaultResult": {}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBalancerTargetGroups": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerTargetGroupsResult",
					"type": "structure",
					"members": {
						"LoadBalancerTargetGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LoadBalancerTargetGroupARN": {},
									"State": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeLoadBalancers": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancersResult",
					"type": "structure",
					"members": {
						"LoadBalancers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LoadBalancerName": {},
									"State": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMetricCollectionTypes": {
				"output": {
					"resultWrapper": "DescribeMetricCollectionTypesResult",
					"type": "structure",
					"members": {
						"Metrics": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Metric": {}
								}
							}
						},
						"Granularities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Granularity": {}
								}
							}
						}
					}
				}
			},
			"DescribeNotificationConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"AutoScalingGroupNames": {
							"shape": "S22"
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeNotificationConfigurationsResult",
					"type": "structure",
					"required": [
						"NotificationConfigurations"
					],
					"members": {
						"NotificationConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AutoScalingGroupName": {},
									"TopicARN": {},
									"NotificationType": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePolicies": {
				"input": {
					"type": "structure",
					"members": {
						"AutoScalingGroupName": {},
						"PolicyNames": {
							"type": "list",
							"member": {}
						},
						"PolicyTypes": {
							"type": "list",
							"member": {}
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribePoliciesResult",
					"type": "structure",
					"members": {
						"ScalingPolicies": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AutoScalingGroupName": {},
									"PolicyName": {},
									"PolicyARN": {},
									"PolicyType": {},
									"AdjustmentType": {},
									"MinAdjustmentStep": {
										"shape": "S3p"
									},
									"MinAdjustmentMagnitude": {
										"type": "integer"
									},
									"ScalingAdjustment": {
										"type": "integer"
									},
									"Cooldown": {
										"type": "integer"
									},
									"StepAdjustments": {
										"shape": "S3s"
									},
									"MetricAggregationType": {},
									"EstimatedInstanceWarmup": {
										"type": "integer"
									},
									"Alarms": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"AlarmName": {},
												"AlarmARN": {}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScalingActivities": {
				"input": {
					"type": "structure",
					"members": {
						"ActivityIds": {
							"type": "list",
							"member": {}
						},
						"AutoScalingGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeScalingActivitiesResult",
					"type": "structure",
					"required": [
						"Activities"
					],
					"members": {
						"Activities": {
							"shape": "S41"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeScalingProcessTypes": {
				"output": {
					"resultWrapper": "DescribeScalingProcessTypesResult",
					"type": "structure",
					"members": {
						"Processes": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ProcessName"
								],
								"members": {
									"ProcessName": {}
								}
							}
						}
					}
				}
			},
			"DescribeScheduledActions": {
				"input": {
					"type": "structure",
					"members": {
						"AutoScalingGroupName": {},
						"ScheduledActionNames": {
							"type": "list",
							"member": {}
						},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeScheduledActionsResult",
					"type": "structure",
					"members": {
						"ScheduledUpdateGroupActions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AutoScalingGroupName": {},
									"ScheduledActionName": {},
									"ScheduledActionARN": {},
									"Time": {
										"type": "timestamp"
									},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"Recurrence": {},
									"MinSize": {
										"type": "integer"
									},
									"MaxSize": {
										"type": "integer"
									},
									"DesiredCapacity": {
										"type": "integer"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"NextToken": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTagsResult",
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S2f"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeTerminationPolicyTypes": {
				"output": {
					"resultWrapper": "DescribeTerminationPolicyTypesResult",
					"type": "structure",
					"members": {
						"TerminationPolicyTypes": {
							"shape": "Sr"
						}
					}
				}
			},
			"DetachInstances": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ShouldDecrementDesiredCapacity"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {},
						"ShouldDecrementDesiredCapacity": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DetachInstancesResult",
					"type": "structure",
					"members": {
						"Activities": {
							"shape": "S41"
						}
					}
				}
			},
			"DetachLoadBalancerTargetGroups": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"TargetGroupARNs"
					],
					"members": {
						"AutoScalingGroupName": {},
						"TargetGroupARNs": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"resultWrapper": "DetachLoadBalancerTargetGroupsResult",
					"type": "structure",
					"members": {}
				}
			},
			"DetachLoadBalancers": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"LoadBalancerNames"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LoadBalancerNames": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "DetachLoadBalancersResult",
					"type": "structure",
					"members": {}
				}
			},
			"DisableMetricsCollection": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"Metrics": {
							"shape": "S4r"
						}
					}
				}
			},
			"EnableMetricsCollection": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"Granularity"
					],
					"members": {
						"AutoScalingGroupName": {},
						"Metrics": {
							"shape": "S4r"
						},
						"Granularity": {}
					}
				}
			},
			"EnterStandby": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ShouldDecrementDesiredCapacity"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {},
						"ShouldDecrementDesiredCapacity": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "EnterStandbyResult",
					"type": "structure",
					"members": {
						"Activities": {
							"shape": "S41"
						}
					}
				}
			},
			"ExecutePolicy": {
				"input": {
					"type": "structure",
					"required": [
						"PolicyName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"PolicyName": {},
						"HonorCooldown": {
							"type": "boolean"
						},
						"MetricValue": {
							"type": "double"
						},
						"BreachThreshold": {
							"type": "double"
						}
					}
				}
			},
			"ExitStandby": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "ExitStandbyResult",
					"type": "structure",
					"members": {
						"Activities": {
							"shape": "S41"
						}
					}
				}
			},
			"PutLifecycleHook": {
				"input": {
					"type": "structure",
					"required": [
						"LifecycleHookName",
						"AutoScalingGroupName"
					],
					"members": {
						"LifecycleHookName": {},
						"AutoScalingGroupName": {},
						"LifecycleTransition": {},
						"RoleARN": {},
						"NotificationTargetARN": {},
						"NotificationMetadata": {},
						"HeartbeatTimeout": {
							"type": "integer"
						},
						"DefaultResult": {}
					}
				},
				"output": {
					"resultWrapper": "PutLifecycleHookResult",
					"type": "structure",
					"members": {}
				}
			},
			"PutNotificationConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"TopicARN",
						"NotificationTypes"
					],
					"members": {
						"AutoScalingGroupName": {},
						"TopicARN": {},
						"NotificationTypes": {
							"shape": "S2m"
						}
					}
				}
			},
			"PutScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"PolicyName",
						"AdjustmentType"
					],
					"members": {
						"AutoScalingGroupName": {},
						"PolicyName": {},
						"PolicyType": {},
						"AdjustmentType": {},
						"MinAdjustmentStep": {
							"shape": "S3p"
						},
						"MinAdjustmentMagnitude": {
							"type": "integer"
						},
						"ScalingAdjustment": {
							"type": "integer"
						},
						"Cooldown": {
							"type": "integer"
						},
						"MetricAggregationType": {},
						"StepAdjustments": {
							"shape": "S3s"
						},
						"EstimatedInstanceWarmup": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "PutScalingPolicyResult",
					"type": "structure",
					"members": {
						"PolicyARN": {}
					}
				}
			},
			"PutScheduledUpdateGroupAction": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"ScheduledActionName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"ScheduledActionName": {},
						"Time": {
							"type": "timestamp"
						},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Recurrence": {},
						"MinSize": {
							"type": "integer"
						},
						"MaxSize": {
							"type": "integer"
						},
						"DesiredCapacity": {
							"type": "integer"
						}
					}
				}
			},
			"RecordLifecycleActionHeartbeat": {
				"input": {
					"type": "structure",
					"required": [
						"LifecycleHookName",
						"AutoScalingGroupName"
					],
					"members": {
						"LifecycleHookName": {},
						"AutoScalingGroupName": {},
						"LifecycleActionToken": {},
						"InstanceId": {}
					}
				},
				"output": {
					"resultWrapper": "RecordLifecycleActionHeartbeatResult",
					"type": "structure",
					"members": {}
				}
			},
			"ResumeProcesses": {
				"input": {
					"shape": "S58"
				}
			},
			"SetDesiredCapacity": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName",
						"DesiredCapacity"
					],
					"members": {
						"AutoScalingGroupName": {},
						"DesiredCapacity": {
							"type": "integer"
						},
						"HonorCooldown": {
							"type": "boolean"
						}
					}
				}
			},
			"SetInstanceHealth": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"HealthStatus"
					],
					"members": {
						"InstanceId": {},
						"HealthStatus": {},
						"ShouldRespectGracePeriod": {
							"type": "boolean"
						}
					}
				}
			},
			"SetInstanceProtection": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds",
						"AutoScalingGroupName",
						"ProtectedFromScaleIn"
					],
					"members": {
						"InstanceIds": {
							"shape": "S2"
						},
						"AutoScalingGroupName": {},
						"ProtectedFromScaleIn": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "SetInstanceProtectionResult",
					"type": "structure",
					"members": {}
				}
			},
			"SuspendProcesses": {
				"input": {
					"shape": "S58"
				}
			},
			"TerminateInstanceInAutoScalingGroup": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"ShouldDecrementDesiredCapacity"
					],
					"members": {
						"InstanceId": {},
						"ShouldDecrementDesiredCapacity": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "TerminateInstanceInAutoScalingGroupResult",
					"type": "structure",
					"members": {
						"Activity": {
							"shape": "S42"
						}
					}
				}
			},
			"UpdateAutoScalingGroup": {
				"input": {
					"type": "structure",
					"required": [
						"AutoScalingGroupName"
					],
					"members": {
						"AutoScalingGroupName": {},
						"LaunchConfigurationName": {},
						"MinSize": {
							"type": "integer"
						},
						"MaxSize": {
							"type": "integer"
						},
						"DesiredCapacity": {
							"type": "integer"
						},
						"DefaultCooldown": {
							"type": "integer"
						},
						"AvailabilityZones": {
							"shape": "Sn"
						},
						"HealthCheckType": {},
						"HealthCheckGracePeriod": {
							"type": "integer"
						},
						"PlacementGroup": {},
						"VPCZoneIdentifier": {},
						"TerminationPolicies": {
							"shape": "Sr"
						},
						"NewInstancesProtectedFromScaleIn": {
							"type": "boolean"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"S6": {
				"type": "list",
				"member": {}
			},
			"Sa": {
				"type": "list",
				"member": {}
			},
			"Sn": {
				"type": "list",
				"member": {}
			},
			"Sr": {
				"type": "list",
				"member": {}
			},
			"Su": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"ResourceId": {},
						"ResourceType": {},
						"Key": {},
						"Value": {},
						"PropagateAtLaunch": {
							"type": "boolean"
						}
					}
				}
			},
			"S11": {
				"type": "list",
				"member": {}
			},
			"S12": {
				"type": "list",
				"member": {}
			},
			"S14": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"DeviceName"
					],
					"members": {
						"VirtualName": {},
						"DeviceName": {},
						"Ebs": {
							"type": "structure",
							"members": {
								"SnapshotId": {},
								"VolumeSize": {
									"type": "integer"
								},
								"VolumeType": {},
								"DeleteOnTermination": {
									"type": "boolean"
								},
								"Iops": {
									"type": "integer"
								},
								"Encrypted": {
									"type": "boolean"
								}
							}
						},
						"NoDevice": {
							"type": "boolean"
						}
					}
				}
			},
			"S1d": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S22": {
				"type": "list",
				"member": {}
			},
			"S2f": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ResourceId": {},
						"ResourceType": {},
						"Key": {},
						"Value": {},
						"PropagateAtLaunch": {
							"type": "boolean"
						}
					}
				}
			},
			"S2m": {
				"type": "list",
				"member": {}
			},
			"S3p": {
				"type": "integer",
				"deprecated": true
			},
			"S3s": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ScalingAdjustment"
					],
					"members": {
						"MetricIntervalLowerBound": {
							"type": "double"
						},
						"MetricIntervalUpperBound": {
							"type": "double"
						},
						"ScalingAdjustment": {
							"type": "integer"
						}
					}
				}
			},
			"S41": {
				"type": "list",
				"member": {
					"shape": "S42"
				}
			},
			"S42": {
				"type": "structure",
				"required": [
					"ActivityId",
					"AutoScalingGroupName",
					"Cause",
					"StartTime",
					"StatusCode"
				],
				"members": {
					"ActivityId": {},
					"AutoScalingGroupName": {},
					"Description": {},
					"Cause": {},
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					},
					"StatusCode": {},
					"StatusMessage": {},
					"Progress": {
						"type": "integer"
					},
					"Details": {}
				}
			},
			"S4r": {
				"type": "list",
				"member": {}
			},
			"S58": {
				"type": "structure",
				"required": [
					"AutoScalingGroupName"
				],
				"members": {
					"AutoScalingGroupName": {},
					"ScalingProcesses": {
						"type": "list",
						"member": {}
					}
				}
			}
		}
	};

/***/ },
/* 643 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeAutoScalingGroups": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "AutoScalingGroups"
			},
			"DescribeAutoScalingInstances": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "AutoScalingInstances"
			},
			"DescribeLaunchConfigurations": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "LaunchConfigurations"
			},
			"DescribeNotificationConfigurations": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "NotificationConfigurations"
			},
			"DescribePolicies": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "ScalingPolicies"
			},
			"DescribeScalingActivities": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "Activities"
			},
			"DescribeScheduledActions": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "ScheduledUpdateGroupActions"
			},
			"DescribeTags": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "Tags"
			}
		}
	};

/***/ },
/* 644 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2010-05-15",
			"endpointPrefix": "cloudformation",
			"protocol": "query",
			"serviceFullName": "AWS CloudFormation",
			"signatureVersion": "v4",
			"uid": "cloudformation-2010-05-15",
			"xmlNamespace": "http://cloudformation.amazonaws.com/doc/2010-05-15/"
		},
		"operations": {
			"CancelUpdateStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {}
					}
				}
			},
			"ContinueUpdateRollback": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"RoleARN": {},
						"ResourcesToSkip": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "ContinueUpdateRollbackResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateChangeSet": {
				"input": {
					"type": "structure",
					"required": [
						"StackName",
						"ChangeSetName"
					],
					"members": {
						"StackName": {},
						"TemplateBody": {},
						"TemplateURL": {},
						"UsePreviousTemplate": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "Sd"
						},
						"Capabilities": {
							"shape": "Si"
						},
						"ResourceTypes": {
							"shape": "Sk"
						},
						"RoleARN": {},
						"NotificationARNs": {
							"shape": "Sm"
						},
						"Tags": {
							"shape": "So"
						},
						"ChangeSetName": {},
						"ClientToken": {},
						"Description": {},
						"ChangeSetType": {}
					}
				},
				"output": {
					"resultWrapper": "CreateChangeSetResult",
					"type": "structure",
					"members": {
						"Id": {},
						"StackId": {}
					}
				}
			},
			"CreateStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"TemplateBody": {},
						"TemplateURL": {},
						"Parameters": {
							"shape": "Sd"
						},
						"DisableRollback": {
							"type": "boolean"
						},
						"TimeoutInMinutes": {
							"type": "integer"
						},
						"NotificationARNs": {
							"shape": "Sm"
						},
						"Capabilities": {
							"shape": "Si"
						},
						"ResourceTypes": {
							"shape": "Sk"
						},
						"RoleARN": {},
						"OnFailure": {},
						"StackPolicyBody": {},
						"StackPolicyURL": {},
						"Tags": {
							"shape": "So"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateStackResult",
					"type": "structure",
					"members": {
						"StackId": {}
					}
				}
			},
			"DeleteChangeSet": {
				"input": {
					"type": "structure",
					"required": [
						"ChangeSetName"
					],
					"members": {
						"ChangeSetName": {},
						"StackName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteChangeSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"RetainResources": {
							"type": "list",
							"member": {}
						},
						"RoleARN": {}
					}
				}
			},
			"DescribeAccountLimits": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAccountLimitsResult",
					"type": "structure",
					"members": {
						"AccountLimits": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Value": {
										"type": "integer"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeChangeSet": {
				"input": {
					"type": "structure",
					"required": [
						"ChangeSetName"
					],
					"members": {
						"ChangeSetName": {},
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeChangeSetResult",
					"type": "structure",
					"members": {
						"ChangeSetName": {},
						"ChangeSetId": {},
						"StackId": {},
						"StackName": {},
						"Description": {},
						"Parameters": {
							"shape": "Sd"
						},
						"CreationTime": {
							"type": "timestamp"
						},
						"ExecutionStatus": {},
						"Status": {},
						"StatusReason": {},
						"NotificationARNs": {
							"shape": "Sm"
						},
						"Capabilities": {
							"shape": "Si"
						},
						"Tags": {
							"shape": "So"
						},
						"Changes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"ResourceChange": {
										"type": "structure",
										"members": {
											"Action": {},
											"LogicalResourceId": {},
											"PhysicalResourceId": {},
											"ResourceType": {},
											"Replacement": {},
											"Scope": {
												"type": "list",
												"member": {}
											},
											"Details": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"Target": {
															"type": "structure",
															"members": {
																"Attribute": {},
																"Name": {},
																"RequiresRecreation": {}
															}
														},
														"Evaluation": {},
														"ChangeSource": {},
														"CausingEntity": {}
													}
												}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeStackEvents": {
				"input": {
					"type": "structure",
					"members": {
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackEventsResult",
					"type": "structure",
					"members": {
						"StackEvents": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"StackId",
									"EventId",
									"StackName",
									"Timestamp"
								],
								"members": {
									"StackId": {},
									"EventId": {},
									"StackName": {},
									"LogicalResourceId": {},
									"PhysicalResourceId": {},
									"ResourceType": {},
									"Timestamp": {
										"type": "timestamp"
									},
									"ResourceStatus": {},
									"ResourceStatusReason": {},
									"ResourceProperties": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeStackResource": {
				"input": {
					"type": "structure",
					"required": [
						"StackName",
						"LogicalResourceId"
					],
					"members": {
						"StackName": {},
						"LogicalResourceId": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackResourceResult",
					"type": "structure",
					"members": {
						"StackResourceDetail": {
							"type": "structure",
							"required": [
								"LogicalResourceId",
								"ResourceType",
								"LastUpdatedTimestamp",
								"ResourceStatus"
							],
							"members": {
								"StackName": {},
								"StackId": {},
								"LogicalResourceId": {},
								"PhysicalResourceId": {},
								"ResourceType": {},
								"LastUpdatedTimestamp": {
									"type": "timestamp"
								},
								"ResourceStatus": {},
								"ResourceStatusReason": {},
								"Description": {},
								"Metadata": {}
							}
						}
					}
				}
			},
			"DescribeStackResources": {
				"input": {
					"type": "structure",
					"members": {
						"StackName": {},
						"LogicalResourceId": {},
						"PhysicalResourceId": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStackResourcesResult",
					"type": "structure",
					"members": {
						"StackResources": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"LogicalResourceId",
									"ResourceType",
									"Timestamp",
									"ResourceStatus"
								],
								"members": {
									"StackName": {},
									"StackId": {},
									"LogicalResourceId": {},
									"PhysicalResourceId": {},
									"ResourceType": {},
									"Timestamp": {
										"type": "timestamp"
									},
									"ResourceStatus": {},
									"ResourceStatusReason": {},
									"Description": {}
								}
							}
						}
					}
				}
			},
			"DescribeStacks": {
				"input": {
					"type": "structure",
					"members": {
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeStacksResult",
					"type": "structure",
					"members": {
						"Stacks": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"StackName",
									"CreationTime",
									"StackStatus"
								],
								"members": {
									"StackId": {},
									"StackName": {},
									"ChangeSetId": {},
									"Description": {},
									"Parameters": {
										"shape": "Sd"
									},
									"CreationTime": {
										"type": "timestamp"
									},
									"LastUpdatedTime": {
										"type": "timestamp"
									},
									"StackStatus": {},
									"StackStatusReason": {},
									"DisableRollback": {
										"type": "boolean"
									},
									"NotificationARNs": {
										"shape": "Sm"
									},
									"TimeoutInMinutes": {
										"type": "integer"
									},
									"Capabilities": {
										"shape": "Si"
									},
									"Outputs": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"OutputKey": {},
												"OutputValue": {},
												"Description": {}
											}
										}
									},
									"RoleARN": {},
									"Tags": {
										"shape": "So"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"EstimateTemplateCost": {
				"input": {
					"type": "structure",
					"members": {
						"TemplateBody": {},
						"TemplateURL": {},
						"Parameters": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"resultWrapper": "EstimateTemplateCostResult",
					"type": "structure",
					"members": {
						"Url": {}
					}
				}
			},
			"ExecuteChangeSet": {
				"input": {
					"type": "structure",
					"required": [
						"ChangeSetName"
					],
					"members": {
						"ChangeSetName": {},
						"StackName": {}
					}
				},
				"output": {
					"resultWrapper": "ExecuteChangeSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"GetStackPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {}
					}
				},
				"output": {
					"resultWrapper": "GetStackPolicyResult",
					"type": "structure",
					"members": {
						"StackPolicyBody": {}
					}
				}
			},
			"GetTemplate": {
				"input": {
					"type": "structure",
					"members": {
						"StackName": {},
						"ChangeSetName": {},
						"TemplateStage": {}
					}
				},
				"output": {
					"resultWrapper": "GetTemplateResult",
					"type": "structure",
					"members": {
						"TemplateBody": {},
						"StagesAvailable": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"GetTemplateSummary": {
				"input": {
					"type": "structure",
					"members": {
						"TemplateBody": {},
						"TemplateURL": {},
						"StackName": {}
					}
				},
				"output": {
					"resultWrapper": "GetTemplateSummaryResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ParameterKey": {},
									"DefaultValue": {},
									"ParameterType": {},
									"NoEcho": {
										"type": "boolean"
									},
									"Description": {},
									"ParameterConstraints": {
										"type": "structure",
										"members": {
											"AllowedValues": {
												"type": "list",
												"member": {}
											}
										}
									}
								}
							}
						},
						"Description": {},
						"Capabilities": {
							"shape": "Si"
						},
						"CapabilitiesReason": {},
						"ResourceTypes": {
							"shape": "Sk"
						},
						"Version": {},
						"Metadata": {},
						"DeclaredTransforms": {
							"shape": "S3k"
						}
					}
				}
			},
			"ListChangeSets": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListChangeSetsResult",
					"type": "structure",
					"members": {
						"Summaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StackId": {},
									"StackName": {},
									"ChangeSetId": {},
									"ChangeSetName": {},
									"ExecutionStatus": {},
									"Status": {},
									"StatusReason": {},
									"CreationTime": {
										"type": "timestamp"
									},
									"Description": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListExports": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListExportsResult",
					"type": "structure",
					"members": {
						"Exports": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ExportingStackId": {},
									"Name": {},
									"Value": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListImports": {
				"input": {
					"type": "structure",
					"required": [
						"ExportName"
					],
					"members": {
						"ExportName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListImportsResult",
					"type": "structure",
					"members": {
						"Imports": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"ListStackResources": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListStackResourcesResult",
					"type": "structure",
					"members": {
						"StackResourceSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"LogicalResourceId",
									"ResourceType",
									"LastUpdatedTimestamp",
									"ResourceStatus"
								],
								"members": {
									"LogicalResourceId": {},
									"PhysicalResourceId": {},
									"ResourceType": {},
									"LastUpdatedTimestamp": {
										"type": "timestamp"
									},
									"ResourceStatus": {},
									"ResourceStatusReason": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListStacks": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"StackStatusFilter": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "ListStacksResult",
					"type": "structure",
					"members": {
						"StackSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"StackName",
									"CreationTime",
									"StackStatus"
								],
								"members": {
									"StackId": {},
									"StackName": {},
									"TemplateDescription": {},
									"CreationTime": {
										"type": "timestamp"
									},
									"LastUpdatedTime": {
										"type": "timestamp"
									},
									"DeletionTime": {
										"type": "timestamp"
									},
									"StackStatus": {},
									"StackStatusReason": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"SetStackPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"StackPolicyBody": {},
						"StackPolicyURL": {}
					}
				}
			},
			"SignalResource": {
				"input": {
					"type": "structure",
					"required": [
						"StackName",
						"LogicalResourceId",
						"UniqueId",
						"Status"
					],
					"members": {
						"StackName": {},
						"LogicalResourceId": {},
						"UniqueId": {},
						"Status": {}
					}
				}
			},
			"UpdateStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackName"
					],
					"members": {
						"StackName": {},
						"TemplateBody": {},
						"TemplateURL": {},
						"UsePreviousTemplate": {
							"type": "boolean"
						},
						"StackPolicyDuringUpdateBody": {},
						"StackPolicyDuringUpdateURL": {},
						"Parameters": {
							"shape": "Sd"
						},
						"Capabilities": {
							"shape": "Si"
						},
						"ResourceTypes": {
							"shape": "Sk"
						},
						"RoleARN": {},
						"StackPolicyBody": {},
						"StackPolicyURL": {},
						"NotificationARNs": {
							"shape": "Sm"
						},
						"Tags": {
							"shape": "So"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateStackResult",
					"type": "structure",
					"members": {
						"StackId": {}
					}
				}
			},
			"ValidateTemplate": {
				"input": {
					"type": "structure",
					"members": {
						"TemplateBody": {},
						"TemplateURL": {}
					}
				},
				"output": {
					"resultWrapper": "ValidateTemplateResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ParameterKey": {},
									"DefaultValue": {},
									"NoEcho": {
										"type": "boolean"
									},
									"Description": {}
								}
							}
						},
						"Description": {},
						"Capabilities": {
							"shape": "Si"
						},
						"CapabilitiesReason": {},
						"DeclaredTransforms": {
							"shape": "S3k"
						}
					}
				}
			}
		},
		"shapes": {
			"Sd": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ParameterKey": {},
						"ParameterValue": {},
						"UsePreviousValue": {
							"type": "boolean"
						}
					}
				}
			},
			"Si": {
				"type": "list",
				"member": {}
			},
			"Sk": {
				"type": "list",
				"member": {}
			},
			"Sm": {
				"type": "list",
				"member": {}
			},
			"So": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S3k": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 645 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeStackEvents": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "StackEvents"
			},
			"DescribeStackResources": {
				"result_key": "StackResources"
			},
			"DescribeStacks": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Stacks"
			},
			"ListStackResources": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "StackResourceSummaries"
			},
			"ListStacks": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "StackSummaries"
			}
		}
	};

/***/ },
/* 646 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"StackExists": {
				"delay": 5,
				"operation": "DescribeStacks",
				"maxAttempts": 20,
				"acceptors": [
					{
						"matcher": "status",
						"expected": 200,
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "ValidationError",
						"state": "retry"
					}
				]
			},
			"StackCreateComplete": {
				"delay": 30,
				"operation": "DescribeStacks",
				"maxAttempts": 120,
				"description": "Wait until stack status is CREATE_COMPLETE.",
				"acceptors": [
					{
						"argument": "Stacks[].StackStatus",
						"expected": "CREATE_COMPLETE",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "CREATE_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "DELETE_COMPLETE",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "DELETE_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "ROLLBACK_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "ROLLBACK_COMPLETE",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"expected": "ValidationError",
						"matcher": "error",
						"state": "failure"
					}
				]
			},
			"StackDeleteComplete": {
				"delay": 30,
				"operation": "DescribeStacks",
				"maxAttempts": 120,
				"description": "Wait until stack status is DELETE_COMPLETE.",
				"acceptors": [
					{
						"argument": "Stacks[].StackStatus",
						"expected": "DELETE_COMPLETE",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"expected": "ValidationError",
						"matcher": "error",
						"state": "success"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "DELETE_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "CREATE_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "ROLLBACK_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "UPDATE_ROLLBACK_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "UPDATE_ROLLBACK_IN_PROGRESS",
						"matcher": "pathAny",
						"state": "failure"
					}
				]
			},
			"StackUpdateComplete": {
				"delay": 30,
				"maxAttempts": 120,
				"operation": "DescribeStacks",
				"description": "Wait until stack status is UPDATE_COMPLETE.",
				"acceptors": [
					{
						"argument": "Stacks[].StackStatus",
						"expected": "UPDATE_COMPLETE",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"expected": "UPDATE_FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Stacks[].StackStatus"
					},
					{
						"argument": "Stacks[].StackStatus",
						"expected": "UPDATE_ROLLBACK_FAILED",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"expected": "UPDATE_ROLLBACK_COMPLETE",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Stacks[].StackStatus"
					},
					{
						"expected": "ValidationError",
						"matcher": "error",
						"state": "failure"
					}
				]
			}
		}
	};

/***/ },
/* 647 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-11-25",
			"endpointPrefix": "cloudfront",
			"globalEndpoint": "cloudfront.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "CloudFront",
			"serviceFullName": "Amazon CloudFront",
			"signatureVersion": "v4",
			"uid": "cloudfront-2016-11-25"
		},
		"operations": {
			"CreateCloudFrontOriginAccessIdentity": {
				"http": {
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"CreateDistribution": {
				"http": {
					"requestUri": "/2016-11-25/distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateDistributionWithTags": {
				"http": {
					"requestUri": "/2016-11-25/distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfigWithTags"
					],
					"members": {
						"DistributionConfigWithTags": {
							"locationName": "DistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							},
							"type": "structure",
							"required": [
								"DistributionConfig",
								"Tags"
							],
							"members": {
								"DistributionConfig": {
									"shape": "S7"
								},
								"Tags": {
									"shape": "S21"
								}
							}
						}
					},
					"payload": "DistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"CreateInvalidation": {
				"http": {
					"requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"InvalidationBatch"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"InvalidationBatch": {
							"shape": "S28",
							"locationName": "InvalidationBatch",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "InvalidationBatch"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"Invalidation": {
							"shape": "S2c"
						}
					},
					"payload": "Invalidation"
				}
			},
			"CreateStreamingDistribution": {
				"http": {
					"requestUri": "/2016-11-25/streaming-distribution",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S2e",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"CreateStreamingDistributionWithTags": {
				"http": {
					"requestUri": "/2016-11-25/streaming-distribution?WithTags",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfigWithTags"
					],
					"members": {
						"StreamingDistributionConfigWithTags": {
							"locationName": "StreamingDistributionConfigWithTags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							},
							"type": "structure",
							"required": [
								"StreamingDistributionConfig",
								"Tags"
							],
							"members": {
								"StreamingDistributionConfig": {
									"shape": "S2e"
								},
								"Tags": {
									"shape": "S21"
								}
							}
						}
					},
					"payload": "StreamingDistributionConfigWithTags"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"DeleteCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2016-11-25/distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"DeleteStreamingDistribution": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2016-11-25/streaming-distribution/{Id}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					}
				}
			},
			"GetCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"GetCloudFrontOriginAccessIdentityConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				}
			},
			"GetDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"GetDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionConfig": {
							"shape": "S7"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "DistributionConfig"
				}
			},
			"GetInvalidation": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId",
						"Id"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Invalidation": {
							"shape": "S2c"
						}
					},
					"payload": "Invalidation"
				}
			},
			"GetStreamingDistribution": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/streaming-distribution/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			},
			"GetStreamingDistributionConfig": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S2e"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistributionConfig"
				}
			},
			"ListCloudFrontOriginAccessIdentities": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentityList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "CloudFrontOriginAccessIdentitySummary",
										"type": "structure",
										"required": [
											"Id",
											"S3CanonicalUserId",
											"Comment"
										],
										"members": {
											"Id": {},
											"S3CanonicalUserId": {},
											"Comment": {}
										}
									}
								}
							}
						}
					},
					"payload": "CloudFrontOriginAccessIdentityList"
				}
			},
			"ListDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S3a"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListDistributionsByWebACLId": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distributionsByWebACLId/{WebACLId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"WebACLId"
					],
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						},
						"WebACLId": {
							"location": "uri",
							"locationName": "WebACLId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DistributionList": {
							"shape": "S3a"
						}
					},
					"payload": "DistributionList"
				}
			},
			"ListInvalidations": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/distribution/{DistributionId}/invalidation"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionId"
					],
					"members": {
						"DistributionId": {
							"location": "uri",
							"locationName": "DistributionId"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InvalidationList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "InvalidationSummary",
										"type": "structure",
										"required": [
											"Id",
											"CreateTime",
											"Status"
										],
										"members": {
											"Id": {},
											"CreateTime": {
												"type": "timestamp"
											},
											"Status": {}
										}
									}
								}
							}
						}
					},
					"payload": "InvalidationList"
				}
			},
			"ListStreamingDistributions": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/streaming-distribution"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistributionList": {
							"type": "structure",
							"required": [
								"Marker",
								"MaxItems",
								"IsTruncated",
								"Quantity"
							],
							"members": {
								"Marker": {},
								"NextMarker": {},
								"MaxItems": {
									"type": "integer"
								},
								"IsTruncated": {
									"type": "boolean"
								},
								"Quantity": {
									"type": "integer"
								},
								"Items": {
									"type": "list",
									"member": {
										"locationName": "StreamingDistributionSummary",
										"type": "structure",
										"required": [
											"Id",
											"ARN",
											"Status",
											"LastModifiedTime",
											"DomainName",
											"S3Origin",
											"Aliases",
											"TrustedSigners",
											"Comment",
											"PriceClass",
											"Enabled"
										],
										"members": {
											"Id": {},
											"ARN": {},
											"Status": {},
											"LastModifiedTime": {
												"type": "timestamp"
											},
											"DomainName": {},
											"S3Origin": {
												"shape": "S2f"
											},
											"Aliases": {
												"shape": "S8"
											},
											"TrustedSigners": {
												"shape": "Sy"
											},
											"Comment": {},
											"PriceClass": {},
											"Enabled": {
												"type": "boolean"
											}
										}
									}
								}
							}
						}
					},
					"payload": "StreamingDistributionList"
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-11-25/tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags"
					],
					"members": {
						"Tags": {
							"shape": "S21"
						}
					},
					"payload": "Tags"
				}
			},
			"TagResource": {
				"http": {
					"requestUri": "/2016-11-25/tagging?Operation=Tag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"Tags"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"Tags": {
							"shape": "S21",
							"locationName": "Tags",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						}
					},
					"payload": "Tags"
				}
			},
			"UntagResource": {
				"http": {
					"requestUri": "/2016-11-25/tagging?Operation=Untag",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"TagKeys"
					],
					"members": {
						"Resource": {
							"location": "querystring",
							"locationName": "Resource"
						},
						"TagKeys": {
							"locationName": "TagKeys",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							},
							"type": "structure",
							"members": {
								"Items": {
									"type": "list",
									"member": {
										"locationName": "Key"
									}
								}
							}
						}
					},
					"payload": "TagKeys"
				}
			},
			"UpdateCloudFrontOriginAccessIdentity": {
				"http": {
					"method": "PUT",
					"requestUri": "/2016-11-25/origin-access-identity/cloudfront/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"CloudFrontOriginAccessIdentityConfig",
						"Id"
					],
					"members": {
						"CloudFrontOriginAccessIdentityConfig": {
							"shape": "S2",
							"locationName": "CloudFrontOriginAccessIdentityConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "CloudFrontOriginAccessIdentityConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"CloudFrontOriginAccessIdentity": {
							"shape": "S5"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "CloudFrontOriginAccessIdentity"
				}
			},
			"UpdateDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2016-11-25/distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"DistributionConfig",
						"Id"
					],
					"members": {
						"DistributionConfig": {
							"shape": "S7",
							"locationName": "DistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "DistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"Distribution": {
							"shape": "S1s"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "Distribution"
				}
			},
			"UpdateStreamingDistribution": {
				"http": {
					"method": "PUT",
					"requestUri": "/2016-11-25/streaming-distribution/{Id}/config"
				},
				"input": {
					"type": "structure",
					"required": [
						"StreamingDistributionConfig",
						"Id"
					],
					"members": {
						"StreamingDistributionConfig": {
							"shape": "S2e",
							"locationName": "StreamingDistributionConfig",
							"xmlNamespace": {
								"uri": "http://cloudfront.amazonaws.com/doc/2016-11-25/"
							}
						},
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						}
					},
					"payload": "StreamingDistributionConfig"
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamingDistribution": {
							"shape": "S2i"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						}
					},
					"payload": "StreamingDistribution"
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Comment"
				],
				"members": {
					"CallerReference": {},
					"Comment": {}
				}
			},
			"S5": {
				"type": "structure",
				"required": [
					"Id",
					"S3CanonicalUserId"
				],
				"members": {
					"Id": {},
					"S3CanonicalUserId": {},
					"CloudFrontOriginAccessIdentityConfig": {
						"shape": "S2"
					}
				}
			},
			"S7": {
				"type": "structure",
				"required": [
					"CallerReference",
					"Origins",
					"DefaultCacheBehavior",
					"Comment",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"Aliases": {
						"shape": "S8"
					},
					"DefaultRootObject": {},
					"Origins": {
						"shape": "Sb"
					},
					"DefaultCacheBehavior": {
						"shape": "Sn"
					},
					"CacheBehaviors": {
						"shape": "S1a"
					},
					"CustomErrorResponses": {
						"shape": "S1d"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"IncludeCookies",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"IncludeCookies": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					},
					"ViewerCertificate": {
						"shape": "S1i"
					},
					"Restrictions": {
						"shape": "S1m"
					},
					"WebACLId": {},
					"HttpVersion": {},
					"IsIPV6Enabled": {
						"type": "boolean"
					}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CNAME"
						}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Origin",
							"type": "structure",
							"required": [
								"Id",
								"DomainName"
							],
							"members": {
								"Id": {},
								"DomainName": {},
								"OriginPath": {},
								"CustomHeaders": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "OriginCustomHeader",
												"type": "structure",
												"required": [
													"HeaderName",
													"HeaderValue"
												],
												"members": {
													"HeaderName": {},
													"HeaderValue": {}
												}
											}
										}
									}
								},
								"S3OriginConfig": {
									"type": "structure",
									"required": [
										"OriginAccessIdentity"
									],
									"members": {
										"OriginAccessIdentity": {}
									}
								},
								"CustomOriginConfig": {
									"type": "structure",
									"required": [
										"HTTPPort",
										"HTTPSPort",
										"OriginProtocolPolicy"
									],
									"members": {
										"HTTPPort": {
											"type": "integer"
										},
										"HTTPSPort": {
											"type": "integer"
										},
										"OriginProtocolPolicy": {},
										"OriginSslProtocols": {
											"type": "structure",
											"required": [
												"Quantity",
												"Items"
											],
											"members": {
												"Quantity": {
													"type": "integer"
												},
												"Items": {
													"type": "list",
													"member": {
														"locationName": "SslProtocol"
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"TargetOriginId",
					"ForwardedValues",
					"TrustedSigners",
					"ViewerProtocolPolicy",
					"MinTTL"
				],
				"members": {
					"TargetOriginId": {},
					"ForwardedValues": {
						"shape": "So"
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"ViewerProtocolPolicy": {},
					"MinTTL": {
						"type": "long"
					},
					"AllowedMethods": {
						"shape": "S12"
					},
					"SmoothStreaming": {
						"type": "boolean"
					},
					"DefaultTTL": {
						"type": "long"
					},
					"MaxTTL": {
						"type": "long"
					},
					"Compress": {
						"type": "boolean"
					},
					"LambdaFunctionAssociations": {
						"shape": "S16"
					}
				}
			},
			"So": {
				"type": "structure",
				"required": [
					"QueryString",
					"Cookies"
				],
				"members": {
					"QueryString": {
						"type": "boolean"
					},
					"Cookies": {
						"type": "structure",
						"required": [
							"Forward"
						],
						"members": {
							"Forward": {},
							"WhitelistedNames": {
								"type": "structure",
								"required": [
									"Quantity"
								],
								"members": {
									"Quantity": {
										"type": "integer"
									},
									"Items": {
										"type": "list",
										"member": {
											"locationName": "Name"
										}
									}
								}
							}
						}
					},
					"Headers": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					},
					"QueryStringCacheKeys": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Name"
								}
							}
						}
					}
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "AwsAccountNumber"
						}
					}
				}
			},
			"S12": {
				"type": "structure",
				"required": [
					"Quantity",
					"Items"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"shape": "S13"
					},
					"CachedMethods": {
						"type": "structure",
						"required": [
							"Quantity",
							"Items"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"shape": "S13"
							}
						}
					}
				}
			},
			"S13": {
				"type": "list",
				"member": {
					"locationName": "Method"
				}
			},
			"S16": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "LambdaFunctionAssociation",
							"type": "structure",
							"members": {
								"LambdaFunctionARN": {},
								"EventType": {}
							}
						}
					}
				}
			},
			"S1a": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CacheBehavior",
							"type": "structure",
							"required": [
								"PathPattern",
								"TargetOriginId",
								"ForwardedValues",
								"TrustedSigners",
								"ViewerProtocolPolicy",
								"MinTTL"
							],
							"members": {
								"PathPattern": {},
								"TargetOriginId": {},
								"ForwardedValues": {
									"shape": "So"
								},
								"TrustedSigners": {
									"shape": "Sy"
								},
								"ViewerProtocolPolicy": {},
								"MinTTL": {
									"type": "long"
								},
								"AllowedMethods": {
									"shape": "S12"
								},
								"SmoothStreaming": {
									"type": "boolean"
								},
								"DefaultTTL": {
									"type": "long"
								},
								"MaxTTL": {
									"type": "long"
								},
								"Compress": {
									"type": "boolean"
								},
								"LambdaFunctionAssociations": {
									"shape": "S16"
								}
							}
						}
					}
				}
			},
			"S1d": {
				"type": "structure",
				"required": [
					"Quantity"
				],
				"members": {
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "CustomErrorResponse",
							"type": "structure",
							"required": [
								"ErrorCode"
							],
							"members": {
								"ErrorCode": {
									"type": "integer"
								},
								"ResponsePagePath": {},
								"ResponseCode": {},
								"ErrorCachingMinTTL": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"S1i": {
				"type": "structure",
				"members": {
					"CloudFrontDefaultCertificate": {
						"type": "boolean"
					},
					"IAMCertificateId": {},
					"ACMCertificateArn": {},
					"SSLSupportMethod": {},
					"MinimumProtocolVersion": {},
					"Certificate": {
						"deprecated": true
					},
					"CertificateSource": {
						"deprecated": true
					}
				}
			},
			"S1m": {
				"type": "structure",
				"required": [
					"GeoRestriction"
				],
				"members": {
					"GeoRestriction": {
						"type": "structure",
						"required": [
							"RestrictionType",
							"Quantity"
						],
						"members": {
							"RestrictionType": {},
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Location"
								}
							}
						}
					}
				}
			},
			"S1s": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"LastModifiedTime",
					"InProgressInvalidationBatches",
					"DomainName",
					"ActiveTrustedSigners",
					"DistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"InProgressInvalidationBatches": {
						"type": "integer"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1u"
					},
					"DistributionConfig": {
						"shape": "S7"
					}
				}
			},
			"S1u": {
				"type": "structure",
				"required": [
					"Enabled",
					"Quantity"
				],
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Signer",
							"type": "structure",
							"members": {
								"AwsAccountNumber": {},
								"KeyPairIds": {
									"type": "structure",
									"required": [
										"Quantity"
									],
									"members": {
										"Quantity": {
											"type": "integer"
										},
										"Items": {
											"type": "list",
											"member": {
												"locationName": "KeyPairId"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S21": {
				"type": "structure",
				"members": {
					"Items": {
						"type": "list",
						"member": {
							"locationName": "Tag",
							"type": "structure",
							"required": [
								"Key"
							],
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S28": {
				"type": "structure",
				"required": [
					"Paths",
					"CallerReference"
				],
				"members": {
					"Paths": {
						"type": "structure",
						"required": [
							"Quantity"
						],
						"members": {
							"Quantity": {
								"type": "integer"
							},
							"Items": {
								"type": "list",
								"member": {
									"locationName": "Path"
								}
							}
						}
					},
					"CallerReference": {}
				}
			},
			"S2c": {
				"type": "structure",
				"required": [
					"Id",
					"Status",
					"CreateTime",
					"InvalidationBatch"
				],
				"members": {
					"Id": {},
					"Status": {},
					"CreateTime": {
						"type": "timestamp"
					},
					"InvalidationBatch": {
						"shape": "S28"
					}
				}
			},
			"S2e": {
				"type": "structure",
				"required": [
					"CallerReference",
					"S3Origin",
					"Comment",
					"TrustedSigners",
					"Enabled"
				],
				"members": {
					"CallerReference": {},
					"S3Origin": {
						"shape": "S2f"
					},
					"Aliases": {
						"shape": "S8"
					},
					"Comment": {},
					"Logging": {
						"type": "structure",
						"required": [
							"Enabled",
							"Bucket",
							"Prefix"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"Bucket": {},
							"Prefix": {}
						}
					},
					"TrustedSigners": {
						"shape": "Sy"
					},
					"PriceClass": {},
					"Enabled": {
						"type": "boolean"
					}
				}
			},
			"S2f": {
				"type": "structure",
				"required": [
					"DomainName",
					"OriginAccessIdentity"
				],
				"members": {
					"DomainName": {},
					"OriginAccessIdentity": {}
				}
			},
			"S2i": {
				"type": "structure",
				"required": [
					"Id",
					"ARN",
					"Status",
					"DomainName",
					"ActiveTrustedSigners",
					"StreamingDistributionConfig"
				],
				"members": {
					"Id": {},
					"ARN": {},
					"Status": {},
					"LastModifiedTime": {
						"type": "timestamp"
					},
					"DomainName": {},
					"ActiveTrustedSigners": {
						"shape": "S1u"
					},
					"StreamingDistributionConfig": {
						"shape": "S2e"
					}
				}
			},
			"S3a": {
				"type": "structure",
				"required": [
					"Marker",
					"MaxItems",
					"IsTruncated",
					"Quantity"
				],
				"members": {
					"Marker": {},
					"NextMarker": {},
					"MaxItems": {
						"type": "integer"
					},
					"IsTruncated": {
						"type": "boolean"
					},
					"Quantity": {
						"type": "integer"
					},
					"Items": {
						"type": "list",
						"member": {
							"locationName": "DistributionSummary",
							"type": "structure",
							"required": [
								"Id",
								"ARN",
								"Status",
								"LastModifiedTime",
								"DomainName",
								"Aliases",
								"Origins",
								"DefaultCacheBehavior",
								"CacheBehaviors",
								"CustomErrorResponses",
								"Comment",
								"PriceClass",
								"Enabled",
								"ViewerCertificate",
								"Restrictions",
								"WebACLId",
								"HttpVersion",
								"IsIPV6Enabled"
							],
							"members": {
								"Id": {},
								"ARN": {},
								"Status": {},
								"LastModifiedTime": {
									"type": "timestamp"
								},
								"DomainName": {},
								"Aliases": {
									"shape": "S8"
								},
								"Origins": {
									"shape": "Sb"
								},
								"DefaultCacheBehavior": {
									"shape": "Sn"
								},
								"CacheBehaviors": {
									"shape": "S1a"
								},
								"CustomErrorResponses": {
									"shape": "S1d"
								},
								"Comment": {},
								"PriceClass": {},
								"Enabled": {
									"type": "boolean"
								},
								"ViewerCertificate": {
									"shape": "S1i"
								},
								"Restrictions": {
									"shape": "S1m"
								},
								"WebACLId": {},
								"HttpVersion": {},
								"IsIPV6Enabled": {
									"type": "boolean"
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 648 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListCloudFrontOriginAccessIdentities": {
				"input_token": "Marker",
				"output_token": "CloudFrontOriginAccessIdentityList.NextMarker",
				"limit_key": "MaxItems",
				"more_results": "CloudFrontOriginAccessIdentityList.IsTruncated",
				"result_key": "CloudFrontOriginAccessIdentityList.Items"
			},
			"ListDistributions": {
				"input_token": "Marker",
				"output_token": "DistributionList.NextMarker",
				"limit_key": "MaxItems",
				"more_results": "DistributionList.IsTruncated",
				"result_key": "DistributionList.Items"
			},
			"ListInvalidations": {
				"input_token": "Marker",
				"output_token": "InvalidationList.NextMarker",
				"limit_key": "MaxItems",
				"more_results": "InvalidationList.IsTruncated",
				"result_key": "InvalidationList.Items"
			},
			"ListStreamingDistributions": {
				"input_token": "Marker",
				"output_token": "StreamingDistributionList.NextMarker",
				"limit_key": "MaxItems",
				"more_results": "StreamingDistributionList.IsTruncated",
				"result_key": "StreamingDistributionList.Items"
			}
		}
	};

/***/ },
/* 649 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DistributionDeployed": {
				"delay": 60,
				"operation": "GetDistribution",
				"maxAttempts": 25,
				"description": "Wait until a distribution is deployed.",
				"acceptors": [
					{
						"expected": "Deployed",
						"matcher": "path",
						"state": "success",
						"argument": "Distribution.Status"
					}
				]
			},
			"InvalidationCompleted": {
				"delay": 20,
				"operation": "GetInvalidation",
				"maxAttempts": 30,
				"description": "Wait until an invalidation has completed.",
				"acceptors": [
					{
						"expected": "Completed",
						"matcher": "path",
						"state": "success",
						"argument": "Invalidation.Status"
					}
				]
			},
			"StreamingDistributionDeployed": {
				"delay": 60,
				"operation": "GetStreamingDistribution",
				"maxAttempts": 25,
				"description": "Wait until a streaming distribution is deployed.",
				"acceptors": [
					{
						"expected": "Deployed",
						"matcher": "path",
						"state": "success",
						"argument": "StreamingDistribution.Status"
					}
				]
			}
		}
	};

/***/ },
/* 650 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-05-30",
			"endpointPrefix": "cloudhsm",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CloudHSM",
			"serviceFullName": "Amazon CloudHSM",
			"signatureVersion": "v4",
			"targetPrefix": "CloudHsmFrontendService",
			"uid": "cloudhsm-2014-05-30"
		},
		"operations": {
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagList"
					],
					"members": {
						"ResourceArn": {},
						"TagList": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			},
			"CreateHapg": {
				"input": {
					"type": "structure",
					"required": [
						"Label"
					],
					"members": {
						"Label": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HapgArn": {}
					}
				}
			},
			"CreateHsm": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId",
						"SshKey",
						"IamRoleArn",
						"SubscriptionType"
					],
					"members": {
						"SubnetId": {
							"locationName": "SubnetId"
						},
						"SshKey": {
							"locationName": "SshKey"
						},
						"EniIp": {
							"locationName": "EniIp"
						},
						"IamRoleArn": {
							"locationName": "IamRoleArn"
						},
						"ExternalId": {
							"locationName": "ExternalId"
						},
						"SubscriptionType": {
							"locationName": "SubscriptionType"
						},
						"ClientToken": {
							"locationName": "ClientToken"
						},
						"SyslogIp": {
							"locationName": "SyslogIp"
						}
					},
					"locationName": "CreateHsmRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"HsmArn": {}
					}
				}
			},
			"CreateLunaClient": {
				"input": {
					"type": "structure",
					"required": [
						"Certificate"
					],
					"members": {
						"Label": {},
						"Certificate": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientArn": {}
					}
				}
			},
			"DeleteHapg": {
				"input": {
					"type": "structure",
					"required": [
						"HapgArn"
					],
					"members": {
						"HapgArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			},
			"DeleteHsm": {
				"input": {
					"type": "structure",
					"required": [
						"HsmArn"
					],
					"members": {
						"HsmArn": {
							"locationName": "HsmArn"
						}
					},
					"locationName": "DeleteHsmRequest"
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			},
			"DeleteLunaClient": {
				"input": {
					"type": "structure",
					"required": [
						"ClientArn"
					],
					"members": {
						"ClientArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			},
			"DescribeHapg": {
				"input": {
					"type": "structure",
					"required": [
						"HapgArn"
					],
					"members": {
						"HapgArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HapgArn": {},
						"HapgSerial": {},
						"HsmsLastActionFailed": {
							"shape": "Sz"
						},
						"HsmsPendingDeletion": {
							"shape": "Sz"
						},
						"HsmsPendingRegistration": {
							"shape": "Sz"
						},
						"Label": {},
						"LastModifiedTimestamp": {},
						"PartitionSerialList": {
							"shape": "S11"
						},
						"State": {}
					}
				}
			},
			"DescribeHsm": {
				"input": {
					"type": "structure",
					"members": {
						"HsmArn": {},
						"HsmSerialNumber": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HsmArn": {},
						"Status": {},
						"StatusDetails": {},
						"AvailabilityZone": {},
						"EniId": {},
						"EniIp": {},
						"SubscriptionType": {},
						"SubscriptionStartDate": {},
						"SubscriptionEndDate": {},
						"VpcId": {},
						"SubnetId": {},
						"IamRoleArn": {},
						"SerialNumber": {},
						"VendorName": {},
						"HsmType": {},
						"SoftwareVersion": {},
						"SshPublicKey": {},
						"SshKeyLastUpdated": {},
						"ServerCertUri": {},
						"ServerCertLastUpdated": {},
						"Partitions": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"DescribeLunaClient": {
				"input": {
					"type": "structure",
					"members": {
						"ClientArn": {},
						"CertificateFingerprint": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientArn": {},
						"Certificate": {},
						"CertificateFingerprint": {},
						"LastModifiedTimestamp": {},
						"Label": {}
					}
				}
			},
			"GetConfig": {
				"input": {
					"type": "structure",
					"required": [
						"ClientArn",
						"ClientVersion",
						"HapgList"
					],
					"members": {
						"ClientArn": {},
						"ClientVersion": {},
						"HapgList": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigType": {},
						"ConfigFile": {},
						"ConfigCred": {}
					}
				}
			},
			"ListAvailableZones": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"AZList": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ListHapgs": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HapgList"
					],
					"members": {
						"HapgList": {
							"shape": "S1i"
						},
						"NextToken": {}
					}
				}
			},
			"ListHsms": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HsmList": {
							"shape": "Sz"
						},
						"NextToken": {}
					}
				}
			},
			"ListLunaClients": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ClientList"
					],
					"members": {
						"ClientList": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagList"
					],
					"members": {
						"TagList": {
							"shape": "S3"
						}
					}
				}
			},
			"ModifyHapg": {
				"input": {
					"type": "structure",
					"required": [
						"HapgArn"
					],
					"members": {
						"HapgArn": {},
						"Label": {},
						"PartitionSerialList": {
							"shape": "S11"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HapgArn": {}
					}
				}
			},
			"ModifyHsm": {
				"input": {
					"type": "structure",
					"required": [
						"HsmArn"
					],
					"members": {
						"HsmArn": {
							"locationName": "HsmArn"
						},
						"SubnetId": {
							"locationName": "SubnetId"
						},
						"EniIp": {
							"locationName": "EniIp"
						},
						"IamRoleArn": {
							"locationName": "IamRoleArn"
						},
						"ExternalId": {
							"locationName": "ExternalId"
						},
						"SyslogIp": {
							"locationName": "SyslogIp"
						}
					},
					"locationName": "ModifyHsmRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"HsmArn": {}
					}
				}
			},
			"ModifyLunaClient": {
				"input": {
					"type": "structure",
					"required": [
						"ClientArn",
						"Certificate"
					],
					"members": {
						"ClientArn": {},
						"Certificate": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClientArn": {}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagKeyList"
					],
					"members": {
						"ResourceArn": {},
						"TagKeyList": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sz": {
				"type": "list",
				"member": {}
			},
			"S11": {
				"type": "list",
				"member": {}
			},
			"S1i": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 651 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-11-01",
			"endpointPrefix": "cloudtrail",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CloudTrail",
			"serviceFullName": "AWS CloudTrail",
			"signatureVersion": "v4",
			"targetPrefix": "com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101",
			"uid": "cloudtrail-2013-11-01"
		},
		"operations": {
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId"
					],
					"members": {
						"ResourceId": {},
						"TagsList": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"CreateTrail": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"S3BucketName"
					],
					"members": {
						"Name": {},
						"S3BucketName": {},
						"S3KeyPrefix": {},
						"SnsTopicName": {},
						"IncludeGlobalServiceEvents": {
							"type": "boolean"
						},
						"IsMultiRegionTrail": {
							"type": "boolean"
						},
						"EnableLogFileValidation": {
							"type": "boolean"
						},
						"CloudWatchLogsLogGroupArn": {},
						"CloudWatchLogsRoleArn": {},
						"KmsKeyId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"S3BucketName": {},
						"S3KeyPrefix": {},
						"SnsTopicName": {
							"deprecated": true
						},
						"SnsTopicARN": {},
						"IncludeGlobalServiceEvents": {
							"type": "boolean"
						},
						"IsMultiRegionTrail": {
							"type": "boolean"
						},
						"TrailARN": {},
						"LogFileValidationEnabled": {
							"type": "boolean"
						},
						"CloudWatchLogsLogGroupArn": {},
						"CloudWatchLogsRoleArn": {},
						"KmsKeyId": {}
					}
				},
				"idempotent": true
			},
			"DeleteTrail": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"DescribeTrails": {
				"input": {
					"type": "structure",
					"members": {
						"trailNameList": {
							"type": "list",
							"member": {}
						},
						"includeShadowTrails": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"trailList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"S3BucketName": {},
									"S3KeyPrefix": {},
									"SnsTopicName": {
										"deprecated": true
									},
									"SnsTopicARN": {},
									"IncludeGlobalServiceEvents": {
										"type": "boolean"
									},
									"IsMultiRegionTrail": {
										"type": "boolean"
									},
									"HomeRegion": {},
									"TrailARN": {},
									"LogFileValidationEnabled": {
										"type": "boolean"
									},
									"CloudWatchLogsLogGroupArn": {},
									"CloudWatchLogsRoleArn": {},
									"KmsKeyId": {},
									"HasCustomEventSelectors": {
										"type": "boolean"
									}
								}
							}
						}
					}
				},
				"idempotent": true
			},
			"GetEventSelectors": {
				"input": {
					"type": "structure",
					"members": {
						"TrailName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrailARN": {},
						"EventSelectors": {
							"shape": "Si"
						}
					}
				},
				"idempotent": true
			},
			"GetTrailStatus": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsLogging": {
							"type": "boolean"
						},
						"LatestDeliveryError": {},
						"LatestNotificationError": {},
						"LatestDeliveryTime": {
							"type": "timestamp"
						},
						"LatestNotificationTime": {
							"type": "timestamp"
						},
						"StartLoggingTime": {
							"type": "timestamp"
						},
						"StopLoggingTime": {
							"type": "timestamp"
						},
						"LatestCloudWatchLogsDeliveryError": {},
						"LatestCloudWatchLogsDeliveryTime": {
							"type": "timestamp"
						},
						"LatestDigestDeliveryTime": {
							"type": "timestamp"
						},
						"LatestDigestDeliveryError": {},
						"LatestDeliveryAttemptTime": {},
						"LatestNotificationAttemptTime": {},
						"LatestNotificationAttemptSucceeded": {},
						"LatestDeliveryAttemptSucceeded": {},
						"TimeLoggingStarted": {},
						"TimeLoggingStopped": {}
					}
				},
				"idempotent": true
			},
			"ListPublicKeys": {
				"input": {
					"type": "structure",
					"members": {
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicKeyList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Value": {
										"type": "blob"
									},
									"ValidityStartTime": {
										"type": "timestamp"
									},
									"ValidityEndTime": {
										"type": "timestamp"
									},
									"Fingerprint": {}
								}
							}
						},
						"NextToken": {}
					}
				},
				"idempotent": true
			},
			"ListTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceIdList"
					],
					"members": {
						"ResourceIdList": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceTagList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ResourceId": {},
									"TagsList": {
										"shape": "S3"
									}
								}
							}
						},
						"NextToken": {}
					}
				},
				"idempotent": true
			},
			"LookupEvents": {
				"input": {
					"type": "structure",
					"members": {
						"LookupAttributes": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"AttributeKey",
									"AttributeValue"
								],
								"members": {
									"AttributeKey": {},
									"AttributeValue": {}
								}
							}
						},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventId": {},
									"EventName": {},
									"EventTime": {
										"type": "timestamp"
									},
									"EventSource": {},
									"Username": {},
									"Resources": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"ResourceType": {},
												"ResourceName": {}
											}
										}
									},
									"CloudTrailEvent": {}
								}
							}
						},
						"NextToken": {}
					}
				},
				"idempotent": true
			},
			"PutEventSelectors": {
				"input": {
					"type": "structure",
					"members": {
						"TrailName": {},
						"EventSelectors": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TrailARN": {},
						"EventSelectors": {
							"shape": "Si"
						}
					}
				},
				"idempotent": true
			},
			"RemoveTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId"
					],
					"members": {
						"ResourceId": {},
						"TagsList": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"StartLogging": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"StopLogging": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"idempotent": true
			},
			"UpdateTrail": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"S3BucketName": {},
						"S3KeyPrefix": {},
						"SnsTopicName": {},
						"IncludeGlobalServiceEvents": {
							"type": "boolean"
						},
						"IsMultiRegionTrail": {
							"type": "boolean"
						},
						"EnableLogFileValidation": {
							"type": "boolean"
						},
						"CloudWatchLogsLogGroupArn": {},
						"CloudWatchLogsRoleArn": {},
						"KmsKeyId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"S3BucketName": {},
						"S3KeyPrefix": {},
						"SnsTopicName": {
							"deprecated": true
						},
						"SnsTopicARN": {},
						"IncludeGlobalServiceEvents": {
							"type": "boolean"
						},
						"IsMultiRegionTrail": {
							"type": "boolean"
						},
						"TrailARN": {},
						"LogFileValidationEnabled": {
							"type": "boolean"
						},
						"CloudWatchLogsLogGroupArn": {},
						"CloudWatchLogsRoleArn": {},
						"KmsKeyId": {}
					}
				},
				"idempotent": true
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Si": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ReadWriteType": {},
						"IncludeManagementEvents": {
							"type": "boolean"
						},
						"DataResources": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 652 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeTrails": {
				"result_key": "trailList"
			},
			"LookupEvents": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "Events"
			}
		}
	};

/***/ },
/* 653 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-04-13",
			"endpointPrefix": "codecommit",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CodeCommit",
			"serviceFullName": "AWS CodeCommit",
			"signatureVersion": "v4",
			"targetPrefix": "CodeCommit_20150413",
			"uid": "codecommit-2015-04-13"
		},
		"operations": {
			"BatchGetRepositories": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryNames"
					],
					"members": {
						"repositoryNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositories": {
							"type": "list",
							"member": {
								"shape": "S6"
							}
						},
						"repositoriesNotFound": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"CreateBranch": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"branchName",
						"commitId"
					],
					"members": {
						"repositoryName": {},
						"branchName": {},
						"commitId": {}
					}
				}
			},
			"CreateRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {},
						"repositoryDescription": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositoryMetadata": {
							"shape": "S6"
						}
					}
				}
			},
			"DeleteRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositoryId": {}
					}
				}
			},
			"GetBlob": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"blobId"
					],
					"members": {
						"repositoryName": {},
						"blobId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"content"
					],
					"members": {
						"content": {
							"type": "blob"
						}
					}
				}
			},
			"GetBranch": {
				"input": {
					"type": "structure",
					"members": {
						"repositoryName": {},
						"branchName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"branch": {
							"type": "structure",
							"members": {
								"branchName": {},
								"commitId": {}
							}
						}
					}
				}
			},
			"GetCommit": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"commitId"
					],
					"members": {
						"repositoryName": {},
						"commitId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"commit"
					],
					"members": {
						"commit": {
							"type": "structure",
							"members": {
								"treeId": {},
								"parents": {
									"type": "list",
									"member": {}
								},
								"message": {},
								"author": {
									"shape": "Sz"
								},
								"committer": {
									"shape": "Sz"
								},
								"additionalData": {}
							}
						}
					}
				}
			},
			"GetDifferences": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"afterCommitSpecifier"
					],
					"members": {
						"repositoryName": {},
						"beforeCommitSpecifier": {},
						"afterCommitSpecifier": {},
						"beforePath": {},
						"afterPath": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"differences": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"beforeBlob": {
										"shape": "S1c"
									},
									"afterBlob": {
										"shape": "S1c"
									},
									"changeType": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositoryMetadata": {
							"shape": "S6"
						}
					}
				}
			},
			"GetRepositoryTriggers": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"configurationId": {},
						"triggers": {
							"shape": "S1k"
						}
					}
				}
			},
			"ListBranches": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"branches": {
							"shape": "S1o"
						},
						"nextToken": {}
					}
				}
			},
			"ListRepositories": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"sortBy": {},
						"order": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositories": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"repositoryName": {},
									"repositoryId": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"PutRepositoryTriggers": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"triggers"
					],
					"members": {
						"repositoryName": {},
						"triggers": {
							"shape": "S1k"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"configurationId": {}
					}
				}
			},
			"TestRepositoryTriggers": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"triggers"
					],
					"members": {
						"repositoryName": {},
						"triggers": {
							"shape": "S1k"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"successfulExecutions": {
							"type": "list",
							"member": {}
						},
						"failedExecutions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"trigger": {},
									"failureMessage": {}
								}
							}
						}
					}
				}
			},
			"UpdateDefaultBranch": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"defaultBranchName"
					],
					"members": {
						"repositoryName": {},
						"defaultBranchName": {}
					}
				}
			},
			"UpdateRepositoryDescription": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {},
						"repositoryDescription": {}
					}
				}
			},
			"UpdateRepositoryName": {
				"input": {
					"type": "structure",
					"required": [
						"oldName",
						"newName"
					],
					"members": {
						"oldName": {},
						"newName": {}
					}
				}
			}
		},
		"shapes": {
			"S6": {
				"type": "structure",
				"members": {
					"accountId": {},
					"repositoryId": {},
					"repositoryName": {},
					"repositoryDescription": {},
					"defaultBranch": {},
					"lastModifiedDate": {
						"type": "timestamp"
					},
					"creationDate": {
						"type": "timestamp"
					},
					"cloneUrlHttp": {},
					"cloneUrlSsh": {},
					"Arn": {}
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"name": {},
					"email": {},
					"date": {}
				}
			},
			"S1c": {
				"type": "structure",
				"members": {
					"blobId": {},
					"path": {},
					"mode": {}
				}
			},
			"S1k": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"name",
						"destinationArn",
						"events"
					],
					"members": {
						"name": {},
						"destinationArn": {},
						"customData": {},
						"branches": {
							"shape": "S1o"
						},
						"events": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S1o": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 654 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetDifferences": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken"
			},
			"ListBranches": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "branches"
			},
			"ListRepositories": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "repositories"
			}
		}
	};

/***/ },
/* 655 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-10-06",
			"endpointPrefix": "codedeploy",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CodeDeploy",
			"serviceFullName": "AWS CodeDeploy",
			"signatureVersion": "v4",
			"targetPrefix": "CodeDeploy_20141006",
			"timestampFormat": "unixTimestamp",
			"uid": "codedeploy-2014-10-06"
		},
		"operations": {
			"AddTagsToOnPremisesInstances": {
				"input": {
					"type": "structure",
					"required": [
						"tags",
						"instanceNames"
					],
					"members": {
						"tags": {
							"shape": "S2"
						},
						"instanceNames": {
							"shape": "S6"
						}
					}
				}
			},
			"BatchGetApplicationRevisions": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"revisions"
					],
					"members": {
						"applicationName": {},
						"revisions": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"errorMessage": {},
						"revisions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"revisionLocation": {
										"shape": "Sb"
									},
									"genericRevisionInfo": {
										"shape": "Sq"
									}
								}
							}
						}
					}
				}
			},
			"BatchGetApplications": {
				"input": {
					"type": "structure",
					"members": {
						"applicationNames": {
							"shape": "Sw"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationsInfo": {
							"type": "list",
							"member": {
								"shape": "Sz"
							}
						}
					}
				}
			},
			"BatchGetDeploymentGroups": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"deploymentGroupNames"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupNames": {
							"shape": "Ss"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentGroupsInfo": {
							"type": "list",
							"member": {
								"shape": "S15"
							}
						},
						"errorMessage": {}
					}
				}
			},
			"BatchGetDeploymentInstances": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId",
						"instanceIds"
					],
					"members": {
						"deploymentId": {},
						"instanceIds": {
							"shape": "S2d"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instancesSummary": {
							"type": "list",
							"member": {
								"shape": "S2h"
							}
						},
						"errorMessage": {}
					}
				}
			},
			"BatchGetDeployments": {
				"input": {
					"type": "structure",
					"members": {
						"deploymentIds": {
							"shape": "S2u"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentsInfo": {
							"type": "list",
							"member": {
								"shape": "S2x"
							}
						}
					}
				}
			},
			"BatchGetOnPremisesInstances": {
				"input": {
					"type": "structure",
					"members": {
						"instanceNames": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceInfos": {
							"type": "list",
							"member": {
								"shape": "S3b"
							}
						}
					}
				}
			},
			"ContinueDeployment": {
				"input": {
					"type": "structure",
					"members": {
						"deploymentId": {}
					}
				}
			},
			"CreateApplication": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationId": {}
					}
				}
			},
			"CreateDeployment": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupName": {},
						"revision": {
							"shape": "Sb"
						},
						"deploymentConfigName": {},
						"description": {},
						"ignoreApplicationStopFailures": {
							"type": "boolean"
						},
						"targetInstances": {
							"shape": "S35"
						},
						"autoRollbackConfiguration": {
							"shape": "S1t"
						},
						"updateOutdatedInstancesOnly": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentId": {}
					}
				}
			},
			"CreateDeploymentConfig": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentConfigName"
					],
					"members": {
						"deploymentConfigName": {},
						"minimumHealthyHosts": {
							"shape": "S3l"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentConfigId": {}
					}
				}
			},
			"CreateDeploymentGroup": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"deploymentGroupName",
						"serviceRoleArn"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupName": {},
						"deploymentConfigName": {},
						"ec2TagFilters": {
							"shape": "S18"
						},
						"onPremisesInstanceTagFilters": {
							"shape": "S1b"
						},
						"autoScalingGroups": {
							"shape": "S36"
						},
						"serviceRoleArn": {},
						"triggerConfigurations": {
							"shape": "S1j"
						},
						"alarmConfiguration": {
							"shape": "S1p"
						},
						"autoRollbackConfiguration": {
							"shape": "S1t"
						},
						"deploymentStyle": {
							"shape": "S1w"
						},
						"blueGreenDeploymentConfiguration": {
							"shape": "S1z"
						},
						"loadBalancerInfo": {
							"shape": "S27"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentGroupId": {}
					}
				}
			},
			"DeleteApplication": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {}
					}
				}
			},
			"DeleteDeploymentConfig": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentConfigName"
					],
					"members": {
						"deploymentConfigName": {}
					}
				}
			},
			"DeleteDeploymentGroup": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"deploymentGroupName"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"hooksNotCleanedUp": {
							"shape": "S1e"
						}
					}
				}
			},
			"DeregisterOnPremisesInstance": {
				"input": {
					"type": "structure",
					"required": [
						"instanceName"
					],
					"members": {
						"instanceName": {}
					}
				}
			},
			"GetApplication": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"application": {
							"shape": "Sz"
						}
					}
				}
			},
			"GetApplicationRevision": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"revision"
					],
					"members": {
						"applicationName": {},
						"revision": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"revision": {
							"shape": "Sb"
						},
						"revisionInfo": {
							"shape": "Sq"
						}
					}
				}
			},
			"GetDeployment": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId"
					],
					"members": {
						"deploymentId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentInfo": {
							"shape": "S2x"
						}
					}
				}
			},
			"GetDeploymentConfig": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentConfigName"
					],
					"members": {
						"deploymentConfigName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentConfigInfo": {
							"type": "structure",
							"members": {
								"deploymentConfigId": {},
								"deploymentConfigName": {},
								"minimumHealthyHosts": {
									"shape": "S3l"
								},
								"createTime": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"GetDeploymentGroup": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"deploymentGroupName"
					],
					"members": {
						"applicationName": {},
						"deploymentGroupName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentGroupInfo": {
							"shape": "S15"
						}
					}
				}
			},
			"GetDeploymentInstance": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId",
						"instanceId"
					],
					"members": {
						"deploymentId": {},
						"instanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceSummary": {
							"shape": "S2h"
						}
					}
				}
			},
			"GetOnPremisesInstance": {
				"input": {
					"type": "structure",
					"required": [
						"instanceName"
					],
					"members": {
						"instanceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceInfo": {
							"shape": "S3b"
						}
					}
				}
			},
			"ListApplicationRevisions": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {},
						"sortBy": {},
						"sortOrder": {},
						"s3Bucket": {},
						"s3KeyPrefix": {},
						"deployed": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"revisions": {
							"shape": "Sa"
						},
						"nextToken": {}
					}
				}
			},
			"ListApplications": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applications": {
							"shape": "Sw"
						},
						"nextToken": {}
					}
				}
			},
			"ListDeploymentConfigs": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deploymentConfigsList": {
							"type": "list",
							"member": {}
						},
						"nextToken": {}
					}
				}
			},
			"ListDeploymentGroups": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName"
					],
					"members": {
						"applicationName": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"deploymentGroups": {
							"shape": "Ss"
						},
						"nextToken": {}
					}
				}
			},
			"ListDeploymentInstances": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId"
					],
					"members": {
						"deploymentId": {},
						"nextToken": {},
						"instanceStatusFilter": {
							"type": "list",
							"member": {}
						},
						"instanceTypeFilter": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instancesList": {
							"shape": "S2d"
						},
						"nextToken": {}
					}
				}
			},
			"ListDeployments": {
				"input": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"deploymentGroupName": {},
						"includeOnlyStatuses": {
							"type": "list",
							"member": {}
						},
						"createTimeRange": {
							"type": "structure",
							"members": {
								"start": {
									"type": "timestamp"
								},
								"end": {
									"type": "timestamp"
								}
							}
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"deployments": {
							"shape": "S2u"
						},
						"nextToken": {}
					}
				}
			},
			"ListOnPremisesInstances": {
				"input": {
					"type": "structure",
					"members": {
						"registrationStatus": {},
						"tagFilters": {
							"shape": "S1b"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"instanceNames": {
							"shape": "S6"
						},
						"nextToken": {}
					}
				}
			},
			"RegisterApplicationRevision": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"revision"
					],
					"members": {
						"applicationName": {},
						"description": {},
						"revision": {
							"shape": "Sb"
						}
					}
				}
			},
			"RegisterOnPremisesInstance": {
				"input": {
					"type": "structure",
					"required": [
						"instanceName"
					],
					"members": {
						"instanceName": {},
						"iamSessionArn": {},
						"iamUserArn": {}
					}
				}
			},
			"RemoveTagsFromOnPremisesInstances": {
				"input": {
					"type": "structure",
					"required": [
						"tags",
						"instanceNames"
					],
					"members": {
						"tags": {
							"shape": "S2"
						},
						"instanceNames": {
							"shape": "S6"
						}
					}
				}
			},
			"SkipWaitTimeForInstanceTermination": {
				"input": {
					"type": "structure",
					"members": {
						"deploymentId": {}
					}
				}
			},
			"StopDeployment": {
				"input": {
					"type": "structure",
					"required": [
						"deploymentId"
					],
					"members": {
						"deploymentId": {},
						"autoRollbackEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"status": {},
						"statusMessage": {}
					}
				}
			},
			"UpdateApplication": {
				"input": {
					"type": "structure",
					"members": {
						"applicationName": {},
						"newApplicationName": {}
					}
				}
			},
			"UpdateDeploymentGroup": {
				"input": {
					"type": "structure",
					"required": [
						"applicationName",
						"currentDeploymentGroupName"
					],
					"members": {
						"applicationName": {},
						"currentDeploymentGroupName": {},
						"newDeploymentGroupName": {},
						"deploymentConfigName": {},
						"ec2TagFilters": {
							"shape": "S18"
						},
						"onPremisesInstanceTagFilters": {
							"shape": "S1b"
						},
						"autoScalingGroups": {
							"shape": "S36"
						},
						"serviceRoleArn": {},
						"triggerConfigurations": {
							"shape": "S1j"
						},
						"alarmConfiguration": {
							"shape": "S1p"
						},
						"autoRollbackConfiguration": {
							"shape": "S1t"
						},
						"deploymentStyle": {
							"shape": "S1w"
						},
						"blueGreenDeploymentConfiguration": {
							"shape": "S1z"
						},
						"loadBalancerInfo": {
							"shape": "S27"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"hooksNotCleanedUp": {
							"shape": "S1e"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S6": {
				"type": "list",
				"member": {}
			},
			"Sa": {
				"type": "list",
				"member": {
					"shape": "Sb"
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"revisionType": {},
					"s3Location": {
						"type": "structure",
						"members": {
							"bucket": {},
							"key": {},
							"bundleType": {},
							"version": {},
							"eTag": {}
						}
					},
					"gitHubLocation": {
						"type": "structure",
						"members": {
							"repository": {},
							"commitId": {}
						}
					}
				}
			},
			"Sq": {
				"type": "structure",
				"members": {
					"description": {},
					"deploymentGroups": {
						"shape": "Ss"
					},
					"firstUsedTime": {
						"type": "timestamp"
					},
					"lastUsedTime": {
						"type": "timestamp"
					},
					"registerTime": {
						"type": "timestamp"
					}
				}
			},
			"Ss": {
				"type": "list",
				"member": {}
			},
			"Sw": {
				"type": "list",
				"member": {}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"applicationId": {},
					"applicationName": {},
					"createTime": {
						"type": "timestamp"
					},
					"linkedToGitHub": {
						"type": "boolean"
					}
				}
			},
			"S15": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"deploymentGroupId": {},
					"deploymentGroupName": {},
					"deploymentConfigName": {},
					"ec2TagFilters": {
						"shape": "S18"
					},
					"onPremisesInstanceTagFilters": {
						"shape": "S1b"
					},
					"autoScalingGroups": {
						"shape": "S1e"
					},
					"serviceRoleArn": {},
					"targetRevision": {
						"shape": "Sb"
					},
					"triggerConfigurations": {
						"shape": "S1j"
					},
					"alarmConfiguration": {
						"shape": "S1p"
					},
					"autoRollbackConfiguration": {
						"shape": "S1t"
					},
					"deploymentStyle": {
						"shape": "S1w"
					},
					"blueGreenDeploymentConfiguration": {
						"shape": "S1z"
					},
					"loadBalancerInfo": {
						"shape": "S27"
					}
				}
			},
			"S18": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {},
						"Type": {}
					}
				}
			},
			"S1b": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {},
						"Type": {}
					}
				}
			},
			"S1e": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"hook": {}
					}
				}
			},
			"S1j": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"triggerName": {},
						"triggerTargetArn": {},
						"triggerEvents": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"enabled": {
						"type": "boolean"
					},
					"ignorePollAlarmFailure": {
						"type": "boolean"
					},
					"alarms": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {}
							}
						}
					}
				}
			},
			"S1t": {
				"type": "structure",
				"members": {
					"enabled": {
						"type": "boolean"
					},
					"events": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S1w": {
				"type": "structure",
				"members": {
					"deploymentType": {},
					"deploymentOption": {}
				}
			},
			"S1z": {
				"type": "structure",
				"members": {
					"terminateBlueInstancesOnDeploymentSuccess": {
						"type": "structure",
						"members": {
							"action": {},
							"terminationWaitTimeInMinutes": {
								"type": "integer"
							}
						}
					},
					"deploymentReadyOption": {
						"type": "structure",
						"members": {
							"actionOnTimeout": {},
							"waitTimeInMinutes": {
								"type": "integer"
							}
						}
					},
					"greenFleetProvisioningOption": {
						"type": "structure",
						"members": {
							"action": {}
						}
					}
				}
			},
			"S27": {
				"type": "structure",
				"members": {
					"elbInfoList": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {}
							}
						}
					}
				}
			},
			"S2d": {
				"type": "list",
				"member": {}
			},
			"S2h": {
				"type": "structure",
				"members": {
					"deploymentId": {},
					"instanceId": {},
					"status": {},
					"lastUpdatedAt": {
						"type": "timestamp"
					},
					"lifecycleEvents": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"lifecycleEventName": {},
								"diagnostics": {
									"type": "structure",
									"members": {
										"errorCode": {},
										"scriptName": {},
										"message": {},
										"logTail": {}
									}
								},
								"startTime": {
									"type": "timestamp"
								},
								"endTime": {
									"type": "timestamp"
								},
								"status": {}
							}
						}
					},
					"instanceType": {}
				}
			},
			"S2u": {
				"type": "list",
				"member": {}
			},
			"S2x": {
				"type": "structure",
				"members": {
					"applicationName": {},
					"deploymentGroupName": {},
					"deploymentConfigName": {},
					"deploymentId": {},
					"revision": {
						"shape": "Sb"
					},
					"status": {},
					"errorInformation": {
						"type": "structure",
						"members": {
							"code": {},
							"message": {}
						}
					},
					"createTime": {
						"type": "timestamp"
					},
					"startTime": {
						"type": "timestamp"
					},
					"completeTime": {
						"type": "timestamp"
					},
					"deploymentOverview": {
						"type": "structure",
						"members": {
							"Pending": {
								"type": "long"
							},
							"InProgress": {
								"type": "long"
							},
							"Succeeded": {
								"type": "long"
							},
							"Failed": {
								"type": "long"
							},
							"Skipped": {
								"type": "long"
							},
							"Ready": {
								"type": "long"
							}
						}
					},
					"description": {},
					"creator": {},
					"ignoreApplicationStopFailures": {
						"type": "boolean"
					},
					"autoRollbackConfiguration": {
						"shape": "S1t"
					},
					"updateOutdatedInstancesOnly": {
						"type": "boolean"
					},
					"rollbackInfo": {
						"type": "structure",
						"members": {
							"rollbackDeploymentId": {},
							"rollbackTriggeringDeploymentId": {},
							"rollbackMessage": {}
						}
					},
					"deploymentStyle": {
						"shape": "S1w"
					},
					"targetInstances": {
						"shape": "S35"
					},
					"instanceTerminationWaitTimeStarted": {
						"type": "boolean"
					},
					"blueGreenDeploymentConfiguration": {
						"shape": "S1z"
					},
					"loadBalancerInfo": {
						"shape": "S27"
					},
					"additionalDeploymentStatusInfo": {}
				}
			},
			"S35": {
				"type": "structure",
				"members": {
					"tagFilters": {
						"shape": "S18"
					},
					"autoScalingGroups": {
						"shape": "S36"
					}
				}
			},
			"S36": {
				"type": "list",
				"member": {}
			},
			"S3b": {
				"type": "structure",
				"members": {
					"instanceName": {},
					"iamSessionArn": {},
					"iamUserArn": {},
					"instanceArn": {},
					"registerTime": {
						"type": "timestamp"
					},
					"deregisterTime": {
						"type": "timestamp"
					},
					"tags": {
						"shape": "S2"
					}
				}
			},
			"S3l": {
				"type": "structure",
				"members": {
					"value": {
						"type": "integer"
					},
					"type": {}
				}
			}
		}
	};

/***/ },
/* 656 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {}
	};

/***/ },
/* 657 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DeploymentSuccessful": {
				"delay": 15,
				"operation": "GetDeployment",
				"maxAttempts": 120,
				"acceptors": [
					{
						"expected": "Succeeded",
						"matcher": "path",
						"state": "success",
						"argument": "deploymentInfo.status"
					},
					{
						"expected": "Failed",
						"matcher": "path",
						"state": "failure",
						"argument": "deploymentInfo.status"
					},
					{
						"expected": "Stopped",
						"matcher": "path",
						"state": "failure",
						"argument": "deploymentInfo.status"
					}
				]
			}
		}
	};

/***/ },
/* 658 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-07-09",
			"endpointPrefix": "codepipeline",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "CodePipeline",
			"serviceFullName": "AWS CodePipeline",
			"signatureVersion": "v4",
			"targetPrefix": "CodePipeline_20150709",
			"uid": "codepipeline-2015-07-09"
		},
		"operations": {
			"AcknowledgeJob": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"nonce"
					],
					"members": {
						"jobId": {},
						"nonce": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"status": {}
					}
				}
			},
			"AcknowledgeThirdPartyJob": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"nonce",
						"clientToken"
					],
					"members": {
						"jobId": {},
						"nonce": {},
						"clientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"status": {}
					}
				}
			},
			"CreateCustomActionType": {
				"input": {
					"type": "structure",
					"required": [
						"category",
						"provider",
						"version",
						"inputArtifactDetails",
						"outputArtifactDetails"
					],
					"members": {
						"category": {},
						"provider": {},
						"version": {},
						"settings": {
							"shape": "Se"
						},
						"configurationProperties": {
							"shape": "Sh"
						},
						"inputArtifactDetails": {
							"shape": "Sn"
						},
						"outputArtifactDetails": {
							"shape": "Sn"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"actionType"
					],
					"members": {
						"actionType": {
							"shape": "Sr"
						}
					}
				}
			},
			"CreatePipeline": {
				"input": {
					"type": "structure",
					"required": [
						"pipeline"
					],
					"members": {
						"pipeline": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipeline": {
							"shape": "Sv"
						}
					}
				}
			},
			"DeleteCustomActionType": {
				"input": {
					"type": "structure",
					"required": [
						"category",
						"provider",
						"version"
					],
					"members": {
						"category": {},
						"provider": {},
						"version": {}
					}
				}
			},
			"DeletePipeline": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {}
					}
				}
			},
			"DisableStageTransition": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"transitionType",
						"reason"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"transitionType": {},
						"reason": {}
					}
				}
			},
			"EnableStageTransition": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"transitionType"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"transitionType": {}
					}
				}
			},
			"GetJobDetails": {
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobDetails": {
							"type": "structure",
							"members": {
								"id": {},
								"data": {
									"shape": "S1x"
								},
								"accountId": {}
							}
						}
					}
				}
			},
			"GetPipeline": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {},
						"version": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipeline": {
							"shape": "Sv"
						}
					}
				}
			},
			"GetPipelineExecution": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"pipelineExecutionId"
					],
					"members": {
						"pipelineName": {},
						"pipelineExecutionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelineExecution": {
							"type": "structure",
							"members": {
								"pipelineName": {},
								"pipelineVersion": {
									"type": "integer"
								},
								"pipelineExecutionId": {},
								"status": {},
								"artifactRevisions": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"name": {},
											"revisionId": {},
											"revisionChangeIdentifier": {},
											"revisionSummary": {},
											"created": {
												"type": "timestamp"
											},
											"revisionUrl": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"GetPipelineState": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelineName": {},
						"pipelineVersion": {
							"type": "integer"
						},
						"stageStates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"stageName": {},
									"inboundTransitionState": {
										"type": "structure",
										"members": {
											"enabled": {
												"type": "boolean"
											},
											"lastChangedBy": {},
											"lastChangedAt": {
												"type": "timestamp"
											},
											"disabledReason": {}
										}
									},
									"actionStates": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"actionName": {},
												"currentRevision": {
													"shape": "S32"
												},
												"latestExecution": {
													"type": "structure",
													"members": {
														"status": {},
														"summary": {},
														"lastStatusChange": {
															"type": "timestamp"
														},
														"token": {},
														"lastUpdatedBy": {},
														"externalExecutionId": {},
														"externalExecutionUrl": {},
														"percentComplete": {
															"type": "integer"
														},
														"errorDetails": {
															"type": "structure",
															"members": {
																"code": {},
																"message": {}
															}
														}
													}
												},
												"entityUrl": {},
												"revisionUrl": {}
											}
										}
									},
									"latestExecution": {
										"type": "structure",
										"required": [
											"pipelineExecutionId",
											"status"
										],
										"members": {
											"pipelineExecutionId": {},
											"status": {}
										}
									}
								}
							}
						},
						"created": {
							"type": "timestamp"
						},
						"updated": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetThirdPartyJobDetails": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"clientToken"
					],
					"members": {
						"jobId": {},
						"clientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobDetails": {
							"type": "structure",
							"members": {
								"id": {},
								"data": {
									"type": "structure",
									"members": {
										"actionTypeId": {
											"shape": "Ss"
										},
										"actionConfiguration": {
											"shape": "S1y"
										},
										"pipelineContext": {
											"shape": "S1z"
										},
										"inputArtifacts": {
											"shape": "S22"
										},
										"outputArtifacts": {
											"shape": "S22"
										},
										"artifactCredentials": {
											"shape": "S2a"
										},
										"continuationToken": {},
										"encryptionKey": {
											"shape": "S11"
										}
									}
								},
								"nonce": {}
							}
						}
					}
				}
			},
			"ListActionTypes": {
				"input": {
					"type": "structure",
					"members": {
						"actionOwnerFilter": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"actionTypes"
					],
					"members": {
						"actionTypes": {
							"type": "list",
							"member": {
								"shape": "Sr"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListPipelines": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelines": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"version": {
										"type": "integer"
									},
									"created": {
										"type": "timestamp"
									},
									"updated": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"PollForJobs": {
				"input": {
					"type": "structure",
					"required": [
						"actionTypeId"
					],
					"members": {
						"actionTypeId": {
							"shape": "Ss"
						},
						"maxBatchSize": {
							"type": "integer"
						},
						"queryParam": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobs": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"id": {},
									"data": {
										"shape": "S1x"
									},
									"nonce": {},
									"accountId": {}
								}
							}
						}
					}
				}
			},
			"PollForThirdPartyJobs": {
				"input": {
					"type": "structure",
					"required": [
						"actionTypeId"
					],
					"members": {
						"actionTypeId": {
							"shape": "Ss"
						},
						"maxBatchSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobs": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"clientId": {},
									"jobId": {}
								}
							}
						}
					}
				}
			},
			"PutActionRevision": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"actionName",
						"actionRevision"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"actionName": {},
						"actionRevision": {
							"shape": "S32"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"newRevision": {
							"type": "boolean"
						},
						"pipelineExecutionId": {}
					}
				}
			},
			"PutApprovalResult": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"actionName",
						"result",
						"token"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"actionName": {},
						"result": {
							"type": "structure",
							"required": [
								"summary",
								"status"
							],
							"members": {
								"summary": {},
								"status": {}
							}
						},
						"token": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"approvedAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"PutJobFailureResult": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"failureDetails"
					],
					"members": {
						"jobId": {},
						"failureDetails": {
							"shape": "S4c"
						}
					}
				}
			},
			"PutJobSuccessResult": {
				"input": {
					"type": "structure",
					"required": [
						"jobId"
					],
					"members": {
						"jobId": {},
						"currentRevision": {
							"shape": "S4f"
						},
						"continuationToken": {},
						"executionDetails": {
							"shape": "S4h"
						}
					}
				}
			},
			"PutThirdPartyJobFailureResult": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"clientToken",
						"failureDetails"
					],
					"members": {
						"jobId": {},
						"clientToken": {},
						"failureDetails": {
							"shape": "S4c"
						}
					}
				}
			},
			"PutThirdPartyJobSuccessResult": {
				"input": {
					"type": "structure",
					"required": [
						"jobId",
						"clientToken"
					],
					"members": {
						"jobId": {},
						"clientToken": {},
						"currentRevision": {
							"shape": "S4f"
						},
						"continuationToken": {},
						"executionDetails": {
							"shape": "S4h"
						}
					}
				}
			},
			"RetryStageExecution": {
				"input": {
					"type": "structure",
					"required": [
						"pipelineName",
						"stageName",
						"pipelineExecutionId",
						"retryMode"
					],
					"members": {
						"pipelineName": {},
						"stageName": {},
						"pipelineExecutionId": {},
						"retryMode": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelineExecutionId": {}
					}
				}
			},
			"StartPipelineExecution": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipelineExecutionId": {}
					}
				}
			},
			"UpdatePipeline": {
				"input": {
					"type": "structure",
					"required": [
						"pipeline"
					],
					"members": {
						"pipeline": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"pipeline": {
							"shape": "Sv"
						}
					}
				}
			}
		},
		"shapes": {
			"Se": {
				"type": "structure",
				"members": {
					"thirdPartyConfigurationUrl": {},
					"entityUrlTemplate": {},
					"executionUrlTemplate": {},
					"revisionUrlTemplate": {}
				}
			},
			"Sh": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"name",
						"required",
						"key",
						"secret"
					],
					"members": {
						"name": {},
						"required": {
							"type": "boolean"
						},
						"key": {
							"type": "boolean"
						},
						"secret": {
							"type": "boolean"
						},
						"queryable": {
							"type": "boolean"
						},
						"description": {},
						"type": {}
					}
				}
			},
			"Sn": {
				"type": "structure",
				"required": [
					"minimumCount",
					"maximumCount"
				],
				"members": {
					"minimumCount": {
						"type": "integer"
					},
					"maximumCount": {
						"type": "integer"
					}
				}
			},
			"Sr": {
				"type": "structure",
				"required": [
					"id",
					"inputArtifactDetails",
					"outputArtifactDetails"
				],
				"members": {
					"id": {
						"shape": "Ss"
					},
					"settings": {
						"shape": "Se"
					},
					"actionConfigurationProperties": {
						"shape": "Sh"
					},
					"inputArtifactDetails": {
						"shape": "Sn"
					},
					"outputArtifactDetails": {
						"shape": "Sn"
					}
				}
			},
			"Ss": {
				"type": "structure",
				"required": [
					"category",
					"owner",
					"provider",
					"version"
				],
				"members": {
					"category": {},
					"owner": {},
					"provider": {},
					"version": {}
				}
			},
			"Sv": {
				"type": "structure",
				"required": [
					"name",
					"roleArn",
					"artifactStore",
					"stages"
				],
				"members": {
					"name": {},
					"roleArn": {},
					"artifactStore": {
						"type": "structure",
						"required": [
							"type",
							"location"
						],
						"members": {
							"type": {},
							"location": {},
							"encryptionKey": {
								"shape": "S11"
							}
						}
					},
					"stages": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"name",
								"actions"
							],
							"members": {
								"name": {},
								"blockers": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"name",
											"type"
										],
										"members": {
											"name": {},
											"type": {}
										}
									}
								},
								"actions": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"name",
											"actionTypeId"
										],
										"members": {
											"name": {},
											"actionTypeId": {
												"shape": "Ss"
											},
											"runOrder": {
												"type": "integer"
											},
											"configuration": {
												"shape": "S1f"
											},
											"outputArtifacts": {
												"type": "list",
												"member": {
													"type": "structure",
													"required": [
														"name"
													],
													"members": {
														"name": {}
													}
												}
											},
											"inputArtifacts": {
												"type": "list",
												"member": {
													"type": "structure",
													"required": [
														"name"
													],
													"members": {
														"name": {}
													}
												}
											},
											"roleArn": {}
										}
									}
								}
							}
						}
					},
					"version": {
						"type": "integer"
					}
				}
			},
			"S11": {
				"type": "structure",
				"required": [
					"id",
					"type"
				],
				"members": {
					"id": {},
					"type": {}
				}
			},
			"S1f": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1x": {
				"type": "structure",
				"members": {
					"actionTypeId": {
						"shape": "Ss"
					},
					"actionConfiguration": {
						"shape": "S1y"
					},
					"pipelineContext": {
						"shape": "S1z"
					},
					"inputArtifacts": {
						"shape": "S22"
					},
					"outputArtifacts": {
						"shape": "S22"
					},
					"artifactCredentials": {
						"shape": "S2a"
					},
					"continuationToken": {},
					"encryptionKey": {
						"shape": "S11"
					}
				}
			},
			"S1y": {
				"type": "structure",
				"members": {
					"configuration": {
						"shape": "S1f"
					}
				}
			},
			"S1z": {
				"type": "structure",
				"members": {
					"pipelineName": {},
					"stage": {
						"type": "structure",
						"members": {
							"name": {}
						}
					},
					"action": {
						"type": "structure",
						"members": {
							"name": {}
						}
					}
				}
			},
			"S22": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"revision": {},
						"location": {
							"type": "structure",
							"members": {
								"type": {},
								"s3Location": {
									"type": "structure",
									"required": [
										"bucketName",
										"objectKey"
									],
									"members": {
										"bucketName": {},
										"objectKey": {}
									}
								}
							}
						}
					}
				}
			},
			"S2a": {
				"type": "structure",
				"required": [
					"accessKeyId",
					"secretAccessKey",
					"sessionToken"
				],
				"members": {
					"accessKeyId": {},
					"secretAccessKey": {},
					"sessionToken": {}
				},
				"sensitive": true
			},
			"S32": {
				"type": "structure",
				"required": [
					"revisionId",
					"revisionChangeId",
					"created"
				],
				"members": {
					"revisionId": {},
					"revisionChangeId": {},
					"created": {
						"type": "timestamp"
					}
				}
			},
			"S4c": {
				"type": "structure",
				"required": [
					"type",
					"message"
				],
				"members": {
					"type": {},
					"message": {},
					"externalExecutionId": {}
				}
			},
			"S4f": {
				"type": "structure",
				"required": [
					"revision",
					"changeIdentifier"
				],
				"members": {
					"revision": {},
					"changeIdentifier": {},
					"created": {
						"type": "timestamp"
					},
					"revisionSummary": {}
				}
			},
			"S4h": {
				"type": "structure",
				"members": {
					"summary": {},
					"externalExecutionId": {},
					"percentComplete": {
						"type": "integer"
					}
				}
			}
		}
	};

/***/ },
/* 659 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-06-30",
			"endpointPrefix": "cognito-identity",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Cognito Identity",
			"signatureVersion": "v4",
			"targetPrefix": "AWSCognitoIdentityService",
			"uid": "cognito-identity-2014-06-30"
		},
		"operations": {
			"CreateIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolName",
						"AllowUnauthenticatedIdentities"
					],
					"members": {
						"IdentityPoolName": {},
						"AllowUnauthenticatedIdentities": {
							"type": "boolean"
						},
						"SupportedLoginProviders": {
							"shape": "S4"
						},
						"DeveloperProviderName": {},
						"OpenIdConnectProviderARNs": {
							"shape": "S8"
						},
						"CognitoIdentityProviders": {
							"shape": "Sa"
						},
						"SamlProviderARNs": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"shape": "Sf"
				}
			},
			"DeleteIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityIdsToDelete"
					],
					"members": {
						"IdentityIdsToDelete": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UnprocessedIdentityIds": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IdentityId": {},
									"ErrorCode": {}
								}
							}
						}
					}
				}
			},
			"DeleteIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				}
			},
			"DescribeIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {}
					}
				},
				"output": {
					"shape": "Sq"
				}
			},
			"DescribeIdentityPool": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				},
				"output": {
					"shape": "Sf"
				}
			},
			"GetCredentialsForIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sv"
						},
						"CustomRoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Credentials": {
							"type": "structure",
							"members": {
								"AccessKeyId": {},
								"SecretKey": {},
								"SessionToken": {},
								"Expiration": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"GetId": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"AccountId": {},
						"IdentityPoolId": {},
						"Logins": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {}
					}
				}
			},
			"GetIdentityPoolRoles": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"Roles": {
							"shape": "S17"
						},
						"RoleMappings": {
							"shape": "S19"
						}
					}
				}
			},
			"GetOpenIdToken": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Token": {}
					}
				}
			},
			"GetOpenIdTokenForDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Logins"
					],
					"members": {
						"IdentityPoolId": {},
						"IdentityId": {},
						"Logins": {
							"shape": "Sv"
						},
						"TokenDuration": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"Token": {}
					}
				}
			},
			"ListIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"MaxResults"
					],
					"members": {
						"IdentityPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"HideDisabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"Identities": {
							"type": "list",
							"member": {
								"shape": "Sq"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityPools": {
				"input": {
					"type": "structure",
					"required": [
						"MaxResults"
					],
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPools": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IdentityPoolId": {},
									"IdentityPoolName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"LookupDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {},
						"IdentityId": {},
						"DeveloperUserIdentifier": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {},
						"DeveloperUserIdentifierList": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"MergeDeveloperIdentities": {
				"input": {
					"type": "structure",
					"required": [
						"SourceUserIdentifier",
						"DestinationUserIdentifier",
						"DeveloperProviderName",
						"IdentityPoolId"
					],
					"members": {
						"SourceUserIdentifier": {},
						"DestinationUserIdentifier": {},
						"DeveloperProviderName": {},
						"IdentityPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityId": {}
					}
				}
			},
			"SetIdentityPoolRoles": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Roles"
					],
					"members": {
						"IdentityPoolId": {},
						"Roles": {
							"shape": "S17"
						},
						"RoleMappings": {
							"shape": "S19"
						}
					}
				}
			},
			"UnlinkDeveloperIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"IdentityPoolId",
						"DeveloperProviderName",
						"DeveloperUserIdentifier"
					],
					"members": {
						"IdentityId": {},
						"IdentityPoolId": {},
						"DeveloperProviderName": {},
						"DeveloperUserIdentifier": {}
					}
				}
			},
			"UnlinkIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"Logins",
						"LoginsToRemove"
					],
					"members": {
						"IdentityId": {},
						"Logins": {
							"shape": "Sv"
						},
						"LoginsToRemove": {
							"shape": "Sr"
						}
					}
				}
			},
			"UpdateIdentityPool": {
				"input": {
					"shape": "Sf"
				},
				"output": {
					"shape": "Sf"
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S8": {
				"type": "list",
				"member": {}
			},
			"Sa": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ProviderName": {},
						"ClientId": {}
					}
				}
			},
			"Se": {
				"type": "list",
				"member": {}
			},
			"Sf": {
				"type": "structure",
				"required": [
					"IdentityPoolId",
					"IdentityPoolName",
					"AllowUnauthenticatedIdentities"
				],
				"members": {
					"IdentityPoolId": {},
					"IdentityPoolName": {},
					"AllowUnauthenticatedIdentities": {
						"type": "boolean"
					},
					"SupportedLoginProviders": {
						"shape": "S4"
					},
					"DeveloperProviderName": {},
					"OpenIdConnectProviderARNs": {
						"shape": "S8"
					},
					"CognitoIdentityProviders": {
						"shape": "Sa"
					},
					"SamlProviderARNs": {
						"shape": "Se"
					}
				}
			},
			"Sq": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"Logins": {
						"shape": "Sr"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					}
				}
			},
			"Sr": {
				"type": "list",
				"member": {}
			},
			"Sv": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S17": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S19": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"Type"
					],
					"members": {
						"Type": {},
						"AmbiguousRoleResolution": {},
						"RulesConfiguration": {
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"Claim",
											"MatchType",
											"Value",
											"RoleARN"
										],
										"members": {
											"Claim": {},
											"MatchType": {},
											"Value": {},
											"RoleARN": {}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 660 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-04-18",
			"endpointPrefix": "cognito-idp",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Cognito Identity Provider",
			"signatureVersion": "v4",
			"targetPrefix": "AWSCognitoIdentityProviderService",
			"uid": "cognito-idp-2016-04-18"
		},
		"operations": {
			"AddCustomAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"CustomAttributes"
					],
					"members": {
						"UserPoolId": {},
						"CustomAttributes": {
							"type": "list",
							"member": {
								"shape": "S4"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminAddUserToGroup": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"GroupName"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"GroupName": {}
					}
				}
			},
			"AdminConfirmSignUp": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminCreateUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"ValidationData": {
							"shape": "Si"
						},
						"TemporaryPassword": {
							"shape": "Sm"
						},
						"ForceAliasCreation": {
							"type": "boolean"
						},
						"MessageAction": {},
						"DesiredDeliveryMediums": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"User": {
							"shape": "Ss"
						}
					}
				}
			},
			"AdminDeleteUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				}
			},
			"AdminDeleteUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"UserAttributeNames"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"UserAttributeNames": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminDisableUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminEnableUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminForgetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"DeviceKey"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"DeviceKey": {}
					}
				}
			},
			"AdminGetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceKey",
						"UserPoolId",
						"Username"
					],
					"members": {
						"DeviceKey": {},
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Device"
					],
					"members": {
						"Device": {
							"shape": "S19"
						}
					}
				}
			},
			"AdminGetUser": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Username"
					],
					"members": {
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"UserCreateDate": {
							"type": "timestamp"
						},
						"UserLastModifiedDate": {
							"type": "timestamp"
						},
						"Enabled": {
							"type": "boolean"
						},
						"UserStatus": {},
						"MFAOptions": {
							"shape": "Sv"
						}
					}
				}
			},
			"AdminInitiateAuth": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId",
						"AuthFlow"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1d"
						},
						"AuthFlow": {},
						"AuthParameters": {
							"shape": "S1f"
						},
						"ClientMetadata": {
							"shape": "S1g"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1k"
						},
						"AuthenticationResult": {
							"shape": "S1l"
						}
					}
				}
			},
			"AdminListDevices": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"Limit": {
							"type": "integer"
						},
						"PaginationToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Devices": {
							"shape": "S1t"
						},
						"PaginationToken": {}
					}
				}
			},
			"AdminListGroupsForUser": {
				"input": {
					"type": "structure",
					"required": [
						"Username",
						"UserPoolId"
					],
					"members": {
						"Username": {
							"shape": "Sd"
						},
						"UserPoolId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Groups": {
							"shape": "S1x"
						},
						"NextToken": {}
					}
				}
			},
			"AdminRemoveUserFromGroup": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"GroupName"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"GroupName": {}
					}
				}
			},
			"AdminResetUserPassword": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminRespondToAuthChallenge": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId",
						"ChallengeName"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1d"
						},
						"ChallengeName": {},
						"ChallengeResponses": {
							"shape": "S26"
						},
						"Session": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1k"
						},
						"AuthenticationResult": {
							"shape": "S1l"
						}
					}
				}
			},
			"AdminSetUserSettings": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"MFAOptions"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"MFAOptions": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUpdateDeviceStatus": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"DeviceKey"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"DeviceKey": {},
						"DeviceRememberedStatus": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUpdateUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username",
						"UserAttributes"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AdminUserGlobalSignOut": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"Username"
					],
					"members": {
						"UserPoolId": {},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ChangePassword": {
				"input": {
					"type": "structure",
					"required": [
						"PreviousPassword",
						"ProposedPassword"
					],
					"members": {
						"PreviousPassword": {
							"shape": "Sm"
						},
						"ProposedPassword": {
							"shape": "Sm"
						},
						"AccessToken": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"ConfirmDevice": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"DeviceKey"
					],
					"members": {
						"AccessToken": {
							"shape": "S1m"
						},
						"DeviceKey": {},
						"DeviceSecretVerifierConfig": {
							"type": "structure",
							"members": {
								"PasswordVerifier": {},
								"Salt": {}
							}
						},
						"DeviceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserConfirmationNecessary": {
							"type": "boolean"
						}
					}
				}
			},
			"ConfirmForgotPassword": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username",
						"ConfirmationCode",
						"Password"
					],
					"members": {
						"ClientId": {
							"shape": "S1d"
						},
						"SecretHash": {
							"shape": "S2o"
						},
						"Username": {
							"shape": "Sd"
						},
						"ConfirmationCode": {},
						"Password": {
							"shape": "Sm"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"ConfirmSignUp": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username",
						"ConfirmationCode"
					],
					"members": {
						"ClientId": {
							"shape": "S1d"
						},
						"SecretHash": {
							"shape": "S2o"
						},
						"Username": {
							"shape": "Sd"
						},
						"ConfirmationCode": {},
						"ForceAliasCreation": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"CreateGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {},
						"Description": {},
						"RoleArn": {},
						"Precedence": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "S1y"
						}
					}
				}
			},
			"CreateUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"JobName",
						"UserPoolId",
						"CloudWatchLogsRoleArn"
					],
					"members": {
						"JobName": {},
						"UserPoolId": {},
						"CloudWatchLogsRoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S2y"
						}
					}
				}
			},
			"CreateUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"PoolName"
					],
					"members": {
						"PoolName": {},
						"Policies": {
							"shape": "S36"
						},
						"LambdaConfig": {
							"shape": "S39"
						},
						"AutoVerifiedAttributes": {
							"shape": "S3a"
						},
						"AliasAttributes": {
							"shape": "S3c"
						},
						"SmsVerificationMessage": {},
						"EmailVerificationMessage": {},
						"EmailVerificationSubject": {},
						"SmsAuthenticationMessage": {},
						"MfaConfiguration": {},
						"DeviceConfiguration": {
							"shape": "S3i"
						},
						"EmailConfiguration": {
							"shape": "S3j"
						},
						"SmsConfiguration": {
							"shape": "S3l"
						},
						"UserPoolTags": {
							"shape": "S3m"
						},
						"AdminCreateUserConfig": {
							"shape": "S3n"
						},
						"Schema": {
							"shape": "S3q"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPool": {
							"shape": "S3s"
						}
					}
				}
			},
			"CreateUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientName"
					],
					"members": {
						"UserPoolId": {},
						"ClientName": {},
						"GenerateSecret": {
							"type": "boolean"
						},
						"RefreshTokenValidity": {
							"type": "integer"
						},
						"ReadAttributes": {
							"shape": "S3y"
						},
						"WriteAttributes": {
							"shape": "S3y"
						},
						"ExplicitAuthFlows": {
							"shape": "S40"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClient": {
							"shape": "S43"
						}
					}
				}
			},
			"DeleteGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {}
					}
				}
			},
			"DeleteUser": {
				"input": {
					"type": "structure",
					"members": {
						"AccessToken": {
							"shape": "S1m"
						}
					}
				},
				"authtype": "none"
			},
			"DeleteUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserAttributeNames"
					],
					"members": {
						"UserAttributeNames": {
							"shape": "Sz"
						},
						"AccessToken": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"DeleteUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				}
			},
			"DeleteUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1d"
						}
					}
				}
			},
			"DescribeUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"JobId"
					],
					"members": {
						"UserPoolId": {},
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S2y"
						}
					}
				}
			},
			"DescribeUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPool": {
							"shape": "S3s"
						}
					}
				}
			},
			"DescribeUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClient": {
							"shape": "S43"
						}
					}
				}
			},
			"ForgetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceKey"
					],
					"members": {
						"AccessToken": {
							"shape": "S1m"
						},
						"DeviceKey": {}
					}
				}
			},
			"ForgotPassword": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username"
					],
					"members": {
						"ClientId": {
							"shape": "S1d"
						},
						"SecretHash": {
							"shape": "S2o"
						},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetails": {
							"shape": "S4k"
						}
					}
				},
				"authtype": "none"
			},
			"GetCSVHeader": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolId": {},
						"CSVHeader": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"GetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"DeviceKey"
					],
					"members": {
						"DeviceKey": {},
						"AccessToken": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Device"
					],
					"members": {
						"Device": {
							"shape": "S19"
						}
					}
				}
			},
			"GetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "S1y"
						}
					}
				}
			},
			"GetUser": {
				"input": {
					"type": "structure",
					"members": {
						"AccessToken": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Username",
						"UserAttributes"
					],
					"members": {
						"Username": {
							"shape": "Sd"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"MFAOptions": {
							"shape": "Sv"
						}
					}
				},
				"authtype": "none"
			},
			"GetUserAttributeVerificationCode": {
				"input": {
					"type": "structure",
					"required": [
						"AttributeName"
					],
					"members": {
						"AccessToken": {
							"shape": "S1m"
						},
						"AttributeName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetails": {
							"shape": "S4k"
						}
					}
				},
				"authtype": "none"
			},
			"GlobalSignOut": {
				"input": {
					"type": "structure",
					"members": {
						"AccessToken": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"InitiateAuth": {
				"input": {
					"type": "structure",
					"required": [
						"AuthFlow",
						"ClientId"
					],
					"members": {
						"AuthFlow": {},
						"AuthParameters": {
							"shape": "S1f"
						},
						"ClientMetadata": {
							"shape": "S1g"
						},
						"ClientId": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1k"
						},
						"AuthenticationResult": {
							"shape": "S1l"
						}
					}
				}
			},
			"ListDevices": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken"
					],
					"members": {
						"AccessToken": {
							"shape": "S1m"
						},
						"Limit": {
							"type": "integer"
						},
						"PaginationToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Devices": {
							"shape": "S1t"
						},
						"PaginationToken": {}
					}
				}
			},
			"ListGroups": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Groups": {
							"shape": "S1x"
						},
						"NextToken": {}
					}
				}
			},
			"ListUserImportJobs": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"MaxResults"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"PaginationToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJobs": {
							"type": "list",
							"member": {
								"shape": "S2y"
							}
						},
						"PaginationToken": {}
					}
				}
			},
			"ListUserPoolClients": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClients": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ClientId": {
										"shape": "S1d"
									},
									"UserPoolId": {},
									"ClientName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListUserPools": {
				"input": {
					"type": "structure",
					"required": [
						"MaxResults"
					],
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPools": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"LambdaConfig": {
										"shape": "S39"
									},
									"Status": {},
									"LastModifiedDate": {
										"type": "timestamp"
									},
									"CreationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListUsers": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"AttributesToGet": {
							"type": "list",
							"member": {}
						},
						"Limit": {
							"type": "integer"
						},
						"PaginationToken": {},
						"Filter": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Users": {
							"shape": "S5m"
						},
						"PaginationToken": {}
					}
				}
			},
			"ListUsersInGroup": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"GroupName"
					],
					"members": {
						"UserPoolId": {},
						"GroupName": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Users": {
							"shape": "S5m"
						},
						"NextToken": {}
					}
				}
			},
			"ResendConfirmationCode": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username"
					],
					"members": {
						"ClientId": {
							"shape": "S1d"
						},
						"SecretHash": {
							"shape": "S2o"
						},
						"Username": {
							"shape": "Sd"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetails": {
							"shape": "S4k"
						}
					}
				},
				"authtype": "none"
			},
			"RespondToAuthChallenge": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"ChallengeName"
					],
					"members": {
						"ClientId": {
							"shape": "S1d"
						},
						"ChallengeName": {},
						"Session": {},
						"ChallengeResponses": {
							"shape": "S26"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChallengeName": {},
						"Session": {},
						"ChallengeParameters": {
							"shape": "S1k"
						},
						"AuthenticationResult": {
							"shape": "S1l"
						}
					}
				}
			},
			"SetUserSettings": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"MFAOptions"
					],
					"members": {
						"AccessToken": {
							"shape": "S1m"
						},
						"MFAOptions": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			},
			"SignUp": {
				"input": {
					"type": "structure",
					"required": [
						"ClientId",
						"Username",
						"Password"
					],
					"members": {
						"ClientId": {
							"shape": "S1d"
						},
						"SecretHash": {
							"shape": "S2o"
						},
						"Username": {
							"shape": "Sd"
						},
						"Password": {
							"shape": "Sm"
						},
						"UserAttributes": {
							"shape": "Si"
						},
						"ValidationData": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserConfirmed": {
							"type": "boolean"
						},
						"CodeDeliveryDetails": {
							"shape": "S4k"
						}
					}
				},
				"authtype": "none"
			},
			"StartUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"JobId"
					],
					"members": {
						"UserPoolId": {},
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S2y"
						}
					}
				}
			},
			"StopUserImportJob": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"JobId"
					],
					"members": {
						"UserPoolId": {},
						"JobId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserImportJob": {
							"shape": "S2y"
						}
					}
				}
			},
			"UpdateDeviceStatus": {
				"input": {
					"type": "structure",
					"required": [
						"AccessToken",
						"DeviceKey"
					],
					"members": {
						"AccessToken": {
							"shape": "S1m"
						},
						"DeviceKey": {},
						"DeviceRememberedStatus": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"UserPoolId"
					],
					"members": {
						"GroupName": {},
						"UserPoolId": {},
						"Description": {},
						"RoleArn": {},
						"Precedence": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Group": {
							"shape": "S1y"
						}
					}
				}
			},
			"UpdateUserAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"UserAttributes"
					],
					"members": {
						"UserAttributes": {
							"shape": "Si"
						},
						"AccessToken": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CodeDeliveryDetailsList": {
							"type": "list",
							"member": {
								"shape": "S4k"
							}
						}
					}
				},
				"authtype": "none"
			},
			"UpdateUserPool": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId"
					],
					"members": {
						"UserPoolId": {},
						"Policies": {
							"shape": "S36"
						},
						"LambdaConfig": {
							"shape": "S39"
						},
						"AutoVerifiedAttributes": {
							"shape": "S3a"
						},
						"SmsVerificationMessage": {},
						"EmailVerificationMessage": {},
						"EmailVerificationSubject": {},
						"SmsAuthenticationMessage": {},
						"MfaConfiguration": {},
						"DeviceConfiguration": {
							"shape": "S3i"
						},
						"EmailConfiguration": {
							"shape": "S3j"
						},
						"SmsConfiguration": {
							"shape": "S3l"
						},
						"UserPoolTags": {
							"shape": "S3m"
						},
						"AdminCreateUserConfig": {
							"shape": "S3n"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateUserPoolClient": {
				"input": {
					"type": "structure",
					"required": [
						"UserPoolId",
						"ClientId"
					],
					"members": {
						"UserPoolId": {},
						"ClientId": {
							"shape": "S1d"
						},
						"ClientName": {},
						"RefreshTokenValidity": {
							"type": "integer"
						},
						"ReadAttributes": {
							"shape": "S3y"
						},
						"WriteAttributes": {
							"shape": "S3y"
						},
						"ExplicitAuthFlows": {
							"shape": "S40"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserPoolClient": {
							"shape": "S43"
						}
					}
				}
			},
			"VerifyUserAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"AttributeName",
						"Code"
					],
					"members": {
						"AccessToken": {
							"shape": "S1m"
						},
						"AttributeName": {},
						"Code": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				},
				"authtype": "none"
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"Name": {},
					"AttributeDataType": {},
					"DeveloperOnlyAttribute": {
						"type": "boolean"
					},
					"Mutable": {
						"type": "boolean"
					},
					"Required": {
						"type": "boolean"
					},
					"NumberAttributeConstraints": {
						"type": "structure",
						"members": {
							"MinValue": {},
							"MaxValue": {}
						}
					},
					"StringAttributeConstraints": {
						"type": "structure",
						"members": {
							"MinLength": {},
							"MaxLength": {}
						}
					}
				}
			},
			"Sd": {
				"type": "string",
				"sensitive": true
			},
			"Si": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Value": {
							"type": "string",
							"sensitive": true
						}
					}
				}
			},
			"Sm": {
				"type": "string",
				"sensitive": true
			},
			"Ss": {
				"type": "structure",
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"Attributes": {
						"shape": "Si"
					},
					"UserCreateDate": {
						"type": "timestamp"
					},
					"UserLastModifiedDate": {
						"type": "timestamp"
					},
					"Enabled": {
						"type": "boolean"
					},
					"UserStatus": {},
					"MFAOptions": {
						"shape": "Sv"
					}
				}
			},
			"Sv": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"DeliveryMedium": {},
						"AttributeName": {}
					}
				}
			},
			"Sz": {
				"type": "list",
				"member": {}
			},
			"S19": {
				"type": "structure",
				"members": {
					"DeviceKey": {},
					"DeviceAttributes": {
						"shape": "Si"
					},
					"DeviceCreateDate": {
						"type": "timestamp"
					},
					"DeviceLastModifiedDate": {
						"type": "timestamp"
					},
					"DeviceLastAuthenticatedDate": {
						"type": "timestamp"
					}
				}
			},
			"S1d": {
				"type": "string",
				"sensitive": true
			},
			"S1f": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1g": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1k": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1l": {
				"type": "structure",
				"members": {
					"AccessToken": {
						"shape": "S1m"
					},
					"ExpiresIn": {
						"type": "integer"
					},
					"TokenType": {},
					"RefreshToken": {
						"shape": "S1m"
					},
					"IdToken": {
						"shape": "S1m"
					},
					"NewDeviceMetadata": {
						"type": "structure",
						"members": {
							"DeviceKey": {},
							"DeviceGroupKey": {}
						}
					}
				}
			},
			"S1m": {
				"type": "string",
				"sensitive": true
			},
			"S1t": {
				"type": "list",
				"member": {
					"shape": "S19"
				}
			},
			"S1x": {
				"type": "list",
				"member": {
					"shape": "S1y"
				}
			},
			"S1y": {
				"type": "structure",
				"members": {
					"GroupName": {},
					"UserPoolId": {},
					"Description": {},
					"RoleArn": {},
					"Precedence": {
						"type": "integer"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					}
				}
			},
			"S26": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S2o": {
				"type": "string",
				"sensitive": true
			},
			"S2y": {
				"type": "structure",
				"members": {
					"JobName": {},
					"JobId": {},
					"UserPoolId": {},
					"PreSignedUrl": {},
					"CreationDate": {
						"type": "timestamp"
					},
					"StartDate": {
						"type": "timestamp"
					},
					"CompletionDate": {
						"type": "timestamp"
					},
					"Status": {},
					"CloudWatchLogsRoleArn": {},
					"ImportedUsers": {
						"type": "long"
					},
					"SkippedUsers": {
						"type": "long"
					},
					"FailedUsers": {
						"type": "long"
					},
					"CompletionMessage": {}
				}
			},
			"S36": {
				"type": "structure",
				"members": {
					"PasswordPolicy": {
						"type": "structure",
						"members": {
							"MinimumLength": {
								"type": "integer"
							},
							"RequireUppercase": {
								"type": "boolean"
							},
							"RequireLowercase": {
								"type": "boolean"
							},
							"RequireNumbers": {
								"type": "boolean"
							},
							"RequireSymbols": {
								"type": "boolean"
							}
						}
					}
				}
			},
			"S39": {
				"type": "structure",
				"members": {
					"PreSignUp": {},
					"CustomMessage": {},
					"PostConfirmation": {},
					"PreAuthentication": {},
					"PostAuthentication": {},
					"DefineAuthChallenge": {},
					"CreateAuthChallenge": {},
					"VerifyAuthChallengeResponse": {}
				}
			},
			"S3a": {
				"type": "list",
				"member": {}
			},
			"S3c": {
				"type": "list",
				"member": {}
			},
			"S3i": {
				"type": "structure",
				"members": {
					"ChallengeRequiredOnNewDevice": {
						"type": "boolean"
					},
					"DeviceOnlyRememberedOnUserPrompt": {
						"type": "boolean"
					}
				}
			},
			"S3j": {
				"type": "structure",
				"members": {
					"SourceArn": {},
					"ReplyToEmailAddress": {}
				}
			},
			"S3l": {
				"type": "structure",
				"required": [
					"SnsCallerArn"
				],
				"members": {
					"SnsCallerArn": {},
					"ExternalId": {}
				}
			},
			"S3m": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S3n": {
				"type": "structure",
				"members": {
					"AllowAdminCreateUserOnly": {
						"type": "boolean"
					},
					"UnusedAccountValidityDays": {
						"type": "integer"
					},
					"InviteMessageTemplate": {
						"type": "structure",
						"members": {
							"SMSMessage": {},
							"EmailMessage": {},
							"EmailSubject": {}
						}
					}
				}
			},
			"S3q": {
				"type": "list",
				"member": {
					"shape": "S4"
				}
			},
			"S3s": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"Policies": {
						"shape": "S36"
					},
					"LambdaConfig": {
						"shape": "S39"
					},
					"Status": {},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"SchemaAttributes": {
						"shape": "S3q"
					},
					"AutoVerifiedAttributes": {
						"shape": "S3a"
					},
					"AliasAttributes": {
						"shape": "S3c"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S3i"
					},
					"EstimatedNumberOfUsers": {
						"type": "integer"
					},
					"EmailConfiguration": {
						"shape": "S3j"
					},
					"SmsConfiguration": {
						"shape": "S3l"
					},
					"UserPoolTags": {
						"shape": "S3m"
					},
					"SmsConfigurationFailure": {},
					"EmailConfigurationFailure": {},
					"AdminCreateUserConfig": {
						"shape": "S3n"
					}
				}
			},
			"S3y": {
				"type": "list",
				"member": {}
			},
			"S40": {
				"type": "list",
				"member": {}
			},
			"S43": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"ClientName": {},
					"ClientId": {
						"shape": "S1d"
					},
					"ClientSecret": {
						"type": "string",
						"sensitive": true
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"CreationDate": {
						"type": "timestamp"
					},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S3y"
					},
					"WriteAttributes": {
						"shape": "S3y"
					},
					"ExplicitAuthFlows": {
						"shape": "S40"
					}
				}
			},
			"S4k": {
				"type": "structure",
				"members": {
					"Destination": {},
					"DeliveryMedium": {},
					"AttributeName": {}
				}
			},
			"S5m": {
				"type": "list",
				"member": {
					"shape": "Ss"
				}
			}
		}
	};

/***/ },
/* 661 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-06-30",
			"endpointPrefix": "cognito-sync",
			"jsonVersion": "1.1",
			"serviceFullName": "Amazon Cognito Sync",
			"signatureVersion": "v4",
			"protocol": "rest-json",
			"uid": "cognito-sync-2014-06-30"
		},
		"operations": {
			"BulkPublish": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/bulkpublish",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {}
					}
				}
			},
			"DeleteDataset": {
				"http": {
					"method": "DELETE",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Dataset": {
							"shape": "S8"
						}
					}
				}
			},
			"DescribeDataset": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Dataset": {
							"shape": "S8"
						}
					}
				}
			},
			"DescribeIdentityPoolUsage": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolUsage": {
							"shape": "Sg"
						}
					}
				}
			},
			"DescribeIdentityUsage": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityUsage": {
							"type": "structure",
							"members": {
								"IdentityId": {},
								"IdentityPoolId": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"DatasetCount": {
									"type": "integer"
								},
								"DataStorage": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"GetBulkPublishDetails": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/getBulkPublishDetails",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"BulkPublishStartTime": {
							"type": "timestamp"
						},
						"BulkPublishCompleteTime": {
							"type": "timestamp"
						},
						"BulkPublishStatus": {},
						"FailureMessage": {}
					}
				}
			},
			"GetCognitoEvents": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/events",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Events": {
							"shape": "Sq"
						}
					}
				}
			},
			"GetIdentityPoolConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"PushSync": {
							"shape": "Sv"
						},
						"CognitoStreams": {
							"shape": "Sz"
						}
					}
				}
			},
			"ListDatasets": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityId",
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Datasets": {
							"type": "list",
							"member": {
								"shape": "S8"
							}
						},
						"Count": {
							"type": "integer"
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityPoolUsage": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolUsages": {
							"type": "list",
							"member": {
								"shape": "Sg"
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"Count": {
							"type": "integer"
						},
						"NextToken": {}
					}
				}
			},
			"ListRecords": {
				"http": {
					"method": "GET",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						},
						"LastSyncCount": {
							"location": "querystring",
							"locationName": "lastSyncCount",
							"type": "long"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"SyncSessionToken": {
							"location": "querystring",
							"locationName": "syncSessionToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Records": {
							"shape": "S1c"
						},
						"NextToken": {},
						"Count": {
							"type": "integer"
						},
						"DatasetSyncCount": {
							"type": "long"
						},
						"LastModifiedBy": {},
						"MergedDatasetNames": {
							"type": "list",
							"member": {}
						},
						"DatasetExists": {
							"type": "boolean"
						},
						"DatasetDeletedAfterRequestedSyncCount": {
							"type": "boolean"
						},
						"SyncSessionToken": {}
					}
				}
			},
			"RegisterDevice": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/identity/{IdentityId}/device",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"Platform",
						"Token"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"Platform": {},
						"Token": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeviceId": {}
					}
				}
			},
			"SetCognitoEvents": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/events",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"Events"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"Events": {
							"shape": "Sq"
						}
					}
				}
			},
			"SetIdentityPoolConfiguration": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"PushSync": {
							"shape": "Sv"
						},
						"CognitoStreams": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IdentityPoolId": {},
						"PushSync": {
							"shape": "Sv"
						},
						"CognitoStreams": {
							"shape": "Sz"
						}
					}
				}
			},
			"SubscribeToDataset": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName",
						"DeviceId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						},
						"DeviceId": {
							"location": "uri",
							"locationName": "DeviceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UnsubscribeFromDataset": {
				"http": {
					"method": "DELETE",
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName",
						"DeviceId"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						},
						"DeviceId": {
							"location": "uri",
							"locationName": "DeviceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateRecords": {
				"http": {
					"requestUri": "/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"IdentityPoolId",
						"IdentityId",
						"DatasetName",
						"SyncSessionToken"
					],
					"members": {
						"IdentityPoolId": {
							"location": "uri",
							"locationName": "IdentityPoolId"
						},
						"IdentityId": {
							"location": "uri",
							"locationName": "IdentityId"
						},
						"DatasetName": {
							"location": "uri",
							"locationName": "DatasetName"
						},
						"DeviceId": {},
						"RecordPatches": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Op",
									"Key",
									"SyncCount"
								],
								"members": {
									"Op": {},
									"Key": {},
									"Value": {},
									"SyncCount": {
										"type": "long"
									},
									"DeviceLastModifiedDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"SyncSessionToken": {},
						"ClientContext": {
							"location": "header",
							"locationName": "x-amz-Client-Context"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Records": {
							"shape": "S1c"
						}
					}
				}
			}
		},
		"shapes": {
			"S8": {
				"type": "structure",
				"members": {
					"IdentityId": {},
					"DatasetName": {},
					"CreationDate": {
						"type": "timestamp"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					},
					"LastModifiedBy": {},
					"DataStorage": {
						"type": "long"
					},
					"NumRecords": {
						"type": "long"
					}
				}
			},
			"Sg": {
				"type": "structure",
				"members": {
					"IdentityPoolId": {},
					"SyncSessionsCount": {
						"type": "long"
					},
					"DataStorage": {
						"type": "long"
					},
					"LastModifiedDate": {
						"type": "timestamp"
					}
				}
			},
			"Sq": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"ApplicationArns": {
						"type": "list",
						"member": {}
					},
					"RoleArn": {}
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"StreamName": {},
					"RoleArn": {},
					"StreamingStatus": {}
				}
			},
			"S1c": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {},
						"SyncCount": {
							"type": "long"
						},
						"LastModifiedDate": {
							"type": "timestamp"
						},
						"LastModifiedBy": {},
						"DeviceLastModifiedDate": {
							"type": "timestamp"
						}
					}
				}
			}
		},
		"examples": {}
	};

/***/ },
/* 662 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-11-12",
			"endpointPrefix": "config",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Config Service",
			"serviceFullName": "AWS Config",
			"signatureVersion": "v4",
			"targetPrefix": "StarlingDoveService",
			"uid": "config-2014-11-12"
		},
		"operations": {
			"DeleteConfigRule": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleName"
					],
					"members": {
						"ConfigRuleName": {}
					}
				}
			},
			"DeleteConfigurationRecorder": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationRecorderName"
					],
					"members": {
						"ConfigurationRecorderName": {}
					}
				}
			},
			"DeleteDeliveryChannel": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryChannelName"
					],
					"members": {
						"DeliveryChannelName": {}
					}
				}
			},
			"DeleteEvaluationResults": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleName"
					],
					"members": {
						"ConfigRuleName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeliverConfigSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"deliveryChannelName"
					],
					"members": {
						"deliveryChannelName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"configSnapshotId": {}
					}
				}
			},
			"DescribeComplianceByConfigRule": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigRuleNames": {
							"shape": "Sd"
						},
						"ComplianceTypes": {
							"shape": "Se"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ComplianceByConfigRules": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ConfigRuleName": {},
									"Compliance": {
										"shape": "Sj"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeComplianceByResource": {
				"input": {
					"type": "structure",
					"members": {
						"ResourceType": {},
						"ResourceId": {},
						"ComplianceTypes": {
							"shape": "Se"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ComplianceByResources": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ResourceType": {},
									"ResourceId": {},
									"Compliance": {
										"shape": "Sj"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeConfigRuleEvaluationStatus": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigRuleNames": {
							"shape": "Sd"
						},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigRulesEvaluationStatus": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ConfigRuleName": {},
									"ConfigRuleArn": {},
									"ConfigRuleId": {},
									"LastSuccessfulInvocationTime": {
										"type": "timestamp"
									},
									"LastFailedInvocationTime": {
										"type": "timestamp"
									},
									"LastSuccessfulEvaluationTime": {
										"type": "timestamp"
									},
									"LastFailedEvaluationTime": {
										"type": "timestamp"
									},
									"FirstActivatedTime": {
										"type": "timestamp"
									},
									"LastErrorCode": {},
									"LastErrorMessage": {},
									"FirstEvaluationStarted": {
										"type": "boolean"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeConfigRules": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigRuleNames": {
							"shape": "Sd"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigRules": {
							"type": "list",
							"member": {
								"shape": "S13"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeConfigurationRecorderStatus": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigurationRecorderNames": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigurationRecordersStatus": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"lastStartTime": {
										"type": "timestamp"
									},
									"lastStopTime": {
										"type": "timestamp"
									},
									"recording": {
										"type": "boolean"
									},
									"lastStatus": {},
									"lastErrorCode": {},
									"lastErrorMessage": {},
									"lastStatusChangeTime": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeConfigurationRecorders": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigurationRecorderNames": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConfigurationRecorders": {
							"type": "list",
							"member": {
								"shape": "S1q"
							}
						}
					}
				}
			},
			"DescribeDeliveryChannelStatus": {
				"input": {
					"type": "structure",
					"members": {
						"DeliveryChannelNames": {
							"shape": "S1x"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeliveryChannelsStatus": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"name": {},
									"configSnapshotDeliveryInfo": {
										"shape": "S21"
									},
									"configHistoryDeliveryInfo": {
										"shape": "S21"
									},
									"configStreamDeliveryInfo": {
										"type": "structure",
										"members": {
											"lastStatus": {},
											"lastErrorCode": {},
											"lastErrorMessage": {},
											"lastStatusChangeTime": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDeliveryChannels": {
				"input": {
					"type": "structure",
					"members": {
						"DeliveryChannelNames": {
							"shape": "S1x"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeliveryChannels": {
							"type": "list",
							"member": {
								"shape": "S27"
							}
						}
					}
				}
			},
			"GetComplianceDetailsByConfigRule": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRuleName"
					],
					"members": {
						"ConfigRuleName": {},
						"ComplianceTypes": {
							"shape": "Se"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationResults": {
							"shape": "S2b"
						},
						"NextToken": {}
					}
				}
			},
			"GetComplianceDetailsByResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId"
					],
					"members": {
						"ResourceType": {},
						"ResourceId": {},
						"ComplianceTypes": {
							"shape": "Se"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationResults": {
							"shape": "S2b"
						},
						"NextToken": {}
					}
				}
			},
			"GetComplianceSummaryByConfigRule": {
				"output": {
					"type": "structure",
					"members": {
						"ComplianceSummary": {
							"shape": "S2i"
						}
					}
				}
			},
			"GetComplianceSummaryByResourceType": {
				"input": {
					"type": "structure",
					"members": {
						"ResourceTypes": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ComplianceSummariesByResourceType": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ResourceType": {},
									"ComplianceSummary": {
										"shape": "S2i"
									}
								}
							}
						}
					}
				}
			},
			"GetResourceConfigHistory": {
				"input": {
					"type": "structure",
					"required": [
						"resourceType",
						"resourceId"
					],
					"members": {
						"resourceType": {},
						"resourceId": {},
						"laterTime": {
							"type": "timestamp"
						},
						"earlierTime": {
							"type": "timestamp"
						},
						"chronologicalOrder": {},
						"limit": {
							"type": "integer"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"configurationItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"version": {},
									"accountId": {},
									"configurationItemCaptureTime": {
										"type": "timestamp"
									},
									"configurationItemStatus": {},
									"configurationStateId": {},
									"configurationItemMD5Hash": {},
									"arn": {},
									"resourceType": {},
									"resourceId": {},
									"resourceName": {},
									"awsRegion": {},
									"availabilityZone": {},
									"resourceCreationTime": {
										"type": "timestamp"
									},
									"tags": {
										"type": "map",
										"key": {},
										"value": {}
									},
									"relatedEvents": {
										"type": "list",
										"member": {}
									},
									"relationships": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"resourceType": {},
												"resourceId": {},
												"resourceName": {},
												"relationshipName": {}
											}
										}
									},
									"configuration": {},
									"supplementaryConfiguration": {
										"type": "map",
										"key": {},
										"value": {}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListDiscoveredResources": {
				"input": {
					"type": "structure",
					"required": [
						"resourceType"
					],
					"members": {
						"resourceType": {},
						"resourceIds": {
							"type": "list",
							"member": {}
						},
						"resourceName": {},
						"limit": {
							"type": "integer"
						},
						"includeDeletedResources": {
							"type": "boolean"
						},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"resourceIdentifiers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"resourceType": {},
									"resourceId": {},
									"resourceName": {},
									"resourceDeletionTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"PutConfigRule": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigRule"
					],
					"members": {
						"ConfigRule": {
							"shape": "S13"
						}
					}
				}
			},
			"PutConfigurationRecorder": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationRecorder"
					],
					"members": {
						"ConfigurationRecorder": {
							"shape": "S1q"
						}
					}
				}
			},
			"PutDeliveryChannel": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryChannel"
					],
					"members": {
						"DeliveryChannel": {
							"shape": "S27"
						}
					}
				}
			},
			"PutEvaluations": {
				"input": {
					"type": "structure",
					"required": [
						"ResultToken"
					],
					"members": {
						"Evaluations": {
							"shape": "S3t"
						},
						"ResultToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedEvaluations": {
							"shape": "S3t"
						}
					}
				}
			},
			"StartConfigRulesEvaluation": {
				"input": {
					"type": "structure",
					"members": {
						"ConfigRuleNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"StartConfigurationRecorder": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationRecorderName"
					],
					"members": {
						"ConfigurationRecorderName": {}
					}
				}
			},
			"StopConfigurationRecorder": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationRecorderName"
					],
					"members": {
						"ConfigurationRecorderName": {}
					}
				}
			}
		},
		"shapes": {
			"Sd": {
				"type": "list",
				"member": {}
			},
			"Se": {
				"type": "list",
				"member": {}
			},
			"Sj": {
				"type": "structure",
				"members": {
					"ComplianceType": {},
					"ComplianceContributorCount": {
						"shape": "Sk"
					}
				}
			},
			"Sk": {
				"type": "structure",
				"members": {
					"CappedCount": {
						"type": "integer"
					},
					"CapExceeded": {
						"type": "boolean"
					}
				}
			},
			"S13": {
				"type": "structure",
				"required": [
					"Source"
				],
				"members": {
					"ConfigRuleName": {},
					"ConfigRuleArn": {},
					"ConfigRuleId": {},
					"Description": {},
					"Scope": {
						"type": "structure",
						"members": {
							"ComplianceResourceTypes": {
								"type": "list",
								"member": {}
							},
							"TagKey": {},
							"TagValue": {},
							"ComplianceResourceId": {}
						}
					},
					"Source": {
						"type": "structure",
						"required": [
							"Owner",
							"SourceIdentifier"
						],
						"members": {
							"Owner": {},
							"SourceIdentifier": {},
							"SourceDetails": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"EventSource": {},
										"MessageType": {},
										"MaximumExecutionFrequency": {}
									}
								}
							}
						}
					},
					"InputParameters": {},
					"MaximumExecutionFrequency": {},
					"ConfigRuleState": {}
				}
			},
			"S1i": {
				"type": "list",
				"member": {}
			},
			"S1q": {
				"type": "structure",
				"members": {
					"name": {},
					"roleARN": {},
					"recordingGroup": {
						"type": "structure",
						"members": {
							"allSupported": {
								"type": "boolean"
							},
							"includeGlobalResourceTypes": {
								"type": "boolean"
							},
							"resourceTypes": {
								"type": "list",
								"member": {}
							}
						}
					}
				}
			},
			"S1x": {
				"type": "list",
				"member": {}
			},
			"S21": {
				"type": "structure",
				"members": {
					"lastStatus": {},
					"lastErrorCode": {},
					"lastErrorMessage": {},
					"lastAttemptTime": {
						"type": "timestamp"
					},
					"lastSuccessfulTime": {
						"type": "timestamp"
					},
					"nextDeliveryTime": {
						"type": "timestamp"
					}
				}
			},
			"S27": {
				"type": "structure",
				"members": {
					"name": {},
					"s3BucketName": {},
					"s3KeyPrefix": {},
					"snsTopicARN": {},
					"configSnapshotDeliveryProperties": {
						"type": "structure",
						"members": {
							"deliveryFrequency": {}
						}
					}
				}
			},
			"S2b": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"EvaluationResultIdentifier": {
							"type": "structure",
							"members": {
								"EvaluationResultQualifier": {
									"type": "structure",
									"members": {
										"ConfigRuleName": {},
										"ResourceType": {},
										"ResourceId": {}
									}
								},
								"OrderingTimestamp": {
									"type": "timestamp"
								}
							}
						},
						"ComplianceType": {},
						"ResultRecordedTime": {
							"type": "timestamp"
						},
						"ConfigRuleInvokedTime": {
							"type": "timestamp"
						},
						"Annotation": {},
						"ResultToken": {}
					}
				}
			},
			"S2i": {
				"type": "structure",
				"members": {
					"CompliantResourceCount": {
						"shape": "Sk"
					},
					"NonCompliantResourceCount": {
						"shape": "Sk"
					},
					"ComplianceSummaryTimestamp": {
						"type": "timestamp"
					}
				}
			},
			"S3t": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"ComplianceResourceType",
						"ComplianceResourceId",
						"ComplianceType",
						"OrderingTimestamp"
					],
					"members": {
						"ComplianceResourceType": {},
						"ComplianceResourceId": {},
						"ComplianceType": {},
						"Annotation": {},
						"OrderingTimestamp": {
							"type": "timestamp"
						}
					}
				}
			}
		}
	};

/***/ },
/* 663 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetResourceConfigHistory": {
				"input_token": "nextToken",
				"limit_key": "limit",
				"output_token": "nextToken",
				"result_key": "configurationItems"
			}
		}
	};

/***/ },
/* 664 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2017-01-06",
			"endpointPrefix": "cur",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Cost and Usage Report Service",
			"signatureVersion": "v4",
			"signingName": "cur",
			"targetPrefix": "AWSOrigamiServiceGatewayService",
			"uid": "cur-2017-01-06"
		},
		"operations": {
			"DeleteReportDefinition": {
				"input": {
					"type": "structure",
					"members": {
						"ReportName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResponseMessage": {}
					}
				}
			},
			"DescribeReportDefinitions": {
				"input": {
					"type": "structure",
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReportDefinitions": {
							"type": "list",
							"member": {
								"shape": "Sa"
							}
						},
						"NextToken": {}
					}
				}
			},
			"PutReportDefinition": {
				"input": {
					"type": "structure",
					"required": [
						"ReportDefinition"
					],
					"members": {
						"ReportDefinition": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"Sa": {
				"type": "structure",
				"required": [
					"ReportName",
					"TimeUnit",
					"Format",
					"Compression",
					"AdditionalSchemaElements",
					"S3Bucket",
					"S3Prefix",
					"S3Region"
				],
				"members": {
					"ReportName": {},
					"TimeUnit": {},
					"Format": {},
					"Compression": {},
					"AdditionalSchemaElements": {
						"type": "list",
						"member": {}
					},
					"S3Bucket": {},
					"S3Prefix": {},
					"S3Region": {},
					"AdditionalArtifacts": {
						"type": "list",
						"member": {}
					}
				}
			}
		}
	};

/***/ },
/* 665 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeReportDefinitions": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults"
			}
		}
	};

/***/ },
/* 666 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-06-23",
			"endpointPrefix": "devicefarm",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Device Farm",
			"signatureVersion": "v4",
			"targetPrefix": "DeviceFarm_20150623",
			"uid": "devicefarm-2015-06-23"
		},
		"operations": {
			"CreateDevicePool": {
				"input": {
					"type": "structure",
					"required": [
						"projectArn",
						"name",
						"rules"
					],
					"members": {
						"projectArn": {},
						"name": {},
						"description": {},
						"rules": {
							"shape": "S5"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devicePool": {
							"shape": "Sb"
						}
					}
				}
			},
			"CreateProject": {
				"input": {
					"type": "structure",
					"required": [
						"name"
					],
					"members": {
						"name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"project": {
							"shape": "Sf"
						}
					}
				}
			},
			"CreateRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"projectArn",
						"deviceArn"
					],
					"members": {
						"projectArn": {},
						"deviceArn": {},
						"name": {},
						"configuration": {
							"type": "structure",
							"members": {
								"billingMethod": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"remoteAccessSession": {
							"shape": "Sl"
						}
					}
				}
			},
			"CreateUpload": {
				"input": {
					"type": "structure",
					"required": [
						"projectArn",
						"name",
						"type"
					],
					"members": {
						"projectArn": {},
						"name": {},
						"type": {},
						"contentType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"upload": {
							"shape": "S12"
						}
					}
				}
			},
			"DeleteDevicePool": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteProject": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteRun": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteUpload": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"GetAccountSettings": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"accountSettings": {
							"type": "structure",
							"members": {
								"awsAccountNumber": {},
								"unmeteredDevices": {
									"shape": "S1k"
								},
								"unmeteredRemoteAccessDevices": {
									"shape": "S1k"
								}
							}
						}
					}
				}
			},
			"GetDevice": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"device": {
							"shape": "So"
						}
					}
				}
			},
			"GetDevicePool": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devicePool": {
							"shape": "Sb"
						}
					}
				}
			},
			"GetDevicePoolCompatibility": {
				"input": {
					"type": "structure",
					"required": [
						"devicePoolArn"
					],
					"members": {
						"devicePoolArn": {},
						"appArn": {},
						"testType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"compatibleDevices": {
							"shape": "S1s"
						},
						"incompatibleDevices": {
							"shape": "S1s"
						}
					}
				}
			},
			"GetJob": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"job": {
							"shape": "S1y"
						}
					}
				}
			},
			"GetOfferingStatus": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"current": {
							"shape": "S23"
						},
						"nextPeriod": {
							"shape": "S23"
						},
						"nextToken": {}
					}
				}
			},
			"GetProject": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"project": {
							"shape": "Sf"
						}
					}
				}
			},
			"GetRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"remoteAccessSession": {
							"shape": "Sl"
						}
					}
				}
			},
			"GetRun": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"run": {
							"shape": "S2k"
						}
					}
				}
			},
			"GetSuite": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"suite": {
							"shape": "S2n"
						}
					}
				}
			},
			"GetTest": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"test": {
							"shape": "S2q"
						}
					}
				}
			},
			"GetUpload": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"upload": {
							"shape": "S12"
						}
					}
				}
			},
			"InstallToRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"remoteAccessSessionArn",
						"appArn"
					],
					"members": {
						"remoteAccessSessionArn": {},
						"appArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"appUpload": {
							"shape": "S12"
						}
					}
				}
			},
			"ListArtifacts": {
				"input": {
					"type": "structure",
					"required": [
						"arn",
						"type"
					],
					"members": {
						"arn": {},
						"type": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"artifacts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"arn": {},
									"name": {},
									"type": {},
									"extension": {},
									"url": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListDevicePools": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"type": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devicePools": {
							"type": "list",
							"member": {
								"shape": "Sb"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListDevices": {
				"input": {
					"type": "structure",
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devices": {
							"type": "list",
							"member": {
								"shape": "So"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListJobs": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"jobs": {
							"type": "list",
							"member": {
								"shape": "S1y"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListOfferingTransactions": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"offeringTransactions": {
							"type": "list",
							"member": {
								"shape": "S3d"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"offerings": {
							"type": "list",
							"member": {
								"shape": "S27"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListProjects": {
				"input": {
					"type": "structure",
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"projects": {
							"type": "list",
							"member": {
								"shape": "Sf"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListRemoteAccessSessions": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"remoteAccessSessions": {
							"type": "list",
							"member": {
								"shape": "Sl"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListRuns": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"runs": {
							"type": "list",
							"member": {
								"shape": "S2k"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListSamples": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"samples": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"arn": {},
									"type": {},
									"url": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListSuites": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"suites": {
							"type": "list",
							"member": {
								"shape": "S2n"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListTests": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tests": {
							"type": "list",
							"member": {
								"shape": "S2q"
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListUniqueProblems": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"uniqueProblems": {
							"type": "map",
							"key": {},
							"value": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"message": {},
										"problems": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"run": {
														"shape": "S49"
													},
													"job": {
														"shape": "S49"
													},
													"suite": {
														"shape": "S49"
													},
													"test": {
														"shape": "S49"
													},
													"device": {
														"shape": "So"
													},
													"result": {},
													"message": {}
												}
											}
										}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListUploads": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"nextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"uploads": {
							"type": "list",
							"member": {
								"shape": "S12"
							}
						},
						"nextToken": {}
					}
				}
			},
			"PurchaseOffering": {
				"input": {
					"type": "structure",
					"members": {
						"offeringId": {},
						"quantity": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"offeringTransaction": {
							"shape": "S3d"
						}
					}
				}
			},
			"RenewOffering": {
				"input": {
					"type": "structure",
					"members": {
						"offeringId": {},
						"quantity": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"offeringTransaction": {
							"shape": "S3d"
						}
					}
				}
			},
			"ScheduleRun": {
				"input": {
					"type": "structure",
					"required": [
						"projectArn",
						"devicePoolArn",
						"test"
					],
					"members": {
						"projectArn": {},
						"appArn": {},
						"devicePoolArn": {},
						"name": {},
						"test": {
							"type": "structure",
							"required": [
								"type"
							],
							"members": {
								"type": {},
								"testPackageArn": {},
								"filter": {},
								"parameters": {
									"type": "map",
									"key": {},
									"value": {}
								}
							}
						},
						"configuration": {
							"type": "structure",
							"members": {
								"extraDataPackageArn": {},
								"networkProfileArn": {},
								"locale": {},
								"location": {
									"type": "structure",
									"required": [
										"latitude",
										"longitude"
									],
									"members": {
										"latitude": {
											"type": "double"
										},
										"longitude": {
											"type": "double"
										}
									}
								},
								"radios": {
									"type": "structure",
									"members": {
										"wifi": {
											"type": "boolean"
										},
										"bluetooth": {
											"type": "boolean"
										},
										"nfc": {
											"type": "boolean"
										},
										"gps": {
											"type": "boolean"
										}
									}
								},
								"auxiliaryApps": {
									"type": "list",
									"member": {}
								},
								"billingMethod": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"run": {
							"shape": "S2k"
						}
					}
				}
			},
			"StopRemoteAccessSession": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"remoteAccessSession": {
							"shape": "Sl"
						}
					}
				}
			},
			"StopRun": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"run": {
							"shape": "S2k"
						}
					}
				}
			},
			"UpdateDevicePool": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"name": {},
						"description": {},
						"rules": {
							"shape": "S5"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"devicePool": {
							"shape": "Sb"
						}
					}
				}
			},
			"UpdateProject": {
				"input": {
					"type": "structure",
					"required": [
						"arn"
					],
					"members": {
						"arn": {},
						"name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"project": {
							"shape": "Sf"
						}
					}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"attribute": {},
						"operator": {},
						"value": {}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"description": {},
					"type": {},
					"rules": {
						"shape": "S5"
					}
				}
			},
			"Sf": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"created": {
						"type": "timestamp"
					}
				}
			},
			"Sl": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"message": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"device": {
						"shape": "So"
					},
					"billingMethod": {},
					"deviceMinutes": {
						"shape": "Sx"
					},
					"endpoint": {}
				}
			},
			"So": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"manufacturer": {},
					"model": {},
					"formFactor": {},
					"platform": {},
					"os": {},
					"cpu": {
						"type": "structure",
						"members": {
							"frequency": {},
							"architecture": {},
							"clock": {
								"type": "double"
							}
						}
					},
					"resolution": {
						"type": "structure",
						"members": {
							"width": {
								"type": "integer"
							},
							"height": {
								"type": "integer"
							}
						}
					},
					"heapSize": {
						"type": "long"
					},
					"memory": {
						"type": "long"
					},
					"image": {},
					"carrier": {},
					"radio": {},
					"remoteAccessEnabled": {
						"type": "boolean"
					},
					"fleetType": {},
					"fleetName": {}
				}
			},
			"Sx": {
				"type": "structure",
				"members": {
					"total": {
						"type": "double"
					},
					"metered": {
						"type": "double"
					},
					"unmetered": {
						"type": "double"
					}
				}
			},
			"S12": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"created": {
						"type": "timestamp"
					},
					"type": {},
					"status": {},
					"url": {},
					"metadata": {},
					"contentType": {},
					"message": {}
				}
			},
			"S1k": {
				"type": "map",
				"key": {},
				"value": {
					"type": "integer"
				}
			},
			"S1s": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"device": {
							"shape": "So"
						},
						"compatible": {
							"type": "boolean"
						},
						"incompatibilityMessages": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"message": {},
									"type": {}
								}
							}
						}
					}
				}
			},
			"S1y": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"type": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"counters": {
						"shape": "S1z"
					},
					"message": {},
					"device": {
						"shape": "So"
					},
					"deviceMinutes": {
						"shape": "Sx"
					}
				}
			},
			"S1z": {
				"type": "structure",
				"members": {
					"total": {
						"type": "integer"
					},
					"passed": {
						"type": "integer"
					},
					"failed": {
						"type": "integer"
					},
					"warned": {
						"type": "integer"
					},
					"errored": {
						"type": "integer"
					},
					"stopped": {
						"type": "integer"
					},
					"skipped": {
						"type": "integer"
					}
				}
			},
			"S23": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S25"
				}
			},
			"S25": {
				"type": "structure",
				"members": {
					"type": {},
					"offering": {
						"shape": "S27"
					},
					"quantity": {
						"type": "integer"
					},
					"effectiveOn": {
						"type": "timestamp"
					}
				}
			},
			"S27": {
				"type": "structure",
				"members": {
					"id": {},
					"description": {},
					"type": {},
					"platform": {},
					"recurringCharges": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"cost": {
									"shape": "S2b"
								},
								"frequency": {}
							}
						}
					}
				}
			},
			"S2b": {
				"type": "structure",
				"members": {
					"amount": {
						"type": "double"
					},
					"currencyCode": {}
				}
			},
			"S2k": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"type": {},
					"platform": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"counters": {
						"shape": "S1z"
					},
					"message": {},
					"totalJobs": {
						"type": "integer"
					},
					"completedJobs": {
						"type": "integer"
					},
					"billingMethod": {},
					"deviceMinutes": {
						"shape": "Sx"
					}
				}
			},
			"S2n": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"type": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"counters": {
						"shape": "S1z"
					},
					"message": {},
					"deviceMinutes": {
						"shape": "Sx"
					}
				}
			},
			"S2q": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {},
					"type": {},
					"created": {
						"type": "timestamp"
					},
					"status": {},
					"result": {},
					"started": {
						"type": "timestamp"
					},
					"stopped": {
						"type": "timestamp"
					},
					"counters": {
						"shape": "S1z"
					},
					"message": {},
					"deviceMinutes": {
						"shape": "Sx"
					}
				}
			},
			"S3d": {
				"type": "structure",
				"members": {
					"offeringStatus": {
						"shape": "S25"
					},
					"transactionId": {},
					"createdOn": {
						"type": "timestamp"
					},
					"cost": {
						"shape": "S2b"
					}
				}
			},
			"S49": {
				"type": "structure",
				"members": {
					"arn": {},
					"name": {}
				}
			}
		}
	};

/***/ },
/* 667 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"GetOfferingStatus": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": [
					"current",
					"nextPeriod"
				]
			},
			"ListArtifacts": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "artifacts"
			},
			"ListDevicePools": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "devicePools"
			},
			"ListDevices": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "devices"
			},
			"ListJobs": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "jobs"
			},
			"ListOfferingTransactions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "offeringTransactions"
			},
			"ListOfferings": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "offerings"
			},
			"ListProjects": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "projects"
			},
			"ListRuns": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "runs"
			},
			"ListSamples": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "samples"
			},
			"ListSuites": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "suites"
			},
			"ListTests": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "tests"
			},
			"ListUniqueProblems": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "uniqueProblems"
			},
			"ListUploads": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"result_key": "uploads"
			}
		}
	};

/***/ },
/* 668 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-10-25",
			"endpointPrefix": "directconnect",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Direct Connect",
			"signatureVersion": "v4",
			"targetPrefix": "OvertureService",
			"uid": "directconnect-2012-10-25"
		},
		"operations": {
			"AllocateConnectionOnInterconnect": {
				"input": {
					"type": "structure",
					"required": [
						"bandwidth",
						"connectionName",
						"ownerAccount",
						"interconnectId",
						"vlan"
					],
					"members": {
						"bandwidth": {},
						"connectionName": {},
						"ownerAccount": {},
						"interconnectId": {},
						"vlan": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"AllocatePrivateVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"ownerAccount",
						"newPrivateVirtualInterfaceAllocation"
					],
					"members": {
						"connectionId": {},
						"ownerAccount": {},
						"newPrivateVirtualInterfaceAllocation": {
							"type": "structure",
							"required": [
								"virtualInterfaceName",
								"vlan",
								"asn"
							],
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"addressFamily": {},
								"customerAddress": {}
							}
						}
					}
				},
				"output": {
					"shape": "Sm"
				}
			},
			"AllocatePublicVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"ownerAccount",
						"newPublicVirtualInterfaceAllocation"
					],
					"members": {
						"connectionId": {},
						"ownerAccount": {},
						"newPublicVirtualInterfaceAllocation": {
							"type": "structure",
							"required": [
								"virtualInterfaceName",
								"vlan",
								"asn"
							],
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"customerAddress": {},
								"addressFamily": {},
								"routeFilterPrefixes": {
									"shape": "Ss"
								}
							}
						}
					}
				},
				"output": {
					"shape": "Sm"
				}
			},
			"ConfirmConnection": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId"
					],
					"members": {
						"connectionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"connectionState": {}
					}
				}
			},
			"ConfirmPrivateVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"virtualInterfaceId",
						"virtualGatewayId"
					],
					"members": {
						"virtualInterfaceId": {},
						"virtualGatewayId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterfaceState": {}
					}
				}
			},
			"ConfirmPublicVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"virtualInterfaceId"
					],
					"members": {
						"virtualInterfaceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterfaceState": {}
					}
				}
			},
			"CreateBGPPeer": {
				"input": {
					"type": "structure",
					"members": {
						"virtualInterfaceId": {},
						"newBGPPeer": {
							"type": "structure",
							"members": {
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"addressFamily": {},
								"amazonAddress": {},
								"customerAddress": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterface": {
							"shape": "Sm"
						}
					}
				}
			},
			"CreateConnection": {
				"input": {
					"type": "structure",
					"required": [
						"location",
						"bandwidth",
						"connectionName"
					],
					"members": {
						"location": {},
						"bandwidth": {},
						"connectionName": {}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"CreateInterconnect": {
				"input": {
					"type": "structure",
					"required": [
						"interconnectName",
						"bandwidth",
						"location"
					],
					"members": {
						"interconnectName": {},
						"bandwidth": {},
						"location": {}
					}
				},
				"output": {
					"shape": "S1d"
				}
			},
			"CreatePrivateVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"newPrivateVirtualInterface"
					],
					"members": {
						"connectionId": {},
						"newPrivateVirtualInterface": {
							"type": "structure",
							"required": [
								"virtualInterfaceName",
								"vlan",
								"asn",
								"virtualGatewayId"
							],
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"customerAddress": {},
								"addressFamily": {},
								"virtualGatewayId": {}
							}
						}
					}
				},
				"output": {
					"shape": "Sm"
				}
			},
			"CreatePublicVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId",
						"newPublicVirtualInterface"
					],
					"members": {
						"connectionId": {},
						"newPublicVirtualInterface": {
							"type": "structure",
							"required": [
								"virtualInterfaceName",
								"vlan",
								"asn"
							],
							"members": {
								"virtualInterfaceName": {},
								"vlan": {
									"type": "integer"
								},
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"amazonAddress": {},
								"customerAddress": {},
								"addressFamily": {},
								"routeFilterPrefixes": {
									"shape": "Ss"
								}
							}
						}
					}
				},
				"output": {
					"shape": "Sm"
				}
			},
			"DeleteBGPPeer": {
				"input": {
					"type": "structure",
					"members": {
						"virtualInterfaceId": {},
						"asn": {
							"type": "integer"
						},
						"customerAddress": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterface": {
							"shape": "Sm"
						}
					}
				}
			},
			"DeleteConnection": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId"
					],
					"members": {
						"connectionId": {}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"DeleteInterconnect": {
				"input": {
					"type": "structure",
					"required": [
						"interconnectId"
					],
					"members": {
						"interconnectId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"interconnectState": {}
					}
				}
			},
			"DeleteVirtualInterface": {
				"input": {
					"type": "structure",
					"required": [
						"virtualInterfaceId"
					],
					"members": {
						"virtualInterfaceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterfaceState": {}
					}
				}
			},
			"DescribeConnectionLoa": {
				"input": {
					"type": "structure",
					"required": [
						"connectionId"
					],
					"members": {
						"connectionId": {},
						"providerName": {},
						"loaContentType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"loa": {
							"shape": "S1u"
						}
					}
				}
			},
			"DescribeConnections": {
				"input": {
					"type": "structure",
					"members": {
						"connectionId": {}
					}
				},
				"output": {
					"shape": "S1x"
				}
			},
			"DescribeConnectionsOnInterconnect": {
				"input": {
					"type": "structure",
					"required": [
						"interconnectId"
					],
					"members": {
						"interconnectId": {}
					}
				},
				"output": {
					"shape": "S1x"
				}
			},
			"DescribeInterconnectLoa": {
				"input": {
					"type": "structure",
					"required": [
						"interconnectId"
					],
					"members": {
						"interconnectId": {},
						"providerName": {},
						"loaContentType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"loa": {
							"shape": "S1u"
						}
					}
				}
			},
			"DescribeInterconnects": {
				"input": {
					"type": "structure",
					"members": {
						"interconnectId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"interconnects": {
							"type": "list",
							"member": {
								"shape": "S1d"
							}
						}
					}
				}
			},
			"DescribeLocations": {
				"output": {
					"type": "structure",
					"members": {
						"locations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"locationCode": {},
									"locationName": {}
								}
							}
						}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArns"
					],
					"members": {
						"resourceArns": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"resourceTags": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"resourceArn": {},
									"tags": {
										"shape": "S2f"
									}
								}
							}
						}
					}
				}
			},
			"DescribeVirtualGateways": {
				"output": {
					"type": "structure",
					"members": {
						"virtualGateways": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"virtualGatewayId": {},
									"virtualGatewayState": {}
								}
							}
						}
					}
				}
			},
			"DescribeVirtualInterfaces": {
				"input": {
					"type": "structure",
					"members": {
						"connectionId": {},
						"virtualInterfaceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"virtualInterfaces": {
							"type": "list",
							"member": {
								"shape": "Sm"
							}
						}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tags"
					],
					"members": {
						"resourceArn": {},
						"tags": {
							"shape": "S2f"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"tagKeys"
					],
					"members": {
						"resourceArn": {},
						"tagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S7": {
				"type": "structure",
				"members": {
					"ownerAccount": {},
					"connectionId": {},
					"connectionName": {},
					"connectionState": {},
					"region": {},
					"location": {},
					"bandwidth": {},
					"vlan": {
						"type": "integer"
					},
					"partnerName": {},
					"loaIssueTime": {
						"type": "timestamp"
					}
				}
			},
			"Sm": {
				"type": "structure",
				"members": {
					"ownerAccount": {},
					"virtualInterfaceId": {},
					"location": {},
					"connectionId": {},
					"virtualInterfaceType": {},
					"virtualInterfaceName": {},
					"vlan": {
						"type": "integer"
					},
					"asn": {
						"type": "integer"
					},
					"authKey": {},
					"amazonAddress": {},
					"customerAddress": {},
					"addressFamily": {},
					"virtualInterfaceState": {},
					"customerRouterConfig": {},
					"virtualGatewayId": {},
					"routeFilterPrefixes": {
						"shape": "Ss"
					},
					"bgpPeers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"asn": {
									"type": "integer"
								},
								"authKey": {},
								"addressFamily": {},
								"amazonAddress": {},
								"customerAddress": {},
								"bgpPeerState": {},
								"bgpStatus": {}
							}
						}
					}
				}
			},
			"Ss": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"cidr": {}
					}
				}
			},
			"S1d": {
				"type": "structure",
				"members": {
					"interconnectId": {},
					"interconnectName": {},
					"interconnectState": {},
					"region": {},
					"location": {},
					"bandwidth": {},
					"loaIssueTime": {
						"type": "timestamp"
					}
				}
			},
			"S1u": {
				"type": "structure",
				"members": {
					"loaContent": {
						"type": "blob"
					},
					"loaContentType": {}
				}
			},
			"S1x": {
				"type": "structure",
				"members": {
					"connections": {
						"type": "list",
						"member": {
							"shape": "S7"
						}
					}
				}
			},
			"S2f": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"key"
					],
					"members": {
						"key": {},
						"value": {}
					}
				}
			}
		}
	};

/***/ },
/* 669 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeConnections": {
				"result_key": "connections"
			},
			"DescribeConnectionsOnInterconnect": {
				"result_key": "connections"
			},
			"DescribeInterconnects": {
				"result_key": "interconnects"
			},
			"DescribeLocations": {
				"result_key": "locations"
			},
			"DescribeVirtualGateways": {
				"result_key": "virtualGateways"
			},
			"DescribeVirtualInterfaces": {
				"result_key": "virtualInterfaces"
			}
		}
	};

/***/ },
/* 670 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2011-12-05",
			"endpointPrefix": "dynamodb",
			"jsonVersion": "1.0",
			"protocol": "json",
			"serviceAbbreviation": "DynamoDB",
			"serviceFullName": "Amazon DynamoDB",
			"signatureVersion": "v4",
			"targetPrefix": "DynamoDB_20111205",
			"uid": "dynamodb-2011-12-05"
		},
		"operations": {
			"BatchGetItem": {
				"input": {
					"type": "structure",
					"required": [
						"RequestItems"
					],
					"members": {
						"RequestItems": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Responses": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"Items": {
										"shape": "Sk"
									},
									"ConsumedCapacityUnits": {
										"type": "double"
									}
								}
							}
						},
						"UnprocessedKeys": {
							"shape": "S2"
						}
					}
				}
			},
			"BatchWriteItem": {
				"input": {
					"type": "structure",
					"required": [
						"RequestItems"
					],
					"members": {
						"RequestItems": {
							"shape": "So"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Responses": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"ConsumedCapacityUnits": {
										"type": "double"
									}
								}
							}
						},
						"UnprocessedItems": {
							"shape": "So"
						}
					}
				}
			},
			"CreateTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"KeySchema",
						"ProvisionedThroughput"
					],
					"members": {
						"TableName": {},
						"KeySchema": {
							"shape": "Sy"
						},
						"ProvisionedThroughput": {
							"shape": "S12"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S15"
						}
					}
				}
			},
			"DeleteItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"Expected": {
							"shape": "S1b"
						},
						"ReturnValues": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sl"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"DeleteTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S15"
						}
					}
				}
			},
			"DescribeTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Table": {
							"shape": "S15"
						}
					}
				}
			},
			"GetItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"AttributesToGet": {
							"shape": "Se"
						},
						"ConsistentRead": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Item": {
							"shape": "Sl"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"ListTables": {
				"input": {
					"type": "structure",
					"members": {
						"ExclusiveStartTableName": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableNames": {
							"type": "list",
							"member": {}
						},
						"LastEvaluatedTableName": {}
					}
				}
			},
			"PutItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Item"
					],
					"members": {
						"TableName": {},
						"Item": {
							"shape": "Ss"
						},
						"Expected": {
							"shape": "S1b"
						},
						"ReturnValues": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sl"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"Query": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"HashKeyValue"
					],
					"members": {
						"TableName": {},
						"AttributesToGet": {
							"shape": "Se"
						},
						"Limit": {
							"type": "integer"
						},
						"ConsistentRead": {
							"type": "boolean"
						},
						"Count": {
							"type": "boolean"
						},
						"HashKeyValue": {
							"shape": "S7"
						},
						"RangeKeyCondition": {
							"shape": "S1u"
						},
						"ScanIndexForward": {
							"type": "boolean"
						},
						"ExclusiveStartKey": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Items": {
							"shape": "Sk"
						},
						"Count": {
							"type": "integer"
						},
						"LastEvaluatedKey": {
							"shape": "S6"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"Scan": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {},
						"AttributesToGet": {
							"shape": "Se"
						},
						"Limit": {
							"type": "integer"
						},
						"Count": {
							"type": "boolean"
						},
						"ScanFilter": {
							"type": "map",
							"key": {},
							"value": {
								"shape": "S1u"
							}
						},
						"ExclusiveStartKey": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Items": {
							"shape": "Sk"
						},
						"Count": {
							"type": "integer"
						},
						"ScannedCount": {
							"type": "integer"
						},
						"LastEvaluatedKey": {
							"shape": "S6"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"UpdateItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key",
						"AttributeUpdates"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"AttributeUpdates": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"Value": {
										"shape": "S7"
									},
									"Action": {}
								}
							}
						},
						"Expected": {
							"shape": "S1b"
						},
						"ReturnValues": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sl"
						},
						"ConsumedCapacityUnits": {
							"type": "double"
						}
					}
				}
			},
			"UpdateTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"ProvisionedThroughput"
					],
					"members": {
						"TableName": {},
						"ProvisionedThroughput": {
							"shape": "S12"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S15"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"Keys"
					],
					"members": {
						"Keys": {
							"type": "list",
							"member": {
								"shape": "S6"
							}
						},
						"AttributesToGet": {
							"shape": "Se"
						},
						"ConsistentRead": {
							"type": "boolean"
						}
					}
				}
			},
			"S6": {
				"type": "structure",
				"required": [
					"HashKeyElement"
				],
				"members": {
					"HashKeyElement": {
						"shape": "S7"
					},
					"RangeKeyElement": {
						"shape": "S7"
					}
				}
			},
			"S7": {
				"type": "structure",
				"members": {
					"S": {},
					"N": {},
					"B": {
						"type": "blob"
					},
					"SS": {
						"type": "list",
						"member": {}
					},
					"NS": {
						"type": "list",
						"member": {}
					},
					"BS": {
						"type": "list",
						"member": {
							"type": "blob"
						}
					}
				}
			},
			"Se": {
				"type": "list",
				"member": {}
			},
			"Sk": {
				"type": "list",
				"member": {
					"shape": "Sl"
				}
			},
			"Sl": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S7"
				}
			},
			"So": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"PutRequest": {
								"type": "structure",
								"required": [
									"Item"
								],
								"members": {
									"Item": {
										"shape": "Ss"
									}
								}
							},
							"DeleteRequest": {
								"type": "structure",
								"required": [
									"Key"
								],
								"members": {
									"Key": {
										"shape": "S6"
									}
								}
							}
						}
					}
				}
			},
			"Ss": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S7"
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"HashKeyElement"
				],
				"members": {
					"HashKeyElement": {
						"shape": "Sz"
					},
					"RangeKeyElement": {
						"shape": "Sz"
					}
				}
			},
			"Sz": {
				"type": "structure",
				"required": [
					"AttributeName",
					"AttributeType"
				],
				"members": {
					"AttributeName": {},
					"AttributeType": {}
				}
			},
			"S12": {
				"type": "structure",
				"required": [
					"ReadCapacityUnits",
					"WriteCapacityUnits"
				],
				"members": {
					"ReadCapacityUnits": {
						"type": "long"
					},
					"WriteCapacityUnits": {
						"type": "long"
					}
				}
			},
			"S15": {
				"type": "structure",
				"members": {
					"TableName": {},
					"KeySchema": {
						"shape": "Sy"
					},
					"TableStatus": {},
					"CreationDateTime": {
						"type": "timestamp"
					},
					"ProvisionedThroughput": {
						"type": "structure",
						"members": {
							"LastIncreaseDateTime": {
								"type": "timestamp"
							},
							"LastDecreaseDateTime": {
								"type": "timestamp"
							},
							"NumberOfDecreasesToday": {
								"type": "long"
							},
							"ReadCapacityUnits": {
								"type": "long"
							},
							"WriteCapacityUnits": {
								"type": "long"
							}
						}
					},
					"TableSizeBytes": {
						"type": "long"
					},
					"ItemCount": {
						"type": "long"
					}
				}
			},
			"S1b": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"Value": {
							"shape": "S7"
						},
						"Exists": {
							"type": "boolean"
						}
					}
				}
			},
			"S1u": {
				"type": "structure",
				"required": [
					"ComparisonOperator"
				],
				"members": {
					"AttributeValueList": {
						"type": "list",
						"member": {
							"shape": "S7"
						}
					},
					"ComparisonOperator": {}
				}
			}
		}
	};

/***/ },
/* 671 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"BatchGetItem": {
				"input_token": "RequestItems",
				"output_token": "UnprocessedKeys"
			},
			"ListTables": {
				"input_token": "ExclusiveStartTableName",
				"limit_key": "Limit",
				"output_token": "LastEvaluatedTableName",
				"result_key": "TableNames"
			},
			"Query": {
				"input_token": "ExclusiveStartKey",
				"limit_key": "Limit",
				"output_token": "LastEvaluatedKey",
				"result_key": "Items"
			},
			"Scan": {
				"input_token": "ExclusiveStartKey",
				"limit_key": "Limit",
				"output_token": "LastEvaluatedKey",
				"result_key": "Items"
			}
		}
	};

/***/ },
/* 672 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"TableExists": {
				"delay": 20,
				"operation": "DescribeTable",
				"maxAttempts": 25,
				"acceptors": [
					{
						"expected": "ACTIVE",
						"matcher": "path",
						"state": "success",
						"argument": "Table.TableStatus"
					},
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "retry"
					}
				]
			},
			"TableNotExists": {
				"delay": 20,
				"operation": "DescribeTable",
				"maxAttempts": 25,
				"acceptors": [
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 673 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-08-10",
			"endpointPrefix": "dynamodb",
			"jsonVersion": "1.0",
			"protocol": "json",
			"serviceAbbreviation": "DynamoDB",
			"serviceFullName": "Amazon DynamoDB",
			"signatureVersion": "v4",
			"targetPrefix": "DynamoDB_20120810",
			"uid": "dynamodb-2012-08-10"
		},
		"operations": {
			"BatchGetItem": {
				"input": {
					"type": "structure",
					"required": [
						"RequestItems"
					],
					"members": {
						"RequestItems": {
							"shape": "S2"
						},
						"ReturnConsumedCapacity": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Responses": {
							"type": "map",
							"key": {},
							"value": {
								"shape": "Sr"
							}
						},
						"UnprocessedKeys": {
							"shape": "S2"
						},
						"ConsumedCapacity": {
							"shape": "St"
						}
					}
				}
			},
			"BatchWriteItem": {
				"input": {
					"type": "structure",
					"required": [
						"RequestItems"
					],
					"members": {
						"RequestItems": {
							"shape": "S10"
						},
						"ReturnConsumedCapacity": {},
						"ReturnItemCollectionMetrics": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UnprocessedItems": {
							"shape": "S10"
						},
						"ItemCollectionMetrics": {
							"type": "map",
							"key": {},
							"value": {
								"type": "list",
								"member": {
									"shape": "S1a"
								}
							}
						},
						"ConsumedCapacity": {
							"shape": "St"
						}
					}
				}
			},
			"CreateTable": {
				"input": {
					"type": "structure",
					"required": [
						"AttributeDefinitions",
						"TableName",
						"KeySchema",
						"ProvisionedThroughput"
					],
					"members": {
						"AttributeDefinitions": {
							"shape": "S1f"
						},
						"TableName": {},
						"KeySchema": {
							"shape": "S1j"
						},
						"LocalSecondaryIndexes": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"IndexName",
									"KeySchema",
									"Projection"
								],
								"members": {
									"IndexName": {},
									"KeySchema": {
										"shape": "S1j"
									},
									"Projection": {
										"shape": "S1o"
									}
								}
							}
						},
						"GlobalSecondaryIndexes": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"IndexName",
									"KeySchema",
									"Projection",
									"ProvisionedThroughput"
								],
								"members": {
									"IndexName": {},
									"KeySchema": {
										"shape": "S1j"
									},
									"Projection": {
										"shape": "S1o"
									},
									"ProvisionedThroughput": {
										"shape": "S1u"
									}
								}
							}
						},
						"ProvisionedThroughput": {
							"shape": "S1u"
						},
						"StreamSpecification": {
							"shape": "S1w"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S20"
						}
					}
				}
			},
			"DeleteItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"Expected": {
							"shape": "S2e"
						},
						"ConditionalOperator": {},
						"ReturnValues": {},
						"ReturnConsumedCapacity": {},
						"ReturnItemCollectionMetrics": {},
						"ConditionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S2m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Ss"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						},
						"ItemCollectionMetrics": {
							"shape": "S1a"
						}
					}
				}
			},
			"DeleteTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S20"
						}
					}
				}
			},
			"DescribeLimits": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountMaxReadCapacityUnits": {
							"type": "long"
						},
						"AccountMaxWriteCapacityUnits": {
							"type": "long"
						},
						"TableMaxReadCapacityUnits": {
							"type": "long"
						},
						"TableMaxWriteCapacityUnits": {
							"type": "long"
						}
					}
				}
			},
			"DescribeTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Table": {
							"shape": "S20"
						}
					}
				}
			},
			"GetItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"AttributesToGet": {
							"shape": "Sj"
						},
						"ConsistentRead": {
							"type": "boolean"
						},
						"ReturnConsumedCapacity": {},
						"ProjectionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Item": {
							"shape": "Ss"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						}
					}
				}
			},
			"ListTables": {
				"input": {
					"type": "structure",
					"members": {
						"ExclusiveStartTableName": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableNames": {
							"type": "list",
							"member": {}
						},
						"LastEvaluatedTableName": {}
					}
				}
			},
			"ListTagsOfResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn"
					],
					"members": {
						"ResourceArn": {},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "S35"
						},
						"NextToken": {}
					}
				}
			},
			"PutItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Item"
					],
					"members": {
						"TableName": {},
						"Item": {
							"shape": "S14"
						},
						"Expected": {
							"shape": "S2e"
						},
						"ReturnValues": {},
						"ReturnConsumedCapacity": {},
						"ReturnItemCollectionMetrics": {},
						"ConditionalOperator": {},
						"ConditionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S2m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Ss"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						},
						"ItemCollectionMetrics": {
							"shape": "S1a"
						}
					}
				}
			},
			"Query": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {},
						"IndexName": {},
						"Select": {},
						"AttributesToGet": {
							"shape": "Sj"
						},
						"Limit": {
							"type": "integer"
						},
						"ConsistentRead": {
							"type": "boolean"
						},
						"KeyConditions": {
							"type": "map",
							"key": {},
							"value": {
								"shape": "S3f"
							}
						},
						"QueryFilter": {
							"shape": "S3g"
						},
						"ConditionalOperator": {},
						"ScanIndexForward": {
							"type": "boolean"
						},
						"ExclusiveStartKey": {
							"shape": "S6"
						},
						"ReturnConsumedCapacity": {},
						"ProjectionExpression": {},
						"FilterExpression": {},
						"KeyConditionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S2m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Items": {
							"shape": "Sr"
						},
						"Count": {
							"type": "integer"
						},
						"ScannedCount": {
							"type": "integer"
						},
						"LastEvaluatedKey": {
							"shape": "S6"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						}
					}
				}
			},
			"Scan": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"TableName": {},
						"IndexName": {},
						"AttributesToGet": {
							"shape": "Sj"
						},
						"Limit": {
							"type": "integer"
						},
						"Select": {},
						"ScanFilter": {
							"shape": "S3g"
						},
						"ConditionalOperator": {},
						"ExclusiveStartKey": {
							"shape": "S6"
						},
						"ReturnConsumedCapacity": {},
						"TotalSegments": {
							"type": "integer"
						},
						"Segment": {
							"type": "integer"
						},
						"ProjectionExpression": {},
						"FilterExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S2m"
						},
						"ConsistentRead": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Items": {
							"shape": "Sr"
						},
						"Count": {
							"type": "integer"
						},
						"ScannedCount": {
							"type": "integer"
						},
						"LastEvaluatedKey": {
							"shape": "S6"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"Tags"
					],
					"members": {
						"ResourceArn": {},
						"Tags": {
							"shape": "S35"
						}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArn",
						"TagKeys"
					],
					"members": {
						"ResourceArn": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"UpdateItem": {
				"input": {
					"type": "structure",
					"required": [
						"TableName",
						"Key"
					],
					"members": {
						"TableName": {},
						"Key": {
							"shape": "S6"
						},
						"AttributeUpdates": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"members": {
									"Value": {
										"shape": "S8"
									},
									"Action": {}
								}
							}
						},
						"Expected": {
							"shape": "S2e"
						},
						"ConditionalOperator": {},
						"ReturnValues": {},
						"ReturnConsumedCapacity": {},
						"ReturnItemCollectionMetrics": {},
						"UpdateExpression": {},
						"ConditionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						},
						"ExpressionAttributeValues": {
							"shape": "S2m"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Ss"
						},
						"ConsumedCapacity": {
							"shape": "Su"
						},
						"ItemCollectionMetrics": {
							"shape": "S1a"
						}
					}
				}
			},
			"UpdateTable": {
				"input": {
					"type": "structure",
					"required": [
						"TableName"
					],
					"members": {
						"AttributeDefinitions": {
							"shape": "S1f"
						},
						"TableName": {},
						"ProvisionedThroughput": {
							"shape": "S1u"
						},
						"GlobalSecondaryIndexUpdates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Update": {
										"type": "structure",
										"required": [
											"IndexName",
											"ProvisionedThroughput"
										],
										"members": {
											"IndexName": {},
											"ProvisionedThroughput": {
												"shape": "S1u"
											}
										}
									},
									"Create": {
										"type": "structure",
										"required": [
											"IndexName",
											"KeySchema",
											"Projection",
											"ProvisionedThroughput"
										],
										"members": {
											"IndexName": {},
											"KeySchema": {
												"shape": "S1j"
											},
											"Projection": {
												"shape": "S1o"
											},
											"ProvisionedThroughput": {
												"shape": "S1u"
											}
										}
									},
									"Delete": {
										"type": "structure",
										"required": [
											"IndexName"
										],
										"members": {
											"IndexName": {}
										}
									}
								}
							}
						},
						"StreamSpecification": {
							"shape": "S1w"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TableDescription": {
							"shape": "S20"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"Keys"
					],
					"members": {
						"Keys": {
							"type": "list",
							"member": {
								"shape": "S6"
							}
						},
						"AttributesToGet": {
							"shape": "Sj"
						},
						"ConsistentRead": {
							"type": "boolean"
						},
						"ProjectionExpression": {},
						"ExpressionAttributeNames": {
							"shape": "Sm"
						}
					}
				}
			},
			"S6": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S8"
				}
			},
			"S8": {
				"type": "structure",
				"members": {
					"S": {},
					"N": {},
					"B": {
						"type": "blob"
					},
					"SS": {
						"type": "list",
						"member": {}
					},
					"NS": {
						"type": "list",
						"member": {}
					},
					"BS": {
						"type": "list",
						"member": {
							"type": "blob"
						}
					},
					"M": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S8"
						}
					},
					"L": {
						"type": "list",
						"member": {
							"shape": "S8"
						}
					},
					"NULL": {
						"type": "boolean"
					},
					"BOOL": {
						"type": "boolean"
					}
				}
			},
			"Sj": {
				"type": "list",
				"member": {}
			},
			"Sm": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sr": {
				"type": "list",
				"member": {
					"shape": "Ss"
				}
			},
			"Ss": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S8"
				}
			},
			"St": {
				"type": "list",
				"member": {
					"shape": "Su"
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"TableName": {},
					"CapacityUnits": {
						"type": "double"
					},
					"Table": {
						"shape": "Sw"
					},
					"LocalSecondaryIndexes": {
						"shape": "Sx"
					},
					"GlobalSecondaryIndexes": {
						"shape": "Sx"
					}
				}
			},
			"Sw": {
				"type": "structure",
				"members": {
					"CapacityUnits": {
						"type": "double"
					}
				}
			},
			"Sx": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "Sw"
				}
			},
			"S10": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {
						"type": "structure",
						"members": {
							"PutRequest": {
								"type": "structure",
								"required": [
									"Item"
								],
								"members": {
									"Item": {
										"shape": "S14"
									}
								}
							},
							"DeleteRequest": {
								"type": "structure",
								"required": [
									"Key"
								],
								"members": {
									"Key": {
										"shape": "S6"
									}
								}
							}
						}
					}
				}
			},
			"S14": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S8"
				}
			},
			"S1a": {
				"type": "structure",
				"members": {
					"ItemCollectionKey": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S8"
						}
					},
					"SizeEstimateRangeGB": {
						"type": "list",
						"member": {
							"type": "double"
						}
					}
				}
			},
			"S1f": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"AttributeName",
						"AttributeType"
					],
					"members": {
						"AttributeName": {},
						"AttributeType": {}
					}
				}
			},
			"S1j": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"AttributeName",
						"KeyType"
					],
					"members": {
						"AttributeName": {},
						"KeyType": {}
					}
				}
			},
			"S1o": {
				"type": "structure",
				"members": {
					"ProjectionType": {},
					"NonKeyAttributes": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S1u": {
				"type": "structure",
				"required": [
					"ReadCapacityUnits",
					"WriteCapacityUnits"
				],
				"members": {
					"ReadCapacityUnits": {
						"type": "long"
					},
					"WriteCapacityUnits": {
						"type": "long"
					}
				}
			},
			"S1w": {
				"type": "structure",
				"members": {
					"StreamEnabled": {
						"type": "boolean"
					},
					"StreamViewType": {}
				}
			},
			"S20": {
				"type": "structure",
				"members": {
					"AttributeDefinitions": {
						"shape": "S1f"
					},
					"TableName": {},
					"KeySchema": {
						"shape": "S1j"
					},
					"TableStatus": {},
					"CreationDateTime": {
						"type": "timestamp"
					},
					"ProvisionedThroughput": {
						"shape": "S23"
					},
					"TableSizeBytes": {
						"type": "long"
					},
					"ItemCount": {
						"type": "long"
					},
					"TableArn": {},
					"LocalSecondaryIndexes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IndexName": {},
								"KeySchema": {
									"shape": "S1j"
								},
								"Projection": {
									"shape": "S1o"
								},
								"IndexSizeBytes": {
									"type": "long"
								},
								"ItemCount": {
									"type": "long"
								},
								"IndexArn": {}
							}
						}
					},
					"GlobalSecondaryIndexes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"IndexName": {},
								"KeySchema": {
									"shape": "S1j"
								},
								"Projection": {
									"shape": "S1o"
								},
								"IndexStatus": {},
								"Backfilling": {
									"type": "boolean"
								},
								"ProvisionedThroughput": {
									"shape": "S23"
								},
								"IndexSizeBytes": {
									"type": "long"
								},
								"ItemCount": {
									"type": "long"
								},
								"IndexArn": {}
							}
						}
					},
					"StreamSpecification": {
						"shape": "S1w"
					},
					"LatestStreamLabel": {},
					"LatestStreamArn": {}
				}
			},
			"S23": {
				"type": "structure",
				"members": {
					"LastIncreaseDateTime": {
						"type": "timestamp"
					},
					"LastDecreaseDateTime": {
						"type": "timestamp"
					},
					"NumberOfDecreasesToday": {
						"type": "long"
					},
					"ReadCapacityUnits": {
						"type": "long"
					},
					"WriteCapacityUnits": {
						"type": "long"
					}
				}
			},
			"S2e": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"Value": {
							"shape": "S8"
						},
						"Exists": {
							"type": "boolean"
						},
						"ComparisonOperator": {},
						"AttributeValueList": {
							"shape": "S2i"
						}
					}
				}
			},
			"S2i": {
				"type": "list",
				"member": {
					"shape": "S8"
				}
			},
			"S2m": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S8"
				}
			},
			"S35": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S3f": {
				"type": "structure",
				"required": [
					"ComparisonOperator"
				],
				"members": {
					"AttributeValueList": {
						"shape": "S2i"
					},
					"ComparisonOperator": {}
				}
			},
			"S3g": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "S3f"
				}
			}
		}
	};

/***/ },
/* 674 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"BatchGetItem": {
				"input_token": "RequestItems",
				"output_token": "UnprocessedKeys"
			},
			"ListTables": {
				"input_token": "ExclusiveStartTableName",
				"limit_key": "Limit",
				"output_token": "LastEvaluatedTableName",
				"result_key": "TableNames"
			},
			"Query": {
				"input_token": "ExclusiveStartKey",
				"limit_key": "Limit",
				"output_token": "LastEvaluatedKey",
				"result_key": "Items"
			},
			"Scan": {
				"input_token": "ExclusiveStartKey",
				"limit_key": "Limit",
				"output_token": "LastEvaluatedKey",
				"result_key": "Items"
			}
		}
	};

/***/ },
/* 675 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"TableExists": {
				"delay": 20,
				"operation": "DescribeTable",
				"maxAttempts": 25,
				"acceptors": [
					{
						"expected": "ACTIVE",
						"matcher": "path",
						"state": "success",
						"argument": "Table.TableStatus"
					},
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "retry"
					}
				]
			},
			"TableNotExists": {
				"delay": 20,
				"operation": "DescribeTable",
				"maxAttempts": 25,
				"acceptors": [
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 676 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-11-15",
			"endpointPrefix": "ec2",
			"protocol": "ec2",
			"serviceAbbreviation": "Amazon EC2",
			"serviceFullName": "Amazon Elastic Compute Cloud",
			"signatureVersion": "v4",
			"uid": "ec2-2016-11-15",
			"xmlNamespace": "http://ec2.amazonaws.com/doc/2016-11-15"
		},
		"operations": {
			"AcceptReservedInstancesExchangeQuote": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstanceIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ReservedInstanceIds": {
							"shape": "S3",
							"locationName": "ReservedInstanceId"
						},
						"TargetConfigurations": {
							"shape": "S5",
							"locationName": "TargetConfiguration"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ExchangeId": {
							"locationName": "exchangeId"
						}
					}
				}
			},
			"AcceptVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcPeeringConnection": {
							"shape": "Sb",
							"locationName": "vpcPeeringConnection"
						}
					}
				}
			},
			"AllocateAddress": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Domain": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PublicIp": {
							"locationName": "publicIp"
						},
						"Domain": {
							"locationName": "domain"
						},
						"AllocationId": {
							"locationName": "allocationId"
						}
					}
				}
			},
			"AllocateHosts": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceType",
						"Quantity",
						"AvailabilityZone"
					],
					"members": {
						"AutoPlacement": {
							"locationName": "autoPlacement"
						},
						"ClientToken": {
							"locationName": "clientToken"
						},
						"InstanceType": {
							"locationName": "instanceType"
						},
						"Quantity": {
							"locationName": "quantity",
							"type": "integer"
						},
						"AvailabilityZone": {
							"locationName": "availabilityZone"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HostIds": {
							"shape": "Sr",
							"locationName": "hostIdSet"
						}
					}
				}
			},
			"AssignIpv6Addresses": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"Ipv6Addresses": {
							"shape": "St",
							"locationName": "ipv6Addresses"
						},
						"Ipv6AddressCount": {
							"locationName": "ipv6AddressCount",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"AssignedIpv6Addresses": {
							"shape": "St",
							"locationName": "assignedIpv6Addresses"
						}
					}
				}
			},
			"AssignPrivateIpAddresses": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"PrivateIpAddresses": {
							"shape": "Sw",
							"locationName": "privateIpAddress"
						},
						"SecondaryPrivateIpAddressCount": {
							"locationName": "secondaryPrivateIpAddressCount",
							"type": "integer"
						},
						"AllowReassignment": {
							"locationName": "allowReassignment",
							"type": "boolean"
						}
					}
				}
			},
			"AssociateAddress": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {},
						"PublicIp": {},
						"AllocationId": {},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						},
						"AllowReassociation": {
							"locationName": "allowReassociation",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						}
					}
				}
			},
			"AssociateDhcpOptions": {
				"input": {
					"type": "structure",
					"required": [
						"DhcpOptionsId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"DhcpOptionsId": {},
						"VpcId": {}
					}
				}
			},
			"AssociateIamInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"IamInstanceProfile",
						"InstanceId"
					],
					"members": {
						"IamInstanceProfile": {
							"shape": "S11"
						},
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamInstanceProfileAssociation": {
							"shape": "S13",
							"locationName": "iamInstanceProfileAssociation"
						}
					}
				}
			},
			"AssociateRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId",
						"RouteTableId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SubnetId": {
							"locationName": "subnetId"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						}
					}
				}
			},
			"AssociateSubnetCidrBlock": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId",
						"Ipv6CidrBlock"
					],
					"members": {
						"SubnetId": {
							"locationName": "subnetId"
						},
						"Ipv6CidrBlock": {
							"locationName": "ipv6CidrBlock"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SubnetId": {
							"locationName": "subnetId"
						},
						"Ipv6CidrBlockAssociation": {
							"shape": "S1a",
							"locationName": "ipv6CidrBlockAssociation"
						}
					}
				}
			},
			"AssociateVpcCidrBlock": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"VpcId": {
							"locationName": "vpcId"
						},
						"AmazonProvidedIpv6CidrBlock": {
							"locationName": "amazonProvidedIpv6CidrBlock",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcId": {
							"locationName": "vpcId"
						},
						"Ipv6CidrBlockAssociation": {
							"shape": "S1f",
							"locationName": "ipv6CidrBlockAssociation"
						}
					}
				}
			},
			"AttachClassicLinkVpc": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"VpcId",
						"Groups"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"VpcId": {
							"locationName": "vpcId"
						},
						"Groups": {
							"shape": "S1j",
							"locationName": "SecurityGroupId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"AttachInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"InternetGatewayId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InternetGatewayId": {
							"locationName": "internetGatewayId"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				}
			},
			"AttachNetworkInterface": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId",
						"InstanceId",
						"DeviceIndex"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"DeviceIndex": {
							"locationName": "deviceIndex",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AttachmentId": {
							"locationName": "attachmentId"
						}
					}
				}
			},
			"AttachVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId",
						"InstanceId",
						"Device"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeId": {},
						"InstanceId": {},
						"Device": {}
					}
				},
				"output": {
					"shape": "S1p"
				}
			},
			"AttachVpnGateway": {
				"input": {
					"type": "structure",
					"required": [
						"VpnGatewayId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpnGatewayId": {},
						"VpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcAttachment": {
							"shape": "S1t",
							"locationName": "attachment"
						}
					}
				}
			},
			"AuthorizeSecurityGroupEgress": {
				"input": {
					"type": "structure",
					"required": [
						"GroupId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupId": {
							"locationName": "groupId"
						},
						"SourceSecurityGroupName": {
							"locationName": "sourceSecurityGroupName"
						},
						"SourceSecurityGroupOwnerId": {
							"locationName": "sourceSecurityGroupOwnerId"
						},
						"IpProtocol": {
							"locationName": "ipProtocol"
						},
						"FromPort": {
							"locationName": "fromPort",
							"type": "integer"
						},
						"ToPort": {
							"locationName": "toPort",
							"type": "integer"
						},
						"CidrIp": {
							"locationName": "cidrIp"
						},
						"IpPermissions": {
							"shape": "S1w",
							"locationName": "ipPermissions"
						}
					}
				}
			},
			"AuthorizeSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupName": {},
						"GroupId": {},
						"SourceSecurityGroupName": {},
						"SourceSecurityGroupOwnerId": {},
						"IpProtocol": {},
						"FromPort": {
							"type": "integer"
						},
						"ToPort": {
							"type": "integer"
						},
						"CidrIp": {},
						"IpPermissions": {
							"shape": "S1w"
						}
					}
				}
			},
			"BundleInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"Storage"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {},
						"Storage": {
							"shape": "S28"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BundleTask": {
							"shape": "S2c",
							"locationName": "bundleInstanceTask"
						}
					}
				}
			},
			"CancelBundleTask": {
				"input": {
					"type": "structure",
					"required": [
						"BundleId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"BundleId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BundleTask": {
							"shape": "S2c",
							"locationName": "bundleInstanceTask"
						}
					}
				}
			},
			"CancelConversionTask": {
				"input": {
					"type": "structure",
					"required": [
						"ConversionTaskId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ConversionTaskId": {
							"locationName": "conversionTaskId"
						},
						"ReasonMessage": {
							"locationName": "reasonMessage"
						}
					}
				}
			},
			"CancelExportTask": {
				"input": {
					"type": "structure",
					"required": [
						"ExportTaskId"
					],
					"members": {
						"ExportTaskId": {
							"locationName": "exportTaskId"
						}
					}
				}
			},
			"CancelImportTask": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ImportTaskId": {},
						"CancelReason": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportTaskId": {
							"locationName": "importTaskId"
						},
						"State": {
							"locationName": "state"
						},
						"PreviousState": {
							"locationName": "previousState"
						}
					}
				}
			},
			"CancelReservedInstancesListing": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstancesListingId"
					],
					"members": {
						"ReservedInstancesListingId": {
							"locationName": "reservedInstancesListingId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesListings": {
							"shape": "S2n",
							"locationName": "reservedInstancesListingsSet"
						}
					}
				}
			},
			"CancelSpotFleetRequests": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestIds",
						"TerminateInstances"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotFleetRequestIds": {
							"shape": "S2z",
							"locationName": "spotFleetRequestId"
						},
						"TerminateInstances": {
							"locationName": "terminateInstances",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UnsuccessfulFleetRequests": {
							"locationName": "unsuccessfulFleetRequestSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"required": [
									"SpotFleetRequestId",
									"Error"
								],
								"members": {
									"SpotFleetRequestId": {
										"locationName": "spotFleetRequestId"
									},
									"Error": {
										"locationName": "error",
										"type": "structure",
										"required": [
											"Code",
											"Message"
										],
										"members": {
											"Code": {
												"locationName": "code"
											},
											"Message": {
												"locationName": "message"
											}
										}
									}
								}
							}
						},
						"SuccessfulFleetRequests": {
							"locationName": "successfulFleetRequestSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"required": [
									"SpotFleetRequestId",
									"CurrentSpotFleetRequestState",
									"PreviousSpotFleetRequestState"
								],
								"members": {
									"SpotFleetRequestId": {
										"locationName": "spotFleetRequestId"
									},
									"CurrentSpotFleetRequestState": {
										"locationName": "currentSpotFleetRequestState"
									},
									"PreviousSpotFleetRequestState": {
										"locationName": "previousSpotFleetRequestState"
									}
								}
							}
						}
					}
				}
			},
			"CancelSpotInstanceRequests": {
				"input": {
					"type": "structure",
					"required": [
						"SpotInstanceRequestIds"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotInstanceRequestIds": {
							"shape": "S39",
							"locationName": "SpotInstanceRequestId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CancelledSpotInstanceRequests": {
							"locationName": "spotInstanceRequestSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"SpotInstanceRequestId": {
										"locationName": "spotInstanceRequestId"
									},
									"State": {
										"locationName": "state"
									}
								}
							}
						}
					}
				}
			},
			"ConfirmProductInstance": {
				"input": {
					"type": "structure",
					"required": [
						"ProductCode",
						"InstanceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ProductCode": {},
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OwnerId": {
							"locationName": "ownerId"
						},
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"CopyImage": {
				"input": {
					"type": "structure",
					"required": [
						"SourceRegion",
						"SourceImageId",
						"Name"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SourceRegion": {},
						"SourceImageId": {},
						"Name": {},
						"Description": {},
						"ClientToken": {},
						"Encrypted": {
							"locationName": "encrypted",
							"type": "boolean"
						},
						"KmsKeyId": {
							"locationName": "kmsKeyId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImageId": {
							"locationName": "imageId"
						}
					}
				}
			},
			"CopySnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceRegion",
						"SourceSnapshotId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SourceRegion": {},
						"SourceSnapshotId": {},
						"Description": {},
						"DestinationRegion": {
							"locationName": "destinationRegion"
						},
						"PresignedUrl": {
							"locationName": "presignedUrl"
						},
						"Encrypted": {
							"locationName": "encrypted",
							"type": "boolean"
						},
						"KmsKeyId": {
							"locationName": "kmsKeyId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SnapshotId": {
							"locationName": "snapshotId"
						}
					}
				}
			},
			"CreateCustomerGateway": {
				"input": {
					"type": "structure",
					"required": [
						"Type",
						"PublicIp",
						"BgpAsn"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Type": {},
						"PublicIp": {
							"locationName": "IpAddress"
						},
						"BgpAsn": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CustomerGateway": {
							"shape": "S3n",
							"locationName": "customerGateway"
						}
					}
				}
			},
			"CreateDhcpOptions": {
				"input": {
					"type": "structure",
					"required": [
						"DhcpConfigurations"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"DhcpConfigurations": {
							"locationName": "dhcpConfiguration",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Key": {
										"locationName": "key"
									},
									"Values": {
										"shape": "S2z",
										"locationName": "Value"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DhcpOptions": {
							"shape": "S3s",
							"locationName": "dhcpOptions"
						}
					}
				}
			},
			"CreateEgressOnlyInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcId": {},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EgressOnlyInternetGateway": {
							"shape": "S3z",
							"locationName": "egressOnlyInternetGateway"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateFlowLogs": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceIds",
						"ResourceType",
						"TrafficType",
						"LogGroupName",
						"DeliverLogsPermissionArn"
					],
					"members": {
						"ResourceIds": {
							"shape": "S2z",
							"locationName": "ResourceId"
						},
						"ResourceType": {},
						"TrafficType": {},
						"LogGroupName": {},
						"DeliverLogsPermissionArn": {},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FlowLogIds": {
							"shape": "S2z",
							"locationName": "flowLogIdSet"
						},
						"ClientToken": {
							"locationName": "clientToken"
						},
						"Unsuccessful": {
							"shape": "S47",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"CreateImage": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"Name"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Name": {
							"locationName": "name"
						},
						"Description": {
							"locationName": "description"
						},
						"NoReboot": {
							"locationName": "noReboot",
							"type": "boolean"
						},
						"BlockDeviceMappings": {
							"shape": "S4b",
							"locationName": "blockDeviceMapping"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImageId": {
							"locationName": "imageId"
						}
					}
				}
			},
			"CreateInstanceExportTask": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"Description": {
							"locationName": "description"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"TargetEnvironment": {
							"locationName": "targetEnvironment"
						},
						"ExportToS3Task": {
							"locationName": "exportToS3",
							"type": "structure",
							"members": {
								"DiskImageFormat": {
									"locationName": "diskImageFormat"
								},
								"ContainerFormat": {
									"locationName": "containerFormat"
								},
								"S3Bucket": {
									"locationName": "s3Bucket"
								},
								"S3Prefix": {
									"locationName": "s3Prefix"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ExportTask": {
							"shape": "S4m",
							"locationName": "exportTask"
						}
					}
				}
			},
			"CreateInternetGateway": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InternetGateway": {
							"shape": "S4s",
							"locationName": "internetGateway"
						}
					}
				}
			},
			"CreateKeyPair": {
				"input": {
					"type": "structure",
					"required": [
						"KeyName"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"KeyName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyName": {
							"locationName": "keyName"
						},
						"KeyFingerprint": {
							"locationName": "keyFingerprint"
						},
						"KeyMaterial": {
							"locationName": "keyMaterial"
						}
					}
				}
			},
			"CreateNatGateway": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId",
						"AllocationId"
					],
					"members": {
						"SubnetId": {},
						"AllocationId": {},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NatGateway": {
							"shape": "S4x",
							"locationName": "natGateway"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateNetworkAcl": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkAcl": {
							"shape": "S54",
							"locationName": "networkAcl"
						}
					}
				}
			},
			"CreateNetworkAclEntry": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkAclId",
						"RuleNumber",
						"Protocol",
						"RuleAction",
						"Egress"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						},
						"RuleNumber": {
							"locationName": "ruleNumber",
							"type": "integer"
						},
						"Protocol": {
							"locationName": "protocol"
						},
						"RuleAction": {
							"locationName": "ruleAction"
						},
						"Egress": {
							"locationName": "egress",
							"type": "boolean"
						},
						"CidrBlock": {
							"locationName": "cidrBlock"
						},
						"Ipv6CidrBlock": {
							"locationName": "ipv6CidrBlock"
						},
						"IcmpTypeCode": {
							"shape": "S58",
							"locationName": "Icmp"
						},
						"PortRange": {
							"shape": "S59",
							"locationName": "portRange"
						}
					}
				}
			},
			"CreateNetworkInterface": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId"
					],
					"members": {
						"SubnetId": {
							"locationName": "subnetId"
						},
						"Description": {
							"locationName": "description"
						},
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						},
						"Groups": {
							"shape": "S5e",
							"locationName": "SecurityGroupId"
						},
						"PrivateIpAddresses": {
							"shape": "S5f",
							"locationName": "privateIpAddresses"
						},
						"SecondaryPrivateIpAddressCount": {
							"locationName": "secondaryPrivateIpAddressCount",
							"type": "integer"
						},
						"Ipv6Addresses": {
							"shape": "S5h",
							"locationName": "ipv6Addresses"
						},
						"Ipv6AddressCount": {
							"locationName": "ipv6AddressCount",
							"type": "integer"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterface": {
							"shape": "S5k",
							"locationName": "networkInterface"
						}
					}
				}
			},
			"CreatePlacementGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"Strategy"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupName": {
							"locationName": "groupName"
						},
						"Strategy": {
							"locationName": "strategy"
						}
					}
				}
			},
			"CreateReservedInstancesListing": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstancesId",
						"InstanceCount",
						"PriceSchedules",
						"ClientToken"
					],
					"members": {
						"ReservedInstancesId": {
							"locationName": "reservedInstancesId"
						},
						"InstanceCount": {
							"locationName": "instanceCount",
							"type": "integer"
						},
						"PriceSchedules": {
							"locationName": "priceSchedules",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Term": {
										"locationName": "term",
										"type": "long"
									},
									"Price": {
										"locationName": "price",
										"type": "double"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									}
								}
							}
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesListings": {
							"shape": "S2n",
							"locationName": "reservedInstancesListingsSet"
						}
					}
				}
			},
			"CreateRoute": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						},
						"DestinationCidrBlock": {
							"locationName": "destinationCidrBlock"
						},
						"GatewayId": {
							"locationName": "gatewayId"
						},
						"DestinationIpv6CidrBlock": {
							"locationName": "destinationIpv6CidrBlock"
						},
						"EgressOnlyInternetGatewayId": {
							"locationName": "egressOnlyInternetGatewayId"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						},
						"NatGatewayId": {
							"locationName": "natGatewayId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"CreateRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RouteTable": {
							"shape": "S65",
							"locationName": "routeTable"
						}
					}
				}
			},
			"CreateSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName",
						"Description"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupName": {},
						"Description": {
							"locationName": "GroupDescription"
						},
						"VpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GroupId": {
							"locationName": "groupId"
						}
					}
				}
			},
			"CreateSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeId": {},
						"Description": {}
					}
				},
				"output": {
					"shape": "S6h"
				}
			},
			"CreateSpotDatafeedSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Bucket": {
							"locationName": "bucket"
						},
						"Prefix": {
							"locationName": "prefix"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotDatafeedSubscription": {
							"shape": "S6l",
							"locationName": "spotDatafeedSubscription"
						}
					}
				}
			},
			"CreateSubnet": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId",
						"CidrBlock"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {},
						"CidrBlock": {},
						"Ipv6CidrBlock": {},
						"AvailabilityZone": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Subnet": {
							"shape": "S6q",
							"locationName": "subnet"
						}
					}
				}
			},
			"CreateTags": {
				"input": {
					"type": "structure",
					"required": [
						"Resources",
						"Tags"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Resources": {
							"shape": "S6u",
							"locationName": "ResourceId"
						},
						"Tags": {
							"shape": "Sj",
							"locationName": "Tag"
						}
					}
				}
			},
			"CreateVolume": {
				"input": {
					"type": "structure",
					"required": [
						"AvailabilityZone"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Size": {
							"type": "integer"
						},
						"SnapshotId": {},
						"AvailabilityZone": {},
						"VolumeType": {},
						"Iops": {
							"type": "integer"
						},
						"Encrypted": {
							"locationName": "encrypted",
							"type": "boolean"
						},
						"KmsKeyId": {}
					}
				},
				"output": {
					"shape": "S6w"
				}
			},
			"CreateVpc": {
				"input": {
					"type": "structure",
					"required": [
						"CidrBlock"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"CidrBlock": {},
						"InstanceTenancy": {
							"locationName": "instanceTenancy"
						},
						"AmazonProvidedIpv6CidrBlock": {
							"locationName": "amazonProvidedIpv6CidrBlock",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Vpc": {
							"shape": "S72",
							"locationName": "vpc"
						}
					}
				}
			},
			"CreateVpcEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId",
						"ServiceName"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcId": {},
						"ServiceName": {},
						"PolicyDocument": {},
						"RouteTableIds": {
							"shape": "S2z",
							"locationName": "RouteTableId"
						},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcEndpoint": {
							"shape": "S77",
							"locationName": "vpcEndpoint"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"CreateVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {
							"locationName": "vpcId"
						},
						"PeerVpcId": {
							"locationName": "peerVpcId"
						},
						"PeerOwnerId": {
							"locationName": "peerOwnerId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcPeeringConnection": {
							"shape": "Sb",
							"locationName": "vpcPeeringConnection"
						}
					}
				}
			},
			"CreateVpnConnection": {
				"input": {
					"type": "structure",
					"required": [
						"Type",
						"CustomerGatewayId",
						"VpnGatewayId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Type": {},
						"CustomerGatewayId": {},
						"VpnGatewayId": {},
						"Options": {
							"locationName": "options",
							"type": "structure",
							"members": {
								"StaticRoutesOnly": {
									"locationName": "staticRoutesOnly",
									"type": "boolean"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpnConnection": {
							"shape": "S7e",
							"locationName": "vpnConnection"
						}
					}
				}
			},
			"CreateVpnConnectionRoute": {
				"input": {
					"type": "structure",
					"required": [
						"VpnConnectionId",
						"DestinationCidrBlock"
					],
					"members": {
						"VpnConnectionId": {},
						"DestinationCidrBlock": {}
					}
				}
			},
			"CreateVpnGateway": {
				"input": {
					"type": "structure",
					"required": [
						"Type"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Type": {},
						"AvailabilityZone": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpnGateway": {
							"shape": "S7q",
							"locationName": "vpnGateway"
						}
					}
				}
			},
			"DeleteCustomerGateway": {
				"input": {
					"type": "structure",
					"required": [
						"CustomerGatewayId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"CustomerGatewayId": {}
					}
				}
			},
			"DeleteDhcpOptions": {
				"input": {
					"type": "structure",
					"required": [
						"DhcpOptionsId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"DhcpOptionsId": {}
					}
				}
			},
			"DeleteEgressOnlyInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"EgressOnlyInternetGatewayId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"EgressOnlyInternetGatewayId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReturnCode": {
							"locationName": "returnCode",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteFlowLogs": {
				"input": {
					"type": "structure",
					"required": [
						"FlowLogIds"
					],
					"members": {
						"FlowLogIds": {
							"shape": "S2z",
							"locationName": "FlowLogId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Unsuccessful": {
							"shape": "S47",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"DeleteInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"InternetGatewayId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InternetGatewayId": {
							"locationName": "internetGatewayId"
						}
					}
				}
			},
			"DeleteKeyPair": {
				"input": {
					"type": "structure",
					"required": [
						"KeyName"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"KeyName": {}
					}
				}
			},
			"DeleteNatGateway": {
				"input": {
					"type": "structure",
					"required": [
						"NatGatewayId"
					],
					"members": {
						"NatGatewayId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NatGatewayId": {
							"locationName": "natGatewayId"
						}
					}
				}
			},
			"DeleteNetworkAcl": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkAclId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						}
					}
				}
			},
			"DeleteNetworkAclEntry": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkAclId",
						"RuleNumber",
						"Egress"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						},
						"RuleNumber": {
							"locationName": "ruleNumber",
							"type": "integer"
						},
						"Egress": {
							"locationName": "egress",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteNetworkInterface": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						}
					}
				}
			},
			"DeletePlacementGroup": {
				"input": {
					"type": "structure",
					"required": [
						"GroupName"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupName": {
							"locationName": "groupName"
						}
					}
				}
			},
			"DeleteRoute": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						},
						"DestinationCidrBlock": {
							"locationName": "destinationCidrBlock"
						},
						"DestinationIpv6CidrBlock": {
							"locationName": "destinationIpv6CidrBlock"
						}
					}
				}
			},
			"DeleteRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						}
					}
				}
			},
			"DeleteSecurityGroup": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupName": {},
						"GroupId": {}
					}
				}
			},
			"DeleteSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SnapshotId": {}
					}
				}
			},
			"DeleteSpotDatafeedSubscription": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteSubnet": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SubnetId": {}
					}
				}
			},
			"DeleteTags": {
				"input": {
					"type": "structure",
					"required": [
						"Resources"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Resources": {
							"shape": "S6u",
							"locationName": "resourceId"
						},
						"Tags": {
							"shape": "Sj",
							"locationName": "tag"
						}
					}
				}
			},
			"DeleteVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeId": {}
					}
				}
			},
			"DeleteVpc": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {}
					}
				}
			},
			"DeleteVpcEndpoints": {
				"input": {
					"type": "structure",
					"required": [
						"VpcEndpointIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcEndpointIds": {
							"shape": "S2z",
							"locationName": "VpcEndpointId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Unsuccessful": {
							"shape": "S47",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"DeleteVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"required": [
						"VpcPeeringConnectionId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DeleteVpnConnection": {
				"input": {
					"type": "structure",
					"required": [
						"VpnConnectionId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpnConnectionId": {}
					}
				}
			},
			"DeleteVpnConnectionRoute": {
				"input": {
					"type": "structure",
					"required": [
						"VpnConnectionId",
						"DestinationCidrBlock"
					],
					"members": {
						"VpnConnectionId": {},
						"DestinationCidrBlock": {}
					}
				}
			},
			"DeleteVpnGateway": {
				"input": {
					"type": "structure",
					"required": [
						"VpnGatewayId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpnGatewayId": {}
					}
				}
			},
			"DeregisterImage": {
				"input": {
					"type": "structure",
					"required": [
						"ImageId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ImageId": {}
					}
				}
			},
			"DescribeAccountAttributes": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"AttributeNames": {
							"locationName": "attributeName",
							"type": "list",
							"member": {
								"locationName": "attributeName"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountAttributes": {
							"locationName": "accountAttributeSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"AttributeName": {
										"locationName": "attributeName"
									},
									"AttributeValues": {
										"locationName": "attributeValueSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"AttributeValue": {
													"locationName": "attributeValue"
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeAddresses": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"PublicIps": {
							"locationName": "PublicIp",
							"type": "list",
							"member": {
								"locationName": "PublicIp"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"AllocationIds": {
							"locationName": "AllocationId",
							"type": "list",
							"member": {
								"locationName": "AllocationId"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Addresses": {
							"locationName": "addressesSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceId": {
										"locationName": "instanceId"
									},
									"PublicIp": {
										"locationName": "publicIp"
									},
									"AllocationId": {
										"locationName": "allocationId"
									},
									"AssociationId": {
										"locationName": "associationId"
									},
									"Domain": {
										"locationName": "domain"
									},
									"NetworkInterfaceId": {
										"locationName": "networkInterfaceId"
									},
									"NetworkInterfaceOwnerId": {
										"locationName": "networkInterfaceOwnerId"
									},
									"PrivateIpAddress": {
										"locationName": "privateIpAddress"
									}
								}
							}
						}
					}
				}
			},
			"DescribeAvailabilityZones": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ZoneNames": {
							"locationName": "ZoneName",
							"type": "list",
							"member": {
								"locationName": "ZoneName"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AvailabilityZones": {
							"locationName": "availabilityZoneInfo",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ZoneName": {
										"locationName": "zoneName"
									},
									"State": {
										"locationName": "zoneState"
									},
									"RegionName": {
										"locationName": "regionName"
									},
									"Messages": {
										"locationName": "messageSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Message": {
													"locationName": "message"
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeBundleTasks": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"BundleIds": {
							"locationName": "BundleId",
							"type": "list",
							"member": {
								"locationName": "BundleId"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BundleTasks": {
							"locationName": "bundleInstanceTasksSet",
							"type": "list",
							"member": {
								"shape": "S2c",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeClassicLinkInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceIds": {
							"shape": "S9g",
							"locationName": "InstanceId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"locationName": "instancesSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceId": {
										"locationName": "instanceId"
									},
									"VpcId": {
										"locationName": "vpcId"
									},
									"Groups": {
										"shape": "S5m",
										"locationName": "groupSet"
									},
									"Tags": {
										"shape": "Sj",
										"locationName": "tagSet"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeConversionTasks": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ConversionTaskIds": {
							"locationName": "conversionTaskId",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConversionTasks": {
							"locationName": "conversionTasks",
							"type": "list",
							"member": {
								"shape": "S9o",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeCustomerGateways": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"CustomerGatewayIds": {
							"locationName": "CustomerGatewayId",
							"type": "list",
							"member": {
								"locationName": "CustomerGatewayId"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CustomerGateways": {
							"locationName": "customerGatewaySet",
							"type": "list",
							"member": {
								"shape": "S3n",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeDhcpOptions": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"DhcpOptionsIds": {
							"locationName": "DhcpOptionsId",
							"type": "list",
							"member": {
								"locationName": "DhcpOptionsId"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DhcpOptions": {
							"locationName": "dhcpOptionsSet",
							"type": "list",
							"member": {
								"shape": "S3s",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeEgressOnlyInternetGateways": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"EgressOnlyInternetGatewayIds": {
							"locationName": "EgressOnlyInternetGatewayId",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EgressOnlyInternetGateways": {
							"locationName": "egressOnlyInternetGatewaySet",
							"type": "list",
							"member": {
								"shape": "S3z",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeExportTasks": {
				"input": {
					"type": "structure",
					"members": {
						"ExportTaskIds": {
							"locationName": "exportTaskId",
							"type": "list",
							"member": {
								"locationName": "ExportTaskId"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ExportTasks": {
							"locationName": "exportTaskSet",
							"type": "list",
							"member": {
								"shape": "S4m",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeFlowLogs": {
				"input": {
					"type": "structure",
					"members": {
						"FlowLogIds": {
							"shape": "S2z",
							"locationName": "FlowLogId"
						},
						"Filter": {
							"shape": "S8x"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FlowLogs": {
							"locationName": "flowLogSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CreationTime": {
										"locationName": "creationTime",
										"type": "timestamp"
									},
									"FlowLogId": {
										"locationName": "flowLogId"
									},
									"FlowLogStatus": {
										"locationName": "flowLogStatus"
									},
									"ResourceId": {
										"locationName": "resourceId"
									},
									"TrafficType": {
										"locationName": "trafficType"
									},
									"LogGroupName": {
										"locationName": "logGroupName"
									},
									"DeliverLogsStatus": {
										"locationName": "deliverLogsStatus"
									},
									"DeliverLogsErrorMessage": {
										"locationName": "deliverLogsErrorMessage"
									},
									"DeliverLogsPermissionArn": {
										"locationName": "deliverLogsPermissionArn"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeHostReservationOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"OfferingId": {},
						"MinDuration": {
							"type": "integer"
						},
						"MaxDuration": {
							"type": "integer"
						},
						"Filter": {
							"shape": "S8x"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OfferingSet": {
							"locationName": "offeringSet",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"OfferingId": {
										"locationName": "offeringId"
									},
									"InstanceFamily": {
										"locationName": "instanceFamily"
									},
									"PaymentOption": {
										"locationName": "paymentOption"
									},
									"UpfrontPrice": {
										"locationName": "upfrontPrice"
									},
									"HourlyPrice": {
										"locationName": "hourlyPrice"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"Duration": {
										"locationName": "duration",
										"type": "integer"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeHostReservations": {
				"input": {
					"type": "structure",
					"members": {
						"HostReservationIdSet": {
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"Filter": {
							"shape": "S8x"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"HostReservationSet": {
							"locationName": "hostReservationSet",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"HostReservationId": {
										"locationName": "hostReservationId"
									},
									"HostIdSet": {
										"shape": "Sar",
										"locationName": "hostIdSet"
									},
									"OfferingId": {
										"locationName": "offeringId"
									},
									"InstanceFamily": {
										"locationName": "instanceFamily"
									},
									"PaymentOption": {
										"locationName": "paymentOption"
									},
									"HourlyPrice": {
										"locationName": "hourlyPrice"
									},
									"UpfrontPrice": {
										"locationName": "upfrontPrice"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"Count": {
										"locationName": "count",
										"type": "integer"
									},
									"Duration": {
										"locationName": "duration",
										"type": "integer"
									},
									"End": {
										"locationName": "end",
										"type": "timestamp"
									},
									"Start": {
										"locationName": "start",
										"type": "timestamp"
									},
									"State": {
										"locationName": "state"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeHosts": {
				"input": {
					"type": "structure",
					"members": {
						"HostIds": {
							"shape": "Sau",
							"locationName": "hostId"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"Filter": {
							"shape": "S8x",
							"locationName": "filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Hosts": {
							"locationName": "hostSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"HostId": {
										"locationName": "hostId"
									},
									"AutoPlacement": {
										"locationName": "autoPlacement"
									},
									"HostReservationId": {
										"locationName": "hostReservationId"
									},
									"ClientToken": {
										"locationName": "clientToken"
									},
									"HostProperties": {
										"locationName": "hostProperties",
										"type": "structure",
										"members": {
											"Sockets": {
												"locationName": "sockets",
												"type": "integer"
											},
											"Cores": {
												"locationName": "cores",
												"type": "integer"
											},
											"TotalVCpus": {
												"locationName": "totalVCpus",
												"type": "integer"
											},
											"InstanceType": {
												"locationName": "instanceType"
											}
										}
									},
									"State": {
										"locationName": "state"
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"Instances": {
										"locationName": "instances",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"InstanceId": {
													"locationName": "instanceId"
												},
												"InstanceType": {
													"locationName": "instanceType"
												}
											}
										}
									},
									"AvailableCapacity": {
										"locationName": "availableCapacity",
										"type": "structure",
										"members": {
											"AvailableInstanceCapacity": {
												"locationName": "availableInstanceCapacity",
												"type": "list",
												"member": {
													"locationName": "item",
													"type": "structure",
													"members": {
														"InstanceType": {
															"locationName": "instanceType"
														},
														"AvailableCapacity": {
															"locationName": "availableCapacity",
															"type": "integer"
														},
														"TotalCapacity": {
															"locationName": "totalCapacity",
															"type": "integer"
														}
													}
												}
											},
											"AvailableVCpus": {
												"locationName": "availableVCpus",
												"type": "integer"
											}
										}
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeIamInstanceProfileAssociations": {
				"input": {
					"type": "structure",
					"members": {
						"AssociationIds": {
							"locationName": "AssociationId",
							"type": "list",
							"member": {
								"locationName": "AssociationId"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamInstanceProfileAssociations": {
							"locationName": "iamInstanceProfileAssociationSet",
							"type": "list",
							"member": {
								"shape": "S13",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeIdFormat": {
				"input": {
					"type": "structure",
					"members": {
						"Resource": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Statuses": {
							"shape": "Sbd",
							"locationName": "statusSet"
						}
					}
				}
			},
			"DescribeIdentityIdFormat": {
				"input": {
					"type": "structure",
					"required": [
						"PrincipalArn"
					],
					"members": {
						"Resource": {
							"locationName": "resource"
						},
						"PrincipalArn": {
							"locationName": "principalArn"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Statuses": {
							"shape": "Sbd",
							"locationName": "statusSet"
						}
					}
				}
			},
			"DescribeImageAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"ImageId",
						"Attribute"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ImageId": {},
						"Attribute": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImageId": {
							"locationName": "imageId"
						},
						"LaunchPermissions": {
							"shape": "Sbk",
							"locationName": "launchPermission"
						},
						"ProductCodes": {
							"shape": "Sbn",
							"locationName": "productCodes"
						},
						"KernelId": {
							"shape": "S3w",
							"locationName": "kernel"
						},
						"RamdiskId": {
							"shape": "S3w",
							"locationName": "ramdisk"
						},
						"Description": {
							"shape": "S3w",
							"locationName": "description"
						},
						"SriovNetSupport": {
							"shape": "S3w",
							"locationName": "sriovNetSupport"
						},
						"BlockDeviceMappings": {
							"shape": "Sbq",
							"locationName": "blockDeviceMapping"
						}
					}
				}
			},
			"DescribeImages": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ImageIds": {
							"locationName": "ImageId",
							"type": "list",
							"member": {
								"locationName": "ImageId"
							}
						},
						"Owners": {
							"shape": "Sbt",
							"locationName": "Owner"
						},
						"ExecutableUsers": {
							"locationName": "ExecutableBy",
							"type": "list",
							"member": {
								"locationName": "ExecutableBy"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Images": {
							"locationName": "imagesSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ImageId": {
										"locationName": "imageId"
									},
									"ImageLocation": {
										"locationName": "imageLocation"
									},
									"State": {
										"locationName": "imageState"
									},
									"OwnerId": {
										"locationName": "imageOwnerId"
									},
									"CreationDate": {
										"locationName": "creationDate"
									},
									"Public": {
										"locationName": "isPublic",
										"type": "boolean"
									},
									"ProductCodes": {
										"shape": "Sbn",
										"locationName": "productCodes"
									},
									"Architecture": {
										"locationName": "architecture"
									},
									"ImageType": {
										"locationName": "imageType"
									},
									"KernelId": {
										"locationName": "kernelId"
									},
									"RamdiskId": {
										"locationName": "ramdiskId"
									},
									"Platform": {
										"locationName": "platform"
									},
									"SriovNetSupport": {
										"locationName": "sriovNetSupport"
									},
									"EnaSupport": {
										"locationName": "enaSupport",
										"type": "boolean"
									},
									"StateReason": {
										"shape": "Sc1",
										"locationName": "stateReason"
									},
									"ImageOwnerAlias": {
										"locationName": "imageOwnerAlias"
									},
									"Name": {
										"locationName": "name"
									},
									"Description": {
										"locationName": "description"
									},
									"RootDeviceType": {
										"locationName": "rootDeviceType"
									},
									"RootDeviceName": {
										"locationName": "rootDeviceName"
									},
									"BlockDeviceMappings": {
										"shape": "Sbq",
										"locationName": "blockDeviceMapping"
									},
									"VirtualizationType": {
										"locationName": "virtualizationType"
									},
									"Tags": {
										"shape": "Sj",
										"locationName": "tagSet"
									},
									"Hypervisor": {
										"locationName": "hypervisor"
									}
								}
							}
						}
					}
				}
			},
			"DescribeImportImageTasks": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ImportTaskIds": {
							"shape": "Sc6",
							"locationName": "ImportTaskId"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"Filters": {
							"shape": "S8x"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportImageTasks": {
							"locationName": "importImageTaskSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ImportTaskId": {
										"locationName": "importTaskId"
									},
									"Architecture": {
										"locationName": "architecture"
									},
									"LicenseType": {
										"locationName": "licenseType"
									},
									"Platform": {
										"locationName": "platform"
									},
									"Hypervisor": {
										"locationName": "hypervisor"
									},
									"Description": {
										"locationName": "description"
									},
									"SnapshotDetails": {
										"shape": "Sca",
										"locationName": "snapshotDetailSet"
									},
									"ImageId": {
										"locationName": "imageId"
									},
									"Progress": {
										"locationName": "progress"
									},
									"StatusMessage": {
										"locationName": "statusMessage"
									},
									"Status": {
										"locationName": "status"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeImportSnapshotTasks": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ImportTaskIds": {
							"shape": "Sc6",
							"locationName": "ImportTaskId"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"Filters": {
							"shape": "S8x"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportSnapshotTasks": {
							"locationName": "importSnapshotTaskSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ImportTaskId": {
										"locationName": "importTaskId"
									},
									"SnapshotTaskDetail": {
										"shape": "Sch",
										"locationName": "snapshotTaskDetail"
									},
									"Description": {
										"locationName": "description"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeInstanceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"Attribute"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Attribute": {
							"locationName": "attribute"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"InstanceType": {
							"shape": "S3w",
							"locationName": "instanceType"
						},
						"KernelId": {
							"shape": "S3w",
							"locationName": "kernel"
						},
						"RamdiskId": {
							"shape": "S3w",
							"locationName": "ramdisk"
						},
						"UserData": {
							"shape": "S3w",
							"locationName": "userData"
						},
						"DisableApiTermination": {
							"shape": "Scl",
							"locationName": "disableApiTermination"
						},
						"InstanceInitiatedShutdownBehavior": {
							"shape": "S3w",
							"locationName": "instanceInitiatedShutdownBehavior"
						},
						"RootDeviceName": {
							"shape": "S3w",
							"locationName": "rootDeviceName"
						},
						"BlockDeviceMappings": {
							"shape": "Scm",
							"locationName": "blockDeviceMapping"
						},
						"ProductCodes": {
							"shape": "Sbn",
							"locationName": "productCodes"
						},
						"EbsOptimized": {
							"shape": "Scl",
							"locationName": "ebsOptimized"
						},
						"SriovNetSupport": {
							"shape": "S3w",
							"locationName": "sriovNetSupport"
						},
						"EnaSupport": {
							"shape": "Scl",
							"locationName": "enaSupport"
						},
						"SourceDestCheck": {
							"shape": "Scl",
							"locationName": "sourceDestCheck"
						},
						"Groups": {
							"shape": "S5m",
							"locationName": "groupSet"
						}
					}
				}
			},
			"DescribeInstanceStatus": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceIds": {
							"shape": "S9g",
							"locationName": "InstanceId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"IncludeAllInstances": {
							"locationName": "includeAllInstances",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceStatuses": {
							"locationName": "instanceStatusSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceId": {
										"locationName": "instanceId"
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"Events": {
										"locationName": "eventsSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Code": {
													"locationName": "code"
												},
												"Description": {
													"locationName": "description"
												},
												"NotBefore": {
													"locationName": "notBefore",
													"type": "timestamp"
												},
												"NotAfter": {
													"locationName": "notAfter",
													"type": "timestamp"
												}
											}
										}
									},
									"InstanceState": {
										"shape": "Scw",
										"locationName": "instanceState"
									},
									"SystemStatus": {
										"shape": "Scy",
										"locationName": "systemStatus"
									},
									"InstanceStatus": {
										"shape": "Scy",
										"locationName": "instanceStatus"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceIds": {
							"shape": "S9g",
							"locationName": "InstanceId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Reservations": {
							"locationName": "reservationSet",
							"type": "list",
							"member": {
								"shape": "Sd7",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeInternetGateways": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InternetGatewayIds": {
							"shape": "S2z",
							"locationName": "internetGatewayId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InternetGateways": {
							"locationName": "internetGatewaySet",
							"type": "list",
							"member": {
								"shape": "S4s",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeKeyPairs": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"KeyNames": {
							"locationName": "KeyName",
							"type": "list",
							"member": {
								"locationName": "KeyName"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyPairs": {
							"locationName": "keySet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"KeyName": {
										"locationName": "keyName"
									},
									"KeyFingerprint": {
										"locationName": "keyFingerprint"
									}
								}
							}
						}
					}
				}
			},
			"DescribeMovingAddresses": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"PublicIps": {
							"shape": "S2z",
							"locationName": "publicIp"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "filter"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MovingAddressStatuses": {
							"locationName": "movingAddressStatusSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"PublicIp": {
										"locationName": "publicIp"
									},
									"MoveStatus": {
										"locationName": "moveStatus"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeNatGateways": {
				"input": {
					"type": "structure",
					"members": {
						"NatGatewayIds": {
							"shape": "S2z",
							"locationName": "NatGatewayId"
						},
						"Filter": {
							"shape": "S8x"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NatGateways": {
							"locationName": "natGatewaySet",
							"type": "list",
							"member": {
								"shape": "S4x",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeNetworkAcls": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkAclIds": {
							"shape": "S2z",
							"locationName": "NetworkAclId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkAcls": {
							"locationName": "networkAclSet",
							"type": "list",
							"member": {
								"shape": "S54",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeNetworkInterfaceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"Attribute": {
							"locationName": "attribute"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"Description": {
							"shape": "S3w",
							"locationName": "description"
						},
						"SourceDestCheck": {
							"shape": "Scl",
							"locationName": "sourceDestCheck"
						},
						"Groups": {
							"shape": "S5m",
							"locationName": "groupSet"
						},
						"Attachment": {
							"shape": "S5o",
							"locationName": "attachment"
						}
					}
				}
			},
			"DescribeNetworkInterfaces": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceIds": {
							"locationName": "NetworkInterfaceId",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterfaces": {
							"locationName": "networkInterfaceSet",
							"type": "list",
							"member": {
								"shape": "S5k",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribePlacementGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupNames": {
							"locationName": "groupName",
							"type": "list",
							"member": {}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PlacementGroups": {
							"locationName": "placementGroupSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"GroupName": {
										"locationName": "groupName"
									},
									"Strategy": {
										"locationName": "strategy"
									},
									"State": {
										"locationName": "state"
									}
								}
							}
						}
					}
				}
			},
			"DescribePrefixLists": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"PrefixListIds": {
							"shape": "S2z",
							"locationName": "PrefixListId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PrefixLists": {
							"locationName": "prefixListSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"PrefixListId": {
										"locationName": "prefixListId"
									},
									"PrefixListName": {
										"locationName": "prefixListName"
									},
									"Cidrs": {
										"shape": "S2z",
										"locationName": "cidrSet"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeRegions": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RegionNames": {
							"locationName": "RegionName",
							"type": "list",
							"member": {
								"locationName": "RegionName"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Regions": {
							"locationName": "regionInfo",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"RegionName": {
										"locationName": "regionName"
									},
									"Endpoint": {
										"locationName": "regionEndpoint"
									}
								}
							}
						}
					}
				}
			},
			"DescribeReservedInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ReservedInstancesIds": {
							"shape": "Ser",
							"locationName": "ReservedInstancesId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"OfferingType": {
							"locationName": "offeringType"
						},
						"OfferingClass": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstances": {
							"locationName": "reservedInstancesSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ReservedInstancesId": {
										"locationName": "reservedInstancesId"
									},
									"InstanceType": {
										"locationName": "instanceType"
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"Start": {
										"locationName": "start",
										"type": "timestamp"
									},
									"End": {
										"locationName": "end",
										"type": "timestamp"
									},
									"Duration": {
										"locationName": "duration",
										"type": "long"
									},
									"UsagePrice": {
										"locationName": "usagePrice",
										"type": "float"
									},
									"FixedPrice": {
										"locationName": "fixedPrice",
										"type": "float"
									},
									"InstanceCount": {
										"locationName": "instanceCount",
										"type": "integer"
									},
									"ProductDescription": {
										"locationName": "productDescription"
									},
									"State": {
										"locationName": "state"
									},
									"Tags": {
										"shape": "Sj",
										"locationName": "tagSet"
									},
									"InstanceTenancy": {
										"locationName": "instanceTenancy"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"OfferingType": {
										"locationName": "offeringType"
									},
									"RecurringCharges": {
										"shape": "Sf0",
										"locationName": "recurringCharges"
									},
									"OfferingClass": {
										"locationName": "offeringClass"
									},
									"Scope": {
										"locationName": "scope"
									}
								}
							}
						}
					}
				}
			},
			"DescribeReservedInstancesListings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedInstancesId": {
							"locationName": "reservedInstancesId"
						},
						"ReservedInstancesListingId": {
							"locationName": "reservedInstancesListingId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesListings": {
							"shape": "S2n",
							"locationName": "reservedInstancesListingsSet"
						}
					}
				}
			},
			"DescribeReservedInstancesModifications": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedInstancesModificationIds": {
							"locationName": "ReservedInstancesModificationId",
							"type": "list",
							"member": {
								"locationName": "ReservedInstancesModificationId"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesModifications": {
							"locationName": "reservedInstancesModificationsSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ReservedInstancesModificationId": {
										"locationName": "reservedInstancesModificationId"
									},
									"ReservedInstancesIds": {
										"locationName": "reservedInstancesSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"ReservedInstancesId": {
													"locationName": "reservedInstancesId"
												}
											}
										}
									},
									"ModificationResults": {
										"locationName": "modificationResultSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"ReservedInstancesId": {
													"locationName": "reservedInstancesId"
												},
												"TargetConfiguration": {
													"shape": "Sff",
													"locationName": "targetConfiguration"
												}
											}
										}
									},
									"CreateDate": {
										"locationName": "createDate",
										"type": "timestamp"
									},
									"UpdateDate": {
										"locationName": "updateDate",
										"type": "timestamp"
									},
									"EffectiveDate": {
										"locationName": "effectiveDate",
										"type": "timestamp"
									},
									"Status": {
										"locationName": "status"
									},
									"StatusMessage": {
										"locationName": "statusMessage"
									},
									"ClientToken": {
										"locationName": "clientToken"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeReservedInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ReservedInstancesOfferingIds": {
							"locationName": "ReservedInstancesOfferingId",
							"type": "list",
							"member": {}
						},
						"InstanceType": {},
						"AvailabilityZone": {},
						"ProductDescription": {},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"InstanceTenancy": {
							"locationName": "instanceTenancy"
						},
						"OfferingType": {
							"locationName": "offeringType"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"IncludeMarketplace": {
							"type": "boolean"
						},
						"MinDuration": {
							"type": "long"
						},
						"MaxDuration": {
							"type": "long"
						},
						"MaxInstanceCount": {
							"type": "integer"
						},
						"OfferingClass": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesOfferings": {
							"locationName": "reservedInstancesOfferingsSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ReservedInstancesOfferingId": {
										"locationName": "reservedInstancesOfferingId"
									},
									"InstanceType": {
										"locationName": "instanceType"
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"Duration": {
										"locationName": "duration",
										"type": "long"
									},
									"UsagePrice": {
										"locationName": "usagePrice",
										"type": "float"
									},
									"FixedPrice": {
										"locationName": "fixedPrice",
										"type": "float"
									},
									"ProductDescription": {
										"locationName": "productDescription"
									},
									"InstanceTenancy": {
										"locationName": "instanceTenancy"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"OfferingType": {
										"locationName": "offeringType"
									},
									"RecurringCharges": {
										"shape": "Sf0",
										"locationName": "recurringCharges"
									},
									"Marketplace": {
										"locationName": "marketplace",
										"type": "boolean"
									},
									"PricingDetails": {
										"locationName": "pricingDetailsSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Price": {
													"locationName": "price",
													"type": "double"
												},
												"Count": {
													"locationName": "count",
													"type": "integer"
												}
											}
										}
									},
									"OfferingClass": {
										"locationName": "offeringClass"
									},
									"Scope": {
										"locationName": "scope"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeRouteTables": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableIds": {
							"shape": "S2z",
							"locationName": "RouteTableId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RouteTables": {
							"locationName": "routeTableSet",
							"type": "list",
							"member": {
								"shape": "S65",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeScheduledInstanceAvailability": {
				"input": {
					"type": "structure",
					"required": [
						"Recurrence",
						"FirstSlotStartTimeRange"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Recurrence": {
							"type": "structure",
							"members": {
								"Frequency": {},
								"Interval": {
									"type": "integer"
								},
								"OccurrenceDays": {
									"locationName": "OccurrenceDay",
									"type": "list",
									"member": {
										"locationName": "OccurenceDay",
										"type": "integer"
									}
								},
								"OccurrenceRelativeToEnd": {
									"type": "boolean"
								},
								"OccurrenceUnit": {}
							}
						},
						"FirstSlotStartTimeRange": {
							"type": "structure",
							"required": [
								"EarliestTime",
								"LatestTime"
							],
							"members": {
								"EarliestTime": {
									"type": "timestamp"
								},
								"LatestTime": {
									"type": "timestamp"
								}
							}
						},
						"MinSlotDurationInHours": {
							"type": "integer"
						},
						"MaxSlotDurationInHours": {
							"type": "integer"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"ScheduledInstanceAvailabilitySet": {
							"locationName": "scheduledInstanceAvailabilitySet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceType": {
										"locationName": "instanceType"
									},
									"Platform": {
										"locationName": "platform"
									},
									"NetworkPlatform": {
										"locationName": "networkPlatform"
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"PurchaseToken": {
										"locationName": "purchaseToken"
									},
									"SlotDurationInHours": {
										"locationName": "slotDurationInHours",
										"type": "integer"
									},
									"Recurrence": {
										"shape": "Sfx",
										"locationName": "recurrence"
									},
									"FirstSlotStartTime": {
										"locationName": "firstSlotStartTime",
										"type": "timestamp"
									},
									"HourlyPrice": {
										"locationName": "hourlyPrice"
									},
									"TotalScheduledInstanceHours": {
										"locationName": "totalScheduledInstanceHours",
										"type": "integer"
									},
									"AvailableInstanceCount": {
										"locationName": "availableInstanceCount",
										"type": "integer"
									},
									"MinTermDurationInDays": {
										"locationName": "minTermDurationInDays",
										"type": "integer"
									},
									"MaxTermDurationInDays": {
										"locationName": "maxTermDurationInDays",
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"DescribeScheduledInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ScheduledInstanceIds": {
							"locationName": "ScheduledInstanceId",
							"type": "list",
							"member": {
								"locationName": "ScheduledInstanceId"
							}
						},
						"SlotStartTimeRange": {
							"type": "structure",
							"members": {
								"EarliestTime": {
									"type": "timestamp"
								},
								"LatestTime": {
									"type": "timestamp"
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextToken": {
							"locationName": "nextToken"
						},
						"ScheduledInstanceSet": {
							"locationName": "scheduledInstanceSet",
							"type": "list",
							"member": {
								"shape": "Sg4",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeSecurityGroupReferences": {
				"input": {
					"type": "structure",
					"required": [
						"GroupId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"GroupId": {
							"type": "list",
							"member": {
								"locationName": "item"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecurityGroupReferenceSet": {
							"locationName": "securityGroupReferenceSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"required": [
									"GroupId",
									"ReferencingVpcId"
								],
								"members": {
									"GroupId": {
										"locationName": "groupId"
									},
									"ReferencingVpcId": {
										"locationName": "referencingVpcId"
									},
									"VpcPeeringConnectionId": {
										"locationName": "vpcPeeringConnectionId"
									}
								}
							}
						}
					}
				}
			},
			"DescribeSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupNames": {
							"shape": "Sgb",
							"locationName": "GroupName"
						},
						"GroupIds": {
							"shape": "S1j",
							"locationName": "GroupId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecurityGroups": {
							"locationName": "securityGroupInfo",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"OwnerId": {
										"locationName": "ownerId"
									},
									"GroupName": {
										"locationName": "groupName"
									},
									"GroupId": {
										"locationName": "groupId"
									},
									"Description": {
										"locationName": "groupDescription"
									},
									"IpPermissions": {
										"shape": "S1w",
										"locationName": "ipPermissions"
									},
									"IpPermissionsEgress": {
										"shape": "S1w",
										"locationName": "ipPermissionsEgress"
									},
									"VpcId": {
										"locationName": "vpcId"
									},
									"Tags": {
										"shape": "Sj",
										"locationName": "tagSet"
									}
								}
							}
						}
					}
				}
			},
			"DescribeSnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotId",
						"Attribute"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SnapshotId": {},
						"Attribute": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SnapshotId": {
							"locationName": "snapshotId"
						},
						"CreateVolumePermissions": {
							"shape": "Sgi",
							"locationName": "createVolumePermission"
						},
						"ProductCodes": {
							"shape": "Sbn",
							"locationName": "productCodes"
						}
					}
				}
			},
			"DescribeSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SnapshotIds": {
							"locationName": "SnapshotId",
							"type": "list",
							"member": {
								"locationName": "SnapshotId"
							}
						},
						"OwnerIds": {
							"shape": "Sbt",
							"locationName": "Owner"
						},
						"RestorableByUserIds": {
							"locationName": "RestorableBy",
							"type": "list",
							"member": {}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Snapshots": {
							"locationName": "snapshotSet",
							"type": "list",
							"member": {
								"shape": "S6h",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeSpotDatafeedSubscription": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotDatafeedSubscription": {
							"shape": "S6l",
							"locationName": "spotDatafeedSubscription"
						}
					}
				}
			},
			"DescribeSpotFleetInstances": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"SpotFleetRequestId",
						"ActiveInstances"
					],
					"members": {
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						},
						"ActiveInstances": {
							"locationName": "activeInstanceSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceType": {
										"locationName": "instanceType"
									},
									"InstanceId": {
										"locationName": "instanceId"
									},
									"SpotInstanceRequestId": {
										"locationName": "spotInstanceRequestId"
									},
									"InstanceHealth": {
										"locationName": "instanceHealth"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeSpotFleetRequestHistory": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestId",
						"StartTime"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						},
						"EventType": {
							"locationName": "eventType"
						},
						"StartTime": {
							"locationName": "startTime",
							"type": "timestamp"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"SpotFleetRequestId",
						"StartTime",
						"LastEvaluatedTime",
						"HistoryRecords"
					],
					"members": {
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						},
						"StartTime": {
							"locationName": "startTime",
							"type": "timestamp"
						},
						"LastEvaluatedTime": {
							"locationName": "lastEvaluatedTime",
							"type": "timestamp"
						},
						"HistoryRecords": {
							"locationName": "historyRecordSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"required": [
									"Timestamp",
									"EventType",
									"EventInformation"
								],
								"members": {
									"Timestamp": {
										"locationName": "timestamp",
										"type": "timestamp"
									},
									"EventType": {
										"locationName": "eventType"
									},
									"EventInformation": {
										"locationName": "eventInformation",
										"type": "structure",
										"members": {
											"InstanceId": {
												"locationName": "instanceId"
											},
											"EventSubType": {
												"locationName": "eventSubType"
											},
											"EventDescription": {
												"locationName": "eventDescription"
											}
										}
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeSpotFleetRequests": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotFleetRequestIds": {
							"shape": "S2z",
							"locationName": "spotFleetRequestId"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"SpotFleetRequestConfigs"
					],
					"members": {
						"SpotFleetRequestConfigs": {
							"locationName": "spotFleetRequestConfigSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"required": [
									"SpotFleetRequestId",
									"SpotFleetRequestState",
									"SpotFleetRequestConfig",
									"CreateTime"
								],
								"members": {
									"SpotFleetRequestId": {
										"locationName": "spotFleetRequestId"
									},
									"SpotFleetRequestState": {
										"locationName": "spotFleetRequestState"
									},
									"SpotFleetRequestConfig": {
										"shape": "Sh6",
										"locationName": "spotFleetRequestConfig"
									},
									"CreateTime": {
										"locationName": "createTime",
										"type": "timestamp"
									},
									"ActivityStatus": {
										"locationName": "activityStatus"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeSpotInstanceRequests": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotInstanceRequestIds": {
							"shape": "S39",
							"locationName": "SpotInstanceRequestId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotInstanceRequests": {
							"shape": "Shj",
							"locationName": "spotInstanceRequestSet"
						}
					}
				}
			},
			"DescribeSpotPriceHistory": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"StartTime": {
							"locationName": "startTime",
							"type": "timestamp"
						},
						"EndTime": {
							"locationName": "endTime",
							"type": "timestamp"
						},
						"InstanceTypes": {
							"locationName": "InstanceType",
							"type": "list",
							"member": {}
						},
						"ProductDescriptions": {
							"locationName": "ProductDescription",
							"type": "list",
							"member": {}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"AvailabilityZone": {
							"locationName": "availabilityZone"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotPriceHistory": {
							"locationName": "spotPriceHistorySet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"InstanceType": {
										"locationName": "instanceType"
									},
									"ProductDescription": {
										"locationName": "productDescription"
									},
									"SpotPrice": {
										"locationName": "spotPrice"
									},
									"Timestamp": {
										"locationName": "timestamp",
										"type": "timestamp"
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeStaleSecurityGroups": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StaleSecurityGroupSet": {
							"locationName": "staleSecurityGroupSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"required": [
									"GroupId"
								],
								"members": {
									"GroupId": {
										"locationName": "groupId"
									},
									"GroupName": {
										"locationName": "groupName"
									},
									"Description": {
										"locationName": "description"
									},
									"VpcId": {
										"locationName": "vpcId"
									},
									"StaleIpPermissions": {
										"shape": "Si0",
										"locationName": "staleIpPermissions"
									},
									"StaleIpPermissionsEgress": {
										"shape": "Si0",
										"locationName": "staleIpPermissionsEgress"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeSubnets": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SubnetIds": {
							"locationName": "SubnetId",
							"type": "list",
							"member": {
								"locationName": "SubnetId"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Subnets": {
							"locationName": "subnetSet",
							"type": "list",
							"member": {
								"shape": "S6q",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"locationName": "tagSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ResourceId": {
										"locationName": "resourceId"
									},
									"ResourceType": {
										"locationName": "resourceType"
									},
									"Key": {
										"locationName": "key"
									},
									"Value": {
										"locationName": "value"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVolumeAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeId": {},
						"Attribute": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeId": {
							"locationName": "volumeId"
						},
						"AutoEnableIO": {
							"shape": "Scl",
							"locationName": "autoEnableIO"
						},
						"ProductCodes": {
							"shape": "Sbn",
							"locationName": "productCodes"
						}
					}
				}
			},
			"DescribeVolumeStatus": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeIds": {
							"shape": "Sii",
							"locationName": "VolumeId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeStatuses": {
							"locationName": "volumeStatusSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"VolumeId": {
										"locationName": "volumeId"
									},
									"AvailabilityZone": {
										"locationName": "availabilityZone"
									},
									"VolumeStatus": {
										"locationName": "volumeStatus",
										"type": "structure",
										"members": {
											"Status": {
												"locationName": "status"
											},
											"Details": {
												"locationName": "details",
												"type": "list",
												"member": {
													"locationName": "item",
													"type": "structure",
													"members": {
														"Name": {
															"locationName": "name"
														},
														"Status": {
															"locationName": "status"
														}
													}
												}
											}
										}
									},
									"Events": {
										"locationName": "eventsSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"EventType": {
													"locationName": "eventType"
												},
												"Description": {
													"locationName": "description"
												},
												"NotBefore": {
													"locationName": "notBefore",
													"type": "timestamp"
												},
												"NotAfter": {
													"locationName": "notAfter",
													"type": "timestamp"
												},
												"EventId": {
													"locationName": "eventId"
												}
											}
										}
									},
									"Actions": {
										"locationName": "actionsSet",
										"type": "list",
										"member": {
											"locationName": "item",
											"type": "structure",
											"members": {
												"Code": {
													"locationName": "code"
												},
												"Description": {
													"locationName": "description"
												},
												"EventType": {
													"locationName": "eventType"
												},
												"EventId": {
													"locationName": "eventId"
												}
											}
										}
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVolumes": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeIds": {
							"shape": "Sii",
							"locationName": "VolumeId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"NextToken": {
							"locationName": "nextToken"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Volumes": {
							"locationName": "volumeSet",
							"type": "list",
							"member": {
								"shape": "S6w",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVolumesModifications": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VolumeIds": {
							"shape": "Sii",
							"locationName": "VolumeId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumesModifications": {
							"locationName": "volumeModificationSet",
							"type": "list",
							"member": {
								"shape": "Sj1",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId",
						"Attribute"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {},
						"Attribute": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcId": {
							"locationName": "vpcId"
						},
						"EnableDnsSupport": {
							"shape": "Scl",
							"locationName": "enableDnsSupport"
						},
						"EnableDnsHostnames": {
							"shape": "Scl",
							"locationName": "enableDnsHostnames"
						}
					}
				}
			},
			"DescribeVpcClassicLink": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcIds": {
							"shape": "Sj7",
							"locationName": "VpcId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Vpcs": {
							"locationName": "vpcSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"VpcId": {
										"locationName": "vpcId"
									},
									"ClassicLinkEnabled": {
										"locationName": "classicLinkEnabled",
										"type": "boolean"
									},
									"Tags": {
										"shape": "Sj",
										"locationName": "tagSet"
									}
								}
							}
						}
					}
				}
			},
			"DescribeVpcClassicLinkDnsSupport": {
				"input": {
					"type": "structure",
					"members": {
						"VpcIds": {
							"shape": "Sj7"
						},
						"MaxResults": {
							"locationName": "maxResults",
							"type": "integer"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Vpcs": {
							"locationName": "vpcs",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"VpcId": {
										"locationName": "vpcId"
									},
									"ClassicLinkDnsSupported": {
										"locationName": "classicLinkDnsSupported",
										"type": "boolean"
									}
								}
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcEndpointServices": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceNames": {
							"shape": "S2z",
							"locationName": "serviceNameSet"
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcEndpoints": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcEndpointIds": {
							"shape": "S2z",
							"locationName": "VpcEndpointId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcEndpoints": {
							"locationName": "vpcEndpointSet",
							"type": "list",
							"member": {
								"shape": "S77",
								"locationName": "item"
							}
						},
						"NextToken": {
							"locationName": "nextToken"
						}
					}
				}
			},
			"DescribeVpcPeeringConnections": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcPeeringConnectionIds": {
							"shape": "S2z",
							"locationName": "VpcPeeringConnectionId"
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcPeeringConnections": {
							"locationName": "vpcPeeringConnectionSet",
							"type": "list",
							"member": {
								"shape": "Sb",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeVpcs": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcIds": {
							"locationName": "VpcId",
							"type": "list",
							"member": {
								"locationName": "VpcId"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Vpcs": {
							"locationName": "vpcSet",
							"type": "list",
							"member": {
								"shape": "S72",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeVpnConnections": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpnConnectionIds": {
							"locationName": "VpnConnectionId",
							"type": "list",
							"member": {
								"locationName": "VpnConnectionId"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpnConnections": {
							"locationName": "vpnConnectionSet",
							"type": "list",
							"member": {
								"shape": "S7e",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DescribeVpnGateways": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpnGatewayIds": {
							"locationName": "VpnGatewayId",
							"type": "list",
							"member": {
								"locationName": "VpnGatewayId"
							}
						},
						"Filters": {
							"shape": "S8x",
							"locationName": "Filter"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpnGateways": {
							"locationName": "vpnGatewaySet",
							"type": "list",
							"member": {
								"shape": "S7q",
								"locationName": "item"
							}
						}
					}
				}
			},
			"DetachClassicLinkVpc": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DetachInternetGateway": {
				"input": {
					"type": "structure",
					"required": [
						"InternetGatewayId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InternetGatewayId": {
							"locationName": "internetGatewayId"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				}
			},
			"DetachNetworkInterface": {
				"input": {
					"type": "structure",
					"required": [
						"AttachmentId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"AttachmentId": {
							"locationName": "attachmentId"
						},
						"Force": {
							"locationName": "force",
							"type": "boolean"
						}
					}
				}
			},
			"DetachVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeId": {},
						"InstanceId": {},
						"Device": {},
						"Force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "S1p"
				}
			},
			"DetachVpnGateway": {
				"input": {
					"type": "structure",
					"required": [
						"VpnGatewayId",
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpnGatewayId": {},
						"VpcId": {}
					}
				}
			},
			"DisableVgwRoutePropagation": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId",
						"GatewayId"
					],
					"members": {
						"RouteTableId": {},
						"GatewayId": {}
					}
				}
			},
			"DisableVpcClassicLink": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DisableVpcClassicLinkDnsSupport": {
				"input": {
					"type": "structure",
					"members": {
						"VpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"DisassociateAddress": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"PublicIp": {},
						"AssociationId": {}
					}
				}
			},
			"DisassociateIamInstanceProfile": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamInstanceProfileAssociation": {
							"shape": "S13",
							"locationName": "iamInstanceProfileAssociation"
						}
					}
				}
			},
			"DisassociateRouteTable": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"AssociationId": {
							"locationName": "associationId"
						}
					}
				}
			},
			"DisassociateSubnetCidrBlock": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SubnetId": {
							"locationName": "subnetId"
						},
						"Ipv6CidrBlockAssociation": {
							"shape": "S1a",
							"locationName": "ipv6CidrBlockAssociation"
						}
					}
				}
			},
			"DisassociateVpcCidrBlock": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {
							"locationName": "associationId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VpcId": {
							"locationName": "vpcId"
						},
						"Ipv6CidrBlockAssociation": {
							"shape": "S1f",
							"locationName": "ipv6CidrBlockAssociation"
						}
					}
				}
			},
			"EnableVgwRoutePropagation": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId",
						"GatewayId"
					],
					"members": {
						"RouteTableId": {},
						"GatewayId": {}
					}
				}
			},
			"EnableVolumeIO": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeId": {
							"locationName": "volumeId"
						}
					}
				}
			},
			"EnableVpcClassicLink": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcId": {
							"locationName": "vpcId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"EnableVpcClassicLinkDnsSupport": {
				"input": {
					"type": "structure",
					"members": {
						"VpcId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"GetConsoleOutput": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Timestamp": {
							"locationName": "timestamp",
							"type": "timestamp"
						},
						"Output": {
							"locationName": "output"
						}
					}
				}
			},
			"GetConsoleScreenshot": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"InstanceId": {},
						"WakeUp": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"ImageData": {
							"locationName": "imageData"
						}
					}
				}
			},
			"GetHostReservationPurchasePreview": {
				"input": {
					"type": "structure",
					"required": [
						"OfferingId",
						"HostIdSet"
					],
					"members": {
						"OfferingId": {},
						"HostIdSet": {
							"shape": "Skt"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Purchase": {
							"shape": "Skv",
							"locationName": "purchase"
						},
						"TotalUpfrontPrice": {
							"locationName": "totalUpfrontPrice"
						},
						"TotalHourlyPrice": {
							"locationName": "totalHourlyPrice"
						},
						"CurrencyCode": {
							"locationName": "currencyCode"
						}
					}
				}
			},
			"GetPasswordData": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Timestamp": {
							"locationName": "timestamp",
							"type": "timestamp"
						},
						"PasswordData": {
							"locationName": "passwordData"
						}
					}
				}
			},
			"GetReservedInstancesExchangeQuote": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstanceIds"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ReservedInstanceIds": {
							"shape": "S3",
							"locationName": "ReservedInstanceId"
						},
						"TargetConfigurations": {
							"shape": "S5",
							"locationName": "TargetConfiguration"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstanceValueSet": {
							"locationName": "reservedInstanceValueSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"ReservedInstanceId": {
										"locationName": "reservedInstanceId"
									},
									"ReservationValue": {
										"shape": "Sl3",
										"locationName": "reservationValue"
									}
								}
							}
						},
						"ReservedInstanceValueRollup": {
							"shape": "Sl3",
							"locationName": "reservedInstanceValueRollup"
						},
						"TargetConfigurationValueSet": {
							"locationName": "targetConfigurationValueSet",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"TargetConfiguration": {
										"locationName": "targetConfiguration",
										"type": "structure",
										"members": {
											"OfferingId": {
												"locationName": "offeringId"
											},
											"InstanceCount": {
												"locationName": "instanceCount",
												"type": "integer"
											}
										}
									},
									"ReservationValue": {
										"shape": "Sl3",
										"locationName": "reservationValue"
									}
								}
							}
						},
						"TargetConfigurationValueRollup": {
							"shape": "Sl3",
							"locationName": "targetConfigurationValueRollup"
						},
						"PaymentDue": {
							"locationName": "paymentDue"
						},
						"CurrencyCode": {
							"locationName": "currencyCode"
						},
						"OutputReservedInstancesWillExpireAt": {
							"locationName": "outputReservedInstancesWillExpireAt",
							"type": "timestamp"
						},
						"IsValidExchange": {
							"locationName": "isValidExchange",
							"type": "boolean"
						},
						"ValidationFailureReason": {
							"locationName": "validationFailureReason"
						}
					}
				}
			},
			"ImportImage": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Description": {},
						"DiskContainers": {
							"locationName": "DiskContainer",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Description": {},
									"Format": {},
									"Url": {},
									"UserBucket": {
										"shape": "Sla"
									},
									"DeviceName": {},
									"SnapshotId": {}
								}
							}
						},
						"LicenseType": {},
						"Hypervisor": {},
						"Architecture": {},
						"Platform": {},
						"ClientData": {
							"shape": "Slb"
						},
						"ClientToken": {},
						"RoleName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportTaskId": {
							"locationName": "importTaskId"
						},
						"Architecture": {
							"locationName": "architecture"
						},
						"LicenseType": {
							"locationName": "licenseType"
						},
						"Platform": {
							"locationName": "platform"
						},
						"Hypervisor": {
							"locationName": "hypervisor"
						},
						"Description": {
							"locationName": "description"
						},
						"SnapshotDetails": {
							"shape": "Sca",
							"locationName": "snapshotDetailSet"
						},
						"ImageId": {
							"locationName": "imageId"
						},
						"Progress": {
							"locationName": "progress"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						},
						"Status": {
							"locationName": "status"
						}
					}
				}
			},
			"ImportInstance": {
				"input": {
					"type": "structure",
					"required": [
						"Platform"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Description": {
							"locationName": "description"
						},
						"LaunchSpecification": {
							"locationName": "launchSpecification",
							"type": "structure",
							"members": {
								"Architecture": {
									"locationName": "architecture"
								},
								"GroupNames": {
									"shape": "Slf",
									"locationName": "GroupName"
								},
								"GroupIds": {
									"shape": "S5e",
									"locationName": "GroupId"
								},
								"AdditionalInfo": {
									"locationName": "additionalInfo"
								},
								"UserData": {
									"locationName": "userData",
									"type": "structure",
									"members": {
										"Data": {
											"locationName": "data"
										}
									}
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"Placement": {
									"shape": "Sdb",
									"locationName": "placement"
								},
								"Monitoring": {
									"locationName": "monitoring",
									"type": "boolean"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"InstanceInitiatedShutdownBehavior": {
									"locationName": "instanceInitiatedShutdownBehavior"
								},
								"PrivateIpAddress": {
									"locationName": "privateIpAddress"
								}
							}
						},
						"DiskImages": {
							"locationName": "diskImage",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Image": {
										"shape": "Slk"
									},
									"Description": {},
									"Volume": {
										"shape": "Sll"
									}
								}
							}
						},
						"Platform": {
							"locationName": "platform"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConversionTask": {
							"shape": "S9o",
							"locationName": "conversionTask"
						}
					}
				}
			},
			"ImportKeyPair": {
				"input": {
					"type": "structure",
					"required": [
						"KeyName",
						"PublicKeyMaterial"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"KeyName": {
							"locationName": "keyName"
						},
						"PublicKeyMaterial": {
							"locationName": "publicKeyMaterial",
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyName": {
							"locationName": "keyName"
						},
						"KeyFingerprint": {
							"locationName": "keyFingerprint"
						}
					}
				}
			},
			"ImportSnapshot": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"Description": {},
						"DiskContainer": {
							"type": "structure",
							"members": {
								"Description": {},
								"Format": {},
								"Url": {},
								"UserBucket": {
									"shape": "Sla"
								}
							}
						},
						"ClientData": {
							"shape": "Slb"
						},
						"ClientToken": {},
						"RoleName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImportTaskId": {
							"locationName": "importTaskId"
						},
						"SnapshotTaskDetail": {
							"shape": "Sch",
							"locationName": "snapshotTaskDetail"
						},
						"Description": {
							"locationName": "description"
						}
					}
				}
			},
			"ImportVolume": {
				"input": {
					"type": "structure",
					"required": [
						"AvailabilityZone",
						"Image",
						"Volume"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"AvailabilityZone": {
							"locationName": "availabilityZone"
						},
						"Image": {
							"shape": "Slk",
							"locationName": "image"
						},
						"Description": {
							"locationName": "description"
						},
						"Volume": {
							"shape": "Sll",
							"locationName": "volume"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConversionTask": {
							"shape": "S9o",
							"locationName": "conversionTask"
						}
					}
				}
			},
			"ModifyHosts": {
				"input": {
					"type": "structure",
					"required": [
						"HostIds",
						"AutoPlacement"
					],
					"members": {
						"HostIds": {
							"shape": "Sau",
							"locationName": "hostId"
						},
						"AutoPlacement": {
							"locationName": "autoPlacement"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Successful": {
							"shape": "Sr",
							"locationName": "successful"
						},
						"Unsuccessful": {
							"shape": "Slw",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"ModifyIdFormat": {
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"UseLongIds"
					],
					"members": {
						"Resource": {},
						"UseLongIds": {
							"type": "boolean"
						}
					}
				}
			},
			"ModifyIdentityIdFormat": {
				"input": {
					"type": "structure",
					"required": [
						"Resource",
						"UseLongIds",
						"PrincipalArn"
					],
					"members": {
						"Resource": {
							"locationName": "resource"
						},
						"UseLongIds": {
							"locationName": "useLongIds",
							"type": "boolean"
						},
						"PrincipalArn": {
							"locationName": "principalArn"
						}
					}
				}
			},
			"ModifyImageAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"ImageId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ImageId": {},
						"Attribute": {},
						"OperationType": {},
						"UserIds": {
							"shape": "Sm1",
							"locationName": "UserId"
						},
						"UserGroups": {
							"locationName": "UserGroup",
							"type": "list",
							"member": {
								"locationName": "UserGroup"
							}
						},
						"ProductCodes": {
							"locationName": "ProductCode",
							"type": "list",
							"member": {
								"locationName": "ProductCode"
							}
						},
						"Value": {},
						"LaunchPermission": {
							"type": "structure",
							"members": {
								"Add": {
									"shape": "Sbk"
								},
								"Remove": {
									"shape": "Sbk"
								}
							}
						},
						"Description": {
							"shape": "S3w"
						}
					}
				}
			},
			"ModifyInstanceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Attribute": {
							"locationName": "attribute"
						},
						"Value": {
							"locationName": "value"
						},
						"BlockDeviceMappings": {
							"locationName": "blockDeviceMapping",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"DeviceName": {
										"locationName": "deviceName"
									},
									"Ebs": {
										"locationName": "ebs",
										"type": "structure",
										"members": {
											"VolumeId": {
												"locationName": "volumeId"
											},
											"DeleteOnTermination": {
												"locationName": "deleteOnTermination",
												"type": "boolean"
											}
										}
									},
									"VirtualName": {
										"locationName": "virtualName"
									},
									"NoDevice": {
										"locationName": "noDevice"
									}
								}
							}
						},
						"SourceDestCheck": {
							"shape": "Scl"
						},
						"DisableApiTermination": {
							"shape": "Scl",
							"locationName": "disableApiTermination"
						},
						"InstanceType": {
							"shape": "S3w",
							"locationName": "instanceType"
						},
						"Kernel": {
							"shape": "S3w",
							"locationName": "kernel"
						},
						"Ramdisk": {
							"shape": "S3w",
							"locationName": "ramdisk"
						},
						"UserData": {
							"locationName": "userData",
							"type": "structure",
							"members": {
								"Value": {
									"locationName": "value",
									"type": "blob"
								}
							}
						},
						"InstanceInitiatedShutdownBehavior": {
							"shape": "S3w",
							"locationName": "instanceInitiatedShutdownBehavior"
						},
						"Groups": {
							"shape": "S1j",
							"locationName": "GroupId"
						},
						"EbsOptimized": {
							"shape": "Scl",
							"locationName": "ebsOptimized"
						},
						"SriovNetSupport": {
							"shape": "S3w",
							"locationName": "sriovNetSupport"
						},
						"EnaSupport": {
							"shape": "Scl",
							"locationName": "enaSupport"
						}
					}
				}
			},
			"ModifyInstancePlacement": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Tenancy": {
							"locationName": "tenancy"
						},
						"Affinity": {
							"locationName": "affinity"
						},
						"HostId": {
							"locationName": "hostId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyNetworkInterfaceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"Description": {
							"shape": "S3w",
							"locationName": "description"
						},
						"SourceDestCheck": {
							"shape": "Scl",
							"locationName": "sourceDestCheck"
						},
						"Groups": {
							"shape": "S5e",
							"locationName": "SecurityGroupId"
						},
						"Attachment": {
							"locationName": "attachment",
							"type": "structure",
							"members": {
								"AttachmentId": {
									"locationName": "attachmentId"
								},
								"DeleteOnTermination": {
									"locationName": "deleteOnTermination",
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"ModifyReservedInstances": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstancesIds",
						"TargetConfigurations"
					],
					"members": {
						"ClientToken": {
							"locationName": "clientToken"
						},
						"ReservedInstancesIds": {
							"shape": "Ser",
							"locationName": "ReservedInstancesId"
						},
						"TargetConfigurations": {
							"locationName": "ReservedInstancesConfigurationSetItemType",
							"type": "list",
							"member": {
								"shape": "Sff",
								"locationName": "item"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesModificationId": {
							"locationName": "reservedInstancesModificationId"
						}
					}
				}
			},
			"ModifySnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SnapshotId": {},
						"Attribute": {},
						"OperationType": {},
						"UserIds": {
							"shape": "Sm1",
							"locationName": "UserId"
						},
						"GroupNames": {
							"shape": "Sgb",
							"locationName": "UserGroup"
						},
						"CreateVolumePermission": {
							"type": "structure",
							"members": {
								"Add": {
									"shape": "Sgi"
								},
								"Remove": {
									"shape": "Sgi"
								}
							}
						}
					}
				}
			},
			"ModifySpotFleetRequest": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestId"
					],
					"members": {
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						},
						"TargetCapacity": {
							"locationName": "targetCapacity",
							"type": "integer"
						},
						"ExcessCapacityTerminationPolicy": {
							"locationName": "excessCapacityTerminationPolicy"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifySubnetAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"SubnetId"
					],
					"members": {
						"SubnetId": {
							"locationName": "subnetId"
						},
						"MapPublicIpOnLaunch": {
							"shape": "Scl"
						},
						"AssignIpv6AddressOnCreation": {
							"shape": "Scl"
						}
					}
				}
			},
			"ModifyVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VolumeId": {},
						"Size": {
							"type": "integer"
						},
						"VolumeType": {},
						"Iops": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeModification": {
							"shape": "Sj1",
							"locationName": "volumeModification"
						}
					}
				}
			},
			"ModifyVolumeAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VolumeId": {},
						"AutoEnableIO": {
							"shape": "Scl"
						}
					}
				}
			},
			"ModifyVpcAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"VpcId"
					],
					"members": {
						"VpcId": {
							"locationName": "vpcId"
						},
						"EnableDnsSupport": {
							"shape": "Scl"
						},
						"EnableDnsHostnames": {
							"shape": "Scl"
						}
					}
				}
			},
			"ModifyVpcEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"VpcEndpointId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcEndpointId": {},
						"ResetPolicy": {
							"type": "boolean"
						},
						"PolicyDocument": {},
						"AddRouteTableIds": {
							"shape": "S2z",
							"locationName": "AddRouteTableId"
						},
						"RemoveRouteTableIds": {
							"shape": "S2z",
							"locationName": "RemoveRouteTableId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ModifyVpcPeeringConnectionOptions": {
				"input": {
					"type": "structure",
					"required": [
						"VpcPeeringConnectionId"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"VpcPeeringConnectionId": {},
						"RequesterPeeringConnectionOptions": {
							"shape": "Smv"
						},
						"AccepterPeeringConnectionOptions": {
							"shape": "Smv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RequesterPeeringConnectionOptions": {
							"shape": "Smx",
							"locationName": "requesterPeeringConnectionOptions"
						},
						"AccepterPeeringConnectionOptions": {
							"shape": "Smx",
							"locationName": "accepterPeeringConnectionOptions"
						}
					}
				}
			},
			"MonitorInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceIds": {
							"shape": "S9g",
							"locationName": "InstanceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceMonitorings": {
							"shape": "Sn0",
							"locationName": "instancesSet"
						}
					}
				}
			},
			"MoveAddressToVpc": {
				"input": {
					"type": "structure",
					"required": [
						"PublicIp"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"PublicIp": {
							"locationName": "publicIp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AllocationId": {
							"locationName": "allocationId"
						},
						"Status": {
							"locationName": "status"
						}
					}
				}
			},
			"PurchaseHostReservation": {
				"input": {
					"type": "structure",
					"required": [
						"OfferingId",
						"HostIdSet"
					],
					"members": {
						"OfferingId": {},
						"HostIdSet": {
							"shape": "Skt"
						},
						"LimitPrice": {},
						"CurrencyCode": {},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Purchase": {
							"shape": "Skv",
							"locationName": "purchase"
						},
						"TotalUpfrontPrice": {
							"locationName": "totalUpfrontPrice"
						},
						"TotalHourlyPrice": {
							"locationName": "totalHourlyPrice"
						},
						"CurrencyCode": {
							"locationName": "currencyCode"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"PurchaseReservedInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedInstancesOfferingId",
						"InstanceCount"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ReservedInstancesOfferingId": {},
						"InstanceCount": {
							"type": "integer"
						},
						"LimitPrice": {
							"locationName": "limitPrice",
							"type": "structure",
							"members": {
								"Amount": {
									"locationName": "amount",
									"type": "double"
								},
								"CurrencyCode": {
									"locationName": "currencyCode"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReservedInstancesId": {
							"locationName": "reservedInstancesId"
						}
					}
				}
			},
			"PurchaseScheduledInstances": {
				"input": {
					"type": "structure",
					"required": [
						"PurchaseRequests"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						},
						"PurchaseRequests": {
							"locationName": "PurchaseRequest",
							"type": "list",
							"member": {
								"locationName": "PurchaseRequest",
								"type": "structure",
								"required": [
									"PurchaseToken",
									"InstanceCount"
								],
								"members": {
									"PurchaseToken": {},
									"InstanceCount": {
										"type": "integer"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScheduledInstanceSet": {
							"locationName": "scheduledInstanceSet",
							"type": "list",
							"member": {
								"shape": "Sg4",
								"locationName": "item"
							}
						}
					}
				}
			},
			"RebootInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceIds": {
							"shape": "S9g",
							"locationName": "InstanceId"
						}
					}
				}
			},
			"RegisterImage": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ImageLocation": {},
						"Name": {
							"locationName": "name"
						},
						"Description": {
							"locationName": "description"
						},
						"Architecture": {
							"locationName": "architecture"
						},
						"KernelId": {
							"locationName": "kernelId"
						},
						"RamdiskId": {
							"locationName": "ramdiskId"
						},
						"RootDeviceName": {
							"locationName": "rootDeviceName"
						},
						"BlockDeviceMappings": {
							"shape": "S4b",
							"locationName": "BlockDeviceMapping"
						},
						"VirtualizationType": {
							"locationName": "virtualizationType"
						},
						"SriovNetSupport": {
							"locationName": "sriovNetSupport"
						},
						"EnaSupport": {
							"locationName": "enaSupport",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ImageId": {
							"locationName": "imageId"
						}
					}
				}
			},
			"RejectVpcPeeringConnection": {
				"input": {
					"type": "structure",
					"required": [
						"VpcPeeringConnectionId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Return": {
							"locationName": "return",
							"type": "boolean"
						}
					}
				}
			},
			"ReleaseAddress": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"PublicIp": {},
						"AllocationId": {}
					}
				}
			},
			"ReleaseHosts": {
				"input": {
					"type": "structure",
					"required": [
						"HostIds"
					],
					"members": {
						"HostIds": {
							"shape": "Sau",
							"locationName": "hostId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Successful": {
							"shape": "Sr",
							"locationName": "successful"
						},
						"Unsuccessful": {
							"shape": "Slw",
							"locationName": "unsuccessful"
						}
					}
				}
			},
			"ReplaceIamInstanceProfileAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"IamInstanceProfile",
						"AssociationId"
					],
					"members": {
						"IamInstanceProfile": {
							"shape": "S11"
						},
						"AssociationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamInstanceProfileAssociation": {
							"shape": "S13",
							"locationName": "iamInstanceProfileAssociation"
						}
					}
				}
			},
			"ReplaceNetworkAclAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId",
						"NetworkAclId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"AssociationId": {
							"locationName": "associationId"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NewAssociationId": {
							"locationName": "newAssociationId"
						}
					}
				}
			},
			"ReplaceNetworkAclEntry": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkAclId",
						"RuleNumber",
						"Protocol",
						"RuleAction",
						"Egress"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkAclId": {
							"locationName": "networkAclId"
						},
						"RuleNumber": {
							"locationName": "ruleNumber",
							"type": "integer"
						},
						"Protocol": {
							"locationName": "protocol"
						},
						"RuleAction": {
							"locationName": "ruleAction"
						},
						"Egress": {
							"locationName": "egress",
							"type": "boolean"
						},
						"CidrBlock": {
							"locationName": "cidrBlock"
						},
						"Ipv6CidrBlock": {
							"locationName": "ipv6CidrBlock"
						},
						"IcmpTypeCode": {
							"shape": "S58",
							"locationName": "Icmp"
						},
						"PortRange": {
							"shape": "S59",
							"locationName": "portRange"
						}
					}
				}
			},
			"ReplaceRoute": {
				"input": {
					"type": "structure",
					"required": [
						"RouteTableId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						},
						"DestinationCidrBlock": {
							"locationName": "destinationCidrBlock"
						},
						"GatewayId": {
							"locationName": "gatewayId"
						},
						"DestinationIpv6CidrBlock": {
							"locationName": "destinationIpv6CidrBlock"
						},
						"EgressOnlyInternetGatewayId": {
							"locationName": "egressOnlyInternetGatewayId"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"VpcPeeringConnectionId": {
							"locationName": "vpcPeeringConnectionId"
						},
						"NatGatewayId": {
							"locationName": "natGatewayId"
						}
					}
				}
			},
			"ReplaceRouteTableAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId",
						"RouteTableId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"AssociationId": {
							"locationName": "associationId"
						},
						"RouteTableId": {
							"locationName": "routeTableId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NewAssociationId": {
							"locationName": "newAssociationId"
						}
					}
				}
			},
			"ReportInstanceStatus": {
				"input": {
					"type": "structure",
					"required": [
						"Instances",
						"Status",
						"ReasonCodes"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"Instances": {
							"shape": "S9g",
							"locationName": "instanceId"
						},
						"Status": {
							"locationName": "status"
						},
						"StartTime": {
							"locationName": "startTime",
							"type": "timestamp"
						},
						"EndTime": {
							"locationName": "endTime",
							"type": "timestamp"
						},
						"ReasonCodes": {
							"locationName": "reasonCode",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"Description": {
							"locationName": "description"
						}
					}
				}
			},
			"RequestSpotFleet": {
				"input": {
					"type": "structure",
					"required": [
						"SpotFleetRequestConfig"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotFleetRequestConfig": {
							"shape": "Sh6",
							"locationName": "spotFleetRequestConfig"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"SpotFleetRequestId"
					],
					"members": {
						"SpotFleetRequestId": {
							"locationName": "spotFleetRequestId"
						}
					}
				}
			},
			"RequestSpotInstances": {
				"input": {
					"type": "structure",
					"required": [
						"SpotPrice"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SpotPrice": {
							"locationName": "spotPrice"
						},
						"ClientToken": {
							"locationName": "clientToken"
						},
						"InstanceCount": {
							"locationName": "instanceCount",
							"type": "integer"
						},
						"Type": {
							"locationName": "type"
						},
						"ValidFrom": {
							"locationName": "validFrom",
							"type": "timestamp"
						},
						"ValidUntil": {
							"locationName": "validUntil",
							"type": "timestamp"
						},
						"LaunchGroup": {
							"locationName": "launchGroup"
						},
						"AvailabilityZoneGroup": {
							"locationName": "availabilityZoneGroup"
						},
						"BlockDurationMinutes": {
							"locationName": "blockDurationMinutes",
							"type": "integer"
						},
						"LaunchSpecification": {
							"type": "structure",
							"members": {
								"ImageId": {
									"locationName": "imageId"
								},
								"KeyName": {
									"locationName": "keyName"
								},
								"SecurityGroups": {
									"shape": "S2z",
									"locationName": "SecurityGroup"
								},
								"UserData": {
									"locationName": "userData"
								},
								"AddressingType": {
									"locationName": "addressingType"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"Placement": {
									"shape": "Sh9",
									"locationName": "placement"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"BlockDeviceMappings": {
									"shape": "Sbq",
									"locationName": "blockDeviceMapping"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"NetworkInterfaces": {
									"shape": "Shb",
									"locationName": "NetworkInterface"
								},
								"IamInstanceProfile": {
									"shape": "S11",
									"locationName": "iamInstanceProfile"
								},
								"EbsOptimized": {
									"locationName": "ebsOptimized",
									"type": "boolean"
								},
								"Monitoring": {
									"shape": "Shp",
									"locationName": "monitoring"
								},
								"SecurityGroupIds": {
									"shape": "S2z",
									"locationName": "SecurityGroupId"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SpotInstanceRequests": {
							"shape": "Shj",
							"locationName": "spotInstanceRequestSet"
						}
					}
				}
			},
			"ResetImageAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"ImageId",
						"Attribute"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ImageId": {},
						"Attribute": {}
					}
				}
			},
			"ResetInstanceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"Attribute"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Attribute": {
							"locationName": "attribute"
						}
					}
				}
			},
			"ResetNetworkInterfaceAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"SourceDestCheck": {
							"locationName": "sourceDestCheck"
						}
					}
				}
			},
			"ResetSnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotId",
						"Attribute"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"SnapshotId": {},
						"Attribute": {}
					}
				}
			},
			"RestoreAddressToClassic": {
				"input": {
					"type": "structure",
					"required": [
						"PublicIp"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"PublicIp": {
							"locationName": "publicIp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"locationName": "status"
						},
						"PublicIp": {
							"locationName": "publicIp"
						}
					}
				}
			},
			"RevokeSecurityGroupEgress": {
				"input": {
					"type": "structure",
					"required": [
						"GroupId"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupId": {
							"locationName": "groupId"
						},
						"SourceSecurityGroupName": {
							"locationName": "sourceSecurityGroupName"
						},
						"SourceSecurityGroupOwnerId": {
							"locationName": "sourceSecurityGroupOwnerId"
						},
						"IpProtocol": {
							"locationName": "ipProtocol"
						},
						"FromPort": {
							"locationName": "fromPort",
							"type": "integer"
						},
						"ToPort": {
							"locationName": "toPort",
							"type": "integer"
						},
						"CidrIp": {
							"locationName": "cidrIp"
						},
						"IpPermissions": {
							"shape": "S1w",
							"locationName": "ipPermissions"
						}
					}
				}
			},
			"RevokeSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"GroupName": {},
						"GroupId": {},
						"SourceSecurityGroupName": {},
						"SourceSecurityGroupOwnerId": {},
						"IpProtocol": {},
						"FromPort": {
							"type": "integer"
						},
						"ToPort": {
							"type": "integer"
						},
						"CidrIp": {},
						"IpPermissions": {
							"shape": "S1w"
						}
					}
				}
			},
			"RunInstances": {
				"input": {
					"type": "structure",
					"required": [
						"ImageId",
						"MinCount",
						"MaxCount"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"ImageId": {},
						"MinCount": {
							"type": "integer"
						},
						"MaxCount": {
							"type": "integer"
						},
						"KeyName": {},
						"SecurityGroups": {
							"shape": "Slf",
							"locationName": "SecurityGroup"
						},
						"SecurityGroupIds": {
							"shape": "S5e",
							"locationName": "SecurityGroupId"
						},
						"UserData": {},
						"InstanceType": {},
						"Placement": {
							"shape": "Sdb"
						},
						"KernelId": {},
						"RamdiskId": {},
						"BlockDeviceMappings": {
							"shape": "S4b",
							"locationName": "BlockDeviceMapping"
						},
						"Monitoring": {
							"shape": "Shp"
						},
						"SubnetId": {},
						"DisableApiTermination": {
							"locationName": "disableApiTermination",
							"type": "boolean"
						},
						"InstanceInitiatedShutdownBehavior": {
							"locationName": "instanceInitiatedShutdownBehavior"
						},
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						},
						"Ipv6Addresses": {
							"shape": "S5h",
							"locationName": "Ipv6Address"
						},
						"Ipv6AddressCount": {
							"type": "integer"
						},
						"ClientToken": {
							"locationName": "clientToken"
						},
						"AdditionalInfo": {
							"locationName": "additionalInfo"
						},
						"NetworkInterfaces": {
							"shape": "Shb",
							"locationName": "networkInterface"
						},
						"IamInstanceProfile": {
							"shape": "S11",
							"locationName": "iamInstanceProfile"
						},
						"EbsOptimized": {
							"locationName": "ebsOptimized",
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "Sd7"
				}
			},
			"RunScheduledInstances": {
				"input": {
					"type": "structure",
					"required": [
						"ScheduledInstanceId",
						"LaunchSpecification"
					],
					"members": {
						"DryRun": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						},
						"InstanceCount": {
							"type": "integer"
						},
						"ScheduledInstanceId": {},
						"LaunchSpecification": {
							"type": "structure",
							"required": [
								"ImageId"
							],
							"members": {
								"ImageId": {},
								"KeyName": {},
								"SecurityGroupIds": {
									"shape": "Sog",
									"locationName": "SecurityGroupId"
								},
								"UserData": {},
								"Placement": {
									"type": "structure",
									"members": {
										"AvailabilityZone": {},
										"GroupName": {}
									}
								},
								"KernelId": {},
								"InstanceType": {},
								"RamdiskId": {},
								"BlockDeviceMappings": {
									"locationName": "BlockDeviceMapping",
									"type": "list",
									"member": {
										"locationName": "BlockDeviceMapping",
										"type": "structure",
										"members": {
											"DeviceName": {},
											"NoDevice": {},
											"VirtualName": {},
											"Ebs": {
												"type": "structure",
												"members": {
													"SnapshotId": {},
													"VolumeSize": {
														"type": "integer"
													},
													"DeleteOnTermination": {
														"type": "boolean"
													},
													"VolumeType": {},
													"Iops": {
														"type": "integer"
													},
													"Encrypted": {
														"type": "boolean"
													}
												}
											}
										}
									}
								},
								"Monitoring": {
									"type": "structure",
									"members": {
										"Enabled": {
											"type": "boolean"
										}
									}
								},
								"SubnetId": {},
								"NetworkInterfaces": {
									"locationName": "NetworkInterface",
									"type": "list",
									"member": {
										"locationName": "NetworkInterface",
										"type": "structure",
										"members": {
											"NetworkInterfaceId": {},
											"DeviceIndex": {
												"type": "integer"
											},
											"SubnetId": {},
											"Description": {},
											"PrivateIpAddress": {},
											"PrivateIpAddressConfigs": {
												"locationName": "PrivateIpAddressConfig",
												"type": "list",
												"member": {
													"locationName": "PrivateIpAddressConfigSet",
													"type": "structure",
													"members": {
														"PrivateIpAddress": {},
														"Primary": {
															"type": "boolean"
														}
													}
												}
											},
											"SecondaryPrivateIpAddressCount": {
												"type": "integer"
											},
											"AssociatePublicIpAddress": {
												"type": "boolean"
											},
											"Groups": {
												"shape": "Sog",
												"locationName": "Group"
											},
											"DeleteOnTermination": {
												"type": "boolean"
											},
											"Ipv6Addresses": {
												"locationName": "Ipv6Address",
												"type": "list",
												"member": {
													"locationName": "Ipv6Address",
													"type": "structure",
													"members": {
														"Ipv6Address": {}
													}
												}
											},
											"Ipv6AddressCount": {
												"type": "integer"
											}
										}
									}
								},
								"IamInstanceProfile": {
									"type": "structure",
									"members": {
										"Arn": {},
										"Name": {}
									}
								},
								"EbsOptimized": {
									"type": "boolean"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceIdSet": {
							"locationName": "instanceIdSet",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						}
					}
				}
			},
			"StartInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "S9g",
							"locationName": "InstanceId"
						},
						"AdditionalInfo": {
							"locationName": "additionalInfo"
						},
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StartingInstances": {
							"shape": "Soy",
							"locationName": "instancesSet"
						}
					}
				}
			},
			"StopInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceIds": {
							"shape": "S9g",
							"locationName": "InstanceId"
						},
						"Force": {
							"locationName": "force",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StoppingInstances": {
							"shape": "Soy",
							"locationName": "instancesSet"
						}
					}
				}
			},
			"TerminateInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceIds": {
							"shape": "S9g",
							"locationName": "InstanceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TerminatingInstances": {
							"shape": "Soy",
							"locationName": "instancesSet"
						}
					}
				}
			},
			"UnassignIpv6Addresses": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId",
						"Ipv6Addresses"
					],
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"Ipv6Addresses": {
							"shape": "St",
							"locationName": "ipv6Addresses"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"UnassignedIpv6Addresses": {
							"shape": "St",
							"locationName": "unassignedIpv6Addresses"
						}
					}
				}
			},
			"UnassignPrivateIpAddresses": {
				"input": {
					"type": "structure",
					"required": [
						"NetworkInterfaceId",
						"PrivateIpAddresses"
					],
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"PrivateIpAddresses": {
							"shape": "Sw",
							"locationName": "privateIpAddress"
						}
					}
				}
			},
			"UnmonitorInstances": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"DryRun": {
							"locationName": "dryRun",
							"type": "boolean"
						},
						"InstanceIds": {
							"shape": "S9g",
							"locationName": "InstanceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceMonitorings": {
							"shape": "Sn0",
							"locationName": "instancesSet"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"locationName": "ReservedInstanceId"
				}
			},
			"S5": {
				"type": "list",
				"member": {
					"locationName": "TargetConfigurationRequest",
					"type": "structure",
					"required": [
						"OfferingId"
					],
					"members": {
						"OfferingId": {},
						"InstanceCount": {
							"type": "integer"
						}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"AccepterVpcInfo": {
						"shape": "Sc",
						"locationName": "accepterVpcInfo"
					},
					"ExpirationTime": {
						"locationName": "expirationTime",
						"type": "timestamp"
					},
					"RequesterVpcInfo": {
						"shape": "Sc",
						"locationName": "requesterVpcInfo"
					},
					"Status": {
						"locationName": "status",
						"type": "structure",
						"members": {
							"Code": {
								"locationName": "code"
							},
							"Message": {
								"locationName": "message"
							}
						}
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					}
				}
			},
			"Sc": {
				"type": "structure",
				"members": {
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"Ipv6CidrBlockSet": {
						"locationName": "ipv6CidrBlockSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Ipv6CidrBlock": {
									"locationName": "ipv6CidrBlock"
								}
							}
						}
					},
					"PeeringOptions": {
						"locationName": "peeringOptions",
						"type": "structure",
						"members": {
							"AllowEgressFromLocalClassicLinkToRemoteVpc": {
								"locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
								"type": "boolean"
							},
							"AllowEgressFromLocalVpcToRemoteClassicLink": {
								"locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
								"type": "boolean"
							},
							"AllowDnsResolutionFromRemoteVpc": {
								"locationName": "allowDnsResolutionFromRemoteVpc",
								"type": "boolean"
							}
						}
					}
				}
			},
			"Sj": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Key": {
							"locationName": "key"
						},
						"Value": {
							"locationName": "value"
						}
					}
				}
			},
			"Sr": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"St": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Sw": {
				"type": "list",
				"member": {
					"locationName": "PrivateIpAddress"
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"Arn": {
						"locationName": "arn"
					},
					"Name": {
						"locationName": "name"
					}
				}
			},
			"S13": {
				"type": "structure",
				"members": {
					"AssociationId": {
						"locationName": "associationId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"IamInstanceProfile": {
						"shape": "S14",
						"locationName": "iamInstanceProfile"
					},
					"State": {
						"locationName": "state"
					},
					"Timestamp": {
						"locationName": "timestamp",
						"type": "timestamp"
					}
				}
			},
			"S14": {
				"type": "structure",
				"members": {
					"Arn": {
						"locationName": "arn"
					},
					"Id": {
						"locationName": "id"
					}
				}
			},
			"S1a": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"Ipv6CidrBlockState": {
						"locationName": "ipv6CidrBlockState",
						"type": "structure",
						"members": {
							"State": {
								"locationName": "state"
							},
							"StatusMessage": {
								"locationName": "statusMessage"
							}
						}
					},
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			},
			"S1f": {
				"type": "structure",
				"members": {
					"Ipv6CidrBlock": {
						"locationName": "ipv6CidrBlock"
					},
					"Ipv6CidrBlockState": {
						"locationName": "ipv6CidrBlockState",
						"type": "structure",
						"members": {
							"State": {
								"locationName": "state"
							},
							"StatusMessage": {
								"locationName": "statusMessage"
							}
						}
					},
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			},
			"S1j": {
				"type": "list",
				"member": {
					"locationName": "groupId"
				}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"VolumeId": {
						"locationName": "volumeId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"Device": {
						"locationName": "device"
					},
					"State": {
						"locationName": "status"
					},
					"AttachTime": {
						"locationName": "attachTime",
						"type": "timestamp"
					},
					"DeleteOnTermination": {
						"locationName": "deleteOnTermination",
						"type": "boolean"
					}
				}
			},
			"S1t": {
				"type": "structure",
				"members": {
					"VpcId": {
						"locationName": "vpcId"
					},
					"State": {
						"locationName": "state"
					}
				}
			},
			"S1w": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"IpProtocol": {
							"locationName": "ipProtocol"
						},
						"FromPort": {
							"locationName": "fromPort",
							"type": "integer"
						},
						"ToPort": {
							"locationName": "toPort",
							"type": "integer"
						},
						"UserIdGroupPairs": {
							"locationName": "groups",
							"type": "list",
							"member": {
								"shape": "S1z",
								"locationName": "item"
							}
						},
						"IpRanges": {
							"locationName": "ipRanges",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CidrIp": {
										"locationName": "cidrIp"
									}
								}
							}
						},
						"Ipv6Ranges": {
							"locationName": "ipv6Ranges",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"CidrIpv6": {
										"locationName": "cidrIpv6"
									}
								}
							}
						},
						"PrefixListIds": {
							"locationName": "prefixListIds",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"PrefixListId": {
										"locationName": "prefixListId"
									}
								}
							}
						}
					}
				}
			},
			"S1z": {
				"type": "structure",
				"members": {
					"UserId": {
						"locationName": "userId"
					},
					"GroupName": {
						"locationName": "groupName"
					},
					"GroupId": {
						"locationName": "groupId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"VpcPeeringConnectionId": {
						"locationName": "vpcPeeringConnectionId"
					},
					"PeeringStatus": {
						"locationName": "peeringStatus"
					}
				}
			},
			"S28": {
				"type": "structure",
				"members": {
					"S3": {
						"type": "structure",
						"members": {
							"Bucket": {
								"locationName": "bucket"
							},
							"Prefix": {
								"locationName": "prefix"
							},
							"AWSAccessKeyId": {},
							"UploadPolicy": {
								"locationName": "uploadPolicy",
								"type": "blob"
							},
							"UploadPolicySignature": {
								"locationName": "uploadPolicySignature"
							}
						}
					}
				}
			},
			"S2c": {
				"type": "structure",
				"members": {
					"InstanceId": {
						"locationName": "instanceId"
					},
					"BundleId": {
						"locationName": "bundleId"
					},
					"State": {
						"locationName": "state"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					},
					"UpdateTime": {
						"locationName": "updateTime",
						"type": "timestamp"
					},
					"Storage": {
						"shape": "S28",
						"locationName": "storage"
					},
					"Progress": {
						"locationName": "progress"
					},
					"BundleTaskError": {
						"locationName": "error",
						"type": "structure",
						"members": {
							"Code": {
								"locationName": "code"
							},
							"Message": {
								"locationName": "message"
							}
						}
					}
				}
			},
			"S2n": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"ReservedInstancesListingId": {
							"locationName": "reservedInstancesListingId"
						},
						"ReservedInstancesId": {
							"locationName": "reservedInstancesId"
						},
						"CreateDate": {
							"locationName": "createDate",
							"type": "timestamp"
						},
						"UpdateDate": {
							"locationName": "updateDate",
							"type": "timestamp"
						},
						"Status": {
							"locationName": "status"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						},
						"InstanceCounts": {
							"locationName": "instanceCounts",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"State": {
										"locationName": "state"
									},
									"InstanceCount": {
										"locationName": "instanceCount",
										"type": "integer"
									}
								}
							}
						},
						"PriceSchedules": {
							"locationName": "priceSchedules",
							"type": "list",
							"member": {
								"locationName": "item",
								"type": "structure",
								"members": {
									"Term": {
										"locationName": "term",
										"type": "long"
									},
									"Price": {
										"locationName": "price",
										"type": "double"
									},
									"CurrencyCode": {
										"locationName": "currencyCode"
									},
									"Active": {
										"locationName": "active",
										"type": "boolean"
									}
								}
							}
						},
						"Tags": {
							"shape": "Sj",
							"locationName": "tagSet"
						},
						"ClientToken": {
							"locationName": "clientToken"
						}
					}
				}
			},
			"S2z": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"S39": {
				"type": "list",
				"member": {
					"locationName": "SpotInstanceRequestId"
				}
			},
			"S3n": {
				"type": "structure",
				"members": {
					"CustomerGatewayId": {
						"locationName": "customerGatewayId"
					},
					"State": {
						"locationName": "state"
					},
					"Type": {
						"locationName": "type"
					},
					"IpAddress": {
						"locationName": "ipAddress"
					},
					"BgpAsn": {
						"locationName": "bgpAsn"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					}
				}
			},
			"S3s": {
				"type": "structure",
				"members": {
					"DhcpOptionsId": {
						"locationName": "dhcpOptionsId"
					},
					"DhcpConfigurations": {
						"locationName": "dhcpConfigurationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Key": {
									"locationName": "key"
								},
								"Values": {
									"locationName": "valueSet",
									"type": "list",
									"member": {
										"shape": "S3w",
										"locationName": "item"
									}
								}
							}
						}
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					}
				}
			},
			"S3w": {
				"type": "structure",
				"members": {
					"Value": {
						"locationName": "value"
					}
				}
			},
			"S3z": {
				"type": "structure",
				"members": {
					"EgressOnlyInternetGatewayId": {
						"locationName": "egressOnlyInternetGatewayId"
					},
					"Attachments": {
						"shape": "S41",
						"locationName": "attachmentSet"
					}
				}
			},
			"S41": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"VpcId": {
							"locationName": "vpcId"
						},
						"State": {
							"locationName": "state"
						}
					}
				}
			},
			"S47": {
				"type": "list",
				"member": {
					"shape": "S48",
					"locationName": "item"
				}
			},
			"S48": {
				"type": "structure",
				"required": [
					"Error"
				],
				"members": {
					"ResourceId": {
						"locationName": "resourceId"
					},
					"Error": {
						"locationName": "error",
						"type": "structure",
						"required": [
							"Code",
							"Message"
						],
						"members": {
							"Code": {
								"locationName": "code"
							},
							"Message": {
								"locationName": "message"
							}
						}
					}
				}
			},
			"S4b": {
				"type": "list",
				"member": {
					"shape": "S4c",
					"locationName": "BlockDeviceMapping"
				}
			},
			"S4c": {
				"type": "structure",
				"members": {
					"VirtualName": {
						"locationName": "virtualName"
					},
					"DeviceName": {
						"locationName": "deviceName"
					},
					"Ebs": {
						"locationName": "ebs",
						"type": "structure",
						"members": {
							"SnapshotId": {
								"locationName": "snapshotId"
							},
							"VolumeSize": {
								"locationName": "volumeSize",
								"type": "integer"
							},
							"DeleteOnTermination": {
								"locationName": "deleteOnTermination",
								"type": "boolean"
							},
							"VolumeType": {
								"locationName": "volumeType"
							},
							"Iops": {
								"locationName": "iops",
								"type": "integer"
							},
							"Encrypted": {
								"locationName": "encrypted",
								"type": "boolean"
							}
						}
					},
					"NoDevice": {
						"locationName": "noDevice"
					}
				}
			},
			"S4m": {
				"type": "structure",
				"members": {
					"ExportTaskId": {
						"locationName": "exportTaskId"
					},
					"Description": {
						"locationName": "description"
					},
					"State": {
						"locationName": "state"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"InstanceExportDetails": {
						"locationName": "instanceExport",
						"type": "structure",
						"members": {
							"InstanceId": {
								"locationName": "instanceId"
							},
							"TargetEnvironment": {
								"locationName": "targetEnvironment"
							}
						}
					},
					"ExportToS3Task": {
						"locationName": "exportToS3",
						"type": "structure",
						"members": {
							"DiskImageFormat": {
								"locationName": "diskImageFormat"
							},
							"ContainerFormat": {
								"locationName": "containerFormat"
							},
							"S3Bucket": {
								"locationName": "s3Bucket"
							},
							"S3Key": {
								"locationName": "s3Key"
							}
						}
					}
				}
			},
			"S4s": {
				"type": "structure",
				"members": {
					"InternetGatewayId": {
						"locationName": "internetGatewayId"
					},
					"Attachments": {
						"shape": "S41",
						"locationName": "attachmentSet"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					}
				}
			},
			"S4x": {
				"type": "structure",
				"members": {
					"VpcId": {
						"locationName": "vpcId"
					},
					"SubnetId": {
						"locationName": "subnetId"
					},
					"NatGatewayId": {
						"locationName": "natGatewayId"
					},
					"CreateTime": {
						"locationName": "createTime",
						"type": "timestamp"
					},
					"DeleteTime": {
						"locationName": "deleteTime",
						"type": "timestamp"
					},
					"NatGatewayAddresses": {
						"locationName": "natGatewayAddressSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"PublicIp": {
									"locationName": "publicIp"
								},
								"AllocationId": {
									"locationName": "allocationId"
								},
								"PrivateIp": {
									"locationName": "privateIp"
								},
								"NetworkInterfaceId": {
									"locationName": "networkInterfaceId"
								}
							}
						}
					},
					"State": {
						"locationName": "state"
					},
					"FailureCode": {
						"locationName": "failureCode"
					},
					"FailureMessage": {
						"locationName": "failureMessage"
					},
					"ProvisionedBandwidth": {
						"locationName": "provisionedBandwidth",
						"type": "structure",
						"members": {
							"Provisioned": {
								"locationName": "provisioned"
							},
							"Requested": {
								"locationName": "requested"
							},
							"RequestTime": {
								"locationName": "requestTime",
								"type": "timestamp"
							},
							"ProvisionTime": {
								"locationName": "provisionTime",
								"type": "timestamp"
							},
							"Status": {
								"locationName": "status"
							}
						}
					}
				}
			},
			"S54": {
				"type": "structure",
				"members": {
					"NetworkAclId": {
						"locationName": "networkAclId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"IsDefault": {
						"locationName": "default",
						"type": "boolean"
					},
					"Entries": {
						"locationName": "entrySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"RuleNumber": {
									"locationName": "ruleNumber",
									"type": "integer"
								},
								"Protocol": {
									"locationName": "protocol"
								},
								"RuleAction": {
									"locationName": "ruleAction"
								},
								"Egress": {
									"locationName": "egress",
									"type": "boolean"
								},
								"CidrBlock": {
									"locationName": "cidrBlock"
								},
								"Ipv6CidrBlock": {
									"locationName": "ipv6CidrBlock"
								},
								"IcmpTypeCode": {
									"shape": "S58",
									"locationName": "icmpTypeCode"
								},
								"PortRange": {
									"shape": "S59",
									"locationName": "portRange"
								}
							}
						}
					},
					"Associations": {
						"locationName": "associationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"NetworkAclAssociationId": {
									"locationName": "networkAclAssociationId"
								},
								"NetworkAclId": {
									"locationName": "networkAclId"
								},
								"SubnetId": {
									"locationName": "subnetId"
								}
							}
						}
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					}
				}
			},
			"S58": {
				"type": "structure",
				"members": {
					"Type": {
						"locationName": "type",
						"type": "integer"
					},
					"Code": {
						"locationName": "code",
						"type": "integer"
					}
				}
			},
			"S59": {
				"type": "structure",
				"members": {
					"From": {
						"locationName": "from",
						"type": "integer"
					},
					"To": {
						"locationName": "to",
						"type": "integer"
					}
				}
			},
			"S5e": {
				"type": "list",
				"member": {
					"locationName": "SecurityGroupId"
				}
			},
			"S5f": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"required": [
						"PrivateIpAddress"
					],
					"members": {
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						},
						"Primary": {
							"locationName": "primary",
							"type": "boolean"
						}
					}
				}
			},
			"S5h": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Ipv6Address": {
							"locationName": "ipv6Address"
						}
					}
				}
			},
			"S5k": {
				"type": "structure",
				"members": {
					"NetworkInterfaceId": {
						"locationName": "networkInterfaceId"
					},
					"SubnetId": {
						"locationName": "subnetId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"Description": {
						"locationName": "description"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"RequesterId": {
						"locationName": "requesterId"
					},
					"RequesterManaged": {
						"locationName": "requesterManaged",
						"type": "boolean"
					},
					"Status": {
						"locationName": "status"
					},
					"MacAddress": {
						"locationName": "macAddress"
					},
					"PrivateIpAddress": {
						"locationName": "privateIpAddress"
					},
					"PrivateDnsName": {
						"locationName": "privateDnsName"
					},
					"SourceDestCheck": {
						"locationName": "sourceDestCheck",
						"type": "boolean"
					},
					"Groups": {
						"shape": "S5m",
						"locationName": "groupSet"
					},
					"Attachment": {
						"shape": "S5o",
						"locationName": "attachment"
					},
					"Association": {
						"shape": "S5p",
						"locationName": "association"
					},
					"TagSet": {
						"shape": "Sj",
						"locationName": "tagSet"
					},
					"PrivateIpAddresses": {
						"locationName": "privateIpAddressesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"PrivateIpAddress": {
									"locationName": "privateIpAddress"
								},
								"PrivateDnsName": {
									"locationName": "privateDnsName"
								},
								"Primary": {
									"locationName": "primary",
									"type": "boolean"
								},
								"Association": {
									"shape": "S5p",
									"locationName": "association"
								}
							}
						}
					},
					"Ipv6Addresses": {
						"locationName": "ipv6AddressesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Ipv6Address": {
									"locationName": "ipv6Address"
								}
							}
						}
					},
					"InterfaceType": {
						"locationName": "interfaceType"
					}
				}
			},
			"S5m": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"GroupName": {
							"locationName": "groupName"
						},
						"GroupId": {
							"locationName": "groupId"
						}
					}
				}
			},
			"S5o": {
				"type": "structure",
				"members": {
					"AttachmentId": {
						"locationName": "attachmentId"
					},
					"InstanceId": {
						"locationName": "instanceId"
					},
					"InstanceOwnerId": {
						"locationName": "instanceOwnerId"
					},
					"DeviceIndex": {
						"locationName": "deviceIndex",
						"type": "integer"
					},
					"Status": {
						"locationName": "status"
					},
					"AttachTime": {
						"locationName": "attachTime",
						"type": "timestamp"
					},
					"DeleteOnTermination": {
						"locationName": "deleteOnTermination",
						"type": "boolean"
					}
				}
			},
			"S5p": {
				"type": "structure",
				"members": {
					"PublicIp": {
						"locationName": "publicIp"
					},
					"PublicDnsName": {
						"locationName": "publicDnsName"
					},
					"IpOwnerId": {
						"locationName": "ipOwnerId"
					},
					"AllocationId": {
						"locationName": "allocationId"
					},
					"AssociationId": {
						"locationName": "associationId"
					}
				}
			},
			"S65": {
				"type": "structure",
				"members": {
					"RouteTableId": {
						"locationName": "routeTableId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"Routes": {
						"locationName": "routeSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"DestinationCidrBlock": {
									"locationName": "destinationCidrBlock"
								},
								"DestinationPrefixListId": {
									"locationName": "destinationPrefixListId"
								},
								"GatewayId": {
									"locationName": "gatewayId"
								},
								"InstanceId": {
									"locationName": "instanceId"
								},
								"InstanceOwnerId": {
									"locationName": "instanceOwnerId"
								},
								"NetworkInterfaceId": {
									"locationName": "networkInterfaceId"
								},
								"VpcPeeringConnectionId": {
									"locationName": "vpcPeeringConnectionId"
								},
								"NatGatewayId": {
									"locationName": "natGatewayId"
								},
								"State": {
									"locationName": "state"
								},
								"Origin": {
									"locationName": "origin"
								},
								"DestinationIpv6CidrBlock": {
									"locationName": "destinationIpv6CidrBlock"
								},
								"EgressOnlyInternetGatewayId": {
									"locationName": "egressOnlyInternetGatewayId"
								}
							}
						}
					},
					"Associations": {
						"locationName": "associationSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"RouteTableAssociationId": {
									"locationName": "routeTableAssociationId"
								},
								"RouteTableId": {
									"locationName": "routeTableId"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"Main": {
									"locationName": "main",
									"type": "boolean"
								}
							}
						}
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					},
					"PropagatingVgws": {
						"locationName": "propagatingVgwSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"GatewayId": {
									"locationName": "gatewayId"
								}
							}
						}
					}
				}
			},
			"S6h": {
				"type": "structure",
				"members": {
					"SnapshotId": {
						"locationName": "snapshotId"
					},
					"VolumeId": {
						"locationName": "volumeId"
					},
					"State": {
						"locationName": "status"
					},
					"StateMessage": {
						"locationName": "statusMessage"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					},
					"Progress": {
						"locationName": "progress"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Description": {
						"locationName": "description"
					},
					"VolumeSize": {
						"locationName": "volumeSize",
						"type": "integer"
					},
					"OwnerAlias": {
						"locationName": "ownerAlias"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"KmsKeyId": {
						"locationName": "kmsKeyId"
					},
					"DataEncryptionKeyId": {
						"locationName": "dataEncryptionKeyId"
					}
				}
			},
			"S6l": {
				"type": "structure",
				"members": {
					"OwnerId": {
						"locationName": "ownerId"
					},
					"Bucket": {
						"locationName": "bucket"
					},
					"Prefix": {
						"locationName": "prefix"
					},
					"State": {
						"locationName": "state"
					},
					"Fault": {
						"shape": "S6n",
						"locationName": "fault"
					}
				}
			},
			"S6n": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code"
					},
					"Message": {
						"locationName": "message"
					}
				}
			},
			"S6q": {
				"type": "structure",
				"members": {
					"SubnetId": {
						"locationName": "subnetId"
					},
					"State": {
						"locationName": "state"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"Ipv6CidrBlockAssociationSet": {
						"locationName": "ipv6CidrBlockAssociationSet",
						"type": "list",
						"member": {
							"shape": "S1a",
							"locationName": "item"
						}
					},
					"AssignIpv6AddressOnCreation": {
						"locationName": "assignIpv6AddressOnCreation",
						"type": "boolean"
					},
					"AvailableIpAddressCount": {
						"locationName": "availableIpAddressCount",
						"type": "integer"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"DefaultForAz": {
						"locationName": "defaultForAz",
						"type": "boolean"
					},
					"MapPublicIpOnLaunch": {
						"locationName": "mapPublicIpOnLaunch",
						"type": "boolean"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					}
				}
			},
			"S6u": {
				"type": "list",
				"member": {}
			},
			"S6w": {
				"type": "structure",
				"members": {
					"VolumeId": {
						"locationName": "volumeId"
					},
					"Size": {
						"locationName": "size",
						"type": "integer"
					},
					"SnapshotId": {
						"locationName": "snapshotId"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"State": {
						"locationName": "status"
					},
					"CreateTime": {
						"locationName": "createTime",
						"type": "timestamp"
					},
					"Attachments": {
						"locationName": "attachmentSet",
						"type": "list",
						"member": {
							"shape": "S1p",
							"locationName": "item"
						}
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					},
					"VolumeType": {
						"locationName": "volumeType"
					},
					"Iops": {
						"locationName": "iops",
						"type": "integer"
					},
					"Encrypted": {
						"locationName": "encrypted",
						"type": "boolean"
					},
					"KmsKeyId": {
						"locationName": "kmsKeyId"
					}
				}
			},
			"S72": {
				"type": "structure",
				"members": {
					"VpcId": {
						"locationName": "vpcId"
					},
					"State": {
						"locationName": "state"
					},
					"CidrBlock": {
						"locationName": "cidrBlock"
					},
					"DhcpOptionsId": {
						"locationName": "dhcpOptionsId"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					},
					"InstanceTenancy": {
						"locationName": "instanceTenancy"
					},
					"IsDefault": {
						"locationName": "isDefault",
						"type": "boolean"
					},
					"Ipv6CidrBlockAssociationSet": {
						"locationName": "ipv6CidrBlockAssociationSet",
						"type": "list",
						"member": {
							"shape": "S1f",
							"locationName": "item"
						}
					}
				}
			},
			"S77": {
				"type": "structure",
				"members": {
					"VpcEndpointId": {
						"locationName": "vpcEndpointId"
					},
					"VpcId": {
						"locationName": "vpcId"
					},
					"ServiceName": {
						"locationName": "serviceName"
					},
					"State": {
						"locationName": "state"
					},
					"PolicyDocument": {
						"locationName": "policyDocument"
					},
					"RouteTableIds": {
						"shape": "S2z",
						"locationName": "routeTableIdSet"
					},
					"CreationTimestamp": {
						"locationName": "creationTimestamp",
						"type": "timestamp"
					}
				}
			},
			"S7e": {
				"type": "structure",
				"members": {
					"VpnConnectionId": {
						"locationName": "vpnConnectionId"
					},
					"State": {
						"locationName": "state"
					},
					"CustomerGatewayConfiguration": {
						"locationName": "customerGatewayConfiguration"
					},
					"Type": {
						"locationName": "type"
					},
					"CustomerGatewayId": {
						"locationName": "customerGatewayId"
					},
					"VpnGatewayId": {
						"locationName": "vpnGatewayId"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					},
					"VgwTelemetry": {
						"locationName": "vgwTelemetry",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"OutsideIpAddress": {
									"locationName": "outsideIpAddress"
								},
								"Status": {
									"locationName": "status"
								},
								"LastStatusChange": {
									"locationName": "lastStatusChange",
									"type": "timestamp"
								},
								"StatusMessage": {
									"locationName": "statusMessage"
								},
								"AcceptedRouteCount": {
									"locationName": "acceptedRouteCount",
									"type": "integer"
								}
							}
						}
					},
					"Options": {
						"locationName": "options",
						"type": "structure",
						"members": {
							"StaticRoutesOnly": {
								"locationName": "staticRoutesOnly",
								"type": "boolean"
							}
						}
					},
					"Routes": {
						"locationName": "routes",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"DestinationCidrBlock": {
									"locationName": "destinationCidrBlock"
								},
								"Source": {
									"locationName": "source"
								},
								"State": {
									"locationName": "state"
								}
							}
						}
					}
				}
			},
			"S7q": {
				"type": "structure",
				"members": {
					"VpnGatewayId": {
						"locationName": "vpnGatewayId"
					},
					"State": {
						"locationName": "state"
					},
					"Type": {
						"locationName": "type"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"VpcAttachments": {
						"locationName": "attachments",
						"type": "list",
						"member": {
							"shape": "S1t",
							"locationName": "item"
						}
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					}
				}
			},
			"S8x": {
				"type": "list",
				"member": {
					"locationName": "Filter",
					"type": "structure",
					"members": {
						"Name": {},
						"Values": {
							"shape": "S2z",
							"locationName": "Value"
						}
					}
				}
			},
			"S9g": {
				"type": "list",
				"member": {
					"locationName": "InstanceId"
				}
			},
			"S9o": {
				"type": "structure",
				"required": [
					"ConversionTaskId",
					"State"
				],
				"members": {
					"ConversionTaskId": {
						"locationName": "conversionTaskId"
					},
					"ExpirationTime": {
						"locationName": "expirationTime"
					},
					"ImportInstance": {
						"locationName": "importInstance",
						"type": "structure",
						"required": [
							"Volumes"
						],
						"members": {
							"Volumes": {
								"locationName": "volumes",
								"type": "list",
								"member": {
									"locationName": "item",
									"type": "structure",
									"required": [
										"BytesConverted",
										"AvailabilityZone",
										"Image",
										"Volume",
										"Status"
									],
									"members": {
										"BytesConverted": {
											"locationName": "bytesConverted",
											"type": "long"
										},
										"AvailabilityZone": {
											"locationName": "availabilityZone"
										},
										"Image": {
											"shape": "S9s",
											"locationName": "image"
										},
										"Volume": {
											"shape": "S9t",
											"locationName": "volume"
										},
										"Status": {
											"locationName": "status"
										},
										"StatusMessage": {
											"locationName": "statusMessage"
										},
										"Description": {
											"locationName": "description"
										}
									}
								}
							},
							"InstanceId": {
								"locationName": "instanceId"
							},
							"Platform": {
								"locationName": "platform"
							},
							"Description": {
								"locationName": "description"
							}
						}
					},
					"ImportVolume": {
						"locationName": "importVolume",
						"type": "structure",
						"required": [
							"BytesConverted",
							"AvailabilityZone",
							"Image",
							"Volume"
						],
						"members": {
							"BytesConverted": {
								"locationName": "bytesConverted",
								"type": "long"
							},
							"AvailabilityZone": {
								"locationName": "availabilityZone"
							},
							"Description": {
								"locationName": "description"
							},
							"Image": {
								"shape": "S9s",
								"locationName": "image"
							},
							"Volume": {
								"shape": "S9t",
								"locationName": "volume"
							}
						}
					},
					"State": {
						"locationName": "state"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"Tags": {
						"shape": "Sj",
						"locationName": "tagSet"
					}
				}
			},
			"S9s": {
				"type": "structure",
				"required": [
					"Format",
					"Size",
					"ImportManifestUrl"
				],
				"members": {
					"Format": {
						"locationName": "format"
					},
					"Size": {
						"locationName": "size",
						"type": "long"
					},
					"ImportManifestUrl": {
						"locationName": "importManifestUrl"
					},
					"Checksum": {
						"locationName": "checksum"
					}
				}
			},
			"S9t": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Size": {
						"locationName": "size",
						"type": "long"
					},
					"Id": {
						"locationName": "id"
					}
				}
			},
			"Sar": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Sau": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Sbd": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Resource": {
							"locationName": "resource"
						},
						"UseLongIds": {
							"locationName": "useLongIds",
							"type": "boolean"
						},
						"Deadline": {
							"locationName": "deadline",
							"type": "timestamp"
						}
					}
				}
			},
			"Sbk": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"UserId": {
							"locationName": "userId"
						},
						"Group": {
							"locationName": "group"
						}
					}
				}
			},
			"Sbn": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"ProductCodeId": {
							"locationName": "productCode"
						},
						"ProductCodeType": {
							"locationName": "type"
						}
					}
				}
			},
			"Sbq": {
				"type": "list",
				"member": {
					"shape": "S4c",
					"locationName": "item"
				}
			},
			"Sbt": {
				"type": "list",
				"member": {
					"locationName": "Owner"
				}
			},
			"Sc1": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code"
					},
					"Message": {
						"locationName": "message"
					}
				}
			},
			"Sc6": {
				"type": "list",
				"member": {
					"locationName": "ImportTaskId"
				}
			},
			"Sca": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"DiskImageSize": {
							"locationName": "diskImageSize",
							"type": "double"
						},
						"Description": {
							"locationName": "description"
						},
						"Format": {
							"locationName": "format"
						},
						"Url": {
							"locationName": "url"
						},
						"UserBucket": {
							"shape": "Scc",
							"locationName": "userBucket"
						},
						"DeviceName": {
							"locationName": "deviceName"
						},
						"SnapshotId": {
							"locationName": "snapshotId"
						},
						"Progress": {
							"locationName": "progress"
						},
						"StatusMessage": {
							"locationName": "statusMessage"
						},
						"Status": {
							"locationName": "status"
						}
					}
				}
			},
			"Scc": {
				"type": "structure",
				"members": {
					"S3Bucket": {
						"locationName": "s3Bucket"
					},
					"S3Key": {
						"locationName": "s3Key"
					}
				}
			},
			"Sch": {
				"type": "structure",
				"members": {
					"DiskImageSize": {
						"locationName": "diskImageSize",
						"type": "double"
					},
					"Description": {
						"locationName": "description"
					},
					"Format": {
						"locationName": "format"
					},
					"Url": {
						"locationName": "url"
					},
					"UserBucket": {
						"shape": "Scc",
						"locationName": "userBucket"
					},
					"SnapshotId": {
						"locationName": "snapshotId"
					},
					"Progress": {
						"locationName": "progress"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"Status": {
						"locationName": "status"
					}
				}
			},
			"Scl": {
				"type": "structure",
				"members": {
					"Value": {
						"locationName": "value",
						"type": "boolean"
					}
				}
			},
			"Scm": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"DeviceName": {
							"locationName": "deviceName"
						},
						"Ebs": {
							"locationName": "ebs",
							"type": "structure",
							"members": {
								"VolumeId": {
									"locationName": "volumeId"
								},
								"Status": {
									"locationName": "status"
								},
								"AttachTime": {
									"locationName": "attachTime",
									"type": "timestamp"
								},
								"DeleteOnTermination": {
									"locationName": "deleteOnTermination",
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"Scw": {
				"type": "structure",
				"members": {
					"Code": {
						"locationName": "code",
						"type": "integer"
					},
					"Name": {
						"locationName": "name"
					}
				}
			},
			"Scy": {
				"type": "structure",
				"members": {
					"Status": {
						"locationName": "status"
					},
					"Details": {
						"locationName": "details",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"Name": {
									"locationName": "name"
								},
								"Status": {
									"locationName": "status"
								},
								"ImpairedSince": {
									"locationName": "impairedSince",
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"Sd7": {
				"type": "structure",
				"members": {
					"ReservationId": {
						"locationName": "reservationId"
					},
					"OwnerId": {
						"locationName": "ownerId"
					},
					"RequesterId": {
						"locationName": "requesterId"
					},
					"Groups": {
						"shape": "S5m",
						"locationName": "groupSet"
					},
					"Instances": {
						"locationName": "instancesSet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"InstanceId": {
									"locationName": "instanceId"
								},
								"ImageId": {
									"locationName": "imageId"
								},
								"State": {
									"shape": "Scw",
									"locationName": "instanceState"
								},
								"PrivateDnsName": {
									"locationName": "privateDnsName"
								},
								"PublicDnsName": {
									"locationName": "dnsName"
								},
								"StateTransitionReason": {
									"locationName": "reason"
								},
								"KeyName": {
									"locationName": "keyName"
								},
								"AmiLaunchIndex": {
									"locationName": "amiLaunchIndex",
									"type": "integer"
								},
								"ProductCodes": {
									"shape": "Sbn",
									"locationName": "productCodes"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"LaunchTime": {
									"locationName": "launchTime",
									"type": "timestamp"
								},
								"Placement": {
									"shape": "Sdb",
									"locationName": "placement"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"Platform": {
									"locationName": "platform"
								},
								"Monitoring": {
									"shape": "Sdc",
									"locationName": "monitoring"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"VpcId": {
									"locationName": "vpcId"
								},
								"PrivateIpAddress": {
									"locationName": "privateIpAddress"
								},
								"PublicIpAddress": {
									"locationName": "ipAddress"
								},
								"StateReason": {
									"shape": "Sc1",
									"locationName": "stateReason"
								},
								"Architecture": {
									"locationName": "architecture"
								},
								"RootDeviceType": {
									"locationName": "rootDeviceType"
								},
								"RootDeviceName": {
									"locationName": "rootDeviceName"
								},
								"BlockDeviceMappings": {
									"shape": "Scm",
									"locationName": "blockDeviceMapping"
								},
								"VirtualizationType": {
									"locationName": "virtualizationType"
								},
								"InstanceLifecycle": {
									"locationName": "instanceLifecycle"
								},
								"SpotInstanceRequestId": {
									"locationName": "spotInstanceRequestId"
								},
								"ClientToken": {
									"locationName": "clientToken"
								},
								"Tags": {
									"shape": "Sj",
									"locationName": "tagSet"
								},
								"SecurityGroups": {
									"shape": "S5m",
									"locationName": "groupSet"
								},
								"SourceDestCheck": {
									"locationName": "sourceDestCheck",
									"type": "boolean"
								},
								"Hypervisor": {
									"locationName": "hypervisor"
								},
								"NetworkInterfaces": {
									"locationName": "networkInterfaceSet",
									"type": "list",
									"member": {
										"locationName": "item",
										"type": "structure",
										"members": {
											"NetworkInterfaceId": {
												"locationName": "networkInterfaceId"
											},
											"SubnetId": {
												"locationName": "subnetId"
											},
											"VpcId": {
												"locationName": "vpcId"
											},
											"Description": {
												"locationName": "description"
											},
											"OwnerId": {
												"locationName": "ownerId"
											},
											"Status": {
												"locationName": "status"
											},
											"MacAddress": {
												"locationName": "macAddress"
											},
											"PrivateIpAddress": {
												"locationName": "privateIpAddress"
											},
											"PrivateDnsName": {
												"locationName": "privateDnsName"
											},
											"SourceDestCheck": {
												"locationName": "sourceDestCheck",
												"type": "boolean"
											},
											"Groups": {
												"shape": "S5m",
												"locationName": "groupSet"
											},
											"Attachment": {
												"locationName": "attachment",
												"type": "structure",
												"members": {
													"AttachmentId": {
														"locationName": "attachmentId"
													},
													"DeviceIndex": {
														"locationName": "deviceIndex",
														"type": "integer"
													},
													"Status": {
														"locationName": "status"
													},
													"AttachTime": {
														"locationName": "attachTime",
														"type": "timestamp"
													},
													"DeleteOnTermination": {
														"locationName": "deleteOnTermination",
														"type": "boolean"
													}
												}
											},
											"Association": {
												"shape": "Sdi",
												"locationName": "association"
											},
											"PrivateIpAddresses": {
												"locationName": "privateIpAddressesSet",
												"type": "list",
												"member": {
													"locationName": "item",
													"type": "structure",
													"members": {
														"PrivateIpAddress": {
															"locationName": "privateIpAddress"
														},
														"PrivateDnsName": {
															"locationName": "privateDnsName"
														},
														"Primary": {
															"locationName": "primary",
															"type": "boolean"
														},
														"Association": {
															"shape": "Sdi",
															"locationName": "association"
														}
													}
												}
											},
											"Ipv6Addresses": {
												"shape": "S5h",
												"locationName": "ipv6AddressesSet"
											}
										}
									}
								},
								"IamInstanceProfile": {
									"shape": "S14",
									"locationName": "iamInstanceProfile"
								},
								"EbsOptimized": {
									"locationName": "ebsOptimized",
									"type": "boolean"
								},
								"SriovNetSupport": {
									"locationName": "sriovNetSupport"
								},
								"EnaSupport": {
									"locationName": "enaSupport",
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"Sdb": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"GroupName": {
						"locationName": "groupName"
					},
					"Tenancy": {
						"locationName": "tenancy"
					},
					"HostId": {
						"locationName": "hostId"
					},
					"Affinity": {
						"locationName": "affinity"
					}
				}
			},
			"Sdc": {
				"type": "structure",
				"members": {
					"State": {
						"locationName": "state"
					}
				}
			},
			"Sdi": {
				"type": "structure",
				"members": {
					"PublicIp": {
						"locationName": "publicIp"
					},
					"PublicDnsName": {
						"locationName": "publicDnsName"
					},
					"IpOwnerId": {
						"locationName": "ipOwnerId"
					}
				}
			},
			"Ser": {
				"type": "list",
				"member": {
					"locationName": "ReservedInstancesId"
				}
			},
			"Sf0": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"Frequency": {
							"locationName": "frequency"
						},
						"Amount": {
							"locationName": "amount",
							"type": "double"
						}
					}
				}
			},
			"Sff": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"Platform": {
						"locationName": "platform"
					},
					"InstanceCount": {
						"locationName": "instanceCount",
						"type": "integer"
					},
					"InstanceType": {
						"locationName": "instanceType"
					},
					"Scope": {
						"locationName": "scope"
					}
				}
			},
			"Sfx": {
				"type": "structure",
				"members": {
					"Frequency": {
						"locationName": "frequency"
					},
					"Interval": {
						"locationName": "interval",
						"type": "integer"
					},
					"OccurrenceDaySet": {
						"locationName": "occurrenceDaySet",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "integer"
						}
					},
					"OccurrenceRelativeToEnd": {
						"locationName": "occurrenceRelativeToEnd",
						"type": "boolean"
					},
					"OccurrenceUnit": {
						"locationName": "occurrenceUnit"
					}
				}
			},
			"Sg4": {
				"type": "structure",
				"members": {
					"ScheduledInstanceId": {
						"locationName": "scheduledInstanceId"
					},
					"InstanceType": {
						"locationName": "instanceType"
					},
					"Platform": {
						"locationName": "platform"
					},
					"NetworkPlatform": {
						"locationName": "networkPlatform"
					},
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"SlotDurationInHours": {
						"locationName": "slotDurationInHours",
						"type": "integer"
					},
					"Recurrence": {
						"shape": "Sfx",
						"locationName": "recurrence"
					},
					"PreviousSlotEndTime": {
						"locationName": "previousSlotEndTime",
						"type": "timestamp"
					},
					"NextSlotStartTime": {
						"locationName": "nextSlotStartTime",
						"type": "timestamp"
					},
					"HourlyPrice": {
						"locationName": "hourlyPrice"
					},
					"TotalScheduledInstanceHours": {
						"locationName": "totalScheduledInstanceHours",
						"type": "integer"
					},
					"InstanceCount": {
						"locationName": "instanceCount",
						"type": "integer"
					},
					"TermStartDate": {
						"locationName": "termStartDate",
						"type": "timestamp"
					},
					"TermEndDate": {
						"locationName": "termEndDate",
						"type": "timestamp"
					},
					"CreateDate": {
						"locationName": "createDate",
						"type": "timestamp"
					}
				}
			},
			"Sgb": {
				"type": "list",
				"member": {
					"locationName": "GroupName"
				}
			},
			"Sgi": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"UserId": {
							"locationName": "userId"
						},
						"Group": {
							"locationName": "group"
						}
					}
				}
			},
			"Sh6": {
				"type": "structure",
				"required": [
					"SpotPrice",
					"TargetCapacity",
					"IamFleetRole",
					"LaunchSpecifications"
				],
				"members": {
					"ClientToken": {
						"locationName": "clientToken"
					},
					"SpotPrice": {
						"locationName": "spotPrice"
					},
					"TargetCapacity": {
						"locationName": "targetCapacity",
						"type": "integer"
					},
					"ValidFrom": {
						"locationName": "validFrom",
						"type": "timestamp"
					},
					"ValidUntil": {
						"locationName": "validUntil",
						"type": "timestamp"
					},
					"TerminateInstancesWithExpiration": {
						"locationName": "terminateInstancesWithExpiration",
						"type": "boolean"
					},
					"IamFleetRole": {
						"locationName": "iamFleetRole"
					},
					"LaunchSpecifications": {
						"locationName": "launchSpecifications",
						"type": "list",
						"member": {
							"locationName": "item",
							"type": "structure",
							"members": {
								"ImageId": {
									"locationName": "imageId"
								},
								"KeyName": {
									"locationName": "keyName"
								},
								"SecurityGroups": {
									"shape": "S5m",
									"locationName": "groupSet"
								},
								"UserData": {
									"locationName": "userData"
								},
								"AddressingType": {
									"locationName": "addressingType"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"Placement": {
									"shape": "Sh9",
									"locationName": "placement"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"BlockDeviceMappings": {
									"shape": "Sbq",
									"locationName": "blockDeviceMapping"
								},
								"Monitoring": {
									"locationName": "monitoring",
									"type": "structure",
									"members": {
										"Enabled": {
											"locationName": "enabled",
											"type": "boolean"
										}
									}
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"NetworkInterfaces": {
									"shape": "Shb",
									"locationName": "networkInterfaceSet"
								},
								"IamInstanceProfile": {
									"shape": "S11",
									"locationName": "iamInstanceProfile"
								},
								"EbsOptimized": {
									"locationName": "ebsOptimized",
									"type": "boolean"
								},
								"WeightedCapacity": {
									"locationName": "weightedCapacity",
									"type": "double"
								},
								"SpotPrice": {
									"locationName": "spotPrice"
								}
							}
						}
					},
					"ExcessCapacityTerminationPolicy": {
						"locationName": "excessCapacityTerminationPolicy"
					},
					"AllocationStrategy": {
						"locationName": "allocationStrategy"
					},
					"FulfilledCapacity": {
						"locationName": "fulfilledCapacity",
						"type": "double"
					},
					"Type": {
						"locationName": "type"
					},
					"ReplaceUnhealthyInstances": {
						"locationName": "replaceUnhealthyInstances",
						"type": "boolean"
					}
				}
			},
			"Sh9": {
				"type": "structure",
				"members": {
					"AvailabilityZone": {
						"locationName": "availabilityZone"
					},
					"GroupName": {
						"locationName": "groupName"
					},
					"Tenancy": {
						"locationName": "tenancy"
					}
				}
			},
			"Shb": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"NetworkInterfaceId": {
							"locationName": "networkInterfaceId"
						},
						"DeviceIndex": {
							"locationName": "deviceIndex",
							"type": "integer"
						},
						"SubnetId": {
							"locationName": "subnetId"
						},
						"Description": {
							"locationName": "description"
						},
						"PrivateIpAddress": {
							"locationName": "privateIpAddress"
						},
						"Groups": {
							"shape": "S5e",
							"locationName": "SecurityGroupId"
						},
						"DeleteOnTermination": {
							"locationName": "deleteOnTermination",
							"type": "boolean"
						},
						"PrivateIpAddresses": {
							"shape": "S5f",
							"locationName": "privateIpAddressesSet",
							"queryName": "PrivateIpAddresses"
						},
						"SecondaryPrivateIpAddressCount": {
							"locationName": "secondaryPrivateIpAddressCount",
							"type": "integer"
						},
						"AssociatePublicIpAddress": {
							"locationName": "associatePublicIpAddress",
							"type": "boolean"
						},
						"Ipv6Addresses": {
							"shape": "S5h",
							"locationName": "ipv6AddressesSet",
							"queryName": "Ipv6Addresses"
						},
						"Ipv6AddressCount": {
							"locationName": "ipv6AddressCount",
							"type": "integer"
						}
					}
				}
			},
			"Shj": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"SpotInstanceRequestId": {
							"locationName": "spotInstanceRequestId"
						},
						"SpotPrice": {
							"locationName": "spotPrice"
						},
						"Type": {
							"locationName": "type"
						},
						"State": {
							"locationName": "state"
						},
						"Fault": {
							"shape": "S6n",
							"locationName": "fault"
						},
						"Status": {
							"locationName": "status",
							"type": "structure",
							"members": {
								"Code": {
									"locationName": "code"
								},
								"UpdateTime": {
									"locationName": "updateTime",
									"type": "timestamp"
								},
								"Message": {
									"locationName": "message"
								}
							}
						},
						"ValidFrom": {
							"locationName": "validFrom",
							"type": "timestamp"
						},
						"ValidUntil": {
							"locationName": "validUntil",
							"type": "timestamp"
						},
						"LaunchGroup": {
							"locationName": "launchGroup"
						},
						"AvailabilityZoneGroup": {
							"locationName": "availabilityZoneGroup"
						},
						"LaunchSpecification": {
							"locationName": "launchSpecification",
							"type": "structure",
							"members": {
								"ImageId": {
									"locationName": "imageId"
								},
								"KeyName": {
									"locationName": "keyName"
								},
								"SecurityGroups": {
									"shape": "S5m",
									"locationName": "groupSet"
								},
								"UserData": {
									"locationName": "userData"
								},
								"AddressingType": {
									"locationName": "addressingType"
								},
								"InstanceType": {
									"locationName": "instanceType"
								},
								"Placement": {
									"shape": "Sh9",
									"locationName": "placement"
								},
								"KernelId": {
									"locationName": "kernelId"
								},
								"RamdiskId": {
									"locationName": "ramdiskId"
								},
								"BlockDeviceMappings": {
									"shape": "Sbq",
									"locationName": "blockDeviceMapping"
								},
								"SubnetId": {
									"locationName": "subnetId"
								},
								"NetworkInterfaces": {
									"shape": "Shb",
									"locationName": "networkInterfaceSet"
								},
								"IamInstanceProfile": {
									"shape": "S11",
									"locationName": "iamInstanceProfile"
								},
								"EbsOptimized": {
									"locationName": "ebsOptimized",
									"type": "boolean"
								},
								"Monitoring": {
									"shape": "Shp",
									"locationName": "monitoring"
								}
							}
						},
						"InstanceId": {
							"locationName": "instanceId"
						},
						"CreateTime": {
							"locationName": "createTime",
							"type": "timestamp"
						},
						"ProductDescription": {
							"locationName": "productDescription"
						},
						"BlockDurationMinutes": {
							"locationName": "blockDurationMinutes",
							"type": "integer"
						},
						"ActualBlockHourlyPrice": {
							"locationName": "actualBlockHourlyPrice"
						},
						"Tags": {
							"shape": "Sj",
							"locationName": "tagSet"
						},
						"LaunchedAvailabilityZone": {
							"locationName": "launchedAvailabilityZone"
						}
					}
				}
			},
			"Shp": {
				"type": "structure",
				"required": [
					"Enabled"
				],
				"members": {
					"Enabled": {
						"locationName": "enabled",
						"type": "boolean"
					}
				}
			},
			"Si0": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"FromPort": {
							"locationName": "fromPort",
							"type": "integer"
						},
						"IpProtocol": {
							"locationName": "ipProtocol"
						},
						"IpRanges": {
							"locationName": "ipRanges",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"PrefixListIds": {
							"locationName": "prefixListIds",
							"type": "list",
							"member": {
								"locationName": "item"
							}
						},
						"ToPort": {
							"locationName": "toPort",
							"type": "integer"
						},
						"UserIdGroupPairs": {
							"locationName": "groups",
							"type": "list",
							"member": {
								"shape": "S1z",
								"locationName": "item"
							}
						}
					}
				}
			},
			"Sii": {
				"type": "list",
				"member": {
					"locationName": "VolumeId"
				}
			},
			"Sj1": {
				"type": "structure",
				"members": {
					"VolumeId": {
						"locationName": "volumeId"
					},
					"ModificationState": {
						"locationName": "modificationState"
					},
					"StatusMessage": {
						"locationName": "statusMessage"
					},
					"TargetSize": {
						"locationName": "targetSize",
						"type": "integer"
					},
					"TargetIops": {
						"locationName": "targetIops",
						"type": "integer"
					},
					"TargetVolumeType": {
						"locationName": "targetVolumeType"
					},
					"OriginalSize": {
						"locationName": "originalSize",
						"type": "integer"
					},
					"OriginalIops": {
						"locationName": "originalIops",
						"type": "integer"
					},
					"OriginalVolumeType": {
						"locationName": "originalVolumeType"
					},
					"Progress": {
						"locationName": "progress",
						"type": "long"
					},
					"StartTime": {
						"locationName": "startTime",
						"type": "timestamp"
					},
					"EndTime": {
						"locationName": "endTime",
						"type": "timestamp"
					}
				}
			},
			"Sj7": {
				"type": "list",
				"member": {
					"locationName": "VpcId"
				}
			},
			"Skt": {
				"type": "list",
				"member": {
					"locationName": "item"
				}
			},
			"Skv": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"HostReservationId": {
							"locationName": "hostReservationId"
						},
						"HostIdSet": {
							"shape": "Sar",
							"locationName": "hostIdSet"
						},
						"InstanceFamily": {
							"locationName": "instanceFamily"
						},
						"PaymentOption": {
							"locationName": "paymentOption"
						},
						"UpfrontPrice": {
							"locationName": "upfrontPrice"
						},
						"HourlyPrice": {
							"locationName": "hourlyPrice"
						},
						"CurrencyCode": {
							"locationName": "currencyCode"
						},
						"Duration": {
							"locationName": "duration",
							"type": "integer"
						}
					}
				}
			},
			"Sl3": {
				"type": "structure",
				"members": {
					"RemainingTotalValue": {
						"locationName": "remainingTotalValue"
					},
					"RemainingUpfrontValue": {
						"locationName": "remainingUpfrontValue"
					},
					"HourlyPrice": {
						"locationName": "hourlyPrice"
					}
				}
			},
			"Sla": {
				"type": "structure",
				"members": {
					"S3Bucket": {},
					"S3Key": {}
				}
			},
			"Slb": {
				"type": "structure",
				"members": {
					"UploadStart": {
						"type": "timestamp"
					},
					"UploadEnd": {
						"type": "timestamp"
					},
					"UploadSize": {
						"type": "double"
					},
					"Comment": {}
				}
			},
			"Slf": {
				"type": "list",
				"member": {
					"locationName": "SecurityGroup"
				}
			},
			"Slk": {
				"type": "structure",
				"required": [
					"Format",
					"Bytes",
					"ImportManifestUrl"
				],
				"members": {
					"Format": {
						"locationName": "format"
					},
					"Bytes": {
						"locationName": "bytes",
						"type": "long"
					},
					"ImportManifestUrl": {
						"locationName": "importManifestUrl"
					}
				}
			},
			"Sll": {
				"type": "structure",
				"required": [
					"Size"
				],
				"members": {
					"Size": {
						"locationName": "size",
						"type": "long"
					}
				}
			},
			"Slw": {
				"type": "list",
				"member": {
					"shape": "S48",
					"locationName": "item"
				}
			},
			"Sm1": {
				"type": "list",
				"member": {
					"locationName": "UserId"
				}
			},
			"Smv": {
				"type": "structure",
				"members": {
					"AllowEgressFromLocalClassicLinkToRemoteVpc": {
						"type": "boolean"
					},
					"AllowEgressFromLocalVpcToRemoteClassicLink": {
						"type": "boolean"
					},
					"AllowDnsResolutionFromRemoteVpc": {
						"type": "boolean"
					}
				}
			},
			"Smx": {
				"type": "structure",
				"members": {
					"AllowEgressFromLocalClassicLinkToRemoteVpc": {
						"locationName": "allowEgressFromLocalClassicLinkToRemoteVpc",
						"type": "boolean"
					},
					"AllowEgressFromLocalVpcToRemoteClassicLink": {
						"locationName": "allowEgressFromLocalVpcToRemoteClassicLink",
						"type": "boolean"
					},
					"AllowDnsResolutionFromRemoteVpc": {
						"locationName": "allowDnsResolutionFromRemoteVpc",
						"type": "boolean"
					}
				}
			},
			"Sn0": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"Monitoring": {
							"shape": "Sdc",
							"locationName": "monitoring"
						}
					}
				}
			},
			"Sog": {
				"type": "list",
				"member": {
					"locationName": "SecurityGroupId"
				}
			},
			"Soy": {
				"type": "list",
				"member": {
					"locationName": "item",
					"type": "structure",
					"members": {
						"InstanceId": {
							"locationName": "instanceId"
						},
						"CurrentState": {
							"shape": "Scw",
							"locationName": "currentState"
						},
						"PreviousState": {
							"shape": "Scw",
							"locationName": "previousState"
						}
					}
				}
			}
		}
	};

/***/ },
/* 677 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeAccountAttributes": {
				"result_key": "AccountAttributes"
			},
			"DescribeAddresses": {
				"result_key": "Addresses"
			},
			"DescribeAvailabilityZones": {
				"result_key": "AvailabilityZones"
			},
			"DescribeBundleTasks": {
				"result_key": "BundleTasks"
			},
			"DescribeConversionTasks": {
				"result_key": "ConversionTasks"
			},
			"DescribeCustomerGateways": {
				"result_key": "CustomerGateways"
			},
			"DescribeDhcpOptions": {
				"result_key": "DhcpOptions"
			},
			"DescribeExportTasks": {
				"result_key": "ExportTasks"
			},
			"DescribeImages": {
				"result_key": "Images"
			},
			"DescribeInstanceStatus": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "InstanceStatuses"
			},
			"DescribeInstances": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Reservations"
			},
			"DescribeInternetGateways": {
				"result_key": "InternetGateways"
			},
			"DescribeKeyPairs": {
				"result_key": "KeyPairs"
			},
			"DescribeNatGateways": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "NatGateways"
			},
			"DescribeNetworkAcls": {
				"result_key": "NetworkAcls"
			},
			"DescribeNetworkInterfaces": {
				"result_key": "NetworkInterfaces"
			},
			"DescribePlacementGroups": {
				"result_key": "PlacementGroups"
			},
			"DescribeRegions": {
				"result_key": "Regions"
			},
			"DescribeReservedInstances": {
				"result_key": "ReservedInstances"
			},
			"DescribeReservedInstancesListings": {
				"result_key": "ReservedInstancesListings"
			},
			"DescribeReservedInstancesModifications": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "ReservedInstancesModifications"
			},
			"DescribeReservedInstancesOfferings": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "ReservedInstancesOfferings"
			},
			"DescribeRouteTables": {
				"result_key": "RouteTables"
			},
			"DescribeSecurityGroups": {
				"result_key": "SecurityGroups"
			},
			"DescribeSnapshots": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Snapshots"
			},
			"DescribeSpotFleetRequests": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "SpotFleetRequestConfigs"
			},
			"DescribeSpotInstanceRequests": {
				"result_key": "SpotInstanceRequests"
			},
			"DescribeSpotPriceHistory": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "SpotPriceHistory"
			},
			"DescribeSubnets": {
				"result_key": "Subnets"
			},
			"DescribeTags": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Tags"
			},
			"DescribeVolumeStatus": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "VolumeStatuses"
			},
			"DescribeVolumes": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Volumes"
			},
			"DescribeVpcPeeringConnections": {
				"result_key": "VpcPeeringConnections"
			},
			"DescribeVpcs": {
				"result_key": "Vpcs"
			},
			"DescribeVpnConnections": {
				"result_key": "VpnConnections"
			},
			"DescribeVpnGateways": {
				"result_key": "VpnGateways"
			}
		}
	};

/***/ },
/* 678 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"InstanceExists": {
				"delay": 5,
				"maxAttempts": 40,
				"operation": "DescribeInstances",
				"acceptors": [
					{
						"matcher": "path",
						"expected": true,
						"argument": "length(Reservations[]) > `0`",
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstanceID.NotFound",
						"state": "retry"
					}
				]
			},
			"BundleTaskComplete": {
				"delay": 15,
				"operation": "DescribeBundleTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "complete",
						"matcher": "pathAll",
						"state": "success",
						"argument": "BundleTasks[].State"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "BundleTasks[].State"
					}
				]
			},
			"ConversionTaskCancelled": {
				"delay": 15,
				"operation": "DescribeConversionTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "cancelled",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ConversionTasks[].State"
					}
				]
			},
			"ConversionTaskCompleted": {
				"delay": 15,
				"operation": "DescribeConversionTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "completed",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ConversionTasks[].State"
					},
					{
						"expected": "cancelled",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "ConversionTasks[].State"
					},
					{
						"expected": "cancelling",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "ConversionTasks[].State"
					}
				]
			},
			"ConversionTaskDeleted": {
				"delay": 15,
				"operation": "DescribeConversionTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ConversionTasks[].State"
					}
				]
			},
			"CustomerGatewayAvailable": {
				"delay": 15,
				"operation": "DescribeCustomerGateways",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "CustomerGateways[].State"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "CustomerGateways[].State"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "CustomerGateways[].State"
					}
				]
			},
			"ExportTaskCancelled": {
				"delay": 15,
				"operation": "DescribeExportTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "cancelled",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ExportTasks[].State"
					}
				]
			},
			"ExportTaskCompleted": {
				"delay": 15,
				"operation": "DescribeExportTasks",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "completed",
						"matcher": "pathAll",
						"state": "success",
						"argument": "ExportTasks[].State"
					}
				]
			},
			"ImageExists": {
				"operation": "DescribeImages",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"matcher": "path",
						"expected": true,
						"argument": "length(Images[]) > `0`",
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidAMIID.NotFound",
						"state": "retry"
					}
				]
			},
			"ImageAvailable": {
				"operation": "DescribeImages",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "Images[].State",
						"expected": "available"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "Images[].State",
						"expected": "failed"
					}
				]
			},
			"InstanceRunning": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "running",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "shutting-down",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "terminated",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "stopping",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstanceID.NotFound",
						"state": "retry"
					}
				]
			},
			"InstanceStatusOk": {
				"operation": "DescribeInstanceStatus",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "InstanceStatuses[].InstanceStatus.Status",
						"expected": "ok"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstanceID.NotFound",
						"state": "retry"
					}
				]
			},
			"InstanceStopped": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "stopped",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "terminated",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					}
				]
			},
			"InstanceTerminated": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "terminated",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					},
					{
						"expected": "stopping",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Reservations[].Instances[].State.Name"
					}
				]
			},
			"KeyPairExists": {
				"operation": "DescribeKeyPairs",
				"delay": 5,
				"maxAttempts": 6,
				"acceptors": [
					{
						"expected": true,
						"matcher": "path",
						"state": "success",
						"argument": "length(KeyPairs[].KeyName) > `0`"
					},
					{
						"expected": "InvalidKeyPair.NotFound",
						"matcher": "error",
						"state": "retry"
					}
				]
			},
			"NatGatewayAvailable": {
				"operation": "DescribeNatGateways",
				"delay": 15,
				"maxAttempts": 40,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "NatGateways[].State",
						"expected": "available"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "NatGateways[].State",
						"expected": "failed"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "NatGateways[].State",
						"expected": "deleting"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "NatGateways[].State",
						"expected": "deleted"
					},
					{
						"state": "retry",
						"matcher": "error",
						"expected": "NatGatewayNotFound"
					}
				]
			},
			"NetworkInterfaceAvailable": {
				"operation": "DescribeNetworkInterfaces",
				"delay": 20,
				"maxAttempts": 10,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "NetworkInterfaces[].Status"
					},
					{
						"expected": "InvalidNetworkInterfaceID.NotFound",
						"matcher": "error",
						"state": "failure"
					}
				]
			},
			"PasswordDataAvailable": {
				"operation": "GetPasswordData",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "path",
						"argument": "length(PasswordData) > `0`",
						"expected": true
					}
				]
			},
			"SnapshotCompleted": {
				"delay": 15,
				"operation": "DescribeSnapshots",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "completed",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Snapshots[].State"
					}
				]
			},
			"SpotInstanceRequestFulfilled": {
				"operation": "DescribeSpotInstanceRequests",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "fulfilled"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "schedule-expired"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "canceled-before-fulfillment"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "bad-parameters"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "SpotInstanceRequests[].Status.Code",
						"expected": "system-error"
					}
				]
			},
			"SubnetAvailable": {
				"delay": 15,
				"operation": "DescribeSubnets",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Subnets[].State"
					}
				]
			},
			"SystemStatusOk": {
				"operation": "DescribeInstanceStatus",
				"maxAttempts": 40,
				"delay": 15,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "InstanceStatuses[].SystemStatus.Status",
						"expected": "ok"
					}
				]
			},
			"VolumeAvailable": {
				"delay": 15,
				"operation": "DescribeVolumes",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Volumes[].State"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Volumes[].State"
					}
				]
			},
			"VolumeDeleted": {
				"delay": 15,
				"operation": "DescribeVolumes",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Volumes[].State"
					},
					{
						"matcher": "error",
						"expected": "InvalidVolume.NotFound",
						"state": "success"
					}
				]
			},
			"VolumeInUse": {
				"delay": 15,
				"operation": "DescribeVolumes",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "in-use",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Volumes[].State"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Volumes[].State"
					}
				]
			},
			"VpcAvailable": {
				"delay": 15,
				"operation": "DescribeVpcs",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Vpcs[].State"
					}
				]
			},
			"VpcExists": {
				"operation": "DescribeVpcs",
				"delay": 1,
				"maxAttempts": 5,
				"acceptors": [
					{
						"matcher": "status",
						"expected": 200,
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidVpcID.NotFound",
						"state": "retry"
					}
				]
			},
			"VpnConnectionAvailable": {
				"delay": 15,
				"operation": "DescribeVpnConnections",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "VpnConnections[].State"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "VpnConnections[].State"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "VpnConnections[].State"
					}
				]
			},
			"VpnConnectionDeleted": {
				"delay": 15,
				"operation": "DescribeVpnConnections",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "VpnConnections[].State"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "VpnConnections[].State"
					}
				]
			},
			"VpcPeeringConnectionExists": {
				"delay": 15,
				"operation": "DescribeVpcPeeringConnections",
				"maxAttempts": 40,
				"acceptors": [
					{
						"matcher": "status",
						"expected": 200,
						"state": "success"
					},
					{
						"matcher": "error",
						"expected": "InvalidVpcPeeringConnectionID.NotFound",
						"state": "retry"
					}
				]
			},
			"VpcPeeringConnectionDeleted": {
				"delay": 15,
				"operation": "DescribeVpcPeeringConnections",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "VpcPeeringConnections[].Status.Code"
					},
					{
						"matcher": "error",
						"expected": "InvalidVpcPeeringConnectionID.NotFound",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 679 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "ecr-2015-09-21",
			"apiVersion": "2015-09-21",
			"endpointPrefix": "ecr",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Amazon ECR",
			"serviceFullName": "Amazon EC2 Container Registry",
			"signatureVersion": "v4",
			"targetPrefix": "AmazonEC2ContainerRegistry_V20150921"
		},
		"operations": {
			"BatchCheckLayerAvailability": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"layerDigests"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"layerDigests": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"layers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"layerDigest": {},
									"layerAvailability": {},
									"layerSize": {
										"type": "long"
									},
									"mediaType": {}
								}
							}
						},
						"failures": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"layerDigest": {},
									"failureCode": {},
									"failureReason": {}
								}
							}
						}
					}
				}
			},
			"BatchDeleteImage": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"imageIds"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageIds": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"imageIds": {
							"shape": "Si"
						},
						"failures": {
							"shape": "Sn"
						}
					}
				}
			},
			"BatchGetImage": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"imageIds"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageIds": {
							"shape": "Si"
						},
						"acceptedMediaTypes": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"images": {
							"type": "list",
							"member": {
								"shape": "Sv"
							}
						},
						"failures": {
							"shape": "Sn"
						}
					}
				}
			},
			"CompleteLayerUpload": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"uploadId",
						"layerDigests"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"uploadId": {},
						"layerDigests": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"uploadId": {},
						"layerDigest": {}
					}
				}
			},
			"CreateRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repository": {
							"shape": "S13"
						}
					}
				}
			},
			"DeleteRepository": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repository": {
							"shape": "S13"
						}
					}
				}
			},
			"DeleteRepositoryPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"policyText": {}
					}
				}
			},
			"DescribeImages": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageIds": {
							"shape": "Si"
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"filter": {
							"type": "structure",
							"members": {
								"tagStatus": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"imageDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"registryId": {},
									"repositoryName": {},
									"imageDigest": {},
									"imageTags": {
										"type": "list",
										"member": {}
									},
									"imageSizeInBytes": {
										"type": "long"
									},
									"imagePushedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeRepositories": {
				"input": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryNames": {
							"type": "list",
							"member": {}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"repositories": {
							"type": "list",
							"member": {
								"shape": "S13"
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetAuthorizationToken": {
				"input": {
					"type": "structure",
					"members": {
						"registryIds": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"authorizationData": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"authorizationToken": {},
									"expiresAt": {
										"type": "timestamp"
									},
									"proxyEndpoint": {}
								}
							}
						}
					}
				}
			},
			"GetDownloadUrlForLayer": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"layerDigest"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"layerDigest": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"downloadUrl": {},
						"layerDigest": {}
					}
				}
			},
			"GetRepositoryPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"policyText": {}
					}
				}
			},
			"InitiateLayerUpload": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"uploadId": {},
						"partSize": {
							"type": "long"
						}
					}
				}
			},
			"ListImages": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"filter": {
							"type": "structure",
							"members": {
								"tagStatus": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"imageIds": {
							"shape": "Si"
						},
						"nextToken": {}
					}
				}
			},
			"PutImage": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"imageManifest"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"imageManifest": {},
						"imageTag": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"image": {
							"shape": "Sv"
						}
					}
				}
			},
			"SetRepositoryPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"policyText"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"policyText": {},
						"force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"policyText": {}
					}
				}
			},
			"UploadLayerPart": {
				"input": {
					"type": "structure",
					"required": [
						"repositoryName",
						"uploadId",
						"partFirstByte",
						"partLastByte",
						"layerPartBlob"
					],
					"members": {
						"registryId": {},
						"repositoryName": {},
						"uploadId": {},
						"partFirstByte": {
							"type": "long"
						},
						"partLastByte": {
							"type": "long"
						},
						"layerPartBlob": {
							"type": "blob"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"registryId": {},
						"repositoryName": {},
						"uploadId": {},
						"lastByteReceived": {
							"type": "long"
						}
					}
				}
			}
		},
		"shapes": {
			"Si": {
				"type": "list",
				"member": {
					"shape": "Sj"
				}
			},
			"Sj": {
				"type": "structure",
				"members": {
					"imageDigest": {},
					"imageTag": {}
				}
			},
			"Sn": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"imageId": {
							"shape": "Sj"
						},
						"failureCode": {},
						"failureReason": {}
					}
				}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"registryId": {},
					"repositoryName": {},
					"imageId": {
						"shape": "Sj"
					},
					"imageManifest": {}
				}
			},
			"S13": {
				"type": "structure",
				"members": {
					"repositoryArn": {},
					"registryId": {},
					"repositoryName": {},
					"repositoryUri": {},
					"createdAt": {
						"type": "timestamp"
					}
				}
			}
		}
	};

/***/ },
/* 680 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListImages": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "imageIds"
			},
			"DescribeImages": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "imageDetails"
			},
			"DescribeRepositories": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "repositories"
			}
		}
	};

/***/ },
/* 681 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-11-13",
			"endpointPrefix": "ecs",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Amazon ECS",
			"serviceFullName": "Amazon EC2 Container Service",
			"signatureVersion": "v4",
			"targetPrefix": "AmazonEC2ContainerServiceV20141113",
			"uid": "ecs-2014-11-13"
		},
		"operations": {
			"CreateCluster": {
				"input": {
					"type": "structure",
					"members": {
						"clusterName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"cluster": {
							"shape": "S4"
						}
					}
				}
			},
			"CreateService": {
				"input": {
					"type": "structure",
					"required": [
						"serviceName",
						"taskDefinition",
						"desiredCount"
					],
					"members": {
						"cluster": {},
						"serviceName": {},
						"taskDefinition": {},
						"loadBalancers": {
							"shape": "S7"
						},
						"desiredCount": {
							"type": "integer"
						},
						"clientToken": {},
						"role": {},
						"deploymentConfiguration": {
							"shape": "Sa"
						},
						"placementConstraints": {
							"shape": "Sb"
						},
						"placementStrategy": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"service": {
							"shape": "Si"
						}
					}
				}
			},
			"DeleteAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"attributes"
					],
					"members": {
						"cluster": {},
						"attributes": {
							"shape": "Sp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"attributes": {
							"shape": "Sp"
						}
					}
				}
			},
			"DeleteCluster": {
				"input": {
					"type": "structure",
					"required": [
						"cluster"
					],
					"members": {
						"cluster": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"cluster": {
							"shape": "S4"
						}
					}
				}
			},
			"DeleteService": {
				"input": {
					"type": "structure",
					"required": [
						"service"
					],
					"members": {
						"cluster": {},
						"service": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"service": {
							"shape": "Si"
						}
					}
				}
			},
			"DeregisterContainerInstance": {
				"input": {
					"type": "structure",
					"required": [
						"containerInstance"
					],
					"members": {
						"cluster": {},
						"containerInstance": {},
						"force": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstance": {
							"shape": "S10"
						}
					}
				}
			},
			"DeregisterTaskDefinition": {
				"input": {
					"type": "structure",
					"required": [
						"taskDefinition"
					],
					"members": {
						"taskDefinition": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskDefinition": {
							"shape": "S1b"
						}
					}
				}
			},
			"DescribeClusters": {
				"input": {
					"type": "structure",
					"members": {
						"clusters": {
							"shape": "S16"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"clusters": {
							"type": "list",
							"member": {
								"shape": "S4"
							}
						},
						"failures": {
							"shape": "S28"
						}
					}
				}
			},
			"DescribeContainerInstances": {
				"input": {
					"type": "structure",
					"required": [
						"containerInstances"
					],
					"members": {
						"cluster": {},
						"containerInstances": {
							"shape": "S16"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstances": {
							"shape": "S2c"
						},
						"failures": {
							"shape": "S28"
						}
					}
				}
			},
			"DescribeServices": {
				"input": {
					"type": "structure",
					"required": [
						"services"
					],
					"members": {
						"cluster": {},
						"services": {
							"shape": "S16"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"services": {
							"type": "list",
							"member": {
								"shape": "Si"
							}
						},
						"failures": {
							"shape": "S28"
						}
					}
				}
			},
			"DescribeTaskDefinition": {
				"input": {
					"type": "structure",
					"required": [
						"taskDefinition"
					],
					"members": {
						"taskDefinition": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskDefinition": {
							"shape": "S1b"
						}
					}
				}
			},
			"DescribeTasks": {
				"input": {
					"type": "structure",
					"required": [
						"tasks"
					],
					"members": {
						"cluster": {},
						"tasks": {
							"shape": "S16"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tasks": {
							"shape": "S2k"
						},
						"failures": {
							"shape": "S28"
						}
					}
				}
			},
			"DiscoverPollEndpoint": {
				"input": {
					"type": "structure",
					"members": {
						"containerInstance": {},
						"cluster": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"endpoint": {},
						"telemetryEndpoint": {}
					}
				}
			},
			"ListAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"targetType"
					],
					"members": {
						"cluster": {},
						"targetType": {},
						"attributeName": {},
						"attributeValue": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"attributes": {
							"shape": "Sp"
						},
						"nextToken": {}
					}
				}
			},
			"ListClusters": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"clusterArns": {
							"shape": "S16"
						},
						"nextToken": {}
					}
				}
			},
			"ListContainerInstances": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"filter": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstanceArns": {
							"shape": "S16"
						},
						"nextToken": {}
					}
				}
			},
			"ListServices": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"serviceArns": {
							"shape": "S16"
						},
						"nextToken": {}
					}
				}
			},
			"ListTaskDefinitionFamilies": {
				"input": {
					"type": "structure",
					"members": {
						"familyPrefix": {},
						"status": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"families": {
							"shape": "S16"
						},
						"nextToken": {}
					}
				}
			},
			"ListTaskDefinitions": {
				"input": {
					"type": "structure",
					"members": {
						"familyPrefix": {},
						"status": {},
						"sort": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskDefinitionArns": {
							"shape": "S16"
						},
						"nextToken": {}
					}
				}
			},
			"ListTasks": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"containerInstance": {},
						"family": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						},
						"startedBy": {},
						"serviceName": {},
						"desiredStatus": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskArns": {
							"shape": "S16"
						},
						"nextToken": {}
					}
				}
			},
			"PutAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"attributes"
					],
					"members": {
						"cluster": {},
						"attributes": {
							"shape": "Sp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"attributes": {
							"shape": "Sp"
						}
					}
				}
			},
			"RegisterContainerInstance": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"instanceIdentityDocument": {},
						"instanceIdentityDocumentSignature": {},
						"totalResources": {
							"shape": "S13"
						},
						"versionInfo": {
							"shape": "S12"
						},
						"containerInstanceArn": {},
						"attributes": {
							"shape": "Sp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstance": {
							"shape": "S10"
						}
					}
				}
			},
			"RegisterTaskDefinition": {
				"input": {
					"type": "structure",
					"required": [
						"family",
						"containerDefinitions"
					],
					"members": {
						"family": {},
						"taskRoleArn": {},
						"networkMode": {},
						"containerDefinitions": {
							"shape": "S1c"
						},
						"volumes": {
							"shape": "S1x"
						},
						"placementConstraints": {
							"shape": "S22"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskDefinition": {
							"shape": "S1b"
						}
					}
				}
			},
			"RunTask": {
				"input": {
					"type": "structure",
					"required": [
						"taskDefinition"
					],
					"members": {
						"cluster": {},
						"taskDefinition": {},
						"overrides": {
							"shape": "S2m"
						},
						"count": {
							"type": "integer"
						},
						"startedBy": {},
						"group": {},
						"placementConstraints": {
							"shape": "Sb"
						},
						"placementStrategy": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tasks": {
							"shape": "S2k"
						},
						"failures": {
							"shape": "S28"
						}
					}
				}
			},
			"StartTask": {
				"input": {
					"type": "structure",
					"required": [
						"taskDefinition",
						"containerInstances"
					],
					"members": {
						"cluster": {},
						"taskDefinition": {},
						"overrides": {
							"shape": "S2m"
						},
						"containerInstances": {
							"shape": "S16"
						},
						"startedBy": {},
						"group": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tasks": {
							"shape": "S2k"
						},
						"failures": {
							"shape": "S28"
						}
					}
				}
			},
			"StopTask": {
				"input": {
					"type": "structure",
					"required": [
						"task"
					],
					"members": {
						"cluster": {},
						"task": {},
						"reason": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"task": {
							"shape": "S2l"
						}
					}
				}
			},
			"SubmitContainerStateChange": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"task": {},
						"containerName": {},
						"status": {},
						"exitCode": {
							"type": "integer"
						},
						"reason": {},
						"networkBindings": {
							"shape": "S2r"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"acknowledgment": {}
					}
				}
			},
			"SubmitTaskStateChange": {
				"input": {
					"type": "structure",
					"members": {
						"cluster": {},
						"task": {},
						"status": {},
						"reason": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"acknowledgment": {}
					}
				}
			},
			"UpdateContainerAgent": {
				"input": {
					"type": "structure",
					"required": [
						"containerInstance"
					],
					"members": {
						"cluster": {},
						"containerInstance": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstance": {
							"shape": "S10"
						}
					}
				}
			},
			"UpdateContainerInstancesState": {
				"input": {
					"type": "structure",
					"required": [
						"containerInstances",
						"status"
					],
					"members": {
						"cluster": {},
						"containerInstances": {
							"shape": "S16"
						},
						"status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"containerInstances": {
							"shape": "S2c"
						},
						"failures": {
							"shape": "S28"
						}
					}
				}
			},
			"UpdateService": {
				"input": {
					"type": "structure",
					"required": [
						"service"
					],
					"members": {
						"cluster": {},
						"service": {},
						"desiredCount": {
							"type": "integer"
						},
						"taskDefinition": {},
						"deploymentConfiguration": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"service": {
							"shape": "Si"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"clusterArn": {},
					"clusterName": {},
					"status": {},
					"registeredContainerInstancesCount": {
						"type": "integer"
					},
					"runningTasksCount": {
						"type": "integer"
					},
					"pendingTasksCount": {
						"type": "integer"
					},
					"activeServicesCount": {
						"type": "integer"
					}
				}
			},
			"S7": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"targetGroupArn": {},
						"loadBalancerName": {},
						"containerName": {},
						"containerPort": {
							"type": "integer"
						}
					}
				}
			},
			"Sa": {
				"type": "structure",
				"members": {
					"maximumPercent": {
						"type": "integer"
					},
					"minimumHealthyPercent": {
						"type": "integer"
					}
				}
			},
			"Sb": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"type": {},
						"expression": {}
					}
				}
			},
			"Se": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"type": {},
						"field": {}
					}
				}
			},
			"Si": {
				"type": "structure",
				"members": {
					"serviceArn": {},
					"serviceName": {},
					"clusterArn": {},
					"loadBalancers": {
						"shape": "S7"
					},
					"status": {},
					"desiredCount": {
						"type": "integer"
					},
					"runningCount": {
						"type": "integer"
					},
					"pendingCount": {
						"type": "integer"
					},
					"taskDefinition": {},
					"deploymentConfiguration": {
						"shape": "Sa"
					},
					"deployments": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"id": {},
								"status": {},
								"taskDefinition": {},
								"desiredCount": {
									"type": "integer"
								},
								"pendingCount": {
									"type": "integer"
								},
								"runningCount": {
									"type": "integer"
								},
								"createdAt": {
									"type": "timestamp"
								},
								"updatedAt": {
									"type": "timestamp"
								}
							}
						}
					},
					"roleArn": {},
					"events": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"id": {},
								"createdAt": {
									"type": "timestamp"
								},
								"message": {}
							}
						}
					},
					"createdAt": {
						"type": "timestamp"
					},
					"placementConstraints": {
						"shape": "Sb"
					},
					"placementStrategy": {
						"shape": "Se"
					}
				}
			},
			"Sp": {
				"type": "list",
				"member": {
					"shape": "Sq"
				}
			},
			"Sq": {
				"type": "structure",
				"required": [
					"name"
				],
				"members": {
					"name": {},
					"value": {},
					"targetType": {},
					"targetId": {}
				}
			},
			"S10": {
				"type": "structure",
				"members": {
					"containerInstanceArn": {},
					"ec2InstanceId": {},
					"version": {
						"type": "long"
					},
					"versionInfo": {
						"shape": "S12"
					},
					"remainingResources": {
						"shape": "S13"
					},
					"registeredResources": {
						"shape": "S13"
					},
					"status": {},
					"agentConnected": {
						"type": "boolean"
					},
					"runningTasksCount": {
						"type": "integer"
					},
					"pendingTasksCount": {
						"type": "integer"
					},
					"agentUpdateStatus": {},
					"attributes": {
						"shape": "Sp"
					}
				}
			},
			"S12": {
				"type": "structure",
				"members": {
					"agentVersion": {},
					"agentHash": {},
					"dockerVersion": {}
				}
			},
			"S13": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"type": {},
						"doubleValue": {
							"type": "double"
						},
						"longValue": {
							"type": "long"
						},
						"integerValue": {
							"type": "integer"
						},
						"stringSetValue": {
							"shape": "S16"
						}
					}
				}
			},
			"S16": {
				"type": "list",
				"member": {}
			},
			"S1b": {
				"type": "structure",
				"members": {
					"taskDefinitionArn": {},
					"containerDefinitions": {
						"shape": "S1c"
					},
					"family": {},
					"taskRoleArn": {},
					"networkMode": {},
					"revision": {
						"type": "integer"
					},
					"volumes": {
						"shape": "S1x"
					},
					"status": {},
					"requiresAttributes": {
						"type": "list",
						"member": {
							"shape": "Sq"
						}
					},
					"placementConstraints": {
						"shape": "S22"
					}
				}
			},
			"S1c": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"image": {},
						"cpu": {
							"type": "integer"
						},
						"memory": {
							"type": "integer"
						},
						"memoryReservation": {
							"type": "integer"
						},
						"links": {
							"shape": "S16"
						},
						"portMappings": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"containerPort": {
										"type": "integer"
									},
									"hostPort": {
										"type": "integer"
									},
									"protocol": {}
								}
							}
						},
						"essential": {
							"type": "boolean"
						},
						"entryPoint": {
							"shape": "S16"
						},
						"command": {
							"shape": "S16"
						},
						"environment": {
							"shape": "S1h"
						},
						"mountPoints": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"sourceVolume": {},
									"containerPath": {},
									"readOnly": {
										"type": "boolean"
									}
								}
							}
						},
						"volumesFrom": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"sourceContainer": {},
									"readOnly": {
										"type": "boolean"
									}
								}
							}
						},
						"hostname": {},
						"user": {},
						"workingDirectory": {},
						"disableNetworking": {
							"type": "boolean"
						},
						"privileged": {
							"type": "boolean"
						},
						"readonlyRootFilesystem": {
							"type": "boolean"
						},
						"dnsServers": {
							"shape": "S16"
						},
						"dnsSearchDomains": {
							"shape": "S16"
						},
						"extraHosts": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"hostname",
									"ipAddress"
								],
								"members": {
									"hostname": {},
									"ipAddress": {}
								}
							}
						},
						"dockerSecurityOptions": {
							"shape": "S16"
						},
						"dockerLabels": {
							"type": "map",
							"key": {},
							"value": {}
						},
						"ulimits": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"name",
									"softLimit",
									"hardLimit"
								],
								"members": {
									"name": {},
									"softLimit": {
										"type": "integer"
									},
									"hardLimit": {
										"type": "integer"
									}
								}
							}
						},
						"logConfiguration": {
							"type": "structure",
							"required": [
								"logDriver"
							],
							"members": {
								"logDriver": {},
								"options": {
									"type": "map",
									"key": {},
									"value": {}
								}
							}
						}
					}
				}
			},
			"S1h": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"value": {}
					}
				}
			},
			"S1x": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"name": {},
						"host": {
							"type": "structure",
							"members": {
								"sourcePath": {}
							}
						}
					}
				}
			},
			"S22": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"type": {},
						"expression": {}
					}
				}
			},
			"S28": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"arn": {},
						"reason": {}
					}
				}
			},
			"S2c": {
				"type": "list",
				"member": {
					"shape": "S10"
				}
			},
			"S2k": {
				"type": "list",
				"member": {
					"shape": "S2l"
				}
			},
			"S2l": {
				"type": "structure",
				"members": {
					"taskArn": {},
					"clusterArn": {},
					"taskDefinitionArn": {},
					"containerInstanceArn": {},
					"overrides": {
						"shape": "S2m"
					},
					"lastStatus": {},
					"desiredStatus": {},
					"containers": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"containerArn": {},
								"taskArn": {},
								"name": {},
								"lastStatus": {},
								"exitCode": {
									"type": "integer"
								},
								"reason": {},
								"networkBindings": {
									"shape": "S2r"
								}
							}
						}
					},
					"startedBy": {},
					"version": {
						"type": "long"
					},
					"stoppedReason": {},
					"createdAt": {
						"type": "timestamp"
					},
					"startedAt": {
						"type": "timestamp"
					},
					"stoppedAt": {
						"type": "timestamp"
					},
					"group": {}
				}
			},
			"S2m": {
				"type": "structure",
				"members": {
					"containerOverrides": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"name": {},
								"command": {
									"shape": "S16"
								},
								"environment": {
									"shape": "S1h"
								}
							}
						}
					},
					"taskRoleArn": {}
				}
			},
			"S2r": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"bindIP": {},
						"containerPort": {
							"type": "integer"
						},
						"hostPort": {
							"type": "integer"
						},
						"protocol": {}
					}
				}
			}
		}
	};

/***/ },
/* 682 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListClusters": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "clusterArns"
			},
			"ListContainerInstances": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "containerInstanceArns"
			},
			"ListTaskDefinitions": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "taskDefinitionArns"
			},
			"ListTaskDefinitionFamilies": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "families"
			},
			"ListTasks": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "taskArns"
			},
			"ListServices": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "maxResults",
				"result_key": "serviceArns"
			}
		}
	};

/***/ },
/* 683 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"TasksRunning": {
				"delay": 6,
				"operation": "DescribeTasks",
				"maxAttempts": 100,
				"acceptors": [
					{
						"expected": "STOPPED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "tasks[].lastStatus"
					},
					{
						"expected": "MISSING",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "failures[].reason"
					},
					{
						"expected": "RUNNING",
						"matcher": "pathAll",
						"state": "success",
						"argument": "tasks[].lastStatus"
					}
				]
			},
			"TasksStopped": {
				"delay": 6,
				"operation": "DescribeTasks",
				"maxAttempts": 100,
				"acceptors": [
					{
						"expected": "STOPPED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "tasks[].lastStatus"
					}
				]
			},
			"ServicesStable": {
				"delay": 15,
				"operation": "DescribeServices",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "MISSING",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "failures[].reason"
					},
					{
						"expected": "DRAINING",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "services[].status"
					},
					{
						"expected": "INACTIVE",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "services[].status"
					},
					{
						"expected": true,
						"matcher": "path",
						"state": "success",
						"argument": "length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"
					}
				]
			},
			"ServicesInactive": {
				"delay": 15,
				"operation": "DescribeServices",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "MISSING",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "failures[].reason"
					},
					{
						"expected": "INACTIVE",
						"matcher": "pathAny",
						"state": "success",
						"argument": "services[].status"
					}
				]
			}
		}
	};

/***/ },
/* 684 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-02-02",
			"endpointPrefix": "elasticache",
			"protocol": "query",
			"serviceFullName": "Amazon ElastiCache",
			"signatureVersion": "v4",
			"uid": "elasticache-2015-02-02",
			"xmlNamespace": "http://elasticache.amazonaws.com/doc/2015-02-02/"
		},
		"operations": {
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"shape": "S5",
					"resultWrapper": "AddTagsToResourceResult"
				}
			},
			"AuthorizeCacheSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSecurityGroupName",
						"EC2SecurityGroupName",
						"EC2SecurityGroupOwnerId"
					],
					"members": {
						"CacheSecurityGroupName": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeCacheSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"CacheSecurityGroup": {
							"shape": "S8"
						}
					}
				}
			},
			"CopySnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceSnapshotName",
						"TargetSnapshotName"
					],
					"members": {
						"SourceSnapshotName": {},
						"TargetSnapshotName": {},
						"TargetBucket": {}
					}
				},
				"output": {
					"resultWrapper": "CopySnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateCacheCluster": {
				"input": {
					"type": "structure",
					"required": [
						"CacheClusterId"
					],
					"members": {
						"CacheClusterId": {},
						"ReplicationGroupId": {},
						"AZMode": {},
						"PreferredAvailabilityZone": {},
						"PreferredAvailabilityZones": {
							"shape": "So"
						},
						"NumCacheNodes": {
							"type": "integer"
						},
						"CacheNodeType": {},
						"Engine": {},
						"EngineVersion": {},
						"CacheParameterGroupName": {},
						"CacheSubnetGroupName": {},
						"CacheSecurityGroupNames": {
							"shape": "Sp"
						},
						"SecurityGroupIds": {
							"shape": "Sq"
						},
						"Tags": {
							"shape": "S3"
						},
						"SnapshotArns": {
							"shape": "Sr"
						},
						"SnapshotName": {},
						"PreferredMaintenanceWindow": {},
						"Port": {
							"type": "integer"
						},
						"NotificationTopicArn": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"SnapshotRetentionLimit": {
							"type": "integer"
						},
						"SnapshotWindow": {},
						"AuthToken": {}
					}
				},
				"output": {
					"resultWrapper": "CreateCacheClusterResult",
					"type": "structure",
					"members": {
						"CacheCluster": {
							"shape": "Su"
						}
					}
				}
			},
			"CreateCacheParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName",
						"CacheParameterGroupFamily",
						"Description"
					],
					"members": {
						"CacheParameterGroupName": {},
						"CacheParameterGroupFamily": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "CreateCacheParameterGroupResult",
					"type": "structure",
					"members": {
						"CacheParameterGroup": {
							"shape": "S19"
						}
					}
				}
			},
			"CreateCacheSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSecurityGroupName",
						"Description"
					],
					"members": {
						"CacheSecurityGroupName": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "CreateCacheSecurityGroupResult",
					"type": "structure",
					"members": {
						"CacheSecurityGroup": {
							"shape": "S8"
						}
					}
				}
			},
			"CreateCacheSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSubnetGroupName",
						"CacheSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"CacheSubnetGroupName": {},
						"CacheSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateCacheSubnetGroupResult",
					"type": "structure",
					"members": {
						"CacheSubnetGroup": {
							"shape": "S1f"
						}
					}
				}
			},
			"CreateReplicationGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId",
						"ReplicationGroupDescription"
					],
					"members": {
						"ReplicationGroupId": {},
						"ReplicationGroupDescription": {},
						"PrimaryClusterId": {},
						"AutomaticFailoverEnabled": {
							"type": "boolean"
						},
						"NumCacheClusters": {
							"type": "integer"
						},
						"PreferredCacheClusterAZs": {
							"shape": "Sl"
						},
						"NumNodeGroups": {
							"type": "integer"
						},
						"ReplicasPerNodeGroup": {
							"type": "integer"
						},
						"NodeGroupConfiguration": {
							"type": "list",
							"member": {
								"shape": "Sk",
								"locationName": "NodeGroupConfiguration"
							}
						},
						"CacheNodeType": {},
						"Engine": {},
						"EngineVersion": {},
						"CacheParameterGroupName": {},
						"CacheSubnetGroupName": {},
						"CacheSecurityGroupNames": {
							"shape": "Sp"
						},
						"SecurityGroupIds": {
							"shape": "Sq"
						},
						"Tags": {
							"shape": "S3"
						},
						"SnapshotArns": {
							"shape": "Sr"
						},
						"SnapshotName": {},
						"PreferredMaintenanceWindow": {},
						"Port": {
							"type": "integer"
						},
						"NotificationTopicArn": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"SnapshotRetentionLimit": {
							"type": "integer"
						},
						"SnapshotWindow": {},
						"AuthToken": {}
					}
				},
				"output": {
					"resultWrapper": "CreateReplicationGroupResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1m"
						}
					}
				}
			},
			"CreateSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotName"
					],
					"members": {
						"ReplicationGroupId": {},
						"CacheClusterId": {},
						"SnapshotName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sd"
						}
					}
				}
			},
			"DeleteCacheCluster": {
				"input": {
					"type": "structure",
					"required": [
						"CacheClusterId"
					],
					"members": {
						"CacheClusterId": {},
						"FinalSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteCacheClusterResult",
					"type": "structure",
					"members": {
						"CacheCluster": {
							"shape": "Su"
						}
					}
				}
			},
			"DeleteCacheParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName"
					],
					"members": {
						"CacheParameterGroupName": {}
					}
				}
			},
			"DeleteCacheSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSecurityGroupName"
					],
					"members": {
						"CacheSecurityGroupName": {}
					}
				}
			},
			"DeleteCacheSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSubnetGroupName"
					],
					"members": {
						"CacheSubnetGroupName": {}
					}
				}
			},
			"DeleteReplicationGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId"
					],
					"members": {
						"ReplicationGroupId": {},
						"RetainPrimaryCluster": {
							"type": "boolean"
						},
						"FinalSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteReplicationGroupResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1m"
						}
					}
				}
			},
			"DeleteSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotName"
					],
					"members": {
						"SnapshotName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sd"
						}
					}
				}
			},
			"DescribeCacheClusters": {
				"input": {
					"type": "structure",
					"members": {
						"CacheClusterId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"ShowCacheNodeInfo": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheClustersResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheClusters": {
							"type": "list",
							"member": {
								"shape": "Su",
								"locationName": "CacheCluster"
							}
						}
					}
				}
			},
			"DescribeCacheEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"CacheParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "CacheEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"CacheParameterGroupFamily": {},
									"CacheEngineDescription": {},
									"CacheEngineVersionDescription": {}
								}
							}
						}
					}
				}
			},
			"DescribeCacheParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"CacheParameterGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S19",
								"locationName": "CacheParameterGroup"
							}
						}
					}
				}
			},
			"DescribeCacheParameters": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName"
					],
					"members": {
						"CacheParameterGroupName": {},
						"Source": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheParametersResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Parameters": {
							"shape": "S2h"
						},
						"CacheNodeTypeSpecificParameters": {
							"shape": "S2k"
						}
					}
				}
			},
			"DescribeCacheSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"CacheSecurityGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "S8",
								"locationName": "CacheSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeCacheSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"CacheSubnetGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCacheSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"CacheSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S1f",
								"locationName": "CacheSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupFamily"
					],
					"members": {
						"CacheParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"type": "structure",
							"members": {
								"CacheParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2h"
								},
								"CacheNodeTypeSpecificParameters": {
									"shape": "S2k"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"Date": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeReplicationGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ReplicationGroupId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReplicationGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReplicationGroups": {
							"type": "list",
							"member": {
								"shape": "S1m",
								"locationName": "ReplicationGroup"
							}
						}
					}
				}
			},
			"DescribeReservedCacheNodes": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedCacheNodeId": {},
						"ReservedCacheNodesOfferingId": {},
						"CacheNodeType": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedCacheNodesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedCacheNodes": {
							"type": "list",
							"member": {
								"shape": "S38",
								"locationName": "ReservedCacheNode"
							}
						}
					}
				}
			},
			"DescribeReservedCacheNodesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedCacheNodesOfferingId": {},
						"CacheNodeType": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedCacheNodesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedCacheNodesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedCacheNodesOffering",
								"type": "structure",
								"members": {
									"ReservedCacheNodesOfferingId": {},
									"CacheNodeType": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"ProductDescription": {},
									"OfferingType": {},
									"RecurringCharges": {
										"shape": "S3a"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"ReplicationGroupId": {},
						"CacheClusterId": {},
						"SnapshotName": {},
						"SnapshotSource": {},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"ShowNodeGroupConfig": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Snapshots": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "Snapshot"
							}
						}
					}
				}
			},
			"ListAllowedNodeTypeModifications": {
				"input": {
					"type": "structure",
					"members": {
						"CacheClusterId": {},
						"ReplicationGroupId": {}
					}
				},
				"output": {
					"resultWrapper": "ListAllowedNodeTypeModificationsResult",
					"type": "structure",
					"members": {
						"ScaleUpModifications": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {}
					}
				},
				"output": {
					"shape": "S5",
					"resultWrapper": "ListTagsForResourceResult"
				}
			},
			"ModifyCacheCluster": {
				"input": {
					"type": "structure",
					"required": [
						"CacheClusterId"
					],
					"members": {
						"CacheClusterId": {},
						"NumCacheNodes": {
							"type": "integer"
						},
						"CacheNodeIdsToRemove": {
							"shape": "Sy"
						},
						"AZMode": {},
						"NewAvailabilityZones": {
							"shape": "So"
						},
						"CacheSecurityGroupNames": {
							"shape": "Sp"
						},
						"SecurityGroupIds": {
							"shape": "Sq"
						},
						"PreferredMaintenanceWindow": {},
						"NotificationTopicArn": {},
						"CacheParameterGroupName": {},
						"NotificationTopicStatus": {},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"SnapshotRetentionLimit": {
							"type": "integer"
						},
						"SnapshotWindow": {},
						"CacheNodeType": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyCacheClusterResult",
					"type": "structure",
					"members": {
						"CacheCluster": {
							"shape": "Su"
						}
					}
				}
			},
			"ModifyCacheParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName",
						"ParameterNameValues"
					],
					"members": {
						"CacheParameterGroupName": {},
						"ParameterNameValues": {
							"shape": "S3q"
						}
					}
				},
				"output": {
					"shape": "S3s",
					"resultWrapper": "ModifyCacheParameterGroupResult"
				}
			},
			"ModifyCacheSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSubnetGroupName"
					],
					"members": {
						"CacheSubnetGroupName": {},
						"CacheSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyCacheSubnetGroupResult",
					"type": "structure",
					"members": {
						"CacheSubnetGroup": {
							"shape": "S1f"
						}
					}
				}
			},
			"ModifyReplicationGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ReplicationGroupId"
					],
					"members": {
						"ReplicationGroupId": {},
						"ReplicationGroupDescription": {},
						"PrimaryClusterId": {},
						"SnapshottingClusterId": {},
						"AutomaticFailoverEnabled": {
							"type": "boolean"
						},
						"CacheSecurityGroupNames": {
							"shape": "Sp"
						},
						"SecurityGroupIds": {
							"shape": "Sq"
						},
						"PreferredMaintenanceWindow": {},
						"NotificationTopicArn": {},
						"CacheParameterGroupName": {},
						"NotificationTopicStatus": {},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"SnapshotRetentionLimit": {
							"type": "integer"
						},
						"SnapshotWindow": {},
						"CacheNodeType": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyReplicationGroupResult",
					"type": "structure",
					"members": {
						"ReplicationGroup": {
							"shape": "S1m"
						}
					}
				}
			},
			"PurchaseReservedCacheNodesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedCacheNodesOfferingId"
					],
					"members": {
						"ReservedCacheNodesOfferingId": {},
						"ReservedCacheNodeId": {},
						"CacheNodeCount": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedCacheNodesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedCacheNode": {
							"shape": "S38"
						}
					}
				}
			},
			"RebootCacheCluster": {
				"input": {
					"type": "structure",
					"required": [
						"CacheClusterId",
						"CacheNodeIdsToReboot"
					],
					"members": {
						"CacheClusterId": {},
						"CacheNodeIdsToReboot": {
							"shape": "Sy"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootCacheClusterResult",
					"type": "structure",
					"members": {
						"CacheCluster": {
							"shape": "Su"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"shape": "S5",
					"resultWrapper": "RemoveTagsFromResourceResult"
				}
			},
			"ResetCacheParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"CacheParameterGroupName"
					],
					"members": {
						"CacheParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"ParameterNameValues": {
							"shape": "S3q"
						}
					}
				},
				"output": {
					"shape": "S3s",
					"resultWrapper": "ResetCacheParameterGroupResult"
				}
			},
			"RevokeCacheSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"CacheSecurityGroupName",
						"EC2SecurityGroupName",
						"EC2SecurityGroupOwnerId"
					],
					"members": {
						"CacheSecurityGroupName": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeCacheSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"CacheSecurityGroup": {
							"shape": "S8"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S5": {
				"type": "structure",
				"members": {
					"TagList": {
						"shape": "S3"
					}
				}
			},
			"S8": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"CacheSecurityGroupName": {},
					"Description": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sd": {
				"type": "structure",
				"members": {
					"SnapshotName": {},
					"ReplicationGroupId": {},
					"ReplicationGroupDescription": {},
					"CacheClusterId": {},
					"SnapshotStatus": {},
					"SnapshotSource": {},
					"CacheNodeType": {},
					"Engine": {},
					"EngineVersion": {},
					"NumCacheNodes": {
						"type": "integer"
					},
					"PreferredAvailabilityZone": {},
					"CacheClusterCreateTime": {
						"type": "timestamp"
					},
					"PreferredMaintenanceWindow": {},
					"TopicArn": {},
					"Port": {
						"type": "integer"
					},
					"CacheParameterGroupName": {},
					"CacheSubnetGroupName": {},
					"VpcId": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {},
					"NumNodeGroups": {
						"type": "integer"
					},
					"AutomaticFailover": {},
					"NodeSnapshots": {
						"type": "list",
						"member": {
							"locationName": "NodeSnapshot",
							"type": "structure",
							"members": {
								"CacheClusterId": {},
								"NodeGroupId": {},
								"CacheNodeId": {},
								"NodeGroupConfiguration": {
									"shape": "Sk"
								},
								"CacheSize": {},
								"CacheNodeCreateTime": {
									"type": "timestamp"
								},
								"SnapshotCreateTime": {
									"type": "timestamp"
								}
							},
							"wrapper": true
						}
					}
				},
				"wrapper": true
			},
			"Sk": {
				"type": "structure",
				"members": {
					"Slots": {},
					"ReplicaCount": {
						"type": "integer"
					},
					"PrimaryAvailabilityZone": {},
					"ReplicaAvailabilityZones": {
						"shape": "Sl"
					}
				}
			},
			"Sl": {
				"type": "list",
				"member": {
					"locationName": "AvailabilityZone"
				}
			},
			"So": {
				"type": "list",
				"member": {
					"locationName": "PreferredAvailabilityZone"
				}
			},
			"Sp": {
				"type": "list",
				"member": {
					"locationName": "CacheSecurityGroupName"
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"locationName": "SecurityGroupId"
				}
			},
			"Sr": {
				"type": "list",
				"member": {
					"locationName": "SnapshotArn"
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"CacheClusterId": {},
					"ConfigurationEndpoint": {
						"shape": "Sv"
					},
					"ClientDownloadLandingPage": {},
					"CacheNodeType": {},
					"Engine": {},
					"EngineVersion": {},
					"CacheClusterStatus": {},
					"NumCacheNodes": {
						"type": "integer"
					},
					"PreferredAvailabilityZone": {},
					"CacheClusterCreateTime": {
						"type": "timestamp"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"NumCacheNodes": {
								"type": "integer"
							},
							"CacheNodeIdsToRemove": {
								"shape": "Sy"
							},
							"EngineVersion": {},
							"CacheNodeType": {}
						}
					},
					"NotificationConfiguration": {
						"type": "structure",
						"members": {
							"TopicArn": {},
							"TopicStatus": {}
						}
					},
					"CacheSecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "CacheSecurityGroup",
							"type": "structure",
							"members": {
								"CacheSecurityGroupName": {},
								"Status": {}
							}
						}
					},
					"CacheParameterGroup": {
						"type": "structure",
						"members": {
							"CacheParameterGroupName": {},
							"ParameterApplyStatus": {},
							"CacheNodeIdsToReboot": {
								"shape": "Sy"
							}
						}
					},
					"CacheSubnetGroupName": {},
					"CacheNodes": {
						"type": "list",
						"member": {
							"locationName": "CacheNode",
							"type": "structure",
							"members": {
								"CacheNodeId": {},
								"CacheNodeStatus": {},
								"CacheNodeCreateTime": {
									"type": "timestamp"
								},
								"Endpoint": {
									"shape": "Sv"
								},
								"ParameterGroupStatus": {},
								"SourceCacheNodeId": {},
								"CustomerAvailabilityZone": {}
							}
						}
					},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"SecurityGroups": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"SecurityGroupId": {},
								"Status": {}
							}
						}
					},
					"ReplicationGroupId": {},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {}
				},
				"wrapper": true
			},
			"Sv": {
				"type": "structure",
				"members": {
					"Address": {},
					"Port": {
						"type": "integer"
					}
				}
			},
			"Sy": {
				"type": "list",
				"member": {
					"locationName": "CacheNodeId"
				}
			},
			"S19": {
				"type": "structure",
				"members": {
					"CacheParameterGroupName": {},
					"CacheParameterGroupFamily": {},
					"Description": {}
				},
				"wrapper": true
			},
			"S1d": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S1f": {
				"type": "structure",
				"members": {
					"CacheSubnetGroupName": {},
					"CacheSubnetGroupDescription": {},
					"VpcId": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"type": "structure",
									"members": {
										"Name": {}
									},
									"wrapper": true
								}
							}
						}
					}
				},
				"wrapper": true
			},
			"S1m": {
				"type": "structure",
				"members": {
					"ReplicationGroupId": {},
					"Description": {},
					"Status": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"PrimaryClusterId": {},
							"AutomaticFailoverStatus": {}
						}
					},
					"MemberClusters": {
						"type": "list",
						"member": {
							"locationName": "ClusterId"
						}
					},
					"NodeGroups": {
						"type": "list",
						"member": {
							"locationName": "NodeGroup",
							"type": "structure",
							"members": {
								"NodeGroupId": {},
								"Status": {},
								"PrimaryEndpoint": {
									"shape": "Sv"
								},
								"Slots": {},
								"NodeGroupMembers": {
									"type": "list",
									"member": {
										"locationName": "NodeGroupMember",
										"type": "structure",
										"members": {
											"CacheClusterId": {},
											"CacheNodeId": {},
											"ReadEndpoint": {
												"shape": "Sv"
											},
											"PreferredAvailabilityZone": {},
											"CurrentRole": {}
										}
									}
								}
							}
						}
					},
					"SnapshottingClusterId": {},
					"AutomaticFailover": {},
					"ConfigurationEndpoint": {
						"shape": "Sv"
					},
					"SnapshotRetentionLimit": {
						"type": "integer"
					},
					"SnapshotWindow": {}
				},
				"wrapper": true
			},
			"S2h": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ChangeType": {}
					}
				}
			},
			"S2k": {
				"type": "list",
				"member": {
					"locationName": "CacheNodeTypeSpecificParameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"Description": {},
						"Source": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"CacheNodeTypeSpecificValues": {
							"type": "list",
							"member": {
								"locationName": "CacheNodeTypeSpecificValue",
								"type": "structure",
								"members": {
									"CacheNodeType": {},
									"Value": {}
								}
							}
						},
						"ChangeType": {}
					}
				}
			},
			"S38": {
				"type": "structure",
				"members": {
					"ReservedCacheNodeId": {},
					"ReservedCacheNodesOfferingId": {},
					"CacheNodeType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CacheNodeCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"State": {},
					"RecurringCharges": {
						"shape": "S3a"
					}
				},
				"wrapper": true
			},
			"S3a": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S3q": {
				"type": "list",
				"member": {
					"locationName": "ParameterNameValue",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {}
					}
				}
			},
			"S3s": {
				"type": "structure",
				"members": {
					"CacheParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 685 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeCacheClusters": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "CacheClusters"
			},
			"DescribeCacheEngineVersions": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "CacheEngineVersions"
			},
			"DescribeCacheParameterGroups": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "CacheParameterGroups"
			},
			"DescribeCacheParameters": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "Parameters"
			},
			"DescribeCacheSecurityGroups": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "CacheSecurityGroups"
			},
			"DescribeCacheSubnetGroups": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "CacheSubnetGroups"
			},
			"DescribeEngineDefaultParameters": {
				"input_token": "Marker",
				"output_token": "EngineDefaults.Marker",
				"limit_key": "MaxRecords",
				"result_key": "EngineDefaults.Parameters"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "Events"
			},
			"DescribeReservedCacheNodes": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "ReservedCacheNodes"
			},
			"DescribeReservedCacheNodesOfferings": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "ReservedCacheNodesOfferings"
			},
			"DescribeReplicationGroups": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "ReplicationGroups"
			},
			"DescribeSnapshots": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "Snapshots"
			}
		}
	};

/***/ },
/* 686 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"CacheClusterAvailable": {
				"acceptors": [
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "available",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "incompatible-network",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "restore-failed",
						"matcher": "pathAny",
						"state": "failure"
					}
				],
				"delay": 15,
				"description": "Wait until ElastiCache cluster is available.",
				"maxAttempts": 40,
				"operation": "DescribeCacheClusters"
			},
			"CacheClusterDeleted": {
				"acceptors": [
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"expected": "CacheClusterNotFound",
						"matcher": "error",
						"state": "success"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "available",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "creating",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "incompatible-network",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "modifying",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "restore-failed",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"argument": "CacheClusters[].CacheClusterStatus",
						"expected": "snapshotting",
						"matcher": "pathAny",
						"state": "failure"
					}
				],
				"delay": 15,
				"description": "Wait until ElastiCache cluster is deleted.",
				"maxAttempts": 40,
				"operation": "DescribeCacheClusters"
			},
			"ReplicationGroupAvailable": {
				"acceptors": [
					{
						"argument": "ReplicationGroups[].Status",
						"expected": "available",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"argument": "ReplicationGroups[].Status",
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure"
					}
				],
				"delay": 15,
				"description": "Wait until ElastiCache replication group is available.",
				"maxAttempts": 40,
				"operation": "DescribeReplicationGroups"
			},
			"ReplicationGroupDeleted": {
				"acceptors": [
					{
						"argument": "ReplicationGroups[].Status",
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success"
					},
					{
						"argument": "ReplicationGroups[].Status",
						"expected": "available",
						"matcher": "pathAny",
						"state": "failure"
					},
					{
						"expected": "ReplicationGroupNotFoundFault",
						"matcher": "error",
						"state": "success"
					}
				],
				"delay": 15,
				"description": "Wait until ElastiCache replication group is deleted.",
				"maxAttempts": 40,
				"operation": "DescribeReplicationGroups"
			}
		}
	};

/***/ },
/* 687 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2010-12-01",
			"endpointPrefix": "elasticbeanstalk",
			"protocol": "query",
			"serviceAbbreviation": "Elastic Beanstalk",
			"serviceFullName": "AWS Elastic Beanstalk",
			"signatureVersion": "v4",
			"uid": "elasticbeanstalk-2010-12-01",
			"xmlNamespace": "http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"
		},
		"operations": {
			"AbortEnvironmentUpdate": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {}
					}
				}
			},
			"ApplyEnvironmentManagedAction": {
				"input": {
					"type": "structure",
					"required": [
						"ActionId"
					],
					"members": {
						"EnvironmentName": {},
						"EnvironmentId": {},
						"ActionId": {}
					}
				},
				"output": {
					"resultWrapper": "ApplyEnvironmentManagedActionResult",
					"type": "structure",
					"members": {
						"ActionId": {},
						"ActionDescription": {},
						"ActionType": {},
						"Status": {}
					}
				}
			},
			"CheckDNSAvailability": {
				"input": {
					"type": "structure",
					"required": [
						"CNAMEPrefix"
					],
					"members": {
						"CNAMEPrefix": {}
					}
				},
				"output": {
					"resultWrapper": "CheckDNSAvailabilityResult",
					"type": "structure",
					"members": {
						"Available": {
							"type": "boolean"
						},
						"FullyQualifiedCNAME": {}
					}
				}
			},
			"ComposeEnvironments": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"GroupName": {},
						"VersionLabels": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"shape": "Si",
					"resultWrapper": "ComposeEnvironmentsResult"
				}
			},
			"CreateApplication": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"Description": {},
						"ResourceLifecycleConfig": {
							"shape": "S14"
						}
					}
				},
				"output": {
					"shape": "S1a",
					"resultWrapper": "CreateApplicationResult"
				}
			},
			"CreateApplicationVersion": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"VersionLabel"
					],
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"Description": {},
						"SourceBuildInformation": {
							"shape": "S1f"
						},
						"SourceBundle": {
							"shape": "S1j"
						},
						"BuildConfiguration": {
							"type": "structure",
							"required": [
								"CodeBuildServiceRole",
								"Image"
							],
							"members": {
								"ArtifactName": {},
								"CodeBuildServiceRole": {},
								"ComputeType": {},
								"Image": {},
								"TimeoutInMinutes": {
									"type": "integer"
								}
							}
						},
						"AutoCreateApplication": {
							"type": "boolean"
						},
						"Process": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "S1r",
					"resultWrapper": "CreateApplicationVersionResult"
				}
			},
			"CreateConfigurationTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"TemplateName"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"SolutionStackName": {},
						"SourceConfiguration": {
							"type": "structure",
							"members": {
								"ApplicationName": {},
								"TemplateName": {}
							}
						},
						"EnvironmentId": {},
						"Description": {},
						"OptionSettings": {
							"shape": "S1w"
						}
					}
				},
				"output": {
					"shape": "S22",
					"resultWrapper": "CreateConfigurationTemplateResult"
				}
			},
			"CreateEnvironment": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"EnvironmentName": {},
						"GroupName": {},
						"Description": {},
						"CNAMEPrefix": {},
						"Tier": {
							"shape": "S10"
						},
						"Tags": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"Value": {}
								}
							}
						},
						"VersionLabel": {},
						"TemplateName": {},
						"SolutionStackName": {},
						"OptionSettings": {
							"shape": "S1w"
						},
						"OptionsToRemove": {
							"shape": "S29"
						}
					}
				},
				"output": {
					"shape": "Sk",
					"resultWrapper": "CreateEnvironmentResult"
				}
			},
			"CreateStorageLocation": {
				"output": {
					"resultWrapper": "CreateStorageLocationResult",
					"type": "structure",
					"members": {
						"S3Bucket": {}
					}
				}
			},
			"DeleteApplication": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"TerminateEnvByForce": {
							"type": "boolean"
						}
					}
				}
			},
			"DeleteApplicationVersion": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"VersionLabel"
					],
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"DeleteSourceBundle": {
							"type": "boolean"
						}
					}
				}
			},
			"DeleteConfigurationTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"TemplateName"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {}
					}
				}
			},
			"DeleteEnvironmentConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"EnvironmentName"
					],
					"members": {
						"ApplicationName": {},
						"EnvironmentName": {}
					}
				}
			},
			"DescribeApplicationVersions": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"VersionLabels": {
							"shape": "S1c"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeApplicationVersionsResult",
					"type": "structure",
					"members": {
						"ApplicationVersions": {
							"type": "list",
							"member": {
								"shape": "S1s"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeApplications": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeApplicationsResult",
					"type": "structure",
					"members": {
						"Applications": {
							"type": "list",
							"member": {
								"shape": "S1b"
							}
						}
					}
				}
			},
			"DescribeConfigurationOptions": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"EnvironmentName": {},
						"SolutionStackName": {},
						"Options": {
							"shape": "S29"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeConfigurationOptionsResult",
					"type": "structure",
					"members": {
						"SolutionStackName": {},
						"Options": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Namespace": {},
									"Name": {},
									"DefaultValue": {},
									"ChangeSeverity": {},
									"UserDefined": {
										"type": "boolean"
									},
									"ValueType": {},
									"ValueOptions": {
										"type": "list",
										"member": {}
									},
									"MinValue": {
										"type": "integer"
									},
									"MaxValue": {
										"type": "integer"
									},
									"MaxLength": {
										"type": "integer"
									},
									"Regex": {
										"type": "structure",
										"members": {
											"Pattern": {},
											"Label": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeConfigurationSettings": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"EnvironmentName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeConfigurationSettingsResult",
					"type": "structure",
					"members": {
						"ConfigurationSettings": {
							"type": "list",
							"member": {
								"shape": "S22"
							}
						}
					}
				}
			},
			"DescribeEnvironmentHealth": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentName": {},
						"EnvironmentId": {},
						"AttributeNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEnvironmentHealthResult",
					"type": "structure",
					"members": {
						"EnvironmentName": {},
						"HealthStatus": {},
						"Status": {},
						"Color": {},
						"Causes": {
							"shape": "S3e"
						},
						"ApplicationMetrics": {
							"shape": "S3g"
						},
						"InstancesHealth": {
							"type": "structure",
							"members": {
								"NoData": {
									"type": "integer"
								},
								"Unknown": {
									"type": "integer"
								},
								"Pending": {
									"type": "integer"
								},
								"Ok": {
									"type": "integer"
								},
								"Info": {
									"type": "integer"
								},
								"Warning": {
									"type": "integer"
								},
								"Degraded": {
									"type": "integer"
								},
								"Severe": {
									"type": "integer"
								}
							}
						},
						"RefreshedAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeEnvironmentManagedActionHistory": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {},
						"NextToken": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEnvironmentManagedActionHistoryResult",
					"type": "structure",
					"members": {
						"ManagedActionHistoryItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ActionId": {},
									"ActionType": {},
									"ActionDescription": {},
									"FailureType": {},
									"Status": {},
									"FailureDescription": {},
									"ExecutedTime": {
										"type": "timestamp"
									},
									"FinishedTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeEnvironmentManagedActions": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentName": {},
						"EnvironmentId": {},
						"Status": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEnvironmentManagedActionsResult",
					"type": "structure",
					"members": {
						"ManagedActions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ActionId": {},
									"ActionDescription": {},
									"ActionType": {},
									"Status": {},
									"WindowStartTime": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeEnvironmentResources": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEnvironmentResourcesResult",
					"type": "structure",
					"members": {
						"EnvironmentResources": {
							"type": "structure",
							"members": {
								"EnvironmentName": {},
								"AutoScalingGroups": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								},
								"Instances": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Id": {}
										}
									}
								},
								"LaunchConfigurations": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								},
								"LoadBalancers": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								},
								"Triggers": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {}
										}
									}
								},
								"Queues": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"Name": {},
											"URL": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeEnvironments": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"EnvironmentIds": {
							"type": "list",
							"member": {}
						},
						"EnvironmentNames": {
							"type": "list",
							"member": {}
						},
						"IncludeDeleted": {
							"type": "boolean"
						},
						"IncludedDeletedBackTo": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"shape": "Si",
					"resultWrapper": "DescribeEnvironmentsResult"
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"TemplateName": {},
						"EnvironmentId": {},
						"EnvironmentName": {},
						"RequestId": {},
						"Severity": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventDate": {
										"type": "timestamp"
									},
									"Message": {},
									"ApplicationName": {},
									"VersionLabel": {},
									"TemplateName": {},
									"EnvironmentName": {},
									"RequestId": {},
									"Severity": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstancesHealth": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentName": {},
						"EnvironmentId": {},
						"AttributeNames": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeInstancesHealthResult",
					"type": "structure",
					"members": {
						"InstanceHealthList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"InstanceId": {},
									"HealthStatus": {},
									"Color": {},
									"Causes": {
										"shape": "S3e"
									},
									"LaunchedAt": {
										"type": "timestamp"
									},
									"ApplicationMetrics": {
										"shape": "S3g"
									},
									"System": {
										"type": "structure",
										"members": {
											"CPUUtilization": {
												"type": "structure",
												"members": {
													"User": {
														"type": "double"
													},
													"Nice": {
														"type": "double"
													},
													"System": {
														"type": "double"
													},
													"Idle": {
														"type": "double"
													},
													"IOWait": {
														"type": "double"
													},
													"IRQ": {
														"type": "double"
													},
													"SoftIRQ": {
														"type": "double"
													}
												}
											},
											"LoadAverage": {
												"type": "list",
												"member": {
													"type": "double"
												}
											}
										}
									},
									"Deployment": {
										"type": "structure",
										"members": {
											"VersionLabel": {},
											"DeploymentId": {
												"type": "long"
											},
											"Status": {},
											"DeploymentTime": {
												"type": "timestamp"
											}
										}
									},
									"AvailabilityZone": {},
									"InstanceType": {}
								}
							}
						},
						"RefreshedAt": {
							"type": "timestamp"
						},
						"NextToken": {}
					}
				}
			},
			"ListAvailableSolutionStacks": {
				"output": {
					"resultWrapper": "ListAvailableSolutionStacksResult",
					"type": "structure",
					"members": {
						"SolutionStacks": {
							"type": "list",
							"member": {}
						},
						"SolutionStackDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SolutionStackName": {},
									"PermittedFileTypes": {
										"type": "list",
										"member": {}
									}
								}
							}
						}
					}
				}
			},
			"RebuildEnvironment": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {}
					}
				}
			},
			"RequestEnvironmentInfo": {
				"input": {
					"type": "structure",
					"required": [
						"InfoType"
					],
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {},
						"InfoType": {}
					}
				}
			},
			"RestartAppServer": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {}
					}
				}
			},
			"RetrieveEnvironmentInfo": {
				"input": {
					"type": "structure",
					"required": [
						"InfoType"
					],
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {},
						"InfoType": {}
					}
				},
				"output": {
					"resultWrapper": "RetrieveEnvironmentInfoResult",
					"type": "structure",
					"members": {
						"EnvironmentInfo": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"InfoType": {},
									"Ec2InstanceId": {},
									"SampleTimestamp": {
										"type": "timestamp"
									},
									"Message": {}
								}
							}
						}
					}
				}
			},
			"SwapEnvironmentCNAMEs": {
				"input": {
					"type": "structure",
					"members": {
						"SourceEnvironmentId": {},
						"SourceEnvironmentName": {},
						"DestinationEnvironmentId": {},
						"DestinationEnvironmentName": {}
					}
				}
			},
			"TerminateEnvironment": {
				"input": {
					"type": "structure",
					"members": {
						"EnvironmentId": {},
						"EnvironmentName": {},
						"TerminateResources": {
							"type": "boolean"
						},
						"ForceTerminate": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "Sk",
					"resultWrapper": "TerminateEnvironmentResult"
				}
			},
			"UpdateApplication": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName"
					],
					"members": {
						"ApplicationName": {},
						"Description": {}
					}
				},
				"output": {
					"shape": "S1a",
					"resultWrapper": "UpdateApplicationResult"
				}
			},
			"UpdateApplicationResourceLifecycle": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"ResourceLifecycleConfig"
					],
					"members": {
						"ApplicationName": {},
						"ResourceLifecycleConfig": {
							"shape": "S14"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateApplicationResourceLifecycleResult",
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"ResourceLifecycleConfig": {
							"shape": "S14"
						}
					}
				}
			},
			"UpdateApplicationVersion": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"VersionLabel"
					],
					"members": {
						"ApplicationName": {},
						"VersionLabel": {},
						"Description": {}
					}
				},
				"output": {
					"shape": "S1r",
					"resultWrapper": "UpdateApplicationVersionResult"
				}
			},
			"UpdateConfigurationTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"TemplateName"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"Description": {},
						"OptionSettings": {
							"shape": "S1w"
						},
						"OptionsToRemove": {
							"shape": "S29"
						}
					}
				},
				"output": {
					"shape": "S22",
					"resultWrapper": "UpdateConfigurationTemplateResult"
				}
			},
			"UpdateEnvironment": {
				"input": {
					"type": "structure",
					"members": {
						"ApplicationName": {},
						"EnvironmentId": {},
						"EnvironmentName": {},
						"GroupName": {},
						"Description": {},
						"Tier": {
							"shape": "S10"
						},
						"VersionLabel": {},
						"TemplateName": {},
						"SolutionStackName": {},
						"OptionSettings": {
							"shape": "S1w"
						},
						"OptionsToRemove": {
							"shape": "S29"
						}
					}
				},
				"output": {
					"shape": "Sk",
					"resultWrapper": "UpdateEnvironmentResult"
				}
			},
			"ValidateConfigurationSettings": {
				"input": {
					"type": "structure",
					"required": [
						"ApplicationName",
						"OptionSettings"
					],
					"members": {
						"ApplicationName": {},
						"TemplateName": {},
						"EnvironmentName": {},
						"OptionSettings": {
							"shape": "S1w"
						}
					}
				},
				"output": {
					"resultWrapper": "ValidateConfigurationSettingsResult",
					"type": "structure",
					"members": {
						"Messages": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Message": {},
									"Severity": {},
									"Namespace": {},
									"OptionName": {}
								}
							}
						}
					}
				}
			}
		},
		"shapes": {
			"Si": {
				"type": "structure",
				"members": {
					"Environments": {
						"type": "list",
						"member": {
							"shape": "Sk"
						}
					}
				}
			},
			"Sk": {
				"type": "structure",
				"members": {
					"EnvironmentName": {},
					"EnvironmentId": {},
					"ApplicationName": {},
					"VersionLabel": {},
					"SolutionStackName": {},
					"TemplateName": {},
					"Description": {},
					"EndpointURL": {},
					"CNAME": {},
					"DateCreated": {
						"type": "timestamp"
					},
					"DateUpdated": {
						"type": "timestamp"
					},
					"Status": {},
					"AbortableOperationInProgress": {
						"type": "boolean"
					},
					"Health": {},
					"HealthStatus": {},
					"Resources": {
						"type": "structure",
						"members": {
							"LoadBalancer": {
								"type": "structure",
								"members": {
									"LoadBalancerName": {},
									"Domain": {},
									"Listeners": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Protocol": {},
												"Port": {
													"type": "integer"
												}
											}
										}
									}
								}
							}
						}
					},
					"Tier": {
						"shape": "S10"
					},
					"EnvironmentLinks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"LinkName": {},
								"EnvironmentName": {}
							}
						}
					}
				}
			},
			"S10": {
				"type": "structure",
				"members": {
					"Name": {},
					"Type": {},
					"Version": {}
				}
			},
			"S14": {
				"type": "structure",
				"members": {
					"ServiceRole": {},
					"VersionLifecycleConfig": {
						"type": "structure",
						"members": {
							"MaxCountRule": {
								"type": "structure",
								"required": [
									"Enabled"
								],
								"members": {
									"Enabled": {
										"type": "boolean"
									},
									"MaxCount": {
										"type": "integer"
									},
									"DeleteSourceFromS3": {
										"type": "boolean"
									}
								}
							},
							"MaxAgeRule": {
								"type": "structure",
								"required": [
									"Enabled"
								],
								"members": {
									"Enabled": {
										"type": "boolean"
									},
									"MaxAgeInDays": {
										"type": "integer"
									},
									"DeleteSourceFromS3": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"S1a": {
				"type": "structure",
				"members": {
					"Application": {
						"shape": "S1b"
					}
				}
			},
			"S1b": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"Description": {},
					"DateCreated": {
						"type": "timestamp"
					},
					"DateUpdated": {
						"type": "timestamp"
					},
					"Versions": {
						"shape": "S1c"
					},
					"ConfigurationTemplates": {
						"type": "list",
						"member": {}
					},
					"ResourceLifecycleConfig": {
						"shape": "S14"
					}
				}
			},
			"S1c": {
				"type": "list",
				"member": {}
			},
			"S1f": {
				"type": "structure",
				"required": [
					"SourceType",
					"SourceRepository",
					"SourceLocation"
				],
				"members": {
					"SourceType": {},
					"SourceRepository": {},
					"SourceLocation": {}
				}
			},
			"S1j": {
				"type": "structure",
				"members": {
					"S3Bucket": {},
					"S3Key": {}
				}
			},
			"S1r": {
				"type": "structure",
				"members": {
					"ApplicationVersion": {
						"shape": "S1s"
					}
				}
			},
			"S1s": {
				"type": "structure",
				"members": {
					"ApplicationName": {},
					"Description": {},
					"VersionLabel": {},
					"SourceBuildInformation": {
						"shape": "S1f"
					},
					"BuildArn": {},
					"SourceBundle": {
						"shape": "S1j"
					},
					"DateCreated": {
						"type": "timestamp"
					},
					"DateUpdated": {
						"type": "timestamp"
					},
					"Status": {}
				}
			},
			"S1w": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ResourceName": {},
						"Namespace": {},
						"OptionName": {},
						"Value": {}
					}
				}
			},
			"S22": {
				"type": "structure",
				"members": {
					"SolutionStackName": {},
					"ApplicationName": {},
					"TemplateName": {},
					"Description": {},
					"EnvironmentName": {},
					"DeploymentStatus": {},
					"DateCreated": {
						"type": "timestamp"
					},
					"DateUpdated": {
						"type": "timestamp"
					},
					"OptionSettings": {
						"shape": "S1w"
					}
				}
			},
			"S29": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ResourceName": {},
						"Namespace": {},
						"OptionName": {}
					}
				}
			},
			"S3e": {
				"type": "list",
				"member": {}
			},
			"S3g": {
				"type": "structure",
				"members": {
					"Duration": {
						"type": "integer"
					},
					"RequestCount": {
						"type": "integer"
					},
					"StatusCodes": {
						"type": "structure",
						"members": {
							"Status2xx": {
								"type": "integer"
							},
							"Status3xx": {
								"type": "integer"
							},
							"Status4xx": {
								"type": "integer"
							},
							"Status5xx": {
								"type": "integer"
							}
						}
					},
					"Latency": {
						"type": "structure",
						"members": {
							"P999": {
								"type": "double"
							},
							"P99": {
								"type": "double"
							},
							"P95": {
								"type": "double"
							},
							"P90": {
								"type": "double"
							},
							"P85": {
								"type": "double"
							},
							"P75": {
								"type": "double"
							},
							"P50": {
								"type": "double"
							},
							"P10": {
								"type": "double"
							}
						}
					}
				}
			}
		}
	};

/***/ },
/* 688 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeApplicationVersions": {
				"result_key": "ApplicationVersions"
			},
			"DescribeApplications": {
				"result_key": "Applications"
			},
			"DescribeConfigurationOptions": {
				"result_key": "Options"
			},
			"DescribeEnvironments": {
				"result_key": "Environments"
			},
			"DescribeEvents": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "Events"
			},
			"ListAvailableSolutionStacks": {
				"result_key": "SolutionStacks"
			}
		}
	};

/***/ },
/* 689 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "elasticloadbalancing-2012-06-01",
			"apiVersion": "2012-06-01",
			"endpointPrefix": "elasticloadbalancing",
			"protocol": "query",
			"serviceFullName": "Elastic Load Balancing",
			"signatureVersion": "v4",
			"xmlNamespace": "http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"
		},
		"operations": {
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerNames",
						"Tags"
					],
					"members": {
						"LoadBalancerNames": {
							"shape": "S2"
						},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"resultWrapper": "AddTagsResult",
					"type": "structure",
					"members": {}
				}
			},
			"ApplySecurityGroupsToLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"SecurityGroups"
					],
					"members": {
						"LoadBalancerName": {},
						"SecurityGroups": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "ApplySecurityGroupsToLoadBalancerResult",
					"type": "structure",
					"members": {
						"SecurityGroups": {
							"shape": "Sa"
						}
					}
				}
			},
			"AttachLoadBalancerToSubnets": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Subnets"
					],
					"members": {
						"LoadBalancerName": {},
						"Subnets": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"resultWrapper": "AttachLoadBalancerToSubnetsResult",
					"type": "structure",
					"members": {
						"Subnets": {
							"shape": "Se"
						}
					}
				}
			},
			"ConfigureHealthCheck": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"HealthCheck"
					],
					"members": {
						"LoadBalancerName": {},
						"HealthCheck": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"resultWrapper": "ConfigureHealthCheckResult",
					"type": "structure",
					"members": {
						"HealthCheck": {
							"shape": "Si"
						}
					}
				}
			},
			"CreateAppCookieStickinessPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"PolicyName",
						"CookieName"
					],
					"members": {
						"LoadBalancerName": {},
						"PolicyName": {},
						"CookieName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateAppCookieStickinessPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateLBCookieStickinessPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"PolicyName"
					],
					"members": {
						"LoadBalancerName": {},
						"PolicyName": {},
						"CookieExpirationPeriod": {
							"type": "long"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateLBCookieStickinessPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Listeners"
					],
					"members": {
						"LoadBalancerName": {},
						"Listeners": {
							"shape": "Sx"
						},
						"AvailabilityZones": {
							"shape": "S13"
						},
						"Subnets": {
							"shape": "Se"
						},
						"SecurityGroups": {
							"shape": "Sa"
						},
						"Scheme": {},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateLoadBalancerResult",
					"type": "structure",
					"members": {
						"DNSName": {}
					}
				}
			},
			"CreateLoadBalancerListeners": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Listeners"
					],
					"members": {
						"LoadBalancerName": {},
						"Listeners": {
							"shape": "Sx"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateLoadBalancerListenersResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateLoadBalancerPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"PolicyName",
						"PolicyTypeName"
					],
					"members": {
						"LoadBalancerName": {},
						"PolicyName": {},
						"PolicyTypeName": {},
						"PolicyAttributes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AttributeName": {},
									"AttributeValue": {}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "CreateLoadBalancerPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName"
					],
					"members": {
						"LoadBalancerName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteLoadBalancerResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteLoadBalancerListeners": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"LoadBalancerPorts"
					],
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerPorts": {
							"type": "list",
							"member": {
								"type": "integer"
							}
						}
					}
				},
				"output": {
					"resultWrapper": "DeleteLoadBalancerListenersResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteLoadBalancerPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"PolicyName"
					],
					"members": {
						"LoadBalancerName": {},
						"PolicyName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteLoadBalancerPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterInstancesFromLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Instances"
					],
					"members": {
						"LoadBalancerName": {},
						"Instances": {
							"shape": "S1p"
						}
					}
				},
				"output": {
					"resultWrapper": "DeregisterInstancesFromLoadBalancerResult",
					"type": "structure",
					"members": {
						"Instances": {
							"shape": "S1p"
						}
					}
				}
			},
			"DescribeInstanceHealth": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName"
					],
					"members": {
						"LoadBalancerName": {},
						"Instances": {
							"shape": "S1p"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeInstanceHealthResult",
					"type": "structure",
					"members": {
						"InstanceStates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"InstanceId": {},
									"State": {},
									"ReasonCode": {},
									"Description": {}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBalancerAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName"
					],
					"members": {
						"LoadBalancerName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerAttributesResult",
					"type": "structure",
					"members": {
						"LoadBalancerAttributes": {
							"shape": "S22"
						}
					}
				}
			},
			"DescribeLoadBalancerPolicies": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerName": {},
						"PolicyNames": {
							"shape": "S2k"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerPoliciesResult",
					"type": "structure",
					"members": {
						"PolicyDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PolicyName": {},
									"PolicyTypeName": {},
									"PolicyAttributeDescriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"AttributeName": {},
												"AttributeValue": {}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBalancerPolicyTypes": {
				"input": {
					"type": "structure",
					"members": {
						"PolicyTypeNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerPolicyTypesResult",
					"type": "structure",
					"members": {
						"PolicyTypeDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PolicyTypeName": {},
									"Description": {},
									"PolicyAttributeTypeDescriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"AttributeName": {},
												"AttributeType": {},
												"Description": {},
												"DefaultValue": {},
												"Cardinality": {}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBalancers": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerNames": {
							"shape": "S2"
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancersResult",
					"type": "structure",
					"members": {
						"LoadBalancerDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LoadBalancerName": {},
									"DNSName": {},
									"CanonicalHostedZoneName": {},
									"CanonicalHostedZoneNameID": {},
									"ListenerDescriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Listener": {
													"shape": "Sy"
												},
												"PolicyNames": {
													"shape": "S2k"
												}
											}
										}
									},
									"Policies": {
										"type": "structure",
										"members": {
											"AppCookieStickinessPolicies": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"PolicyName": {},
														"CookieName": {}
													}
												}
											},
											"LBCookieStickinessPolicies": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"PolicyName": {},
														"CookieExpirationPeriod": {
															"type": "long"
														}
													}
												}
											},
											"OtherPolicies": {
												"shape": "S2k"
											}
										}
									},
									"BackendServerDescriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"InstancePort": {
													"type": "integer"
												},
												"PolicyNames": {
													"shape": "S2k"
												}
											}
										}
									},
									"AvailabilityZones": {
										"shape": "S13"
									},
									"Subnets": {
										"shape": "Se"
									},
									"VPCId": {},
									"Instances": {
										"shape": "S1p"
									},
									"HealthCheck": {
										"shape": "Si"
									},
									"SourceSecurityGroup": {
										"type": "structure",
										"members": {
											"OwnerAlias": {},
											"GroupName": {}
										}
									},
									"SecurityGroups": {
										"shape": "Sa"
									},
									"CreatedTime": {
										"type": "timestamp"
									},
									"Scheme": {}
								}
							}
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerNames"
					],
					"members": {
						"LoadBalancerNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTagsResult",
					"type": "structure",
					"members": {
						"TagDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LoadBalancerName": {},
									"Tags": {
										"shape": "S4"
									}
								}
							}
						}
					}
				}
			},
			"DetachLoadBalancerFromSubnets": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Subnets"
					],
					"members": {
						"LoadBalancerName": {},
						"Subnets": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"resultWrapper": "DetachLoadBalancerFromSubnetsResult",
					"type": "structure",
					"members": {
						"Subnets": {
							"shape": "Se"
						}
					}
				}
			},
			"DisableAvailabilityZonesForLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"AvailabilityZones"
					],
					"members": {
						"LoadBalancerName": {},
						"AvailabilityZones": {
							"shape": "S13"
						}
					}
				},
				"output": {
					"resultWrapper": "DisableAvailabilityZonesForLoadBalancerResult",
					"type": "structure",
					"members": {
						"AvailabilityZones": {
							"shape": "S13"
						}
					}
				}
			},
			"EnableAvailabilityZonesForLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"AvailabilityZones"
					],
					"members": {
						"LoadBalancerName": {},
						"AvailabilityZones": {
							"shape": "S13"
						}
					}
				},
				"output": {
					"resultWrapper": "EnableAvailabilityZonesForLoadBalancerResult",
					"type": "structure",
					"members": {
						"AvailabilityZones": {
							"shape": "S13"
						}
					}
				}
			},
			"ModifyLoadBalancerAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"LoadBalancerAttributes"
					],
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerAttributes": {
							"shape": "S22"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyLoadBalancerAttributesResult",
					"type": "structure",
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerAttributes": {
							"shape": "S22"
						}
					}
				}
			},
			"RegisterInstancesWithLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"Instances"
					],
					"members": {
						"LoadBalancerName": {},
						"Instances": {
							"shape": "S1p"
						}
					}
				},
				"output": {
					"resultWrapper": "RegisterInstancesWithLoadBalancerResult",
					"type": "structure",
					"members": {
						"Instances": {
							"shape": "S1p"
						}
					}
				}
			},
			"RemoveTags": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerNames",
						"Tags"
					],
					"members": {
						"LoadBalancerNames": {
							"shape": "S2"
						},
						"Tags": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "RemoveTagsResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetLoadBalancerListenerSSLCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"LoadBalancerPort",
						"SSLCertificateId"
					],
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerPort": {
							"type": "integer"
						},
						"SSLCertificateId": {}
					}
				},
				"output": {
					"resultWrapper": "SetLoadBalancerListenerSSLCertificateResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetLoadBalancerPoliciesForBackendServer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"InstancePort",
						"PolicyNames"
					],
					"members": {
						"LoadBalancerName": {},
						"InstancePort": {
							"type": "integer"
						},
						"PolicyNames": {
							"shape": "S2k"
						}
					}
				},
				"output": {
					"resultWrapper": "SetLoadBalancerPoliciesForBackendServerResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetLoadBalancerPoliciesOfListener": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerName",
						"LoadBalancerPort",
						"PolicyNames"
					],
					"members": {
						"LoadBalancerName": {},
						"LoadBalancerPort": {
							"type": "integer"
						},
						"PolicyNames": {
							"shape": "S2k"
						}
					}
				},
				"output": {
					"resultWrapper": "SetLoadBalancerPoliciesOfListenerResult",
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"S4": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sa": {
				"type": "list",
				"member": {}
			},
			"Se": {
				"type": "list",
				"member": {}
			},
			"Si": {
				"type": "structure",
				"required": [
					"Target",
					"Interval",
					"Timeout",
					"UnhealthyThreshold",
					"HealthyThreshold"
				],
				"members": {
					"Target": {},
					"Interval": {
						"type": "integer"
					},
					"Timeout": {
						"type": "integer"
					},
					"UnhealthyThreshold": {
						"type": "integer"
					},
					"HealthyThreshold": {
						"type": "integer"
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"shape": "Sy"
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"Protocol",
					"LoadBalancerPort",
					"InstancePort"
				],
				"members": {
					"Protocol": {},
					"LoadBalancerPort": {
						"type": "integer"
					},
					"InstanceProtocol": {},
					"InstancePort": {
						"type": "integer"
					},
					"SSLCertificateId": {}
				}
			},
			"S13": {
				"type": "list",
				"member": {}
			},
			"S1p": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"InstanceId": {}
					}
				}
			},
			"S22": {
				"type": "structure",
				"members": {
					"CrossZoneLoadBalancing": {
						"type": "structure",
						"required": [
							"Enabled"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							}
						}
					},
					"AccessLog": {
						"type": "structure",
						"required": [
							"Enabled"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"S3BucketName": {},
							"EmitInterval": {
								"type": "integer"
							},
							"S3BucketPrefix": {}
						}
					},
					"ConnectionDraining": {
						"type": "structure",
						"required": [
							"Enabled"
						],
						"members": {
							"Enabled": {
								"type": "boolean"
							},
							"Timeout": {
								"type": "integer"
							}
						}
					},
					"ConnectionSettings": {
						"type": "structure",
						"required": [
							"IdleTimeout"
						],
						"members": {
							"IdleTimeout": {
								"type": "integer"
							}
						}
					},
					"AdditionalAttributes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S2k": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 690 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeInstanceHealth": {
				"result_key": "InstanceStates"
			},
			"DescribeLoadBalancerPolicies": {
				"result_key": "PolicyDescriptions"
			},
			"DescribeLoadBalancerPolicyTypes": {
				"result_key": "PolicyTypeDescriptions"
			},
			"DescribeLoadBalancers": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"result_key": "LoadBalancerDescriptions"
			}
		}
	};

/***/ },
/* 691 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"InstanceDeregistered": {
				"delay": 15,
				"operation": "DescribeInstanceHealth",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": "OutOfService",
						"matcher": "pathAll",
						"state": "success",
						"argument": "InstanceStates[].State"
					},
					{
						"matcher": "error",
						"expected": "InvalidInstance",
						"state": "success"
					}
				]
			},
			"AnyInstanceInService": {
				"acceptors": [
					{
						"argument": "InstanceStates[].State",
						"expected": "InService",
						"matcher": "pathAny",
						"state": "success"
					}
				],
				"delay": 15,
				"maxAttempts": 40,
				"operation": "DescribeInstanceHealth"
			},
			"InstanceInService": {
				"acceptors": [
					{
						"argument": "InstanceStates[].State",
						"expected": "InService",
						"matcher": "pathAll",
						"state": "success"
					}
				],
				"delay": 15,
				"maxAttempts": 40,
				"operation": "DescribeInstanceHealth"
			}
		}
	};

/***/ },
/* 692 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-12-01",
			"endpointPrefix": "elasticloadbalancing",
			"protocol": "query",
			"serviceAbbreviation": "Elastic Load Balancing v2",
			"serviceFullName": "Elastic Load Balancing",
			"signatureVersion": "v4",
			"uid": "elasticloadbalancingv2-2015-12-01",
			"xmlNamespace": "http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"
		},
		"operations": {
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArns",
						"Tags"
					],
					"members": {
						"ResourceArns": {
							"shape": "S2"
						},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"resultWrapper": "AddTagsResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateListener": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn",
						"Protocol",
						"Port",
						"DefaultActions"
					],
					"members": {
						"LoadBalancerArn": {},
						"Protocol": {},
						"Port": {
							"type": "integer"
						},
						"SslPolicy": {},
						"Certificates": {
							"shape": "Se"
						},
						"DefaultActions": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateListenerResult",
					"type": "structure",
					"members": {
						"Listeners": {
							"shape": "Sm"
						}
					}
				}
			},
			"CreateLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Subnets"
					],
					"members": {
						"Name": {},
						"Subnets": {
							"shape": "Sr"
						},
						"SecurityGroups": {
							"shape": "St"
						},
						"Scheme": {},
						"Tags": {
							"shape": "S4"
						},
						"IpAddressType": {}
					}
				},
				"output": {
					"resultWrapper": "CreateLoadBalancerResult",
					"type": "structure",
					"members": {
						"LoadBalancers": {
							"shape": "Sy"
						}
					}
				}
			},
			"CreateRule": {
				"input": {
					"type": "structure",
					"required": [
						"ListenerArn",
						"Conditions",
						"Priority",
						"Actions"
					],
					"members": {
						"ListenerArn": {},
						"Conditions": {
							"shape": "S1c"
						},
						"Priority": {
							"type": "integer"
						},
						"Actions": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateRuleResult",
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S1j"
						}
					}
				}
			},
			"CreateTargetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Protocol",
						"Port",
						"VpcId"
					],
					"members": {
						"Name": {},
						"Protocol": {},
						"Port": {
							"type": "integer"
						},
						"VpcId": {},
						"HealthCheckProtocol": {},
						"HealthCheckPort": {},
						"HealthCheckPath": {},
						"HealthCheckIntervalSeconds": {
							"type": "integer"
						},
						"HealthCheckTimeoutSeconds": {
							"type": "integer"
						},
						"HealthyThresholdCount": {
							"type": "integer"
						},
						"UnhealthyThresholdCount": {
							"type": "integer"
						},
						"Matcher": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateTargetGroupResult",
					"type": "structure",
					"members": {
						"TargetGroups": {
							"shape": "S1y"
						}
					}
				}
			},
			"DeleteListener": {
				"input": {
					"type": "structure",
					"required": [
						"ListenerArn"
					],
					"members": {
						"ListenerArn": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteListenerResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn"
					],
					"members": {
						"LoadBalancerArn": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteLoadBalancerResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleArn"
					],
					"members": {
						"RuleArn": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteRuleResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTargetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn"
					],
					"members": {
						"TargetGroupArn": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteTargetGroupResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterTargets": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn",
						"Targets"
					],
					"members": {
						"TargetGroupArn": {},
						"Targets": {
							"shape": "S2a"
						}
					}
				},
				"output": {
					"resultWrapper": "DeregisterTargetsResult",
					"type": "structure",
					"members": {}
				}
			},
			"DescribeListeners": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerArn": {},
						"ListenerArns": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeListenersResult",
					"type": "structure",
					"members": {
						"Listeners": {
							"shape": "Sm"
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeLoadBalancerAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn"
					],
					"members": {
						"LoadBalancerArn": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancerAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "S2l"
						}
					}
				}
			},
			"DescribeLoadBalancers": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerArns": {
							"shape": "S20"
						},
						"Names": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeLoadBalancersResult",
					"type": "structure",
					"members": {
						"LoadBalancers": {
							"shape": "Sy"
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeRules": {
				"input": {
					"type": "structure",
					"members": {
						"ListenerArn": {},
						"RuleArns": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeRulesResult",
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S1j"
						}
					}
				}
			},
			"DescribeSSLPolicies": {
				"input": {
					"type": "structure",
					"members": {
						"Names": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeSSLPoliciesResult",
					"type": "structure",
					"members": {
						"SslPolicies": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SslProtocols": {
										"type": "list",
										"member": {}
									},
									"Ciphers": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Name": {},
												"Priority": {
													"type": "integer"
												}
											}
										}
									},
									"Name": {}
								}
							}
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArns"
					],
					"members": {
						"ResourceArns": {
							"shape": "S2"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTagsResult",
					"type": "structure",
					"members": {
						"TagDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ResourceArn": {},
									"Tags": {
										"shape": "S4"
									}
								}
							}
						}
					}
				}
			},
			"DescribeTargetGroupAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn"
					],
					"members": {
						"TargetGroupArn": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeTargetGroupAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "S3c"
						}
					}
				}
			},
			"DescribeTargetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"LoadBalancerArn": {},
						"TargetGroupArns": {
							"type": "list",
							"member": {}
						},
						"Names": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTargetGroupsResult",
					"type": "structure",
					"members": {
						"TargetGroups": {
							"shape": "S1y"
						},
						"NextMarker": {}
					}
				}
			},
			"DescribeTargetHealth": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn"
					],
					"members": {
						"TargetGroupArn": {},
						"Targets": {
							"shape": "S2a"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTargetHealthResult",
					"type": "structure",
					"members": {
						"TargetHealthDescriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Target": {
										"shape": "S2b"
									},
									"HealthCheckPort": {},
									"TargetHealth": {
										"type": "structure",
										"members": {
											"State": {},
											"Reason": {},
											"Description": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"ModifyListener": {
				"input": {
					"type": "structure",
					"required": [
						"ListenerArn"
					],
					"members": {
						"ListenerArn": {},
						"Port": {
							"type": "integer"
						},
						"Protocol": {},
						"SslPolicy": {},
						"Certificates": {
							"shape": "Se"
						},
						"DefaultActions": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyListenerResult",
					"type": "structure",
					"members": {
						"Listeners": {
							"shape": "Sm"
						}
					}
				}
			},
			"ModifyLoadBalancerAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn",
						"Attributes"
					],
					"members": {
						"LoadBalancerArn": {},
						"Attributes": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyLoadBalancerAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "S2l"
						}
					}
				}
			},
			"ModifyRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleArn"
					],
					"members": {
						"RuleArn": {},
						"Conditions": {
							"shape": "S1c"
						},
						"Actions": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyRuleResult",
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S1j"
						}
					}
				}
			},
			"ModifyTargetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn"
					],
					"members": {
						"TargetGroupArn": {},
						"HealthCheckProtocol": {},
						"HealthCheckPort": {},
						"HealthCheckPath": {},
						"HealthCheckIntervalSeconds": {
							"type": "integer"
						},
						"HealthCheckTimeoutSeconds": {
							"type": "integer"
						},
						"HealthyThresholdCount": {
							"type": "integer"
						},
						"UnhealthyThresholdCount": {
							"type": "integer"
						},
						"Matcher": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyTargetGroupResult",
					"type": "structure",
					"members": {
						"TargetGroups": {
							"shape": "S1y"
						}
					}
				}
			},
			"ModifyTargetGroupAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn",
						"Attributes"
					],
					"members": {
						"TargetGroupArn": {},
						"Attributes": {
							"shape": "S3c"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyTargetGroupAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "S3c"
						}
					}
				}
			},
			"RegisterTargets": {
				"input": {
					"type": "structure",
					"required": [
						"TargetGroupArn",
						"Targets"
					],
					"members": {
						"TargetGroupArn": {},
						"Targets": {
							"shape": "S2a"
						}
					}
				},
				"output": {
					"resultWrapper": "RegisterTargetsResult",
					"type": "structure",
					"members": {}
				}
			},
			"RemoveTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceArns",
						"TagKeys"
					],
					"members": {
						"ResourceArns": {
							"shape": "S2"
						},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "RemoveTagsResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIpAddressType": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn",
						"IpAddressType"
					],
					"members": {
						"LoadBalancerArn": {},
						"IpAddressType": {}
					}
				},
				"output": {
					"resultWrapper": "SetIpAddressTypeResult",
					"type": "structure",
					"members": {
						"IpAddressType": {}
					}
				}
			},
			"SetRulePriorities": {
				"input": {
					"type": "structure",
					"required": [
						"RulePriorities"
					],
					"members": {
						"RulePriorities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RuleArn": {},
									"Priority": {
										"type": "integer"
									}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "SetRulePrioritiesResult",
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S1j"
						}
					}
				}
			},
			"SetSecurityGroups": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn",
						"SecurityGroups"
					],
					"members": {
						"LoadBalancerArn": {},
						"SecurityGroups": {
							"shape": "St"
						}
					}
				},
				"output": {
					"resultWrapper": "SetSecurityGroupsResult",
					"type": "structure",
					"members": {
						"SecurityGroupIds": {
							"shape": "St"
						}
					}
				}
			},
			"SetSubnets": {
				"input": {
					"type": "structure",
					"required": [
						"LoadBalancerArn",
						"Subnets"
					],
					"members": {
						"LoadBalancerArn": {},
						"Subnets": {
							"shape": "Sr"
						}
					}
				},
				"output": {
					"resultWrapper": "SetSubnetsResult",
					"type": "structure",
					"members": {
						"AvailabilityZones": {
							"shape": "S18"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"S4": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Se": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"CertificateArn": {}
					}
				}
			},
			"Sh": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Type",
						"TargetGroupArn"
					],
					"members": {
						"Type": {},
						"TargetGroupArn": {}
					}
				}
			},
			"Sm": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ListenerArn": {},
						"LoadBalancerArn": {},
						"Port": {
							"type": "integer"
						},
						"Protocol": {},
						"Certificates": {
							"shape": "Se"
						},
						"SslPolicy": {},
						"DefaultActions": {
							"shape": "Sh"
						}
					}
				}
			},
			"Sr": {
				"type": "list",
				"member": {}
			},
			"St": {
				"type": "list",
				"member": {}
			},
			"Sy": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"LoadBalancerArn": {},
						"DNSName": {},
						"CanonicalHostedZoneId": {},
						"CreatedTime": {
							"type": "timestamp"
						},
						"LoadBalancerName": {},
						"Scheme": {},
						"VpcId": {},
						"State": {
							"type": "structure",
							"members": {
								"Code": {},
								"Reason": {}
							}
						},
						"Type": {},
						"AvailabilityZones": {
							"shape": "S18"
						},
						"SecurityGroups": {
							"shape": "St"
						},
						"IpAddressType": {}
					}
				}
			},
			"S18": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"ZoneName": {},
						"SubnetId": {}
					}
				}
			},
			"S1c": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Field": {},
						"Values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S1j": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"RuleArn": {},
						"Priority": {},
						"Conditions": {
							"shape": "S1c"
						},
						"Actions": {
							"shape": "Sh"
						},
						"IsDefault": {
							"type": "boolean"
						}
					}
				}
			},
			"S1v": {
				"type": "structure",
				"required": [
					"HttpCode"
				],
				"members": {
					"HttpCode": {}
				}
			},
			"S1y": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"TargetGroupArn": {},
						"TargetGroupName": {},
						"Protocol": {},
						"Port": {
							"type": "integer"
						},
						"VpcId": {},
						"HealthCheckProtocol": {},
						"HealthCheckPort": {},
						"HealthCheckIntervalSeconds": {
							"type": "integer"
						},
						"HealthCheckTimeoutSeconds": {
							"type": "integer"
						},
						"HealthyThresholdCount": {
							"type": "integer"
						},
						"UnhealthyThresholdCount": {
							"type": "integer"
						},
						"HealthCheckPath": {},
						"Matcher": {
							"shape": "S1v"
						},
						"LoadBalancerArns": {
							"shape": "S20"
						}
					}
				}
			},
			"S20": {
				"type": "list",
				"member": {}
			},
			"S2a": {
				"type": "list",
				"member": {
					"shape": "S2b"
				}
			},
			"S2b": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {},
					"Port": {
						"type": "integer"
					}
				}
			},
			"S2l": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S3c": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			}
		}
	};

/***/ },
/* 693 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeListeners": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"result_key": "Listeners"
			},
			"DescribeLoadBalancers": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"result_key": "LoadBalancers"
			},
			"DescribeTargetGroups": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"result_key": "TargetGroups"
			}
		}
	};

/***/ },
/* 694 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "elasticmapreduce-2009-03-31",
			"apiVersion": "2009-03-31",
			"endpointPrefix": "elasticmapreduce",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Amazon EMR",
			"serviceFullName": "Amazon Elastic MapReduce",
			"signatureVersion": "v4",
			"targetPrefix": "ElasticMapReduce",
			"timestampFormat": "unixTimestamp"
		},
		"operations": {
			"AddInstanceGroups": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceGroups",
						"JobFlowId"
					],
					"members": {
						"InstanceGroups": {
							"shape": "S2"
						},
						"JobFlowId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobFlowId": {},
						"InstanceGroupIds": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"AddJobFlowSteps": {
				"input": {
					"type": "structure",
					"required": [
						"JobFlowId",
						"Steps"
					],
					"members": {
						"JobFlowId": {},
						"Steps": {
							"shape": "S10"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StepIds": {
							"shape": "S19"
						}
					}
				}
			},
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"Tags"
					],
					"members": {
						"ResourceId": {},
						"Tags": {
							"shape": "S1c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CancelSteps": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterId": {},
						"StepIds": {
							"shape": "S19"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CancelStepsInfoList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StepId": {},
									"Status": {},
									"Reason": {}
								}
							}
						}
					}
				}
			},
			"CreateSecurityConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"SecurityConfiguration"
					],
					"members": {
						"Name": {},
						"SecurityConfiguration": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Name",
						"CreationDateTime"
					],
					"members": {
						"Name": {},
						"CreationDateTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"DeleteSecurityConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Cluster": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Status": {
									"shape": "S1u"
								},
								"Ec2InstanceAttributes": {
									"type": "structure",
									"members": {
										"Ec2KeyName": {},
										"Ec2SubnetId": {},
										"Ec2AvailabilityZone": {},
										"IamInstanceProfile": {},
										"EmrManagedMasterSecurityGroup": {},
										"EmrManagedSlaveSecurityGroup": {},
										"ServiceAccessSecurityGroup": {},
										"AdditionalMasterSecurityGroups": {
											"shape": "S20"
										},
										"AdditionalSlaveSecurityGroups": {
											"shape": "S20"
										}
									}
								},
								"LogUri": {},
								"RequestedAmiVersion": {},
								"RunningAmiVersion": {},
								"ReleaseLabel": {},
								"AutoTerminate": {
									"type": "boolean"
								},
								"TerminationProtected": {
									"type": "boolean"
								},
								"VisibleToAllUsers": {
									"type": "boolean"
								},
								"Applications": {
									"shape": "S22"
								},
								"Tags": {
									"shape": "S1c"
								},
								"ServiceRole": {},
								"NormalizedInstanceHours": {
									"type": "integer"
								},
								"MasterPublicDnsName": {},
								"Configurations": {
									"shape": "S9"
								},
								"SecurityConfiguration": {},
								"AutoScalingRole": {},
								"ScaleDownBehavior": {}
							}
						}
					}
				}
			},
			"DescribeJobFlows": {
				"input": {
					"type": "structure",
					"members": {
						"CreatedAfter": {
							"type": "timestamp"
						},
						"CreatedBefore": {
							"type": "timestamp"
						},
						"JobFlowIds": {
							"shape": "S17"
						},
						"JobFlowStates": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobFlows": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"JobFlowId",
									"Name",
									"ExecutionStatusDetail",
									"Instances"
								],
								"members": {
									"JobFlowId": {},
									"Name": {},
									"LogUri": {},
									"AmiVersion": {},
									"ExecutionStatusDetail": {
										"type": "structure",
										"required": [
											"State",
											"CreationDateTime"
										],
										"members": {
											"State": {},
											"CreationDateTime": {
												"type": "timestamp"
											},
											"StartDateTime": {
												"type": "timestamp"
											},
											"ReadyDateTime": {
												"type": "timestamp"
											},
											"EndDateTime": {
												"type": "timestamp"
											},
											"LastStateChangeReason": {}
										}
									},
									"Instances": {
										"type": "structure",
										"required": [
											"MasterInstanceType",
											"SlaveInstanceType",
											"InstanceCount"
										],
										"members": {
											"MasterInstanceType": {},
											"MasterPublicDnsName": {},
											"MasterInstanceId": {},
											"SlaveInstanceType": {},
											"InstanceCount": {
												"type": "integer"
											},
											"InstanceGroups": {
												"type": "list",
												"member": {
													"type": "structure",
													"required": [
														"Market",
														"InstanceRole",
														"InstanceType",
														"InstanceRequestCount",
														"InstanceRunningCount",
														"State",
														"CreationDateTime"
													],
													"members": {
														"InstanceGroupId": {},
														"Name": {},
														"Market": {},
														"InstanceRole": {},
														"BidPrice": {},
														"InstanceType": {},
														"InstanceRequestCount": {
															"type": "integer"
														},
														"InstanceRunningCount": {
															"type": "integer"
														},
														"State": {},
														"LastStateChangeReason": {},
														"CreationDateTime": {
															"type": "timestamp"
														},
														"StartDateTime": {
															"type": "timestamp"
														},
														"ReadyDateTime": {
															"type": "timestamp"
														},
														"EndDateTime": {
															"type": "timestamp"
														}
													}
												}
											},
											"NormalizedInstanceHours": {
												"type": "integer"
											},
											"Ec2KeyName": {},
											"Ec2SubnetId": {},
											"Placement": {
												"shape": "S2g"
											},
											"KeepJobFlowAliveWhenNoSteps": {
												"type": "boolean"
											},
											"TerminationProtected": {
												"type": "boolean"
											},
											"HadoopVersion": {}
										}
									},
									"Steps": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"StepConfig",
												"ExecutionStatusDetail"
											],
											"members": {
												"StepConfig": {
													"shape": "S11"
												},
												"ExecutionStatusDetail": {
													"type": "structure",
													"required": [
														"State",
														"CreationDateTime"
													],
													"members": {
														"State": {},
														"CreationDateTime": {
															"type": "timestamp"
														},
														"StartDateTime": {
															"type": "timestamp"
														},
														"EndDateTime": {
															"type": "timestamp"
														},
														"LastStateChangeReason": {}
													}
												}
											}
										}
									},
									"BootstrapActions": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"BootstrapActionConfig": {
													"shape": "S2n"
												}
											}
										}
									},
									"SupportedProducts": {
										"shape": "S2p"
									},
									"VisibleToAllUsers": {
										"type": "boolean"
									},
									"JobFlowRole": {},
									"ServiceRole": {},
									"AutoScalingRole": {},
									"ScaleDownBehavior": {}
								}
							}
						}
					}
				},
				"deprecated": true
			},
			"DescribeSecurityConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"SecurityConfiguration": {},
						"CreationDateTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeStep": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId",
						"StepId"
					],
					"members": {
						"ClusterId": {},
						"StepId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Step": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"Config": {
									"shape": "S2v"
								},
								"ActionOnFailure": {},
								"Status": {
									"shape": "S2w"
								}
							}
						}
					}
				}
			},
			"ListBootstrapActions": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BootstrapActions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"ScriptPath": {},
									"Args": {
										"shape": "S20"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListClusters": {
				"input": {
					"type": "structure",
					"members": {
						"CreatedAfter": {
							"type": "timestamp"
						},
						"CreatedBefore": {
							"type": "timestamp"
						},
						"ClusterStates": {
							"type": "list",
							"member": {}
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Clusters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"Status": {
										"shape": "S1u"
									},
									"NormalizedInstanceHours": {
										"type": "integer"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListInstanceGroups": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"Market": {},
									"InstanceGroupType": {},
									"BidPrice": {},
									"InstanceType": {},
									"RequestedInstanceCount": {
										"type": "integer"
									},
									"RunningInstanceCount": {
										"type": "integer"
									},
									"Status": {
										"type": "structure",
										"members": {
											"State": {},
											"StateChangeReason": {
												"type": "structure",
												"members": {
													"Code": {},
													"Message": {}
												}
											},
											"Timeline": {
												"type": "structure",
												"members": {
													"CreationDateTime": {
														"type": "timestamp"
													},
													"ReadyDateTime": {
														"type": "timestamp"
													},
													"EndDateTime": {
														"type": "timestamp"
													}
												}
											}
										}
									},
									"Configurations": {
										"shape": "S9"
									},
									"EbsBlockDevices": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"VolumeSpecification": {
													"shape": "Sg"
												},
												"Device": {}
											}
										}
									},
									"EbsOptimized": {
										"type": "boolean"
									},
									"ShrinkPolicy": {
										"shape": "S3o"
									},
									"AutoScalingPolicy": {
										"shape": "S3s"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListInstances": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {},
						"InstanceGroupId": {},
						"InstanceGroupTypes": {
							"type": "list",
							"member": {}
						},
						"InstanceStates": {
							"type": "list",
							"member": {}
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Ec2InstanceId": {},
									"PublicDnsName": {},
									"PublicIpAddress": {},
									"PrivateDnsName": {},
									"PrivateIpAddress": {},
									"Status": {
										"type": "structure",
										"members": {
											"State": {},
											"StateChangeReason": {
												"type": "structure",
												"members": {
													"Code": {},
													"Message": {}
												}
											},
											"Timeline": {
												"type": "structure",
												"members": {
													"CreationDateTime": {
														"type": "timestamp"
													},
													"ReadyDateTime": {
														"type": "timestamp"
													},
													"EndDateTime": {
														"type": "timestamp"
													}
												}
											}
										}
									},
									"InstanceGroupId": {},
									"EbsVolumes": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Device": {},
												"VolumeId": {}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListSecurityConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SecurityConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"CreationDateTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListSteps": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId"
					],
					"members": {
						"ClusterId": {},
						"StepStates": {
							"type": "list",
							"member": {}
						},
						"StepIds": {
							"shape": "S17"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Steps": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"Name": {},
									"Config": {
										"shape": "S2v"
									},
									"ActionOnFailure": {},
									"Status": {
										"shape": "S2w"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ModifyInstanceGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterId": {},
						"InstanceGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"InstanceGroupId"
								],
								"members": {
									"InstanceGroupId": {},
									"InstanceCount": {
										"type": "integer"
									},
									"EC2InstanceIdsToTerminate": {
										"type": "list",
										"member": {}
									},
									"ShrinkPolicy": {
										"shape": "S3o"
									}
								}
							}
						}
					}
				}
			},
			"PutAutoScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId",
						"InstanceGroupId",
						"AutoScalingPolicy"
					],
					"members": {
						"ClusterId": {},
						"InstanceGroupId": {},
						"AutoScalingPolicy": {
							"shape": "Si"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ClusterId": {},
						"InstanceGroupId": {},
						"AutoScalingPolicy": {
							"shape": "S3s"
						}
					}
				}
			},
			"RemoveAutoScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterId",
						"InstanceGroupId"
					],
					"members": {
						"ClusterId": {},
						"InstanceGroupId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"RemoveTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"TagKeys"
					],
					"members": {
						"ResourceId": {},
						"TagKeys": {
							"shape": "S20"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"RunJobFlow": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Instances"
					],
					"members": {
						"Name": {},
						"LogUri": {},
						"AdditionalInfo": {},
						"AmiVersion": {},
						"ReleaseLabel": {},
						"Instances": {
							"type": "structure",
							"members": {
								"MasterInstanceType": {},
								"SlaveInstanceType": {},
								"InstanceCount": {
									"type": "integer"
								},
								"InstanceGroups": {
									"shape": "S2"
								},
								"Ec2KeyName": {},
								"Placement": {
									"shape": "S2g"
								},
								"KeepJobFlowAliveWhenNoSteps": {
									"type": "boolean"
								},
								"TerminationProtected": {
									"type": "boolean"
								},
								"HadoopVersion": {},
								"Ec2SubnetId": {},
								"EmrManagedMasterSecurityGroup": {},
								"EmrManagedSlaveSecurityGroup": {},
								"ServiceAccessSecurityGroup": {},
								"AdditionalMasterSecurityGroups": {
									"shape": "S4v"
								},
								"AdditionalSlaveSecurityGroups": {
									"shape": "S4v"
								}
							}
						},
						"Steps": {
							"shape": "S10"
						},
						"BootstrapActions": {
							"type": "list",
							"member": {
								"shape": "S2n"
							}
						},
						"SupportedProducts": {
							"shape": "S2p"
						},
						"NewSupportedProducts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Args": {
										"shape": "S17"
									}
								}
							}
						},
						"Applications": {
							"shape": "S22"
						},
						"Configurations": {
							"shape": "S9"
						},
						"VisibleToAllUsers": {
							"type": "boolean"
						},
						"JobFlowRole": {},
						"ServiceRole": {},
						"Tags": {
							"shape": "S1c"
						},
						"SecurityConfiguration": {},
						"AutoScalingRole": {},
						"ScaleDownBehavior": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"JobFlowId": {}
					}
				}
			},
			"SetTerminationProtection": {
				"input": {
					"type": "structure",
					"required": [
						"JobFlowIds",
						"TerminationProtected"
					],
					"members": {
						"JobFlowIds": {
							"shape": "S17"
						},
						"TerminationProtected": {
							"type": "boolean"
						}
					}
				}
			},
			"SetVisibleToAllUsers": {
				"input": {
					"type": "structure",
					"required": [
						"JobFlowIds",
						"VisibleToAllUsers"
					],
					"members": {
						"JobFlowIds": {
							"shape": "S17"
						},
						"VisibleToAllUsers": {
							"type": "boolean"
						}
					}
				}
			},
			"TerminateJobFlows": {
				"input": {
					"type": "structure",
					"required": [
						"JobFlowIds"
					],
					"members": {
						"JobFlowIds": {
							"shape": "S17"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"InstanceRole",
						"InstanceType",
						"InstanceCount"
					],
					"members": {
						"Name": {},
						"Market": {},
						"InstanceRole": {},
						"BidPrice": {},
						"InstanceType": {},
						"InstanceCount": {
							"type": "integer"
						},
						"Configurations": {
							"shape": "S9"
						},
						"EbsConfiguration": {
							"type": "structure",
							"members": {
								"EbsBlockDeviceConfigs": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"VolumeSpecification"
										],
										"members": {
											"VolumeSpecification": {
												"shape": "Sg"
											},
											"VolumesPerInstance": {
												"type": "integer"
											}
										}
									}
								},
								"EbsOptimized": {
									"type": "boolean"
								}
							}
						},
						"AutoScalingPolicy": {
							"shape": "Si"
						}
					}
				}
			},
			"S9": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Classification": {},
						"Configurations": {
							"shape": "S9"
						},
						"Properties": {
							"shape": "Sc"
						}
					}
				}
			},
			"Sc": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sg": {
				"type": "structure",
				"required": [
					"VolumeType",
					"SizeInGB"
				],
				"members": {
					"VolumeType": {},
					"Iops": {
						"type": "integer"
					},
					"SizeInGB": {
						"type": "integer"
					}
				}
			},
			"Si": {
				"type": "structure",
				"required": [
					"Constraints",
					"Rules"
				],
				"members": {
					"Constraints": {
						"shape": "Sj"
					},
					"Rules": {
						"shape": "Sk"
					}
				}
			},
			"Sj": {
				"type": "structure",
				"required": [
					"MinCapacity",
					"MaxCapacity"
				],
				"members": {
					"MinCapacity": {
						"type": "integer"
					},
					"MaxCapacity": {
						"type": "integer"
					}
				}
			},
			"Sk": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Action",
						"Trigger"
					],
					"members": {
						"Name": {},
						"Description": {},
						"Action": {
							"type": "structure",
							"required": [
								"SimpleScalingPolicyConfiguration"
							],
							"members": {
								"Market": {},
								"SimpleScalingPolicyConfiguration": {
									"type": "structure",
									"required": [
										"ScalingAdjustment"
									],
									"members": {
										"AdjustmentType": {},
										"ScalingAdjustment": {
											"type": "integer"
										},
										"CoolDown": {
											"type": "integer"
										}
									}
								}
							}
						},
						"Trigger": {
							"type": "structure",
							"required": [
								"CloudWatchAlarmDefinition"
							],
							"members": {
								"CloudWatchAlarmDefinition": {
									"type": "structure",
									"required": [
										"ComparisonOperator",
										"MetricName",
										"Period",
										"Threshold"
									],
									"members": {
										"ComparisonOperator": {},
										"EvaluationPeriods": {
											"type": "integer"
										},
										"MetricName": {},
										"Namespace": {},
										"Period": {
											"type": "integer"
										},
										"Statistic": {},
										"Threshold": {
											"type": "double"
										},
										"Unit": {},
										"Dimensions": {
											"type": "list",
											"member": {
												"type": "structure",
												"members": {
													"Key": {},
													"Value": {}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S10": {
				"type": "list",
				"member": {
					"shape": "S11"
				}
			},
			"S11": {
				"type": "structure",
				"required": [
					"Name",
					"HadoopJarStep"
				],
				"members": {
					"Name": {},
					"ActionOnFailure": {},
					"HadoopJarStep": {
						"type": "structure",
						"required": [
							"Jar"
						],
						"members": {
							"Properties": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Key": {},
										"Value": {}
									}
								}
							},
							"Jar": {},
							"MainClass": {},
							"Args": {
								"shape": "S17"
							}
						}
					}
				}
			},
			"S17": {
				"type": "list",
				"member": {}
			},
			"S19": {
				"type": "list",
				"member": {}
			},
			"S1c": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S1u": {
				"type": "structure",
				"members": {
					"State": {},
					"StateChangeReason": {
						"type": "structure",
						"members": {
							"Code": {},
							"Message": {}
						}
					},
					"Timeline": {
						"type": "structure",
						"members": {
							"CreationDateTime": {
								"type": "timestamp"
							},
							"ReadyDateTime": {
								"type": "timestamp"
							},
							"EndDateTime": {
								"type": "timestamp"
							}
						}
					}
				}
			},
			"S20": {
				"type": "list",
				"member": {}
			},
			"S22": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Name": {},
						"Version": {},
						"Args": {
							"shape": "S20"
						},
						"AdditionalInfo": {
							"shape": "Sc"
						}
					}
				}
			},
			"S2g": {
				"type": "structure",
				"required": [
					"AvailabilityZone"
				],
				"members": {
					"AvailabilityZone": {}
				}
			},
			"S2n": {
				"type": "structure",
				"required": [
					"Name",
					"ScriptBootstrapAction"
				],
				"members": {
					"Name": {},
					"ScriptBootstrapAction": {
						"type": "structure",
						"required": [
							"Path"
						],
						"members": {
							"Path": {},
							"Args": {
								"shape": "S17"
							}
						}
					}
				}
			},
			"S2p": {
				"type": "list",
				"member": {}
			},
			"S2v": {
				"type": "structure",
				"members": {
					"Jar": {},
					"Properties": {
						"shape": "Sc"
					},
					"MainClass": {},
					"Args": {
						"shape": "S20"
					}
				}
			},
			"S2w": {
				"type": "structure",
				"members": {
					"State": {},
					"StateChangeReason": {
						"type": "structure",
						"members": {
							"Code": {},
							"Message": {}
						}
					},
					"FailureDetails": {
						"type": "structure",
						"members": {
							"Reason": {},
							"Message": {},
							"LogFile": {}
						}
					},
					"Timeline": {
						"type": "structure",
						"members": {
							"CreationDateTime": {
								"type": "timestamp"
							},
							"StartDateTime": {
								"type": "timestamp"
							},
							"EndDateTime": {
								"type": "timestamp"
							}
						}
					}
				}
			},
			"S3o": {
				"type": "structure",
				"members": {
					"DecommissionTimeout": {
						"type": "integer"
					},
					"InstanceResizePolicy": {
						"type": "structure",
						"members": {
							"InstancesToTerminate": {
								"shape": "S3q"
							},
							"InstancesToProtect": {
								"shape": "S3q"
							},
							"InstanceTerminationTimeout": {
								"type": "integer"
							}
						}
					}
				}
			},
			"S3q": {
				"type": "list",
				"member": {}
			},
			"S3s": {
				"type": "structure",
				"members": {
					"Status": {
						"type": "structure",
						"members": {
							"State": {},
							"StateChangeReason": {
								"type": "structure",
								"members": {
									"Code": {},
									"Message": {}
								}
							}
						}
					},
					"Constraints": {
						"shape": "Sj"
					},
					"Rules": {
						"shape": "Sk"
					}
				}
			},
			"S4v": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 695 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeJobFlows": {
				"result_key": "JobFlows"
			},
			"ListBootstrapActions": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "BootstrapActions"
			},
			"ListClusters": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "Clusters"
			},
			"ListInstanceGroups": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "InstanceGroups"
			},
			"ListInstances": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "Instances"
			},
			"ListSteps": {
				"input_token": "Marker",
				"output_token": "Marker",
				"result_key": "Steps"
			}
		}
	};

/***/ },
/* 696 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"ClusterRunning": {
				"delay": 30,
				"operation": "DescribeCluster",
				"maxAttempts": 60,
				"acceptors": [
					{
						"state": "success",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "RUNNING"
					},
					{
						"state": "success",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "WAITING"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "TERMINATING"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "TERMINATED"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Cluster.Status.State",
						"expected": "TERMINATED_WITH_ERRORS"
					}
				]
			},
			"StepComplete": {
				"delay": 30,
				"operation": "DescribeStep",
				"maxAttempts": 60,
				"acceptors": [
					{
						"state": "success",
						"matcher": "path",
						"argument": "Step.Status.State",
						"expected": "COMPLETED"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Step.Status.State",
						"expected": "FAILED"
					},
					{
						"state": "failure",
						"matcher": "path",
						"argument": "Step.Status.State",
						"expected": "CANCELLED"
					}
				]
			}
		}
	};

/***/ },
/* 697 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "elastictranscoder-2012-09-25",
			"apiVersion": "2012-09-25",
			"endpointPrefix": "elastictranscoder",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Elastic Transcoder",
			"signatureVersion": "v4"
		},
		"operations": {
			"CancelJob": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2012-09-25/jobs/{Id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateJob": {
				"http": {
					"requestUri": "/2012-09-25/jobs",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"PipelineId"
					],
					"members": {
						"PipelineId": {},
						"Input": {
							"shape": "S5"
						},
						"Inputs": {
							"shape": "St"
						},
						"Output": {
							"shape": "Su"
						},
						"Outputs": {
							"type": "list",
							"member": {
								"shape": "Su"
							}
						},
						"OutputKeyPrefix": {},
						"Playlists": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Format": {},
									"OutputKeys": {
										"shape": "S1l"
									},
									"HlsContentProtection": {
										"shape": "S1m"
									},
									"PlayReadyDrm": {
										"shape": "S1q"
									}
								}
							}
						},
						"UserMetadata": {
							"shape": "S1v"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Job": {
							"shape": "S1y"
						}
					}
				}
			},
			"CreatePipeline": {
				"http": {
					"requestUri": "/2012-09-25/pipelines",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"InputBucket",
						"Role"
					],
					"members": {
						"Name": {},
						"InputBucket": {},
						"OutputBucket": {},
						"Role": {},
						"AwsKmsKeyArn": {},
						"Notifications": {
							"shape": "S2a"
						},
						"ContentConfig": {
							"shape": "S2c"
						},
						"ThumbnailConfig": {
							"shape": "S2c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						},
						"Warnings": {
							"shape": "S2n"
						}
					}
				}
			},
			"CreatePreset": {
				"http": {
					"requestUri": "/2012-09-25/presets",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Container"
					],
					"members": {
						"Name": {},
						"Description": {},
						"Container": {},
						"Video": {
							"shape": "S2r"
						},
						"Audio": {
							"shape": "S37"
						},
						"Thumbnails": {
							"shape": "S3i"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Preset": {
							"shape": "S3m"
						},
						"Warning": {}
					}
				}
			},
			"DeletePipeline": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2012-09-25/pipelines/{Id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeletePreset": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2012-09-25/presets/{Id}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ListJobsByPipeline": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/jobsByPipeline/{PipelineId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"PipelineId"
					],
					"members": {
						"PipelineId": {
							"location": "uri",
							"locationName": "PipelineId"
						},
						"Ascending": {
							"location": "querystring",
							"locationName": "Ascending"
						},
						"PageToken": {
							"location": "querystring",
							"locationName": "PageToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Jobs": {
							"shape": "S3v"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListJobsByStatus": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/jobsByStatus/{Status}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Status": {
							"location": "uri",
							"locationName": "Status"
						},
						"Ascending": {
							"location": "querystring",
							"locationName": "Ascending"
						},
						"PageToken": {
							"location": "querystring",
							"locationName": "PageToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Jobs": {
							"shape": "S3v"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPipelines": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/pipelines"
				},
				"input": {
					"type": "structure",
					"members": {
						"Ascending": {
							"location": "querystring",
							"locationName": "Ascending"
						},
						"PageToken": {
							"location": "querystring",
							"locationName": "PageToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipelines": {
							"type": "list",
							"member": {
								"shape": "S2l"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPresets": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/presets"
				},
				"input": {
					"type": "structure",
					"members": {
						"Ascending": {
							"location": "querystring",
							"locationName": "Ascending"
						},
						"PageToken": {
							"location": "querystring",
							"locationName": "PageToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Presets": {
							"type": "list",
							"member": {
								"shape": "S3m"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ReadJob": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/jobs/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Job": {
							"shape": "S1y"
						}
					}
				}
			},
			"ReadPipeline": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/pipelines/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						},
						"Warnings": {
							"shape": "S2n"
						}
					}
				}
			},
			"ReadPreset": {
				"http": {
					"method": "GET",
					"requestUri": "/2012-09-25/presets/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Preset": {
							"shape": "S3m"
						}
					}
				}
			},
			"TestRole": {
				"http": {
					"requestUri": "/2012-09-25/roleTests",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Role",
						"InputBucket",
						"OutputBucket",
						"Topics"
					],
					"members": {
						"Role": {},
						"InputBucket": {},
						"OutputBucket": {},
						"Topics": {
							"type": "list",
							"member": {}
						}
					},
					"deprecated": true
				},
				"output": {
					"type": "structure",
					"members": {
						"Success": {},
						"Messages": {
							"type": "list",
							"member": {}
						}
					},
					"deprecated": true
				},
				"deprecated": true
			},
			"UpdatePipeline": {
				"http": {
					"method": "PUT",
					"requestUri": "/2012-09-25/pipelines/{Id}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Name": {},
						"InputBucket": {},
						"Role": {},
						"AwsKmsKeyArn": {},
						"Notifications": {
							"shape": "S2a"
						},
						"ContentConfig": {
							"shape": "S2c"
						},
						"ThumbnailConfig": {
							"shape": "S2c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						},
						"Warnings": {
							"shape": "S2n"
						}
					}
				}
			},
			"UpdatePipelineNotifications": {
				"http": {
					"requestUri": "/2012-09-25/pipelines/{Id}/notifications"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id",
						"Notifications"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Notifications": {
							"shape": "S2a"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						}
					}
				}
			},
			"UpdatePipelineStatus": {
				"http": {
					"requestUri": "/2012-09-25/pipelines/{Id}/status"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id",
						"Status"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Pipeline": {
							"shape": "S2l"
						}
					}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "structure",
				"members": {
					"Key": {},
					"FrameRate": {},
					"Resolution": {},
					"AspectRatio": {},
					"Interlaced": {},
					"Container": {},
					"Encryption": {
						"shape": "Sc"
					},
					"TimeSpan": {
						"shape": "Sg"
					},
					"InputCaptions": {
						"type": "structure",
						"members": {
							"MergePolicy": {},
							"CaptionSources": {
								"shape": "Sk"
							}
						}
					},
					"DetectedProperties": {
						"type": "structure",
						"members": {
							"Width": {
								"type": "integer"
							},
							"Height": {
								"type": "integer"
							},
							"FrameRate": {},
							"FileSize": {
								"type": "long"
							},
							"DurationMillis": {
								"type": "long"
							}
						}
					}
				}
			},
			"Sc": {
				"type": "structure",
				"members": {
					"Mode": {},
					"Key": {},
					"KeyMd5": {},
					"InitializationVector": {}
				}
			},
			"Sg": {
				"type": "structure",
				"members": {
					"StartTime": {},
					"Duration": {}
				}
			},
			"Sk": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Language": {},
						"TimeOffset": {},
						"Label": {},
						"Encryption": {
							"shape": "Sc"
						}
					}
				}
			},
			"St": {
				"type": "list",
				"member": {
					"shape": "S5"
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"Key": {},
					"ThumbnailPattern": {},
					"ThumbnailEncryption": {
						"shape": "Sc"
					},
					"Rotate": {},
					"PresetId": {},
					"SegmentDuration": {},
					"Watermarks": {
						"shape": "Sx"
					},
					"AlbumArt": {
						"shape": "S11"
					},
					"Composition": {
						"shape": "S19",
						"deprecated": true
					},
					"Captions": {
						"shape": "S1b"
					},
					"Encryption": {
						"shape": "Sc"
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"PresetWatermarkId": {},
						"InputKey": {},
						"Encryption": {
							"shape": "Sc"
						}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"MergePolicy": {},
					"Artwork": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"InputKey": {},
								"MaxWidth": {},
								"MaxHeight": {},
								"SizingPolicy": {},
								"PaddingPolicy": {},
								"AlbumArtFormat": {},
								"Encryption": {
									"shape": "Sc"
								}
							}
						}
					}
				}
			},
			"S19": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"TimeSpan": {
							"shape": "Sg"
						}
					},
					"deprecated": true
				},
				"deprecated": true
			},
			"S1b": {
				"type": "structure",
				"members": {
					"MergePolicy": {
						"deprecated": true
					},
					"CaptionSources": {
						"shape": "Sk",
						"deprecated": true
					},
					"CaptionFormats": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Format": {},
								"Pattern": {},
								"Encryption": {
									"shape": "Sc"
								}
							}
						}
					}
				}
			},
			"S1l": {
				"type": "list",
				"member": {}
			},
			"S1m": {
				"type": "structure",
				"members": {
					"Method": {},
					"Key": {},
					"KeyMd5": {},
					"InitializationVector": {},
					"LicenseAcquisitionUrl": {},
					"KeyStoragePolicy": {}
				}
			},
			"S1q": {
				"type": "structure",
				"members": {
					"Format": {},
					"Key": {},
					"KeyMd5": {},
					"KeyId": {},
					"InitializationVector": {},
					"LicenseAcquisitionUrl": {}
				}
			},
			"S1v": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1y": {
				"type": "structure",
				"members": {
					"Id": {},
					"Arn": {},
					"PipelineId": {},
					"Input": {
						"shape": "S5"
					},
					"Inputs": {
						"shape": "St"
					},
					"Output": {
						"shape": "S1z"
					},
					"Outputs": {
						"type": "list",
						"member": {
							"shape": "S1z"
						}
					},
					"OutputKeyPrefix": {},
					"Playlists": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Name": {},
								"Format": {},
								"OutputKeys": {
									"shape": "S1l"
								},
								"HlsContentProtection": {
									"shape": "S1m"
								},
								"PlayReadyDrm": {
									"shape": "S1q"
								},
								"Status": {},
								"StatusDetail": {}
							}
						}
					},
					"Status": {},
					"UserMetadata": {
						"shape": "S1v"
					},
					"Timing": {
						"type": "structure",
						"members": {
							"SubmitTimeMillis": {
								"type": "long"
							},
							"StartTimeMillis": {
								"type": "long"
							},
							"FinishTimeMillis": {
								"type": "long"
							}
						}
					}
				}
			},
			"S1z": {
				"type": "structure",
				"members": {
					"Id": {},
					"Key": {},
					"ThumbnailPattern": {},
					"ThumbnailEncryption": {
						"shape": "Sc"
					},
					"Rotate": {},
					"PresetId": {},
					"SegmentDuration": {},
					"Status": {},
					"StatusDetail": {},
					"Duration": {
						"type": "long"
					},
					"Width": {
						"type": "integer"
					},
					"Height": {
						"type": "integer"
					},
					"FrameRate": {},
					"FileSize": {
						"type": "long"
					},
					"DurationMillis": {
						"type": "long"
					},
					"Watermarks": {
						"shape": "Sx"
					},
					"AlbumArt": {
						"shape": "S11"
					},
					"Composition": {
						"shape": "S19",
						"deprecated": true
					},
					"Captions": {
						"shape": "S1b"
					},
					"Encryption": {
						"shape": "Sc"
					},
					"AppliedColorSpaceConversion": {}
				}
			},
			"S2a": {
				"type": "structure",
				"members": {
					"Progressing": {},
					"Completed": {},
					"Warning": {},
					"Error": {}
				}
			},
			"S2c": {
				"type": "structure",
				"members": {
					"Bucket": {},
					"StorageClass": {},
					"Permissions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"GranteeType": {},
								"Grantee": {},
								"Access": {
									"type": "list",
									"member": {}
								}
							}
						}
					}
				}
			},
			"S2l": {
				"type": "structure",
				"members": {
					"Id": {},
					"Arn": {},
					"Name": {},
					"Status": {},
					"InputBucket": {},
					"OutputBucket": {},
					"Role": {},
					"AwsKmsKeyArn": {},
					"Notifications": {
						"shape": "S2a"
					},
					"ContentConfig": {
						"shape": "S2c"
					},
					"ThumbnailConfig": {
						"shape": "S2c"
					}
				}
			},
			"S2n": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Code": {},
						"Message": {}
					}
				}
			},
			"S2r": {
				"type": "structure",
				"members": {
					"Codec": {},
					"CodecOptions": {
						"type": "map",
						"key": {},
						"value": {}
					},
					"KeyframesMaxDist": {},
					"FixedGOP": {},
					"BitRate": {},
					"FrameRate": {},
					"MaxFrameRate": {},
					"Resolution": {},
					"AspectRatio": {},
					"MaxWidth": {},
					"MaxHeight": {},
					"DisplayAspectRatio": {},
					"SizingPolicy": {},
					"PaddingPolicy": {},
					"Watermarks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"MaxWidth": {},
								"MaxHeight": {},
								"SizingPolicy": {},
								"HorizontalAlign": {},
								"HorizontalOffset": {},
								"VerticalAlign": {},
								"VerticalOffset": {},
								"Opacity": {},
								"Target": {}
							}
						}
					}
				}
			},
			"S37": {
				"type": "structure",
				"members": {
					"Codec": {},
					"SampleRate": {},
					"BitRate": {},
					"Channels": {},
					"AudioPackingMode": {},
					"CodecOptions": {
						"type": "structure",
						"members": {
							"Profile": {},
							"BitDepth": {},
							"BitOrder": {},
							"Signed": {}
						}
					}
				}
			},
			"S3i": {
				"type": "structure",
				"members": {
					"Format": {},
					"Interval": {},
					"Resolution": {},
					"AspectRatio": {},
					"MaxWidth": {},
					"MaxHeight": {},
					"SizingPolicy": {},
					"PaddingPolicy": {}
				}
			},
			"S3m": {
				"type": "structure",
				"members": {
					"Id": {},
					"Arn": {},
					"Name": {},
					"Description": {},
					"Container": {},
					"Audio": {
						"shape": "S37"
					},
					"Video": {
						"shape": "S2r"
					},
					"Thumbnails": {
						"shape": "S3i"
					},
					"Type": {}
				}
			},
			"S3v": {
				"type": "list",
				"member": {
					"shape": "S1y"
				}
			}
		}
	};

/***/ },
/* 698 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListJobsByPipeline": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"result_key": "Jobs"
			},
			"ListJobsByStatus": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"result_key": "Jobs"
			},
			"ListPipelines": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"result_key": "Pipelines"
			},
			"ListPresets": {
				"input_token": "PageToken",
				"output_token": "NextPageToken",
				"result_key": "Presets"
			}
		}
	};

/***/ },
/* 699 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"JobComplete": {
				"delay": 30,
				"operation": "ReadJob",
				"maxAttempts": 120,
				"acceptors": [
					{
						"expected": "Complete",
						"matcher": "path",
						"state": "success",
						"argument": "Job.Status"
					},
					{
						"expected": "Canceled",
						"matcher": "path",
						"state": "failure",
						"argument": "Job.Status"
					},
					{
						"expected": "Error",
						"matcher": "path",
						"state": "failure",
						"argument": "Job.Status"
					}
				]
			}
		}
	};

/***/ },
/* 700 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "email-2010-12-01",
			"apiVersion": "2010-12-01",
			"endpointPrefix": "email",
			"protocol": "query",
			"serviceAbbreviation": "Amazon SES",
			"serviceFullName": "Amazon Simple Email Service",
			"signatureVersion": "v4",
			"signingName": "ses",
			"xmlNamespace": "http://ses.amazonaws.com/doc/2010-12-01/"
		},
		"operations": {
			"CloneReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"OriginalRuleSetName"
					],
					"members": {
						"RuleSetName": {},
						"OriginalRuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "CloneReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateConfigurationSet": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSet"
					],
					"members": {
						"ConfigurationSet": {
							"shape": "S5"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateConfigurationSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateConfigurationSetEventDestination": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"EventDestination"
					],
					"members": {
						"ConfigurationSetName": {},
						"EventDestination": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateConfigurationSetEventDestinationResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateReceiptFilter": {
				"input": {
					"type": "structure",
					"required": [
						"Filter"
					],
					"members": {
						"Filter": {
							"shape": "So"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateReceiptFilterResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateReceiptRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"Rule"
					],
					"members": {
						"RuleSetName": {},
						"After": {},
						"Rule": {
							"shape": "Sw"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateReceiptRuleResult",
					"type": "structure",
					"members": {}
				}
			},
			"CreateReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName"
					],
					"members": {
						"RuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteConfigurationSet": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName"
					],
					"members": {
						"ConfigurationSetName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteConfigurationSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteConfigurationSetEventDestination": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"EventDestinationName"
					],
					"members": {
						"ConfigurationSetName": {},
						"EventDestinationName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteConfigurationSetEventDestinationResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"Identity"
					],
					"members": {
						"Identity": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteIdentityResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteIdentityPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"PolicyName"
					],
					"members": {
						"Identity": {},
						"PolicyName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteIdentityPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteReceiptFilter": {
				"input": {
					"type": "structure",
					"required": [
						"FilterName"
					],
					"members": {
						"FilterName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteReceiptFilterResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteReceiptRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"RuleName"
					],
					"members": {
						"RuleSetName": {},
						"RuleName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteReceiptRuleResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName"
					],
					"members": {
						"RuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"DeleteVerifiedEmailAddress": {
				"input": {
					"type": "structure",
					"required": [
						"EmailAddress"
					],
					"members": {
						"EmailAddress": {}
					}
				}
			},
			"DescribeActiveReceiptRuleSet": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "DescribeActiveReceiptRuleSetResult",
					"type": "structure",
					"members": {
						"Metadata": {
							"shape": "S26"
						},
						"Rules": {
							"shape": "S28"
						}
					}
				}
			},
			"DescribeConfigurationSet": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName"
					],
					"members": {
						"ConfigurationSetName": {},
						"ConfigurationSetAttributeNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeConfigurationSetResult",
					"type": "structure",
					"members": {
						"ConfigurationSet": {
							"shape": "S5"
						},
						"EventDestinations": {
							"type": "list",
							"member": {
								"shape": "S9"
							}
						}
					}
				}
			},
			"DescribeReceiptRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"RuleName"
					],
					"members": {
						"RuleSetName": {},
						"RuleName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReceiptRuleResult",
					"type": "structure",
					"members": {
						"Rule": {
							"shape": "Sw"
						}
					}
				}
			},
			"DescribeReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName"
					],
					"members": {
						"RuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReceiptRuleSetResult",
					"type": "structure",
					"members": {
						"Metadata": {
							"shape": "S26"
						},
						"Rules": {
							"shape": "S28"
						}
					}
				}
			},
			"GetIdentityDkimAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S2j"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityDkimAttributesResult",
					"type": "structure",
					"required": [
						"DkimAttributes"
					],
					"members": {
						"DkimAttributes": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"required": [
									"DkimEnabled",
									"DkimVerificationStatus"
								],
								"members": {
									"DkimEnabled": {
										"type": "boolean"
									},
									"DkimVerificationStatus": {},
									"DkimTokens": {
										"shape": "S2o"
									}
								}
							}
						}
					}
				}
			},
			"GetIdentityMailFromDomainAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S2j"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityMailFromDomainAttributesResult",
					"type": "structure",
					"required": [
						"MailFromDomainAttributes"
					],
					"members": {
						"MailFromDomainAttributes": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"required": [
									"MailFromDomain",
									"MailFromDomainStatus",
									"BehaviorOnMXFailure"
								],
								"members": {
									"MailFromDomain": {},
									"MailFromDomainStatus": {},
									"BehaviorOnMXFailure": {}
								}
							}
						}
					}
				}
			},
			"GetIdentityNotificationAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S2j"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityNotificationAttributesResult",
					"type": "structure",
					"required": [
						"NotificationAttributes"
					],
					"members": {
						"NotificationAttributes": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"required": [
									"BounceTopic",
									"ComplaintTopic",
									"DeliveryTopic",
									"ForwardingEnabled"
								],
								"members": {
									"BounceTopic": {},
									"ComplaintTopic": {},
									"DeliveryTopic": {},
									"ForwardingEnabled": {
										"type": "boolean"
									},
									"HeadersInBounceNotificationsEnabled": {
										"type": "boolean"
									},
									"HeadersInComplaintNotificationsEnabled": {
										"type": "boolean"
									},
									"HeadersInDeliveryNotificationsEnabled": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"GetIdentityPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"PolicyNames"
					],
					"members": {
						"Identity": {},
						"PolicyNames": {
							"shape": "S33"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityPoliciesResult",
					"type": "structure",
					"required": [
						"Policies"
					],
					"members": {
						"Policies": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"GetIdentityVerificationAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S2j"
						}
					}
				},
				"output": {
					"resultWrapper": "GetIdentityVerificationAttributesResult",
					"type": "structure",
					"required": [
						"VerificationAttributes"
					],
					"members": {
						"VerificationAttributes": {
							"type": "map",
							"key": {},
							"value": {
								"type": "structure",
								"required": [
									"VerificationStatus"
								],
								"members": {
									"VerificationStatus": {},
									"VerificationToken": {}
								}
							}
						}
					}
				}
			},
			"GetSendQuota": {
				"output": {
					"resultWrapper": "GetSendQuotaResult",
					"type": "structure",
					"members": {
						"Max24HourSend": {
							"type": "double"
						},
						"MaxSendRate": {
							"type": "double"
						},
						"SentLast24Hours": {
							"type": "double"
						}
					}
				}
			},
			"GetSendStatistics": {
				"output": {
					"resultWrapper": "GetSendStatisticsResult",
					"type": "structure",
					"members": {
						"SendDataPoints": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "timestamp"
									},
									"DeliveryAttempts": {
										"type": "long"
									},
									"Bounces": {
										"type": "long"
									},
									"Complaints": {
										"type": "long"
									},
									"Rejects": {
										"type": "long"
									}
								}
							}
						}
					}
				}
			},
			"ListConfigurationSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListConfigurationSetsResult",
					"type": "structure",
					"members": {
						"ConfigurationSets": {
							"type": "list",
							"member": {
								"shape": "S5"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentities": {
				"input": {
					"type": "structure",
					"members": {
						"IdentityType": {},
						"NextToken": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ListIdentitiesResult",
					"type": "structure",
					"required": [
						"Identities"
					],
					"members": {
						"Identities": {
							"shape": "S2j"
						},
						"NextToken": {}
					}
				}
			},
			"ListIdentityPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"Identity"
					],
					"members": {
						"Identity": {}
					}
				},
				"output": {
					"resultWrapper": "ListIdentityPoliciesResult",
					"type": "structure",
					"required": [
						"PolicyNames"
					],
					"members": {
						"PolicyNames": {
							"shape": "S33"
						}
					}
				}
			},
			"ListReceiptFilters": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "ListReceiptFiltersResult",
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"shape": "So"
							}
						}
					}
				}
			},
			"ListReceiptRuleSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListReceiptRuleSetsResult",
					"type": "structure",
					"members": {
						"RuleSets": {
							"type": "list",
							"member": {
								"shape": "S26"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListVerifiedEmailAddresses": {
				"output": {
					"resultWrapper": "ListVerifiedEmailAddressesResult",
					"type": "structure",
					"members": {
						"VerifiedEmailAddresses": {
							"shape": "S40"
						}
					}
				}
			},
			"PutIdentityPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"PolicyName",
						"Policy"
					],
					"members": {
						"Identity": {},
						"PolicyName": {},
						"Policy": {}
					}
				},
				"output": {
					"resultWrapper": "PutIdentityPolicyResult",
					"type": "structure",
					"members": {}
				}
			},
			"ReorderReceiptRuleSet": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"RuleNames"
					],
					"members": {
						"RuleSetName": {},
						"RuleNames": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "ReorderReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"SendBounce": {
				"input": {
					"type": "structure",
					"required": [
						"OriginalMessageId",
						"BounceSender",
						"BouncedRecipientInfoList"
					],
					"members": {
						"OriginalMessageId": {},
						"BounceSender": {},
						"Explanation": {},
						"MessageDsn": {
							"type": "structure",
							"required": [
								"ReportingMta"
							],
							"members": {
								"ReportingMta": {},
								"ArrivalDate": {
									"type": "timestamp"
								},
								"ExtensionFields": {
									"shape": "S4c"
								}
							}
						},
						"BouncedRecipientInfoList": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Recipient"
								],
								"members": {
									"Recipient": {},
									"RecipientArn": {},
									"BounceType": {},
									"RecipientDsnFields": {
										"type": "structure",
										"required": [
											"Action",
											"Status"
										],
										"members": {
											"FinalRecipient": {},
											"Action": {},
											"RemoteMta": {},
											"Status": {},
											"DiagnosticCode": {},
											"LastAttemptDate": {
												"type": "timestamp"
											},
											"ExtensionFields": {
												"shape": "S4c"
											}
										}
									}
								}
							}
						},
						"BounceSenderArn": {}
					}
				},
				"output": {
					"resultWrapper": "SendBounceResult",
					"type": "structure",
					"members": {
						"MessageId": {}
					}
				}
			},
			"SendEmail": {
				"input": {
					"type": "structure",
					"required": [
						"Source",
						"Destination",
						"Message"
					],
					"members": {
						"Source": {},
						"Destination": {
							"type": "structure",
							"members": {
								"ToAddresses": {
									"shape": "S40"
								},
								"CcAddresses": {
									"shape": "S40"
								},
								"BccAddresses": {
									"shape": "S40"
								}
							}
						},
						"Message": {
							"type": "structure",
							"required": [
								"Subject",
								"Body"
							],
							"members": {
								"Subject": {
									"shape": "S4t"
								},
								"Body": {
									"type": "structure",
									"members": {
										"Text": {
											"shape": "S4t"
										},
										"Html": {
											"shape": "S4t"
										}
									}
								}
							}
						},
						"ReplyToAddresses": {
							"shape": "S40"
						},
						"ReturnPath": {},
						"SourceArn": {},
						"ReturnPathArn": {},
						"Tags": {
							"shape": "S4x"
						},
						"ConfigurationSetName": {}
					}
				},
				"output": {
					"resultWrapper": "SendEmailResult",
					"type": "structure",
					"required": [
						"MessageId"
					],
					"members": {
						"MessageId": {}
					}
				}
			},
			"SendRawEmail": {
				"input": {
					"type": "structure",
					"required": [
						"RawMessage"
					],
					"members": {
						"Source": {},
						"Destinations": {
							"shape": "S40"
						},
						"RawMessage": {
							"type": "structure",
							"required": [
								"Data"
							],
							"members": {
								"Data": {
									"type": "blob"
								}
							}
						},
						"FromArn": {},
						"SourceArn": {},
						"ReturnPathArn": {},
						"Tags": {
							"shape": "S4x"
						},
						"ConfigurationSetName": {}
					}
				},
				"output": {
					"resultWrapper": "SendRawEmailResult",
					"type": "structure",
					"required": [
						"MessageId"
					],
					"members": {
						"MessageId": {}
					}
				}
			},
			"SetActiveReceiptRuleSet": {
				"input": {
					"type": "structure",
					"members": {
						"RuleSetName": {}
					}
				},
				"output": {
					"resultWrapper": "SetActiveReceiptRuleSetResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityDkimEnabled": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"DkimEnabled"
					],
					"members": {
						"Identity": {},
						"DkimEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityDkimEnabledResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityFeedbackForwardingEnabled": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"ForwardingEnabled"
					],
					"members": {
						"Identity": {},
						"ForwardingEnabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityFeedbackForwardingEnabledResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityHeadersInNotificationsEnabled": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"NotificationType",
						"Enabled"
					],
					"members": {
						"Identity": {},
						"NotificationType": {},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityHeadersInNotificationsEnabledResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityMailFromDomain": {
				"input": {
					"type": "structure",
					"required": [
						"Identity"
					],
					"members": {
						"Identity": {},
						"MailFromDomain": {},
						"BehaviorOnMXFailure": {}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityMailFromDomainResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetIdentityNotificationTopic": {
				"input": {
					"type": "structure",
					"required": [
						"Identity",
						"NotificationType"
					],
					"members": {
						"Identity": {},
						"NotificationType": {},
						"SnsTopic": {}
					}
				},
				"output": {
					"resultWrapper": "SetIdentityNotificationTopicResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetReceiptRulePosition": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"RuleName"
					],
					"members": {
						"RuleSetName": {},
						"RuleName": {},
						"After": {}
					}
				},
				"output": {
					"resultWrapper": "SetReceiptRulePositionResult",
					"type": "structure",
					"members": {}
				}
			},
			"UpdateConfigurationSetEventDestination": {
				"input": {
					"type": "structure",
					"required": [
						"ConfigurationSetName",
						"EventDestination"
					],
					"members": {
						"ConfigurationSetName": {},
						"EventDestination": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateConfigurationSetEventDestinationResult",
					"type": "structure",
					"members": {}
				}
			},
			"UpdateReceiptRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleSetName",
						"Rule"
					],
					"members": {
						"RuleSetName": {},
						"Rule": {
							"shape": "Sw"
						}
					}
				},
				"output": {
					"resultWrapper": "UpdateReceiptRuleResult",
					"type": "structure",
					"members": {}
				}
			},
			"VerifyDomainDkim": {
				"input": {
					"type": "structure",
					"required": [
						"Domain"
					],
					"members": {
						"Domain": {}
					}
				},
				"output": {
					"resultWrapper": "VerifyDomainDkimResult",
					"type": "structure",
					"required": [
						"DkimTokens"
					],
					"members": {
						"DkimTokens": {
							"shape": "S2o"
						}
					}
				}
			},
			"VerifyDomainIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"Domain"
					],
					"members": {
						"Domain": {}
					}
				},
				"output": {
					"resultWrapper": "VerifyDomainIdentityResult",
					"type": "structure",
					"required": [
						"VerificationToken"
					],
					"members": {
						"VerificationToken": {}
					}
				}
			},
			"VerifyEmailAddress": {
				"input": {
					"type": "structure",
					"required": [
						"EmailAddress"
					],
					"members": {
						"EmailAddress": {}
					}
				}
			},
			"VerifyEmailIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"EmailAddress"
					],
					"members": {
						"EmailAddress": {}
					}
				},
				"output": {
					"resultWrapper": "VerifyEmailIdentityResult",
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {}
				}
			},
			"S9": {
				"type": "structure",
				"required": [
					"Name",
					"MatchingEventTypes"
				],
				"members": {
					"Name": {},
					"Enabled": {
						"type": "boolean"
					},
					"MatchingEventTypes": {
						"type": "list",
						"member": {}
					},
					"KinesisFirehoseDestination": {
						"type": "structure",
						"required": [
							"IAMRoleARN",
							"DeliveryStreamARN"
						],
						"members": {
							"IAMRoleARN": {},
							"DeliveryStreamARN": {}
						}
					},
					"CloudWatchDestination": {
						"type": "structure",
						"required": [
							"DimensionConfigurations"
						],
						"members": {
							"DimensionConfigurations": {
								"type": "list",
								"member": {
									"type": "structure",
									"required": [
										"DimensionName",
										"DimensionValueSource",
										"DefaultDimensionValue"
									],
									"members": {
										"DimensionName": {},
										"DimensionValueSource": {},
										"DefaultDimensionValue": {}
									}
								}
							}
						}
					}
				}
			},
			"So": {
				"type": "structure",
				"required": [
					"Name",
					"IpFilter"
				],
				"members": {
					"Name": {},
					"IpFilter": {
						"type": "structure",
						"required": [
							"Policy",
							"Cidr"
						],
						"members": {
							"Policy": {},
							"Cidr": {}
						}
					}
				}
			},
			"Sw": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Enabled": {
						"type": "boolean"
					},
					"TlsPolicy": {},
					"Recipients": {
						"type": "list",
						"member": {}
					},
					"Actions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"S3Action": {
									"type": "structure",
									"required": [
										"BucketName"
									],
									"members": {
										"TopicArn": {},
										"BucketName": {},
										"ObjectKeyPrefix": {},
										"KmsKeyArn": {}
									}
								},
								"BounceAction": {
									"type": "structure",
									"required": [
										"SmtpReplyCode",
										"Message",
										"Sender"
									],
									"members": {
										"TopicArn": {},
										"SmtpReplyCode": {},
										"StatusCode": {},
										"Message": {},
										"Sender": {}
									}
								},
								"WorkmailAction": {
									"type": "structure",
									"required": [
										"OrganizationArn"
									],
									"members": {
										"TopicArn": {},
										"OrganizationArn": {}
									}
								},
								"LambdaAction": {
									"type": "structure",
									"required": [
										"FunctionArn"
									],
									"members": {
										"TopicArn": {},
										"FunctionArn": {},
										"InvocationType": {}
									}
								},
								"StopAction": {
									"type": "structure",
									"required": [
										"Scope"
									],
									"members": {
										"Scope": {},
										"TopicArn": {}
									}
								},
								"AddHeaderAction": {
									"type": "structure",
									"required": [
										"HeaderName",
										"HeaderValue"
									],
									"members": {
										"HeaderName": {},
										"HeaderValue": {}
									}
								},
								"SNSAction": {
									"type": "structure",
									"required": [
										"TopicArn"
									],
									"members": {
										"TopicArn": {},
										"Encoding": {}
									}
								}
							}
						}
					},
					"ScanEnabled": {
						"type": "boolean"
					}
				}
			},
			"S26": {
				"type": "structure",
				"members": {
					"Name": {},
					"CreatedTimestamp": {
						"type": "timestamp"
					}
				}
			},
			"S28": {
				"type": "list",
				"member": {
					"shape": "Sw"
				}
			},
			"S2j": {
				"type": "list",
				"member": {}
			},
			"S2o": {
				"type": "list",
				"member": {}
			},
			"S33": {
				"type": "list",
				"member": {}
			},
			"S40": {
				"type": "list",
				"member": {}
			},
			"S4c": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Value"
					],
					"members": {
						"Name": {},
						"Value": {}
					}
				}
			},
			"S4t": {
				"type": "structure",
				"required": [
					"Data"
				],
				"members": {
					"Data": {},
					"Charset": {}
				}
			},
			"S4x": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Value"
					],
					"members": {
						"Name": {},
						"Value": {}
					}
				}
			}
		}
	};

/***/ },
/* 701 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListIdentities": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxItems",
				"result_key": "Identities"
			},
			"ListVerifiedEmailAddresses": {
				"result_key": "VerifiedEmailAddresses"
			}
		}
	};

/***/ },
/* 702 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"IdentityExists": {
				"delay": 3,
				"operation": "GetIdentityVerificationAttributes",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": "Success",
						"matcher": "pathAll",
						"state": "success",
						"argument": "VerificationAttributes.*.VerificationStatus"
					}
				]
			}
		}
	};

/***/ },
/* 703 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "events-2015-10-07",
			"apiVersion": "2015-10-07",
			"endpointPrefix": "events",
			"jsonVersion": "1.1",
			"serviceFullName": "Amazon CloudWatch Events",
			"signatureVersion": "v4",
			"targetPrefix": "AWSEvents",
			"protocol": "json"
		},
		"operations": {
			"DeleteRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				}
			},
			"DescribeRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"Arn": {},
						"EventPattern": {},
						"ScheduleExpression": {},
						"State": {},
						"Description": {},
						"RoleArn": {}
					}
				}
			},
			"DisableRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				}
			},
			"EnableRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				}
			},
			"ListRuleNamesByTarget": {
				"input": {
					"type": "structure",
					"required": [
						"TargetArn"
					],
					"members": {
						"TargetArn": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuleNames": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"ListRules": {
				"input": {
					"type": "structure",
					"members": {
						"NamePrefix": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rules": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Arn": {},
									"EventPattern": {},
									"State": {},
									"Description": {},
									"ScheduleExpression": {},
									"RoleArn": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListTargetsByRule": {
				"input": {
					"type": "structure",
					"required": [
						"Rule"
					],
					"members": {
						"Rule": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Targets": {
							"shape": "Sp"
						},
						"NextToken": {}
					}
				}
			},
			"PutEvents": {
				"input": {
					"type": "structure",
					"required": [
						"Entries"
					],
					"members": {
						"Entries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Time": {
										"type": "timestamp"
									},
									"Source": {},
									"Resources": {
										"type": "list",
										"member": {}
									},
									"DetailType": {},
									"Detail": {}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedEntryCount": {
							"type": "integer"
						},
						"Entries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"PutRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"ScheduleExpression": {},
						"EventPattern": {},
						"State": {},
						"Description": {},
						"RoleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuleArn": {}
					}
				}
			},
			"PutTargets": {
				"input": {
					"type": "structure",
					"required": [
						"Rule",
						"Targets"
					],
					"members": {
						"Rule": {},
						"Targets": {
							"shape": "Sp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedEntryCount": {
							"type": "integer"
						},
						"FailedEntries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TargetId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"RemoveTargets": {
				"input": {
					"type": "structure",
					"required": [
						"Rule",
						"Ids"
					],
					"members": {
						"Rule": {},
						"Ids": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FailedEntryCount": {
							"type": "integer"
						},
						"FailedEntries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TargetId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"TestEventPattern": {
				"input": {
					"type": "structure",
					"required": [
						"EventPattern",
						"Event"
					],
					"members": {
						"EventPattern": {},
						"Event": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Result": {
							"type": "boolean"
						}
					}
				}
			}
		},
		"shapes": {
			"Sp": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Id",
						"Arn"
					],
					"members": {
						"Id": {},
						"Arn": {},
						"Input": {},
						"InputPath": {}
					}
				}
			}
		},
		"examples": {}
	};

/***/ },
/* 704 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-08-04",
			"endpointPrefix": "firehose",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Firehose",
			"serviceFullName": "Amazon Kinesis Firehose",
			"signatureVersion": "v4",
			"targetPrefix": "Firehose_20150804",
			"uid": "firehose-2015-08-04"
		},
		"operations": {
			"CreateDeliveryStream": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName"
					],
					"members": {
						"DeliveryStreamName": {},
						"S3DestinationConfiguration": {
							"shape": "S3",
							"deprecated": true
						},
						"ExtendedS3DestinationConfiguration": {
							"type": "structure",
							"required": [
								"RoleARN",
								"BucketARN"
							],
							"members": {
								"RoleARN": {},
								"BucketARN": {},
								"Prefix": {},
								"BufferingHints": {
									"shape": "S7"
								},
								"CompressionFormat": {},
								"EncryptionConfiguration": {
									"shape": "Sb"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sf"
								},
								"ProcessingConfiguration": {
									"shape": "Sk"
								},
								"S3BackupMode": {},
								"S3BackupConfiguration": {
									"shape": "S3"
								}
							}
						},
						"RedshiftDestinationConfiguration": {
							"type": "structure",
							"required": [
								"RoleARN",
								"ClusterJDBCURL",
								"CopyCommand",
								"Username",
								"Password",
								"S3Configuration"
							],
							"members": {
								"RoleARN": {},
								"ClusterJDBCURL": {},
								"CopyCommand": {
									"shape": "Sv"
								},
								"Username": {
									"shape": "Sz"
								},
								"Password": {
									"shape": "S10"
								},
								"RetryOptions": {
									"shape": "S11"
								},
								"S3Configuration": {
									"shape": "S3"
								},
								"ProcessingConfiguration": {
									"shape": "Sk"
								},
								"S3BackupMode": {},
								"S3BackupConfiguration": {
									"shape": "S3"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sf"
								}
							}
						},
						"ElasticsearchDestinationConfiguration": {
							"type": "structure",
							"required": [
								"RoleARN",
								"DomainARN",
								"IndexName",
								"TypeName",
								"S3Configuration"
							],
							"members": {
								"RoleARN": {},
								"DomainARN": {},
								"IndexName": {},
								"TypeName": {},
								"IndexRotationPeriod": {},
								"BufferingHints": {
									"shape": "S19"
								},
								"RetryOptions": {
									"shape": "S1c"
								},
								"S3BackupMode": {},
								"S3Configuration": {
									"shape": "S3"
								},
								"ProcessingConfiguration": {
									"shape": "Sk"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sf"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeliveryStreamARN": {}
					}
				}
			},
			"DeleteDeliveryStream": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName"
					],
					"members": {
						"DeliveryStreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeDeliveryStream": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName"
					],
					"members": {
						"DeliveryStreamName": {},
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartDestinationId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DeliveryStreamDescription"
					],
					"members": {
						"DeliveryStreamDescription": {
							"type": "structure",
							"required": [
								"DeliveryStreamName",
								"DeliveryStreamARN",
								"DeliveryStreamStatus",
								"VersionId",
								"Destinations",
								"HasMoreDestinations"
							],
							"members": {
								"DeliveryStreamName": {},
								"DeliveryStreamARN": {},
								"DeliveryStreamStatus": {},
								"VersionId": {},
								"CreateTimestamp": {
									"type": "timestamp"
								},
								"LastUpdateTimestamp": {
									"type": "timestamp"
								},
								"Destinations": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"DestinationId"
										],
										"members": {
											"DestinationId": {},
											"S3DestinationDescription": {
												"shape": "S1t"
											},
											"ExtendedS3DestinationDescription": {
												"type": "structure",
												"required": [
													"RoleARN",
													"BucketARN",
													"BufferingHints",
													"CompressionFormat",
													"EncryptionConfiguration"
												],
												"members": {
													"RoleARN": {},
													"BucketARN": {},
													"Prefix": {},
													"BufferingHints": {
														"shape": "S7"
													},
													"CompressionFormat": {},
													"EncryptionConfiguration": {
														"shape": "Sb"
													},
													"CloudWatchLoggingOptions": {
														"shape": "Sf"
													},
													"ProcessingConfiguration": {
														"shape": "Sk"
													},
													"S3BackupMode": {},
													"S3BackupDescription": {
														"shape": "S1t"
													}
												}
											},
											"RedshiftDestinationDescription": {
												"type": "structure",
												"required": [
													"RoleARN",
													"ClusterJDBCURL",
													"CopyCommand",
													"Username",
													"S3DestinationDescription"
												],
												"members": {
													"RoleARN": {},
													"ClusterJDBCURL": {},
													"CopyCommand": {
														"shape": "Sv"
													},
													"Username": {
														"shape": "Sz"
													},
													"RetryOptions": {
														"shape": "S11"
													},
													"S3DestinationDescription": {
														"shape": "S1t"
													},
													"ProcessingConfiguration": {
														"shape": "Sk"
													},
													"S3BackupMode": {},
													"S3BackupDescription": {
														"shape": "S1t"
													},
													"CloudWatchLoggingOptions": {
														"shape": "Sf"
													}
												}
											},
											"ElasticsearchDestinationDescription": {
												"type": "structure",
												"members": {
													"RoleARN": {},
													"DomainARN": {},
													"IndexName": {},
													"TypeName": {},
													"IndexRotationPeriod": {},
													"BufferingHints": {
														"shape": "S19"
													},
													"RetryOptions": {
														"shape": "S1c"
													},
													"S3BackupMode": {},
													"S3DestinationDescription": {
														"shape": "S1t"
													},
													"ProcessingConfiguration": {
														"shape": "Sk"
													},
													"CloudWatchLoggingOptions": {
														"shape": "Sf"
													}
												}
											}
										}
									}
								},
								"HasMoreDestinations": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"ListDeliveryStreams": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartDeliveryStreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DeliveryStreamNames",
						"HasMoreDeliveryStreams"
					],
					"members": {
						"DeliveryStreamNames": {
							"type": "list",
							"member": {}
						},
						"HasMoreDeliveryStreams": {
							"type": "boolean"
						}
					}
				}
			},
			"PutRecord": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName",
						"Record"
					],
					"members": {
						"DeliveryStreamName": {},
						"Record": {
							"shape": "S22"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"RecordId"
					],
					"members": {
						"RecordId": {}
					}
				}
			},
			"PutRecordBatch": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName",
						"Records"
					],
					"members": {
						"DeliveryStreamName": {},
						"Records": {
							"type": "list",
							"member": {
								"shape": "S22"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"FailedPutCount",
						"RequestResponses"
					],
					"members": {
						"FailedPutCount": {
							"type": "integer"
						},
						"RequestResponses": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RecordId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"UpdateDestination": {
				"input": {
					"type": "structure",
					"required": [
						"DeliveryStreamName",
						"CurrentDeliveryStreamVersionId",
						"DestinationId"
					],
					"members": {
						"DeliveryStreamName": {},
						"CurrentDeliveryStreamVersionId": {},
						"DestinationId": {},
						"S3DestinationUpdate": {
							"shape": "S2f",
							"deprecated": true
						},
						"ExtendedS3DestinationUpdate": {
							"type": "structure",
							"members": {
								"RoleARN": {},
								"BucketARN": {},
								"Prefix": {},
								"BufferingHints": {
									"shape": "S7"
								},
								"CompressionFormat": {},
								"EncryptionConfiguration": {
									"shape": "Sb"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sf"
								},
								"ProcessingConfiguration": {
									"shape": "Sk"
								},
								"S3BackupMode": {},
								"S3BackupUpdate": {
									"shape": "S2f"
								}
							}
						},
						"RedshiftDestinationUpdate": {
							"type": "structure",
							"members": {
								"RoleARN": {},
								"ClusterJDBCURL": {},
								"CopyCommand": {
									"shape": "Sv"
								},
								"Username": {
									"shape": "Sz"
								},
								"Password": {
									"shape": "S10"
								},
								"RetryOptions": {
									"shape": "S11"
								},
								"S3Update": {
									"shape": "S2f"
								},
								"ProcessingConfiguration": {
									"shape": "Sk"
								},
								"S3BackupMode": {},
								"S3BackupUpdate": {
									"shape": "S2f"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sf"
								}
							}
						},
						"ElasticsearchDestinationUpdate": {
							"type": "structure",
							"members": {
								"RoleARN": {},
								"DomainARN": {},
								"IndexName": {},
								"TypeName": {},
								"IndexRotationPeriod": {},
								"BufferingHints": {
									"shape": "S19"
								},
								"RetryOptions": {
									"shape": "S1c"
								},
								"S3Update": {
									"shape": "S2f"
								},
								"ProcessingConfiguration": {
									"shape": "Sk"
								},
								"CloudWatchLoggingOptions": {
									"shape": "Sf"
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "structure",
				"required": [
					"RoleARN",
					"BucketARN"
				],
				"members": {
					"RoleARN": {},
					"BucketARN": {},
					"Prefix": {},
					"BufferingHints": {
						"shape": "S7"
					},
					"CompressionFormat": {},
					"EncryptionConfiguration": {
						"shape": "Sb"
					},
					"CloudWatchLoggingOptions": {
						"shape": "Sf"
					}
				}
			},
			"S7": {
				"type": "structure",
				"members": {
					"SizeInMBs": {
						"type": "integer"
					},
					"IntervalInSeconds": {
						"type": "integer"
					}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"NoEncryptionConfig": {},
					"KMSEncryptionConfig": {
						"type": "structure",
						"required": [
							"AWSKMSKeyARN"
						],
						"members": {
							"AWSKMSKeyARN": {}
						}
					}
				}
			},
			"Sf": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"LogGroupName": {},
					"LogStreamName": {}
				}
			},
			"Sk": {
				"type": "structure",
				"members": {
					"Enabled": {
						"type": "boolean"
					},
					"Processors": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Type"
							],
							"members": {
								"Type": {},
								"Parameters": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"ParameterName",
											"ParameterValue"
										],
										"members": {
											"ParameterName": {},
											"ParameterValue": {}
										}
									}
								}
							}
						}
					}
				}
			},
			"Sv": {
				"type": "structure",
				"required": [
					"DataTableName"
				],
				"members": {
					"DataTableName": {},
					"DataTableColumns": {},
					"CopyOptions": {}
				}
			},
			"Sz": {
				"type": "string",
				"sensitive": true
			},
			"S10": {
				"type": "string",
				"sensitive": true
			},
			"S11": {
				"type": "structure",
				"members": {
					"DurationInSeconds": {
						"type": "integer"
					}
				}
			},
			"S19": {
				"type": "structure",
				"members": {
					"IntervalInSeconds": {
						"type": "integer"
					},
					"SizeInMBs": {
						"type": "integer"
					}
				}
			},
			"S1c": {
				"type": "structure",
				"members": {
					"DurationInSeconds": {
						"type": "integer"
					}
				}
			},
			"S1t": {
				"type": "structure",
				"required": [
					"RoleARN",
					"BucketARN",
					"BufferingHints",
					"CompressionFormat",
					"EncryptionConfiguration"
				],
				"members": {
					"RoleARN": {},
					"BucketARN": {},
					"Prefix": {},
					"BufferingHints": {
						"shape": "S7"
					},
					"CompressionFormat": {},
					"EncryptionConfiguration": {
						"shape": "Sb"
					},
					"CloudWatchLoggingOptions": {
						"shape": "Sf"
					}
				}
			},
			"S22": {
				"type": "structure",
				"required": [
					"Data"
				],
				"members": {
					"Data": {
						"type": "blob"
					}
				}
			},
			"S2f": {
				"type": "structure",
				"members": {
					"RoleARN": {},
					"BucketARN": {},
					"Prefix": {},
					"BufferingHints": {
						"shape": "S7"
					},
					"CompressionFormat": {},
					"EncryptionConfiguration": {
						"shape": "Sb"
					},
					"CloudWatchLoggingOptions": {
						"shape": "Sf"
					}
				}
			}
		}
	};

/***/ },
/* 705 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "gamelift-2015-10-01",
			"apiVersion": "2015-10-01",
			"endpointPrefix": "gamelift",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon GameLift",
			"signatureVersion": "v4",
			"targetPrefix": "GameLift"
		},
		"operations": {
			"CreateAlias": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"RoutingStrategy"
					],
					"members": {
						"Name": {},
						"Description": {},
						"RoutingStrategy": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Alias": {
							"shape": "S9"
						}
					}
				}
			},
			"CreateBuild": {
				"input": {
					"type": "structure",
					"members": {
						"Name": {},
						"Version": {},
						"StorageLocation": {
							"shape": "Sd"
						},
						"OperatingSystem": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Build": {
							"shape": "Sh"
						},
						"UploadCredentials": {
							"shape": "Sl"
						},
						"StorageLocation": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateFleet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"BuildId",
						"EC2InstanceType"
					],
					"members": {
						"Name": {},
						"Description": {},
						"BuildId": {},
						"ServerLaunchPath": {},
						"ServerLaunchParameters": {},
						"LogPaths": {
							"shape": "Sn"
						},
						"EC2InstanceType": {},
						"EC2InboundPermissions": {
							"shape": "Sp"
						},
						"NewGameSessionProtectionPolicy": {},
						"RuntimeConfiguration": {
							"shape": "Sv"
						},
						"ResourceCreationLimitPolicy": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetAttributes": {
							"shape": "S12"
						}
					}
				}
			},
			"CreateGameSession": {
				"input": {
					"type": "structure",
					"required": [
						"MaximumPlayerSessionCount"
					],
					"members": {
						"FleetId": {},
						"AliasId": {},
						"MaximumPlayerSessionCount": {
							"type": "integer"
						},
						"Name": {},
						"GameProperties": {
							"shape": "S15"
						},
						"CreatorId": {},
						"GameSessionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSession": {
							"shape": "S1b"
						}
					}
				}
			},
			"CreatePlayerSession": {
				"input": {
					"type": "structure",
					"required": [
						"GameSessionId",
						"PlayerId"
					],
					"members": {
						"GameSessionId": {},
						"PlayerId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PlayerSession": {
							"shape": "S1i"
						}
					}
				}
			},
			"CreatePlayerSessions": {
				"input": {
					"type": "structure",
					"required": [
						"GameSessionId",
						"PlayerIds"
					],
					"members": {
						"GameSessionId": {},
						"PlayerIds": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PlayerSessions": {
							"shape": "S1o"
						}
					}
				}
			},
			"DeleteAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasId"
					],
					"members": {
						"AliasId": {}
					}
				}
			},
			"DeleteBuild": {
				"input": {
					"type": "structure",
					"required": [
						"BuildId"
					],
					"members": {
						"BuildId": {}
					}
				}
			},
			"DeleteFleet": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {}
					}
				}
			},
			"DeleteScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"FleetId"
					],
					"members": {
						"Name": {},
						"FleetId": {}
					}
				}
			},
			"DescribeAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasId"
					],
					"members": {
						"AliasId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Alias": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeBuild": {
				"input": {
					"type": "structure",
					"required": [
						"BuildId"
					],
					"members": {
						"BuildId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Build": {
							"shape": "Sh"
						}
					}
				}
			},
			"DescribeEC2InstanceLimits": {
				"input": {
					"type": "structure",
					"members": {
						"EC2InstanceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EC2InstanceLimits": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EC2InstanceType": {},
									"CurrentInstances": {
										"type": "integer"
									},
									"InstanceLimit": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"DescribeFleetAttributes": {
				"input": {
					"type": "structure",
					"members": {
						"FleetIds": {
							"shape": "S22"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetAttributes": {
							"type": "list",
							"member": {
								"shape": "S12"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeFleetCapacity": {
				"input": {
					"type": "structure",
					"members": {
						"FleetIds": {
							"shape": "S22"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetCapacity": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FleetId": {},
									"InstanceType": {},
									"InstanceCounts": {
										"type": "structure",
										"members": {
											"DESIRED": {
												"type": "integer"
											},
											"MINIMUM": {
												"type": "integer"
											},
											"MAXIMUM": {
												"type": "integer"
											},
											"PENDING": {
												"type": "integer"
											},
											"ACTIVE": {
												"type": "integer"
											},
											"IDLE": {
												"type": "integer"
											},
											"TERMINATING": {
												"type": "integer"
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeFleetEvents": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EventId": {},
									"ResourceId": {},
									"EventCode": {},
									"Message": {},
									"EventTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeFleetPortSettings": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InboundPermissions": {
							"shape": "Sp"
						}
					}
				}
			},
			"DescribeFleetUtilization": {
				"input": {
					"type": "structure",
					"members": {
						"FleetIds": {
							"shape": "S22"
						},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetUtilization": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FleetId": {},
									"ActiveServerProcessCount": {
										"type": "integer"
									},
									"ActiveGameSessionCount": {
										"type": "integer"
									},
									"CurrentPlayerSessionCount": {
										"type": "integer"
									},
									"MaximumPlayerSessionCount": {
										"type": "integer"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeGameSessionDetails": {
				"input": {
					"type": "structure",
					"members": {
						"FleetId": {},
						"GameSessionId": {},
						"AliasId": {},
						"StatusFilter": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessionDetails": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"GameSession": {
										"shape": "S1b"
									},
									"ProtectionPolicy": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeGameSessions": {
				"input": {
					"type": "structure",
					"members": {
						"FleetId": {},
						"GameSessionId": {},
						"AliasId": {},
						"StatusFilter": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessions": {
							"shape": "S2r"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstances": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"InstanceId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FleetId": {},
									"InstanceId": {},
									"IpAddress": {},
									"OperatingSystem": {},
									"Type": {},
									"Status": {},
									"CreationTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePlayerSessions": {
				"input": {
					"type": "structure",
					"members": {
						"GameSessionId": {},
						"PlayerId": {},
						"PlayerSessionId": {},
						"PlayerSessionStatusFilter": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PlayerSessions": {
							"shape": "S1o"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeRuntimeConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuntimeConfiguration": {
							"shape": "Sv"
						}
					}
				}
			},
			"DescribeScalingPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"StatusFilter": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ScalingPolicies": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FleetId": {},
									"Name": {},
									"Status": {},
									"ScalingAdjustment": {
										"type": "integer"
									},
									"ScalingAdjustmentType": {},
									"ComparisonOperator": {},
									"Threshold": {
										"type": "double"
									},
									"EvaluationPeriods": {
										"type": "integer"
									},
									"MetricName": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetGameSessionLogUrl": {
				"input": {
					"type": "structure",
					"required": [
						"GameSessionId"
					],
					"members": {
						"GameSessionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PreSignedUrl": {}
					}
				}
			},
			"GetInstanceAccess": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"InstanceId"
					],
					"members": {
						"FleetId": {},
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceAccess": {
							"type": "structure",
							"members": {
								"FleetId": {},
								"InstanceId": {},
								"IpAddress": {},
								"OperatingSystem": {},
								"Credentials": {
									"type": "structure",
									"members": {
										"UserName": {},
										"Secret": {}
									},
									"sensitive": true
								}
							}
						}
					}
				}
			},
			"ListAliases": {
				"input": {
					"type": "structure",
					"members": {
						"RoutingStrategyType": {},
						"Name": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Aliases": {
							"type": "list",
							"member": {
								"shape": "S9"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListBuilds": {
				"input": {
					"type": "structure",
					"members": {
						"Status": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Builds": {
							"type": "list",
							"member": {
								"shape": "Sh"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListFleets": {
				"input": {
					"type": "structure",
					"members": {
						"BuildId": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetIds": {
							"shape": "S22"
						},
						"NextToken": {}
					}
				}
			},
			"PutScalingPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"FleetId",
						"ScalingAdjustment",
						"ScalingAdjustmentType",
						"Threshold",
						"ComparisonOperator",
						"EvaluationPeriods",
						"MetricName"
					],
					"members": {
						"Name": {},
						"FleetId": {},
						"ScalingAdjustment": {
							"type": "integer"
						},
						"ScalingAdjustmentType": {},
						"Threshold": {
							"type": "double"
						},
						"ComparisonOperator": {},
						"EvaluationPeriods": {
							"type": "integer"
						},
						"MetricName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {}
					}
				}
			},
			"RequestUploadCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"BuildId"
					],
					"members": {
						"BuildId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UploadCredentials": {
							"shape": "Sl"
						},
						"StorageLocation": {
							"shape": "Sd"
						}
					}
				}
			},
			"ResolveAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasId"
					],
					"members": {
						"AliasId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetId": {}
					}
				}
			},
			"SearchGameSessions": {
				"input": {
					"type": "structure",
					"members": {
						"FleetId": {},
						"AliasId": {},
						"FilterExpression": {},
						"SortExpression": {},
						"Limit": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSessions": {
							"shape": "S2r"
						},
						"NextToken": {}
					}
				}
			},
			"UpdateAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasId"
					],
					"members": {
						"AliasId": {},
						"Name": {},
						"Description": {},
						"RoutingStrategy": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Alias": {
							"shape": "S9"
						}
					}
				}
			},
			"UpdateBuild": {
				"input": {
					"type": "structure",
					"required": [
						"BuildId"
					],
					"members": {
						"BuildId": {},
						"Name": {},
						"Version": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Build": {
							"shape": "Sh"
						}
					}
				}
			},
			"UpdateFleetAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"Name": {},
						"Description": {},
						"NewGameSessionProtectionPolicy": {},
						"ResourceCreationLimitPolicy": {
							"shape": "Sz"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetId": {}
					}
				}
			},
			"UpdateFleetCapacity": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"DesiredInstances": {
							"type": "integer"
						},
						"MinSize": {
							"type": "integer"
						},
						"MaxSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetId": {}
					}
				}
			},
			"UpdateFleetPortSettings": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId"
					],
					"members": {
						"FleetId": {},
						"InboundPermissionAuthorizations": {
							"shape": "Sp"
						},
						"InboundPermissionRevocations": {
							"shape": "Sp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FleetId": {}
					}
				}
			},
			"UpdateGameSession": {
				"input": {
					"type": "structure",
					"required": [
						"GameSessionId"
					],
					"members": {
						"GameSessionId": {},
						"MaximumPlayerSessionCount": {
							"type": "integer"
						},
						"Name": {},
						"PlayerSessionCreationPolicy": {},
						"ProtectionPolicy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GameSession": {
							"shape": "S1b"
						}
					}
				}
			},
			"UpdateRuntimeConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"FleetId",
						"RuntimeConfiguration"
					],
					"members": {
						"FleetId": {},
						"RuntimeConfiguration": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RuntimeConfiguration": {
							"shape": "Sv"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"Type": {},
					"FleetId": {},
					"Message": {}
				}
			},
			"S9": {
				"type": "structure",
				"members": {
					"AliasId": {},
					"Name": {},
					"Description": {},
					"RoutingStrategy": {
						"shape": "S4"
					},
					"CreationTime": {
						"type": "timestamp"
					},
					"LastUpdatedTime": {
						"type": "timestamp"
					}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"Bucket": {},
					"Key": {},
					"RoleArn": {}
				}
			},
			"Sh": {
				"type": "structure",
				"members": {
					"BuildId": {},
					"Name": {},
					"Version": {},
					"Status": {},
					"SizeOnDisk": {
						"type": "long"
					},
					"OperatingSystem": {},
					"CreationTime": {
						"type": "timestamp"
					}
				}
			},
			"Sl": {
				"type": "structure",
				"members": {
					"AccessKeyId": {},
					"SecretAccessKey": {},
					"SessionToken": {}
				},
				"sensitive": true
			},
			"Sn": {
				"type": "list",
				"member": {}
			},
			"Sp": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"FromPort",
						"ToPort",
						"IpRange",
						"Protocol"
					],
					"members": {
						"FromPort": {
							"type": "integer"
						},
						"ToPort": {
							"type": "integer"
						},
						"IpRange": {},
						"Protocol": {}
					}
				}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"ServerProcesses": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"LaunchPath",
								"ConcurrentExecutions"
							],
							"members": {
								"LaunchPath": {},
								"Parameters": {},
								"ConcurrentExecutions": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"NewGameSessionsPerCreator": {
						"type": "integer"
					},
					"PolicyPeriodInMinutes": {
						"type": "integer"
					}
				}
			},
			"S12": {
				"type": "structure",
				"members": {
					"FleetId": {},
					"Description": {},
					"Name": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"TerminationTime": {
						"type": "timestamp"
					},
					"Status": {},
					"BuildId": {},
					"ServerLaunchPath": {},
					"ServerLaunchParameters": {},
					"LogPaths": {
						"shape": "Sn"
					},
					"NewGameSessionProtectionPolicy": {},
					"OperatingSystem": {},
					"ResourceCreationLimitPolicy": {
						"shape": "Sz"
					}
				}
			},
			"S15": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"members": {
					"GameSessionId": {},
					"Name": {},
					"FleetId": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"TerminationTime": {
						"type": "timestamp"
					},
					"CurrentPlayerSessionCount": {
						"type": "integer"
					},
					"MaximumPlayerSessionCount": {
						"type": "integer"
					},
					"Status": {},
					"GameProperties": {
						"shape": "S15"
					},
					"IpAddress": {},
					"Port": {
						"type": "integer"
					},
					"PlayerSessionCreationPolicy": {},
					"CreatorId": {}
				}
			},
			"S1i": {
				"type": "structure",
				"members": {
					"PlayerSessionId": {},
					"PlayerId": {},
					"GameSessionId": {},
					"FleetId": {},
					"CreationTime": {
						"type": "timestamp"
					},
					"TerminationTime": {
						"type": "timestamp"
					},
					"Status": {},
					"IpAddress": {},
					"Port": {
						"type": "integer"
					}
				}
			},
			"S1o": {
				"type": "list",
				"member": {
					"shape": "S1i"
				}
			},
			"S22": {
				"type": "list",
				"member": {}
			},
			"S2r": {
				"type": "list",
				"member": {
					"shape": "S1b"
				}
			}
		}
	};

/***/ },
/* 706 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-02-16",
			"endpointPrefix": "inspector",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Inspector",
			"signatureVersion": "v4",
			"targetPrefix": "InspectorService",
			"uid": "inspector-2016-02-16"
		},
		"operations": {
			"AddAttributesToFindings": {
				"input": {
					"type": "structure",
					"required": [
						"findingArns",
						"attributes"
					],
					"members": {
						"findingArns": {
							"shape": "S2"
						},
						"attributes": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"failedItems"
					],
					"members": {
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"CreateAssessmentTarget": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetName",
						"resourceGroupArn"
					],
					"members": {
						"assessmentTargetName": {},
						"resourceGroupArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTargetArn"
					],
					"members": {
						"assessmentTargetArn": {}
					}
				}
			},
			"CreateAssessmentTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetArn",
						"assessmentTemplateName",
						"durationInSeconds",
						"rulesPackageArns"
					],
					"members": {
						"assessmentTargetArn": {},
						"assessmentTemplateName": {},
						"durationInSeconds": {
							"type": "integer"
						},
						"rulesPackageArns": {
							"shape": "Sj"
						},
						"userAttributesForFindings": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTemplateArn"
					],
					"members": {
						"assessmentTemplateArn": {}
					}
				}
			},
			"CreateResourceGroup": {
				"input": {
					"type": "structure",
					"required": [
						"resourceGroupTags"
					],
					"members": {
						"resourceGroupTags": {
							"shape": "Sm"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"resourceGroupArn"
					],
					"members": {
						"resourceGroupArn": {}
					}
				}
			},
			"DeleteAssessmentRun": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {}
					}
				}
			},
			"DeleteAssessmentTarget": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetArn"
					],
					"members": {
						"assessmentTargetArn": {}
					}
				}
			},
			"DeleteAssessmentTemplate": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTemplateArn"
					],
					"members": {
						"assessmentTemplateArn": {}
					}
				}
			},
			"DescribeAssessmentRuns": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArns"
					],
					"members": {
						"assessmentRunArns": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentRuns",
						"failedItems"
					],
					"members": {
						"assessmentRuns": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"name",
									"assessmentTemplateArn",
									"state",
									"durationInSeconds",
									"rulesPackageArns",
									"userAttributesForFindings",
									"createdAt",
									"stateChangedAt",
									"dataCollected",
									"stateChanges",
									"notifications"
								],
								"members": {
									"arn": {},
									"name": {},
									"assessmentTemplateArn": {},
									"state": {},
									"durationInSeconds": {
										"type": "integer"
									},
									"rulesPackageArns": {
										"type": "list",
										"member": {}
									},
									"userAttributesForFindings": {
										"shape": "S4"
									},
									"createdAt": {
										"type": "timestamp"
									},
									"startedAt": {
										"type": "timestamp"
									},
									"completedAt": {
										"type": "timestamp"
									},
									"stateChangedAt": {
										"type": "timestamp"
									},
									"dataCollected": {
										"type": "boolean"
									},
									"stateChanges": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"stateChangedAt",
												"state"
											],
											"members": {
												"stateChangedAt": {
													"type": "timestamp"
												},
												"state": {}
											}
										}
									},
									"notifications": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"date",
												"event",
												"error"
											],
											"members": {
												"date": {
													"type": "timestamp"
												},
												"event": {},
												"message": {},
												"error": {
													"type": "boolean"
												},
												"snsTopicArn": {},
												"snsPublishStatusCode": {}
											}
										}
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeAssessmentTargets": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetArns"
					],
					"members": {
						"assessmentTargetArns": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTargets",
						"failedItems"
					],
					"members": {
						"assessmentTargets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"name",
									"resourceGroupArn",
									"createdAt",
									"updatedAt"
								],
								"members": {
									"arn": {},
									"name": {},
									"resourceGroupArn": {},
									"createdAt": {
										"type": "timestamp"
									},
									"updatedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeAssessmentTemplates": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTemplateArns"
					],
					"members": {
						"assessmentTemplateArns": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTemplates",
						"failedItems"
					],
					"members": {
						"assessmentTemplates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"name",
									"assessmentTargetArn",
									"durationInSeconds",
									"rulesPackageArns",
									"userAttributesForFindings",
									"createdAt"
								],
								"members": {
									"arn": {},
									"name": {},
									"assessmentTargetArn": {},
									"durationInSeconds": {
										"type": "integer"
									},
									"rulesPackageArns": {
										"shape": "Sj"
									},
									"userAttributesForFindings": {
										"shape": "S4"
									},
									"createdAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeCrossAccountAccessRole": {
				"output": {
					"type": "structure",
					"required": [
						"roleArn",
						"valid",
						"registeredAt"
					],
					"members": {
						"roleArn": {},
						"valid": {
							"type": "boolean"
						},
						"registeredAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"DescribeFindings": {
				"input": {
					"type": "structure",
					"required": [
						"findingArns"
					],
					"members": {
						"findingArns": {
							"shape": "Sv"
						},
						"locale": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"findings",
						"failedItems"
					],
					"members": {
						"findings": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"attributes",
									"userAttributes",
									"createdAt",
									"updatedAt"
								],
								"members": {
									"arn": {},
									"schemaVersion": {
										"type": "integer"
									},
									"service": {},
									"serviceAttributes": {
										"type": "structure",
										"required": [
											"schemaVersion"
										],
										"members": {
											"schemaVersion": {
												"type": "integer"
											},
											"assessmentRunArn": {},
											"rulesPackageArn": {}
										}
									},
									"assetType": {},
									"assetAttributes": {
										"type": "structure",
										"required": [
											"schemaVersion"
										],
										"members": {
											"schemaVersion": {
												"type": "integer"
											},
											"agentId": {},
											"autoScalingGroup": {},
											"amiId": {},
											"hostname": {},
											"ipv4Addresses": {
												"type": "list",
												"member": {}
											}
										}
									},
									"id": {},
									"title": {},
									"description": {},
									"recommendation": {},
									"severity": {},
									"numericSeverity": {
										"type": "double"
									},
									"confidence": {
										"type": "integer"
									},
									"indicatorOfCompromise": {
										"type": "boolean"
									},
									"attributes": {
										"shape": "S24"
									},
									"userAttributes": {
										"shape": "S4"
									},
									"createdAt": {
										"type": "timestamp"
									},
									"updatedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeResourceGroups": {
				"input": {
					"type": "structure",
					"required": [
						"resourceGroupArns"
					],
					"members": {
						"resourceGroupArns": {
							"shape": "Sv"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"resourceGroups",
						"failedItems"
					],
					"members": {
						"resourceGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"tags",
									"createdAt"
								],
								"members": {
									"arn": {},
									"tags": {
										"shape": "Sm"
									},
									"createdAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"DescribeRulesPackages": {
				"input": {
					"type": "structure",
					"required": [
						"rulesPackageArns"
					],
					"members": {
						"rulesPackageArns": {
							"shape": "Sv"
						},
						"locale": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"rulesPackages",
						"failedItems"
					],
					"members": {
						"rulesPackages": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"arn",
									"name",
									"version",
									"provider"
								],
								"members": {
									"arn": {},
									"name": {},
									"version": {},
									"provider": {},
									"description": {}
								}
							}
						},
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"GetTelemetryMetadata": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"telemetryMetadata"
					],
					"members": {
						"telemetryMetadata": {
							"shape": "S2i"
						}
					}
				}
			},
			"ListAssessmentRunAgents": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {},
						"filter": {
							"type": "structure",
							"required": [
								"agentHealths",
								"agentHealthCodes"
							],
							"members": {
								"agentHealths": {
									"type": "list",
									"member": {}
								},
								"agentHealthCodes": {
									"type": "list",
									"member": {}
								}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentRunAgents"
					],
					"members": {
						"assessmentRunAgents": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"agentId",
									"assessmentRunArn",
									"agentHealth",
									"agentHealthCode",
									"telemetryMetadata"
								],
								"members": {
									"agentId": {},
									"assessmentRunArn": {},
									"agentHealth": {},
									"agentHealthCode": {},
									"agentHealthDetails": {},
									"autoScalingGroup": {},
									"telemetryMetadata": {
										"shape": "S2i"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListAssessmentRuns": {
				"input": {
					"type": "structure",
					"members": {
						"assessmentTemplateArns": {
							"shape": "S2y"
						},
						"filter": {
							"type": "structure",
							"members": {
								"namePattern": {},
								"states": {
									"type": "list",
									"member": {}
								},
								"durationRange": {
									"shape": "S32"
								},
								"rulesPackageArns": {
									"shape": "S33"
								},
								"startTimeRange": {
									"shape": "S34"
								},
								"completionTimeRange": {
									"shape": "S34"
								},
								"stateChangeTimeRange": {
									"shape": "S34"
								}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentRunArns"
					],
					"members": {
						"assessmentRunArns": {
							"shape": "S36"
						},
						"nextToken": {}
					}
				}
			},
			"ListAssessmentTargets": {
				"input": {
					"type": "structure",
					"members": {
						"filter": {
							"type": "structure",
							"members": {
								"assessmentTargetNamePattern": {}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTargetArns"
					],
					"members": {
						"assessmentTargetArns": {
							"shape": "S36"
						},
						"nextToken": {}
					}
				}
			},
			"ListAssessmentTemplates": {
				"input": {
					"type": "structure",
					"members": {
						"assessmentTargetArns": {
							"shape": "S2y"
						},
						"filter": {
							"type": "structure",
							"members": {
								"namePattern": {},
								"durationRange": {
									"shape": "S32"
								},
								"rulesPackageArns": {
									"shape": "S33"
								}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentTemplateArns"
					],
					"members": {
						"assessmentTemplateArns": {
							"shape": "S36"
						},
						"nextToken": {}
					}
				}
			},
			"ListEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"resourceArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"subscriptions"
					],
					"members": {
						"subscriptions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"resourceArn",
									"topicArn",
									"eventSubscriptions"
								],
								"members": {
									"resourceArn": {},
									"topicArn": {},
									"eventSubscriptions": {
										"type": "list",
										"member": {
											"type": "structure",
											"required": [
												"event",
												"subscribedAt"
											],
											"members": {
												"event": {},
												"subscribedAt": {
													"type": "timestamp"
												}
											}
										}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListFindings": {
				"input": {
					"type": "structure",
					"members": {
						"assessmentRunArns": {
							"shape": "S2y"
						},
						"filter": {
							"type": "structure",
							"members": {
								"agentIds": {
									"type": "list",
									"member": {}
								},
								"autoScalingGroups": {
									"type": "list",
									"member": {}
								},
								"ruleNames": {
									"type": "list",
									"member": {}
								},
								"severities": {
									"type": "list",
									"member": {}
								},
								"rulesPackageArns": {
									"shape": "S33"
								},
								"attributes": {
									"shape": "S24"
								},
								"userAttributes": {
									"shape": "S24"
								},
								"creationTimeRange": {
									"shape": "S34"
								}
							}
						},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"findingArns"
					],
					"members": {
						"findingArns": {
							"shape": "S36"
						},
						"nextToken": {}
					}
				}
			},
			"ListRulesPackages": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"rulesPackageArns"
					],
					"members": {
						"rulesPackageArns": {
							"shape": "S36"
						},
						"nextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"tags"
					],
					"members": {
						"tags": {
							"shape": "S3w"
						}
					}
				}
			},
			"PreviewAgents": {
				"input": {
					"type": "structure",
					"required": [
						"previewAgentsArn"
					],
					"members": {
						"previewAgentsArn": {},
						"nextToken": {},
						"maxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"agentPreviews"
					],
					"members": {
						"agentPreviews": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"agentId"
								],
								"members": {
									"agentId": {},
									"autoScalingGroup": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"RegisterCrossAccountAccessRole": {
				"input": {
					"type": "structure",
					"required": [
						"roleArn"
					],
					"members": {
						"roleArn": {}
					}
				}
			},
			"RemoveAttributesFromFindings": {
				"input": {
					"type": "structure",
					"required": [
						"findingArns",
						"attributeKeys"
					],
					"members": {
						"findingArns": {
							"shape": "S2"
						},
						"attributeKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"failedItems"
					],
					"members": {
						"failedItems": {
							"shape": "S9"
						}
					}
				}
			},
			"SetTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn"
					],
					"members": {
						"resourceArn": {},
						"tags": {
							"shape": "S3w"
						}
					}
				}
			},
			"StartAssessmentRun": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTemplateArn"
					],
					"members": {
						"assessmentTemplateArn": {},
						"assessmentRunName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {}
					}
				}
			},
			"StopAssessmentRun": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentRunArn"
					],
					"members": {
						"assessmentRunArn": {}
					}
				}
			},
			"SubscribeToEvent": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"event",
						"topicArn"
					],
					"members": {
						"resourceArn": {},
						"event": {},
						"topicArn": {}
					}
				}
			},
			"UnsubscribeFromEvent": {
				"input": {
					"type": "structure",
					"required": [
						"resourceArn",
						"event",
						"topicArn"
					],
					"members": {
						"resourceArn": {},
						"event": {},
						"topicArn": {}
					}
				}
			},
			"UpdateAssessmentTarget": {
				"input": {
					"type": "structure",
					"required": [
						"assessmentTargetArn",
						"assessmentTargetName",
						"resourceGroupArn"
					],
					"members": {
						"assessmentTargetArn": {},
						"assessmentTargetName": {},
						"resourceGroupArn": {}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"S4": {
				"type": "list",
				"member": {
					"shape": "S5"
				}
			},
			"S5": {
				"type": "structure",
				"required": [
					"key"
				],
				"members": {
					"key": {},
					"value": {}
				}
			},
			"S9": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"required": [
						"failureCode",
						"retryable"
					],
					"members": {
						"failureCode": {},
						"retryable": {
							"type": "boolean"
						}
					}
				}
			},
			"Sj": {
				"type": "list",
				"member": {}
			},
			"Sm": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"key"
					],
					"members": {
						"key": {},
						"value": {}
					}
				}
			},
			"Sv": {
				"type": "list",
				"member": {}
			},
			"S24": {
				"type": "list",
				"member": {
					"shape": "S5"
				}
			},
			"S2i": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"messageType",
						"count"
					],
					"members": {
						"messageType": {},
						"count": {
							"type": "long"
						},
						"dataSize": {
							"type": "long"
						}
					}
				}
			},
			"S2y": {
				"type": "list",
				"member": {}
			},
			"S32": {
				"type": "structure",
				"members": {
					"minSeconds": {
						"type": "integer"
					},
					"maxSeconds": {
						"type": "integer"
					}
				}
			},
			"S33": {
				"type": "list",
				"member": {}
			},
			"S34": {
				"type": "structure",
				"members": {
					"beginDate": {
						"type": "timestamp"
					},
					"endDate": {
						"type": "timestamp"
					}
				}
			},
			"S36": {
				"type": "list",
				"member": {}
			},
			"S3w": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"key"
					],
					"members": {
						"key": {},
						"value": {}
					}
				}
			}
		}
	};

/***/ },
/* 707 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "iot-2015-05-28",
			"apiVersion": "2015-05-28",
			"endpointPrefix": "iot",
			"serviceFullName": "AWS IoT",
			"signatureVersion": "v4",
			"signingName": "execute-api",
			"protocol": "rest-json"
		},
		"operations": {
			"AcceptCertificateTransfer": {
				"http": {
					"method": "PATCH",
					"requestUri": "/accept-certificate-transfer/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						},
						"setAsActive": {
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						}
					}
				}
			},
			"AttachPrincipalPolicy": {
				"http": {
					"method": "PUT",
					"requestUri": "/principal-policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"principal"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-iot-principal"
						}
					}
				}
			},
			"AttachThingPrincipal": {
				"http": {
					"method": "PUT",
					"requestUri": "/things/{thingName}/principals"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName",
						"principal"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-principal"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CancelCertificateTransfer": {
				"http": {
					"method": "PATCH",
					"requestUri": "/cancel-certificate-transfer/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						}
					}
				}
			},
			"CreateCertificateFromCsr": {
				"http": {
					"requestUri": "/certificates"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateSigningRequest"
					],
					"members": {
						"certificateSigningRequest": {},
						"setAsActive": {
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {},
						"certificatePem": {}
					}
				}
			},
			"CreateKeysAndCertificate": {
				"http": {
					"requestUri": "/keys-and-certificate"
				},
				"input": {
					"type": "structure",
					"members": {
						"setAsActive": {
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {},
						"certificatePem": {},
						"keyPair": {
							"type": "structure",
							"members": {
								"PublicKey": {},
								"PrivateKey": {
									"type": "string",
									"sensitive": true
								}
							}
						}
					}
				}
			},
			"CreatePolicy": {
				"http": {
					"requestUri": "/policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyDocument"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyDocument": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyName": {},
						"policyArn": {},
						"policyDocument": {},
						"policyVersionId": {}
					}
				}
			},
			"CreatePolicyVersion": {
				"http": {
					"requestUri": "/policies/{policyName}/version"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyDocument"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyDocument": {},
						"setAsDefault": {
							"location": "querystring",
							"locationName": "setAsDefault",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyArn": {},
						"policyDocument": {},
						"policyVersionId": {},
						"isDefaultVersion": {
							"type": "boolean"
						}
					}
				}
			},
			"CreateThing": {
				"http": {
					"requestUri": "/things/{thingName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"thingTypeName": {},
						"attributePayload": {
							"shape": "Sw"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingName": {},
						"thingArn": {}
					}
				}
			},
			"CreateThingType": {
				"http": {
					"requestUri": "/thing-types/{thingTypeName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingTypeName"
					],
					"members": {
						"thingTypeName": {
							"location": "uri",
							"locationName": "thingTypeName"
						},
						"thingTypeProperties": {
							"shape": "S14"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingTypeName": {},
						"thingTypeArn": {}
					}
				}
			},
			"CreateTopicRule": {
				"http": {
					"requestUri": "/rules/{ruleName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName",
						"topicRulePayload"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						},
						"topicRulePayload": {
							"shape": "S1b"
						}
					},
					"payload": "topicRulePayload"
				}
			},
			"DeleteCACertificate": {
				"http": {
					"method": "DELETE",
					"requestUri": "/cacertificate/{caCertificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "caCertificateId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteCertificate": {
				"http": {
					"method": "DELETE",
					"requestUri": "/certificates/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						}
					}
				}
			},
			"DeletePolicy": {
				"http": {
					"method": "DELETE",
					"requestUri": "/policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						}
					}
				}
			},
			"DeletePolicyVersion": {
				"http": {
					"method": "DELETE",
					"requestUri": "/policies/{policyName}/version/{policyVersionId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyVersionId"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyVersionId": {
							"location": "uri",
							"locationName": "policyVersionId"
						}
					}
				}
			},
			"DeleteRegistrationCode": {
				"http": {
					"method": "DELETE",
					"requestUri": "/registrationcode"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteThing": {
				"http": {
					"method": "DELETE",
					"requestUri": "/things/{thingName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"expectedVersion": {
							"location": "querystring",
							"locationName": "expectedVersion",
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteThingType": {
				"http": {
					"method": "DELETE",
					"requestUri": "/thing-types/{thingTypeName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingTypeName"
					],
					"members": {
						"thingTypeName": {
							"location": "uri",
							"locationName": "thingTypeName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTopicRule": {
				"http": {
					"method": "DELETE",
					"requestUri": "/rules/{ruleName}"
				},
				"input": {
					"type": "structure",
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						}
					},
					"required": [
						"ruleName"
					]
				}
			},
			"DeprecateThingType": {
				"http": {
					"requestUri": "/thing-types/{thingTypeName}/deprecate"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingTypeName"
					],
					"members": {
						"thingTypeName": {
							"location": "uri",
							"locationName": "thingTypeName"
						},
						"undoDeprecate": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeCACertificate": {
				"http": {
					"method": "GET",
					"requestUri": "/cacertificate/{caCertificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "caCertificateId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateDescription": {
							"type": "structure",
							"members": {
								"certificateArn": {},
								"certificateId": {},
								"status": {},
								"certificatePem": {},
								"ownedBy": {},
								"creationDate": {
									"type": "timestamp"
								},
								"autoRegistrationStatus": {}
							}
						}
					}
				}
			},
			"DescribeCertificate": {
				"http": {
					"method": "GET",
					"requestUri": "/certificates/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateDescription": {
							"type": "structure",
							"members": {
								"certificateArn": {},
								"certificateId": {},
								"caCertificateId": {},
								"status": {},
								"certificatePem": {},
								"ownedBy": {},
								"previousOwnedBy": {},
								"creationDate": {
									"type": "timestamp"
								},
								"lastModifiedDate": {
									"type": "timestamp"
								},
								"transferData": {
									"type": "structure",
									"members": {
										"transferMessage": {},
										"rejectReason": {},
										"transferDate": {
											"type": "timestamp"
										},
										"acceptDate": {
											"type": "timestamp"
										},
										"rejectDate": {
											"type": "timestamp"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeEndpoint": {
				"http": {
					"method": "GET",
					"requestUri": "/endpoint"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"endpointAddress": {}
					}
				}
			},
			"DescribeThing": {
				"http": {
					"method": "GET",
					"requestUri": "/things/{thingName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"defaultClientId": {},
						"thingName": {},
						"thingTypeName": {},
						"attributes": {
							"shape": "Sx"
						},
						"version": {
							"type": "long"
						}
					}
				}
			},
			"DescribeThingType": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-types/{thingTypeName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingTypeName"
					],
					"members": {
						"thingTypeName": {
							"location": "uri",
							"locationName": "thingTypeName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingTypeName": {},
						"thingTypeProperties": {
							"shape": "S14"
						},
						"thingTypeMetadata": {
							"shape": "S3u"
						}
					}
				}
			},
			"DetachPrincipalPolicy": {
				"http": {
					"method": "DELETE",
					"requestUri": "/principal-policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"principal"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-iot-principal"
						}
					}
				}
			},
			"DetachThingPrincipal": {
				"http": {
					"method": "DELETE",
					"requestUri": "/things/{thingName}/principals"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName",
						"principal"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-principal"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisableTopicRule": {
				"http": {
					"requestUri": "/rules/{ruleName}/disable"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						}
					}
				}
			},
			"EnableTopicRule": {
				"http": {
					"requestUri": "/rules/{ruleName}/enable"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						}
					}
				}
			},
			"GetLoggingOptions": {
				"http": {
					"method": "GET",
					"requestUri": "/loggingOptions"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"roleArn": {},
						"logLevel": {}
					}
				}
			},
			"GetPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/policies/{policyName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyName": {},
						"policyArn": {},
						"policyDocument": {},
						"defaultVersionId": {}
					}
				}
			},
			"GetPolicyVersion": {
				"http": {
					"method": "GET",
					"requestUri": "/policies/{policyName}/version/{policyVersionId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyVersionId"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyVersionId": {
							"location": "uri",
							"locationName": "policyVersionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyArn": {},
						"policyName": {},
						"policyDocument": {},
						"policyVersionId": {},
						"isDefaultVersion": {
							"type": "boolean"
						}
					}
				}
			},
			"GetRegistrationCode": {
				"http": {
					"method": "GET",
					"requestUri": "/registrationcode"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"registrationCode": {}
					}
				}
			},
			"GetTopicRule": {
				"http": {
					"method": "GET",
					"requestUri": "/rules/{ruleName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ruleArn": {},
						"rule": {
							"type": "structure",
							"members": {
								"ruleName": {},
								"sql": {},
								"description": {},
								"createdAt": {
									"type": "timestamp"
								},
								"actions": {
									"shape": "S1e"
								},
								"ruleDisabled": {
									"type": "boolean"
								},
								"awsIotSqlVersion": {}
							}
						}
					}
				}
			},
			"ListCACertificates": {
				"http": {
					"method": "GET",
					"requestUri": "/cacertificates"
				},
				"input": {
					"type": "structure",
					"members": {
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"certificateArn": {},
									"certificateId": {},
									"status": {},
									"creationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextMarker": {}
					}
				}
			},
			"ListCertificates": {
				"http": {
					"method": "GET",
					"requestUri": "/certificates"
				},
				"input": {
					"type": "structure",
					"members": {
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificates": {
							"shape": "S4r"
						},
						"nextMarker": {}
					}
				}
			},
			"ListCertificatesByCA": {
				"http": {
					"method": "GET",
					"requestUri": "/certificates-by-ca/{caCertificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"caCertificateId"
					],
					"members": {
						"caCertificateId": {
							"location": "uri",
							"locationName": "caCertificateId"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificates": {
							"shape": "S4r"
						},
						"nextMarker": {}
					}
				}
			},
			"ListOutgoingCertificates": {
				"http": {
					"method": "GET",
					"requestUri": "/certificates-out-going"
				},
				"input": {
					"type": "structure",
					"members": {
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"outgoingCertificates": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"certificateArn": {},
									"certificateId": {},
									"transferredTo": {},
									"transferDate": {
										"type": "timestamp"
									},
									"transferMessage": {},
									"creationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"nextMarker": {}
					}
				}
			},
			"ListPolicies": {
				"http": {
					"method": "GET",
					"requestUri": "/policies"
				},
				"input": {
					"type": "structure",
					"members": {
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policies": {
							"shape": "S51"
						},
						"nextMarker": {}
					}
				}
			},
			"ListPolicyPrincipals": {
				"http": {
					"method": "GET",
					"requestUri": "/policy-principals"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName"
					],
					"members": {
						"policyName": {
							"location": "header",
							"locationName": "x-amzn-iot-policy"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"principals": {
							"shape": "S55"
						},
						"nextMarker": {}
					}
				}
			},
			"ListPolicyVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/policies/{policyName}/version"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policyVersions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"versionId": {},
									"isDefaultVersion": {
										"type": "boolean"
									},
									"createDate": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"ListPrincipalPolicies": {
				"http": {
					"method": "GET",
					"requestUri": "/principal-policies"
				},
				"input": {
					"type": "structure",
					"required": [
						"principal"
					],
					"members": {
						"principal": {
							"location": "header",
							"locationName": "x-amzn-iot-principal"
						},
						"marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"pageSize": {
							"location": "querystring",
							"locationName": "pageSize",
							"type": "integer"
						},
						"ascendingOrder": {
							"location": "querystring",
							"locationName": "isAscendingOrder",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"policies": {
							"shape": "S51"
						},
						"nextMarker": {}
					}
				}
			},
			"ListPrincipalThings": {
				"http": {
					"method": "GET",
					"requestUri": "/principals/things"
				},
				"input": {
					"type": "structure",
					"required": [
						"principal"
					],
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"principal": {
							"location": "header",
							"locationName": "x-amzn-principal"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"things": {
							"type": "list",
							"member": {}
						},
						"nextToken": {}
					}
				}
			},
			"ListThingPrincipals": {
				"http": {
					"method": "GET",
					"requestUri": "/things/{thingName}/principals"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"principals": {
							"shape": "S55"
						}
					}
				}
			},
			"ListThingTypes": {
				"http": {
					"method": "GET",
					"requestUri": "/thing-types"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"thingTypeName": {
							"location": "querystring",
							"locationName": "thingTypeName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"thingTypes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"thingTypeName": {},
									"thingTypeProperties": {
										"shape": "S14"
									},
									"thingTypeMetadata": {
										"shape": "S3u"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListThings": {
				"http": {
					"method": "GET",
					"requestUri": "/things"
				},
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"attributeName": {
							"location": "querystring",
							"locationName": "attributeName"
						},
						"attributeValue": {
							"location": "querystring",
							"locationName": "attributeValue"
						},
						"thingTypeName": {
							"location": "querystring",
							"locationName": "thingTypeName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"things": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"thingName": {},
									"thingTypeName": {},
									"attributes": {
										"shape": "Sx"
									},
									"version": {
										"type": "long"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"ListTopicRules": {
				"http": {
					"method": "GET",
					"requestUri": "/rules"
				},
				"input": {
					"type": "structure",
					"members": {
						"topic": {
							"location": "querystring",
							"locationName": "topic"
						},
						"maxResults": {
							"location": "querystring",
							"locationName": "maxResults",
							"type": "integer"
						},
						"nextToken": {
							"location": "querystring",
							"locationName": "nextToken"
						},
						"ruleDisabled": {
							"location": "querystring",
							"locationName": "ruleDisabled",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"rules": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ruleArn": {},
									"ruleName": {},
									"topicPattern": {},
									"createdAt": {
										"type": "timestamp"
									},
									"ruleDisabled": {
										"type": "boolean"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"RegisterCACertificate": {
				"http": {
					"requestUri": "/cacertificate"
				},
				"input": {
					"type": "structure",
					"required": [
						"caCertificate",
						"verificationCertificate"
					],
					"members": {
						"caCertificate": {},
						"verificationCertificate": {},
						"setAsActive": {
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						},
						"allowAutoRegistration": {
							"location": "querystring",
							"locationName": "allowAutoRegistration",
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {}
					}
				}
			},
			"RegisterCertificate": {
				"http": {
					"requestUri": "/certificate/register"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificatePem"
					],
					"members": {
						"certificatePem": {},
						"caCertificatePem": {},
						"setAsActive": {
							"deprecated": true,
							"location": "querystring",
							"locationName": "setAsActive",
							"type": "boolean"
						},
						"status": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {}
					}
				}
			},
			"RejectCertificateTransfer": {
				"http": {
					"method": "PATCH",
					"requestUri": "/reject-certificate-transfer/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						},
						"rejectReason": {}
					}
				}
			},
			"ReplaceTopicRule": {
				"http": {
					"method": "PATCH",
					"requestUri": "/rules/{ruleName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"ruleName",
						"topicRulePayload"
					],
					"members": {
						"ruleName": {
							"location": "uri",
							"locationName": "ruleName"
						},
						"topicRulePayload": {
							"shape": "S1b"
						}
					},
					"payload": "topicRulePayload"
				}
			},
			"SetDefaultPolicyVersion": {
				"http": {
					"method": "PATCH",
					"requestUri": "/policies/{policyName}/version/{policyVersionId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"policyName",
						"policyVersionId"
					],
					"members": {
						"policyName": {
							"location": "uri",
							"locationName": "policyName"
						},
						"policyVersionId": {
							"location": "uri",
							"locationName": "policyVersionId"
						}
					}
				}
			},
			"SetLoggingOptions": {
				"http": {
					"requestUri": "/loggingOptions"
				},
				"input": {
					"type": "structure",
					"required": [
						"loggingOptionsPayload"
					],
					"members": {
						"loggingOptionsPayload": {
							"type": "structure",
							"required": [
								"roleArn"
							],
							"members": {
								"roleArn": {},
								"logLevel": {}
							}
						}
					},
					"payload": "loggingOptionsPayload"
				}
			},
			"TransferCertificate": {
				"http": {
					"method": "PATCH",
					"requestUri": "/transfer-certificate/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId",
						"targetAwsAccount"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						},
						"targetAwsAccount": {
							"location": "querystring",
							"locationName": "targetAwsAccount"
						},
						"transferMessage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"transferredCertificateArn": {}
					}
				}
			},
			"UpdateCACertificate": {
				"http": {
					"method": "PUT",
					"requestUri": "/cacertificate/{caCertificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "caCertificateId"
						},
						"newStatus": {
							"location": "querystring",
							"locationName": "newStatus"
						},
						"newAutoRegistrationStatus": {
							"location": "querystring",
							"locationName": "newAutoRegistrationStatus"
						}
					}
				}
			},
			"UpdateCertificate": {
				"http": {
					"method": "PUT",
					"requestUri": "/certificates/{certificateId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"certificateId",
						"newStatus"
					],
					"members": {
						"certificateId": {
							"location": "uri",
							"locationName": "certificateId"
						},
						"newStatus": {
							"location": "querystring",
							"locationName": "newStatus"
						}
					}
				}
			},
			"UpdateThing": {
				"http": {
					"method": "PATCH",
					"requestUri": "/things/{thingName}"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"thingTypeName": {},
						"attributePayload": {
							"shape": "Sw"
						},
						"expectedVersion": {
							"type": "long"
						},
						"removeThingType": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			}
		},
		"shapes": {
			"Sw": {
				"type": "structure",
				"members": {
					"attributes": {
						"shape": "Sx"
					},
					"merge": {
						"type": "boolean"
					}
				}
			},
			"Sx": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S14": {
				"type": "structure",
				"members": {
					"thingTypeDescription": {},
					"searchableAttributes": {
						"type": "list",
						"member": {}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"required": [
					"sql",
					"actions"
				],
				"members": {
					"sql": {},
					"description": {},
					"actions": {
						"shape": "S1e"
					},
					"ruleDisabled": {
						"type": "boolean"
					},
					"awsIotSqlVersion": {}
				}
			},
			"S1e": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"dynamoDB": {
							"type": "structure",
							"required": [
								"tableName",
								"roleArn",
								"hashKeyField",
								"hashKeyValue"
							],
							"members": {
								"tableName": {},
								"roleArn": {},
								"operation": {},
								"hashKeyField": {},
								"hashKeyValue": {},
								"hashKeyType": {},
								"rangeKeyField": {},
								"rangeKeyValue": {},
								"rangeKeyType": {},
								"payloadField": {}
							}
						},
						"dynamoDBv2": {
							"type": "structure",
							"members": {
								"roleArn": {},
								"putItem": {
									"type": "structure",
									"required": [
										"tableName"
									],
									"members": {
										"tableName": {}
									}
								}
							}
						},
						"lambda": {
							"type": "structure",
							"required": [
								"functionArn"
							],
							"members": {
								"functionArn": {}
							}
						},
						"sns": {
							"type": "structure",
							"required": [
								"targetArn",
								"roleArn"
							],
							"members": {
								"targetArn": {},
								"roleArn": {},
								"messageFormat": {}
							}
						},
						"sqs": {
							"type": "structure",
							"required": [
								"roleArn",
								"queueUrl"
							],
							"members": {
								"roleArn": {},
								"queueUrl": {},
								"useBase64": {
									"type": "boolean"
								}
							}
						},
						"kinesis": {
							"type": "structure",
							"required": [
								"roleArn",
								"streamName"
							],
							"members": {
								"roleArn": {},
								"streamName": {},
								"partitionKey": {}
							}
						},
						"republish": {
							"type": "structure",
							"required": [
								"roleArn",
								"topic"
							],
							"members": {
								"roleArn": {},
								"topic": {}
							}
						},
						"s3": {
							"type": "structure",
							"required": [
								"roleArn",
								"bucketName",
								"key"
							],
							"members": {
								"roleArn": {},
								"bucketName": {},
								"key": {},
								"cannedAcl": {}
							}
						},
						"firehose": {
							"type": "structure",
							"required": [
								"roleArn",
								"deliveryStreamName"
							],
							"members": {
								"roleArn": {},
								"deliveryStreamName": {},
								"separator": {}
							}
						},
						"cloudwatchMetric": {
							"type": "structure",
							"required": [
								"roleArn",
								"metricNamespace",
								"metricName",
								"metricValue",
								"metricUnit"
							],
							"members": {
								"roleArn": {},
								"metricNamespace": {},
								"metricName": {},
								"metricValue": {},
								"metricUnit": {},
								"metricTimestamp": {}
							}
						},
						"cloudwatchAlarm": {
							"type": "structure",
							"required": [
								"roleArn",
								"alarmName",
								"stateReason",
								"stateValue"
							],
							"members": {
								"roleArn": {},
								"alarmName": {},
								"stateReason": {},
								"stateValue": {}
							}
						},
						"elasticsearch": {
							"type": "structure",
							"required": [
								"roleArn",
								"endpoint",
								"index",
								"type",
								"id"
							],
							"members": {
								"roleArn": {},
								"endpoint": {},
								"index": {},
								"type": {},
								"id": {}
							}
						}
					}
				}
			},
			"S3u": {
				"type": "structure",
				"members": {
					"deprecated": {
						"type": "boolean"
					},
					"deprecationDate": {
						"type": "timestamp"
					},
					"creationDate": {
						"type": "timestamp"
					}
				}
			},
			"S4r": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"certificateArn": {},
						"certificateId": {},
						"status": {},
						"creationDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"S51": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"policyName": {},
						"policyArn": {}
					}
				}
			},
			"S55": {
				"type": "list",
				"member": {}
			}
		},
		"examples": {}
	};

/***/ },
/* 708 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "iot-data-2015-05-28",
			"apiVersion": "2015-05-28",
			"endpointPrefix": "data.iot",
			"protocol": "rest-json",
			"serviceFullName": "AWS IoT Data Plane",
			"signatureVersion": "v4",
			"signingName": "iotdata"
		},
		"operations": {
			"DeleteThingShadow": {
				"http": {
					"method": "DELETE",
					"requestUri": "/things/{thingName}/shadow"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"payload"
					],
					"members": {
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				}
			},
			"GetThingShadow": {
				"http": {
					"method": "GET",
					"requestUri": "/things/{thingName}/shadow"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				}
			},
			"Publish": {
				"http": {
					"requestUri": "/topics/{topic}"
				},
				"input": {
					"type": "structure",
					"required": [
						"topic"
					],
					"members": {
						"topic": {
							"location": "uri",
							"locationName": "topic"
						},
						"qos": {
							"location": "querystring",
							"locationName": "qos",
							"type": "integer"
						},
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				}
			},
			"UpdateThingShadow": {
				"http": {
					"requestUri": "/things/{thingName}/shadow"
				},
				"input": {
					"type": "structure",
					"required": [
						"thingName",
						"payload"
					],
					"members": {
						"thingName": {
							"location": "uri",
							"locationName": "thingName"
						},
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				},
				"output": {
					"type": "structure",
					"members": {
						"payload": {
							"type": "blob"
						}
					},
					"payload": "payload"
				}
			}
		},
		"shapes": {}
	};

/***/ },
/* 709 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "kinesis-2013-12-02",
			"apiVersion": "2013-12-02",
			"endpointPrefix": "kinesis",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Kinesis",
			"serviceFullName": "Amazon Kinesis",
			"signatureVersion": "v4",
			"targetPrefix": "Kinesis_20131202"
		},
		"operations": {
			"AddTagsToStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"Tags"
					],
					"members": {
						"StreamName": {},
						"Tags": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"CreateStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardCount"
					],
					"members": {
						"StreamName": {},
						"ShardCount": {
							"type": "integer"
						}
					}
				}
			},
			"DecreaseStreamRetentionPeriod": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"RetentionPeriodHours"
					],
					"members": {
						"StreamName": {},
						"RetentionPeriodHours": {
							"type": "integer"
						}
					}
				}
			},
			"DeleteStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {}
					}
				}
			},
			"DescribeLimits": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"ShardLimit",
						"OpenShardCount"
					],
					"members": {
						"ShardLimit": {
							"type": "integer"
						},
						"OpenShardCount": {
							"type": "integer"
						}
					}
				}
			},
			"DescribeStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {},
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartShardId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"StreamDescription"
					],
					"members": {
						"StreamDescription": {
							"type": "structure",
							"required": [
								"StreamName",
								"StreamARN",
								"StreamStatus",
								"Shards",
								"HasMoreShards",
								"RetentionPeriodHours",
								"StreamCreationTimestamp",
								"EnhancedMonitoring"
							],
							"members": {
								"StreamName": {},
								"StreamARN": {},
								"StreamStatus": {},
								"Shards": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"ShardId",
											"HashKeyRange",
											"SequenceNumberRange"
										],
										"members": {
											"ShardId": {},
											"ParentShardId": {},
											"AdjacentParentShardId": {},
											"HashKeyRange": {
												"type": "structure",
												"required": [
													"StartingHashKey",
													"EndingHashKey"
												],
												"members": {
													"StartingHashKey": {},
													"EndingHashKey": {}
												}
											},
											"SequenceNumberRange": {
												"type": "structure",
												"required": [
													"StartingSequenceNumber"
												],
												"members": {
													"StartingSequenceNumber": {},
													"EndingSequenceNumber": {}
												}
											}
										}
									}
								},
								"HasMoreShards": {
									"type": "boolean"
								},
								"RetentionPeriodHours": {
									"type": "integer"
								},
								"StreamCreationTimestamp": {
									"type": "timestamp"
								},
								"EnhancedMonitoring": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ShardLevelMetrics": {
												"shape": "Su"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DisableEnhancedMonitoring": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardLevelMetrics"
					],
					"members": {
						"StreamName": {},
						"ShardLevelMetrics": {
							"shape": "Su"
						}
					}
				},
				"output": {
					"shape": "Sx"
				}
			},
			"EnableEnhancedMonitoring": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardLevelMetrics"
					],
					"members": {
						"StreamName": {},
						"ShardLevelMetrics": {
							"shape": "Su"
						}
					}
				},
				"output": {
					"shape": "Sx"
				}
			},
			"GetRecords": {
				"input": {
					"type": "structure",
					"required": [
						"ShardIterator"
					],
					"members": {
						"ShardIterator": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Records"
					],
					"members": {
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"SequenceNumber",
									"Data",
									"PartitionKey"
								],
								"members": {
									"SequenceNumber": {},
									"ApproximateArrivalTimestamp": {
										"type": "timestamp"
									},
									"Data": {
										"type": "blob"
									},
									"PartitionKey": {}
								}
							}
						},
						"NextShardIterator": {},
						"MillisBehindLatest": {
							"type": "long"
						}
					}
				}
			},
			"GetShardIterator": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardId",
						"ShardIteratorType"
					],
					"members": {
						"StreamName": {},
						"ShardId": {},
						"ShardIteratorType": {},
						"StartingSequenceNumber": {},
						"Timestamp": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ShardIterator": {}
					}
				}
			},
			"IncreaseStreamRetentionPeriod": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"RetentionPeriodHours"
					],
					"members": {
						"StreamName": {},
						"RetentionPeriodHours": {
							"type": "integer"
						}
					}
				}
			},
			"ListStreams": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartStreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"StreamNames",
						"HasMoreStreams"
					],
					"members": {
						"StreamNames": {
							"type": "list",
							"member": {}
						},
						"HasMoreStreams": {
							"type": "boolean"
						}
					}
				}
			},
			"ListTagsForStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName"
					],
					"members": {
						"StreamName": {},
						"ExclusiveStartTagKey": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Tags",
						"HasMoreTags"
					],
					"members": {
						"Tags": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key"
								],
								"members": {
									"Key": {},
									"Value": {}
								}
							}
						},
						"HasMoreTags": {
							"type": "boolean"
						}
					}
				}
			},
			"MergeShards": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardToMerge",
						"AdjacentShardToMerge"
					],
					"members": {
						"StreamName": {},
						"ShardToMerge": {},
						"AdjacentShardToMerge": {}
					}
				}
			},
			"PutRecord": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"Data",
						"PartitionKey"
					],
					"members": {
						"StreamName": {},
						"Data": {
							"type": "blob"
						},
						"PartitionKey": {},
						"ExplicitHashKey": {},
						"SequenceNumberForOrdering": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ShardId",
						"SequenceNumber"
					],
					"members": {
						"ShardId": {},
						"SequenceNumber": {}
					}
				}
			},
			"PutRecords": {
				"input": {
					"type": "structure",
					"required": [
						"Records",
						"StreamName"
					],
					"members": {
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Data",
									"PartitionKey"
								],
								"members": {
									"Data": {
										"type": "blob"
									},
									"ExplicitHashKey": {},
									"PartitionKey": {}
								}
							}
						},
						"StreamName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Records"
					],
					"members": {
						"FailedRecordCount": {
							"type": "integer"
						},
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"SequenceNumber": {},
									"ShardId": {},
									"ErrorCode": {},
									"ErrorMessage": {}
								}
							}
						}
					}
				}
			},
			"RemoveTagsFromStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"TagKeys"
					],
					"members": {
						"StreamName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"SplitShard": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"ShardToSplit",
						"NewStartingHashKey"
					],
					"members": {
						"StreamName": {},
						"ShardToSplit": {},
						"NewStartingHashKey": {}
					}
				}
			},
			"UpdateShardCount": {
				"input": {
					"type": "structure",
					"required": [
						"StreamName",
						"TargetShardCount",
						"ScalingType"
					],
					"members": {
						"StreamName": {},
						"TargetShardCount": {
							"type": "integer"
						},
						"ScalingType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamName": {},
						"CurrentShardCount": {
							"type": "integer"
						},
						"TargetShardCount": {
							"type": "integer"
						}
					}
				}
			}
		},
		"shapes": {
			"Su": {
				"type": "list",
				"member": {}
			},
			"Sx": {
				"type": "structure",
				"members": {
					"StreamName": {},
					"CurrentShardLevelMetrics": {
						"shape": "Su"
					},
					"DesiredShardLevelMetrics": {
						"shape": "Su"
					}
				}
			}
		}
	};

/***/ },
/* 710 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeStream": {
				"input_token": "ExclusiveStartShardId",
				"limit_key": "Limit",
				"more_results": "StreamDescription.HasMoreShards",
				"output_token": "StreamDescription.Shards[-1].ShardId",
				"result_key": "StreamDescription.Shards"
			},
			"ListStreams": {
				"input_token": "ExclusiveStartStreamName",
				"limit_key": "Limit",
				"more_results": "HasMoreStreams",
				"output_token": "StreamNames[-1]",
				"result_key": "StreamNames"
			}
		}
	};

/***/ },
/* 711 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"StreamExists": {
				"delay": 10,
				"operation": "DescribeStream",
				"maxAttempts": 18,
				"acceptors": [
					{
						"expected": "ACTIVE",
						"matcher": "path",
						"state": "success",
						"argument": "StreamDescription.StreamStatus"
					}
				]
			}
		}
	};

/***/ },
/* 712 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-11-01",
			"endpointPrefix": "kms",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "KMS",
			"serviceFullName": "AWS Key Management Service",
			"signatureVersion": "v4",
			"targetPrefix": "TrentService",
			"uid": "kms-2014-11-01"
		},
		"operations": {
			"CancelKeyDeletion": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyId": {}
					}
				}
			},
			"CreateAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasName",
						"TargetKeyId"
					],
					"members": {
						"AliasName": {},
						"TargetKeyId": {}
					}
				}
			},
			"CreateGrant": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"GranteePrincipal"
					],
					"members": {
						"KeyId": {},
						"GranteePrincipal": {},
						"RetiringPrincipal": {},
						"Operations": {
							"shape": "S8"
						},
						"Constraints": {
							"shape": "Sa"
						},
						"GrantTokens": {
							"shape": "Se"
						},
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GrantToken": {},
						"GrantId": {}
					}
				}
			},
			"CreateKey": {
				"input": {
					"type": "structure",
					"members": {
						"Policy": {},
						"Description": {},
						"KeyUsage": {},
						"Origin": {},
						"BypassPolicyLockoutSafetyCheck": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyMetadata": {
							"shape": "Su"
						}
					}
				}
			},
			"Decrypt": {
				"input": {
					"type": "structure",
					"required": [
						"CiphertextBlob"
					],
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"EncryptionContext": {
							"shape": "Sb"
						},
						"GrantTokens": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyId": {},
						"Plaintext": {
							"shape": "S13"
						}
					}
				}
			},
			"DeleteAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasName"
					],
					"members": {
						"AliasName": {}
					}
				}
			},
			"DeleteImportedKeyMaterial": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"DescribeKey": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"GrantTokens": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyMetadata": {
							"shape": "Su"
						}
					}
				}
			},
			"DisableKey": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"DisableKeyRotation": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"EnableKey": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"EnableKeyRotation": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				}
			},
			"Encrypt": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"Plaintext"
					],
					"members": {
						"KeyId": {},
						"Plaintext": {
							"shape": "S13"
						},
						"EncryptionContext": {
							"shape": "Sb"
						},
						"GrantTokens": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"KeyId": {}
					}
				}
			},
			"GenerateDataKey": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"EncryptionContext": {
							"shape": "Sb"
						},
						"NumberOfBytes": {
							"type": "integer"
						},
						"KeySpec": {},
						"GrantTokens": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"Plaintext": {
							"shape": "S13"
						},
						"KeyId": {}
					}
				}
			},
			"GenerateDataKeyWithoutPlaintext": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"EncryptionContext": {
							"shape": "Sb"
						},
						"KeySpec": {},
						"NumberOfBytes": {
							"type": "integer"
						},
						"GrantTokens": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"KeyId": {}
					}
				}
			},
			"GenerateRandom": {
				"input": {
					"type": "structure",
					"members": {
						"NumberOfBytes": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Plaintext": {
							"shape": "S13"
						}
					}
				}
			},
			"GetKeyPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"PolicyName"
					],
					"members": {
						"KeyId": {},
						"PolicyName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Policy": {}
					}
				}
			},
			"GetKeyRotationStatus": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyRotationEnabled": {
							"type": "boolean"
						}
					}
				}
			},
			"GetParametersForImport": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"WrappingAlgorithm",
						"WrappingKeySpec"
					],
					"members": {
						"KeyId": {},
						"WrappingAlgorithm": {},
						"WrappingKeySpec": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyId": {},
						"ImportToken": {
							"type": "blob"
						},
						"PublicKey": {
							"shape": "S13"
						},
						"ParametersValidTo": {
							"type": "timestamp"
						}
					}
				}
			},
			"ImportKeyMaterial": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"ImportToken",
						"EncryptedKeyMaterial"
					],
					"members": {
						"KeyId": {},
						"ImportToken": {
							"type": "blob"
						},
						"EncryptedKeyMaterial": {
							"type": "blob"
						},
						"ValidTo": {
							"type": "timestamp"
						},
						"ExpirationModel": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ListAliases": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Aliases": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AliasName": {},
									"AliasArn": {},
									"TargetKeyId": {}
								}
							}
						},
						"NextMarker": {},
						"Truncated": {
							"type": "boolean"
						}
					}
				}
			},
			"ListGrants": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"Limit": {
							"type": "integer"
						},
						"Marker": {},
						"KeyId": {}
					}
				},
				"output": {
					"shape": "S24"
				}
			},
			"ListKeyPolicies": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PolicyNames": {
							"type": "list",
							"member": {}
						},
						"NextMarker": {},
						"Truncated": {
							"type": "boolean"
						}
					}
				}
			},
			"ListKeys": {
				"input": {
					"type": "structure",
					"members": {
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Keys": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"KeyId": {},
									"KeyArn": {}
								}
							}
						},
						"NextMarker": {},
						"Truncated": {
							"type": "boolean"
						}
					}
				}
			},
			"ListResourceTags": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tags": {
							"shape": "Sp"
						},
						"NextMarker": {},
						"Truncated": {
							"type": "boolean"
						}
					}
				}
			},
			"ListRetirableGrants": {
				"input": {
					"type": "structure",
					"required": [
						"RetiringPrincipal"
					],
					"members": {
						"Limit": {
							"type": "integer"
						},
						"Marker": {},
						"RetiringPrincipal": {}
					}
				},
				"output": {
					"shape": "S24"
				}
			},
			"PutKeyPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"PolicyName",
						"Policy"
					],
					"members": {
						"KeyId": {},
						"PolicyName": {},
						"Policy": {},
						"BypassPolicyLockoutSafetyCheck": {
							"type": "boolean"
						}
					}
				}
			},
			"ReEncrypt": {
				"input": {
					"type": "structure",
					"required": [
						"CiphertextBlob",
						"DestinationKeyId"
					],
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"SourceEncryptionContext": {
							"shape": "Sb"
						},
						"DestinationKeyId": {},
						"DestinationEncryptionContext": {
							"shape": "Sb"
						},
						"GrantTokens": {
							"shape": "Se"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CiphertextBlob": {
							"type": "blob"
						},
						"SourceKeyId": {},
						"KeyId": {}
					}
				}
			},
			"RetireGrant": {
				"input": {
					"type": "structure",
					"members": {
						"GrantToken": {},
						"KeyId": {},
						"GrantId": {}
					}
				}
			},
			"RevokeGrant": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"GrantId"
					],
					"members": {
						"KeyId": {},
						"GrantId": {}
					}
				}
			},
			"ScheduleKeyDeletion": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId"
					],
					"members": {
						"KeyId": {},
						"PendingWindowInDays": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"KeyId": {},
						"DeletionDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"TagResource": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"Tags"
					],
					"members": {
						"KeyId": {},
						"Tags": {
							"shape": "Sp"
						}
					}
				}
			},
			"UntagResource": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"TagKeys"
					],
					"members": {
						"KeyId": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"UpdateAlias": {
				"input": {
					"type": "structure",
					"required": [
						"AliasName",
						"TargetKeyId"
					],
					"members": {
						"AliasName": {},
						"TargetKeyId": {}
					}
				}
			},
			"UpdateKeyDescription": {
				"input": {
					"type": "structure",
					"required": [
						"KeyId",
						"Description"
					],
					"members": {
						"KeyId": {},
						"Description": {}
					}
				}
			}
		},
		"shapes": {
			"S8": {
				"type": "list",
				"member": {}
			},
			"Sa": {
				"type": "structure",
				"members": {
					"EncryptionContextSubset": {
						"shape": "Sb"
					},
					"EncryptionContextEquals": {
						"shape": "Sb"
					}
				}
			},
			"Sb": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Se": {
				"type": "list",
				"member": {}
			},
			"Sp": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"TagKey",
						"TagValue"
					],
					"members": {
						"TagKey": {},
						"TagValue": {}
					}
				}
			},
			"Su": {
				"type": "structure",
				"required": [
					"KeyId"
				],
				"members": {
					"AWSAccountId": {},
					"KeyId": {},
					"Arn": {},
					"CreationDate": {
						"type": "timestamp"
					},
					"Enabled": {
						"type": "boolean"
					},
					"Description": {},
					"KeyUsage": {},
					"KeyState": {},
					"DeletionDate": {
						"type": "timestamp"
					},
					"ValidTo": {
						"type": "timestamp"
					},
					"Origin": {},
					"ExpirationModel": {}
				}
			},
			"S13": {
				"type": "blob",
				"sensitive": true
			},
			"S24": {
				"type": "structure",
				"members": {
					"Grants": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"KeyId": {},
								"GrantId": {},
								"Name": {},
								"CreationDate": {
									"type": "timestamp"
								},
								"GranteePrincipal": {},
								"RetiringPrincipal": {},
								"IssuingAccount": {},
								"Operations": {
									"shape": "S8"
								},
								"Constraints": {
									"shape": "Sa"
								}
							}
						}
					},
					"NextMarker": {},
					"Truncated": {
						"type": "boolean"
					}
				}
			}
		}
	};

/***/ },
/* 713 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListAliases": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"more_results": "Truncated",
				"output_token": "NextMarker",
				"result_key": "Aliases"
			},
			"ListGrants": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"more_results": "Truncated",
				"output_token": "NextMarker",
				"result_key": "Grants"
			},
			"ListKeyPolicies": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"more_results": "Truncated",
				"output_token": "NextMarker",
				"result_key": "PolicyNames"
			},
			"ListKeys": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"more_results": "Truncated",
				"output_token": "NextMarker",
				"result_key": "Keys"
			}
		}
	};

/***/ },
/* 714 */
/***/ function(module, exports) {

	module.exports = {
		"metadata": {
			"apiVersion": "2014-11-11",
			"endpointPrefix": "lambda",
			"serviceFullName": "AWS Lambda",
			"signatureVersion": "v4",
			"protocol": "rest-json"
		},
		"operations": {
			"AddEventSource": {
				"http": {
					"requestUri": "/2014-11-13/event-source-mappings/"
				},
				"input": {
					"type": "structure",
					"required": [
						"EventSource",
						"FunctionName",
						"Role"
					],
					"members": {
						"EventSource": {},
						"FunctionName": {},
						"Role": {},
						"BatchSize": {
							"type": "integer"
						},
						"Parameters": {
							"shape": "S6"
						}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"DeleteFunction": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2014-11-13/functions/{FunctionName}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						}
					}
				}
			},
			"GetEventSource": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/event-source-mappings/{UUID}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						}
					}
				},
				"output": {
					"shape": "S7"
				}
			},
			"GetFunction": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/functions/{FunctionName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Configuration": {
							"shape": "Se"
						},
						"Code": {
							"type": "structure",
							"members": {
								"RepositoryType": {},
								"Location": {}
							}
						}
					}
				}
			},
			"GetFunctionConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/functions/{FunctionName}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						}
					}
				},
				"output": {
					"shape": "Se"
				}
			},
			"InvokeAsync": {
				"http": {
					"requestUri": "/2014-11-13/functions/{FunctionName}/invoke-async/",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"InvokeArgs"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"InvokeArgs": {
							"shape": "Sq"
						}
					},
					"payload": "InvokeArgs"
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"location": "statusCode",
							"type": "integer"
						}
					}
				}
			},
			"ListEventSources": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/event-source-mappings/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"EventSourceArn": {
							"location": "querystring",
							"locationName": "EventSource"
						},
						"FunctionName": {
							"location": "querystring",
							"locationName": "FunctionName"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"EventSources": {
							"type": "list",
							"member": {
								"shape": "S7"
							}
						}
					}
				}
			},
			"ListFunctions": {
				"http": {
					"method": "GET",
					"requestUri": "/2014-11-13/functions/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Functions": {
							"type": "list",
							"member": {
								"shape": "Se"
							}
						}
					}
				}
			},
			"RemoveEventSource": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2014-11-13/event-source-mappings/{UUID}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						}
					}
				}
			},
			"UpdateFunctionConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/2014-11-13/functions/{FunctionName}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Role": {
							"location": "querystring",
							"locationName": "Role"
						},
						"Handler": {
							"location": "querystring",
							"locationName": "Handler"
						},
						"Description": {
							"location": "querystring",
							"locationName": "Description"
						},
						"Timeout": {
							"location": "querystring",
							"locationName": "Timeout",
							"type": "integer"
						},
						"MemorySize": {
							"location": "querystring",
							"locationName": "MemorySize",
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "Se"
				}
			},
			"UploadFunction": {
				"http": {
					"method": "PUT",
					"requestUri": "/2014-11-13/functions/{FunctionName}",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"FunctionZip",
						"Runtime",
						"Role",
						"Handler",
						"Mode"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"FunctionZip": {
							"shape": "Sq"
						},
						"Runtime": {
							"location": "querystring",
							"locationName": "Runtime"
						},
						"Role": {
							"location": "querystring",
							"locationName": "Role"
						},
						"Handler": {
							"location": "querystring",
							"locationName": "Handler"
						},
						"Mode": {
							"location": "querystring",
							"locationName": "Mode"
						},
						"Description": {
							"location": "querystring",
							"locationName": "Description"
						},
						"Timeout": {
							"location": "querystring",
							"locationName": "Timeout",
							"type": "integer"
						},
						"MemorySize": {
							"location": "querystring",
							"locationName": "MemorySize",
							"type": "integer"
						}
					},
					"payload": "FunctionZip"
				},
				"output": {
					"shape": "Se"
				}
			}
		},
		"shapes": {
			"S6": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S7": {
				"type": "structure",
				"members": {
					"UUID": {},
					"BatchSize": {
						"type": "integer"
					},
					"EventSource": {},
					"FunctionName": {},
					"Parameters": {
						"shape": "S6"
					},
					"Role": {},
					"LastModified": {
						"type": "timestamp"
					},
					"IsActive": {
						"type": "boolean"
					},
					"Status": {}
				}
			},
			"Se": {
				"type": "structure",
				"members": {
					"FunctionName": {},
					"FunctionARN": {},
					"ConfigurationId": {},
					"Runtime": {},
					"Role": {},
					"Handler": {},
					"Mode": {},
					"CodeSize": {
						"type": "long"
					},
					"Description": {},
					"Timeout": {
						"type": "integer"
					},
					"MemorySize": {
						"type": "integer"
					},
					"LastModified": {
						"type": "timestamp"
					}
				}
			},
			"Sq": {
				"type": "blob",
				"streaming": true
			}
		}
	};

/***/ },
/* 715 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListEventSources": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"limit_key": "MaxItems",
				"result_key": "EventSources"
			},
			"ListFunctions": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"limit_key": "MaxItems",
				"result_key": "Functions"
			}
		}
	};

/***/ },
/* 716 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-03-31",
			"endpointPrefix": "lambda",
			"protocol": "rest-json",
			"serviceFullName": "AWS Lambda",
			"signatureVersion": "v4",
			"uid": "lambda-2015-03-31"
		},
		"operations": {
			"AddPermission": {
				"http": {
					"requestUri": "/2015-03-31/functions/{FunctionName}/policy",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"StatementId",
						"Action",
						"Principal"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"StatementId": {},
						"Action": {},
						"Principal": {},
						"SourceArn": {},
						"SourceAccount": {},
						"EventSourceToken": {},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Statement": {}
					}
				}
			},
			"CreateAlias": {
				"http": {
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Name",
						"FunctionVersion"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Name": {},
						"FunctionVersion": {},
						"Description": {}
					}
				},
				"output": {
					"shape": "Sg"
				}
			},
			"CreateEventSourceMapping": {
				"http": {
					"requestUri": "/2015-03-31/event-source-mappings/",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"EventSourceArn",
						"FunctionName",
						"StartingPosition"
					],
					"members": {
						"EventSourceArn": {},
						"FunctionName": {},
						"Enabled": {
							"type": "boolean"
						},
						"BatchSize": {
							"type": "integer"
						},
						"StartingPosition": {},
						"StartingPositionTimestamp": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"shape": "Sn"
				}
			},
			"CreateFunction": {
				"http": {
					"requestUri": "/2015-03-31/functions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Runtime",
						"Role",
						"Handler",
						"Code"
					],
					"members": {
						"FunctionName": {},
						"Runtime": {},
						"Role": {},
						"Handler": {},
						"Code": {
							"type": "structure",
							"members": {
								"ZipFile": {
									"shape": "St"
								},
								"S3Bucket": {},
								"S3Key": {},
								"S3ObjectVersion": {}
							}
						},
						"Description": {},
						"Timeout": {
							"type": "integer"
						},
						"MemorySize": {
							"type": "integer"
						},
						"Publish": {
							"type": "boolean"
						},
						"VpcConfig": {
							"shape": "S10"
						},
						"DeadLetterConfig": {
							"shape": "S15"
						},
						"Environment": {
							"shape": "S17"
						},
						"KMSKeyArn": {}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"DeleteAlias": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Name"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Name": {
							"location": "uri",
							"locationName": "Name"
						}
					}
				}
			},
			"DeleteEventSourceMapping": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-03-31/event-source-mappings/{UUID}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						}
					}
				},
				"output": {
					"shape": "Sn"
				}
			},
			"DeleteFunction": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-03-31/functions/{FunctionName}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				}
			},
			"GetAccountSettings": {
				"http": {
					"method": "GET",
					"requestUri": "/2016-08-19/account-settings/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountLimit": {
							"type": "structure",
							"members": {
								"TotalCodeSize": {
									"type": "long"
								},
								"CodeSizeUnzipped": {
									"type": "long"
								},
								"CodeSizeZipped": {
									"type": "long"
								},
								"ConcurrentExecutions": {
									"type": "integer"
								}
							}
						},
						"AccountUsage": {
							"type": "structure",
							"members": {
								"TotalCodeSize": {
									"type": "long"
								},
								"FunctionCount": {
									"type": "long"
								}
							}
						}
					}
				}
			},
			"GetAlias": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Name"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Name": {
							"location": "uri",
							"locationName": "Name"
						}
					}
				},
				"output": {
					"shape": "Sg"
				}
			},
			"GetEventSourceMapping": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/event-source-mappings/{UUID}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						}
					}
				},
				"output": {
					"shape": "Sn"
				}
			},
			"GetFunction": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Configuration": {
							"shape": "S1c"
						},
						"Code": {
							"type": "structure",
							"members": {
								"RepositoryType": {},
								"Location": {}
							}
						}
					}
				}
			},
			"GetFunctionConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"GetPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/policy",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Policy": {}
					}
				}
			},
			"Invoke": {
				"http": {
					"requestUri": "/2015-03-31/functions/{FunctionName}/invocations"
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"InvocationType": {
							"location": "header",
							"locationName": "X-Amz-Invocation-Type"
						},
						"LogType": {
							"location": "header",
							"locationName": "X-Amz-Log-Type"
						},
						"ClientContext": {
							"location": "header",
							"locationName": "X-Amz-Client-Context"
						},
						"Payload": {
							"shape": "St"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					},
					"payload": "Payload"
				},
				"output": {
					"type": "structure",
					"members": {
						"StatusCode": {
							"location": "statusCode",
							"type": "integer"
						},
						"FunctionError": {
							"location": "header",
							"locationName": "X-Amz-Function-Error"
						},
						"LogResult": {
							"location": "header",
							"locationName": "X-Amz-Log-Result"
						},
						"Payload": {
							"shape": "St"
						}
					},
					"payload": "Payload"
				}
			},
			"InvokeAsync": {
				"http": {
					"requestUri": "/2014-11-13/functions/{FunctionName}/invoke-async/",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"InvokeArgs"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"InvokeArgs": {
							"type": "blob",
							"streaming": true
						}
					},
					"deprecated": true,
					"payload": "InvokeArgs"
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {
							"location": "statusCode",
							"type": "integer"
						}
					},
					"deprecated": true
				},
				"deprecated": true
			},
			"ListAliases": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"FunctionVersion": {
							"location": "querystring",
							"locationName": "FunctionVersion"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Aliases": {
							"type": "list",
							"member": {
								"shape": "Sg"
							}
						}
					}
				}
			},
			"ListEventSourceMappings": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/event-source-mappings/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"EventSourceArn": {
							"location": "querystring",
							"locationName": "EventSourceArn"
						},
						"FunctionName": {
							"location": "querystring",
							"locationName": "FunctionName"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"EventSourceMappings": {
							"type": "list",
							"member": {
								"shape": "Sn"
							}
						}
					}
				}
			},
			"ListFunctions": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Functions": {
							"shape": "S2h"
						}
					}
				}
			},
			"ListVersionsByFunction": {
				"http": {
					"method": "GET",
					"requestUri": "/2015-03-31/functions/{FunctionName}/versions",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "Marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "MaxItems",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Versions": {
							"shape": "S2h"
						}
					}
				}
			},
			"PublishVersion": {
				"http": {
					"requestUri": "/2015-03-31/functions/{FunctionName}/versions",
					"responseCode": 201
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"CodeSha256": {},
						"Description": {}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"RemovePermission": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2015-03-31/functions/{FunctionName}/policy/{StatementId}",
					"responseCode": 204
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"StatementId"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"StatementId": {
							"location": "uri",
							"locationName": "StatementId"
						},
						"Qualifier": {
							"location": "querystring",
							"locationName": "Qualifier"
						}
					}
				}
			},
			"UpdateAlias": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-03-31/functions/{FunctionName}/aliases/{Name}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName",
						"Name"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Name": {
							"location": "uri",
							"locationName": "Name"
						},
						"FunctionVersion": {},
						"Description": {}
					}
				},
				"output": {
					"shape": "Sg"
				}
			},
			"UpdateEventSourceMapping": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-03-31/event-source-mappings/{UUID}",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"UUID"
					],
					"members": {
						"UUID": {
							"location": "uri",
							"locationName": "UUID"
						},
						"FunctionName": {},
						"Enabled": {
							"type": "boolean"
						},
						"BatchSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"shape": "Sn"
				}
			},
			"UpdateFunctionCode": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-03-31/functions/{FunctionName}/code",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"ZipFile": {
							"shape": "St"
						},
						"S3Bucket": {},
						"S3Key": {},
						"S3ObjectVersion": {},
						"Publish": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"shape": "S1c"
				}
			},
			"UpdateFunctionConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/2015-03-31/functions/{FunctionName}/configuration",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"FunctionName"
					],
					"members": {
						"FunctionName": {
							"location": "uri",
							"locationName": "FunctionName"
						},
						"Role": {},
						"Handler": {},
						"Description": {},
						"Timeout": {
							"type": "integer"
						},
						"MemorySize": {
							"type": "integer"
						},
						"VpcConfig": {
							"shape": "S10"
						},
						"Environment": {
							"shape": "S17"
						},
						"Runtime": {},
						"DeadLetterConfig": {
							"shape": "S15"
						},
						"KMSKeyArn": {}
					}
				},
				"output": {
					"shape": "S1c"
				}
			}
		},
		"shapes": {
			"Sg": {
				"type": "structure",
				"members": {
					"AliasArn": {},
					"Name": {},
					"FunctionVersion": {},
					"Description": {}
				}
			},
			"Sn": {
				"type": "structure",
				"members": {
					"UUID": {},
					"BatchSize": {
						"type": "integer"
					},
					"EventSourceArn": {},
					"FunctionArn": {},
					"LastModified": {
						"type": "timestamp"
					},
					"LastProcessingResult": {},
					"State": {},
					"StateTransitionReason": {}
				}
			},
			"St": {
				"type": "blob",
				"sensitive": true
			},
			"S10": {
				"type": "structure",
				"members": {
					"SubnetIds": {
						"shape": "S11"
					},
					"SecurityGroupIds": {
						"shape": "S13"
					}
				}
			},
			"S11": {
				"type": "list",
				"member": {}
			},
			"S13": {
				"type": "list",
				"member": {}
			},
			"S15": {
				"type": "structure",
				"members": {
					"TargetArn": {}
				}
			},
			"S17": {
				"type": "structure",
				"members": {
					"Variables": {
						"shape": "S18"
					}
				}
			},
			"S18": {
				"type": "map",
				"key": {
					"type": "string",
					"sensitive": true
				},
				"value": {
					"type": "string",
					"sensitive": true
				},
				"sensitive": true
			},
			"S1c": {
				"type": "structure",
				"members": {
					"FunctionName": {},
					"FunctionArn": {},
					"Runtime": {},
					"Role": {},
					"Handler": {},
					"CodeSize": {
						"type": "long"
					},
					"Description": {},
					"Timeout": {
						"type": "integer"
					},
					"MemorySize": {
						"type": "integer"
					},
					"LastModified": {},
					"CodeSha256": {},
					"Version": {},
					"VpcConfig": {
						"type": "structure",
						"members": {
							"SubnetIds": {
								"shape": "S11"
							},
							"SecurityGroupIds": {
								"shape": "S13"
							},
							"VpcId": {}
						}
					},
					"DeadLetterConfig": {
						"shape": "S15"
					},
					"Environment": {
						"type": "structure",
						"members": {
							"Variables": {
								"shape": "S18"
							},
							"Error": {
								"type": "structure",
								"members": {
									"ErrorCode": {},
									"Message": {
										"type": "string",
										"sensitive": true
									}
								}
							}
						}
					},
					"KMSKeyArn": {}
				}
			},
			"S2h": {
				"type": "list",
				"member": {
					"shape": "S1c"
				}
			}
		}
	};

/***/ },
/* 717 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListEventSourceMappings": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"limit_key": "MaxItems",
				"result_key": "EventSourceMappings"
			},
			"ListFunctions": {
				"input_token": "Marker",
				"output_token": "NextMarker",
				"limit_key": "MaxItems",
				"result_key": "Functions"
			}
		}
	};

/***/ },
/* 718 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-03-28",
			"endpointPrefix": "logs",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon CloudWatch Logs",
			"signatureVersion": "v4",
			"targetPrefix": "Logs_20140328",
			"uid": "logs-2014-03-28"
		},
		"operations": {
			"CancelExportTask": {
				"input": {
					"type": "structure",
					"required": [
						"taskId"
					],
					"members": {
						"taskId": {}
					}
				}
			},
			"CreateExportTask": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"from",
						"to",
						"destination"
					],
					"members": {
						"taskName": {},
						"logGroupName": {},
						"logStreamNamePrefix": {},
						"from": {
							"type": "long"
						},
						"to": {
							"type": "long"
						},
						"destination": {},
						"destinationPrefix": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"taskId": {}
					}
				}
			},
			"CreateLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {},
						"tags": {
							"shape": "Sc"
						}
					}
				}
			},
			"CreateLogStream": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"logStreamName"
					],
					"members": {
						"logGroupName": {},
						"logStreamName": {}
					}
				}
			},
			"DeleteDestination": {
				"input": {
					"type": "structure",
					"required": [
						"destinationName"
					],
					"members": {
						"destinationName": {}
					}
				}
			},
			"DeleteLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {}
					}
				}
			},
			"DeleteLogStream": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"logStreamName"
					],
					"members": {
						"logGroupName": {},
						"logStreamName": {}
					}
				}
			},
			"DeleteMetricFilter": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"filterName"
					],
					"members": {
						"logGroupName": {},
						"filterName": {}
					}
				}
			},
			"DeleteRetentionPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {}
					}
				}
			},
			"DeleteSubscriptionFilter": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"filterName"
					],
					"members": {
						"logGroupName": {},
						"filterName": {}
					}
				}
			},
			"DescribeDestinations": {
				"input": {
					"type": "structure",
					"members": {
						"DestinationNamePrefix": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"destinations": {
							"type": "list",
							"member": {
								"shape": "St"
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeExportTasks": {
				"input": {
					"type": "structure",
					"members": {
						"taskId": {},
						"statusCode": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"exportTasks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"taskId": {},
									"taskName": {},
									"logGroupName": {},
									"from": {
										"type": "long"
									},
									"to": {
										"type": "long"
									},
									"destination": {},
									"destinationPrefix": {},
									"status": {
										"type": "structure",
										"members": {
											"code": {},
											"message": {}
										}
									},
									"executionInfo": {
										"type": "structure",
										"members": {
											"creationTime": {
												"type": "long"
											},
											"completionTime": {
												"type": "long"
											}
										}
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeLogGroups": {
				"input": {
					"type": "structure",
					"members": {
						"logGroupNamePrefix": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"logGroups": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"logGroupName": {},
									"creationTime": {
										"type": "long"
									},
									"retentionInDays": {
										"type": "integer"
									},
									"metricFilterCount": {
										"type": "integer"
									},
									"arn": {},
									"storedBytes": {
										"type": "long"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeLogStreams": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {},
						"logStreamNamePrefix": {},
						"orderBy": {},
						"descending": {
							"type": "boolean"
						},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"logStreams": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"logStreamName": {},
									"creationTime": {
										"type": "long"
									},
									"firstEventTimestamp": {
										"type": "long"
									},
									"lastEventTimestamp": {
										"type": "long"
									},
									"lastIngestionTime": {
										"type": "long"
									},
									"uploadSequenceToken": {},
									"arn": {},
									"storedBytes": {
										"type": "long"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeMetricFilters": {
				"input": {
					"type": "structure",
					"members": {
						"logGroupName": {},
						"filterNamePrefix": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						},
						"metricName": {},
						"metricNamespace": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"metricFilters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"filterName": {},
									"filterPattern": {},
									"metricTransformations": {
										"shape": "S1r"
									},
									"creationTime": {
										"type": "long"
									},
									"logGroupName": {}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"DescribeSubscriptionFilters": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {},
						"filterNamePrefix": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"subscriptionFilters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"filterName": {},
									"logGroupName": {},
									"filterPattern": {},
									"destinationArn": {},
									"roleArn": {},
									"distribution": {},
									"creationTime": {
										"type": "long"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"FilterLogEvents": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {},
						"logStreamNames": {
							"type": "list",
							"member": {}
						},
						"startTime": {
							"type": "long"
						},
						"endTime": {
							"type": "long"
						},
						"filterPattern": {},
						"nextToken": {},
						"limit": {
							"type": "integer"
						},
						"interleaved": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"logStreamName": {},
									"timestamp": {
										"type": "long"
									},
									"message": {},
									"ingestionTime": {
										"type": "long"
									},
									"eventId": {}
								}
							}
						},
						"searchedLogStreams": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"logStreamName": {},
									"searchedCompletely": {
										"type": "boolean"
									}
								}
							}
						},
						"nextToken": {}
					}
				}
			},
			"GetLogEvents": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"logStreamName"
					],
					"members": {
						"logGroupName": {},
						"logStreamName": {},
						"startTime": {
							"type": "long"
						},
						"endTime": {
							"type": "long"
						},
						"nextToken": {},
						"limit": {
							"type": "integer"
						},
						"startFromHead": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"events": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"timestamp": {
										"type": "long"
									},
									"message": {},
									"ingestionTime": {
										"type": "long"
									}
								}
							}
						},
						"nextForwardToken": {},
						"nextBackwardToken": {}
					}
				}
			},
			"ListTagsLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName"
					],
					"members": {
						"logGroupName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"tags": {
							"shape": "Sc"
						}
					}
				}
			},
			"PutDestination": {
				"input": {
					"type": "structure",
					"required": [
						"destinationName",
						"targetArn",
						"roleArn"
					],
					"members": {
						"destinationName": {},
						"targetArn": {},
						"roleArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"destination": {
							"shape": "St"
						}
					}
				}
			},
			"PutDestinationPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"destinationName",
						"accessPolicy"
					],
					"members": {
						"destinationName": {},
						"accessPolicy": {}
					}
				}
			},
			"PutLogEvents": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"logStreamName",
						"logEvents"
					],
					"members": {
						"logGroupName": {},
						"logStreamName": {},
						"logEvents": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"timestamp",
									"message"
								],
								"members": {
									"timestamp": {
										"type": "long"
									},
									"message": {}
								}
							}
						},
						"sequenceToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"nextSequenceToken": {},
						"rejectedLogEventsInfo": {
							"type": "structure",
							"members": {
								"tooNewLogEventStartIndex": {
									"type": "integer"
								},
								"tooOldLogEventEndIndex": {
									"type": "integer"
								},
								"expiredLogEventEndIndex": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"PutMetricFilter": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"filterName",
						"filterPattern",
						"metricTransformations"
					],
					"members": {
						"logGroupName": {},
						"filterName": {},
						"filterPattern": {},
						"metricTransformations": {
							"shape": "S1r"
						}
					}
				}
			},
			"PutRetentionPolicy": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"retentionInDays"
					],
					"members": {
						"logGroupName": {},
						"retentionInDays": {
							"type": "integer"
						}
					}
				}
			},
			"PutSubscriptionFilter": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"filterName",
						"filterPattern",
						"destinationArn"
					],
					"members": {
						"logGroupName": {},
						"filterName": {},
						"filterPattern": {},
						"destinationArn": {},
						"roleArn": {},
						"distribution": {}
					}
				}
			},
			"TagLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"tags"
					],
					"members": {
						"logGroupName": {},
						"tags": {
							"shape": "Sc"
						}
					}
				}
			},
			"TestMetricFilter": {
				"input": {
					"type": "structure",
					"required": [
						"filterPattern",
						"logEventMessages"
					],
					"members": {
						"filterPattern": {},
						"logEventMessages": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"matches": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"eventNumber": {
										"type": "long"
									},
									"eventMessage": {},
									"extractedValues": {
										"type": "map",
										"key": {},
										"value": {}
									}
								}
							}
						}
					}
				}
			},
			"UntagLogGroup": {
				"input": {
					"type": "structure",
					"required": [
						"logGroupName",
						"tags"
					],
					"members": {
						"logGroupName": {},
						"tags": {
							"type": "list",
							"member": {}
						}
					}
				}
			}
		},
		"shapes": {
			"Sc": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"St": {
				"type": "structure",
				"members": {
					"destinationName": {},
					"targetArn": {},
					"roleArn": {},
					"accessPolicy": {},
					"arn": {},
					"creationTime": {
						"type": "long"
					}
				}
			},
			"S1r": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"metricName",
						"metricNamespace",
						"metricValue"
					],
					"members": {
						"metricName": {},
						"metricNamespace": {},
						"metricValue": {},
						"defaultValue": {
							"type": "double"
						}
					}
				}
			}
		}
	};

/***/ },
/* 719 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDestinations": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "limit",
				"result_key": "destinations"
			},
			"DescribeLogGroups": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "limit",
				"result_key": "logGroups"
			},
			"DescribeLogStreams": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "limit",
				"result_key": "logStreams"
			},
			"DescribeMetricFilters": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "limit",
				"result_key": "metricFilters"
			},
			"DescribeSubscriptionFilters": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "limit",
				"result_key": "subscriptionFilters"
			},
			"FilterLogEvents": {
				"input_token": "nextToken",
				"output_token": "nextToken",
				"limit_key": "limit",
				"result_key": [
					"events",
					"searchedLogStreams"
				]
			},
			"GetLogEvents": {
				"input_token": "nextToken",
				"output_token": "nextForwardToken",
				"limit_key": "limit",
				"result_key": "events"
			}
		}
	};

/***/ },
/* 720 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "machinelearning-2014-12-12",
			"apiVersion": "2014-12-12",
			"endpointPrefix": "machinelearning",
			"jsonVersion": "1.1",
			"serviceFullName": "Amazon Machine Learning",
			"signatureVersion": "v4",
			"targetPrefix": "AmazonML_20141212",
			"protocol": "json"
		},
		"operations": {
			"AddTags": {
				"input": {
					"type": "structure",
					"required": [
						"Tags",
						"ResourceId",
						"ResourceType"
					],
					"members": {
						"Tags": {
							"shape": "S2"
						},
						"ResourceId": {},
						"ResourceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceId": {},
						"ResourceType": {}
					}
				}
			},
			"CreateBatchPrediction": {
				"input": {
					"type": "structure",
					"required": [
						"BatchPredictionId",
						"MLModelId",
						"BatchPredictionDataSourceId",
						"OutputUri"
					],
					"members": {
						"BatchPredictionId": {},
						"BatchPredictionName": {},
						"MLModelId": {},
						"BatchPredictionDataSourceId": {},
						"OutputUri": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BatchPredictionId": {}
					}
				}
			},
			"CreateDataSourceFromRDS": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId",
						"RDSData",
						"RoleARN"
					],
					"members": {
						"DataSourceId": {},
						"DataSourceName": {},
						"RDSData": {
							"type": "structure",
							"required": [
								"DatabaseInformation",
								"SelectSqlQuery",
								"DatabaseCredentials",
								"S3StagingLocation",
								"ResourceRole",
								"ServiceRole",
								"SubnetId",
								"SecurityGroupIds"
							],
							"members": {
								"DatabaseInformation": {
									"shape": "Sf"
								},
								"SelectSqlQuery": {},
								"DatabaseCredentials": {
									"type": "structure",
									"required": [
										"Username",
										"Password"
									],
									"members": {
										"Username": {},
										"Password": {}
									}
								},
								"S3StagingLocation": {},
								"DataRearrangement": {},
								"DataSchema": {},
								"DataSchemaUri": {},
								"ResourceRole": {},
								"ServiceRole": {},
								"SubnetId": {},
								"SecurityGroupIds": {
									"type": "list",
									"member": {}
								}
							}
						},
						"RoleARN": {},
						"ComputeStatistics": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"CreateDataSourceFromRedshift": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId",
						"DataSpec",
						"RoleARN"
					],
					"members": {
						"DataSourceId": {},
						"DataSourceName": {},
						"DataSpec": {
							"type": "structure",
							"required": [
								"DatabaseInformation",
								"SelectSqlQuery",
								"DatabaseCredentials",
								"S3StagingLocation"
							],
							"members": {
								"DatabaseInformation": {
									"shape": "Sy"
								},
								"SelectSqlQuery": {},
								"DatabaseCredentials": {
									"type": "structure",
									"required": [
										"Username",
										"Password"
									],
									"members": {
										"Username": {},
										"Password": {}
									}
								},
								"S3StagingLocation": {},
								"DataRearrangement": {},
								"DataSchema": {},
								"DataSchemaUri": {}
							}
						},
						"RoleARN": {},
						"ComputeStatistics": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"CreateDataSourceFromS3": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId",
						"DataSpec"
					],
					"members": {
						"DataSourceId": {},
						"DataSourceName": {},
						"DataSpec": {
							"type": "structure",
							"required": [
								"DataLocationS3"
							],
							"members": {
								"DataLocationS3": {},
								"DataRearrangement": {},
								"DataSchema": {},
								"DataSchemaLocationS3": {}
							}
						},
						"ComputeStatistics": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"CreateEvaluation": {
				"input": {
					"type": "structure",
					"required": [
						"EvaluationId",
						"MLModelId",
						"EvaluationDataSourceId"
					],
					"members": {
						"EvaluationId": {},
						"EvaluationName": {},
						"MLModelId": {},
						"EvaluationDataSourceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationId": {}
					}
				}
			},
			"CreateMLModel": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId",
						"MLModelType",
						"TrainingDataSourceId"
					],
					"members": {
						"MLModelId": {},
						"MLModelName": {},
						"MLModelType": {},
						"Parameters": {
							"shape": "S1d"
						},
						"TrainingDataSourceId": {},
						"Recipe": {},
						"RecipeUri": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {}
					}
				}
			},
			"CreateRealtimeEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {},
						"RealtimeEndpointInfo": {
							"shape": "S1j"
						}
					}
				}
			},
			"DeleteBatchPrediction": {
				"input": {
					"type": "structure",
					"required": [
						"BatchPredictionId"
					],
					"members": {
						"BatchPredictionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BatchPredictionId": {}
					}
				}
			},
			"DeleteDataSource": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId"
					],
					"members": {
						"DataSourceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"DeleteEvaluation": {
				"input": {
					"type": "structure",
					"required": [
						"EvaluationId"
					],
					"members": {
						"EvaluationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationId": {}
					}
				}
			},
			"DeleteMLModel": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {}
					}
				}
			},
			"DeleteRealtimeEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {},
						"RealtimeEndpointInfo": {
							"shape": "S1j"
						}
					}
				}
			},
			"DeleteTags": {
				"input": {
					"type": "structure",
					"required": [
						"TagKeys",
						"ResourceId",
						"ResourceType"
					],
					"members": {
						"TagKeys": {
							"type": "list",
							"member": {}
						},
						"ResourceId": {},
						"ResourceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceId": {},
						"ResourceType": {}
					}
				}
			},
			"DescribeBatchPredictions": {
				"input": {
					"type": "structure",
					"members": {
						"FilterVariable": {},
						"EQ": {},
						"GT": {},
						"LT": {},
						"GE": {},
						"LE": {},
						"NE": {},
						"Prefix": {},
						"SortOrder": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Results": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"BatchPredictionId": {},
									"MLModelId": {},
									"BatchPredictionDataSourceId": {},
									"InputDataLocationS3": {},
									"CreatedByIamUser": {},
									"CreatedAt": {
										"type": "timestamp"
									},
									"LastUpdatedAt": {
										"type": "timestamp"
									},
									"Name": {},
									"Status": {},
									"OutputUri": {},
									"Message": {},
									"ComputeTime": {
										"type": "long"
									},
									"FinishedAt": {
										"type": "timestamp"
									},
									"StartedAt": {
										"type": "timestamp"
									},
									"TotalRecordCount": {
										"type": "long"
									},
									"InvalidRecordCount": {
										"type": "long"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeDataSources": {
				"input": {
					"type": "structure",
					"members": {
						"FilterVariable": {},
						"EQ": {},
						"GT": {},
						"LT": {},
						"GE": {},
						"LE": {},
						"NE": {},
						"Prefix": {},
						"SortOrder": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Results": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DataSourceId": {},
									"DataLocationS3": {},
									"DataRearrangement": {},
									"CreatedByIamUser": {},
									"CreatedAt": {
										"type": "timestamp"
									},
									"LastUpdatedAt": {
										"type": "timestamp"
									},
									"DataSizeInBytes": {
										"type": "long"
									},
									"NumberOfFiles": {
										"type": "long"
									},
									"Name": {},
									"Status": {},
									"Message": {},
									"RedshiftMetadata": {
										"shape": "S2i"
									},
									"RDSMetadata": {
										"shape": "S2j"
									},
									"RoleARN": {},
									"ComputeStatistics": {
										"type": "boolean"
									},
									"ComputeTime": {
										"type": "long"
									},
									"FinishedAt": {
										"type": "timestamp"
									},
									"StartedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeEvaluations": {
				"input": {
					"type": "structure",
					"members": {
						"FilterVariable": {},
						"EQ": {},
						"GT": {},
						"LT": {},
						"GE": {},
						"LE": {},
						"NE": {},
						"Prefix": {},
						"SortOrder": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Results": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EvaluationId": {},
									"MLModelId": {},
									"EvaluationDataSourceId": {},
									"InputDataLocationS3": {},
									"CreatedByIamUser": {},
									"CreatedAt": {
										"type": "timestamp"
									},
									"LastUpdatedAt": {
										"type": "timestamp"
									},
									"Name": {},
									"Status": {},
									"PerformanceMetrics": {
										"shape": "S2q"
									},
									"Message": {},
									"ComputeTime": {
										"type": "long"
									},
									"FinishedAt": {
										"type": "timestamp"
									},
									"StartedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMLModels": {
				"input": {
					"type": "structure",
					"members": {
						"FilterVariable": {},
						"EQ": {},
						"GT": {},
						"LT": {},
						"GE": {},
						"LE": {},
						"NE": {},
						"Prefix": {},
						"SortOrder": {},
						"NextToken": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Results": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"MLModelId": {},
									"TrainingDataSourceId": {},
									"CreatedByIamUser": {},
									"CreatedAt": {
										"type": "timestamp"
									},
									"LastUpdatedAt": {
										"type": "timestamp"
									},
									"Name": {},
									"Status": {},
									"SizeInBytes": {
										"type": "long"
									},
									"EndpointInfo": {
										"shape": "S1j"
									},
									"TrainingParameters": {
										"shape": "S1d"
									},
									"InputDataLocationS3": {},
									"Algorithm": {},
									"MLModelType": {},
									"ScoreThreshold": {
										"type": "float"
									},
									"ScoreThresholdLastUpdatedAt": {
										"type": "timestamp"
									},
									"Message": {},
									"ComputeTime": {
										"type": "long"
									},
									"FinishedAt": {
										"type": "timestamp"
									},
									"StartedAt": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceId",
						"ResourceType"
					],
					"members": {
						"ResourceId": {},
						"ResourceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceId": {},
						"ResourceType": {},
						"Tags": {
							"shape": "S2"
						}
					}
				}
			},
			"GetBatchPrediction": {
				"input": {
					"type": "structure",
					"required": [
						"BatchPredictionId"
					],
					"members": {
						"BatchPredictionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BatchPredictionId": {},
						"MLModelId": {},
						"BatchPredictionDataSourceId": {},
						"InputDataLocationS3": {},
						"CreatedByIamUser": {},
						"CreatedAt": {
							"type": "timestamp"
						},
						"LastUpdatedAt": {
							"type": "timestamp"
						},
						"Name": {},
						"Status": {},
						"OutputUri": {},
						"LogUri": {},
						"Message": {},
						"ComputeTime": {
							"type": "long"
						},
						"FinishedAt": {
							"type": "timestamp"
						},
						"StartedAt": {
							"type": "timestamp"
						},
						"TotalRecordCount": {
							"type": "long"
						},
						"InvalidRecordCount": {
							"type": "long"
						}
					}
				}
			},
			"GetDataSource": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId"
					],
					"members": {
						"DataSourceId": {},
						"Verbose": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {},
						"DataLocationS3": {},
						"DataRearrangement": {},
						"CreatedByIamUser": {},
						"CreatedAt": {
							"type": "timestamp"
						},
						"LastUpdatedAt": {
							"type": "timestamp"
						},
						"DataSizeInBytes": {
							"type": "long"
						},
						"NumberOfFiles": {
							"type": "long"
						},
						"Name": {},
						"Status": {},
						"LogUri": {},
						"Message": {},
						"RedshiftMetadata": {
							"shape": "S2i"
						},
						"RDSMetadata": {
							"shape": "S2j"
						},
						"RoleARN": {},
						"ComputeStatistics": {
							"type": "boolean"
						},
						"ComputeTime": {
							"type": "long"
						},
						"FinishedAt": {
							"type": "timestamp"
						},
						"StartedAt": {
							"type": "timestamp"
						},
						"DataSourceSchema": {}
					}
				}
			},
			"GetEvaluation": {
				"input": {
					"type": "structure",
					"required": [
						"EvaluationId"
					],
					"members": {
						"EvaluationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationId": {},
						"MLModelId": {},
						"EvaluationDataSourceId": {},
						"InputDataLocationS3": {},
						"CreatedByIamUser": {},
						"CreatedAt": {
							"type": "timestamp"
						},
						"LastUpdatedAt": {
							"type": "timestamp"
						},
						"Name": {},
						"Status": {},
						"PerformanceMetrics": {
							"shape": "S2q"
						},
						"LogUri": {},
						"Message": {},
						"ComputeTime": {
							"type": "long"
						},
						"FinishedAt": {
							"type": "timestamp"
						},
						"StartedAt": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetMLModel": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {},
						"Verbose": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {},
						"TrainingDataSourceId": {},
						"CreatedByIamUser": {},
						"CreatedAt": {
							"type": "timestamp"
						},
						"LastUpdatedAt": {
							"type": "timestamp"
						},
						"Name": {},
						"Status": {},
						"SizeInBytes": {
							"type": "long"
						},
						"EndpointInfo": {
							"shape": "S1j"
						},
						"TrainingParameters": {
							"shape": "S1d"
						},
						"InputDataLocationS3": {},
						"MLModelType": {},
						"ScoreThreshold": {
							"type": "float"
						},
						"ScoreThresholdLastUpdatedAt": {
							"type": "timestamp"
						},
						"LogUri": {},
						"Message": {},
						"ComputeTime": {
							"type": "long"
						},
						"FinishedAt": {
							"type": "timestamp"
						},
						"StartedAt": {
							"type": "timestamp"
						},
						"Recipe": {},
						"Schema": {}
					}
				}
			},
			"Predict": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId",
						"Record",
						"PredictEndpoint"
					],
					"members": {
						"MLModelId": {},
						"Record": {
							"type": "map",
							"key": {},
							"value": {}
						},
						"PredictEndpoint": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Prediction": {
							"type": "structure",
							"members": {
								"predictedLabel": {},
								"predictedValue": {
									"type": "float"
								},
								"predictedScores": {
									"type": "map",
									"key": {},
									"value": {
										"type": "float"
									}
								},
								"details": {
									"type": "map",
									"key": {},
									"value": {}
								}
							}
						}
					}
				}
			},
			"UpdateBatchPrediction": {
				"input": {
					"type": "structure",
					"required": [
						"BatchPredictionId",
						"BatchPredictionName"
					],
					"members": {
						"BatchPredictionId": {},
						"BatchPredictionName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BatchPredictionId": {}
					}
				}
			},
			"UpdateDataSource": {
				"input": {
					"type": "structure",
					"required": [
						"DataSourceId",
						"DataSourceName"
					],
					"members": {
						"DataSourceId": {},
						"DataSourceName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DataSourceId": {}
					}
				}
			},
			"UpdateEvaluation": {
				"input": {
					"type": "structure",
					"required": [
						"EvaluationId",
						"EvaluationName"
					],
					"members": {
						"EvaluationId": {},
						"EvaluationName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EvaluationId": {}
					}
				}
			},
			"UpdateMLModel": {
				"input": {
					"type": "structure",
					"required": [
						"MLModelId"
					],
					"members": {
						"MLModelId": {},
						"MLModelName": {},
						"ScoreThreshold": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MLModelId": {}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sf": {
				"type": "structure",
				"required": [
					"InstanceIdentifier",
					"DatabaseName"
				],
				"members": {
					"InstanceIdentifier": {},
					"DatabaseName": {}
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"DatabaseName",
					"ClusterIdentifier"
				],
				"members": {
					"DatabaseName": {},
					"ClusterIdentifier": {}
				}
			},
			"S1d": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1j": {
				"type": "structure",
				"members": {
					"PeakRequestsPerSecond": {
						"type": "integer"
					},
					"CreatedAt": {
						"type": "timestamp"
					},
					"EndpointUrl": {},
					"EndpointStatus": {}
				}
			},
			"S2i": {
				"type": "structure",
				"members": {
					"RedshiftDatabase": {
						"shape": "Sy"
					},
					"DatabaseUserName": {},
					"SelectSqlQuery": {}
				}
			},
			"S2j": {
				"type": "structure",
				"members": {
					"Database": {
						"shape": "Sf"
					},
					"DatabaseUserName": {},
					"SelectSqlQuery": {},
					"ResourceRole": {},
					"ServiceRole": {},
					"DataPipelineId": {}
				}
			},
			"S2q": {
				"type": "structure",
				"members": {
					"Properties": {
						"type": "map",
						"key": {},
						"value": {}
					}
				}
			}
		},
		"examples": {}
	};

/***/ },
/* 721 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeBatchPredictions": {
				"limit_key": "Limit",
				"output_token": "NextToken",
				"input_token": "NextToken",
				"result_key": "Results"
			},
			"DescribeDataSources": {
				"limit_key": "Limit",
				"output_token": "NextToken",
				"input_token": "NextToken",
				"result_key": "Results"
			},
			"DescribeEvaluations": {
				"limit_key": "Limit",
				"output_token": "NextToken",
				"input_token": "NextToken",
				"result_key": "Results"
			},
			"DescribeMLModels": {
				"limit_key": "Limit",
				"output_token": "NextToken",
				"input_token": "NextToken",
				"result_key": "Results"
			}
		}
	};

/***/ },
/* 722 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DataSourceAvailable": {
				"delay": 30,
				"operation": "DescribeDataSources",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "COMPLETED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Results[].Status"
					},
					{
						"expected": "FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Results[].Status"
					}
				]
			},
			"MLModelAvailable": {
				"delay": 30,
				"operation": "DescribeMLModels",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "COMPLETED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Results[].Status"
					},
					{
						"expected": "FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Results[].Status"
					}
				]
			},
			"EvaluationAvailable": {
				"delay": 30,
				"operation": "DescribeEvaluations",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "COMPLETED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Results[].Status"
					},
					{
						"expected": "FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Results[].Status"
					}
				]
			},
			"BatchPredictionAvailable": {
				"delay": 30,
				"operation": "DescribeBatchPredictions",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "COMPLETED",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Results[].Status"
					},
					{
						"expected": "FAILED",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Results[].Status"
					}
				]
			}
		}
	};

/***/ },
/* 723 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2015-07-01",
			"endpointPrefix": "marketplacecommerceanalytics",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Marketplace Commerce Analytics",
			"signatureVersion": "v4",
			"signingName": "marketplacecommerceanalytics",
			"targetPrefix": "MarketplaceCommerceAnalytics20150701",
			"uid": "marketplacecommerceanalytics-2015-07-01"
		},
		"operations": {
			"GenerateDataSet": {
				"input": {
					"type": "structure",
					"required": [
						"dataSetType",
						"dataSetPublicationDate",
						"roleNameArn",
						"destinationS3BucketName",
						"snsTopicArn"
					],
					"members": {
						"dataSetType": {},
						"dataSetPublicationDate": {
							"type": "timestamp"
						},
						"roleNameArn": {},
						"destinationS3BucketName": {},
						"destinationS3Prefix": {},
						"snsTopicArn": {},
						"customerDefinedValues": {
							"shape": "S8"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"dataSetRequestId": {}
					}
				}
			},
			"StartSupportDataExport": {
				"input": {
					"type": "structure",
					"required": [
						"dataSetType",
						"fromDate",
						"roleNameArn",
						"destinationS3BucketName",
						"snsTopicArn"
					],
					"members": {
						"dataSetType": {},
						"fromDate": {
							"type": "timestamp"
						},
						"roleNameArn": {},
						"destinationS3BucketName": {},
						"destinationS3Prefix": {},
						"snsTopicArn": {},
						"customerDefinedValues": {
							"shape": "S8"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"dataSetRequestId": {}
					}
				}
			}
		},
		"shapes": {
			"S8": {
				"type": "map",
				"key": {},
				"value": {}
			}
		}
	};

/***/ },
/* 724 */
/***/ function(module, exports) {

	module.exports = {
		"acm": {
			"name": "ACM",
			"cors": true
		},
		"apigateway": {
			"name": "APIGateway",
			"cors": true
		},
		"applicationautoscaling": {
			"prefix": "application-autoscaling",
			"name": "ApplicationAutoScaling",
			"cors": true
		},
		"appstream": {
			"name": "AppStream"
		},
		"autoscaling": {
			"name": "AutoScaling",
			"cors": true
		},
		"batch": {
			"name": "Batch"
		},
		"budgets": {
			"name": "Budgets"
		},
		"clouddirectory": {
			"name": "CloudDirectory"
		},
		"cloudformation": {
			"name": "CloudFormation",
			"cors": true
		},
		"cloudfront": {
			"name": "CloudFront",
			"versions": [
				"2013-05-12*",
				"2013-11-11*",
				"2014-05-31*",
				"2014-10-21*",
				"2014-11-06*",
				"2015-04-17*",
				"2015-07-27*",
				"2015-09-17*",
				"2016-01-13*",
				"2016-01-28*",
				"2016-08-01*",
				"2016-08-20*",
				"2016-09-07*",
				"2016-09-29*"
			],
			"cors": true
		},
		"cloudhsm": {
			"name": "CloudHSM",
			"cors": true
		},
		"cloudsearch": {
			"name": "CloudSearch"
		},
		"cloudsearchdomain": {
			"name": "CloudSearchDomain"
		},
		"cloudtrail": {
			"name": "CloudTrail",
			"cors": true
		},
		"cloudwatch": {
			"prefix": "monitoring",
			"name": "CloudWatch",
			"cors": true
		},
		"cloudwatchevents": {
			"prefix": "events",
			"name": "CloudWatchEvents",
			"versions": [
				"2014-02-03*"
			],
			"cors": true
		},
		"cloudwatchlogs": {
			"prefix": "logs",
			"name": "CloudWatchLogs",
			"cors": true
		},
		"codebuild": {
			"name": "CodeBuild"
		},
		"codecommit": {
			"name": "CodeCommit",
			"cors": true
		},
		"codedeploy": {
			"name": "CodeDeploy",
			"cors": true
		},
		"codepipeline": {
			"name": "CodePipeline",
			"cors": true
		},
		"cognitoidentity": {
			"prefix": "cognito-identity",
			"name": "CognitoIdentity",
			"cors": true
		},
		"cognitoidentityserviceprovider": {
			"prefix": "cognito-idp",
			"name": "CognitoIdentityServiceProvider",
			"cors": true
		},
		"cognitosync": {
			"prefix": "cognito-sync",
			"name": "CognitoSync",
			"cors": true
		},
		"configservice": {
			"prefix": "config",
			"name": "ConfigService",
			"cors": true
		},
		"cur": {
			"name": "CUR",
			"cors": true
		},
		"datapipeline": {
			"name": "DataPipeline"
		},
		"devicefarm": {
			"name": "DeviceFarm",
			"cors": true
		},
		"directconnect": {
			"name": "DirectConnect",
			"cors": true
		},
		"directoryservice": {
			"prefix": "ds",
			"name": "DirectoryService"
		},
		"discovery": {
			"name": "Discovery"
		},
		"dms": {
			"name": "DMS"
		},
		"dynamodb": {
			"name": "DynamoDB",
			"cors": true
		},
		"dynamodbstreams": {
			"prefix": "streams.dynamodb",
			"name": "DynamoDBStreams",
			"cors": true
		},
		"ec2": {
			"name": "EC2",
			"versions": [
				"2013-06-15*",
				"2013-10-15*",
				"2014-02-01*",
				"2014-05-01*",
				"2014-06-15*",
				"2014-09-01*",
				"2014-10-01*",
				"2015-03-01*",
				"2015-04-15*",
				"2015-10-01*",
				"2016-04-01*",
				"2016-09-15*"
			],
			"cors": true
		},
		"ecr": {
			"name": "ECR",
			"cors": true
		},
		"ecs": {
			"name": "ECS",
			"cors": true
		},
		"efs": {
			"prefix": "elasticfilesystem",
			"name": "EFS"
		},
		"elasticache": {
			"name": "ElastiCache",
			"versions": [
				"2012-11-15*",
				"2014-03-24*",
				"2014-07-15*",
				"2014-09-30*"
			],
			"cors": true
		},
		"elasticbeanstalk": {
			"name": "ElasticBeanstalk",
			"cors": true
		},
		"elb": {
			"prefix": "elasticloadbalancing",
			"name": "ELB",
			"cors": true
		},
		"elbv2": {
			"prefix": "elasticloadbalancingv2",
			"name": "ELBv2",
			"cors": true
		},
		"emr": {
			"prefix": "elasticmapreduce",
			"name": "EMR",
			"cors": true
		},
		"es": {
			"name": "ES"
		},
		"elastictranscoder": {
			"name": "ElasticTranscoder",
			"cors": true
		},
		"firehose": {
			"name": "Firehose",
			"cors": true
		},
		"gamelift": {
			"name": "GameLift",
			"cors": true
		},
		"glacier": {
			"name": "Glacier"
		},
		"health": {
			"name": "Health"
		},
		"iam": {
			"name": "IAM"
		},
		"importexport": {
			"name": "ImportExport"
		},
		"inspector": {
			"name": "Inspector",
			"versions": [
				"2015-08-18*"
			],
			"cors": true
		},
		"iot": {
			"name": "Iot",
			"cors": true
		},
		"iotdata": {
			"prefix": "iot-data",
			"name": "IotData",
			"cors": true
		},
		"kinesis": {
			"name": "Kinesis",
			"cors": true
		},
		"kinesisanalytics": {
			"name": "KinesisAnalytics"
		},
		"kms": {
			"name": "KMS",
			"cors": true
		},
		"lambda": {
			"name": "Lambda",
			"cors": true
		},
		"lexruntime": {
			"prefix": "runtime.lex",
			"name": "LexRuntime",
			"cors": true
		},
		"lightsail": {
			"name": "Lightsail"
		},
		"machinelearning": {
			"name": "MachineLearning",
			"cors": true
		},
		"marketplacecommerceanalytics": {
			"name": "MarketplaceCommerceAnalytics",
			"cors": true
		},
		"marketplacemetering": {
			"prefix": "meteringmarketplace",
			"name": "MarketplaceMetering"
		},
		"mobileanalytics": {
			"name": "MobileAnalytics",
			"cors": true
		},
		"opsworks": {
			"name": "OpsWorks",
			"cors": true
		},
		"opsworkscm": {
			"name": "OpsWorksCM"
		},
		"pinpoint": {
			"name": "Pinpoint"
		},
		"polly": {
			"name": "Polly",
			"cors": true
		},
		"rds": {
			"name": "RDS",
			"versions": [
				"2014-09-01*"
			],
			"cors": true
		},
		"redshift": {
			"name": "Redshift",
			"cors": true
		},
		"rekognition": {
			"name": "Rekognition",
			"cors": true
		},
		"route53": {
			"name": "Route53",
			"cors": true
		},
		"route53domains": {
			"name": "Route53Domains",
			"cors": true
		},
		"s3": {
			"name": "S3",
			"dualstackAvailable": true,
			"cors": true
		},
		"servicecatalog": {
			"name": "ServiceCatalog",
			"cors": true
		},
		"ses": {
			"prefix": "email",
			"name": "SES",
			"cors": true
		},
		"shield": {
			"name": "Shield"
		},
		"simpledb": {
			"prefix": "sdb",
			"name": "SimpleDB"
		},
		"sms": {
			"name": "SMS"
		},
		"snowball": {
			"name": "Snowball"
		},
		"sns": {
			"name": "SNS",
			"cors": true
		},
		"sqs": {
			"name": "SQS",
			"cors": true
		},
		"ssm": {
			"name": "SSM",
			"cors": true
		},
		"storagegateway": {
			"name": "StorageGateway",
			"cors": true
		},
		"stepfunctions": {
			"prefix": "states",
			"name": "StepFunctions"
		},
		"sts": {
			"name": "STS",
			"cors": true
		},
		"support": {
			"name": "Support"
		},
		"swf": {
			"name": "SWF"
		},
		"xray": {
			"name": "XRay"
		},
		"waf": {
			"name": "WAF",
			"cors": true
		},
		"wafregional": {
			"prefix": "waf-regional",
			"name": "WAFRegional"
		},
		"workspaces": {
			"name": "WorkSpaces"
		}
	};

/***/ },
/* 725 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-06-05",
			"endpointPrefix": "mobileanalytics",
			"serviceFullName": "Amazon Mobile Analytics",
			"signatureVersion": "v4",
			"protocol": "rest-json"
		},
		"operations": {
			"PutEvents": {
				"http": {
					"requestUri": "/2014-06-05/events",
					"responseCode": 202
				},
				"input": {
					"type": "structure",
					"required": [
						"events",
						"clientContext"
					],
					"members": {
						"events": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"eventType",
									"timestamp"
								],
								"members": {
									"eventType": {},
									"timestamp": {},
									"session": {
										"type": "structure",
										"members": {
											"id": {},
											"duration": {
												"type": "long"
											},
											"startTimestamp": {},
											"stopTimestamp": {}
										}
									},
									"version": {},
									"attributes": {
										"type": "map",
										"key": {},
										"value": {}
									},
									"metrics": {
										"type": "map",
										"key": {},
										"value": {
											"type": "double"
										}
									}
								}
							}
						},
						"clientContext": {
							"location": "header",
							"locationName": "x-amz-Client-Context"
						},
						"clientContextEncoding": {
							"location": "header",
							"locationName": "x-amz-Client-Context-Encoding"
						}
					}
				}
			}
		},
		"shapes": {}
	};

/***/ },
/* 726 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "monitoring-2010-08-01",
			"apiVersion": "2010-08-01",
			"endpointPrefix": "monitoring",
			"protocol": "query",
			"serviceAbbreviation": "CloudWatch",
			"serviceFullName": "Amazon CloudWatch",
			"signatureVersion": "v4",
			"xmlNamespace": "http://monitoring.amazonaws.com/doc/2010-08-01/"
		},
		"operations": {
			"DeleteAlarms": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmNames"
					],
					"members": {
						"AlarmNames": {
							"shape": "S2"
						}
					}
				}
			},
			"DescribeAlarmHistory": {
				"input": {
					"type": "structure",
					"members": {
						"AlarmName": {},
						"HistoryItemType": {},
						"StartDate": {
							"type": "timestamp"
						},
						"EndDate": {
							"type": "timestamp"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAlarmHistoryResult",
					"type": "structure",
					"members": {
						"AlarmHistoryItems": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AlarmName": {},
									"Timestamp": {
										"type": "timestamp"
									},
									"HistoryItemType": {},
									"HistorySummary": {},
									"HistoryData": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAlarms": {
				"input": {
					"type": "structure",
					"members": {
						"AlarmNames": {
							"shape": "S2"
						},
						"AlarmNamePrefix": {},
						"StateValue": {},
						"ActionPrefix": {},
						"MaxRecords": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAlarmsResult",
					"type": "structure",
					"members": {
						"MetricAlarms": {
							"shape": "Sj"
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAlarmsForMetric": {
				"input": {
					"type": "structure",
					"required": [
						"MetricName",
						"Namespace"
					],
					"members": {
						"MetricName": {},
						"Namespace": {},
						"Statistic": {},
						"ExtendedStatistic": {},
						"Dimensions": {
							"shape": "Sw"
						},
						"Period": {
							"type": "integer"
						},
						"Unit": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeAlarmsForMetricResult",
					"type": "structure",
					"members": {
						"MetricAlarms": {
							"shape": "Sj"
						}
					}
				}
			},
			"DisableAlarmActions": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmNames"
					],
					"members": {
						"AlarmNames": {
							"shape": "S2"
						}
					}
				}
			},
			"EnableAlarmActions": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmNames"
					],
					"members": {
						"AlarmNames": {
							"shape": "S2"
						}
					}
				}
			},
			"GetMetricStatistics": {
				"input": {
					"type": "structure",
					"required": [
						"Namespace",
						"MetricName",
						"StartTime",
						"EndTime",
						"Period"
					],
					"members": {
						"Namespace": {},
						"MetricName": {},
						"Dimensions": {
							"shape": "Sw"
						},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Period": {
							"type": "integer"
						},
						"Statistics": {
							"type": "list",
							"member": {}
						},
						"ExtendedStatistics": {
							"type": "list",
							"member": {}
						},
						"Unit": {}
					}
				},
				"output": {
					"resultWrapper": "GetMetricStatisticsResult",
					"type": "structure",
					"members": {
						"Label": {},
						"Datapoints": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Timestamp": {
										"type": "timestamp"
									},
									"SampleCount": {
										"type": "double"
									},
									"Average": {
										"type": "double"
									},
									"Sum": {
										"type": "double"
									},
									"Minimum": {
										"type": "double"
									},
									"Maximum": {
										"type": "double"
									},
									"Unit": {},
									"ExtendedStatistics": {
										"type": "map",
										"key": {},
										"value": {
											"type": "double"
										}
									}
								},
								"xmlOrder": [
									"Timestamp",
									"SampleCount",
									"Average",
									"Sum",
									"Minimum",
									"Maximum",
									"Unit",
									"ExtendedStatistics"
								]
							}
						}
					}
				}
			},
			"ListMetrics": {
				"input": {
					"type": "structure",
					"members": {
						"Namespace": {},
						"MetricName": {},
						"Dimensions": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Name"
								],
								"members": {
									"Name": {},
									"Value": {}
								}
							}
						},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListMetricsResult",
					"type": "structure",
					"members": {
						"Metrics": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Namespace": {},
									"MetricName": {},
									"Dimensions": {
										"shape": "Sw"
									}
								},
								"xmlOrder": [
									"Namespace",
									"MetricName",
									"Dimensions"
								]
							}
						},
						"NextToken": {}
					},
					"xmlOrder": [
						"Metrics",
						"NextToken"
					]
				}
			},
			"PutMetricAlarm": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmName",
						"MetricName",
						"Namespace",
						"Period",
						"EvaluationPeriods",
						"Threshold",
						"ComparisonOperator"
					],
					"members": {
						"AlarmName": {},
						"AlarmDescription": {},
						"ActionsEnabled": {
							"type": "boolean"
						},
						"OKActions": {
							"shape": "So"
						},
						"AlarmActions": {
							"shape": "So"
						},
						"InsufficientDataActions": {
							"shape": "So"
						},
						"MetricName": {},
						"Namespace": {},
						"Statistic": {},
						"ExtendedStatistic": {},
						"Dimensions": {
							"shape": "Sw"
						},
						"Period": {
							"type": "integer"
						},
						"Unit": {},
						"EvaluationPeriods": {
							"type": "integer"
						},
						"Threshold": {
							"type": "double"
						},
						"ComparisonOperator": {}
					}
				}
			},
			"PutMetricData": {
				"input": {
					"type": "structure",
					"required": [
						"Namespace",
						"MetricData"
					],
					"members": {
						"Namespace": {},
						"MetricData": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"MetricName"
								],
								"members": {
									"MetricName": {},
									"Dimensions": {
										"shape": "Sw"
									},
									"Timestamp": {
										"type": "timestamp"
									},
									"Value": {
										"type": "double"
									},
									"StatisticValues": {
										"type": "structure",
										"required": [
											"SampleCount",
											"Sum",
											"Minimum",
											"Maximum"
										],
										"members": {
											"SampleCount": {
												"type": "double"
											},
											"Sum": {
												"type": "double"
											},
											"Minimum": {
												"type": "double"
											},
											"Maximum": {
												"type": "double"
											}
										}
									},
									"Unit": {}
								}
							}
						}
					}
				}
			},
			"SetAlarmState": {
				"input": {
					"type": "structure",
					"required": [
						"AlarmName",
						"StateValue",
						"StateReason"
					],
					"members": {
						"AlarmName": {},
						"StateValue": {},
						"StateReason": {},
						"StateReasonData": {}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "list",
				"member": {}
			},
			"Sj": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"AlarmName": {},
						"AlarmArn": {},
						"AlarmDescription": {},
						"AlarmConfigurationUpdatedTimestamp": {
							"type": "timestamp"
						},
						"ActionsEnabled": {
							"type": "boolean"
						},
						"OKActions": {
							"shape": "So"
						},
						"AlarmActions": {
							"shape": "So"
						},
						"InsufficientDataActions": {
							"shape": "So"
						},
						"StateValue": {},
						"StateReason": {},
						"StateReasonData": {},
						"StateUpdatedTimestamp": {
							"type": "timestamp"
						},
						"MetricName": {},
						"Namespace": {},
						"Statistic": {},
						"ExtendedStatistic": {},
						"Dimensions": {
							"shape": "Sw"
						},
						"Period": {
							"type": "integer"
						},
						"Unit": {},
						"EvaluationPeriods": {
							"type": "integer"
						},
						"Threshold": {
							"type": "double"
						},
						"ComparisonOperator": {}
					},
					"xmlOrder": [
						"AlarmName",
						"AlarmArn",
						"AlarmDescription",
						"AlarmConfigurationUpdatedTimestamp",
						"ActionsEnabled",
						"OKActions",
						"AlarmActions",
						"InsufficientDataActions",
						"StateValue",
						"StateReason",
						"StateReasonData",
						"StateUpdatedTimestamp",
						"MetricName",
						"Namespace",
						"Statistic",
						"Dimensions",
						"Period",
						"Unit",
						"EvaluationPeriods",
						"Threshold",
						"ComparisonOperator",
						"ExtendedStatistic"
					]
				}
			},
			"So": {
				"type": "list",
				"member": {}
			},
			"Sw": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name",
						"Value"
					],
					"members": {
						"Name": {},
						"Value": {}
					},
					"xmlOrder": [
						"Name",
						"Value"
					]
				}
			}
		}
	};

/***/ },
/* 727 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeAlarmHistory": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "AlarmHistoryItems"
			},
			"DescribeAlarms": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxRecords",
				"result_key": "MetricAlarms"
			},
			"DescribeAlarmsForMetric": {
				"result_key": "MetricAlarms"
			},
			"ListMetrics": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Metrics"
			}
		}
	};

/***/ },
/* 728 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"AlarmExists": {
				"delay": 5,
				"maxAttempts": 40,
				"operation": "DescribeAlarms",
				"acceptors": [
					{
						"matcher": "path",
						"expected": true,
						"argument": "length(MetricAlarms[]) > `0`",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 729 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "opsworks-2013-02-18",
			"apiVersion": "2013-02-18",
			"endpointPrefix": "opsworks",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS OpsWorks",
			"signatureVersion": "v4",
			"targetPrefix": "OpsWorks_20130218"
		},
		"operations": {
			"AssignInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"LayerIds"
					],
					"members": {
						"InstanceId": {},
						"LayerIds": {
							"shape": "S3"
						}
					}
				}
			},
			"AssignVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"VolumeId": {},
						"InstanceId": {}
					}
				}
			},
			"AssociateElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp"
					],
					"members": {
						"ElasticIp": {},
						"InstanceId": {}
					}
				}
			},
			"AttachElasticLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticLoadBalancerName",
						"LayerId"
					],
					"members": {
						"ElasticLoadBalancerName": {},
						"LayerId": {}
					}
				}
			},
			"CloneStack": {
				"input": {
					"type": "structure",
					"required": [
						"SourceStackId",
						"ServiceRoleArn"
					],
					"members": {
						"SourceStackId": {},
						"Name": {},
						"Region": {},
						"VpcId": {},
						"Attributes": {
							"shape": "S8"
						},
						"ServiceRoleArn": {},
						"DefaultInstanceProfileArn": {},
						"DefaultOs": {},
						"HostnameTheme": {},
						"DefaultAvailabilityZone": {},
						"DefaultSubnetId": {},
						"CustomJson": {},
						"ConfigurationManager": {
							"shape": "Sa"
						},
						"ChefConfiguration": {
							"shape": "Sb"
						},
						"UseCustomCookbooks": {
							"type": "boolean"
						},
						"UseOpsworksSecurityGroups": {
							"type": "boolean"
						},
						"CustomCookbooksSource": {
							"shape": "Sd"
						},
						"DefaultSshKeyName": {},
						"ClonePermissions": {
							"type": "boolean"
						},
						"CloneAppIds": {
							"shape": "S3"
						},
						"DefaultRootDeviceType": {},
						"AgentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StackId": {}
					}
				}
			},
			"CreateApp": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"Name",
						"Type"
					],
					"members": {
						"StackId": {},
						"Shortname": {},
						"Name": {},
						"Description": {},
						"DataSources": {
							"shape": "Si"
						},
						"Type": {},
						"AppSource": {
							"shape": "Sd"
						},
						"Domains": {
							"shape": "S3"
						},
						"EnableSsl": {
							"type": "boolean"
						},
						"SslConfiguration": {
							"shape": "Sl"
						},
						"Attributes": {
							"shape": "Sm"
						},
						"Environment": {
							"shape": "So"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AppId": {}
					}
				}
			},
			"CreateDeployment": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"Command"
					],
					"members": {
						"StackId": {},
						"AppId": {},
						"InstanceIds": {
							"shape": "S3"
						},
						"LayerIds": {
							"shape": "S3"
						},
						"Command": {
							"shape": "Ss"
						},
						"Comment": {},
						"CustomJson": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeploymentId": {}
					}
				}
			},
			"CreateInstance": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"LayerIds",
						"InstanceType"
					],
					"members": {
						"StackId": {},
						"LayerIds": {
							"shape": "S3"
						},
						"InstanceType": {},
						"AutoScalingType": {},
						"Hostname": {},
						"Os": {},
						"AmiId": {},
						"SshKeyName": {},
						"AvailabilityZone": {},
						"VirtualizationType": {},
						"SubnetId": {},
						"Architecture": {},
						"RootDeviceType": {},
						"BlockDeviceMappings": {
							"shape": "Sz"
						},
						"InstallUpdatesOnBoot": {
							"type": "boolean"
						},
						"EbsOptimized": {
							"type": "boolean"
						},
						"AgentVersion": {},
						"Tenancy": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {}
					}
				}
			},
			"CreateLayer": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"Type",
						"Name",
						"Shortname"
					],
					"members": {
						"StackId": {},
						"Type": {},
						"Name": {},
						"Shortname": {},
						"Attributes": {
							"shape": "S17"
						},
						"CustomInstanceProfileArn": {},
						"CustomJson": {},
						"CustomSecurityGroupIds": {
							"shape": "S3"
						},
						"Packages": {
							"shape": "S3"
						},
						"VolumeConfigurations": {
							"shape": "S19"
						},
						"EnableAutoHealing": {
							"type": "boolean"
						},
						"AutoAssignElasticIps": {
							"type": "boolean"
						},
						"AutoAssignPublicIps": {
							"type": "boolean"
						},
						"CustomRecipes": {
							"shape": "S1b"
						},
						"InstallUpdatesOnBoot": {
							"type": "boolean"
						},
						"UseEbsOptimizedInstances": {
							"type": "boolean"
						},
						"LifecycleEventConfiguration": {
							"shape": "S1c"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LayerId": {}
					}
				}
			},
			"CreateStack": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Region",
						"ServiceRoleArn",
						"DefaultInstanceProfileArn"
					],
					"members": {
						"Name": {},
						"Region": {},
						"VpcId": {},
						"Attributes": {
							"shape": "S8"
						},
						"ServiceRoleArn": {},
						"DefaultInstanceProfileArn": {},
						"DefaultOs": {},
						"HostnameTheme": {},
						"DefaultAvailabilityZone": {},
						"DefaultSubnetId": {},
						"CustomJson": {},
						"ConfigurationManager": {
							"shape": "Sa"
						},
						"ChefConfiguration": {
							"shape": "Sb"
						},
						"UseCustomCookbooks": {
							"type": "boolean"
						},
						"UseOpsworksSecurityGroups": {
							"type": "boolean"
						},
						"CustomCookbooksSource": {
							"shape": "Sd"
						},
						"DefaultSshKeyName": {},
						"DefaultRootDeviceType": {},
						"AgentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StackId": {}
					}
				}
			},
			"CreateUserProfile": {
				"input": {
					"type": "structure",
					"required": [
						"IamUserArn"
					],
					"members": {
						"IamUserArn": {},
						"SshUsername": {},
						"SshPublicKey": {},
						"AllowSelfManagement": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IamUserArn": {}
					}
				}
			},
			"DeleteApp": {
				"input": {
					"type": "structure",
					"required": [
						"AppId"
					],
					"members": {
						"AppId": {}
					}
				}
			},
			"DeleteInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"DeleteElasticIp": {
							"type": "boolean"
						},
						"DeleteVolumes": {
							"type": "boolean"
						}
					}
				}
			},
			"DeleteLayer": {
				"input": {
					"type": "structure",
					"required": [
						"LayerId"
					],
					"members": {
						"LayerId": {}
					}
				}
			},
			"DeleteStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				}
			},
			"DeleteUserProfile": {
				"input": {
					"type": "structure",
					"required": [
						"IamUserArn"
					],
					"members": {
						"IamUserArn": {}
					}
				}
			},
			"DeregisterEcsCluster": {
				"input": {
					"type": "structure",
					"required": [
						"EcsClusterArn"
					],
					"members": {
						"EcsClusterArn": {}
					}
				}
			},
			"DeregisterElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp"
					],
					"members": {
						"ElasticIp": {}
					}
				}
			},
			"DeregisterInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				}
			},
			"DeregisterRdsDbInstance": {
				"input": {
					"type": "structure",
					"required": [
						"RdsDbInstanceArn"
					],
					"members": {
						"RdsDbInstanceArn": {}
					}
				}
			},
			"DeregisterVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"VolumeId": {}
					}
				}
			},
			"DescribeAgentVersions": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"ConfigurationManager": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AgentVersions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Version": {},
									"ConfigurationManager": {
										"shape": "Sa"
									}
								}
							}
						}
					}
				}
			},
			"DescribeApps": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"AppIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Apps": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AppId": {},
									"StackId": {},
									"Shortname": {},
									"Name": {},
									"Description": {},
									"DataSources": {
										"shape": "Si"
									},
									"Type": {},
									"AppSource": {
										"shape": "Sd"
									},
									"Domains": {
										"shape": "S3"
									},
									"EnableSsl": {
										"type": "boolean"
									},
									"SslConfiguration": {
										"shape": "Sl"
									},
									"Attributes": {
										"shape": "Sm"
									},
									"CreatedAt": {},
									"Environment": {
										"shape": "So"
									}
								}
							}
						}
					}
				}
			},
			"DescribeCommands": {
				"input": {
					"type": "structure",
					"members": {
						"DeploymentId": {},
						"InstanceId": {},
						"CommandIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Commands": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"CommandId": {},
									"InstanceId": {},
									"DeploymentId": {},
									"CreatedAt": {},
									"AcknowledgedAt": {},
									"CompletedAt": {},
									"Status": {},
									"ExitCode": {
										"type": "integer"
									},
									"LogUrl": {},
									"Type": {}
								}
							}
						}
					}
				}
			},
			"DescribeDeployments": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"AppId": {},
						"DeploymentIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Deployments": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DeploymentId": {},
									"StackId": {},
									"AppId": {},
									"CreatedAt": {},
									"CompletedAt": {},
									"Duration": {
										"type": "integer"
									},
									"IamUserArn": {},
									"Comment": {},
									"Command": {
										"shape": "Ss"
									},
									"Status": {},
									"CustomJson": {},
									"InstanceIds": {
										"shape": "S3"
									}
								}
							}
						}
					}
				}
			},
			"DescribeEcsClusters": {
				"input": {
					"type": "structure",
					"members": {
						"EcsClusterArns": {
							"shape": "S3"
						},
						"StackId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EcsClusters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EcsClusterArn": {},
									"EcsClusterName": {},
									"StackId": {},
									"RegisteredAt": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeElasticIps": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceId": {},
						"StackId": {},
						"Ips": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ElasticIps": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Ip": {},
									"Name": {},
									"Domain": {},
									"Region": {},
									"InstanceId": {}
								}
							}
						}
					}
				}
			},
			"DescribeElasticLoadBalancers": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"LayerIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ElasticLoadBalancers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ElasticLoadBalancerName": {},
									"Region": {},
									"DnsName": {},
									"StackId": {},
									"LayerId": {},
									"VpcId": {},
									"AvailabilityZones": {
										"shape": "S3"
									},
									"SubnetIds": {
										"shape": "S3"
									},
									"Ec2InstanceIds": {
										"shape": "S3"
									}
								}
							}
						}
					}
				}
			},
			"DescribeInstances": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"LayerId": {},
						"InstanceIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AgentVersion": {},
									"AmiId": {},
									"Architecture": {},
									"AutoScalingType": {},
									"AvailabilityZone": {},
									"BlockDeviceMappings": {
										"shape": "Sz"
									},
									"CreatedAt": {},
									"EbsOptimized": {
										"type": "boolean"
									},
									"Ec2InstanceId": {},
									"EcsClusterArn": {},
									"EcsContainerInstanceArn": {},
									"ElasticIp": {},
									"Hostname": {},
									"InfrastructureClass": {},
									"InstallUpdatesOnBoot": {
										"type": "boolean"
									},
									"InstanceId": {},
									"InstanceProfileArn": {},
									"InstanceType": {},
									"LastServiceErrorId": {},
									"LayerIds": {
										"shape": "S3"
									},
									"Os": {},
									"Platform": {},
									"PrivateDns": {},
									"PrivateIp": {},
									"PublicDns": {},
									"PublicIp": {},
									"RegisteredBy": {},
									"ReportedAgentVersion": {},
									"ReportedOs": {
										"type": "structure",
										"members": {
											"Family": {},
											"Name": {},
											"Version": {}
										}
									},
									"RootDeviceType": {},
									"RootDeviceVolumeId": {},
									"SecurityGroupIds": {
										"shape": "S3"
									},
									"SshHostDsaKeyFingerprint": {},
									"SshHostRsaKeyFingerprint": {},
									"SshKeyName": {},
									"StackId": {},
									"Status": {},
									"SubnetId": {},
									"Tenancy": {},
									"VirtualizationType": {}
								}
							}
						}
					}
				}
			},
			"DescribeLayers": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"LayerIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Layers": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StackId": {},
									"LayerId": {},
									"Type": {},
									"Name": {},
									"Shortname": {},
									"Attributes": {
										"shape": "S17"
									},
									"CustomInstanceProfileArn": {},
									"CustomJson": {},
									"CustomSecurityGroupIds": {
										"shape": "S3"
									},
									"DefaultSecurityGroupNames": {
										"shape": "S3"
									},
									"Packages": {
										"shape": "S3"
									},
									"VolumeConfigurations": {
										"shape": "S19"
									},
									"EnableAutoHealing": {
										"type": "boolean"
									},
									"AutoAssignElasticIps": {
										"type": "boolean"
									},
									"AutoAssignPublicIps": {
										"type": "boolean"
									},
									"DefaultRecipes": {
										"shape": "S1b"
									},
									"CustomRecipes": {
										"shape": "S1b"
									},
									"CreatedAt": {},
									"InstallUpdatesOnBoot": {
										"type": "boolean"
									},
									"UseEbsOptimizedInstances": {
										"type": "boolean"
									},
									"LifecycleEventConfiguration": {
										"shape": "S1c"
									}
								}
							}
						}
					}
				}
			},
			"DescribeLoadBasedAutoScaling": {
				"input": {
					"type": "structure",
					"required": [
						"LayerIds"
					],
					"members": {
						"LayerIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LoadBasedAutoScalingConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"LayerId": {},
									"Enable": {
										"type": "boolean"
									},
									"UpScaling": {
										"shape": "S30"
									},
									"DownScaling": {
										"shape": "S30"
									}
								}
							}
						}
					}
				}
			},
			"DescribeMyUserProfile": {
				"output": {
					"type": "structure",
					"members": {
						"UserProfile": {
							"type": "structure",
							"members": {
								"IamUserArn": {},
								"Name": {},
								"SshUsername": {},
								"SshPublicKey": {}
							}
						}
					}
				}
			},
			"DescribePermissions": {
				"input": {
					"type": "structure",
					"members": {
						"IamUserArn": {},
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Permissions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StackId": {},
									"IamUserArn": {},
									"AllowSsh": {
										"type": "boolean"
									},
									"AllowSudo": {
										"type": "boolean"
									},
									"Level": {}
								}
							}
						}
					}
				}
			},
			"DescribeRaidArrays": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceId": {},
						"StackId": {},
						"RaidArrayIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RaidArrays": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RaidArrayId": {},
									"InstanceId": {},
									"Name": {},
									"RaidLevel": {
										"type": "integer"
									},
									"NumberOfDisks": {
										"type": "integer"
									},
									"Size": {
										"type": "integer"
									},
									"Device": {},
									"MountPoint": {},
									"AvailabilityZone": {},
									"CreatedAt": {},
									"StackId": {},
									"VolumeType": {},
									"Iops": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"DescribeRdsDbInstances": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {},
						"RdsDbInstanceArns": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RdsDbInstances": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"RdsDbInstanceArn": {},
									"DbInstanceIdentifier": {},
									"DbUser": {},
									"DbPassword": {},
									"Region": {},
									"Address": {},
									"Engine": {},
									"StackId": {},
									"MissingOnRds": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"DescribeServiceErrors": {
				"input": {
					"type": "structure",
					"members": {
						"StackId": {},
						"InstanceId": {},
						"ServiceErrorIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ServiceErrors": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ServiceErrorId": {},
									"StackId": {},
									"InstanceId": {},
									"Type": {},
									"Message": {},
									"CreatedAt": {}
								}
							}
						}
					}
				}
			},
			"DescribeStackProvisioningParameters": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AgentInstallerUrl": {},
						"Parameters": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"DescribeStackSummary": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StackSummary": {
							"type": "structure",
							"members": {
								"StackId": {},
								"Name": {},
								"Arn": {},
								"LayersCount": {
									"type": "integer"
								},
								"AppsCount": {
									"type": "integer"
								},
								"InstancesCount": {
									"type": "structure",
									"members": {
										"Assigning": {
											"type": "integer"
										},
										"Booting": {
											"type": "integer"
										},
										"ConnectionLost": {
											"type": "integer"
										},
										"Deregistering": {
											"type": "integer"
										},
										"Online": {
											"type": "integer"
										},
										"Pending": {
											"type": "integer"
										},
										"Rebooting": {
											"type": "integer"
										},
										"Registered": {
											"type": "integer"
										},
										"Registering": {
											"type": "integer"
										},
										"Requested": {
											"type": "integer"
										},
										"RunningSetup": {
											"type": "integer"
										},
										"SetupFailed": {
											"type": "integer"
										},
										"ShuttingDown": {
											"type": "integer"
										},
										"StartFailed": {
											"type": "integer"
										},
										"Stopped": {
											"type": "integer"
										},
										"Stopping": {
											"type": "integer"
										},
										"Terminated": {
											"type": "integer"
										},
										"Terminating": {
											"type": "integer"
										},
										"Unassigning": {
											"type": "integer"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeStacks": {
				"input": {
					"type": "structure",
					"members": {
						"StackIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Stacks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StackId": {},
									"Name": {},
									"Arn": {},
									"Region": {},
									"VpcId": {},
									"Attributes": {
										"shape": "S8"
									},
									"ServiceRoleArn": {},
									"DefaultInstanceProfileArn": {},
									"DefaultOs": {},
									"HostnameTheme": {},
									"DefaultAvailabilityZone": {},
									"DefaultSubnetId": {},
									"CustomJson": {},
									"ConfigurationManager": {
										"shape": "Sa"
									},
									"ChefConfiguration": {
										"shape": "Sb"
									},
									"UseCustomCookbooks": {
										"type": "boolean"
									},
									"UseOpsworksSecurityGroups": {
										"type": "boolean"
									},
									"CustomCookbooksSource": {
										"shape": "Sd"
									},
									"DefaultSshKeyName": {},
									"CreatedAt": {},
									"DefaultRootDeviceType": {},
									"AgentVersion": {}
								}
							}
						}
					}
				}
			},
			"DescribeTimeBasedAutoScaling": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TimeBasedAutoScalingConfigurations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"InstanceId": {},
									"AutoScalingSchedule": {
										"shape": "S40"
									}
								}
							}
						}
					}
				}
			},
			"DescribeUserProfiles": {
				"input": {
					"type": "structure",
					"members": {
						"IamUserArns": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"UserProfiles": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"IamUserArn": {},
									"Name": {},
									"SshUsername": {},
									"SshPublicKey": {},
									"AllowSelfManagement": {
										"type": "boolean"
									}
								}
							}
						}
					}
				}
			},
			"DescribeVolumes": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceId": {},
						"StackId": {},
						"RaidArrayId": {},
						"VolumeIds": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Volumes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeId": {},
									"Ec2VolumeId": {},
									"Name": {},
									"RaidArrayId": {},
									"InstanceId": {},
									"Status": {},
									"Size": {
										"type": "integer"
									},
									"Device": {},
									"MountPoint": {},
									"Region": {},
									"AvailabilityZone": {},
									"VolumeType": {},
									"Iops": {
										"type": "integer"
									}
								}
							}
						}
					}
				}
			},
			"DetachElasticLoadBalancer": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticLoadBalancerName",
						"LayerId"
					],
					"members": {
						"ElasticLoadBalancerName": {},
						"LayerId": {}
					}
				}
			},
			"DisassociateElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp"
					],
					"members": {
						"ElasticIp": {}
					}
				}
			},
			"GetHostnameSuggestion": {
				"input": {
					"type": "structure",
					"required": [
						"LayerId"
					],
					"members": {
						"LayerId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LayerId": {},
						"Hostname": {}
					}
				}
			},
			"GrantAccess": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"ValidForInMinutes": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TemporaryCredential": {
							"type": "structure",
							"members": {
								"Username": {},
								"Password": {},
								"ValidForInMinutes": {
									"type": "integer"
								},
								"InstanceId": {}
							}
						}
					}
				}
			},
			"RebootInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				}
			},
			"RegisterEcsCluster": {
				"input": {
					"type": "structure",
					"required": [
						"EcsClusterArn",
						"StackId"
					],
					"members": {
						"EcsClusterArn": {},
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EcsClusterArn": {}
					}
				}
			},
			"RegisterElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp",
						"StackId"
					],
					"members": {
						"ElasticIp": {},
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ElasticIp": {}
					}
				}
			},
			"RegisterInstance": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {},
						"Hostname": {},
						"PublicIp": {},
						"PrivateIp": {},
						"RsaPublicKey": {},
						"RsaPublicKeyFingerprint": {},
						"InstanceIdentity": {
							"type": "structure",
							"members": {
								"Document": {},
								"Signature": {}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {}
					}
				}
			},
			"RegisterRdsDbInstance": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"RdsDbInstanceArn",
						"DbUser",
						"DbPassword"
					],
					"members": {
						"StackId": {},
						"RdsDbInstanceArn": {},
						"DbUser": {},
						"DbPassword": {}
					}
				}
			},
			"RegisterVolume": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"Ec2VolumeId": {},
						"StackId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeId": {}
					}
				}
			},
			"SetLoadBasedAutoScaling": {
				"input": {
					"type": "structure",
					"required": [
						"LayerId"
					],
					"members": {
						"LayerId": {},
						"Enable": {
							"type": "boolean"
						},
						"UpScaling": {
							"shape": "S30"
						},
						"DownScaling": {
							"shape": "S30"
						}
					}
				}
			},
			"SetPermission": {
				"input": {
					"type": "structure",
					"required": [
						"StackId",
						"IamUserArn"
					],
					"members": {
						"StackId": {},
						"IamUserArn": {},
						"AllowSsh": {
							"type": "boolean"
						},
						"AllowSudo": {
							"type": "boolean"
						},
						"Level": {}
					}
				}
			},
			"SetTimeBasedAutoScaling": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"AutoScalingSchedule": {
							"shape": "S40"
						}
					}
				}
			},
			"StartInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				}
			},
			"StartStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				}
			},
			"StopInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				}
			},
			"StopStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {}
					}
				}
			},
			"UnassignInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				}
			},
			"UnassignVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"VolumeId": {}
					}
				}
			},
			"UpdateApp": {
				"input": {
					"type": "structure",
					"required": [
						"AppId"
					],
					"members": {
						"AppId": {},
						"Name": {},
						"Description": {},
						"DataSources": {
							"shape": "Si"
						},
						"Type": {},
						"AppSource": {
							"shape": "Sd"
						},
						"Domains": {
							"shape": "S3"
						},
						"EnableSsl": {
							"type": "boolean"
						},
						"SslConfiguration": {
							"shape": "Sl"
						},
						"Attributes": {
							"shape": "Sm"
						},
						"Environment": {
							"shape": "So"
						}
					}
				}
			},
			"UpdateElasticIp": {
				"input": {
					"type": "structure",
					"required": [
						"ElasticIp"
					],
					"members": {
						"ElasticIp": {},
						"Name": {}
					}
				}
			},
			"UpdateInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"LayerIds": {
							"shape": "S3"
						},
						"InstanceType": {},
						"AutoScalingType": {},
						"Hostname": {},
						"Os": {},
						"AmiId": {},
						"SshKeyName": {},
						"Architecture": {},
						"InstallUpdatesOnBoot": {
							"type": "boolean"
						},
						"EbsOptimized": {
							"type": "boolean"
						},
						"AgentVersion": {}
					}
				}
			},
			"UpdateLayer": {
				"input": {
					"type": "structure",
					"required": [
						"LayerId"
					],
					"members": {
						"LayerId": {},
						"Name": {},
						"Shortname": {},
						"Attributes": {
							"shape": "S17"
						},
						"CustomInstanceProfileArn": {},
						"CustomJson": {},
						"CustomSecurityGroupIds": {
							"shape": "S3"
						},
						"Packages": {
							"shape": "S3"
						},
						"VolumeConfigurations": {
							"shape": "S19"
						},
						"EnableAutoHealing": {
							"type": "boolean"
						},
						"AutoAssignElasticIps": {
							"type": "boolean"
						},
						"AutoAssignPublicIps": {
							"type": "boolean"
						},
						"CustomRecipes": {
							"shape": "S1b"
						},
						"InstallUpdatesOnBoot": {
							"type": "boolean"
						},
						"UseEbsOptimizedInstances": {
							"type": "boolean"
						},
						"LifecycleEventConfiguration": {
							"shape": "S1c"
						}
					}
				}
			},
			"UpdateMyUserProfile": {
				"input": {
					"type": "structure",
					"members": {
						"SshPublicKey": {}
					}
				}
			},
			"UpdateRdsDbInstance": {
				"input": {
					"type": "structure",
					"required": [
						"RdsDbInstanceArn"
					],
					"members": {
						"RdsDbInstanceArn": {},
						"DbUser": {},
						"DbPassword": {}
					}
				}
			},
			"UpdateStack": {
				"input": {
					"type": "structure",
					"required": [
						"StackId"
					],
					"members": {
						"StackId": {},
						"Name": {},
						"Attributes": {
							"shape": "S8"
						},
						"ServiceRoleArn": {},
						"DefaultInstanceProfileArn": {},
						"DefaultOs": {},
						"HostnameTheme": {},
						"DefaultAvailabilityZone": {},
						"DefaultSubnetId": {},
						"CustomJson": {},
						"ConfigurationManager": {
							"shape": "Sa"
						},
						"ChefConfiguration": {
							"shape": "Sb"
						},
						"UseCustomCookbooks": {
							"type": "boolean"
						},
						"CustomCookbooksSource": {
							"shape": "Sd"
						},
						"DefaultSshKeyName": {},
						"DefaultRootDeviceType": {},
						"UseOpsworksSecurityGroups": {
							"type": "boolean"
						},
						"AgentVersion": {}
					}
				}
			},
			"UpdateUserProfile": {
				"input": {
					"type": "structure",
					"required": [
						"IamUserArn"
					],
					"members": {
						"IamUserArn": {},
						"SshUsername": {},
						"SshPublicKey": {},
						"AllowSelfManagement": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeId"
					],
					"members": {
						"VolumeId": {},
						"Name": {},
						"MountPoint": {}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "list",
				"member": {}
			},
			"S8": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"Sa": {
				"type": "structure",
				"members": {
					"Name": {},
					"Version": {}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"ManageBerkshelf": {
						"type": "boolean"
					},
					"BerkshelfVersion": {}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"Type": {},
					"Url": {},
					"Username": {},
					"Password": {},
					"SshKey": {},
					"Revision": {}
				}
			},
			"Si": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Type": {},
						"Arn": {},
						"DatabaseName": {}
					}
				}
			},
			"Sl": {
				"type": "structure",
				"required": [
					"Certificate",
					"PrivateKey"
				],
				"members": {
					"Certificate": {},
					"PrivateKey": {},
					"Chain": {}
				}
			},
			"Sm": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"So": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {},
						"Secure": {
							"type": "boolean"
						}
					}
				}
			},
			"Ss": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Args": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "S3"
						}
					}
				}
			},
			"Sz": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"DeviceName": {},
						"NoDevice": {},
						"VirtualName": {},
						"Ebs": {
							"type": "structure",
							"members": {
								"SnapshotId": {},
								"Iops": {
									"type": "integer"
								},
								"VolumeSize": {
									"type": "integer"
								},
								"VolumeType": {},
								"DeleteOnTermination": {
									"type": "boolean"
								}
							}
						}
					}
				}
			},
			"S17": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S19": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"MountPoint",
						"NumberOfDisks",
						"Size"
					],
					"members": {
						"MountPoint": {},
						"RaidLevel": {
							"type": "integer"
						},
						"NumberOfDisks": {
							"type": "integer"
						},
						"Size": {
							"type": "integer"
						},
						"VolumeType": {},
						"Iops": {
							"type": "integer"
						}
					}
				}
			},
			"S1b": {
				"type": "structure",
				"members": {
					"Setup": {
						"shape": "S3"
					},
					"Configure": {
						"shape": "S3"
					},
					"Deploy": {
						"shape": "S3"
					},
					"Undeploy": {
						"shape": "S3"
					},
					"Shutdown": {
						"shape": "S3"
					}
				}
			},
			"S1c": {
				"type": "structure",
				"members": {
					"Shutdown": {
						"type": "structure",
						"members": {
							"ExecutionTimeout": {
								"type": "integer"
							},
							"DelayUntilElbConnectionsDrained": {
								"type": "boolean"
							}
						}
					}
				}
			},
			"S30": {
				"type": "structure",
				"members": {
					"InstanceCount": {
						"type": "integer"
					},
					"ThresholdsWaitTime": {
						"type": "integer"
					},
					"IgnoreMetricsTime": {
						"type": "integer"
					},
					"CpuThreshold": {
						"type": "double"
					},
					"MemoryThreshold": {
						"type": "double"
					},
					"LoadThreshold": {
						"type": "double"
					},
					"Alarms": {
						"shape": "S3"
					}
				}
			},
			"S40": {
				"type": "structure",
				"members": {
					"Monday": {
						"shape": "S41"
					},
					"Tuesday": {
						"shape": "S41"
					},
					"Wednesday": {
						"shape": "S41"
					},
					"Thursday": {
						"shape": "S41"
					},
					"Friday": {
						"shape": "S41"
					},
					"Saturday": {
						"shape": "S41"
					},
					"Sunday": {
						"shape": "S41"
					}
				}
			},
			"S41": {
				"type": "map",
				"key": {},
				"value": {}
			}
		}
	};

/***/ },
/* 730 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeApps": {
				"result_key": "Apps"
			},
			"DescribeCommands": {
				"result_key": "Commands"
			},
			"DescribeDeployments": {
				"result_key": "Deployments"
			},
			"DescribeEcsClusters": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "EcsClusters"
			},
			"DescribeElasticIps": {
				"result_key": "ElasticIps"
			},
			"DescribeElasticLoadBalancers": {
				"result_key": "ElasticLoadBalancers"
			},
			"DescribeInstances": {
				"result_key": "Instances"
			},
			"DescribeLayers": {
				"result_key": "Layers"
			},
			"DescribeLoadBasedAutoScaling": {
				"result_key": "LoadBasedAutoScalingConfigurations"
			},
			"DescribePermissions": {
				"result_key": "Permissions"
			},
			"DescribeRaidArrays": {
				"result_key": "RaidArrays"
			},
			"DescribeServiceErrors": {
				"result_key": "ServiceErrors"
			},
			"DescribeStacks": {
				"result_key": "Stacks"
			},
			"DescribeTimeBasedAutoScaling": {
				"result_key": "TimeBasedAutoScalingConfigurations"
			},
			"DescribeUserProfiles": {
				"result_key": "UserProfiles"
			},
			"DescribeVolumes": {
				"result_key": "Volumes"
			}
		}
	};

/***/ },
/* 731 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"AppExists": {
				"delay": 1,
				"operation": "DescribeApps",
				"maxAttempts": 40,
				"acceptors": [
					{
						"expected": 200,
						"matcher": "status",
						"state": "success"
					},
					{
						"matcher": "status",
						"expected": 400,
						"state": "failure"
					}
				]
			},
			"DeploymentSuccessful": {
				"delay": 15,
				"operation": "DescribeDeployments",
				"maxAttempts": 40,
				"description": "Wait until a deployment has completed successfully",
				"acceptors": [
					{
						"expected": "successful",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Deployments[].Status"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Deployments[].Status"
					}
				]
			},
			"InstanceOnline": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"description": "Wait until OpsWorks instance is online.",
				"acceptors": [
					{
						"expected": "online",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Instances[].Status"
					},
					{
						"expected": "setup_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "shutting_down",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "start_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stopped",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stopping",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "terminating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "terminated",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stop_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					}
				]
			},
			"InstanceRegistered": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"description": "Wait until OpsWorks instance is registered.",
				"acceptors": [
					{
						"expected": "registered",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Instances[].Status"
					},
					{
						"expected": "setup_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "shutting_down",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stopped",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stopping",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "terminating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "terminated",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stop_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					}
				]
			},
			"InstanceStopped": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"description": "Wait until OpsWorks instance is stopped.",
				"acceptors": [
					{
						"expected": "stopped",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Instances[].Status"
					},
					{
						"expected": "booting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "online",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "rebooting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "requested",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "running_setup",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "setup_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "start_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "stop_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					}
				]
			},
			"InstanceTerminated": {
				"delay": 15,
				"operation": "DescribeInstances",
				"maxAttempts": 40,
				"description": "Wait until OpsWorks instance is terminated.",
				"acceptors": [
					{
						"expected": "terminated",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Instances[].Status"
					},
					{
						"expected": "ResourceNotFoundException",
						"matcher": "error",
						"state": "success"
					},
					{
						"expected": "booting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "online",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "pending",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "rebooting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "requested",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "running_setup",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "setup_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					},
					{
						"expected": "start_failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Instances[].Status"
					}
				]
			}
		}
	};

/***/ },
/* 732 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-06-10",
			"endpointPrefix": "polly",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Polly",
			"signatureVersion": "v4",
			"uid": "polly-2016-06-10"
		},
		"operations": {
			"DeleteLexicon": {
				"http": {
					"method": "DELETE",
					"requestUri": "/v1/lexicons/{LexiconName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {
							"shape": "S2",
							"location": "uri",
							"locationName": "LexiconName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeVoices": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/voices",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"LanguageCode": {
							"location": "querystring",
							"locationName": "LanguageCode"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "NextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Voices": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Gender": {},
									"Id": {},
									"LanguageCode": {},
									"LanguageName": {},
									"Name": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetLexicon": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/lexicons/{LexiconName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {
							"shape": "S2",
							"location": "uri",
							"locationName": "LexiconName"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Lexicon": {
							"type": "structure",
							"members": {
								"Content": {},
								"Name": {
									"shape": "S2"
								}
							}
						},
						"LexiconAttributes": {
							"shape": "Si"
						}
					}
				}
			},
			"ListLexicons": {
				"http": {
					"method": "GET",
					"requestUri": "/v1/lexicons",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {
							"location": "querystring",
							"locationName": "NextToken"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Lexicons": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {
										"shape": "S2"
									},
									"Attributes": {
										"shape": "Si"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"PutLexicon": {
				"http": {
					"method": "PUT",
					"requestUri": "/v1/lexicons/{LexiconName}",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Content"
					],
					"members": {
						"Name": {
							"shape": "S2",
							"location": "uri",
							"locationName": "LexiconName"
						},
						"Content": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"SynthesizeSpeech": {
				"http": {
					"requestUri": "/v1/speech",
					"responseCode": 200
				},
				"input": {
					"type": "structure",
					"required": [
						"OutputFormat",
						"Text",
						"VoiceId"
					],
					"members": {
						"LexiconNames": {
							"type": "list",
							"member": {
								"shape": "S2"
							}
						},
						"OutputFormat": {},
						"SampleRate": {},
						"Text": {},
						"TextType": {},
						"VoiceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AudioStream": {
							"type": "blob",
							"streaming": true
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"RequestCharacters": {
							"location": "header",
							"locationName": "x-amzn-RequestCharacters",
							"type": "integer"
						}
					},
					"payload": "AudioStream"
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "string",
				"sensitive": true
			},
			"Si": {
				"type": "structure",
				"members": {
					"Alphabet": {},
					"LanguageCode": {},
					"LastModified": {
						"type": "timestamp"
					},
					"LexiconArn": {},
					"LexemesCount": {
						"type": "integer"
					},
					"Size": {
						"type": "integer"
					}
				}
			}
		}
	};

/***/ },
/* 733 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-01-10",
			"endpointPrefix": "rds",
			"protocol": "query",
			"serviceAbbreviation": "Amazon RDS",
			"serviceFullName": "Amazon Relational Database Service",
			"signatureVersion": "v4",
			"uid": "rds-2013-01-10",
			"xmlNamespace": "http://rds.amazonaws.com/doc/2013-01-10/"
		},
		"operations": {
			"AddSourceIdentifierToSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				}
			},
			"AuthorizeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CopyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBSnapshotIdentifier",
						"TargetDBSnapshotIdentifier"
					],
					"members": {
						"SourceDBSnapshotIdentifier": {},
						"TargetDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CopyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"AllocatedStorage",
						"DBInstanceClass",
						"Engine",
						"MasterUsername",
						"MasterUserPassword"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CharacterSetName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBInstanceReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"SourceDBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SourceDBInstanceIdentifier": {},
						"DBInstanceClass": {},
						"AvailabilityZone": {},
						"Port": {
							"type": "integer"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "S1c"
						}
					}
				}
			},
			"CreateDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName",
						"DBSecurityGroupDescription"
					],
					"members": {
						"DBSecurityGroupName": {},
						"DBSecurityGroupDescription": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSecurityGroupResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"DBInstanceIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"DBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"DBSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"SourceIds": {
							"shape": "S5"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"CreateOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName",
						"EngineName",
						"MajorEngineVersion",
						"OptionGroupDescription"
					],
					"members": {
						"OptionGroupName": {},
						"EngineName": {},
						"MajorEngineVersion": {},
						"OptionGroupDescription": {}
					}
				},
				"output": {
					"resultWrapper": "CreateOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1o"
						}
					}
				}
			},
			"DeleteDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"DeleteDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {}
					}
				}
			},
			"DeleteDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {}
					}
				}
			},
			"DeleteDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"DeleteDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName"
					],
					"members": {
						"DBSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"DeleteOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {}
					}
				}
			},
			"DescribeDBEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						},
						"ListSupportedCharacterSets": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "DBEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBParameterGroupFamily": {},
									"DBEngineDescription": {},
									"DBEngineVersionDescription": {},
									"DefaultCharacterSet": {
										"shape": "S25"
									},
									"SupportedCharacterSets": {
										"type": "list",
										"member": {
											"shape": "S25",
											"locationName": "CharacterSet"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstances": {
							"type": "list",
							"member": {
								"shape": "St",
								"locationName": "DBInstance"
							}
						}
					}
				}
			},
			"DescribeDBParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBParameterGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S1c",
								"locationName": "DBParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"Source": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S2f"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "DBSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeDBSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"SnapshotType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSnapshots": {
							"type": "list",
							"member": {
								"shape": "Sk",
								"locationName": "DBSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSubnetGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S11",
								"locationName": "DBSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"type": "structure",
							"members": {
								"DBParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2f"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"EventCategories": {
										"shape": "S6"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S4",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"EventCategories": {
							"shape": "S6"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S6"
									},
									"Date": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeOptionGroupOptions": {
				"input": {
					"type": "structure",
					"required": [
						"EngineName"
					],
					"members": {
						"EngineName": {},
						"MajorEngineVersion": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupOptionsResult",
					"type": "structure",
					"members": {
						"OptionGroupOptions": {
							"type": "list",
							"member": {
								"locationName": "OptionGroupOption",
								"type": "structure",
								"members": {
									"Name": {},
									"Description": {},
									"EngineName": {},
									"MajorEngineVersion": {},
									"MinimumRequiredMinorEngineVersion": {},
									"PortRequired": {
										"type": "boolean"
									},
									"DefaultPort": {
										"type": "integer"
									},
									"OptionsDependedOn": {
										"type": "list",
										"member": {
											"locationName": "OptionName"
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOptionGroups": {
				"input": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"EngineName": {},
						"MajorEngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupsResult",
					"type": "structure",
					"members": {
						"OptionGroupsList": {
							"type": "list",
							"member": {
								"shape": "S1o",
								"locationName": "OptionGroup"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOrderableDBInstanceOptions": {
				"input": {
					"type": "structure",
					"required": [
						"Engine"
					],
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBInstanceClass": {},
						"LicenseModel": {},
						"Vpc": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
					"type": "structure",
					"members": {
						"OrderableDBInstanceOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableDBInstanceOption",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBInstanceClass": {},
									"LicenseModel": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S14",
											"locationName": "AvailabilityZone"
										}
									},
									"MultiAZCapable": {
										"type": "boolean"
									},
									"ReadReplicaCapable": {
										"type": "boolean"
									},
									"Vpc": {
										"type": "boolean"
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstanceId": {},
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstances": {
							"type": "list",
							"member": {
								"shape": "S3m",
								"locationName": "ReservedDBInstance"
							}
						}
					}
				}
			},
			"DescribeReservedDBInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstancesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedDBInstancesOffering",
								"type": "structure",
								"members": {
									"ReservedDBInstancesOfferingId": {},
									"DBInstanceClass": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"ProductDescription": {},
									"OfferingType": {},
									"MultiAZ": {
										"type": "boolean"
									},
									"RecurringCharges": {
										"shape": "S3o"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "S9"
						}
					}
				}
			},
			"ModifyDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"MasterUserPassword": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"NewDBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"ModifyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBParameterGroupName": {},
						"Parameters": {
							"shape": "S2f"
						}
					}
				},
				"output": {
					"shape": "S3z",
					"resultWrapper": "ModifyDBParameterGroupResult"
				}
			},
			"ModifyDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1i"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"ModifyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {},
						"OptionsToInclude": {
							"type": "list",
							"member": {
								"locationName": "OptionConfiguration",
								"type": "structure",
								"required": [
									"OptionName"
								],
								"members": {
									"OptionName": {},
									"Port": {
										"type": "integer"
									},
									"DBSecurityGroupMemberships": {
										"shape": "Sp"
									},
									"VpcSecurityGroupMemberships": {
										"shape": "Sq"
									}
								}
							}
						},
						"OptionsToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1o"
						}
					}
				}
			},
			"PromoteReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"PurchaseReservedDBInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedDBInstancesOfferingId"
					],
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"ReservedDBInstanceId": {},
						"DBInstanceCount": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedDBInstance": {
							"shape": "S3m"
						}
					}
				}
			},
			"RebootDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"ForceFailover": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RemoveSourceIdentifierFromSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ResetDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S2f"
						}
					}
				},
				"output": {
					"shape": "S3z",
					"resultWrapper": "ResetDBParameterGroupResult"
				}
			},
			"RestoreDBInstanceFromDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RestoreDBInstanceToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBInstanceIdentifier",
						"TargetDBInstanceIdentifier"
					],
					"members": {
						"SourceDBInstanceIdentifier": {},
						"TargetDBInstanceIdentifier": {},
						"RestoreTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RevokeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"Id": {},
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S5"
					},
					"EventCategoriesList": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S5": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S6": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"S9": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"VpcId": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupId": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sk": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"Iops": {
						"type": "integer"
					}
				},
				"wrapper": true
			},
			"Sp": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroupName"
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"Engine": {},
					"DBInstanceStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							}
						}
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"PreferredBackupWindow": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBSecurityGroups": {
						"shape": "Sv"
					},
					"VpcSecurityGroups": {
						"shape": "Sx"
					},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "DBParameterGroup",
							"type": "structure",
							"members": {
								"DBParameterGroupName": {},
								"ParameterApplyStatus": {}
							}
						}
					},
					"AvailabilityZone": {},
					"DBSubnetGroup": {
						"shape": "S11"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"DBInstanceClass": {},
							"AllocatedStorage": {
								"type": "integer"
							},
							"MasterUserPassword": {},
							"Port": {
								"type": "integer"
							},
							"BackupRetentionPeriod": {
								"type": "integer"
							},
							"MultiAZ": {
								"type": "boolean"
							},
							"EngineVersion": {},
							"Iops": {
								"type": "integer"
							},
							"DBInstanceIdentifier": {}
						}
					},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"ReadReplicaSourceDBInstanceIdentifier": {},
					"ReadReplicaDBInstanceIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBInstanceIdentifier"
						}
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupMembership": {
						"type": "structure",
						"members": {
							"OptionGroupName": {},
							"Status": {}
						}
					},
					"CharacterSetName": {},
					"SecondaryAvailabilityZone": {},
					"PubliclyAccessible": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"Sv": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroup",
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Status": {}
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupMembership",
					"type": "structure",
					"members": {
						"VpcSecurityGroupId": {},
						"Status": {}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S14"
								},
								"SubnetStatus": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"S14": {
				"type": "structure",
				"members": {
					"Name": {},
					"ProvisionedIopsCapable": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S1c": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {}
				},
				"wrapper": true
			},
			"S1i": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S1o": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"OptionGroupDescription": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"Options": {
						"type": "list",
						"member": {
							"locationName": "Option",
							"type": "structure",
							"members": {
								"OptionName": {},
								"OptionDescription": {},
								"Port": {
									"type": "integer"
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sv"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "Sx"
								}
							}
						}
					},
					"AllowsVpcAndNonVpcInstanceMemberships": {
						"type": "boolean"
					},
					"VpcId": {}
				},
				"wrapper": true
			},
			"S25": {
				"type": "structure",
				"members": {
					"CharacterSetName": {},
					"CharacterSetDescription": {}
				}
			},
			"S2f": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"ApplyType": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ApplyMethod": {}
					}
				}
			},
			"S3m": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"State": {},
					"RecurringCharges": {
						"shape": "S3o"
					}
				},
				"wrapper": true
			},
			"S3o": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S3z": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 734 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDBEngineVersions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBEngineVersions"
			},
			"DescribeDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBInstances"
			},
			"DescribeDBParameterGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBParameterGroups"
			},
			"DescribeDBParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Parameters"
			},
			"DescribeDBSecurityGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSecurityGroups"
			},
			"DescribeDBSnapshots": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSnapshots"
			},
			"DescribeDBSubnetGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSubnetGroups"
			},
			"DescribeEngineDefaultParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "EngineDefaults.Marker",
				"result_key": "EngineDefaults.Parameters"
			},
			"DescribeEventSubscriptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "EventSubscriptionsList"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Events"
			},
			"DescribeOptionGroupOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupOptions"
			},
			"DescribeOptionGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupsList"
			},
			"DescribeOrderableDBInstanceOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OrderableDBInstanceOptions"
			},
			"DescribeReservedDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstances"
			},
			"DescribeReservedDBInstancesOfferings": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstancesOfferings"
			},
			"ListTagsForResource": {
				"result_key": "TagList"
			}
		}
	};

/***/ },
/* 735 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-02-12",
			"endpointPrefix": "rds",
			"protocol": "query",
			"serviceAbbreviation": "Amazon RDS",
			"serviceFullName": "Amazon Relational Database Service",
			"signatureVersion": "v4",
			"uid": "rds-2013-02-12",
			"xmlNamespace": "http://rds.amazonaws.com/doc/2013-02-12/"
		},
		"operations": {
			"AddSourceIdentifierToSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				}
			},
			"AuthorizeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CopyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBSnapshotIdentifier",
						"TargetDBSnapshotIdentifier"
					],
					"members": {
						"SourceDBSnapshotIdentifier": {},
						"TargetDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CopyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"AllocatedStorage",
						"DBInstanceClass",
						"Engine",
						"MasterUsername",
						"MasterUserPassword"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CharacterSetName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBInstanceReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"SourceDBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SourceDBInstanceIdentifier": {},
						"DBInstanceClass": {},
						"AvailabilityZone": {},
						"Port": {
							"type": "integer"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "S1d"
						}
					}
				}
			},
			"CreateDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName",
						"DBSecurityGroupDescription"
					],
					"members": {
						"DBSecurityGroupName": {},
						"DBSecurityGroupDescription": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSecurityGroupResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"DBInstanceIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"DBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"DBSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1j"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"SourceIds": {
							"shape": "S5"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"CreateOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName",
						"EngineName",
						"MajorEngineVersion",
						"OptionGroupDescription"
					],
					"members": {
						"OptionGroupName": {},
						"EngineName": {},
						"MajorEngineVersion": {},
						"OptionGroupDescription": {}
					}
				},
				"output": {
					"resultWrapper": "CreateOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1p"
						}
					}
				}
			},
			"DeleteDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"DeleteDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {}
					}
				}
			},
			"DeleteDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {}
					}
				}
			},
			"DeleteDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"DeleteDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName"
					],
					"members": {
						"DBSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"DeleteOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {}
					}
				}
			},
			"DescribeDBEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						},
						"ListSupportedCharacterSets": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "DBEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBParameterGroupFamily": {},
									"DBEngineDescription": {},
									"DBEngineVersionDescription": {},
									"DefaultCharacterSet": {
										"shape": "S28"
									},
									"SupportedCharacterSets": {
										"type": "list",
										"member": {
											"shape": "S28",
											"locationName": "CharacterSet"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstances": {
							"type": "list",
							"member": {
								"shape": "St",
								"locationName": "DBInstance"
							}
						}
					}
				}
			},
			"DescribeDBLogFiles": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"FilenameContains": {},
						"FileLastWritten": {
							"type": "long"
						},
						"FileSize": {
							"type": "long"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBLogFilesResult",
					"type": "structure",
					"members": {
						"DescribeDBLogFiles": {
							"type": "list",
							"member": {
								"locationName": "DescribeDBLogFilesDetails",
								"type": "structure",
								"members": {
									"LogFileName": {},
									"LastWritten": {
										"type": "long"
									},
									"Size": {
										"type": "long"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBParameterGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S1d",
								"locationName": "DBParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"Source": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S2n"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "DBSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeDBSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"SnapshotType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSnapshots": {
							"type": "list",
							"member": {
								"shape": "Sk",
								"locationName": "DBSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSubnetGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S11",
								"locationName": "DBSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"type": "structure",
							"members": {
								"DBParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2n"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"EventCategories": {
										"shape": "S6"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S4",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"EventCategories": {
							"shape": "S6"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S6"
									},
									"Date": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeOptionGroupOptions": {
				"input": {
					"type": "structure",
					"required": [
						"EngineName"
					],
					"members": {
						"EngineName": {},
						"MajorEngineVersion": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupOptionsResult",
					"type": "structure",
					"members": {
						"OptionGroupOptions": {
							"type": "list",
							"member": {
								"locationName": "OptionGroupOption",
								"type": "structure",
								"members": {
									"Name": {},
									"Description": {},
									"EngineName": {},
									"MajorEngineVersion": {},
									"MinimumRequiredMinorEngineVersion": {},
									"PortRequired": {
										"type": "boolean"
									},
									"DefaultPort": {
										"type": "integer"
									},
									"OptionsDependedOn": {
										"type": "list",
										"member": {
											"locationName": "OptionName"
										}
									},
									"Persistent": {
										"type": "boolean"
									},
									"OptionGroupOptionSettings": {
										"type": "list",
										"member": {
											"locationName": "OptionGroupOptionSetting",
											"type": "structure",
											"members": {
												"SettingName": {},
												"SettingDescription": {},
												"DefaultValue": {},
												"ApplyType": {},
												"AllowedValues": {},
												"IsModifiable": {
													"type": "boolean"
												}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOptionGroups": {
				"input": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"EngineName": {},
						"MajorEngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupsResult",
					"type": "structure",
					"members": {
						"OptionGroupsList": {
							"type": "list",
							"member": {
								"shape": "S1p",
								"locationName": "OptionGroup"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOrderableDBInstanceOptions": {
				"input": {
					"type": "structure",
					"required": [
						"Engine"
					],
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBInstanceClass": {},
						"LicenseModel": {},
						"Vpc": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
					"type": "structure",
					"members": {
						"OrderableDBInstanceOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableDBInstanceOption",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBInstanceClass": {},
									"LicenseModel": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S14",
											"locationName": "AvailabilityZone"
										}
									},
									"MultiAZCapable": {
										"type": "boolean"
									},
									"ReadReplicaCapable": {
										"type": "boolean"
									},
									"Vpc": {
										"type": "boolean"
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstanceId": {},
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstances": {
							"type": "list",
							"member": {
								"shape": "S3w",
								"locationName": "ReservedDBInstance"
							}
						}
					}
				}
			},
			"DescribeReservedDBInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstancesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedDBInstancesOffering",
								"type": "structure",
								"members": {
									"ReservedDBInstancesOfferingId": {},
									"DBInstanceClass": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"ProductDescription": {},
									"OfferingType": {},
									"MultiAZ": {
										"type": "boolean"
									},
									"RecurringCharges": {
										"shape": "S3y"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DownloadDBLogFilePortion": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"LogFileName"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"LogFileName": {},
						"Marker": {},
						"NumberOfLines": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DownloadDBLogFilePortionResult",
					"type": "structure",
					"members": {
						"LogFileData": {},
						"Marker": {},
						"AdditionalDataPending": {
							"type": "boolean"
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "S9"
						}
					}
				}
			},
			"ModifyDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"MasterUserPassword": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"NewDBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"ModifyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBParameterGroupName": {},
						"Parameters": {
							"shape": "S2n"
						}
					}
				},
				"output": {
					"shape": "S4b",
					"resultWrapper": "ModifyDBParameterGroupResult"
				}
			},
			"ModifyDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1j"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"ModifyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {},
						"OptionsToInclude": {
							"type": "list",
							"member": {
								"locationName": "OptionConfiguration",
								"type": "structure",
								"required": [
									"OptionName"
								],
								"members": {
									"OptionName": {},
									"Port": {
										"type": "integer"
									},
									"DBSecurityGroupMemberships": {
										"shape": "Sp"
									},
									"VpcSecurityGroupMemberships": {
										"shape": "Sq"
									},
									"OptionSettings": {
										"type": "list",
										"member": {
											"shape": "S1t",
											"locationName": "OptionSetting"
										}
									}
								}
							}
						},
						"OptionsToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1p"
						}
					}
				}
			},
			"PromoteReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"PurchaseReservedDBInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedDBInstancesOfferingId"
					],
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"ReservedDBInstanceId": {},
						"DBInstanceCount": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedDBInstance": {
							"shape": "S3w"
						}
					}
				}
			},
			"RebootDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"ForceFailover": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RemoveSourceIdentifierFromSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ResetDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S2n"
						}
					}
				},
				"output": {
					"shape": "S4b",
					"resultWrapper": "ResetDBParameterGroupResult"
				}
			},
			"RestoreDBInstanceFromDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RestoreDBInstanceToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBInstanceIdentifier",
						"TargetDBInstanceIdentifier"
					],
					"members": {
						"SourceDBInstanceIdentifier": {},
						"TargetDBInstanceIdentifier": {},
						"RestoreTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RevokeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S5"
					},
					"EventCategoriesList": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S5": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S6": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"S9": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"VpcId": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupId": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sk": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {}
				},
				"wrapper": true
			},
			"Sp": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroupName"
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"Engine": {},
					"DBInstanceStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							}
						}
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"PreferredBackupWindow": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBSecurityGroups": {
						"shape": "Sv"
					},
					"VpcSecurityGroups": {
						"shape": "Sx"
					},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "DBParameterGroup",
							"type": "structure",
							"members": {
								"DBParameterGroupName": {},
								"ParameterApplyStatus": {}
							}
						}
					},
					"AvailabilityZone": {},
					"DBSubnetGroup": {
						"shape": "S11"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"DBInstanceClass": {},
							"AllocatedStorage": {
								"type": "integer"
							},
							"MasterUserPassword": {},
							"Port": {
								"type": "integer"
							},
							"BackupRetentionPeriod": {
								"type": "integer"
							},
							"MultiAZ": {
								"type": "boolean"
							},
							"EngineVersion": {},
							"Iops": {
								"type": "integer"
							},
							"DBInstanceIdentifier": {}
						}
					},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"ReadReplicaSourceDBInstanceIdentifier": {},
					"ReadReplicaDBInstanceIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBInstanceIdentifier"
						}
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupMemberships": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupMembership",
							"type": "structure",
							"members": {
								"OptionGroupName": {},
								"Status": {}
							}
						}
					},
					"CharacterSetName": {},
					"SecondaryAvailabilityZone": {},
					"PubliclyAccessible": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"Sv": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroup",
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Status": {}
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupMembership",
					"type": "structure",
					"members": {
						"VpcSecurityGroupId": {},
						"Status": {}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S14"
								},
								"SubnetStatus": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"S14": {
				"type": "structure",
				"members": {
					"Name": {},
					"ProvisionedIopsCapable": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S1d": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {}
				},
				"wrapper": true
			},
			"S1j": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S1p": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"OptionGroupDescription": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"Options": {
						"type": "list",
						"member": {
							"locationName": "Option",
							"type": "structure",
							"members": {
								"OptionName": {},
								"OptionDescription": {},
								"Persistent": {
									"type": "boolean"
								},
								"Port": {
									"type": "integer"
								},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "S1t",
										"locationName": "OptionSetting"
									}
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sv"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "Sx"
								}
							}
						}
					},
					"AllowsVpcAndNonVpcInstanceMemberships": {
						"type": "boolean"
					},
					"VpcId": {}
				},
				"wrapper": true
			},
			"S1t": {
				"type": "structure",
				"members": {
					"Name": {},
					"Value": {},
					"DefaultValue": {},
					"Description": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"IsCollection": {
						"type": "boolean"
					}
				}
			},
			"S28": {
				"type": "structure",
				"members": {
					"CharacterSetName": {},
					"CharacterSetDescription": {}
				}
			},
			"S2n": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"ApplyType": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ApplyMethod": {}
					}
				}
			},
			"S3w": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"State": {},
					"RecurringCharges": {
						"shape": "S3y"
					}
				},
				"wrapper": true
			},
			"S3y": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S4b": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 736 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDBEngineVersions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBEngineVersions"
			},
			"DescribeDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBInstances"
			},
			"DescribeDBLogFiles": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DescribeDBLogFiles"
			},
			"DescribeDBParameterGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBParameterGroups"
			},
			"DescribeDBParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Parameters"
			},
			"DescribeDBSecurityGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSecurityGroups"
			},
			"DescribeDBSnapshots": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSnapshots"
			},
			"DescribeDBSubnetGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSubnetGroups"
			},
			"DescribeEngineDefaultParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "EngineDefaults.Marker",
				"result_key": "EngineDefaults.Parameters"
			},
			"DescribeEventSubscriptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "EventSubscriptionsList"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Events"
			},
			"DescribeOptionGroupOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupOptions"
			},
			"DescribeOptionGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupsList"
			},
			"DescribeOrderableDBInstanceOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OrderableDBInstanceOptions"
			},
			"DescribeReservedDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstances"
			},
			"DescribeReservedDBInstancesOfferings": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstancesOfferings"
			},
			"DownloadDBLogFilePortion": {
				"input_token": "Marker",
				"limit_key": "NumberOfLines",
				"more_results": "AdditionalDataPending",
				"output_token": "Marker",
				"result_key": "LogFileData"
			},
			"ListTagsForResource": {
				"result_key": "TagList"
			}
		}
	};

/***/ },
/* 737 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-09-09",
			"endpointPrefix": "rds",
			"protocol": "query",
			"serviceAbbreviation": "Amazon RDS",
			"serviceFullName": "Amazon Relational Database Service",
			"signatureVersion": "v4",
			"uid": "rds-2013-09-09",
			"xmlNamespace": "http://rds.amazonaws.com/doc/2013-09-09/"
		},
		"operations": {
			"AddSourceIdentifierToSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				}
			},
			"AuthorizeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CopyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBSnapshotIdentifier",
						"TargetDBSnapshotIdentifier"
					],
					"members": {
						"SourceDBSnapshotIdentifier": {},
						"TargetDBSnapshotIdentifier": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"AllocatedStorage",
						"DBInstanceClass",
						"Engine",
						"MasterUsername",
						"MasterUserPassword"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CharacterSetName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBInstanceReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"SourceDBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SourceDBInstanceIdentifier": {},
						"DBInstanceClass": {},
						"AvailabilityZone": {},
						"Port": {
							"type": "integer"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						},
						"DBSubnetGroupName": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"CreateDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "S1f"
						}
					}
				}
			},
			"CreateDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName",
						"DBSecurityGroupDescription"
					],
					"members": {
						"DBSecurityGroupName": {},
						"DBSecurityGroupDescription": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSecurityGroupResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"DBInstanceIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"DBInstanceIdentifier": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"DBSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1l"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"SourceIds": {
							"shape": "S5"
						},
						"Enabled": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"CreateOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName",
						"EngineName",
						"MajorEngineVersion",
						"OptionGroupDescription"
					],
					"members": {
						"OptionGroupName": {},
						"EngineName": {},
						"MajorEngineVersion": {},
						"OptionGroupDescription": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1r"
						}
					}
				}
			},
			"DeleteDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"DeleteDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {}
					}
				}
			},
			"DeleteDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {}
					}
				}
			},
			"DeleteDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "Sk"
						}
					}
				}
			},
			"DeleteDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName"
					],
					"members": {
						"DBSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"DeleteOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {}
					}
				}
			},
			"DescribeDBEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						},
						"ListSupportedCharacterSets": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "DBEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBParameterGroupFamily": {},
									"DBEngineDescription": {},
									"DBEngineVersionDescription": {},
									"DefaultCharacterSet": {
										"shape": "S2d"
									},
									"SupportedCharacterSets": {
										"type": "list",
										"member": {
											"shape": "S2d",
											"locationName": "CharacterSet"
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstances": {
							"type": "list",
							"member": {
								"shape": "St",
								"locationName": "DBInstance"
							}
						}
					}
				}
			},
			"DescribeDBLogFiles": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"FilenameContains": {},
						"FileLastWritten": {
							"type": "long"
						},
						"FileSize": {
							"type": "long"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBLogFilesResult",
					"type": "structure",
					"members": {
						"DescribeDBLogFiles": {
							"type": "list",
							"member": {
								"locationName": "DescribeDBLogFilesDetails",
								"type": "structure",
								"members": {
									"LogFileName": {},
									"LastWritten": {
										"type": "long"
									},
									"Size": {
										"type": "long"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBParameterGroupName": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S1f",
								"locationName": "DBParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"Source": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S2s"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "DBSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeDBSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"SnapshotType": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSnapshots": {
							"type": "list",
							"member": {
								"shape": "Sk",
								"locationName": "DBSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSubnetGroupName": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S11",
								"locationName": "DBSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"type": "structure",
							"members": {
								"DBParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2s"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {},
						"Filters": {
							"shape": "S27"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"EventCategories": {
										"shape": "S6"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S4",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"EventCategories": {
							"shape": "S6"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S6"
									},
									"Date": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeOptionGroupOptions": {
				"input": {
					"type": "structure",
					"required": [
						"EngineName"
					],
					"members": {
						"EngineName": {},
						"MajorEngineVersion": {},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupOptionsResult",
					"type": "structure",
					"members": {
						"OptionGroupOptions": {
							"type": "list",
							"member": {
								"locationName": "OptionGroupOption",
								"type": "structure",
								"members": {
									"Name": {},
									"Description": {},
									"EngineName": {},
									"MajorEngineVersion": {},
									"MinimumRequiredMinorEngineVersion": {},
									"PortRequired": {
										"type": "boolean"
									},
									"DefaultPort": {
										"type": "integer"
									},
									"OptionsDependedOn": {
										"type": "list",
										"member": {
											"locationName": "OptionName"
										}
									},
									"Persistent": {
										"type": "boolean"
									},
									"Permanent": {
										"type": "boolean"
									},
									"OptionGroupOptionSettings": {
										"type": "list",
										"member": {
											"locationName": "OptionGroupOptionSetting",
											"type": "structure",
											"members": {
												"SettingName": {},
												"SettingDescription": {},
												"DefaultValue": {},
												"ApplyType": {},
												"AllowedValues": {},
												"IsModifiable": {
													"type": "boolean"
												}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOptionGroups": {
				"input": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Filters": {
							"shape": "S27"
						},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"EngineName": {},
						"MajorEngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupsResult",
					"type": "structure",
					"members": {
						"OptionGroupsList": {
							"type": "list",
							"member": {
								"shape": "S1r",
								"locationName": "OptionGroup"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOrderableDBInstanceOptions": {
				"input": {
					"type": "structure",
					"required": [
						"Engine"
					],
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBInstanceClass": {},
						"LicenseModel": {},
						"Vpc": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
					"type": "structure",
					"members": {
						"OrderableDBInstanceOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableDBInstanceOption",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBInstanceClass": {},
									"LicenseModel": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S14",
											"locationName": "AvailabilityZone"
										}
									},
									"MultiAZCapable": {
										"type": "boolean"
									},
									"ReadReplicaCapable": {
										"type": "boolean"
									},
									"Vpc": {
										"type": "boolean"
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstanceId": {},
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstances": {
							"type": "list",
							"member": {
								"shape": "S41",
								"locationName": "ReservedDBInstance"
							}
						}
					}
				}
			},
			"DescribeReservedDBInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S27"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstancesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedDBInstancesOffering",
								"type": "structure",
								"members": {
									"ReservedDBInstancesOfferingId": {},
									"DBInstanceClass": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"ProductDescription": {},
									"OfferingType": {},
									"MultiAZ": {
										"type": "boolean"
									},
									"RecurringCharges": {
										"shape": "S43"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DownloadDBLogFilePortion": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"LogFileName"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"LogFileName": {},
						"Marker": {},
						"NumberOfLines": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DownloadDBLogFilePortionResult",
					"type": "structure",
					"members": {
						"LogFileData": {},
						"Marker": {},
						"AdditionalDataPending": {
							"type": "boolean"
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {},
						"Filters": {
							"shape": "S27"
						}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "S9"
						}
					}
				}
			},
			"ModifyDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"DBSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"MasterUserPassword": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"NewDBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"ModifyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBParameterGroupName": {},
						"Parameters": {
							"shape": "S2s"
						}
					}
				},
				"output": {
					"shape": "S4g",
					"resultWrapper": "ModifyDBParameterGroupResult"
				}
			},
			"ModifyDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S1l"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S11"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S6"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"ModifyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {},
						"OptionsToInclude": {
							"type": "list",
							"member": {
								"locationName": "OptionConfiguration",
								"type": "structure",
								"required": [
									"OptionName"
								],
								"members": {
									"OptionName": {},
									"Port": {
										"type": "integer"
									},
									"DBSecurityGroupMemberships": {
										"shape": "Sp"
									},
									"VpcSecurityGroupMemberships": {
										"shape": "Sq"
									},
									"OptionSettings": {
										"type": "list",
										"member": {
											"shape": "S1v",
											"locationName": "OptionSetting"
										}
									}
								}
							}
						},
						"OptionsToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S1r"
						}
					}
				}
			},
			"PromoteReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"PurchaseReservedDBInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedDBInstancesOfferingId"
					],
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"ReservedDBInstanceId": {},
						"DBInstanceCount": {
							"type": "integer"
						},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedDBInstance": {
							"shape": "S41"
						}
					}
				}
			},
			"RebootDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"ForceFailover": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RemoveSourceIdentifierFromSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S4"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ResetDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S2s"
						}
					}
				},
				"output": {
					"shape": "S4g",
					"resultWrapper": "ResetDBParameterGroupResult"
				}
			},
			"RestoreDBInstanceFromDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RestoreDBInstanceToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBInstanceIdentifier",
						"TargetDBInstanceIdentifier"
					],
					"members": {
						"SourceDBInstanceIdentifier": {},
						"TargetDBInstanceIdentifier": {},
						"RestoreTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"Tags": {
							"shape": "S9"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "St"
						}
					}
				}
			},
			"RevokeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sd"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S5"
					},
					"EventCategoriesList": {
						"shape": "S6"
					},
					"Enabled": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S5": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S6": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"S9": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"VpcId": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupId": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sk": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PercentProgress": {
						"type": "integer"
					},
					"SourceRegion": {}
				},
				"wrapper": true
			},
			"Sp": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroupName"
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"Engine": {},
					"DBInstanceStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							}
						}
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"PreferredBackupWindow": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBSecurityGroups": {
						"shape": "Sv"
					},
					"VpcSecurityGroups": {
						"shape": "Sx"
					},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "DBParameterGroup",
							"type": "structure",
							"members": {
								"DBParameterGroupName": {},
								"ParameterApplyStatus": {}
							}
						}
					},
					"AvailabilityZone": {},
					"DBSubnetGroup": {
						"shape": "S11"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"DBInstanceClass": {},
							"AllocatedStorage": {
								"type": "integer"
							},
							"MasterUserPassword": {},
							"Port": {
								"type": "integer"
							},
							"BackupRetentionPeriod": {
								"type": "integer"
							},
							"MultiAZ": {
								"type": "boolean"
							},
							"EngineVersion": {},
							"Iops": {
								"type": "integer"
							},
							"DBInstanceIdentifier": {}
						}
					},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"ReadReplicaSourceDBInstanceIdentifier": {},
					"ReadReplicaDBInstanceIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBInstanceIdentifier"
						}
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupMemberships": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupMembership",
							"type": "structure",
							"members": {
								"OptionGroupName": {},
								"Status": {}
							}
						}
					},
					"CharacterSetName": {},
					"SecondaryAvailabilityZone": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"StatusInfos": {
						"type": "list",
						"member": {
							"locationName": "DBInstanceStatusInfo",
							"type": "structure",
							"members": {
								"StatusType": {},
								"Normal": {
									"type": "boolean"
								},
								"Status": {},
								"Message": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sv": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroup",
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Status": {}
					}
				}
			},
			"Sx": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupMembership",
					"type": "structure",
					"members": {
						"VpcSecurityGroupId": {},
						"Status": {}
					}
				}
			},
			"S11": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S14"
								},
								"SubnetStatus": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"S14": {
				"type": "structure",
				"members": {
					"Name": {},
					"ProvisionedIopsCapable": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"S1f": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {}
				},
				"wrapper": true
			},
			"S1l": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S1r": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"OptionGroupDescription": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"Options": {
						"type": "list",
						"member": {
							"locationName": "Option",
							"type": "structure",
							"members": {
								"OptionName": {},
								"OptionDescription": {},
								"Persistent": {
									"type": "boolean"
								},
								"Permanent": {
									"type": "boolean"
								},
								"Port": {
									"type": "integer"
								},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "S1v",
										"locationName": "OptionSetting"
									}
								},
								"DBSecurityGroupMemberships": {
									"shape": "Sv"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "Sx"
								}
							}
						}
					},
					"AllowsVpcAndNonVpcInstanceMemberships": {
						"type": "boolean"
					},
					"VpcId": {}
				},
				"wrapper": true
			},
			"S1v": {
				"type": "structure",
				"members": {
					"Name": {},
					"Value": {},
					"DefaultValue": {},
					"Description": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"IsCollection": {
						"type": "boolean"
					}
				}
			},
			"S27": {
				"type": "list",
				"member": {
					"locationName": "Filter",
					"type": "structure",
					"required": [
						"Name",
						"Values"
					],
					"members": {
						"Name": {},
						"Values": {
							"type": "list",
							"member": {
								"locationName": "Value"
							}
						}
					}
				}
			},
			"S2d": {
				"type": "structure",
				"members": {
					"CharacterSetName": {},
					"CharacterSetDescription": {}
				}
			},
			"S2s": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"ApplyType": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ApplyMethod": {}
					}
				}
			},
			"S41": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"State": {},
					"RecurringCharges": {
						"shape": "S43"
					}
				},
				"wrapper": true
			},
			"S43": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S4g": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 738 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDBEngineVersions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBEngineVersions"
			},
			"DescribeDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBInstances"
			},
			"DescribeDBLogFiles": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DescribeDBLogFiles"
			},
			"DescribeDBParameterGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBParameterGroups"
			},
			"DescribeDBParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Parameters"
			},
			"DescribeDBSecurityGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSecurityGroups"
			},
			"DescribeDBSnapshots": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSnapshots"
			},
			"DescribeDBSubnetGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSubnetGroups"
			},
			"DescribeEngineDefaultParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "EngineDefaults.Marker",
				"result_key": "EngineDefaults.Parameters"
			},
			"DescribeEventSubscriptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "EventSubscriptionsList"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Events"
			},
			"DescribeOptionGroupOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupOptions"
			},
			"DescribeOptionGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupsList"
			},
			"DescribeOrderableDBInstanceOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OrderableDBInstanceOptions"
			},
			"DescribeReservedDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstances"
			},
			"DescribeReservedDBInstancesOfferings": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstancesOfferings"
			},
			"DownloadDBLogFilePortion": {
				"input_token": "Marker",
				"limit_key": "NumberOfLines",
				"more_results": "AdditionalDataPending",
				"output_token": "Marker",
				"result_key": "LogFileData"
			},
			"ListTagsForResource": {
				"result_key": "TagList"
			}
		}
	};

/***/ },
/* 739 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DBInstanceAvailable": {
				"delay": 30,
				"operation": "DescribeDBInstances",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-restore",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-parameters",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-parameters",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-restore",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					}
				]
			},
			"DBInstanceDeleted": {
				"delay": 30,
				"operation": "DescribeDBInstances",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "creating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "modifying",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "rebooting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "resetting-master-credentials",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					}
				]
			}
		}
	};

/***/ },
/* 740 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-10-31",
			"endpointPrefix": "rds",
			"protocol": "query",
			"serviceAbbreviation": "Amazon RDS",
			"serviceFullName": "Amazon Relational Database Service",
			"signatureVersion": "v4",
			"uid": "rds-2014-10-31",
			"xmlNamespace": "http://rds.amazonaws.com/doc/2014-10-31/"
		},
		"operations": {
			"AddRoleToDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"RoleArn"
					],
					"members": {
						"DBClusterIdentifier": {},
						"RoleArn": {}
					}
				}
			},
			"AddSourceIdentifierToSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "AddSourceIdentifierToSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S5"
						}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				}
			},
			"ApplyPendingMaintenanceAction": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceIdentifier",
						"ApplyAction",
						"OptInType"
					],
					"members": {
						"ResourceIdentifier": {},
						"ApplyAction": {},
						"OptInType": {}
					}
				},
				"output": {
					"resultWrapper": "ApplyPendingMaintenanceActionResult",
					"type": "structure",
					"members": {
						"ResourcePendingMaintenanceActions": {
							"shape": "Se"
						}
					}
				}
			},
			"AuthorizeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sk"
						}
					}
				}
			},
			"CopyDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBClusterParameterGroupIdentifier",
						"TargetDBClusterParameterGroupIdentifier",
						"TargetDBClusterParameterGroupDescription"
					],
					"members": {
						"SourceDBClusterParameterGroupIdentifier": {},
						"TargetDBClusterParameterGroupIdentifier": {},
						"TargetDBClusterParameterGroupDescription": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyDBClusterParameterGroupResult",
					"type": "structure",
					"members": {
						"DBClusterParameterGroup": {
							"shape": "Sr"
						}
					}
				}
			},
			"CopyDBClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBClusterSnapshotIdentifier",
						"TargetDBClusterSnapshotIdentifier"
					],
					"members": {
						"SourceDBClusterSnapshotIdentifier": {},
						"TargetDBClusterSnapshotIdentifier": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyDBClusterSnapshotResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshot": {
							"shape": "Su"
						}
					}
				}
			},
			"CopyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBParameterGroupIdentifier",
						"TargetDBParameterGroupIdentifier",
						"TargetDBParameterGroupDescription"
					],
					"members": {
						"SourceDBParameterGroupIdentifier": {},
						"TargetDBParameterGroupIdentifier": {},
						"TargetDBParameterGroupDescription": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "Sz"
						}
					}
				}
			},
			"CopyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBSnapshotIdentifier",
						"TargetDBSnapshotIdentifier"
					],
					"members": {
						"SourceDBSnapshotIdentifier": {},
						"TargetDBSnapshotIdentifier": {},
						"KmsKeyId": {},
						"Tags": {
							"shape": "Sa"
						},
						"CopyTags": {
							"type": "boolean"
						},
						"PreSignedUrl": {},
						"SourceRegion": {}
					}
				},
				"output": {
					"resultWrapper": "CopyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "S13"
						}
					}
				}
			},
			"CopyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"SourceOptionGroupIdentifier",
						"TargetOptionGroupIdentifier",
						"TargetOptionGroupDescription"
					],
					"members": {
						"SourceOptionGroupIdentifier": {},
						"TargetOptionGroupIdentifier": {},
						"TargetOptionGroupDescription": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CopyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S17"
						}
					}
				}
			},
			"CreateDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"Engine"
					],
					"members": {
						"AvailabilityZones": {
							"shape": "Sv"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"CharacterSetName": {},
						"DatabaseName": {},
						"DBClusterIdentifier": {},
						"DBClusterParameterGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1h"
						},
						"DBSubnetGroupName": {},
						"Engine": {},
						"EngineVersion": {},
						"Port": {
							"type": "integer"
						},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"OptionGroupName": {},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"ReplicationSourceIdentifier": {},
						"Tags": {
							"shape": "Sa"
						},
						"StorageEncrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1j"
						}
					}
				}
			},
			"CreateDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBClusterParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBClusterParameterGroupResult",
					"type": "structure",
					"members": {
						"DBClusterParameterGroup": {
							"shape": "Sr"
						}
					}
				}
			},
			"CreateDBClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterSnapshotIdentifier",
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterSnapshotIdentifier": {},
						"DBClusterIdentifier": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBClusterSnapshotResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshot": {
							"shape": "Su"
						}
					}
				}
			},
			"CreateDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBInstanceClass",
						"Engine"
					],
					"members": {
						"DBName": {},
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"Engine": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"DBSecurityGroups": {
							"shape": "S1w"
						},
						"VpcSecurityGroupIds": {
							"shape": "S1h"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"PreferredMaintenanceWindow": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"Port": {
							"type": "integer"
						},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CharacterSetName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sa"
						},
						"DBClusterIdentifier": {},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {},
						"StorageEncrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {},
						"Domain": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"MonitoringInterval": {
							"type": "integer"
						},
						"MonitoringRoleArn": {},
						"DomainIAMRoleName": {},
						"PromotionTier": {
							"type": "integer"
						},
						"Timezone": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S1y"
						}
					}
				}
			},
			"CreateDBInstanceReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"SourceDBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SourceDBInstanceIdentifier": {},
						"DBInstanceClass": {},
						"AvailabilityZone": {},
						"Port": {
							"type": "integer"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sa"
						},
						"DBSubnetGroupName": {},
						"StorageType": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"MonitoringInterval": {
							"type": "integer"
						},
						"MonitoringRoleArn": {},
						"KmsKeyId": {},
						"PreSignedUrl": {}
					}
				},
				"output": {
					"resultWrapper": "CreateDBInstanceReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S1y"
						}
					}
				}
			},
			"CreateDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"DBParameterGroupFamily",
						"Description"
					],
					"members": {
						"DBParameterGroupName": {},
						"DBParameterGroupFamily": {},
						"Description": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBParameterGroupResult",
					"type": "structure",
					"members": {
						"DBParameterGroup": {
							"shape": "Sz"
						}
					}
				}
			},
			"CreateDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName",
						"DBSecurityGroupDescription"
					],
					"members": {
						"DBSecurityGroupName": {},
						"DBSecurityGroupDescription": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSecurityGroupResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sk"
						}
					}
				}
			},
			"CreateDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"DBInstanceIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"DBInstanceIdentifier": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "S13"
						}
					}
				}
			},
			"CreateDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"DBSubnetGroupDescription",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S2o"
						},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S22"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S7"
						},
						"SourceIds": {
							"shape": "S6"
						},
						"Enabled": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S5"
						}
					}
				}
			},
			"CreateOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName",
						"EngineName",
						"MajorEngineVersion",
						"OptionGroupDescription"
					],
					"members": {
						"OptionGroupName": {},
						"EngineName": {},
						"MajorEngineVersion": {},
						"OptionGroupDescription": {},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S17"
						}
					}
				}
			},
			"DeleteDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1j"
						}
					}
				}
			},
			"DeleteDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName"
					],
					"members": {
						"DBClusterParameterGroupName": {}
					}
				}
			},
			"DeleteDBClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterSnapshotIdentifier"
					],
					"members": {
						"DBClusterSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBClusterSnapshotResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshot": {
							"shape": "Su"
						}
					}
				}
			},
			"DeleteDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"SkipFinalSnapshot": {
							"type": "boolean"
						},
						"FinalDBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S1y"
						}
					}
				}
			},
			"DeleteDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {}
					}
				}
			},
			"DeleteDBSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {}
					}
				}
			},
			"DeleteDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "S13"
						}
					}
				}
			},
			"DeleteDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName"
					],
					"members": {
						"DBSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S5"
						}
					}
				}
			},
			"DeleteOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {}
					}
				}
			},
			"DescribeAccountAttributes": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "DescribeAccountAttributesResult",
					"type": "structure",
					"members": {
						"AccountQuotas": {
							"type": "list",
							"member": {
								"locationName": "AccountQuota",
								"type": "structure",
								"members": {
									"AccountQuotaName": {},
									"Used": {
										"type": "long"
									},
									"Max": {
										"type": "long"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeCertificates": {
				"input": {
					"type": "structure",
					"members": {
						"CertificateIdentifier": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeCertificatesResult",
					"type": "structure",
					"members": {
						"Certificates": {
							"type": "list",
							"member": {
								"locationName": "Certificate",
								"type": "structure",
								"members": {
									"CertificateIdentifier": {},
									"CertificateType": {},
									"Thumbprint": {},
									"ValidFrom": {
										"type": "timestamp"
									},
									"ValidTill": {
										"type": "timestamp"
									},
									"CertificateArn": {}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBClusterParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBClusterParameterGroupName": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBClusterParameterGroups": {
							"type": "list",
							"member": {
								"shape": "Sr",
								"locationName": "DBClusterParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBClusterParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName"
					],
					"members": {
						"DBClusterParameterGroupName": {},
						"Source": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S3q"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBClusterSnapshotAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterSnapshotIdentifier"
					],
					"members": {
						"DBClusterSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterSnapshotAttributesResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshotAttributesResult": {
							"shape": "S3v"
						}
					}
				}
			},
			"DescribeDBClusterSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBClusterIdentifier": {},
						"DBClusterSnapshotIdentifier": {},
						"SnapshotType": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"IncludeShared": {
							"type": "boolean"
						},
						"IncludePublic": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClusterSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBClusterSnapshots": {
							"type": "list",
							"member": {
								"shape": "Su",
								"locationName": "DBClusterSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBClusters": {
				"input": {
					"type": "structure",
					"members": {
						"DBClusterIdentifier": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBClustersResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBClusters": {
							"type": "list",
							"member": {
								"shape": "S1j",
								"locationName": "DBCluster"
							}
						}
					}
				}
			},
			"DescribeDBEngineVersions": {
				"input": {
					"type": "structure",
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"DefaultOnly": {
							"type": "boolean"
						},
						"ListSupportedCharacterSets": {
							"type": "boolean"
						},
						"ListSupportedTimezones": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBEngineVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBEngineVersions": {
							"type": "list",
							"member": {
								"locationName": "DBEngineVersion",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBParameterGroupFamily": {},
									"DBEngineDescription": {},
									"DBEngineVersionDescription": {},
									"DefaultCharacterSet": {
										"shape": "S49"
									},
									"SupportedCharacterSets": {
										"type": "list",
										"member": {
											"shape": "S49",
											"locationName": "CharacterSet"
										}
									},
									"ValidUpgradeTarget": {
										"type": "list",
										"member": {
											"locationName": "UpgradeTarget",
											"type": "structure",
											"members": {
												"Engine": {},
												"EngineVersion": {},
												"Description": {},
												"AutoUpgrade": {
													"type": "boolean"
												},
												"IsMajorVersionUpgrade": {
													"type": "boolean"
												}
											}
										}
									},
									"SupportedTimezones": {
										"type": "list",
										"member": {
											"locationName": "Timezone",
											"type": "structure",
											"members": {
												"TimezoneName": {}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"DescribeDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBInstances": {
							"type": "list",
							"member": {
								"shape": "S1y",
								"locationName": "DBInstance"
							}
						}
					}
				}
			},
			"DescribeDBLogFiles": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"FilenameContains": {},
						"FileLastWritten": {
							"type": "long"
						},
						"FileSize": {
							"type": "long"
						},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBLogFilesResult",
					"type": "structure",
					"members": {
						"DescribeDBLogFiles": {
							"type": "list",
							"member": {
								"locationName": "DescribeDBLogFilesDetails",
								"type": "structure",
								"members": {
									"LogFileName": {},
									"LastWritten": {
										"type": "long"
									},
									"Size": {
										"type": "long"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBParameterGroupName": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBParameterGroups": {
							"type": "list",
							"member": {
								"shape": "Sz",
								"locationName": "DBParameterGroup"
							}
						}
					}
				}
			},
			"DescribeDBParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"Source": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S3q"
						},
						"Marker": {}
					}
				}
			},
			"DescribeDBSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "Sk",
								"locationName": "DBSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeDBSnapshotAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotAttributesResult",
					"type": "structure",
					"members": {
						"DBSnapshotAttributesResult": {
							"shape": "S4w"
						}
					}
				}
			},
			"DescribeDBSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"SnapshotType": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"IncludeShared": {
							"type": "boolean"
						},
						"IncludePublic": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSnapshots": {
							"type": "list",
							"member": {
								"shape": "S13",
								"locationName": "DBSnapshot"
							}
						}
					}
				}
			},
			"DescribeDBSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"DBSubnetGroupName": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDBSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"DBSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S22",
								"locationName": "DBSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeEngineDefaultClusterParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultClusterParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"shape": "S57"
						}
					}
				}
			},
			"DescribeEngineDefaultParameters": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupFamily"
					],
					"members": {
						"DBParameterGroupFamily": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEngineDefaultParametersResult",
					"type": "structure",
					"members": {
						"EngineDefaults": {
							"shape": "S57"
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {},
						"Filters": {
							"shape": "S3f"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"EventCategories": {
										"shape": "S7"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S5",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"EventCategories": {
							"shape": "S7"
						},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S7"
									},
									"Date": {
										"type": "timestamp"
									},
									"SourceArn": {}
								}
							}
						}
					}
				}
			},
			"DescribeOptionGroupOptions": {
				"input": {
					"type": "structure",
					"required": [
						"EngineName"
					],
					"members": {
						"EngineName": {},
						"MajorEngineVersion": {},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupOptionsResult",
					"type": "structure",
					"members": {
						"OptionGroupOptions": {
							"type": "list",
							"member": {
								"locationName": "OptionGroupOption",
								"type": "structure",
								"members": {
									"Name": {},
									"Description": {},
									"EngineName": {},
									"MajorEngineVersion": {},
									"MinimumRequiredMinorEngineVersion": {},
									"PortRequired": {
										"type": "boolean"
									},
									"DefaultPort": {
										"type": "integer"
									},
									"OptionsDependedOn": {
										"type": "list",
										"member": {
											"locationName": "OptionName"
										}
									},
									"OptionsConflictsWith": {
										"type": "list",
										"member": {
											"locationName": "OptionConflictName"
										}
									},
									"Persistent": {
										"type": "boolean"
									},
									"Permanent": {
										"type": "boolean"
									},
									"OptionGroupOptionSettings": {
										"type": "list",
										"member": {
											"locationName": "OptionGroupOptionSetting",
											"type": "structure",
											"members": {
												"SettingName": {},
												"SettingDescription": {},
												"DefaultValue": {},
												"ApplyType": {},
												"AllowedValues": {},
												"IsModifiable": {
													"type": "boolean"
												}
											}
										}
									},
									"OptionGroupOptionVersions": {
										"type": "list",
										"member": {
											"locationName": "OptionVersion",
											"type": "structure",
											"members": {
												"Version": {},
												"IsDefault": {
													"type": "boolean"
												}
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOptionGroups": {
				"input": {
					"type": "structure",
					"members": {
						"OptionGroupName": {},
						"Filters": {
							"shape": "S3f"
						},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						},
						"EngineName": {},
						"MajorEngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOptionGroupsResult",
					"type": "structure",
					"members": {
						"OptionGroupsList": {
							"type": "list",
							"member": {
								"shape": "S17",
								"locationName": "OptionGroup"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeOrderableDBInstanceOptions": {
				"input": {
					"type": "structure",
					"required": [
						"Engine"
					],
					"members": {
						"Engine": {},
						"EngineVersion": {},
						"DBInstanceClass": {},
						"LicenseModel": {},
						"Vpc": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableDBInstanceOptionsResult",
					"type": "structure",
					"members": {
						"OrderableDBInstanceOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableDBInstanceOption",
								"type": "structure",
								"members": {
									"Engine": {},
									"EngineVersion": {},
									"DBInstanceClass": {},
									"LicenseModel": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S25",
											"locationName": "AvailabilityZone"
										}
									},
									"MultiAZCapable": {
										"type": "boolean"
									},
									"ReadReplicaCapable": {
										"type": "boolean"
									},
									"Vpc": {
										"type": "boolean"
									},
									"SupportsStorageEncryption": {
										"type": "boolean"
									},
									"StorageType": {},
									"SupportsIops": {
										"type": "boolean"
									},
									"SupportsEnhancedMonitoring": {
										"type": "boolean"
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribePendingMaintenanceActions": {
				"input": {
					"type": "structure",
					"members": {
						"ResourceIdentifier": {},
						"Filters": {
							"shape": "S3f"
						},
						"Marker": {},
						"MaxRecords": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribePendingMaintenanceActionsResult",
					"type": "structure",
					"members": {
						"PendingMaintenanceActions": {
							"type": "list",
							"member": {
								"shape": "Se",
								"locationName": "ResourcePendingMaintenanceActions"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedDBInstances": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstanceId": {},
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstances": {
							"type": "list",
							"member": {
								"shape": "S6a",
								"locationName": "ReservedDBInstance"
							}
						}
					}
				}
			},
			"DescribeReservedDBInstancesOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"DBInstanceClass": {},
						"Duration": {},
						"ProductDescription": {},
						"OfferingType": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"Filters": {
							"shape": "S3f"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedDBInstancesOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedDBInstancesOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedDBInstancesOffering",
								"type": "structure",
								"members": {
									"ReservedDBInstancesOfferingId": {},
									"DBInstanceClass": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"ProductDescription": {},
									"OfferingType": {},
									"MultiAZ": {
										"type": "boolean"
									},
									"RecurringCharges": {
										"shape": "S6c"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeSourceRegions": {
				"input": {
					"type": "structure",
					"members": {
						"RegionName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"Filters": {
							"shape": "S3f"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeSourceRegionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"SourceRegions": {
							"type": "list",
							"member": {
								"locationName": "SourceRegion",
								"type": "structure",
								"members": {
									"RegionName": {},
									"Endpoint": {},
									"Status": {}
								}
							}
						}
					}
				}
			},
			"DownloadDBLogFilePortion": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"LogFileName"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"LogFileName": {},
						"Marker": {},
						"NumberOfLines": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "DownloadDBLogFilePortionResult",
					"type": "structure",
					"members": {
						"LogFileData": {},
						"Marker": {},
						"AdditionalDataPending": {
							"type": "boolean"
						}
					}
				}
			},
			"FailoverDBCluster": {
				"input": {
					"type": "structure",
					"members": {
						"DBClusterIdentifier": {},
						"TargetDBInstanceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "FailoverDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1j"
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName"
					],
					"members": {
						"ResourceName": {},
						"Filters": {
							"shape": "S3f"
						}
					}
				},
				"output": {
					"resultWrapper": "ListTagsForResourceResult",
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "Sa"
						}
					}
				}
			},
			"ModifyDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {},
						"NewDBClusterIdentifier": {},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"DBClusterParameterGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1h"
						},
						"Port": {
							"type": "integer"
						},
						"MasterUserPassword": {},
						"OptionGroupName": {},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1j"
						}
					}
				}
			},
			"ModifyDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBClusterParameterGroupName": {},
						"Parameters": {
							"shape": "S3q"
						}
					}
				},
				"output": {
					"shape": "S6v",
					"resultWrapper": "ModifyDBClusterParameterGroupResult"
				}
			},
			"ModifyDBClusterSnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterSnapshotIdentifier",
						"AttributeName"
					],
					"members": {
						"DBClusterSnapshotIdentifier": {},
						"AttributeName": {},
						"ValuesToAdd": {
							"shape": "S3y"
						},
						"ValuesToRemove": {
							"shape": "S3y"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBClusterSnapshotAttributeResult",
					"type": "structure",
					"members": {
						"DBClusterSnapshotAttributesResult": {
							"shape": "S3v"
						}
					}
				}
			},
			"ModifyDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"AllocatedStorage": {
							"type": "integer"
						},
						"DBInstanceClass": {},
						"DBSubnetGroupName": {},
						"DBSecurityGroups": {
							"shape": "S1w"
						},
						"VpcSecurityGroupIds": {
							"shape": "S1h"
						},
						"ApplyImmediately": {
							"type": "boolean"
						},
						"MasterUserPassword": {},
						"DBParameterGroupName": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"EngineVersion": {},
						"AllowMajorVersionUpgrade": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"NewDBInstanceIdentifier": {},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {},
						"CACertificateIdentifier": {},
						"Domain": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"MonitoringInterval": {
							"type": "integer"
						},
						"DBPortNumber": {
							"type": "integer"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"MonitoringRoleArn": {},
						"DomainIAMRoleName": {},
						"PromotionTier": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S1y"
						}
					}
				}
			},
			"ModifyDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName",
						"Parameters"
					],
					"members": {
						"DBParameterGroupName": {},
						"Parameters": {
							"shape": "S3q"
						}
					}
				},
				"output": {
					"shape": "S71",
					"resultWrapper": "ModifyDBParameterGroupResult"
				}
			},
			"ModifyDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"EngineVersion": {}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBSnapshot": {
							"shape": "S13"
						}
					}
				}
			},
			"ModifyDBSnapshotAttribute": {
				"input": {
					"type": "structure",
					"required": [
						"DBSnapshotIdentifier",
						"AttributeName"
					],
					"members": {
						"DBSnapshotIdentifier": {},
						"AttributeName": {},
						"ValuesToAdd": {
							"shape": "S3y"
						},
						"ValuesToRemove": {
							"shape": "S3y"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSnapshotAttributeResult",
					"type": "structure",
					"members": {
						"DBSnapshotAttributesResult": {
							"shape": "S4w"
						}
					}
				}
			},
			"ModifyDBSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"DBSubnetGroupName": {},
						"DBSubnetGroupDescription": {},
						"SubnetIds": {
							"shape": "S2o"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyDBSubnetGroupResult",
					"type": "structure",
					"members": {
						"DBSubnetGroup": {
							"shape": "S22"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"EventCategories": {
							"shape": "S7"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S5"
						}
					}
				}
			},
			"ModifyOptionGroup": {
				"input": {
					"type": "structure",
					"required": [
						"OptionGroupName"
					],
					"members": {
						"OptionGroupName": {},
						"OptionsToInclude": {
							"type": "list",
							"member": {
								"locationName": "OptionConfiguration",
								"type": "structure",
								"required": [
									"OptionName"
								],
								"members": {
									"OptionName": {},
									"Port": {
										"type": "integer"
									},
									"OptionVersion": {},
									"DBSecurityGroupMemberships": {
										"shape": "S1w"
									},
									"VpcSecurityGroupMemberships": {
										"shape": "S1h"
									},
									"OptionSettings": {
										"type": "list",
										"member": {
											"shape": "S1b",
											"locationName": "OptionSetting"
										}
									}
								}
							}
						},
						"OptionsToRemove": {
							"type": "list",
							"member": {}
						},
						"ApplyImmediately": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyOptionGroupResult",
					"type": "structure",
					"members": {
						"OptionGroup": {
							"shape": "S17"
						}
					}
				}
			},
			"PromoteReadReplica": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"PreferredBackupWindow": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S1y"
						}
					}
				}
			},
			"PromoteReadReplicaDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "PromoteReadReplicaDBClusterResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1j"
						}
					}
				}
			},
			"PurchaseReservedDBInstancesOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedDBInstancesOfferingId"
					],
					"members": {
						"ReservedDBInstancesOfferingId": {},
						"ReservedDBInstanceId": {},
						"DBInstanceCount": {
							"type": "integer"
						},
						"Tags": {
							"shape": "Sa"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedDBInstancesOfferingResult",
					"type": "structure",
					"members": {
						"ReservedDBInstance": {
							"shape": "S6a"
						}
					}
				}
			},
			"RebootDBInstance": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"ForceFailover": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "RebootDBInstanceResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S1y"
						}
					}
				}
			},
			"RemoveRoleFromDBCluster": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"RoleArn"
					],
					"members": {
						"DBClusterIdentifier": {},
						"RoleArn": {}
					}
				}
			},
			"RemoveSourceIdentifierFromSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SourceIdentifier"
					],
					"members": {
						"SubscriptionName": {},
						"SourceIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RemoveSourceIdentifierFromSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S5"
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ResetDBClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterParameterGroupName"
					],
					"members": {
						"DBClusterParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S3q"
						}
					}
				},
				"output": {
					"shape": "S6v",
					"resultWrapper": "ResetDBClusterParameterGroupResult"
				}
			},
			"ResetDBParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"DBParameterGroupName"
					],
					"members": {
						"DBParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S3q"
						}
					}
				},
				"output": {
					"shape": "S71",
					"resultWrapper": "ResetDBParameterGroupResult"
				}
			},
			"RestoreDBClusterFromS3": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"Engine",
						"MasterUsername",
						"MasterUserPassword",
						"SourceEngine",
						"SourceEngineVersion",
						"S3BucketName",
						"S3IngestionRoleArn"
					],
					"members": {
						"AvailabilityZones": {
							"shape": "Sv"
						},
						"BackupRetentionPeriod": {
							"type": "integer"
						},
						"CharacterSetName": {},
						"DatabaseName": {},
						"DBClusterIdentifier": {},
						"DBClusterParameterGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1h"
						},
						"DBSubnetGroupName": {},
						"Engine": {},
						"EngineVersion": {},
						"Port": {
							"type": "integer"
						},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"OptionGroupName": {},
						"PreferredBackupWindow": {},
						"PreferredMaintenanceWindow": {},
						"Tags": {
							"shape": "Sa"
						},
						"StorageEncrypted": {
							"type": "boolean"
						},
						"KmsKeyId": {},
						"SourceEngine": {},
						"SourceEngineVersion": {},
						"S3BucketName": {},
						"S3Prefix": {},
						"S3IngestionRoleArn": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBClusterFromS3Result",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1j"
						}
					}
				}
			},
			"RestoreDBClusterFromSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"SnapshotIdentifier",
						"Engine"
					],
					"members": {
						"AvailabilityZones": {
							"shape": "Sv"
						},
						"DBClusterIdentifier": {},
						"SnapshotIdentifier": {},
						"Engine": {},
						"EngineVersion": {},
						"Port": {
							"type": "integer"
						},
						"DBSubnetGroupName": {},
						"DatabaseName": {},
						"OptionGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1h"
						},
						"Tags": {
							"shape": "Sa"
						},
						"KmsKeyId": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBClusterFromSnapshotResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1j"
						}
					}
				}
			},
			"RestoreDBClusterToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"DBClusterIdentifier",
						"SourceDBClusterIdentifier"
					],
					"members": {
						"DBClusterIdentifier": {},
						"SourceDBClusterIdentifier": {},
						"RestoreToTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"Port": {
							"type": "integer"
						},
						"DBSubnetGroupName": {},
						"OptionGroupName": {},
						"VpcSecurityGroupIds": {
							"shape": "S1h"
						},
						"Tags": {
							"shape": "Sa"
						},
						"KmsKeyId": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBClusterToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBCluster": {
							"shape": "S1j"
						}
					}
				}
			},
			"RestoreDBInstanceFromDBSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"DBInstanceIdentifier",
						"DBSnapshotIdentifier"
					],
					"members": {
						"DBInstanceIdentifier": {},
						"DBSnapshotIdentifier": {},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"Tags": {
							"shape": "Sa"
						},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {},
						"Domain": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"DomainIAMRoleName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceFromDBSnapshotResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S1y"
						}
					}
				}
			},
			"RestoreDBInstanceToPointInTime": {
				"input": {
					"type": "structure",
					"required": [
						"SourceDBInstanceIdentifier",
						"TargetDBInstanceIdentifier"
					],
					"members": {
						"SourceDBInstanceIdentifier": {},
						"TargetDBInstanceIdentifier": {},
						"RestoreTime": {
							"type": "timestamp"
						},
						"UseLatestRestorableTime": {
							"type": "boolean"
						},
						"DBInstanceClass": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"DBSubnetGroupName": {},
						"MultiAZ": {
							"type": "boolean"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"AutoMinorVersionUpgrade": {
							"type": "boolean"
						},
						"LicenseModel": {},
						"DBName": {},
						"Engine": {},
						"Iops": {
							"type": "integer"
						},
						"OptionGroupName": {},
						"CopyTagsToSnapshot": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "Sa"
						},
						"StorageType": {},
						"TdeCredentialArn": {},
						"TdeCredentialPassword": {},
						"Domain": {},
						"DomainIAMRoleName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreDBInstanceToPointInTimeResult",
					"type": "structure",
					"members": {
						"DBInstance": {
							"shape": "S1y"
						}
					}
				}
			},
			"RevokeDBSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"DBSecurityGroupName"
					],
					"members": {
						"DBSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupId": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeDBSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"DBSecurityGroup": {
							"shape": "Sk"
						}
					}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "structure",
				"members": {
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S6"
					},
					"EventCategoriesList": {
						"shape": "S7"
					},
					"Enabled": {
						"type": "boolean"
					},
					"EventSubscriptionArn": {}
				},
				"wrapper": true
			},
			"S6": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S7": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"Sa": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Se": {
				"type": "structure",
				"members": {
					"ResourceIdentifier": {},
					"PendingMaintenanceActionDetails": {
						"type": "list",
						"member": {
							"locationName": "PendingMaintenanceAction",
							"type": "structure",
							"members": {
								"Action": {},
								"AutoAppliedAfterDate": {
									"type": "timestamp"
								},
								"ForcedApplyDate": {
									"type": "timestamp"
								},
								"OptInStatus": {},
								"CurrentApplyDate": {
									"type": "timestamp"
								},
								"Description": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"Sk": {
				"type": "structure",
				"members": {
					"OwnerId": {},
					"DBSecurityGroupName": {},
					"DBSecurityGroupDescription": {},
					"VpcId": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupId": {},
								"EC2SecurityGroupOwnerId": {}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {}
							}
						}
					},
					"DBSecurityGroupArn": {}
				},
				"wrapper": true
			},
			"Sr": {
				"type": "structure",
				"members": {
					"DBClusterParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {},
					"DBClusterParameterGroupArn": {}
				},
				"wrapper": true
			},
			"Su": {
				"type": "structure",
				"members": {
					"AvailabilityZones": {
						"shape": "Sv"
					},
					"DBClusterSnapshotIdentifier": {},
					"DBClusterIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"VpcId": {},
					"ClusterCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"PercentProgress": {
						"type": "integer"
					},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"DBClusterSnapshotArn": {}
				},
				"wrapper": true
			},
			"Sv": {
				"type": "list",
				"member": {
					"locationName": "AvailabilityZone"
				}
			},
			"Sz": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {},
					"DBParameterGroupFamily": {},
					"Description": {},
					"DBParameterGroupArn": {}
				},
				"wrapper": true
			},
			"S13": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBInstanceIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Engine": {},
					"AllocatedStorage": {
						"type": "integer"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"VpcId": {},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"EngineVersion": {},
					"LicenseModel": {},
					"SnapshotType": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupName": {},
					"PercentProgress": {
						"type": "integer"
					},
					"SourceRegion": {},
					"SourceDBSnapshotIdentifier": {},
					"StorageType": {},
					"TdeCredentialArn": {},
					"Encrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"DBSnapshotArn": {},
					"Timezone": {}
				},
				"wrapper": true
			},
			"S17": {
				"type": "structure",
				"members": {
					"OptionGroupName": {},
					"OptionGroupDescription": {},
					"EngineName": {},
					"MajorEngineVersion": {},
					"Options": {
						"type": "list",
						"member": {
							"locationName": "Option",
							"type": "structure",
							"members": {
								"OptionName": {},
								"OptionDescription": {},
								"Persistent": {
									"type": "boolean"
								},
								"Permanent": {
									"type": "boolean"
								},
								"Port": {
									"type": "integer"
								},
								"OptionVersion": {},
								"OptionSettings": {
									"type": "list",
									"member": {
										"shape": "S1b",
										"locationName": "OptionSetting"
									}
								},
								"DBSecurityGroupMemberships": {
									"shape": "S1c"
								},
								"VpcSecurityGroupMemberships": {
									"shape": "S1e"
								}
							}
						}
					},
					"AllowsVpcAndNonVpcInstanceMemberships": {
						"type": "boolean"
					},
					"VpcId": {},
					"OptionGroupArn": {}
				},
				"wrapper": true
			},
			"S1b": {
				"type": "structure",
				"members": {
					"Name": {},
					"Value": {},
					"DefaultValue": {},
					"Description": {},
					"ApplyType": {},
					"DataType": {},
					"AllowedValues": {},
					"IsModifiable": {
						"type": "boolean"
					},
					"IsCollection": {
						"type": "boolean"
					}
				}
			},
			"S1c": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroup",
					"type": "structure",
					"members": {
						"DBSecurityGroupName": {},
						"Status": {}
					}
				}
			},
			"S1e": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupMembership",
					"type": "structure",
					"members": {
						"VpcSecurityGroupId": {},
						"Status": {}
					}
				}
			},
			"S1h": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"S1j": {
				"type": "structure",
				"members": {
					"AllocatedStorage": {
						"type": "integer"
					},
					"AvailabilityZones": {
						"shape": "Sv"
					},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"CharacterSetName": {},
					"DatabaseName": {},
					"DBClusterIdentifier": {},
					"DBClusterParameterGroup": {},
					"DBSubnetGroup": {},
					"Status": {},
					"PercentProgress": {},
					"EarliestRestorableTime": {
						"type": "timestamp"
					},
					"Endpoint": {},
					"ReaderEndpoint": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"Engine": {},
					"EngineVersion": {},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"Port": {
						"type": "integer"
					},
					"MasterUsername": {},
					"DBClusterOptionGroupMemberships": {
						"type": "list",
						"member": {
							"locationName": "DBClusterOptionGroup",
							"type": "structure",
							"members": {
								"DBClusterOptionGroupName": {},
								"Status": {}
							}
						}
					},
					"PreferredBackupWindow": {},
					"PreferredMaintenanceWindow": {},
					"ReplicationSourceIdentifier": {},
					"ReadReplicaIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaIdentifier"
						}
					},
					"DBClusterMembers": {
						"type": "list",
						"member": {
							"locationName": "DBClusterMember",
							"type": "structure",
							"members": {
								"DBInstanceIdentifier": {},
								"IsClusterWriter": {
									"type": "boolean"
								},
								"DBClusterParameterGroupStatus": {},
								"PromotionTier": {
									"type": "integer"
								}
							},
							"wrapper": true
						}
					},
					"VpcSecurityGroups": {
						"shape": "S1e"
					},
					"HostedZoneId": {},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"DbClusterResourceId": {},
					"DBClusterArn": {},
					"AssociatedRoles": {
						"type": "list",
						"member": {
							"locationName": "DBClusterRole",
							"type": "structure",
							"members": {
								"RoleArn": {},
								"Status": {}
							}
						}
					},
					"ClusterCreateTime": {
						"type": "timestamp"
					}
				},
				"wrapper": true
			},
			"S1w": {
				"type": "list",
				"member": {
					"locationName": "DBSecurityGroupName"
				}
			},
			"S1y": {
				"type": "structure",
				"members": {
					"DBInstanceIdentifier": {},
					"DBInstanceClass": {},
					"Engine": {},
					"DBInstanceStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							},
							"HostedZoneId": {}
						}
					},
					"AllocatedStorage": {
						"type": "integer"
					},
					"InstanceCreateTime": {
						"type": "timestamp"
					},
					"PreferredBackupWindow": {},
					"BackupRetentionPeriod": {
						"type": "integer"
					},
					"DBSecurityGroups": {
						"shape": "S1c"
					},
					"VpcSecurityGroups": {
						"shape": "S1e"
					},
					"DBParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "DBParameterGroup",
							"type": "structure",
							"members": {
								"DBParameterGroupName": {},
								"ParameterApplyStatus": {}
							}
						}
					},
					"AvailabilityZone": {},
					"DBSubnetGroup": {
						"shape": "S22"
					},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"DBInstanceClass": {},
							"AllocatedStorage": {
								"type": "integer"
							},
							"MasterUserPassword": {},
							"Port": {
								"type": "integer"
							},
							"BackupRetentionPeriod": {
								"type": "integer"
							},
							"MultiAZ": {
								"type": "boolean"
							},
							"EngineVersion": {},
							"LicenseModel": {},
							"Iops": {
								"type": "integer"
							},
							"DBInstanceIdentifier": {},
							"StorageType": {},
							"CACertificateIdentifier": {},
							"DBSubnetGroupName": {}
						}
					},
					"LatestRestorableTime": {
						"type": "timestamp"
					},
					"MultiAZ": {
						"type": "boolean"
					},
					"EngineVersion": {},
					"AutoMinorVersionUpgrade": {
						"type": "boolean"
					},
					"ReadReplicaSourceDBInstanceIdentifier": {},
					"ReadReplicaDBInstanceIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBInstanceIdentifier"
						}
					},
					"ReadReplicaDBClusterIdentifiers": {
						"type": "list",
						"member": {
							"locationName": "ReadReplicaDBClusterIdentifier"
						}
					},
					"LicenseModel": {},
					"Iops": {
						"type": "integer"
					},
					"OptionGroupMemberships": {
						"type": "list",
						"member": {
							"locationName": "OptionGroupMembership",
							"type": "structure",
							"members": {
								"OptionGroupName": {},
								"Status": {}
							}
						}
					},
					"CharacterSetName": {},
					"SecondaryAvailabilityZone": {},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"StatusInfos": {
						"type": "list",
						"member": {
							"locationName": "DBInstanceStatusInfo",
							"type": "structure",
							"members": {
								"StatusType": {},
								"Normal": {
									"type": "boolean"
								},
								"Status": {},
								"Message": {}
							}
						}
					},
					"StorageType": {},
					"TdeCredentialArn": {},
					"DbInstancePort": {
						"type": "integer"
					},
					"DBClusterIdentifier": {},
					"StorageEncrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"DbiResourceId": {},
					"CACertificateIdentifier": {},
					"DomainMemberships": {
						"type": "list",
						"member": {
							"locationName": "DomainMembership",
							"type": "structure",
							"members": {
								"Domain": {},
								"Status": {},
								"FQDN": {},
								"IAMRoleName": {}
							}
						}
					},
					"CopyTagsToSnapshot": {
						"type": "boolean"
					},
					"MonitoringInterval": {
						"type": "integer"
					},
					"EnhancedMonitoringResourceArn": {},
					"MonitoringRoleArn": {},
					"PromotionTier": {
						"type": "integer"
					},
					"DBInstanceArn": {},
					"Timezone": {}
				},
				"wrapper": true
			},
			"S22": {
				"type": "structure",
				"members": {
					"DBSubnetGroupName": {},
					"DBSubnetGroupDescription": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S25"
								},
								"SubnetStatus": {}
							}
						}
					},
					"DBSubnetGroupArn": {}
				},
				"wrapper": true
			},
			"S25": {
				"type": "structure",
				"members": {
					"Name": {}
				},
				"wrapper": true
			},
			"S2o": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S3f": {
				"type": "list",
				"member": {
					"locationName": "Filter",
					"type": "structure",
					"required": [
						"Name",
						"Values"
					],
					"members": {
						"Name": {},
						"Values": {
							"type": "list",
							"member": {
								"locationName": "Value"
							}
						}
					}
				}
			},
			"S3q": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"ApplyType": {},
						"DataType": {},
						"AllowedValues": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {},
						"ApplyMethod": {}
					}
				}
			},
			"S3v": {
				"type": "structure",
				"members": {
					"DBClusterSnapshotIdentifier": {},
					"DBClusterSnapshotAttributes": {
						"type": "list",
						"member": {
							"locationName": "DBClusterSnapshotAttribute",
							"type": "structure",
							"members": {
								"AttributeName": {},
								"AttributeValues": {
									"shape": "S3y"
								}
							}
						}
					}
				},
				"wrapper": true
			},
			"S3y": {
				"type": "list",
				"member": {
					"locationName": "AttributeValue"
				}
			},
			"S49": {
				"type": "structure",
				"members": {
					"CharacterSetName": {},
					"CharacterSetDescription": {}
				}
			},
			"S4w": {
				"type": "structure",
				"members": {
					"DBSnapshotIdentifier": {},
					"DBSnapshotAttributes": {
						"type": "list",
						"member": {
							"locationName": "DBSnapshotAttribute",
							"type": "structure",
							"members": {
								"AttributeName": {},
								"AttributeValues": {
									"shape": "S3y"
								}
							},
							"wrapper": true
						}
					}
				},
				"wrapper": true
			},
			"S57": {
				"type": "structure",
				"members": {
					"DBParameterGroupFamily": {},
					"Marker": {},
					"Parameters": {
						"shape": "S3q"
					}
				},
				"wrapper": true
			},
			"S6a": {
				"type": "structure",
				"members": {
					"ReservedDBInstanceId": {},
					"ReservedDBInstancesOfferingId": {},
					"DBInstanceClass": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"DBInstanceCount": {
						"type": "integer"
					},
					"ProductDescription": {},
					"OfferingType": {},
					"MultiAZ": {
						"type": "boolean"
					},
					"State": {},
					"RecurringCharges": {
						"shape": "S6c"
					},
					"ReservedDBInstanceArn": {}
				},
				"wrapper": true
			},
			"S6c": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S6v": {
				"type": "structure",
				"members": {
					"DBClusterParameterGroupName": {}
				}
			},
			"S71": {
				"type": "structure",
				"members": {
					"DBParameterGroupName": {}
				}
			}
		}
	};

/***/ },
/* 741 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeDBEngineVersions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBEngineVersions"
			},
			"DescribeDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBInstances"
			},
			"DescribeDBLogFiles": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DescribeDBLogFiles"
			},
			"DescribeDBParameterGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBParameterGroups"
			},
			"DescribeDBParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Parameters"
			},
			"DescribeDBSecurityGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSecurityGroups"
			},
			"DescribeDBSnapshots": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSnapshots"
			},
			"DescribeDBSubnetGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "DBSubnetGroups"
			},
			"DescribeEngineDefaultParameters": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "EngineDefaults.Marker",
				"result_key": "EngineDefaults.Parameters"
			},
			"DescribeEventSubscriptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "EventSubscriptionsList"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "Events"
			},
			"DescribeOptionGroupOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupOptions"
			},
			"DescribeOptionGroups": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OptionGroupsList"
			},
			"DescribeOrderableDBInstanceOptions": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "OrderableDBInstanceOptions"
			},
			"DescribeReservedDBInstances": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstances"
			},
			"DescribeReservedDBInstancesOfferings": {
				"input_token": "Marker",
				"limit_key": "MaxRecords",
				"output_token": "Marker",
				"result_key": "ReservedDBInstancesOfferings"
			},
			"DownloadDBLogFilePortion": {
				"input_token": "Marker",
				"limit_key": "NumberOfLines",
				"more_results": "AdditionalDataPending",
				"output_token": "Marker",
				"result_key": "LogFileData"
			},
			"ListTagsForResource": {
				"result_key": "TagList"
			}
		}
	};

/***/ },
/* 742 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"DBInstanceAvailable": {
				"delay": 30,
				"operation": "DescribeDBInstances",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-restore",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "incompatible-parameters",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					}
				]
			},
			"DBInstanceDeleted": {
				"delay": 30,
				"operation": "DescribeDBInstances",
				"maxAttempts": 60,
				"acceptors": [
					{
						"expected": "deleted",
						"matcher": "pathAll",
						"state": "success",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "DBInstanceNotFound",
						"matcher": "error",
						"state": "success"
					},
					{
						"expected": "creating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "modifying",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "rebooting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					},
					{
						"expected": "resetting-master-credentials",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "DBInstances[].DBInstanceStatus"
					}
				]
			}
		}
	};

/***/ },
/* 743 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "redshift-2012-12-01",
			"apiVersion": "2012-12-01",
			"endpointPrefix": "redshift",
			"protocol": "query",
			"serviceFullName": "Amazon Redshift",
			"signatureVersion": "v4",
			"xmlNamespace": "http://redshift.amazonaws.com/doc/2012-12-01/"
		},
		"operations": {
			"AuthorizeClusterSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSecurityGroupName"
					],
					"members": {
						"ClusterSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeClusterSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"ClusterSecurityGroup": {
							"shape": "S4"
						}
					}
				}
			},
			"AuthorizeSnapshotAccess": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotIdentifier",
						"AccountWithRestoreAccess"
					],
					"members": {
						"SnapshotIdentifier": {},
						"SnapshotClusterIdentifier": {},
						"AccountWithRestoreAccess": {}
					}
				},
				"output": {
					"resultWrapper": "AuthorizeSnapshotAccessResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sd"
						}
					}
				}
			},
			"CopyClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SourceSnapshotIdentifier",
						"TargetSnapshotIdentifier"
					],
					"members": {
						"SourceSnapshotIdentifier": {},
						"SourceSnapshotClusterIdentifier": {},
						"TargetSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "CopyClusterSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"NodeType",
						"MasterUsername",
						"MasterUserPassword"
					],
					"members": {
						"DBName": {},
						"ClusterIdentifier": {},
						"ClusterType": {},
						"NodeType": {},
						"MasterUsername": {},
						"MasterUserPassword": {},
						"ClusterSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"ClusterSubnetGroupName": {},
						"AvailabilityZone": {},
						"PreferredMaintenanceWindow": {},
						"ClusterParameterGroupName": {},
						"AutomatedSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"Port": {
							"type": "integer"
						},
						"ClusterVersion": {},
						"AllowVersionUpgrade": {
							"type": "boolean"
						},
						"NumberOfNodes": {
							"type": "integer"
						},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"Encrypted": {
							"type": "boolean"
						},
						"HsmClientCertificateIdentifier": {},
						"HsmConfigurationIdentifier": {},
						"ElasticIp": {},
						"Tags": {
							"shape": "S7"
						},
						"KmsKeyId": {},
						"EnhancedVpcRouting": {
							"type": "boolean"
						},
						"AdditionalInfo": {},
						"IamRoles": {
							"shape": "St"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			},
			"CreateClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName",
						"ParameterGroupFamily",
						"Description"
					],
					"members": {
						"ParameterGroupName": {},
						"ParameterGroupFamily": {},
						"Description": {},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterParameterGroupResult",
					"type": "structure",
					"members": {
						"ClusterParameterGroup": {
							"shape": "S1g"
						}
					}
				}
			},
			"CreateClusterSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSecurityGroupName",
						"Description"
					],
					"members": {
						"ClusterSecurityGroupName": {},
						"Description": {},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterSecurityGroupResult",
					"type": "structure",
					"members": {
						"ClusterSecurityGroup": {
							"shape": "S4"
						}
					}
				}
			},
			"CreateClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotIdentifier",
						"ClusterIdentifier"
					],
					"members": {
						"SnapshotIdentifier": {},
						"ClusterIdentifier": {},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateClusterSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSubnetGroupName",
						"Description",
						"SubnetIds"
					],
					"members": {
						"ClusterSubnetGroupName": {},
						"Description": {},
						"SubnetIds": {
							"shape": "S1m"
						},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateClusterSubnetGroupResult",
					"type": "structure",
					"members": {
						"ClusterSubnetGroup": {
							"shape": "S1o"
						}
					}
				}
			},
			"CreateEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName",
						"SnsTopicArn"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"SourceIds": {
							"shape": "S1t"
						},
						"EventCategories": {
							"shape": "S1u"
						},
						"Severity": {},
						"Enabled": {
							"type": "boolean"
						},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S1w"
						}
					}
				}
			},
			"CreateHsmClientCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"HsmClientCertificateIdentifier"
					],
					"members": {
						"HsmClientCertificateIdentifier": {},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateHsmClientCertificateResult",
					"type": "structure",
					"members": {
						"HsmClientCertificate": {
							"shape": "S1z"
						}
					}
				}
			},
			"CreateHsmConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"HsmConfigurationIdentifier",
						"Description",
						"HsmIpAddress",
						"HsmPartitionName",
						"HsmPartitionPassword",
						"HsmServerPublicCertificate"
					],
					"members": {
						"HsmConfigurationIdentifier": {},
						"Description": {},
						"HsmIpAddress": {},
						"HsmPartitionName": {},
						"HsmPartitionPassword": {},
						"HsmServerPublicCertificate": {},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateHsmConfigurationResult",
					"type": "structure",
					"members": {
						"HsmConfiguration": {
							"shape": "S22"
						}
					}
				}
			},
			"CreateSnapshotCopyGrant": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotCopyGrantName"
					],
					"members": {
						"SnapshotCopyGrantName": {},
						"KmsKeyId": {},
						"Tags": {
							"shape": "S7"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateSnapshotCopyGrantResult",
					"type": "structure",
					"members": {
						"SnapshotCopyGrant": {
							"shape": "S25"
						}
					}
				}
			},
			"CreateTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"Tags"
					],
					"members": {
						"ResourceName": {},
						"Tags": {
							"shape": "S7"
						}
					}
				}
			},
			"DeleteCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"SkipFinalClusterSnapshot": {
							"type": "boolean"
						},
						"FinalClusterSnapshotIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteClusterResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			},
			"DeleteClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName"
					],
					"members": {
						"ParameterGroupName": {}
					}
				}
			},
			"DeleteClusterSecurityGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSecurityGroupName"
					],
					"members": {
						"ClusterSecurityGroupName": {}
					}
				}
			},
			"DeleteClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotIdentifier"
					],
					"members": {
						"SnapshotIdentifier": {},
						"SnapshotClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DeleteClusterSnapshotResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sd"
						}
					}
				}
			},
			"DeleteClusterSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSubnetGroupName"
					],
					"members": {
						"ClusterSubnetGroupName": {}
					}
				}
			},
			"DeleteEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {}
					}
				}
			},
			"DeleteHsmClientCertificate": {
				"input": {
					"type": "structure",
					"required": [
						"HsmClientCertificateIdentifier"
					],
					"members": {
						"HsmClientCertificateIdentifier": {}
					}
				}
			},
			"DeleteHsmConfiguration": {
				"input": {
					"type": "structure",
					"required": [
						"HsmConfigurationIdentifier"
					],
					"members": {
						"HsmConfigurationIdentifier": {}
					}
				}
			},
			"DeleteSnapshotCopyGrant": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotCopyGrantName"
					],
					"members": {
						"SnapshotCopyGrantName": {}
					}
				}
			},
			"DeleteTags": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceName",
						"TagKeys"
					],
					"members": {
						"ResourceName": {},
						"TagKeys": {
							"shape": "S2j"
						}
					}
				}
			},
			"DescribeClusterParameterGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ParameterGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S2j"
						},
						"TagValues": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterParameterGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ParameterGroups": {
							"type": "list",
							"member": {
								"shape": "S1g",
								"locationName": "ClusterParameterGroup"
							}
						}
					}
				}
			},
			"DescribeClusterParameters": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName"
					],
					"members": {
						"ParameterGroupName": {},
						"Source": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterParametersResult",
					"type": "structure",
					"members": {
						"Parameters": {
							"shape": "S2q"
						},
						"Marker": {}
					}
				}
			},
			"DescribeClusterSecurityGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterSecurityGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S2j"
						},
						"TagValues": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterSecurityGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ClusterSecurityGroups": {
							"type": "list",
							"member": {
								"shape": "S4",
								"locationName": "ClusterSecurityGroup"
							}
						}
					}
				}
			},
			"DescribeClusterSnapshots": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterIdentifier": {},
						"SnapshotIdentifier": {},
						"SnapshotType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"OwnerAccount": {},
						"TagKeys": {
							"shape": "S2j"
						},
						"TagValues": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterSnapshotsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Snapshots": {
							"type": "list",
							"member": {
								"shape": "Sd",
								"locationName": "Snapshot"
							}
						}
					}
				}
			},
			"DescribeClusterSubnetGroups": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterSubnetGroupName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S2j"
						},
						"TagValues": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterSubnetGroupsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ClusterSubnetGroups": {
							"type": "list",
							"member": {
								"shape": "S1o",
								"locationName": "ClusterSubnetGroup"
							}
						}
					}
				}
			},
			"DescribeClusterVersions": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterVersion": {},
						"ClusterParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeClusterVersionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ClusterVersions": {
							"type": "list",
							"member": {
								"locationName": "ClusterVersion",
								"type": "structure",
								"members": {
									"ClusterVersion": {},
									"ClusterParameterGroupFamily": {},
									"Description": {}
								}
							}
						}
					}
				}
			},
			"DescribeClusters": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S2j"
						},
						"TagValues": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeClustersResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Clusters": {
							"type": "list",
							"member": {
								"shape": "Sv",
								"locationName": "Cluster"
							}
						}
					}
				}
			},
			"DescribeDefaultClusterParameters": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupFamily"
					],
					"members": {
						"ParameterGroupFamily": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeDefaultClusterParametersResult",
					"type": "structure",
					"members": {
						"DefaultClusterParameters": {
							"type": "structure",
							"members": {
								"ParameterGroupFamily": {},
								"Marker": {},
								"Parameters": {
									"shape": "S2q"
								}
							},
							"wrapper": true
						}
					}
				}
			},
			"DescribeEventCategories": {
				"input": {
					"type": "structure",
					"members": {
						"SourceType": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventCategoriesResult",
					"type": "structure",
					"members": {
						"EventCategoriesMapList": {
							"type": "list",
							"member": {
								"locationName": "EventCategoriesMap",
								"type": "structure",
								"members": {
									"SourceType": {},
									"Events": {
										"type": "list",
										"member": {
											"locationName": "EventInfoMap",
											"type": "structure",
											"members": {
												"EventId": {},
												"EventCategories": {
													"shape": "S1u"
												},
												"EventDescription": {},
												"Severity": {}
											},
											"wrapper": true
										}
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeEventSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"SubscriptionName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventSubscriptionsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"EventSubscriptionsList": {
							"type": "list",
							"member": {
								"shape": "S1w",
								"locationName": "EventSubscription"
							}
						}
					}
				}
			},
			"DescribeEvents": {
				"input": {
					"type": "structure",
					"members": {
						"SourceIdentifier": {},
						"SourceType": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						},
						"Duration": {
							"type": "integer"
						},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeEventsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"Events": {
							"type": "list",
							"member": {
								"locationName": "Event",
								"type": "structure",
								"members": {
									"SourceIdentifier": {},
									"SourceType": {},
									"Message": {},
									"EventCategories": {
										"shape": "S1u"
									},
									"Severity": {},
									"Date": {
										"type": "timestamp"
									},
									"EventId": {}
								}
							}
						}
					}
				}
			},
			"DescribeHsmClientCertificates": {
				"input": {
					"type": "structure",
					"members": {
						"HsmClientCertificateIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S2j"
						},
						"TagValues": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeHsmClientCertificatesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"HsmClientCertificates": {
							"type": "list",
							"member": {
								"shape": "S1z",
								"locationName": "HsmClientCertificate"
							}
						}
					}
				}
			},
			"DescribeHsmConfigurations": {
				"input": {
					"type": "structure",
					"members": {
						"HsmConfigurationIdentifier": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S2j"
						},
						"TagValues": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeHsmConfigurationsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"HsmConfigurations": {
							"type": "list",
							"member": {
								"shape": "S22",
								"locationName": "HsmConfiguration"
							}
						}
					}
				}
			},
			"DescribeLoggingStatus": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"shape": "S3x",
					"resultWrapper": "DescribeLoggingStatusResult"
				}
			},
			"DescribeOrderableClusterOptions": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterVersion": {},
						"NodeType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeOrderableClusterOptionsResult",
					"type": "structure",
					"members": {
						"OrderableClusterOptions": {
							"type": "list",
							"member": {
								"locationName": "OrderableClusterOption",
								"type": "structure",
								"members": {
									"ClusterVersion": {},
									"ClusterType": {},
									"NodeType": {},
									"AvailabilityZones": {
										"type": "list",
										"member": {
											"shape": "S1r",
											"locationName": "AvailabilityZone"
										}
									}
								},
								"wrapper": true
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeReservedNodeOfferings": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedNodeOfferingId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedNodeOfferingsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedNodeOfferings": {
							"type": "list",
							"member": {
								"locationName": "ReservedNodeOffering",
								"type": "structure",
								"members": {
									"ReservedNodeOfferingId": {},
									"NodeType": {},
									"Duration": {
										"type": "integer"
									},
									"FixedPrice": {
										"type": "double"
									},
									"UsagePrice": {
										"type": "double"
									},
									"CurrencyCode": {},
									"OfferingType": {},
									"RecurringCharges": {
										"shape": "S47"
									}
								},
								"wrapper": true
							}
						}
					}
				}
			},
			"DescribeReservedNodes": {
				"input": {
					"type": "structure",
					"members": {
						"ReservedNodeId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeReservedNodesResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"ReservedNodes": {
							"type": "list",
							"member": {
								"shape": "S4c",
								"locationName": "ReservedNode"
							}
						}
					}
				}
			},
			"DescribeResize": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeResizeResult",
					"type": "structure",
					"members": {
						"TargetNodeType": {},
						"TargetNumberOfNodes": {
							"type": "integer"
						},
						"TargetClusterType": {},
						"Status": {},
						"ImportTablesCompleted": {
							"type": "list",
							"member": {}
						},
						"ImportTablesInProgress": {
							"type": "list",
							"member": {}
						},
						"ImportTablesNotStarted": {
							"type": "list",
							"member": {}
						},
						"AvgResizeRateInMegaBytesPerSecond": {
							"type": "double"
						},
						"TotalResizeDataInMegaBytes": {
							"type": "long"
						},
						"ProgressInMegaBytes": {
							"type": "long"
						},
						"ElapsedTimeInSeconds": {
							"type": "long"
						},
						"EstimatedTimeToCompletionInSeconds": {
							"type": "long"
						}
					}
				}
			},
			"DescribeSnapshotCopyGrants": {
				"input": {
					"type": "structure",
					"members": {
						"SnapshotCopyGrantName": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S2j"
						},
						"TagValues": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeSnapshotCopyGrantsResult",
					"type": "structure",
					"members": {
						"Marker": {},
						"SnapshotCopyGrants": {
							"type": "list",
							"member": {
								"shape": "S25",
								"locationName": "SnapshotCopyGrant"
							}
						}
					}
				}
			},
			"DescribeTableRestoreStatus": {
				"input": {
					"type": "structure",
					"members": {
						"ClusterIdentifier": {},
						"TableRestoreRequestId": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"resultWrapper": "DescribeTableRestoreStatusResult",
					"type": "structure",
					"members": {
						"TableRestoreStatusDetails": {
							"type": "list",
							"member": {
								"shape": "S4q",
								"locationName": "TableRestoreStatus"
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeTags": {
				"input": {
					"type": "structure",
					"members": {
						"ResourceName": {},
						"ResourceType": {},
						"MaxRecords": {
							"type": "integer"
						},
						"Marker": {},
						"TagKeys": {
							"shape": "S2j"
						},
						"TagValues": {
							"shape": "S2l"
						}
					}
				},
				"output": {
					"resultWrapper": "DescribeTagsResult",
					"type": "structure",
					"members": {
						"TaggedResources": {
							"type": "list",
							"member": {
								"locationName": "TaggedResource",
								"type": "structure",
								"members": {
									"Tag": {
										"shape": "S8"
									},
									"ResourceName": {},
									"ResourceType": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DisableLogging": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"shape": "S3x",
					"resultWrapper": "DisableLoggingResult"
				}
			},
			"DisableSnapshotCopy": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "DisableSnapshotCopyResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			},
			"EnableLogging": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"BucketName"
					],
					"members": {
						"ClusterIdentifier": {},
						"BucketName": {},
						"S3KeyPrefix": {}
					}
				},
				"output": {
					"shape": "S3x",
					"resultWrapper": "EnableLoggingResult"
				}
			},
			"EnableSnapshotCopy": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"DestinationRegion"
					],
					"members": {
						"ClusterIdentifier": {},
						"DestinationRegion": {},
						"RetentionPeriod": {
							"type": "integer"
						},
						"SnapshotCopyGrantName": {}
					}
				},
				"output": {
					"resultWrapper": "EnableSnapshotCopyResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			},
			"ModifyCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"ClusterType": {},
						"NodeType": {},
						"NumberOfNodes": {
							"type": "integer"
						},
						"ClusterSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"MasterUserPassword": {},
						"ClusterParameterGroupName": {},
						"AutomatedSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"PreferredMaintenanceWindow": {},
						"ClusterVersion": {},
						"AllowVersionUpgrade": {
							"type": "boolean"
						},
						"HsmClientCertificateIdentifier": {},
						"HsmConfigurationIdentifier": {},
						"NewClusterIdentifier": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"ElasticIp": {},
						"EnhancedVpcRouting": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyClusterResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			},
			"ModifyClusterIamRoles": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"AddIamRoles": {
							"shape": "St"
						},
						"RemoveIamRoles": {
							"shape": "St"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyClusterIamRolesResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			},
			"ModifyClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName",
						"Parameters"
					],
					"members": {
						"ParameterGroupName": {},
						"Parameters": {
							"shape": "S2q"
						}
					}
				},
				"output": {
					"shape": "S57",
					"resultWrapper": "ModifyClusterParameterGroupResult"
				}
			},
			"ModifyClusterSubnetGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSubnetGroupName",
						"SubnetIds"
					],
					"members": {
						"ClusterSubnetGroupName": {},
						"Description": {},
						"SubnetIds": {
							"shape": "S1m"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyClusterSubnetGroupResult",
					"type": "structure",
					"members": {
						"ClusterSubnetGroup": {
							"shape": "S1o"
						}
					}
				}
			},
			"ModifyEventSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionName"
					],
					"members": {
						"SubscriptionName": {},
						"SnsTopicArn": {},
						"SourceType": {},
						"SourceIds": {
							"shape": "S1t"
						},
						"EventCategories": {
							"shape": "S1u"
						},
						"Severity": {},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifyEventSubscriptionResult",
					"type": "structure",
					"members": {
						"EventSubscription": {
							"shape": "S1w"
						}
					}
				}
			},
			"ModifySnapshotCopyRetentionPeriod": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"RetentionPeriod"
					],
					"members": {
						"ClusterIdentifier": {},
						"RetentionPeriod": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "ModifySnapshotCopyRetentionPeriodResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			},
			"PurchaseReservedNodeOffering": {
				"input": {
					"type": "structure",
					"required": [
						"ReservedNodeOfferingId"
					],
					"members": {
						"ReservedNodeOfferingId": {},
						"NodeCount": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "PurchaseReservedNodeOfferingResult",
					"type": "structure",
					"members": {
						"ReservedNode": {
							"shape": "S4c"
						}
					}
				}
			},
			"RebootCluster": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RebootClusterResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			},
			"ResetClusterParameterGroup": {
				"input": {
					"type": "structure",
					"required": [
						"ParameterGroupName"
					],
					"members": {
						"ParameterGroupName": {},
						"ResetAllParameters": {
							"type": "boolean"
						},
						"Parameters": {
							"shape": "S2q"
						}
					}
				},
				"output": {
					"shape": "S57",
					"resultWrapper": "ResetClusterParameterGroupResult"
				}
			},
			"RestoreFromClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"SnapshotIdentifier"
					],
					"members": {
						"ClusterIdentifier": {},
						"SnapshotIdentifier": {},
						"SnapshotClusterIdentifier": {},
						"Port": {
							"type": "integer"
						},
						"AvailabilityZone": {},
						"AllowVersionUpgrade": {
							"type": "boolean"
						},
						"ClusterSubnetGroupName": {},
						"PubliclyAccessible": {
							"type": "boolean"
						},
						"OwnerAccount": {},
						"HsmClientCertificateIdentifier": {},
						"HsmConfigurationIdentifier": {},
						"ElasticIp": {},
						"ClusterParameterGroupName": {},
						"ClusterSecurityGroups": {
							"shape": "Sp"
						},
						"VpcSecurityGroupIds": {
							"shape": "Sq"
						},
						"PreferredMaintenanceWindow": {},
						"AutomatedSnapshotRetentionPeriod": {
							"type": "integer"
						},
						"KmsKeyId": {},
						"NodeType": {},
						"EnhancedVpcRouting": {
							"type": "boolean"
						},
						"AdditionalInfo": {},
						"IamRoles": {
							"shape": "St"
						}
					}
				},
				"output": {
					"resultWrapper": "RestoreFromClusterSnapshotResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			},
			"RestoreTableFromClusterSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier",
						"SnapshotIdentifier",
						"SourceDatabaseName",
						"SourceTableName",
						"NewTableName"
					],
					"members": {
						"ClusterIdentifier": {},
						"SnapshotIdentifier": {},
						"SourceDatabaseName": {},
						"SourceSchemaName": {},
						"SourceTableName": {},
						"TargetDatabaseName": {},
						"TargetSchemaName": {},
						"NewTableName": {}
					}
				},
				"output": {
					"resultWrapper": "RestoreTableFromClusterSnapshotResult",
					"type": "structure",
					"members": {
						"TableRestoreStatus": {
							"shape": "S4q"
						}
					}
				}
			},
			"RevokeClusterSecurityGroupIngress": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterSecurityGroupName"
					],
					"members": {
						"ClusterSecurityGroupName": {},
						"CIDRIP": {},
						"EC2SecurityGroupName": {},
						"EC2SecurityGroupOwnerId": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeClusterSecurityGroupIngressResult",
					"type": "structure",
					"members": {
						"ClusterSecurityGroup": {
							"shape": "S4"
						}
					}
				}
			},
			"RevokeSnapshotAccess": {
				"input": {
					"type": "structure",
					"required": [
						"SnapshotIdentifier",
						"AccountWithRestoreAccess"
					],
					"members": {
						"SnapshotIdentifier": {},
						"SnapshotClusterIdentifier": {},
						"AccountWithRestoreAccess": {}
					}
				},
				"output": {
					"resultWrapper": "RevokeSnapshotAccessResult",
					"type": "structure",
					"members": {
						"Snapshot": {
							"shape": "Sd"
						}
					}
				}
			},
			"RotateEncryptionKey": {
				"input": {
					"type": "structure",
					"required": [
						"ClusterIdentifier"
					],
					"members": {
						"ClusterIdentifier": {}
					}
				},
				"output": {
					"resultWrapper": "RotateEncryptionKeyResult",
					"type": "structure",
					"members": {
						"Cluster": {
							"shape": "Sv"
						}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "structure",
				"members": {
					"ClusterSecurityGroupName": {},
					"Description": {},
					"EC2SecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "EC2SecurityGroup",
							"type": "structure",
							"members": {
								"Status": {},
								"EC2SecurityGroupName": {},
								"EC2SecurityGroupOwnerId": {},
								"Tags": {
									"shape": "S7"
								}
							}
						}
					},
					"IPRanges": {
						"type": "list",
						"member": {
							"locationName": "IPRange",
							"type": "structure",
							"members": {
								"Status": {},
								"CIDRIP": {},
								"Tags": {
									"shape": "S7"
								}
							}
						}
					},
					"Tags": {
						"shape": "S7"
					}
				},
				"wrapper": true
			},
			"S7": {
				"type": "list",
				"member": {
					"shape": "S8",
					"locationName": "Tag"
				}
			},
			"S8": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"Sd": {
				"type": "structure",
				"members": {
					"SnapshotIdentifier": {},
					"ClusterIdentifier": {},
					"SnapshotCreateTime": {
						"type": "timestamp"
					},
					"Status": {},
					"Port": {
						"type": "integer"
					},
					"AvailabilityZone": {},
					"ClusterCreateTime": {
						"type": "timestamp"
					},
					"MasterUsername": {},
					"ClusterVersion": {},
					"SnapshotType": {},
					"NodeType": {},
					"NumberOfNodes": {
						"type": "integer"
					},
					"DBName": {},
					"VpcId": {},
					"Encrypted": {
						"type": "boolean"
					},
					"KmsKeyId": {},
					"EncryptedWithHSM": {
						"type": "boolean"
					},
					"AccountsWithRestoreAccess": {
						"type": "list",
						"member": {
							"locationName": "AccountWithRestoreAccess",
							"type": "structure",
							"members": {
								"AccountId": {}
							}
						}
					},
					"OwnerAccount": {},
					"TotalBackupSizeInMegaBytes": {
						"type": "double"
					},
					"ActualIncrementalBackupSizeInMegaBytes": {
						"type": "double"
					},
					"BackupProgressInMegaBytes": {
						"type": "double"
					},
					"CurrentBackupRateInMegaBytesPerSecond": {
						"type": "double"
					},
					"EstimatedSecondsToCompletion": {
						"type": "long"
					},
					"ElapsedTimeInSeconds": {
						"type": "long"
					},
					"SourceRegion": {},
					"Tags": {
						"shape": "S7"
					},
					"RestorableNodeTypes": {
						"type": "list",
						"member": {
							"locationName": "NodeType"
						}
					},
					"EnhancedVpcRouting": {
						"type": "boolean"
					}
				},
				"wrapper": true
			},
			"Sp": {
				"type": "list",
				"member": {
					"locationName": "ClusterSecurityGroupName"
				}
			},
			"Sq": {
				"type": "list",
				"member": {
					"locationName": "VpcSecurityGroupId"
				}
			},
			"St": {
				"type": "list",
				"member": {
					"locationName": "IamRoleArn"
				}
			},
			"Sv": {
				"type": "structure",
				"members": {
					"ClusterIdentifier": {},
					"NodeType": {},
					"ClusterStatus": {},
					"ModifyStatus": {},
					"MasterUsername": {},
					"DBName": {},
					"Endpoint": {
						"type": "structure",
						"members": {
							"Address": {},
							"Port": {
								"type": "integer"
							}
						}
					},
					"ClusterCreateTime": {
						"type": "timestamp"
					},
					"AutomatedSnapshotRetentionPeriod": {
						"type": "integer"
					},
					"ClusterSecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "ClusterSecurityGroup",
							"type": "structure",
							"members": {
								"ClusterSecurityGroupName": {},
								"Status": {}
							}
						}
					},
					"VpcSecurityGroups": {
						"type": "list",
						"member": {
							"locationName": "VpcSecurityGroup",
							"type": "structure",
							"members": {
								"VpcSecurityGroupId": {},
								"Status": {}
							}
						}
					},
					"ClusterParameterGroups": {
						"type": "list",
						"member": {
							"locationName": "ClusterParameterGroup",
							"type": "structure",
							"members": {
								"ParameterGroupName": {},
								"ParameterApplyStatus": {},
								"ClusterParameterStatusList": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ParameterName": {},
											"ParameterApplyStatus": {},
											"ParameterApplyErrorDescription": {}
										}
									}
								}
							}
						}
					},
					"ClusterSubnetGroupName": {},
					"VpcId": {},
					"AvailabilityZone": {},
					"PreferredMaintenanceWindow": {},
					"PendingModifiedValues": {
						"type": "structure",
						"members": {
							"MasterUserPassword": {},
							"NodeType": {},
							"NumberOfNodes": {
								"type": "integer"
							},
							"ClusterType": {},
							"ClusterVersion": {},
							"AutomatedSnapshotRetentionPeriod": {
								"type": "integer"
							},
							"ClusterIdentifier": {},
							"PubliclyAccessible": {
								"type": "boolean"
							},
							"EnhancedVpcRouting": {
								"type": "boolean"
							}
						}
					},
					"ClusterVersion": {},
					"AllowVersionUpgrade": {
						"type": "boolean"
					},
					"NumberOfNodes": {
						"type": "integer"
					},
					"PubliclyAccessible": {
						"type": "boolean"
					},
					"Encrypted": {
						"type": "boolean"
					},
					"RestoreStatus": {
						"type": "structure",
						"members": {
							"Status": {},
							"CurrentRestoreRateInMegaBytesPerSecond": {
								"type": "double"
							},
							"SnapshotSizeInMegaBytes": {
								"type": "long"
							},
							"ProgressInMegaBytes": {
								"type": "long"
							},
							"ElapsedTimeInSeconds": {
								"type": "long"
							},
							"EstimatedTimeToCompletionInSeconds": {
								"type": "long"
							}
						}
					},
					"HsmStatus": {
						"type": "structure",
						"members": {
							"HsmClientCertificateIdentifier": {},
							"HsmConfigurationIdentifier": {},
							"Status": {}
						}
					},
					"ClusterSnapshotCopyStatus": {
						"type": "structure",
						"members": {
							"DestinationRegion": {},
							"RetentionPeriod": {
								"type": "long"
							},
							"SnapshotCopyGrantName": {}
						}
					},
					"ClusterPublicKey": {},
					"ClusterNodes": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"NodeRole": {},
								"PrivateIPAddress": {},
								"PublicIPAddress": {}
							}
						}
					},
					"ElasticIpStatus": {
						"type": "structure",
						"members": {
							"ElasticIp": {},
							"Status": {}
						}
					},
					"ClusterRevisionNumber": {},
					"Tags": {
						"shape": "S7"
					},
					"KmsKeyId": {},
					"EnhancedVpcRouting": {
						"type": "boolean"
					},
					"IamRoles": {
						"type": "list",
						"member": {
							"locationName": "ClusterIamRole",
							"type": "structure",
							"members": {
								"IamRoleArn": {},
								"ApplyStatus": {}
							}
						}
					}
				},
				"wrapper": true
			},
			"S1g": {
				"type": "structure",
				"members": {
					"ParameterGroupName": {},
					"ParameterGroupFamily": {},
					"Description": {},
					"Tags": {
						"shape": "S7"
					}
				},
				"wrapper": true
			},
			"S1m": {
				"type": "list",
				"member": {
					"locationName": "SubnetIdentifier"
				}
			},
			"S1o": {
				"type": "structure",
				"members": {
					"ClusterSubnetGroupName": {},
					"Description": {},
					"VpcId": {},
					"SubnetGroupStatus": {},
					"Subnets": {
						"type": "list",
						"member": {
							"locationName": "Subnet",
							"type": "structure",
							"members": {
								"SubnetIdentifier": {},
								"SubnetAvailabilityZone": {
									"shape": "S1r"
								},
								"SubnetStatus": {}
							}
						}
					},
					"Tags": {
						"shape": "S7"
					}
				},
				"wrapper": true
			},
			"S1r": {
				"type": "structure",
				"members": {
					"Name": {}
				},
				"wrapper": true
			},
			"S1t": {
				"type": "list",
				"member": {
					"locationName": "SourceId"
				}
			},
			"S1u": {
				"type": "list",
				"member": {
					"locationName": "EventCategory"
				}
			},
			"S1w": {
				"type": "structure",
				"members": {
					"CustomerAwsId": {},
					"CustSubscriptionId": {},
					"SnsTopicArn": {},
					"Status": {},
					"SubscriptionCreationTime": {
						"type": "timestamp"
					},
					"SourceType": {},
					"SourceIdsList": {
						"shape": "S1t"
					},
					"EventCategoriesList": {
						"shape": "S1u"
					},
					"Severity": {},
					"Enabled": {
						"type": "boolean"
					},
					"Tags": {
						"shape": "S7"
					}
				},
				"wrapper": true
			},
			"S1z": {
				"type": "structure",
				"members": {
					"HsmClientCertificateIdentifier": {},
					"HsmClientCertificatePublicKey": {},
					"Tags": {
						"shape": "S7"
					}
				},
				"wrapper": true
			},
			"S22": {
				"type": "structure",
				"members": {
					"HsmConfigurationIdentifier": {},
					"Description": {},
					"HsmIpAddress": {},
					"HsmPartitionName": {},
					"Tags": {
						"shape": "S7"
					}
				},
				"wrapper": true
			},
			"S25": {
				"type": "structure",
				"members": {
					"SnapshotCopyGrantName": {},
					"KmsKeyId": {},
					"Tags": {
						"shape": "S7"
					}
				},
				"wrapper": true
			},
			"S2j": {
				"type": "list",
				"member": {
					"locationName": "TagKey"
				}
			},
			"S2l": {
				"type": "list",
				"member": {
					"locationName": "TagValue"
				}
			},
			"S2q": {
				"type": "list",
				"member": {
					"locationName": "Parameter",
					"type": "structure",
					"members": {
						"ParameterName": {},
						"ParameterValue": {},
						"Description": {},
						"Source": {},
						"DataType": {},
						"AllowedValues": {},
						"ApplyType": {},
						"IsModifiable": {
							"type": "boolean"
						},
						"MinimumEngineVersion": {}
					}
				}
			},
			"S3x": {
				"type": "structure",
				"members": {
					"LoggingEnabled": {
						"type": "boolean"
					},
					"BucketName": {},
					"S3KeyPrefix": {},
					"LastSuccessfulDeliveryTime": {
						"type": "timestamp"
					},
					"LastFailureTime": {
						"type": "timestamp"
					},
					"LastFailureMessage": {}
				}
			},
			"S47": {
				"type": "list",
				"member": {
					"locationName": "RecurringCharge",
					"type": "structure",
					"members": {
						"RecurringChargeAmount": {
							"type": "double"
						},
						"RecurringChargeFrequency": {}
					},
					"wrapper": true
				}
			},
			"S4c": {
				"type": "structure",
				"members": {
					"ReservedNodeId": {},
					"ReservedNodeOfferingId": {},
					"NodeType": {},
					"StartTime": {
						"type": "timestamp"
					},
					"Duration": {
						"type": "integer"
					},
					"FixedPrice": {
						"type": "double"
					},
					"UsagePrice": {
						"type": "double"
					},
					"CurrencyCode": {},
					"NodeCount": {
						"type": "integer"
					},
					"State": {},
					"OfferingType": {},
					"RecurringCharges": {
						"shape": "S47"
					}
				},
				"wrapper": true
			},
			"S4q": {
				"type": "structure",
				"members": {
					"TableRestoreRequestId": {},
					"Status": {},
					"Message": {},
					"RequestTime": {
						"type": "timestamp"
					},
					"ProgressInMegaBytes": {
						"type": "long"
					},
					"TotalDataInMegaBytes": {
						"type": "long"
					},
					"ClusterIdentifier": {},
					"SnapshotIdentifier": {},
					"SourceDatabaseName": {},
					"SourceSchemaName": {},
					"SourceTableName": {},
					"TargetDatabaseName": {},
					"TargetSchemaName": {},
					"NewTableName": {}
				},
				"wrapper": true
			},
			"S57": {
				"type": "structure",
				"members": {
					"ParameterGroupName": {},
					"ParameterGroupStatus": {}
				}
			}
		}
	};

/***/ },
/* 744 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeClusterParameterGroups": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "ParameterGroups"
			},
			"DescribeClusterParameters": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "Parameters"
			},
			"DescribeClusterSecurityGroups": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "ClusterSecurityGroups"
			},
			"DescribeClusterSnapshots": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "Snapshots"
			},
			"DescribeClusterSubnetGroups": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "ClusterSubnetGroups"
			},
			"DescribeClusterVersions": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "ClusterVersions"
			},
			"DescribeClusters": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "Clusters"
			},
			"DescribeDefaultClusterParameters": {
				"input_token": "Marker",
				"output_token": "DefaultClusterParameters.Marker",
				"limit_key": "MaxRecords",
				"result_key": "DefaultClusterParameters.Parameters"
			},
			"DescribeEventSubscriptions": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "EventSubscriptionsList"
			},
			"DescribeEvents": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "Events"
			},
			"DescribeHsmClientCertificates": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "HsmClientCertificates"
			},
			"DescribeHsmConfigurations": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "HsmConfigurations"
			},
			"DescribeOrderableClusterOptions": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "OrderableClusterOptions"
			},
			"DescribeReservedNodeOfferings": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "ReservedNodeOfferings"
			},
			"DescribeReservedNodes": {
				"input_token": "Marker",
				"output_token": "Marker",
				"limit_key": "MaxRecords",
				"result_key": "ReservedNodes"
			}
		}
	};

/***/ },
/* 745 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"ClusterAvailable": {
				"delay": 60,
				"operation": "DescribeClusters",
				"maxAttempts": 30,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Clusters[].ClusterStatus"
					},
					{
						"expected": "deleting",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Clusters[].ClusterStatus"
					},
					{
						"expected": "ClusterNotFound",
						"matcher": "error",
						"state": "retry"
					}
				]
			},
			"ClusterDeleted": {
				"delay": 60,
				"operation": "DescribeClusters",
				"maxAttempts": 30,
				"acceptors": [
					{
						"expected": "ClusterNotFound",
						"matcher": "error",
						"state": "success"
					},
					{
						"expected": "creating",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Clusters[].ClusterStatus"
					},
					{
						"expected": "modifying",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Clusters[].ClusterStatus"
					}
				]
			},
			"ClusterRestored": {
				"operation": "DescribeClusters",
				"maxAttempts": 30,
				"delay": 60,
				"acceptors": [
					{
						"state": "success",
						"matcher": "pathAll",
						"argument": "Clusters[].RestoreStatus.Status",
						"expected": "completed"
					},
					{
						"state": "failure",
						"matcher": "pathAny",
						"argument": "Clusters[].ClusterStatus",
						"expected": "deleting"
					}
				]
			},
			"SnapshotAvailable": {
				"delay": 15,
				"operation": "DescribeClusterSnapshots",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": "available",
						"matcher": "pathAll",
						"state": "success",
						"argument": "Snapshots[].Status"
					},
					{
						"expected": "failed",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Snapshots[].Status"
					},
					{
						"expected": "deleted",
						"matcher": "pathAny",
						"state": "failure",
						"argument": "Snapshots[].Status"
					}
				]
			}
		}
	};

/***/ },
/* 746 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-06-27",
			"endpointPrefix": "rekognition",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Rekognition",
			"signatureVersion": "v4",
			"targetPrefix": "RekognitionService",
			"uid": "rekognition-2016-06-27"
		},
		"operations": {
			"CompareFaces": {
				"input": {
					"type": "structure",
					"required": [
						"SourceImage",
						"TargetImage"
					],
					"members": {
						"SourceImage": {
							"shape": "S2"
						},
						"TargetImage": {
							"shape": "S2"
						},
						"SimilarityThreshold": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SourceImageFace": {
							"type": "structure",
							"members": {
								"BoundingBox": {
									"shape": "Sb"
								},
								"Confidence": {
									"type": "float"
								}
							}
						},
						"FaceMatches": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Similarity": {
										"type": "float"
									},
									"Face": {
										"type": "structure",
										"members": {
											"BoundingBox": {
												"shape": "Sb"
											},
											"Confidence": {
												"type": "float"
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"CreateCollection": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId"
					],
					"members": {
						"CollectionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StatusCode": {
							"type": "integer"
						},
						"CollectionArn": {}
					}
				}
			},
			"DeleteCollection": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId"
					],
					"members": {
						"CollectionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StatusCode": {
							"type": "integer"
						}
					}
				}
			},
			"DeleteFaces": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId",
						"FaceIds"
					],
					"members": {
						"CollectionId": {},
						"FaceIds": {
							"shape": "So"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeletedFaces": {
							"shape": "So"
						}
					}
				}
			},
			"DetectFaces": {
				"input": {
					"type": "structure",
					"required": [
						"Image"
					],
					"members": {
						"Image": {
							"shape": "S2"
						},
						"Attributes": {
							"shape": "Ss"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FaceDetails": {
							"type": "list",
							"member": {
								"shape": "Sw"
							}
						},
						"OrientationCorrection": {}
					}
				}
			},
			"DetectLabels": {
				"input": {
					"type": "structure",
					"required": [
						"Image"
					],
					"members": {
						"Image": {
							"shape": "S2"
						},
						"MaxLabels": {
							"type": "integer"
						},
						"MinConfidence": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Labels": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Confidence": {
										"type": "float"
									}
								}
							}
						},
						"OrientationCorrection": {}
					}
				}
			},
			"IndexFaces": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId",
						"Image"
					],
					"members": {
						"CollectionId": {},
						"Image": {
							"shape": "S2"
						},
						"ExternalImageId": {},
						"DetectionAttributes": {
							"shape": "Ss"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FaceRecords": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Face": {
										"shape": "S1r"
									},
									"FaceDetail": {
										"shape": "Sw"
									}
								}
							}
						},
						"OrientationCorrection": {}
					}
				}
			},
			"ListCollections": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CollectionIds": {
							"type": "list",
							"member": {}
						},
						"NextToken": {}
					}
				}
			},
			"ListFaces": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId"
					],
					"members": {
						"CollectionId": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Faces": {
							"type": "list",
							"member": {
								"shape": "S1r"
							}
						},
						"NextToken": {}
					}
				}
			},
			"SearchFaces": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId",
						"FaceId"
					],
					"members": {
						"CollectionId": {},
						"FaceId": {},
						"MaxFaces": {
							"type": "integer"
						},
						"FaceMatchThreshold": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SearchedFaceId": {},
						"FaceMatches": {
							"shape": "S24"
						}
					}
				}
			},
			"SearchFacesByImage": {
				"input": {
					"type": "structure",
					"required": [
						"CollectionId",
						"Image"
					],
					"members": {
						"CollectionId": {},
						"Image": {
							"shape": "S2"
						},
						"MaxFaces": {
							"type": "integer"
						},
						"FaceMatchThreshold": {
							"type": "float"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SearchedFaceBoundingBox": {
							"shape": "Sb"
						},
						"SearchedFaceConfidence": {
							"type": "float"
						},
						"FaceMatches": {
							"shape": "S24"
						}
					}
				}
			}
		},
		"shapes": {
			"S2": {
				"type": "structure",
				"members": {
					"Bytes": {
						"type": "blob"
					},
					"S3Object": {
						"type": "structure",
						"members": {
							"Bucket": {},
							"Name": {},
							"Version": {}
						}
					}
				}
			},
			"Sb": {
				"type": "structure",
				"members": {
					"Width": {
						"type": "float"
					},
					"Height": {
						"type": "float"
					},
					"Left": {
						"type": "float"
					},
					"Top": {
						"type": "float"
					}
				}
			},
			"So": {
				"type": "list",
				"member": {}
			},
			"Ss": {
				"type": "list",
				"member": {}
			},
			"Sw": {
				"type": "structure",
				"members": {
					"BoundingBox": {
						"shape": "Sb"
					},
					"AgeRange": {
						"type": "structure",
						"members": {
							"Low": {
								"type": "integer"
							},
							"High": {
								"type": "integer"
							}
						}
					},
					"Smile": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Eyeglasses": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Sunglasses": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Gender": {
						"type": "structure",
						"members": {
							"Value": {},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Beard": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Mustache": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"EyesOpen": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"MouthOpen": {
						"type": "structure",
						"members": {
							"Value": {
								"type": "boolean"
							},
							"Confidence": {
								"type": "float"
							}
						}
					},
					"Emotions": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"Confidence": {
									"type": "float"
								}
							}
						}
					},
					"Landmarks": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Type": {},
								"X": {
									"type": "float"
								},
								"Y": {
									"type": "float"
								}
							}
						}
					},
					"Pose": {
						"type": "structure",
						"members": {
							"Roll": {
								"type": "float"
							},
							"Yaw": {
								"type": "float"
							},
							"Pitch": {
								"type": "float"
							}
						}
					},
					"Quality": {
						"type": "structure",
						"members": {
							"Brightness": {
								"type": "float"
							},
							"Sharpness": {
								"type": "float"
							}
						}
					},
					"Confidence": {
						"type": "float"
					}
				}
			},
			"S1r": {
				"type": "structure",
				"members": {
					"FaceId": {},
					"BoundingBox": {
						"shape": "Sb"
					},
					"ImageId": {},
					"ExternalImageId": {},
					"Confidence": {
						"type": "float"
					}
				}
			},
			"S24": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Similarity": {
							"type": "float"
						},
						"Face": {
							"shape": "S1r"
						}
					}
				}
			}
		}
	};

/***/ },
/* 747 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListCollections": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "CollectionIds"
			},
			"ListFaces": {
				"input_token": "NextToken",
				"limit_key": "MaxResults",
				"output_token": "NextToken",
				"result_key": "Faces"
			}
		}
	};

/***/ },
/* 748 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-04-01",
			"endpointPrefix": "route53",
			"globalEndpoint": "route53.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "Route 53",
			"serviceFullName": "Amazon Route 53",
			"signatureVersion": "v4",
			"uid": "route53-2013-04-01"
		},
		"operations": {
			"AssociateVPCWithHostedZone": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/associatevpc"
				},
				"input": {
					"locationName": "AssociateVPCWithHostedZoneRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"VPC": {
							"shape": "S3"
						},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"ChangeResourceRecordSets": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/rrset/"
				},
				"input": {
					"locationName": "ChangeResourceRecordSetsRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"ChangeBatch"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"ChangeBatch": {
							"type": "structure",
							"required": [
								"Changes"
							],
							"members": {
								"Comment": {},
								"Changes": {
									"type": "list",
									"member": {
										"locationName": "Change",
										"type": "structure",
										"required": [
											"Action",
											"ResourceRecordSet"
										],
										"members": {
											"Action": {},
											"ResourceRecordSet": {
												"shape": "Sh"
											}
										}
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"ChangeTagsForResource": {
				"http": {
					"requestUri": "/2013-04-01/tags/{ResourceType}/{ResourceId}"
				},
				"input": {
					"locationName": "ChangeTagsForResourceRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId"
					],
					"members": {
						"ResourceType": {
							"location": "uri",
							"locationName": "ResourceType"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						},
						"AddTags": {
							"shape": "S14"
						},
						"RemoveTagKeys": {
							"type": "list",
							"member": {
								"locationName": "Key"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateHealthCheck": {
				"http": {
					"requestUri": "/2013-04-01/healthcheck",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateHealthCheckRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"CallerReference",
						"HealthCheckConfig"
					],
					"members": {
						"CallerReference": {},
						"HealthCheckConfig": {
							"shape": "S1c"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheck",
						"Location"
					],
					"members": {
						"HealthCheck": {
							"shape": "S1x"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateHostedZone": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateHostedZoneRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Name",
						"CallerReference"
					],
					"members": {
						"Name": {},
						"VPC": {
							"shape": "S3"
						},
						"CallerReference": {},
						"HostedZoneConfig": {
							"shape": "S2d"
						},
						"DelegationSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZone",
						"ChangeInfo",
						"DelegationSet",
						"Location"
					],
					"members": {
						"HostedZone": {
							"shape": "S2g"
						},
						"ChangeInfo": {
							"shape": "S8"
						},
						"DelegationSet": {
							"shape": "S2i"
						},
						"VPC": {
							"shape": "S3"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateReusableDelegationSet": {
				"http": {
					"requestUri": "/2013-04-01/delegationset",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateReusableDelegationSetRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"CallerReference"
					],
					"members": {
						"CallerReference": {},
						"HostedZoneId": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DelegationSet",
						"Location"
					],
					"members": {
						"DelegationSet": {
							"shape": "S2i"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateTrafficPolicy": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicy",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateTrafficPolicyRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Name",
						"Document"
					],
					"members": {
						"Name": {},
						"Document": {},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicy",
						"Location"
					],
					"members": {
						"TrafficPolicy": {
							"shape": "S2r"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateTrafficPolicyInstance": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicyinstance",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateTrafficPolicyInstanceRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"Name",
						"TTL",
						"TrafficPolicyId",
						"TrafficPolicyVersion"
					],
					"members": {
						"HostedZoneId": {},
						"Name": {},
						"TTL": {
							"type": "long"
						},
						"TrafficPolicyId": {},
						"TrafficPolicyVersion": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstance",
						"Location"
					],
					"members": {
						"TrafficPolicyInstance": {
							"shape": "S2w"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateTrafficPolicyVersion": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicy/{Id}",
					"responseCode": 201
				},
				"input": {
					"locationName": "CreateTrafficPolicyVersionRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Id",
						"Document"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Document": {},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicy",
						"Location"
					],
					"members": {
						"TrafficPolicy": {
							"shape": "S2r"
						},
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				}
			},
			"CreateVPCAssociationAuthorization": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/authorizevpcassociation"
				},
				"input": {
					"locationName": "CreateVPCAssociationAuthorizationRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"VPC": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {},
						"VPC": {
							"shape": "S3"
						}
					}
				}
			},
			"DeleteHealthCheck": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteHostedZone": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/hostedzone/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"DeleteReusableDelegationSet": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/delegationset/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTrafficPolicy": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id",
						"Version"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Version": {
							"location": "uri",
							"locationName": "Version",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteTrafficPolicyInstance": {
				"http": {
					"method": "DELETE",
					"requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteVPCAssociationAuthorization": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"
				},
				"input": {
					"locationName": "DeleteVPCAssociationAuthorizationRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"VPC": {
							"shape": "S3"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisassociateVPCFromHostedZone": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}/disassociatevpc"
				},
				"input": {
					"locationName": "DisassociateVPCFromHostedZoneRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPC"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"VPC": {
							"shape": "S3"
						},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"GetChange": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/change/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ChangeInfo"
					],
					"members": {
						"ChangeInfo": {
							"shape": "S8"
						}
					}
				}
			},
			"GetCheckerIpRanges": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/checkeripranges"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"CheckerIpRanges"
					],
					"members": {
						"CheckerIpRanges": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"GetGeoLocation": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/geolocation"
				},
				"input": {
					"type": "structure",
					"members": {
						"ContinentCode": {
							"location": "querystring",
							"locationName": "continentcode"
						},
						"CountryCode": {
							"location": "querystring",
							"locationName": "countrycode"
						},
						"SubdivisionCode": {
							"location": "querystring",
							"locationName": "subdivisioncode"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"GeoLocationDetails"
					],
					"members": {
						"GeoLocationDetails": {
							"shape": "S3q"
						}
					}
				}
			},
			"GetHealthCheck": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheck"
					],
					"members": {
						"HealthCheck": {
							"shape": "S1x"
						}
					}
				}
			},
			"GetHealthCheckCount": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheckcount"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheckCount"
					],
					"members": {
						"HealthCheckCount": {
							"type": "long"
						}
					}
				}
			},
			"GetHealthCheckLastFailureReason": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"
				},
				"input": {
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheckObservations"
					],
					"members": {
						"HealthCheckObservations": {
							"shape": "S41"
						}
					}
				}
			},
			"GetHealthCheckStatus": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}/status"
				},
				"input": {
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheckObservations"
					],
					"members": {
						"HealthCheckObservations": {
							"shape": "S41"
						}
					}
				}
			},
			"GetHostedZone": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzone/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZone"
					],
					"members": {
						"HostedZone": {
							"shape": "S2g"
						},
						"DelegationSet": {
							"shape": "S2i"
						},
						"VPCs": {
							"shape": "S49"
						}
					}
				}
			},
			"GetHostedZoneCount": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzonecount"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZoneCount"
					],
					"members": {
						"HostedZoneCount": {
							"type": "long"
						}
					}
				}
			},
			"GetReusableDelegationSet": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/delegationset/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DelegationSet"
					],
					"members": {
						"DelegationSet": {
							"shape": "S2i"
						}
					}
				}
			},
			"GetTrafficPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id",
						"Version"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Version": {
							"location": "uri",
							"locationName": "Version",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicy"
					],
					"members": {
						"TrafficPolicy": {
							"shape": "S2r"
						}
					}
				}
			},
			"GetTrafficPolicyInstance": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstance"
					],
					"members": {
						"TrafficPolicyInstance": {
							"shape": "S2w"
						}
					}
				}
			},
			"GetTrafficPolicyInstanceCount": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstancecount"
				},
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstanceCount"
					],
					"members": {
						"TrafficPolicyInstanceCount": {
							"type": "integer"
						}
					}
				}
			},
			"ListGeoLocations": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/geolocations"
				},
				"input": {
					"type": "structure",
					"members": {
						"StartContinentCode": {
							"location": "querystring",
							"locationName": "startcontinentcode"
						},
						"StartCountryCode": {
							"location": "querystring",
							"locationName": "startcountrycode"
						},
						"StartSubdivisionCode": {
							"location": "querystring",
							"locationName": "startsubdivisioncode"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"GeoLocationDetailsList",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"GeoLocationDetailsList": {
							"type": "list",
							"member": {
								"shape": "S3q",
								"locationName": "GeoLocationDetails"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextContinentCode": {},
						"NextCountryCode": {},
						"NextSubdivisionCode": {},
						"MaxItems": {}
					}
				}
			},
			"ListHealthChecks": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/healthcheck"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthChecks",
						"Marker",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"HealthChecks": {
							"type": "list",
							"member": {
								"shape": "S1x",
								"locationName": "HealthCheck"
							}
						},
						"Marker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListHostedZones": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzone"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						},
						"DelegationSetId": {
							"location": "querystring",
							"locationName": "delegationsetid"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZones",
						"Marker",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"HostedZones": {
							"shape": "S4x"
						},
						"Marker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListHostedZonesByName": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzonesbyname"
				},
				"input": {
					"type": "structure",
					"members": {
						"DNSName": {
							"location": "querystring",
							"locationName": "dnsname"
						},
						"HostedZoneId": {
							"location": "querystring",
							"locationName": "hostedzoneid"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZones",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"HostedZones": {
							"shape": "S4x"
						},
						"DNSName": {},
						"HostedZoneId": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextDNSName": {},
						"NextHostedZoneId": {},
						"MaxItems": {}
					}
				}
			},
			"ListResourceRecordSets": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzone/{Id}/rrset"
				},
				"input": {
					"type": "structure",
					"required": [
						"HostedZoneId"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"StartRecordName": {
							"location": "querystring",
							"locationName": "name"
						},
						"StartRecordType": {
							"location": "querystring",
							"locationName": "type"
						},
						"StartRecordIdentifier": {
							"location": "querystring",
							"locationName": "identifier"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceRecordSets",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"ResourceRecordSets": {
							"type": "list",
							"member": {
								"shape": "Sh",
								"locationName": "ResourceRecordSet"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextRecordName": {},
						"NextRecordType": {},
						"NextRecordIdentifier": {},
						"MaxItems": {}
					}
				}
			},
			"ListReusableDelegationSets": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/delegationset"
				},
				"input": {
					"type": "structure",
					"members": {
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DelegationSets",
						"Marker",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"DelegationSets": {
							"type": "list",
							"member": {
								"shape": "S2i",
								"locationName": "DelegationSet"
							}
						},
						"Marker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListTagsForResource": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/tags/{ResourceType}/{ResourceId}"
				},
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId"
					],
					"members": {
						"ResourceType": {
							"location": "uri",
							"locationName": "ResourceType"
						},
						"ResourceId": {
							"location": "uri",
							"locationName": "ResourceId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceTagSet"
					],
					"members": {
						"ResourceTagSet": {
							"shape": "S58"
						}
					}
				}
			},
			"ListTagsForResources": {
				"http": {
					"requestUri": "/2013-04-01/tags/{ResourceType}"
				},
				"input": {
					"locationName": "ListTagsForResourcesRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceIds"
					],
					"members": {
						"ResourceType": {
							"location": "uri",
							"locationName": "ResourceType"
						},
						"ResourceIds": {
							"type": "list",
							"member": {
								"locationName": "ResourceId"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"ResourceTagSets"
					],
					"members": {
						"ResourceTagSets": {
							"type": "list",
							"member": {
								"shape": "S58",
								"locationName": "ResourceTagSet"
							}
						}
					}
				}
			},
			"ListTrafficPolicies": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicies"
				},
				"input": {
					"type": "structure",
					"members": {
						"TrafficPolicyIdMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyid"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicySummaries",
						"IsTruncated",
						"TrafficPolicyIdMarker",
						"MaxItems"
					],
					"members": {
						"TrafficPolicySummaries": {
							"type": "list",
							"member": {
								"locationName": "TrafficPolicySummary",
								"type": "structure",
								"required": [
									"Id",
									"Name",
									"Type",
									"LatestVersion",
									"TrafficPolicyCount"
								],
								"members": {
									"Id": {},
									"Name": {},
									"Type": {},
									"LatestVersion": {
										"type": "integer"
									},
									"TrafficPolicyCount": {
										"type": "integer"
									}
								}
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"TrafficPolicyIdMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListTrafficPolicyInstances": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstances"
				},
				"input": {
					"type": "structure",
					"members": {
						"HostedZoneIdMarker": {
							"location": "querystring",
							"locationName": "hostedzoneid"
						},
						"TrafficPolicyInstanceNameMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancename"
						},
						"TrafficPolicyInstanceTypeMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancetype"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstances",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"TrafficPolicyInstances": {
							"shape": "S5j"
						},
						"HostedZoneIdMarker": {},
						"TrafficPolicyInstanceNameMarker": {},
						"TrafficPolicyInstanceTypeMarker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"MaxItems": {}
					}
				}
			},
			"ListTrafficPolicyInstancesByHostedZone": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstances/hostedzone"
				},
				"input": {
					"type": "structure",
					"required": [
						"HostedZoneId"
					],
					"members": {
						"HostedZoneId": {
							"location": "querystring",
							"locationName": "id"
						},
						"TrafficPolicyInstanceNameMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancename"
						},
						"TrafficPolicyInstanceTypeMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancetype"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstances",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"TrafficPolicyInstances": {
							"shape": "S5j"
						},
						"TrafficPolicyInstanceNameMarker": {},
						"TrafficPolicyInstanceTypeMarker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"MaxItems": {}
					}
				}
			},
			"ListTrafficPolicyInstancesByPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicyinstances/trafficpolicy"
				},
				"input": {
					"type": "structure",
					"required": [
						"TrafficPolicyId",
						"TrafficPolicyVersion"
					],
					"members": {
						"TrafficPolicyId": {
							"location": "querystring",
							"locationName": "id"
						},
						"TrafficPolicyVersion": {
							"location": "querystring",
							"locationName": "version",
							"type": "integer"
						},
						"HostedZoneIdMarker": {
							"location": "querystring",
							"locationName": "hostedzoneid"
						},
						"TrafficPolicyInstanceNameMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancename"
						},
						"TrafficPolicyInstanceTypeMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyinstancetype"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstances",
						"IsTruncated",
						"MaxItems"
					],
					"members": {
						"TrafficPolicyInstances": {
							"shape": "S5j"
						},
						"HostedZoneIdMarker": {},
						"TrafficPolicyInstanceNameMarker": {},
						"TrafficPolicyInstanceTypeMarker": {},
						"IsTruncated": {
							"type": "boolean"
						},
						"MaxItems": {}
					}
				}
			},
			"ListTrafficPolicyVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/trafficpolicies/{Id}/versions"
				},
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"TrafficPolicyVersionMarker": {
							"location": "querystring",
							"locationName": "trafficpolicyversion"
						},
						"MaxItems": {
							"location": "querystring",
							"locationName": "maxitems"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicies",
						"IsTruncated",
						"TrafficPolicyVersionMarker",
						"MaxItems"
					],
					"members": {
						"TrafficPolicies": {
							"type": "list",
							"member": {
								"shape": "S2r",
								"locationName": "TrafficPolicy"
							}
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"TrafficPolicyVersionMarker": {},
						"MaxItems": {}
					}
				}
			},
			"ListVPCAssociationAuthorizations": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/hostedzone/{Id}/authorizevpcassociation"
				},
				"input": {
					"type": "structure",
					"required": [
						"HostedZoneId"
					],
					"members": {
						"HostedZoneId": {
							"location": "uri",
							"locationName": "Id"
						},
						"NextToken": {
							"location": "querystring",
							"locationName": "nexttoken"
						},
						"MaxResults": {
							"location": "querystring",
							"locationName": "maxresults"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZoneId",
						"VPCs"
					],
					"members": {
						"HostedZoneId": {},
						"NextToken": {},
						"VPCs": {
							"shape": "S49"
						}
					}
				}
			},
			"TestDNSAnswer": {
				"http": {
					"method": "GET",
					"requestUri": "/2013-04-01/testdnsanswer"
				},
				"input": {
					"type": "structure",
					"required": [
						"HostedZoneId",
						"RecordName",
						"RecordType"
					],
					"members": {
						"HostedZoneId": {
							"location": "querystring",
							"locationName": "hostedzoneid"
						},
						"RecordName": {
							"location": "querystring",
							"locationName": "recordname"
						},
						"RecordType": {
							"location": "querystring",
							"locationName": "recordtype"
						},
						"ResolverIP": {
							"location": "querystring",
							"locationName": "resolverip"
						},
						"EDNS0ClientSubnetIP": {
							"location": "querystring",
							"locationName": "edns0clientsubnetip"
						},
						"EDNS0ClientSubnetMask": {
							"location": "querystring",
							"locationName": "edns0clientsubnetmask"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Nameserver",
						"RecordName",
						"RecordType",
						"RecordData",
						"ResponseCode",
						"Protocol"
					],
					"members": {
						"Nameserver": {},
						"RecordName": {},
						"RecordType": {},
						"RecordData": {
							"type": "list",
							"member": {
								"locationName": "RecordDataEntry"
							}
						},
						"ResponseCode": {},
						"Protocol": {}
					}
				}
			},
			"UpdateHealthCheck": {
				"http": {
					"requestUri": "/2013-04-01/healthcheck/{HealthCheckId}"
				},
				"input": {
					"locationName": "UpdateHealthCheckRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"HealthCheckId"
					],
					"members": {
						"HealthCheckId": {
							"location": "uri",
							"locationName": "HealthCheckId"
						},
						"HealthCheckVersion": {
							"type": "long"
						},
						"IPAddress": {},
						"Port": {
							"type": "integer"
						},
						"ResourcePath": {},
						"FullyQualifiedDomainName": {},
						"SearchString": {},
						"FailureThreshold": {
							"type": "integer"
						},
						"Inverted": {
							"type": "boolean"
						},
						"HealthThreshold": {
							"type": "integer"
						},
						"ChildHealthChecks": {
							"shape": "S1o"
						},
						"EnableSNI": {
							"type": "boolean"
						},
						"Regions": {
							"shape": "S1q"
						},
						"AlarmIdentifier": {
							"shape": "S1s"
						},
						"InsufficientDataHealthStatus": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HealthCheck"
					],
					"members": {
						"HealthCheck": {
							"shape": "S1x"
						}
					}
				}
			},
			"UpdateHostedZoneComment": {
				"http": {
					"requestUri": "/2013-04-01/hostedzone/{Id}"
				},
				"input": {
					"locationName": "UpdateHostedZoneCommentRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"HostedZone"
					],
					"members": {
						"HostedZone": {
							"shape": "S2g"
						}
					}
				}
			},
			"UpdateTrafficPolicyComment": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicy/{Id}/{Version}"
				},
				"input": {
					"locationName": "UpdateTrafficPolicyCommentRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Id",
						"Version",
						"Comment"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"Version": {
							"location": "uri",
							"locationName": "Version",
							"type": "integer"
						},
						"Comment": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicy"
					],
					"members": {
						"TrafficPolicy": {
							"shape": "S2r"
						}
					}
				}
			},
			"UpdateTrafficPolicyInstance": {
				"http": {
					"requestUri": "/2013-04-01/trafficpolicyinstance/{Id}"
				},
				"input": {
					"locationName": "UpdateTrafficPolicyInstanceRequest",
					"xmlNamespace": {
						"uri": "https://route53.amazonaws.com/doc/2013-04-01/"
					},
					"type": "structure",
					"required": [
						"Id",
						"TTL",
						"TrafficPolicyId",
						"TrafficPolicyVersion"
					],
					"members": {
						"Id": {
							"location": "uri",
							"locationName": "Id"
						},
						"TTL": {
							"type": "long"
						},
						"TrafficPolicyId": {},
						"TrafficPolicyVersion": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TrafficPolicyInstance"
					],
					"members": {
						"TrafficPolicyInstance": {
							"shape": "S2w"
						}
					}
				}
			}
		},
		"shapes": {
			"S3": {
				"type": "structure",
				"members": {
					"VPCRegion": {},
					"VPCId": {}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"Id",
					"Status",
					"SubmittedAt"
				],
				"members": {
					"Id": {},
					"Status": {},
					"SubmittedAt": {
						"type": "timestamp"
					},
					"Comment": {}
				}
			},
			"Sh": {
				"type": "structure",
				"required": [
					"Name",
					"Type"
				],
				"members": {
					"Name": {},
					"Type": {},
					"SetIdentifier": {},
					"Weight": {
						"type": "long"
					},
					"Region": {},
					"GeoLocation": {
						"type": "structure",
						"members": {
							"ContinentCode": {},
							"CountryCode": {},
							"SubdivisionCode": {}
						}
					},
					"Failover": {},
					"TTL": {
						"type": "long"
					},
					"ResourceRecords": {
						"type": "list",
						"member": {
							"locationName": "ResourceRecord",
							"type": "structure",
							"required": [
								"Value"
							],
							"members": {
								"Value": {}
							}
						}
					},
					"AliasTarget": {
						"type": "structure",
						"required": [
							"HostedZoneId",
							"DNSName",
							"EvaluateTargetHealth"
						],
						"members": {
							"HostedZoneId": {},
							"DNSName": {},
							"EvaluateTargetHealth": {
								"type": "boolean"
							}
						}
					},
					"HealthCheckId": {},
					"TrafficPolicyInstanceId": {}
				}
			},
			"S14": {
				"type": "list",
				"member": {
					"locationName": "Tag",
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S1c": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"IPAddress": {},
					"Port": {
						"type": "integer"
					},
					"Type": {},
					"ResourcePath": {},
					"FullyQualifiedDomainName": {},
					"SearchString": {},
					"RequestInterval": {
						"type": "integer"
					},
					"FailureThreshold": {
						"type": "integer"
					},
					"MeasureLatency": {
						"type": "boolean"
					},
					"Inverted": {
						"type": "boolean"
					},
					"HealthThreshold": {
						"type": "integer"
					},
					"ChildHealthChecks": {
						"shape": "S1o"
					},
					"EnableSNI": {
						"type": "boolean"
					},
					"Regions": {
						"shape": "S1q"
					},
					"AlarmIdentifier": {
						"shape": "S1s"
					},
					"InsufficientDataHealthStatus": {}
				}
			},
			"S1o": {
				"type": "list",
				"member": {
					"locationName": "ChildHealthCheck"
				}
			},
			"S1q": {
				"type": "list",
				"member": {
					"locationName": "Region"
				}
			},
			"S1s": {
				"type": "structure",
				"required": [
					"Region",
					"Name"
				],
				"members": {
					"Region": {},
					"Name": {}
				}
			},
			"S1x": {
				"type": "structure",
				"required": [
					"Id",
					"CallerReference",
					"HealthCheckConfig",
					"HealthCheckVersion"
				],
				"members": {
					"Id": {},
					"CallerReference": {},
					"HealthCheckConfig": {
						"shape": "S1c"
					},
					"HealthCheckVersion": {
						"type": "long"
					},
					"CloudWatchAlarmConfiguration": {
						"type": "structure",
						"required": [
							"EvaluationPeriods",
							"Threshold",
							"ComparisonOperator",
							"Period",
							"MetricName",
							"Namespace",
							"Statistic"
						],
						"members": {
							"EvaluationPeriods": {
								"type": "integer"
							},
							"Threshold": {
								"type": "double"
							},
							"ComparisonOperator": {},
							"Period": {
								"type": "integer"
							},
							"MetricName": {},
							"Namespace": {},
							"Statistic": {},
							"Dimensions": {
								"type": "list",
								"member": {
									"locationName": "Dimension",
									"type": "structure",
									"required": [
										"Name",
										"Value"
									],
									"members": {
										"Name": {},
										"Value": {}
									}
								}
							}
						}
					}
				}
			},
			"S2d": {
				"type": "structure",
				"members": {
					"Comment": {},
					"PrivateZone": {
						"type": "boolean"
					}
				}
			},
			"S2g": {
				"type": "structure",
				"required": [
					"Id",
					"Name",
					"CallerReference"
				],
				"members": {
					"Id": {},
					"Name": {},
					"CallerReference": {},
					"Config": {
						"shape": "S2d"
					},
					"ResourceRecordSetCount": {
						"type": "long"
					}
				}
			},
			"S2i": {
				"type": "structure",
				"required": [
					"NameServers"
				],
				"members": {
					"Id": {},
					"CallerReference": {},
					"NameServers": {
						"type": "list",
						"member": {
							"locationName": "NameServer"
						}
					}
				}
			},
			"S2r": {
				"type": "structure",
				"required": [
					"Id",
					"Version",
					"Name",
					"Type",
					"Document"
				],
				"members": {
					"Id": {},
					"Version": {
						"type": "integer"
					},
					"Name": {},
					"Type": {},
					"Document": {},
					"Comment": {}
				}
			},
			"S2w": {
				"type": "structure",
				"required": [
					"Id",
					"HostedZoneId",
					"Name",
					"TTL",
					"State",
					"Message",
					"TrafficPolicyId",
					"TrafficPolicyVersion",
					"TrafficPolicyType"
				],
				"members": {
					"Id": {},
					"HostedZoneId": {},
					"Name": {},
					"TTL": {
						"type": "long"
					},
					"State": {},
					"Message": {},
					"TrafficPolicyId": {},
					"TrafficPolicyVersion": {
						"type": "integer"
					},
					"TrafficPolicyType": {}
				}
			},
			"S3q": {
				"type": "structure",
				"members": {
					"ContinentCode": {},
					"ContinentName": {},
					"CountryCode": {},
					"CountryName": {},
					"SubdivisionCode": {},
					"SubdivisionName": {}
				}
			},
			"S41": {
				"type": "list",
				"member": {
					"locationName": "HealthCheckObservation",
					"type": "structure",
					"members": {
						"Region": {},
						"IPAddress": {},
						"StatusReport": {
							"type": "structure",
							"members": {
								"Status": {},
								"CheckedTime": {
									"type": "timestamp"
								}
							}
						}
					}
				}
			},
			"S49": {
				"type": "list",
				"member": {
					"shape": "S3",
					"locationName": "VPC"
				}
			},
			"S4x": {
				"type": "list",
				"member": {
					"shape": "S2g",
					"locationName": "HostedZone"
				}
			},
			"S58": {
				"type": "structure",
				"members": {
					"ResourceType": {},
					"ResourceId": {},
					"Tags": {
						"shape": "S14"
					}
				}
			},
			"S5j": {
				"type": "list",
				"member": {
					"shape": "S2w",
					"locationName": "TrafficPolicyInstance"
				}
			}
		}
	};

/***/ },
/* 749 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListHealthChecks": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "NextMarker",
				"result_key": "HealthChecks"
			},
			"ListHostedZones": {
				"input_token": "Marker",
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": "NextMarker",
				"result_key": "HostedZones"
			},
			"ListResourceRecordSets": {
				"input_token": [
					"StartRecordName",
					"StartRecordType",
					"StartRecordIdentifier"
				],
				"limit_key": "MaxItems",
				"more_results": "IsTruncated",
				"output_token": [
					"NextRecordName",
					"NextRecordType",
					"NextRecordIdentifier"
				],
				"result_key": "ResourceRecordSets"
			}
		}
	};

/***/ },
/* 750 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"ResourceRecordSetsChanged": {
				"delay": 30,
				"maxAttempts": 60,
				"operation": "GetChange",
				"acceptors": [
					{
						"matcher": "path",
						"expected": "INSYNC",
						"argument": "ChangeInfo.Status",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 751 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "route53domains-2014-05-15",
			"apiVersion": "2014-05-15",
			"endpointPrefix": "route53domains",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "Amazon Route 53 Domains",
			"signatureVersion": "v4",
			"targetPrefix": "Route53Domains_v20140515"
		},
		"operations": {
			"CheckDomainAvailability": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"IdnLangCode": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Availability"
					],
					"members": {
						"Availability": {}
					}
				}
			},
			"DeleteTagsForDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"TagsToDelete"
					],
					"members": {
						"DomainName": {},
						"TagsToDelete": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisableDomainAutoRenew": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisableDomainTransferLock": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"EnableDomainAutoRenew": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"EnableDomainTransferLock": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"GetContactReachabilityStatus": {
				"input": {
					"type": "structure",
					"members": {
						"domainName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"domainName": {},
						"status": {}
					}
				}
			},
			"GetDomainDetail": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"DomainName",
						"Nameservers",
						"AdminContact",
						"RegistrantContact",
						"TechContact"
					],
					"members": {
						"DomainName": {},
						"Nameservers": {
							"shape": "So"
						},
						"AutoRenew": {
							"type": "boolean"
						},
						"AdminContact": {
							"shape": "Su"
						},
						"RegistrantContact": {
							"shape": "Su"
						},
						"TechContact": {
							"shape": "Su"
						},
						"AdminPrivacy": {
							"type": "boolean"
						},
						"RegistrantPrivacy": {
							"type": "boolean"
						},
						"TechPrivacy": {
							"type": "boolean"
						},
						"RegistrarName": {},
						"WhoIsServer": {},
						"RegistrarUrl": {},
						"AbuseContactEmail": {},
						"AbuseContactPhone": {},
						"RegistryDomainId": {},
						"CreationDate": {
							"type": "timestamp"
						},
						"UpdatedDate": {
							"type": "timestamp"
						},
						"ExpirationDate": {
							"type": "timestamp"
						},
						"Reseller": {},
						"DnsSec": {},
						"StatusList": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"GetDomainSuggestions": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"SuggestionCount",
						"OnlyAvailable"
					],
					"members": {
						"DomainName": {},
						"SuggestionCount": {
							"type": "integer"
						},
						"OnlyAvailable": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SuggestionsList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DomainName": {},
									"Availability": {}
								}
							}
						}
					}
				}
			},
			"GetOperationDetail": {
				"input": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"OperationId": {},
						"Status": {},
						"Message": {},
						"DomainName": {},
						"Type": {},
						"SubmittedDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"ListDomains": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Domains"
					],
					"members": {
						"Domains": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"DomainName"
								],
								"members": {
									"DomainName": {},
									"AutoRenew": {
										"type": "boolean"
									},
									"TransferLock": {
										"type": "boolean"
									},
									"Expiry": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextPageMarker": {}
					}
				}
			},
			"ListOperations": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"Operations"
					],
					"members": {
						"Operations": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"OperationId",
									"Status",
									"Type",
									"SubmittedDate"
								],
								"members": {
									"OperationId": {},
									"Status": {},
									"Type": {},
									"SubmittedDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextPageMarker": {}
					}
				}
			},
			"ListTagsForDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagList"
					],
					"members": {
						"TagList": {
							"shape": "S24"
						}
					}
				}
			},
			"RegisterDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"DurationInYears",
						"AdminContact",
						"RegistrantContact",
						"TechContact"
					],
					"members": {
						"DomainName": {},
						"IdnLangCode": {},
						"DurationInYears": {
							"type": "integer"
						},
						"AutoRenew": {
							"type": "boolean"
						},
						"AdminContact": {
							"shape": "Su"
						},
						"RegistrantContact": {
							"shape": "Su"
						},
						"TechContact": {
							"shape": "Su"
						},
						"PrivacyProtectAdminContact": {
							"type": "boolean"
						},
						"PrivacyProtectRegistrantContact": {
							"type": "boolean"
						},
						"PrivacyProtectTechContact": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"RenewDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"CurrentExpiryYear"
					],
					"members": {
						"DomainName": {},
						"DurationInYears": {
							"type": "integer"
						},
						"CurrentExpiryYear": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"ResendContactReachabilityEmail": {
				"input": {
					"type": "structure",
					"members": {
						"domainName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"domainName": {},
						"emailAddress": {},
						"isAlreadyVerified": {
							"type": "boolean"
						}
					}
				}
			},
			"RetrieveDomainAuthCode": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"AuthCode"
					],
					"members": {
						"AuthCode": {
							"shape": "S2h"
						}
					}
				}
			},
			"TransferDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"DurationInYears",
						"AdminContact",
						"RegistrantContact",
						"TechContact"
					],
					"members": {
						"DomainName": {},
						"IdnLangCode": {},
						"DurationInYears": {
							"type": "integer"
						},
						"Nameservers": {
							"shape": "So"
						},
						"AuthCode": {
							"shape": "S2h"
						},
						"AutoRenew": {
							"type": "boolean"
						},
						"AdminContact": {
							"shape": "Su"
						},
						"RegistrantContact": {
							"shape": "Su"
						},
						"TechContact": {
							"shape": "Su"
						},
						"PrivacyProtectAdminContact": {
							"type": "boolean"
						},
						"PrivacyProtectRegistrantContact": {
							"type": "boolean"
						},
						"PrivacyProtectTechContact": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateDomainContact": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"AdminContact": {
							"shape": "Su"
						},
						"RegistrantContact": {
							"shape": "Su"
						},
						"TechContact": {
							"shape": "Su"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateDomainContactPrivacy": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"AdminPrivacy": {
							"type": "boolean"
						},
						"RegistrantPrivacy": {
							"type": "boolean"
						},
						"TechPrivacy": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateDomainNameservers": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName",
						"Nameservers"
					],
					"members": {
						"DomainName": {},
						"FIAuthKey": {},
						"Nameservers": {
							"shape": "So"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"OperationId"
					],
					"members": {
						"OperationId": {}
					}
				}
			},
			"UpdateTagsForDomain": {
				"input": {
					"type": "structure",
					"required": [
						"DomainName"
					],
					"members": {
						"DomainName": {},
						"TagsToUpdate": {
							"shape": "S24"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ViewBilling": {
				"input": {
					"type": "structure",
					"members": {
						"Start": {
							"type": "timestamp"
						},
						"End": {
							"type": "timestamp"
						},
						"Marker": {},
						"MaxItems": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextPageMarker": {},
						"BillingRecords": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DomainName": {},
									"Operation": {},
									"InvoiceId": {},
									"BillDate": {
										"type": "timestamp"
									},
									"Price": {
										"type": "double"
									}
								}
							}
						}
					}
				}
			}
		},
		"shapes": {
			"So": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"GlueIps": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"Su": {
				"type": "structure",
				"members": {
					"FirstName": {},
					"LastName": {},
					"ContactType": {},
					"OrganizationName": {},
					"AddressLine1": {},
					"AddressLine2": {},
					"City": {},
					"State": {},
					"CountryCode": {},
					"ZipCode": {},
					"PhoneNumber": {},
					"Email": {},
					"Fax": {},
					"ExtraParams": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Name",
								"Value"
							],
							"members": {
								"Name": {},
								"Value": {}
							}
						}
					}
				},
				"sensitive": true
			},
			"S24": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S2h": {
				"type": "string",
				"sensitive": true
			}
		}
	};

/***/ },
/* 752 */
/***/ function(module, exports) {

	module.exports = {
		"version": "1.0",
		"pagination": {
			"ListDomains": {
				"limit_key": "MaxItems",
				"input_token": "Marker",
				"output_token": "NextPageMarker",
				"result_key": "Domains"
			},
			"ListOperations": {
				"limit_key": "MaxItems",
				"input_token": "Marker",
				"output_token": "NextPageMarker",
				"result_key": "Operations"
			}
		}
	};

/***/ },
/* 753 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2016-11-28",
			"endpointPrefix": "runtime.lex",
			"jsonVersion": "1.1",
			"protocol": "rest-json",
			"serviceFullName": "Amazon Lex Runtime Service",
			"signatureVersion": "v4",
			"signingName": "lex",
			"uid": "runtime.lex-2016-11-28"
		},
		"operations": {
			"PostText": {
				"http": {
					"requestUri": "/bot/{botName}/alias/{botAlias}/user/{userId}/text"
				},
				"input": {
					"type": "structure",
					"required": [
						"botName",
						"botAlias",
						"userId",
						"inputText"
					],
					"members": {
						"botName": {
							"location": "uri",
							"locationName": "botName"
						},
						"botAlias": {
							"location": "uri",
							"locationName": "botAlias"
						},
						"userId": {
							"location": "uri",
							"locationName": "userId"
						},
						"sessionAttributes": {
							"shape": "S5"
						},
						"inputText": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"intentName": {},
						"slots": {
							"shape": "S5"
						},
						"sessionAttributes": {
							"shape": "S5"
						},
						"message": {},
						"dialogState": {},
						"slotToElicit": {},
						"responseCard": {
							"type": "structure",
							"members": {
								"version": {},
								"contentType": {},
								"genericAttachments": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"title": {},
											"subTitle": {},
											"attachmentLinkUrl": {},
											"imageUrl": {},
											"buttons": {
												"type": "list",
												"member": {
													"type": "structure",
													"required": [
														"text",
														"value"
													],
													"members": {
														"text": {},
														"value": {}
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "map",
				"key": {},
				"value": {}
			}
		}
	};

/***/ },
/* 754 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {}
	};

/***/ },
/* 755 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2006-03-01",
			"checksumFormat": "md5",
			"endpointPrefix": "s3",
			"globalEndpoint": "s3.amazonaws.com",
			"protocol": "rest-xml",
			"serviceAbbreviation": "Amazon S3",
			"serviceFullName": "Amazon Simple Storage Service",
			"signatureVersion": "s3",
			"timestampFormat": "rfc822",
			"uid": "s3-2006-03-01"
		},
		"operations": {
			"AbortMultipartUpload": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"CompleteMultipartUpload": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"MultipartUpload": {
							"locationName": "CompleteMultipartUpload",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"Parts": {
									"locationName": "Part",
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ETag": {},
											"PartNumber": {
												"type": "integer"
											}
										}
									},
									"flattened": true
								}
							}
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "MultipartUpload"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {},
						"Bucket": {},
						"Key": {},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"ETag": {},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"CopyObject": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"CopySource",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"CopySource": {
							"location": "header",
							"locationName": "x-amz-copy-source"
						},
						"CopySourceIfMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-match"
						},
						"CopySourceIfModifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-modified-since",
							"type": "timestamp"
						},
						"CopySourceIfNoneMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-none-match"
						},
						"CopySourceIfUnmodifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-unmodified-since",
							"type": "timestamp"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"MetadataDirective": {
							"location": "header",
							"locationName": "x-amz-metadata-directive"
						},
						"TaggingDirective": {
							"location": "header",
							"locationName": "x-amz-tagging-directive"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"CopySourceSSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
						},
						"CopySourceSSECustomerKey": {
							"shape": "S1c",
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
						},
						"CopySourceSSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Tagging": {
							"location": "header",
							"locationName": "x-amz-tagging"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CopyObjectResult": {
							"type": "structure",
							"members": {
								"ETag": {},
								"LastModified": {
									"type": "timestamp"
								}
							}
						},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"CopySourceVersionId": {
							"location": "header",
							"locationName": "x-amz-copy-source-version-id"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					},
					"payload": "CopyObjectResult"
				},
				"alias": "PutObjectCopy"
			},
			"CreateBucket": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CreateBucketConfiguration": {
							"locationName": "CreateBucketConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"LocationConstraint": {}
							}
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWrite": {
							"location": "header",
							"locationName": "x-amz-grant-write"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						}
					},
					"payload": "CreateBucketConfiguration"
				},
				"output": {
					"type": "structure",
					"members": {
						"Location": {
							"location": "header",
							"locationName": "Location"
						}
					}
				},
				"alias": "PutBucket"
			},
			"CreateMultipartUpload": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}?uploads"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AbortDate": {
							"location": "header",
							"locationName": "x-amz-abort-date",
							"type": "timestamp"
						},
						"AbortRuleId": {
							"location": "header",
							"locationName": "x-amz-abort-rule-id"
						},
						"Bucket": {
							"locationName": "Bucket"
						},
						"Key": {},
						"UploadId": {},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				},
				"alias": "InitiateMultipartUpload"
			},
			"DeleteBucket": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketAnalyticsConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				}
			},
			"DeleteBucketCors": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?cors"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketInventoryConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				}
			},
			"DeleteBucketLifecycle": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketMetricsConfiguration": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				}
			},
			"DeleteBucketPolicy": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?policy"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketReplication": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?replication"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketTagging": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteBucketWebsite": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}?website"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"DeleteObject": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"MFA": {
							"location": "header",
							"locationName": "x-amz-mfa"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeleteMarker": {
							"location": "header",
							"locationName": "x-amz-delete-marker",
							"type": "boolean"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"DeleteObjectTagging": {
				"http": {
					"method": "DELETE",
					"requestUri": "/{Bucket}/{Key+}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						}
					}
				}
			},
			"DeleteObjects": {
				"http": {
					"requestUri": "/{Bucket}?delete"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Delete"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delete": {
							"locationName": "Delete",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Objects"
							],
							"members": {
								"Objects": {
									"locationName": "Object",
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"Key"
										],
										"members": {
											"Key": {},
											"VersionId": {}
										}
									},
									"flattened": true
								},
								"Quiet": {
									"type": "boolean"
								}
							}
						},
						"MFA": {
							"location": "header",
							"locationName": "x-amz-mfa"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "Delete"
				},
				"output": {
					"type": "structure",
					"members": {
						"Deleted": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"VersionId": {},
									"DeleteMarker": {
										"type": "boolean"
									},
									"DeleteMarkerVersionId": {}
								}
							},
							"flattened": true
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"Errors": {
							"locationName": "Error",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"VersionId": {},
									"Code": {},
									"Message": {}
								}
							},
							"flattened": true
						}
					}
				},
				"alias": "DeleteMultipleObjects"
			},
			"GetBucketAccelerateConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?accelerate"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {}
					}
				}
			},
			"GetBucketAcl": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Owner": {
							"shape": "S2u"
						},
						"Grants": {
							"shape": "S2x",
							"locationName": "AccessControlList"
						}
					}
				}
			},
			"GetBucketAnalyticsConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AnalyticsConfiguration": {
							"shape": "S36"
						}
					},
					"payload": "AnalyticsConfiguration"
				}
			},
			"GetBucketCors": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?cors"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CORSRules": {
							"shape": "S3m",
							"locationName": "CORSRule"
						}
					}
				}
			},
			"GetBucketInventoryConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InventoryConfiguration": {
							"shape": "S3z"
						}
					},
					"payload": "InventoryConfiguration"
				}
			},
			"GetBucketLifecycle": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S4c",
							"locationName": "Rule"
						}
					}
				},
				"deprecated": true
			},
			"GetBucketLifecycleConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rules": {
							"shape": "S4r",
							"locationName": "Rule"
						}
					}
				}
			},
			"GetBucketLocation": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?location"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LocationConstraint": {}
					}
				}
			},
			"GetBucketLogging": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?logging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LoggingEnabled": {
							"shape": "S51"
						}
					}
				}
			},
			"GetBucketMetricsConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"MetricsConfiguration": {
							"shape": "S59"
						}
					},
					"payload": "MetricsConfiguration"
				}
			},
			"GetBucketNotification": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"shape": "S5c"
				},
				"output": {
					"shape": "S5d"
				},
				"deprecated": true
			},
			"GetBucketNotificationConfiguration": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"shape": "S5c"
				},
				"output": {
					"shape": "S5o"
				}
			},
			"GetBucketPolicy": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?policy"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Policy": {}
					},
					"payload": "Policy"
				}
			},
			"GetBucketReplication": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?replication"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ReplicationConfiguration": {
							"shape": "S67"
						}
					},
					"payload": "ReplicationConfiguration"
				}
			},
			"GetBucketRequestPayment": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?requestPayment"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Payer": {}
					}
				}
			},
			"GetBucketTagging": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagSet"
					],
					"members": {
						"TagSet": {
							"shape": "S3c"
						}
					}
				}
			},
			"GetBucketVersioning": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?versioning"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Status": {},
						"MFADelete": {
							"locationName": "MfaDelete"
						}
					}
				}
			},
			"GetBucketWebsite": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?website"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RedirectAllRequestsTo": {
							"shape": "S6o"
						},
						"IndexDocument": {
							"shape": "S6r"
						},
						"ErrorDocument": {
							"shape": "S6t"
						},
						"RoutingRules": {
							"shape": "S6u"
						}
					}
				}
			},
			"GetObject": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						},
						"IfModifiedSince": {
							"location": "header",
							"locationName": "If-Modified-Since",
							"type": "timestamp"
						},
						"IfNoneMatch": {
							"location": "header",
							"locationName": "If-None-Match"
						},
						"IfUnmodifiedSince": {
							"location": "header",
							"locationName": "If-Unmodified-Since",
							"type": "timestamp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Range": {
							"location": "header",
							"locationName": "Range"
						},
						"ResponseCacheControl": {
							"location": "querystring",
							"locationName": "response-cache-control"
						},
						"ResponseContentDisposition": {
							"location": "querystring",
							"locationName": "response-content-disposition"
						},
						"ResponseContentEncoding": {
							"location": "querystring",
							"locationName": "response-content-encoding"
						},
						"ResponseContentLanguage": {
							"location": "querystring",
							"locationName": "response-content-language"
						},
						"ResponseContentType": {
							"location": "querystring",
							"locationName": "response-content-type"
						},
						"ResponseExpires": {
							"location": "querystring",
							"locationName": "response-expires",
							"type": "timestamp"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"DeleteMarker": {
							"location": "header",
							"locationName": "x-amz-delete-marker",
							"type": "boolean"
						},
						"AcceptRanges": {
							"location": "header",
							"locationName": "accept-ranges"
						},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"Restore": {
							"location": "header",
							"locationName": "x-amz-restore"
						},
						"LastModified": {
							"location": "header",
							"locationName": "Last-Modified",
							"type": "timestamp"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"MissingMeta": {
							"location": "header",
							"locationName": "x-amz-missing-meta",
							"type": "integer"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentRange": {
							"location": "header",
							"locationName": "Content-Range"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"ReplicationStatus": {
							"location": "header",
							"locationName": "x-amz-replication-status"
						},
						"PartsCount": {
							"location": "header",
							"locationName": "x-amz-mp-parts-count",
							"type": "integer"
						},
						"TagCount": {
							"location": "header",
							"locationName": "x-amz-tagging-count",
							"type": "integer"
						}
					},
					"payload": "Body"
				}
			},
			"GetObjectAcl": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Owner": {
							"shape": "S2u"
						},
						"Grants": {
							"shape": "S2x",
							"locationName": "AccessControlList"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"GetObjectTagging": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						}
					}
				},
				"output": {
					"type": "structure",
					"required": [
						"TagSet"
					],
					"members": {
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"TagSet": {
							"shape": "S3c"
						}
					}
				}
			},
			"GetObjectTorrent": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}?torrent"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					},
					"payload": "Body"
				}
			},
			"HeadBucket": {
				"http": {
					"method": "HEAD",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						}
					}
				}
			},
			"HeadObject": {
				"http": {
					"method": "HEAD",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"IfMatch": {
							"location": "header",
							"locationName": "If-Match"
						},
						"IfModifiedSince": {
							"location": "header",
							"locationName": "If-Modified-Since",
							"type": "timestamp"
						},
						"IfNoneMatch": {
							"location": "header",
							"locationName": "If-None-Match"
						},
						"IfUnmodifiedSince": {
							"location": "header",
							"locationName": "If-Unmodified-Since",
							"type": "timestamp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Range": {
							"location": "header",
							"locationName": "Range"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DeleteMarker": {
							"location": "header",
							"locationName": "x-amz-delete-marker",
							"type": "boolean"
						},
						"AcceptRanges": {
							"location": "header",
							"locationName": "accept-ranges"
						},
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"Restore": {
							"location": "header",
							"locationName": "x-amz-restore"
						},
						"LastModified": {
							"location": "header",
							"locationName": "Last-Modified",
							"type": "timestamp"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"MissingMeta": {
							"location": "header",
							"locationName": "x-amz-missing-meta",
							"type": "integer"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						},
						"ReplicationStatus": {
							"location": "header",
							"locationName": "x-amz-replication-status"
						},
						"PartsCount": {
							"location": "header",
							"locationName": "x-amz-mp-parts-count",
							"type": "integer"
						}
					}
				}
			},
			"ListBucketAnalyticsConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"ContinuationToken": {},
						"NextContinuationToken": {},
						"AnalyticsConfigurationList": {
							"locationName": "AnalyticsConfiguration",
							"type": "list",
							"member": {
								"shape": "S36"
							},
							"flattened": true
						}
					}
				}
			},
			"ListBucketInventoryConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ContinuationToken": {},
						"InventoryConfigurationList": {
							"locationName": "InventoryConfiguration",
							"type": "list",
							"member": {
								"shape": "S3z"
							},
							"flattened": true
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"NextContinuationToken": {}
					}
				}
			},
			"ListBucketMetricsConfigurations": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"ContinuationToken": {},
						"NextContinuationToken": {},
						"MetricsConfigurationList": {
							"locationName": "MetricsConfiguration",
							"type": "list",
							"member": {
								"shape": "S59"
							},
							"flattened": true
						}
					}
				}
			},
			"ListBuckets": {
				"http": {
					"method": "GET"
				},
				"output": {
					"type": "structure",
					"members": {
						"Buckets": {
							"type": "list",
							"member": {
								"locationName": "Bucket",
								"type": "structure",
								"members": {
									"Name": {},
									"CreationDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"Owner": {
							"shape": "S2u"
						}
					}
				},
				"alias": "GetService"
			},
			"ListMultipartUploads": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?uploads"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"KeyMarker": {
							"location": "querystring",
							"locationName": "key-marker"
						},
						"MaxUploads": {
							"location": "querystring",
							"locationName": "max-uploads",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"UploadIdMarker": {
							"location": "querystring",
							"locationName": "upload-id-marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Bucket": {},
						"KeyMarker": {},
						"UploadIdMarker": {},
						"NextKeyMarker": {},
						"Prefix": {},
						"Delimiter": {},
						"NextUploadIdMarker": {},
						"MaxUploads": {
							"type": "integer"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Uploads": {
							"locationName": "Upload",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"UploadId": {},
									"Key": {},
									"Initiated": {
										"type": "timestamp"
									},
									"StorageClass": {},
									"Owner": {
										"shape": "S2u"
									},
									"Initiator": {
										"shape": "S8q"
									}
								}
							},
							"flattened": true
						},
						"CommonPrefixes": {
							"shape": "S8r"
						},
						"EncodingType": {}
					}
				}
			},
			"ListObjectVersions": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?versions"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"KeyMarker": {
							"location": "querystring",
							"locationName": "key-marker"
						},
						"MaxKeys": {
							"location": "querystring",
							"locationName": "max-keys",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"VersionIdMarker": {
							"location": "querystring",
							"locationName": "version-id-marker"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"KeyMarker": {},
						"VersionIdMarker": {},
						"NextKeyMarker": {},
						"NextVersionIdMarker": {},
						"Versions": {
							"locationName": "Version",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ETag": {},
									"Size": {
										"type": "integer"
									},
									"StorageClass": {},
									"Key": {},
									"VersionId": {},
									"IsLatest": {
										"type": "boolean"
									},
									"LastModified": {
										"type": "timestamp"
									},
									"Owner": {
										"shape": "S2u"
									}
								}
							},
							"flattened": true
						},
						"DeleteMarkers": {
							"locationName": "DeleteMarker",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Owner": {
										"shape": "S2u"
									},
									"Key": {},
									"VersionId": {},
									"IsLatest": {
										"type": "boolean"
									},
									"LastModified": {
										"type": "timestamp"
									}
								}
							},
							"flattened": true
						},
						"Name": {},
						"Prefix": {},
						"Delimiter": {},
						"MaxKeys": {
							"type": "integer"
						},
						"CommonPrefixes": {
							"shape": "S8r"
						},
						"EncodingType": {}
					}
				},
				"alias": "GetBucketObjectVersions"
			},
			"ListObjects": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"Marker": {
							"location": "querystring",
							"locationName": "marker"
						},
						"MaxKeys": {
							"location": "querystring",
							"locationName": "max-keys",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"Marker": {},
						"NextMarker": {},
						"Contents": {
							"shape": "S99"
						},
						"Name": {},
						"Prefix": {},
						"Delimiter": {},
						"MaxKeys": {
							"type": "integer"
						},
						"CommonPrefixes": {
							"shape": "S8r"
						},
						"EncodingType": {}
					}
				},
				"alias": "GetBucket"
			},
			"ListObjectsV2": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}?list-type=2"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Delimiter": {
							"location": "querystring",
							"locationName": "delimiter"
						},
						"EncodingType": {
							"location": "querystring",
							"locationName": "encoding-type"
						},
						"MaxKeys": {
							"location": "querystring",
							"locationName": "max-keys",
							"type": "integer"
						},
						"Prefix": {
							"location": "querystring",
							"locationName": "prefix"
						},
						"ContinuationToken": {
							"location": "querystring",
							"locationName": "continuation-token"
						},
						"FetchOwner": {
							"location": "querystring",
							"locationName": "fetch-owner",
							"type": "boolean"
						},
						"StartAfter": {
							"location": "querystring",
							"locationName": "start-after"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IsTruncated": {
							"type": "boolean"
						},
						"Contents": {
							"shape": "S99"
						},
						"Name": {},
						"Prefix": {},
						"Delimiter": {},
						"MaxKeys": {
							"type": "integer"
						},
						"CommonPrefixes": {
							"shape": "S8r"
						},
						"EncodingType": {},
						"KeyCount": {
							"type": "integer"
						},
						"ContinuationToken": {},
						"NextContinuationToken": {},
						"StartAfter": {}
					}
				}
			},
			"ListParts": {
				"http": {
					"method": "GET",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"MaxParts": {
							"location": "querystring",
							"locationName": "max-parts",
							"type": "integer"
						},
						"PartNumberMarker": {
							"location": "querystring",
							"locationName": "part-number-marker",
							"type": "integer"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AbortDate": {
							"location": "header",
							"locationName": "x-amz-abort-date",
							"type": "timestamp"
						},
						"AbortRuleId": {
							"location": "header",
							"locationName": "x-amz-abort-rule-id"
						},
						"Bucket": {},
						"Key": {},
						"UploadId": {},
						"PartNumberMarker": {
							"type": "integer"
						},
						"NextPartNumberMarker": {
							"type": "integer"
						},
						"MaxParts": {
							"type": "integer"
						},
						"IsTruncated": {
							"type": "boolean"
						},
						"Parts": {
							"locationName": "Part",
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PartNumber": {
										"type": "integer"
									},
									"LastModified": {
										"type": "timestamp"
									},
									"ETag": {},
									"Size": {
										"type": "integer"
									}
								}
							},
							"flattened": true
						},
						"Initiator": {
							"shape": "S8q"
						},
						"Owner": {
							"shape": "S2u"
						},
						"StorageClass": {},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutBucketAccelerateConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?accelerate"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"AccelerateConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"AccelerateConfiguration": {
							"locationName": "AccelerateConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"Status": {}
							}
						}
					},
					"payload": "AccelerateConfiguration"
				}
			},
			"PutBucketAcl": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"AccessControlPolicy": {
							"shape": "S9r",
							"locationName": "AccessControlPolicy",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWrite": {
							"location": "header",
							"locationName": "x-amz-grant-write"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						}
					},
					"payload": "AccessControlPolicy"
				}
			},
			"PutBucketAnalyticsConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?analytics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id",
						"AnalyticsConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						},
						"AnalyticsConfiguration": {
							"shape": "S36",
							"locationName": "AnalyticsConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "AnalyticsConfiguration"
				}
			},
			"PutBucketCors": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?cors"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"CORSConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CORSConfiguration": {
							"locationName": "CORSConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"CORSRules"
							],
							"members": {
								"CORSRules": {
									"shape": "S3m",
									"locationName": "CORSRule"
								}
							}
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "CORSConfiguration"
				}
			},
			"PutBucketInventoryConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?inventory"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id",
						"InventoryConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						},
						"InventoryConfiguration": {
							"shape": "S3z",
							"locationName": "InventoryConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "InventoryConfiguration"
				}
			},
			"PutBucketLifecycle": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"LifecycleConfiguration": {
							"locationName": "LifecycleConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"shape": "S4c",
									"locationName": "Rule"
								}
							}
						}
					},
					"payload": "LifecycleConfiguration"
				},
				"deprecated": true
			},
			"PutBucketLifecycleConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?lifecycle"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"LifecycleConfiguration": {
							"locationName": "LifecycleConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Rules"
							],
							"members": {
								"Rules": {
									"shape": "S4r",
									"locationName": "Rule"
								}
							}
						}
					},
					"payload": "LifecycleConfiguration"
				}
			},
			"PutBucketLogging": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?logging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"BucketLoggingStatus"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"BucketLoggingStatus": {
							"locationName": "BucketLoggingStatus",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"LoggingEnabled": {
									"shape": "S51"
								}
							}
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						}
					},
					"payload": "BucketLoggingStatus"
				}
			},
			"PutBucketMetricsConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?metrics"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Id",
						"MetricsConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Id": {
							"location": "querystring",
							"locationName": "id"
						},
						"MetricsConfiguration": {
							"shape": "S59",
							"locationName": "MetricsConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "MetricsConfiguration"
				}
			},
			"PutBucketNotification": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"NotificationConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"NotificationConfiguration": {
							"shape": "S5d",
							"locationName": "NotificationConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "NotificationConfiguration"
				},
				"deprecated": true
			},
			"PutBucketNotificationConfiguration": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?notification"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"NotificationConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"NotificationConfiguration": {
							"shape": "S5o",
							"locationName": "NotificationConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "NotificationConfiguration"
				}
			},
			"PutBucketPolicy": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?policy"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Policy"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Policy": {}
					},
					"payload": "Policy"
				}
			},
			"PutBucketReplication": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?replication"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"ReplicationConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ReplicationConfiguration": {
							"shape": "S67",
							"locationName": "ReplicationConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "ReplicationConfiguration"
				}
			},
			"PutBucketRequestPayment": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?requestPayment"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"RequestPaymentConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"RequestPaymentConfiguration": {
							"locationName": "RequestPaymentConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Payer"
							],
							"members": {
								"Payer": {}
							}
						}
					},
					"payload": "RequestPaymentConfiguration"
				}
			},
			"PutBucketTagging": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Tagging"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Tagging": {
							"shape": "Sab",
							"locationName": "Tagging",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "Tagging"
				}
			},
			"PutBucketVersioning": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?versioning"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"VersioningConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"MFA": {
							"location": "header",
							"locationName": "x-amz-mfa"
						},
						"VersioningConfiguration": {
							"locationName": "VersioningConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"MFADelete": {
									"locationName": "MfaDelete"
								},
								"Status": {}
							}
						}
					},
					"payload": "VersioningConfiguration"
				}
			},
			"PutBucketWebsite": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}?website"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"WebsiteConfiguration"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"WebsiteConfiguration": {
							"locationName": "WebsiteConfiguration",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"members": {
								"ErrorDocument": {
									"shape": "S6t"
								},
								"IndexDocument": {
									"shape": "S6r"
								},
								"RedirectAllRequestsTo": {
									"shape": "S6o"
								},
								"RoutingRules": {
									"shape": "S6u"
								}
							}
						}
					},
					"payload": "WebsiteConfiguration"
				}
			},
			"PutObject": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CacheControl": {
							"location": "header",
							"locationName": "Cache-Control"
						},
						"ContentDisposition": {
							"location": "header",
							"locationName": "Content-Disposition"
						},
						"ContentEncoding": {
							"location": "header",
							"locationName": "Content-Encoding"
						},
						"ContentLanguage": {
							"location": "header",
							"locationName": "Content-Language"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"ContentType": {
							"location": "header",
							"locationName": "Content-Type"
						},
						"Expires": {
							"location": "header",
							"locationName": "Expires",
							"type": "timestamp"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"Metadata": {
							"shape": "S11",
							"location": "headers",
							"locationName": "x-amz-meta-"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"StorageClass": {
							"location": "header",
							"locationName": "x-amz-storage-class"
						},
						"WebsiteRedirectLocation": {
							"location": "header",
							"locationName": "x-amz-website-redirect-location"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"Tagging": {
							"location": "header",
							"locationName": "x-amz-tagging"
						}
					},
					"payload": "Body"
				},
				"output": {
					"type": "structure",
					"members": {
						"Expiration": {
							"location": "header",
							"locationName": "x-amz-expiration"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectAcl": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?acl"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"ACL": {
							"location": "header",
							"locationName": "x-amz-acl"
						},
						"AccessControlPolicy": {
							"shape": "S9r",
							"locationName": "AccessControlPolicy",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"GrantFullControl": {
							"location": "header",
							"locationName": "x-amz-grant-full-control"
						},
						"GrantRead": {
							"location": "header",
							"locationName": "x-amz-grant-read"
						},
						"GrantReadACP": {
							"location": "header",
							"locationName": "x-amz-grant-read-acp"
						},
						"GrantWrite": {
							"location": "header",
							"locationName": "x-amz-grant-write"
						},
						"GrantWriteACP": {
							"location": "header",
							"locationName": "x-amz-grant-write-acp"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						}
					},
					"payload": "AccessControlPolicy"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"PutObjectTagging": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}?tagging"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"Tagging"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Tagging": {
							"shape": "Sab",
							"locationName": "Tagging",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							}
						}
					},
					"payload": "Tagging"
				},
				"output": {
					"type": "structure",
					"members": {
						"VersionId": {
							"location": "header",
							"locationName": "x-amz-version-id"
						}
					}
				}
			},
			"RestoreObject": {
				"http": {
					"requestUri": "/{Bucket}/{Key+}?restore"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"VersionId": {
							"location": "querystring",
							"locationName": "versionId"
						},
						"RestoreRequest": {
							"locationName": "RestoreRequest",
							"xmlNamespace": {
								"uri": "http://s3.amazonaws.com/doc/2006-03-01/"
							},
							"type": "structure",
							"required": [
								"Days"
							],
							"members": {
								"Days": {
									"type": "integer"
								},
								"GlacierJobParameters": {
									"type": "structure",
									"required": [
										"Tier"
									],
									"members": {
										"Tier": {}
									}
								}
							}
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "RestoreRequest"
				},
				"output": {
					"type": "structure",
					"members": {
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				},
				"alias": "PostObjectRestore"
			},
			"UploadPart": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"Key",
						"PartNumber",
						"UploadId"
					],
					"members": {
						"Body": {
							"streaming": true,
							"type": "blob"
						},
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"ContentLength": {
							"location": "header",
							"locationName": "Content-Length",
							"type": "long"
						},
						"ContentMD5": {
							"location": "header",
							"locationName": "Content-MD5"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					},
					"payload": "Body"
				},
				"output": {
					"type": "structure",
					"members": {
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"ETag": {
							"location": "header",
							"locationName": "ETag"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					}
				}
			},
			"UploadPartCopy": {
				"http": {
					"method": "PUT",
					"requestUri": "/{Bucket}/{Key+}"
				},
				"input": {
					"type": "structure",
					"required": [
						"Bucket",
						"CopySource",
						"Key",
						"PartNumber",
						"UploadId"
					],
					"members": {
						"Bucket": {
							"location": "uri",
							"locationName": "Bucket"
						},
						"CopySource": {
							"location": "header",
							"locationName": "x-amz-copy-source"
						},
						"CopySourceIfMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-match"
						},
						"CopySourceIfModifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-modified-since",
							"type": "timestamp"
						},
						"CopySourceIfNoneMatch": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-none-match"
						},
						"CopySourceIfUnmodifiedSince": {
							"location": "header",
							"locationName": "x-amz-copy-source-if-unmodified-since",
							"type": "timestamp"
						},
						"CopySourceRange": {
							"location": "header",
							"locationName": "x-amz-copy-source-range"
						},
						"Key": {
							"location": "uri",
							"locationName": "Key"
						},
						"PartNumber": {
							"location": "querystring",
							"locationName": "partNumber",
							"type": "integer"
						},
						"UploadId": {
							"location": "querystring",
							"locationName": "uploadId"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKey": {
							"shape": "S19",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"CopySourceSSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-algorithm"
						},
						"CopySourceSSECustomerKey": {
							"shape": "S1c",
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key"
						},
						"CopySourceSSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-copy-source-server-side-encryption-customer-key-MD5"
						},
						"RequestPayer": {
							"location": "header",
							"locationName": "x-amz-request-payer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CopySourceVersionId": {
							"location": "header",
							"locationName": "x-amz-copy-source-version-id"
						},
						"CopyPartResult": {
							"type": "structure",
							"members": {
								"ETag": {},
								"LastModified": {
									"type": "timestamp"
								}
							}
						},
						"ServerSideEncryption": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption"
						},
						"SSECustomerAlgorithm": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-algorithm"
						},
						"SSECustomerKeyMD5": {
							"location": "header",
							"locationName": "x-amz-server-side-encryption-customer-key-MD5"
						},
						"SSEKMSKeyId": {
							"shape": "Sj",
							"location": "header",
							"locationName": "x-amz-server-side-encryption-aws-kms-key-id"
						},
						"RequestCharged": {
							"location": "header",
							"locationName": "x-amz-request-charged"
						}
					},
					"payload": "CopyPartResult"
				}
			}
		},
		"shapes": {
			"Sj": {
				"type": "string",
				"sensitive": true
			},
			"S11": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S19": {
				"type": "blob",
				"sensitive": true
			},
			"S1c": {
				"type": "blob",
				"sensitive": true
			},
			"S2u": {
				"type": "structure",
				"members": {
					"DisplayName": {},
					"ID": {}
				}
			},
			"S2x": {
				"type": "list",
				"member": {
					"locationName": "Grant",
					"type": "structure",
					"members": {
						"Grantee": {
							"shape": "S2z"
						},
						"Permission": {}
					}
				}
			},
			"S2z": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"DisplayName": {},
					"EmailAddress": {},
					"ID": {},
					"Type": {
						"locationName": "xsi:type",
						"xmlAttribute": true
					},
					"URI": {}
				},
				"xmlNamespace": {
					"prefix": "xsi",
					"uri": "http://www.w3.org/2001/XMLSchema-instance"
				}
			},
			"S36": {
				"type": "structure",
				"required": [
					"Id",
					"StorageClassAnalysis"
				],
				"members": {
					"Id": {},
					"Filter": {
						"type": "structure",
						"members": {
							"Prefix": {},
							"Tag": {
								"shape": "S39"
							},
							"And": {
								"type": "structure",
								"members": {
									"Prefix": {},
									"Tags": {
										"shape": "S3c",
										"flattened": true,
										"locationName": "Tag"
									}
								}
							}
						}
					},
					"StorageClassAnalysis": {
						"type": "structure",
						"members": {
							"DataExport": {
								"type": "structure",
								"required": [
									"OutputSchemaVersion",
									"Destination"
								],
								"members": {
									"OutputSchemaVersion": {},
									"Destination": {
										"type": "structure",
										"required": [
											"S3BucketDestination"
										],
										"members": {
											"S3BucketDestination": {
												"type": "structure",
												"required": [
													"Format",
													"Bucket"
												],
												"members": {
													"Format": {},
													"BucketAccountId": {},
													"Bucket": {},
													"Prefix": {}
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			"S39": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"S3c": {
				"type": "list",
				"member": {
					"shape": "S39",
					"locationName": "Tag"
				}
			},
			"S3m": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"AllowedMethods",
						"AllowedOrigins"
					],
					"members": {
						"AllowedHeaders": {
							"locationName": "AllowedHeader",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"AllowedMethods": {
							"locationName": "AllowedMethod",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"AllowedOrigins": {
							"locationName": "AllowedOrigin",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"ExposeHeaders": {
							"locationName": "ExposeHeader",
							"type": "list",
							"member": {},
							"flattened": true
						},
						"MaxAgeSeconds": {
							"type": "integer"
						}
					}
				},
				"flattened": true
			},
			"S3z": {
				"type": "structure",
				"required": [
					"Destination",
					"IsEnabled",
					"Id",
					"IncludedObjectVersions",
					"Schedule"
				],
				"members": {
					"Destination": {
						"type": "structure",
						"required": [
							"S3BucketDestination"
						],
						"members": {
							"S3BucketDestination": {
								"type": "structure",
								"required": [
									"Bucket",
									"Format"
								],
								"members": {
									"AccountId": {},
									"Bucket": {},
									"Format": {},
									"Prefix": {}
								}
							}
						}
					},
					"IsEnabled": {
						"type": "boolean"
					},
					"Filter": {
						"type": "structure",
						"required": [
							"Prefix"
						],
						"members": {
							"Prefix": {}
						}
					},
					"Id": {},
					"IncludedObjectVersions": {},
					"OptionalFields": {
						"type": "list",
						"member": {
							"locationName": "Field"
						}
					},
					"Schedule": {
						"type": "structure",
						"required": [
							"Frequency"
						],
						"members": {
							"Frequency": {}
						}
					}
				}
			},
			"S4c": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Prefix",
						"Status"
					],
					"members": {
						"Expiration": {
							"shape": "S4e"
						},
						"ID": {},
						"Prefix": {},
						"Status": {},
						"Transition": {
							"shape": "S4j"
						},
						"NoncurrentVersionTransition": {
							"shape": "S4l"
						},
						"NoncurrentVersionExpiration": {
							"shape": "S4m"
						},
						"AbortIncompleteMultipartUpload": {
							"shape": "S4n"
						}
					}
				},
				"flattened": true
			},
			"S4e": {
				"type": "structure",
				"members": {
					"Date": {
						"shape": "S4f"
					},
					"Days": {
						"type": "integer"
					},
					"ExpiredObjectDeleteMarker": {
						"type": "boolean"
					}
				}
			},
			"S4f": {
				"type": "timestamp",
				"timestampFormat": "iso8601"
			},
			"S4j": {
				"type": "structure",
				"members": {
					"Date": {
						"shape": "S4f"
					},
					"Days": {
						"type": "integer"
					},
					"StorageClass": {}
				}
			},
			"S4l": {
				"type": "structure",
				"members": {
					"NoncurrentDays": {
						"type": "integer"
					},
					"StorageClass": {}
				}
			},
			"S4m": {
				"type": "structure",
				"members": {
					"NoncurrentDays": {
						"type": "integer"
					}
				}
			},
			"S4n": {
				"type": "structure",
				"members": {
					"DaysAfterInitiation": {
						"type": "integer"
					}
				}
			},
			"S4r": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Status"
					],
					"members": {
						"Expiration": {
							"shape": "S4e"
						},
						"ID": {},
						"Prefix": {
							"deprecated": true
						},
						"Filter": {
							"type": "structure",
							"members": {
								"Prefix": {},
								"Tag": {
									"shape": "S39"
								},
								"And": {
									"type": "structure",
									"members": {
										"Prefix": {},
										"Tags": {
											"shape": "S3c",
											"flattened": true,
											"locationName": "Tag"
										}
									}
								}
							}
						},
						"Status": {},
						"Transitions": {
							"locationName": "Transition",
							"type": "list",
							"member": {
								"shape": "S4j"
							},
							"flattened": true
						},
						"NoncurrentVersionTransitions": {
							"locationName": "NoncurrentVersionTransition",
							"type": "list",
							"member": {
								"shape": "S4l"
							},
							"flattened": true
						},
						"NoncurrentVersionExpiration": {
							"shape": "S4m"
						},
						"AbortIncompleteMultipartUpload": {
							"shape": "S4n"
						}
					}
				},
				"flattened": true
			},
			"S51": {
				"type": "structure",
				"members": {
					"TargetBucket": {},
					"TargetGrants": {
						"type": "list",
						"member": {
							"locationName": "Grant",
							"type": "structure",
							"members": {
								"Grantee": {
									"shape": "S2z"
								},
								"Permission": {}
							}
						}
					},
					"TargetPrefix": {}
				}
			},
			"S59": {
				"type": "structure",
				"required": [
					"Id"
				],
				"members": {
					"Id": {},
					"Filter": {
						"type": "structure",
						"members": {
							"Prefix": {},
							"Tag": {
								"shape": "S39"
							},
							"And": {
								"type": "structure",
								"members": {
									"Prefix": {},
									"Tags": {
										"shape": "S3c",
										"flattened": true,
										"locationName": "Tag"
									}
								}
							}
						}
					}
				}
			},
			"S5c": {
				"type": "structure",
				"required": [
					"Bucket"
				],
				"members": {
					"Bucket": {
						"location": "uri",
						"locationName": "Bucket"
					}
				}
			},
			"S5d": {
				"type": "structure",
				"members": {
					"TopicConfiguration": {
						"type": "structure",
						"members": {
							"Id": {},
							"Events": {
								"shape": "S5g",
								"locationName": "Event"
							},
							"Event": {
								"deprecated": true
							},
							"Topic": {}
						}
					},
					"QueueConfiguration": {
						"type": "structure",
						"members": {
							"Id": {},
							"Event": {
								"deprecated": true
							},
							"Events": {
								"shape": "S5g",
								"locationName": "Event"
							},
							"Queue": {}
						}
					},
					"CloudFunctionConfiguration": {
						"type": "structure",
						"members": {
							"Id": {},
							"Event": {
								"deprecated": true
							},
							"Events": {
								"shape": "S5g",
								"locationName": "Event"
							},
							"CloudFunction": {},
							"InvocationRole": {}
						}
					}
				}
			},
			"S5g": {
				"type": "list",
				"member": {},
				"flattened": true
			},
			"S5o": {
				"type": "structure",
				"members": {
					"TopicConfigurations": {
						"locationName": "TopicConfiguration",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"TopicArn",
								"Events"
							],
							"members": {
								"Id": {},
								"TopicArn": {
									"locationName": "Topic"
								},
								"Events": {
									"shape": "S5g",
									"locationName": "Event"
								},
								"Filter": {
									"shape": "S5r"
								}
							}
						},
						"flattened": true
					},
					"QueueConfigurations": {
						"locationName": "QueueConfiguration",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"QueueArn",
								"Events"
							],
							"members": {
								"Id": {},
								"QueueArn": {
									"locationName": "Queue"
								},
								"Events": {
									"shape": "S5g",
									"locationName": "Event"
								},
								"Filter": {
									"shape": "S5r"
								}
							}
						},
						"flattened": true
					},
					"LambdaFunctionConfigurations": {
						"locationName": "CloudFunctionConfiguration",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"LambdaFunctionArn",
								"Events"
							],
							"members": {
								"Id": {},
								"LambdaFunctionArn": {
									"locationName": "CloudFunction"
								},
								"Events": {
									"shape": "S5g",
									"locationName": "Event"
								},
								"Filter": {
									"shape": "S5r"
								}
							}
						},
						"flattened": true
					}
				}
			},
			"S5r": {
				"type": "structure",
				"members": {
					"Key": {
						"locationName": "S3Key",
						"type": "structure",
						"members": {
							"FilterRules": {
								"locationName": "FilterRule",
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Name": {},
										"Value": {}
									}
								},
								"flattened": true
							}
						}
					}
				}
			},
			"S67": {
				"type": "structure",
				"required": [
					"Role",
					"Rules"
				],
				"members": {
					"Role": {},
					"Rules": {
						"locationName": "Rule",
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Prefix",
								"Status",
								"Destination"
							],
							"members": {
								"ID": {},
								"Prefix": {},
								"Status": {},
								"Destination": {
									"type": "structure",
									"required": [
										"Bucket"
									],
									"members": {
										"Bucket": {},
										"StorageClass": {}
									}
								}
							}
						},
						"flattened": true
					}
				}
			},
			"S6o": {
				"type": "structure",
				"required": [
					"HostName"
				],
				"members": {
					"HostName": {},
					"Protocol": {}
				}
			},
			"S6r": {
				"type": "structure",
				"required": [
					"Suffix"
				],
				"members": {
					"Suffix": {}
				}
			},
			"S6t": {
				"type": "structure",
				"required": [
					"Key"
				],
				"members": {
					"Key": {}
				}
			},
			"S6u": {
				"type": "list",
				"member": {
					"locationName": "RoutingRule",
					"type": "structure",
					"required": [
						"Redirect"
					],
					"members": {
						"Condition": {
							"type": "structure",
							"members": {
								"HttpErrorCodeReturnedEquals": {},
								"KeyPrefixEquals": {}
							}
						},
						"Redirect": {
							"type": "structure",
							"members": {
								"HostName": {},
								"HttpRedirectCode": {},
								"Protocol": {},
								"ReplaceKeyPrefixWith": {},
								"ReplaceKeyWith": {}
							}
						}
					}
				}
			},
			"S8q": {
				"type": "structure",
				"members": {
					"ID": {},
					"DisplayName": {}
				}
			},
			"S8r": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Prefix": {}
					}
				},
				"flattened": true
			},
			"S99": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"LastModified": {
							"type": "timestamp"
						},
						"ETag": {},
						"Size": {
							"type": "integer"
						},
						"StorageClass": {},
						"Owner": {
							"shape": "S2u"
						}
					}
				},
				"flattened": true
			},
			"S9r": {
				"type": "structure",
				"members": {
					"Grants": {
						"shape": "S2x",
						"locationName": "AccessControlList"
					},
					"Owner": {
						"shape": "S2u"
					}
				}
			},
			"Sab": {
				"type": "structure",
				"required": [
					"TagSet"
				],
				"members": {
					"TagSet": {
						"shape": "S3c"
					}
				}
			}
		}
	};

/***/ },
/* 756 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListBuckets": {
				"result_key": "Buckets"
			},
			"ListMultipartUploads": {
				"limit_key": "MaxUploads",
				"more_results": "IsTruncated",
				"output_token": [
					"NextKeyMarker",
					"NextUploadIdMarker"
				],
				"input_token": [
					"KeyMarker",
					"UploadIdMarker"
				],
				"result_key": [
					"Uploads",
					"CommonPrefixes"
				]
			},
			"ListObjectVersions": {
				"more_results": "IsTruncated",
				"limit_key": "MaxKeys",
				"output_token": [
					"NextKeyMarker",
					"NextVersionIdMarker"
				],
				"input_token": [
					"KeyMarker",
					"VersionIdMarker"
				],
				"result_key": [
					"Versions",
					"DeleteMarkers",
					"CommonPrefixes"
				]
			},
			"ListObjects": {
				"more_results": "IsTruncated",
				"limit_key": "MaxKeys",
				"output_token": "NextMarker || Contents[-1].Key",
				"input_token": "Marker",
				"result_key": [
					"Contents",
					"CommonPrefixes"
				]
			},
			"ListObjectsV2": {
				"limit_key": "MaxKeys",
				"output_token": "NextContinuationToken",
				"input_token": "ContinuationToken",
				"result_key": [
					"Contents",
					"CommonPrefixes"
				]
			},
			"ListParts": {
				"more_results": "IsTruncated",
				"limit_key": "MaxParts",
				"output_token": "NextPartNumberMarker",
				"input_token": "PartNumberMarker",
				"result_key": "Parts"
			}
		}
	};

/***/ },
/* 757 */
/***/ function(module, exports) {

	module.exports = {
		"version": 2,
		"waiters": {
			"BucketExists": {
				"delay": 5,
				"operation": "HeadBucket",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 200,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 301,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 403,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 404,
						"matcher": "status",
						"state": "retry"
					}
				]
			},
			"BucketNotExists": {
				"delay": 5,
				"operation": "HeadBucket",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 404,
						"matcher": "status",
						"state": "success"
					}
				]
			},
			"ObjectExists": {
				"delay": 5,
				"operation": "HeadObject",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 200,
						"matcher": "status",
						"state": "success"
					},
					{
						"expected": 404,
						"matcher": "status",
						"state": "retry"
					}
				]
			},
			"ObjectNotExists": {
				"delay": 5,
				"operation": "HeadObject",
				"maxAttempts": 20,
				"acceptors": [
					{
						"expected": 404,
						"matcher": "status",
						"state": "success"
					}
				]
			}
		}
	};

/***/ },
/* 758 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "servicecatalog-2015-12-10",
			"apiVersion": "2015-12-10",
			"endpointPrefix": "servicecatalog",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Service Catalog",
			"signatureVersion": "v4",
			"targetPrefix": "AWS242ServiceCatalogService"
		},
		"operations": {
			"AcceptPortfolioShare": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociatePrincipalWithPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId",
						"PrincipalARN",
						"PrincipalType"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"PrincipalARN": {},
						"PrincipalType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"AssociateProductWithPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"PortfolioId": {},
						"SourcePortfolioId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateConstraint": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId",
						"ProductId",
						"Parameters",
						"Type",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"ProductId": {},
						"Parameters": {},
						"Type": {},
						"Description": {},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConstraintDetail": {
							"shape": "Sh"
						},
						"ConstraintParameters": {},
						"Status": {}
					}
				}
			},
			"CreatePortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"DisplayName",
						"ProviderName",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"DisplayName": {},
						"Description": {},
						"ProviderName": {},
						"Tags": {
							"shape": "So"
						},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetail": {
							"shape": "St"
						},
						"Tags": {
							"shape": "Sw"
						}
					}
				}
			},
			"CreatePortfolioShare": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId",
						"AccountId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"AccountId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateProduct": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Owner",
						"ProductType",
						"ProvisioningArtifactParameters",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"Name": {},
						"Owner": {},
						"Description": {},
						"Distributor": {},
						"SupportDescription": {},
						"SupportEmail": {},
						"SupportUrl": {},
						"ProductType": {},
						"Tags": {
							"shape": "So"
						},
						"ProvisioningArtifactParameters": {
							"shape": "S17"
						},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewDetail": {
							"shape": "S1f"
						},
						"ProvisioningArtifactDetail": {
							"shape": "S1k"
						},
						"Tags": {
							"shape": "Sw"
						}
					}
				}
			},
			"CreateProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"Parameters",
						"IdempotencyToken"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"Parameters": {
							"shape": "S17"
						},
						"IdempotencyToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactDetail": {
							"shape": "S1k"
						},
						"Info": {
							"shape": "S1a"
						},
						"Status": {}
					}
				}
			},
			"DeleteConstraint": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeletePortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeletePortfolioShare": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId",
						"AccountId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"AccountId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteProduct": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"ProvisioningArtifactId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DescribeConstraint": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConstraintDetail": {
							"shape": "Sh"
						},
						"ConstraintParameters": {},
						"Status": {}
					}
				}
			},
			"DescribePortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetail": {
							"shape": "St"
						},
						"Tags": {
							"shape": "Sw"
						}
					}
				}
			},
			"DescribeProduct": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewSummary": {
							"shape": "S1g"
						},
						"ProvisioningArtifacts": {
							"shape": "S23"
						}
					}
				}
			},
			"DescribeProductAsAdmin": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewDetail": {
							"shape": "S1f"
						},
						"Tags": {
							"shape": "Sw"
						}
					}
				}
			},
			"DescribeProductView": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewSummary": {
							"shape": "S1g"
						},
						"ProvisioningArtifacts": {
							"shape": "S23"
						}
					}
				}
			},
			"DescribeProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProvisioningArtifactId",
						"ProductId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProvisioningArtifactId": {},
						"ProductId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactDetail": {
							"shape": "S1k"
						},
						"Info": {
							"shape": "S1a"
						},
						"Status": {}
					}
				}
			},
			"DescribeProvisioningParameters": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"PathId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactParameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ParameterKey": {},
									"DefaultValue": {},
									"ParameterType": {},
									"IsNoEcho": {
										"type": "boolean"
									},
									"Description": {},
									"ParameterConstraints": {
										"type": "structure",
										"members": {
											"AllowedValues": {
												"type": "list",
												"member": {}
											}
										}
									}
								}
							}
						},
						"ConstraintSummaries": {
							"shape": "S2o"
						},
						"UsageInstructions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Type": {},
									"Value": {}
								}
							}
						}
					}
				}
			},
			"DescribeRecord": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S2y"
						},
						"RecordOutputs": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"OutputKey": {},
									"OutputValue": {},
									"Description": {}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"DisassociatePrincipalFromPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId",
						"PrincipalARN"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"PrincipalARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DisassociateProductFromPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"PortfolioId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ListAcceptedPortfolioShares": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetails": {
							"shape": "S3m"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListConstraintsForPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"ProductId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConstraintDetails": {
							"type": "list",
							"member": {
								"shape": "Sh"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListLaunchPaths": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"LaunchPathSummaries": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Id": {},
									"ConstraintSummaries": {
										"shape": "S2o"
									},
									"Tags": {
										"shape": "Sw"
									},
									"Name": {}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPortfolioAccess": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountIds": {
							"type": "list",
							"member": {}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPortfolios": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetails": {
							"shape": "S3m"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPortfoliosForProduct": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetails": {
							"shape": "S3m"
						},
						"NextPageToken": {}
					}
				}
			},
			"ListPrincipalsForPortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Principals": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PrincipalARN": {},
									"PrincipalType": {}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListProvisioningArtifacts": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactDetails": {
							"type": "list",
							"member": {
								"shape": "S1k"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ListRecordHistory": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"AccessLevelFilter": {
							"shape": "S4a"
						},
						"SearchFilter": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetails": {
							"type": "list",
							"member": {
								"shape": "S2y"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"ProvisionProduct": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId",
						"ProvisionedProductName",
						"ProvisionToken"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"PathId": {},
						"ProvisionedProductName": {},
						"ProvisioningParameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"Value": {}
								}
							}
						},
						"Tags": {
							"shape": "Sw"
						},
						"NotificationArns": {
							"type": "list",
							"member": {}
						},
						"ProvisionToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S2y"
						}
					}
				}
			},
			"RejectPortfolioShare": {
				"input": {
					"type": "structure",
					"required": [
						"PortfolioId"
					],
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"ScanProvisionedProducts": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"AccessLevelFilter": {
							"shape": "S4a"
						},
						"PageSize": {
							"type": "integer"
						},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisionedProducts": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Arn": {},
									"Type": {},
									"Id": {},
									"Status": {},
									"StatusMessage": {},
									"CreatedTime": {
										"type": "timestamp"
									},
									"IdempotencyToken": {},
									"LastRecordId": {}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"SearchProducts": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"Filters": {
							"shape": "S50"
						},
						"PageSize": {
							"type": "integer"
						},
						"SortBy": {},
						"SortOrder": {},
						"PageToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewSummaries": {
							"type": "list",
							"member": {
								"shape": "S1g"
							}
						},
						"ProductViewAggregations": {
							"type": "map",
							"key": {},
							"value": {
								"type": "list",
								"member": {
									"type": "structure",
									"members": {
										"Value": {},
										"ApproximateCount": {
											"type": "integer"
										}
									}
								}
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"SearchProductsAsAdmin": {
				"input": {
					"type": "structure",
					"members": {
						"AcceptLanguage": {},
						"PortfolioId": {},
						"Filters": {
							"shape": "S50"
						},
						"SortBy": {},
						"SortOrder": {},
						"PageToken": {},
						"PageSize": {
							"type": "integer"
						},
						"ProductSource": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewDetails": {
							"type": "list",
							"member": {
								"shape": "S1f"
							}
						},
						"NextPageToken": {}
					}
				}
			},
			"TerminateProvisionedProduct": {
				"input": {
					"type": "structure",
					"required": [
						"TerminateToken"
					],
					"members": {
						"ProvisionedProductName": {},
						"ProvisionedProductId": {},
						"TerminateToken": {
							"idempotencyToken": true
						},
						"IgnoreErrors": {
							"type": "boolean"
						},
						"AcceptLanguage": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S2y"
						}
					}
				}
			},
			"UpdateConstraint": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {},
						"Description": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ConstraintDetail": {
							"shape": "Sh"
						},
						"ConstraintParameters": {},
						"Status": {}
					}
				}
			},
			"UpdatePortfolio": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {},
						"DisplayName": {},
						"Description": {},
						"ProviderName": {},
						"AddTags": {
							"shape": "So"
						},
						"RemoveTags": {
							"shape": "S5o"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"PortfolioDetail": {
							"shape": "St"
						},
						"Tags": {
							"shape": "Sw"
						}
					}
				}
			},
			"UpdateProduct": {
				"input": {
					"type": "structure",
					"required": [
						"Id"
					],
					"members": {
						"AcceptLanguage": {},
						"Id": {},
						"Name": {},
						"Owner": {},
						"Description": {},
						"Distributor": {},
						"SupportDescription": {},
						"SupportEmail": {},
						"SupportUrl": {},
						"AddTags": {
							"shape": "So"
						},
						"RemoveTags": {
							"shape": "S5o"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProductViewDetail": {
							"shape": "S1f"
						},
						"Tags": {
							"shape": "Sw"
						}
					}
				}
			},
			"UpdateProvisionedProduct": {
				"input": {
					"type": "structure",
					"required": [
						"UpdateToken"
					],
					"members": {
						"AcceptLanguage": {},
						"ProvisionedProductName": {},
						"ProvisionedProductId": {},
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"PathId": {},
						"ProvisioningParameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Key": {},
									"Value": {},
									"UsePreviousValue": {
										"type": "boolean"
									}
								}
							}
						},
						"UpdateToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"RecordDetail": {
							"shape": "S2y"
						}
					}
				}
			},
			"UpdateProvisioningArtifact": {
				"input": {
					"type": "structure",
					"required": [
						"ProductId",
						"ProvisioningArtifactId"
					],
					"members": {
						"AcceptLanguage": {},
						"ProductId": {},
						"ProvisioningArtifactId": {},
						"Name": {},
						"Description": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ProvisioningArtifactDetail": {
							"shape": "S1k"
						},
						"Info": {
							"shape": "S1a"
						},
						"Status": {}
					}
				}
			}
		},
		"shapes": {
			"Sh": {
				"type": "structure",
				"members": {
					"ConstraintId": {},
					"Type": {},
					"Description": {},
					"Owner": {}
				}
			},
			"So": {
				"type": "list",
				"member": {
					"shape": "Sp"
				}
			},
			"Sp": {
				"type": "structure",
				"required": [
					"Key",
					"Value"
				],
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"Id": {},
					"ARN": {},
					"DisplayName": {},
					"Description": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"ProviderName": {}
				}
			},
			"Sw": {
				"type": "list",
				"member": {
					"shape": "Sp"
				}
			},
			"S17": {
				"type": "structure",
				"required": [
					"Info"
				],
				"members": {
					"Name": {},
					"Description": {},
					"Info": {
						"shape": "S1a"
					},
					"Type": {}
				}
			},
			"S1a": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1f": {
				"type": "structure",
				"members": {
					"ProductViewSummary": {
						"shape": "S1g"
					},
					"Status": {},
					"ProductARN": {},
					"CreatedTime": {
						"type": "timestamp"
					}
				}
			},
			"S1g": {
				"type": "structure",
				"members": {
					"Id": {},
					"ProductId": {},
					"Name": {},
					"Owner": {},
					"ShortDescription": {},
					"Type": {},
					"Distributor": {},
					"HasDefaultPath": {
						"type": "boolean"
					},
					"SupportEmail": {},
					"SupportDescription": {},
					"SupportUrl": {}
				}
			},
			"S1k": {
				"type": "structure",
				"members": {
					"Id": {},
					"Name": {},
					"Description": {},
					"Type": {},
					"CreatedTime": {
						"type": "timestamp"
					}
				}
			},
			"S23": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Id": {},
						"Name": {},
						"Description": {},
						"CreatedTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"S2o": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Type": {},
						"Description": {}
					}
				}
			},
			"S2y": {
				"type": "structure",
				"members": {
					"RecordId": {},
					"ProvisionedProductName": {},
					"Status": {},
					"CreatedTime": {
						"type": "timestamp"
					},
					"UpdatedTime": {
						"type": "timestamp"
					},
					"ProvisionedProductType": {},
					"RecordType": {},
					"ProvisionedProductId": {},
					"ProductId": {},
					"ProvisioningArtifactId": {},
					"PathId": {},
					"RecordErrors": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Code": {},
								"Description": {}
							}
						}
					},
					"RecordTags": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Key": {},
								"Value": {}
							}
						}
					}
				}
			},
			"S3m": {
				"type": "list",
				"member": {
					"shape": "St"
				}
			},
			"S4a": {
				"type": "structure",
				"members": {
					"Key": {},
					"Value": {}
				}
			},
			"S50": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {}
				}
			},
			"S5o": {
				"type": "list",
				"member": {}
			}
		}
	};

/***/ },
/* 759 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "sns-2010-03-31",
			"apiVersion": "2010-03-31",
			"endpointPrefix": "sns",
			"protocol": "query",
			"serviceAbbreviation": "Amazon SNS",
			"serviceFullName": "Amazon Simple Notification Service",
			"signatureVersion": "v4",
			"xmlNamespace": "http://sns.amazonaws.com/doc/2010-03-31/"
		},
		"operations": {
			"AddPermission": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"Label",
						"AWSAccountId",
						"ActionName"
					],
					"members": {
						"TopicArn": {},
						"Label": {},
						"AWSAccountId": {
							"type": "list",
							"member": {}
						},
						"ActionName": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"CheckIfPhoneNumberIsOptedOut": {
				"input": {
					"type": "structure",
					"required": [
						"phoneNumber"
					],
					"members": {
						"phoneNumber": {}
					}
				},
				"output": {
					"resultWrapper": "CheckIfPhoneNumberIsOptedOutResult",
					"type": "structure",
					"members": {
						"isOptedOut": {
							"type": "boolean"
						}
					}
				}
			},
			"ConfirmSubscription": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"Token"
					],
					"members": {
						"TopicArn": {},
						"Token": {},
						"AuthenticateOnUnsubscribe": {}
					}
				},
				"output": {
					"resultWrapper": "ConfirmSubscriptionResult",
					"type": "structure",
					"members": {
						"SubscriptionArn": {}
					}
				}
			},
			"CreatePlatformApplication": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Platform",
						"Attributes"
					],
					"members": {
						"Name": {},
						"Platform": {},
						"Attributes": {
							"shape": "Sj"
						}
					}
				},
				"output": {
					"resultWrapper": "CreatePlatformApplicationResult",
					"type": "structure",
					"members": {
						"PlatformApplicationArn": {}
					}
				}
			},
			"CreatePlatformEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn",
						"Token"
					],
					"members": {
						"PlatformApplicationArn": {},
						"Token": {},
						"CustomUserData": {},
						"Attributes": {
							"shape": "Sj"
						}
					}
				},
				"output": {
					"resultWrapper": "CreatePlatformEndpointResult",
					"type": "structure",
					"members": {
						"EndpointArn": {}
					}
				}
			},
			"CreateTopic": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"resultWrapper": "CreateTopicResult",
					"type": "structure",
					"members": {
						"TopicArn": {}
					}
				}
			},
			"DeleteEndpoint": {
				"input": {
					"type": "structure",
					"required": [
						"EndpointArn"
					],
					"members": {
						"EndpointArn": {}
					}
				}
			},
			"DeletePlatformApplication": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn"
					],
					"members": {
						"PlatformApplicationArn": {}
					}
				}
			},
			"DeleteTopic": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn"
					],
					"members": {
						"TopicArn": {}
					}
				}
			},
			"GetEndpointAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"EndpointArn"
					],
					"members": {
						"EndpointArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetEndpointAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"GetPlatformApplicationAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn"
					],
					"members": {
						"PlatformApplicationArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetPlatformApplicationAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"GetSMSAttributes": {
				"input": {
					"type": "structure",
					"members": {
						"attributes": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"resultWrapper": "GetSMSAttributesResult",
					"type": "structure",
					"members": {
						"attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"GetSubscriptionAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionArn"
					],
					"members": {
						"SubscriptionArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetSubscriptionAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"GetTopicAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn"
					],
					"members": {
						"TopicArn": {}
					}
				},
				"output": {
					"resultWrapper": "GetTopicAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"type": "map",
							"key": {},
							"value": {}
						}
					}
				}
			},
			"ListEndpointsByPlatformApplication": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn"
					],
					"members": {
						"PlatformApplicationArn": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListEndpointsByPlatformApplicationResult",
					"type": "structure",
					"members": {
						"Endpoints": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"EndpointArn": {},
									"Attributes": {
										"shape": "Sj"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListPhoneNumbersOptedOut": {
				"input": {
					"type": "structure",
					"members": {
						"nextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListPhoneNumbersOptedOutResult",
					"type": "structure",
					"members": {
						"phoneNumbers": {
							"type": "list",
							"member": {}
						},
						"nextToken": {}
					}
				}
			},
			"ListPlatformApplications": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListPlatformApplicationsResult",
					"type": "structure",
					"members": {
						"PlatformApplications": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PlatformApplicationArn": {},
									"Attributes": {
										"shape": "Sj"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListSubscriptions": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListSubscriptionsResult",
					"type": "structure",
					"members": {
						"Subscriptions": {
							"shape": "S1n"
						},
						"NextToken": {}
					}
				}
			},
			"ListSubscriptionsByTopic": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn"
					],
					"members": {
						"TopicArn": {},
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListSubscriptionsByTopicResult",
					"type": "structure",
					"members": {
						"Subscriptions": {
							"shape": "S1n"
						},
						"NextToken": {}
					}
				}
			},
			"ListTopics": {
				"input": {
					"type": "structure",
					"members": {
						"NextToken": {}
					}
				},
				"output": {
					"resultWrapper": "ListTopicsResult",
					"type": "structure",
					"members": {
						"Topics": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TopicArn": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"OptInPhoneNumber": {
				"input": {
					"type": "structure",
					"required": [
						"phoneNumber"
					],
					"members": {
						"phoneNumber": {}
					}
				},
				"output": {
					"resultWrapper": "OptInPhoneNumberResult",
					"type": "structure",
					"members": {}
				}
			},
			"Publish": {
				"input": {
					"type": "structure",
					"required": [
						"Message"
					],
					"members": {
						"TopicArn": {},
						"TargetArn": {},
						"PhoneNumber": {},
						"Message": {},
						"Subject": {},
						"MessageStructure": {},
						"MessageAttributes": {
							"type": "map",
							"key": {
								"locationName": "Name"
							},
							"value": {
								"locationName": "Value",
								"type": "structure",
								"required": [
									"DataType"
								],
								"members": {
									"DataType": {},
									"StringValue": {},
									"BinaryValue": {
										"type": "blob"
									}
								}
							}
						}
					}
				},
				"output": {
					"resultWrapper": "PublishResult",
					"type": "structure",
					"members": {
						"MessageId": {}
					}
				}
			},
			"RemovePermission": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"Label"
					],
					"members": {
						"TopicArn": {},
						"Label": {}
					}
				}
			},
			"SetEndpointAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"EndpointArn",
						"Attributes"
					],
					"members": {
						"EndpointArn": {},
						"Attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"SetPlatformApplicationAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"PlatformApplicationArn",
						"Attributes"
					],
					"members": {
						"PlatformApplicationArn": {},
						"Attributes": {
							"shape": "Sj"
						}
					}
				}
			},
			"SetSMSAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"attributes"
					],
					"members": {
						"attributes": {
							"shape": "Sj"
						}
					}
				},
				"output": {
					"resultWrapper": "SetSMSAttributesResult",
					"type": "structure",
					"members": {}
				}
			},
			"SetSubscriptionAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionArn",
						"AttributeName"
					],
					"members": {
						"SubscriptionArn": {},
						"AttributeName": {},
						"AttributeValue": {}
					}
				}
			},
			"SetTopicAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"AttributeName"
					],
					"members": {
						"TopicArn": {},
						"AttributeName": {},
						"AttributeValue": {}
					}
				}
			},
			"Subscribe": {
				"input": {
					"type": "structure",
					"required": [
						"TopicArn",
						"Protocol"
					],
					"members": {
						"TopicArn": {},
						"Protocol": {},
						"Endpoint": {}
					}
				},
				"output": {
					"resultWrapper": "SubscribeResult",
					"type": "structure",
					"members": {
						"SubscriptionArn": {}
					}
				}
			},
			"Unsubscribe": {
				"input": {
					"type": "structure",
					"required": [
						"SubscriptionArn"
					],
					"members": {
						"SubscriptionArn": {}
					}
				}
			}
		},
		"shapes": {
			"Sj": {
				"type": "map",
				"key": {},
				"value": {}
			},
			"S1n": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"SubscriptionArn": {},
						"Owner": {},
						"Protocol": {},
						"Endpoint": {},
						"TopicArn": {}
					}
				}
			}
		}
	};

/***/ },
/* 760 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListEndpointsByPlatformApplication": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Endpoints"
			},
			"ListPlatformApplications": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "PlatformApplications"
			},
			"ListSubscriptions": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Subscriptions"
			},
			"ListSubscriptionsByTopic": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Subscriptions"
			},
			"ListTopics": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"result_key": "Topics"
			}
		}
	};

/***/ },
/* 761 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-11-05",
			"endpointPrefix": "sqs",
			"protocol": "query",
			"serviceAbbreviation": "Amazon SQS",
			"serviceFullName": "Amazon Simple Queue Service",
			"signatureVersion": "v4",
			"uid": "sqs-2012-11-05",
			"xmlNamespace": "http://queue.amazonaws.com/doc/2012-11-05/"
		},
		"operations": {
			"AddPermission": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Label",
						"AWSAccountIds",
						"Actions"
					],
					"members": {
						"QueueUrl": {},
						"Label": {},
						"AWSAccountIds": {
							"type": "list",
							"member": {
								"locationName": "AWSAccountId"
							},
							"flattened": true
						},
						"Actions": {
							"type": "list",
							"member": {
								"locationName": "ActionName"
							},
							"flattened": true
						}
					}
				}
			},
			"ChangeMessageVisibility": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"ReceiptHandle",
						"VisibilityTimeout"
					],
					"members": {
						"QueueUrl": {},
						"ReceiptHandle": {},
						"VisibilityTimeout": {
							"type": "integer"
						}
					}
				}
			},
			"ChangeMessageVisibilityBatch": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Entries"
					],
					"members": {
						"QueueUrl": {},
						"Entries": {
							"type": "list",
							"member": {
								"locationName": "ChangeMessageVisibilityBatchRequestEntry",
								"type": "structure",
								"required": [
									"Id",
									"ReceiptHandle"
								],
								"members": {
									"Id": {},
									"ReceiptHandle": {},
									"VisibilityTimeout": {
										"type": "integer"
									}
								}
							},
							"flattened": true
						}
					}
				},
				"output": {
					"resultWrapper": "ChangeMessageVisibilityBatchResult",
					"type": "structure",
					"required": [
						"Successful",
						"Failed"
					],
					"members": {
						"Successful": {
							"type": "list",
							"member": {
								"locationName": "ChangeMessageVisibilityBatchResultEntry",
								"type": "structure",
								"required": [
									"Id"
								],
								"members": {
									"Id": {}
								}
							},
							"flattened": true
						},
						"Failed": {
							"shape": "Sd"
						}
					}
				}
			},
			"CreateQueue": {
				"input": {
					"type": "structure",
					"required": [
						"QueueName"
					],
					"members": {
						"QueueName": {},
						"Attributes": {
							"shape": "Sh",
							"locationName": "Attribute"
						}
					}
				},
				"output": {
					"resultWrapper": "CreateQueueResult",
					"type": "structure",
					"members": {
						"QueueUrl": {}
					}
				}
			},
			"DeleteMessage": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"ReceiptHandle"
					],
					"members": {
						"QueueUrl": {},
						"ReceiptHandle": {}
					}
				}
			},
			"DeleteMessageBatch": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Entries"
					],
					"members": {
						"QueueUrl": {},
						"Entries": {
							"type": "list",
							"member": {
								"locationName": "DeleteMessageBatchRequestEntry",
								"type": "structure",
								"required": [
									"Id",
									"ReceiptHandle"
								],
								"members": {
									"Id": {},
									"ReceiptHandle": {}
								}
							},
							"flattened": true
						}
					}
				},
				"output": {
					"resultWrapper": "DeleteMessageBatchResult",
					"type": "structure",
					"required": [
						"Successful",
						"Failed"
					],
					"members": {
						"Successful": {
							"type": "list",
							"member": {
								"locationName": "DeleteMessageBatchResultEntry",
								"type": "structure",
								"required": [
									"Id"
								],
								"members": {
									"Id": {}
								}
							},
							"flattened": true
						},
						"Failed": {
							"shape": "Sd"
						}
					}
				}
			},
			"DeleteQueue": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {}
					}
				}
			},
			"GetQueueAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {},
						"AttributeNames": {
							"shape": "St"
						}
					}
				},
				"output": {
					"resultWrapper": "GetQueueAttributesResult",
					"type": "structure",
					"members": {
						"Attributes": {
							"shape": "Sh",
							"locationName": "Attribute"
						}
					}
				}
			},
			"GetQueueUrl": {
				"input": {
					"type": "structure",
					"required": [
						"QueueName"
					],
					"members": {
						"QueueName": {},
						"QueueOwnerAWSAccountId": {}
					}
				},
				"output": {
					"resultWrapper": "GetQueueUrlResult",
					"type": "structure",
					"members": {
						"QueueUrl": {}
					}
				}
			},
			"ListDeadLetterSourceQueues": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {}
					}
				},
				"output": {
					"resultWrapper": "ListDeadLetterSourceQueuesResult",
					"type": "structure",
					"required": [
						"queueUrls"
					],
					"members": {
						"queueUrls": {
							"shape": "Sz"
						}
					}
				}
			},
			"ListQueues": {
				"input": {
					"type": "structure",
					"members": {
						"QueueNamePrefix": {}
					}
				},
				"output": {
					"resultWrapper": "ListQueuesResult",
					"type": "structure",
					"members": {
						"QueueUrls": {
							"shape": "Sz"
						}
					}
				}
			},
			"PurgeQueue": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {}
					}
				}
			},
			"ReceiveMessage": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl"
					],
					"members": {
						"QueueUrl": {},
						"AttributeNames": {
							"shape": "St"
						},
						"MessageAttributeNames": {
							"type": "list",
							"member": {
								"locationName": "MessageAttributeName"
							},
							"flattened": true
						},
						"MaxNumberOfMessages": {
							"type": "integer"
						},
						"VisibilityTimeout": {
							"type": "integer"
						},
						"WaitTimeSeconds": {
							"type": "integer"
						},
						"ReceiveRequestAttemptId": {}
					}
				},
				"output": {
					"resultWrapper": "ReceiveMessageResult",
					"type": "structure",
					"members": {
						"Messages": {
							"type": "list",
							"member": {
								"locationName": "Message",
								"type": "structure",
								"members": {
									"MessageId": {},
									"ReceiptHandle": {},
									"MD5OfBody": {},
									"Body": {},
									"Attributes": {
										"locationName": "Attribute",
										"type": "map",
										"key": {
											"locationName": "Name"
										},
										"value": {
											"locationName": "Value"
										},
										"flattened": true
									},
									"MD5OfMessageAttributes": {},
									"MessageAttributes": {
										"shape": "S1b",
										"locationName": "MessageAttribute"
									}
								}
							},
							"flattened": true
						}
					}
				}
			},
			"RemovePermission": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Label"
					],
					"members": {
						"QueueUrl": {},
						"Label": {}
					}
				}
			},
			"SendMessage": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"MessageBody"
					],
					"members": {
						"QueueUrl": {},
						"MessageBody": {},
						"DelaySeconds": {
							"type": "integer"
						},
						"MessageAttributes": {
							"shape": "S1b",
							"locationName": "MessageAttribute"
						},
						"MessageDeduplicationId": {},
						"MessageGroupId": {}
					}
				},
				"output": {
					"resultWrapper": "SendMessageResult",
					"type": "structure",
					"members": {
						"MD5OfMessageBody": {},
						"MD5OfMessageAttributes": {},
						"MessageId": {},
						"SequenceNumber": {}
					}
				}
			},
			"SendMessageBatch": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Entries"
					],
					"members": {
						"QueueUrl": {},
						"Entries": {
							"type": "list",
							"member": {
								"locationName": "SendMessageBatchRequestEntry",
								"type": "structure",
								"required": [
									"Id",
									"MessageBody"
								],
								"members": {
									"Id": {},
									"MessageBody": {},
									"DelaySeconds": {
										"type": "integer"
									},
									"MessageAttributes": {
										"shape": "S1b",
										"locationName": "MessageAttribute"
									},
									"MessageDeduplicationId": {},
									"MessageGroupId": {}
								}
							},
							"flattened": true
						}
					}
				},
				"output": {
					"resultWrapper": "SendMessageBatchResult",
					"type": "structure",
					"required": [
						"Successful",
						"Failed"
					],
					"members": {
						"Successful": {
							"type": "list",
							"member": {
								"locationName": "SendMessageBatchResultEntry",
								"type": "structure",
								"required": [
									"Id",
									"MessageId",
									"MD5OfMessageBody"
								],
								"members": {
									"Id": {},
									"MessageId": {},
									"MD5OfMessageBody": {},
									"MD5OfMessageAttributes": {},
									"SequenceNumber": {}
								}
							},
							"flattened": true
						},
						"Failed": {
							"shape": "Sd"
						}
					}
				}
			},
			"SetQueueAttributes": {
				"input": {
					"type": "structure",
					"required": [
						"QueueUrl",
						"Attributes"
					],
					"members": {
						"QueueUrl": {},
						"Attributes": {
							"shape": "Sh",
							"locationName": "Attribute"
						}
					}
				}
			}
		},
		"shapes": {
			"Sd": {
				"type": "list",
				"member": {
					"locationName": "BatchResultErrorEntry",
					"type": "structure",
					"required": [
						"Id",
						"SenderFault",
						"Code"
					],
					"members": {
						"Id": {},
						"SenderFault": {
							"type": "boolean"
						},
						"Code": {},
						"Message": {}
					}
				},
				"flattened": true
			},
			"Sh": {
				"type": "map",
				"key": {
					"locationName": "Name"
				},
				"value": {
					"locationName": "Value"
				},
				"flattened": true,
				"locationName": "Attribute"
			},
			"St": {
				"type": "list",
				"member": {
					"locationName": "AttributeName"
				},
				"flattened": true
			},
			"Sz": {
				"type": "list",
				"member": {
					"locationName": "QueueUrl"
				},
				"flattened": true
			},
			"S1b": {
				"type": "map",
				"key": {
					"locationName": "Name"
				},
				"value": {
					"locationName": "Value",
					"type": "structure",
					"required": [
						"DataType"
					],
					"members": {
						"StringValue": {},
						"BinaryValue": {
							"type": "blob"
						},
						"StringListValues": {
							"flattened": true,
							"locationName": "StringListValue",
							"type": "list",
							"member": {
								"locationName": "StringListValue"
							}
						},
						"BinaryListValues": {
							"flattened": true,
							"locationName": "BinaryListValue",
							"type": "list",
							"member": {
								"locationName": "BinaryListValue",
								"type": "blob"
							}
						},
						"DataType": {}
					}
				},
				"flattened": true
			}
		}
	};

/***/ },
/* 762 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"ListQueues": {
				"result_key": "QueueUrls"
			}
		}
	};

/***/ },
/* 763 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2014-11-06",
			"endpointPrefix": "ssm",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "Amazon SSM",
			"serviceFullName": "Amazon Simple Systems Manager (SSM)",
			"signatureVersion": "v4",
			"targetPrefix": "AmazonSSM",
			"uid": "ssm-2014-11-06"
		},
		"operations": {
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId",
						"Tags"
					],
					"members": {
						"ResourceType": {},
						"ResourceId": {},
						"Tags": {
							"shape": "S4"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CancelCommand": {
				"input": {
					"type": "structure",
					"required": [
						"CommandId"
					],
					"members": {
						"CommandId": {},
						"InstanceIds": {
							"shape": "Sb"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"CreateActivation": {
				"input": {
					"type": "structure",
					"required": [
						"IamRole"
					],
					"members": {
						"Description": {},
						"DefaultInstanceName": {},
						"IamRole": {},
						"RegistrationLimit": {
							"type": "integer"
						},
						"ExpirationDate": {
							"type": "timestamp"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ActivationId": {},
						"ActivationCode": {}
					}
				}
			},
			"CreateAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"DocumentVersion": {},
						"InstanceId": {},
						"Parameters": {
							"shape": "Sq"
						},
						"Targets": {
							"shape": "Su"
						},
						"ScheduleExpression": {},
						"OutputLocation": {
							"shape": "S10"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationDescription": {
							"shape": "S16"
						}
					}
				}
			},
			"CreateAssociationBatch": {
				"input": {
					"type": "structure",
					"required": [
						"Entries"
					],
					"members": {
						"Entries": {
							"type": "list",
							"member": {
								"shape": "S1j",
								"locationName": "entries"
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Successful": {
							"type": "list",
							"member": {
								"shape": "S16",
								"locationName": "AssociationDescription"
							}
						},
						"Failed": {
							"type": "list",
							"member": {
								"locationName": "FailedCreateAssociationEntry",
								"type": "structure",
								"members": {
									"Entry": {
										"shape": "S1j"
									},
									"Message": {},
									"Fault": {}
								}
							}
						}
					}
				}
			},
			"CreateDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Content",
						"Name"
					],
					"members": {
						"Content": {},
						"Name": {},
						"DocumentType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentDescription": {
							"shape": "S1u"
						}
					}
				}
			},
			"CreateMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Schedule",
						"Duration",
						"Cutoff",
						"AllowUnassociatedTargets"
					],
					"members": {
						"Name": {},
						"Schedule": {},
						"Duration": {
							"type": "integer"
						},
						"Cutoff": {
							"type": "integer"
						},
						"AllowUnassociatedTargets": {
							"type": "boolean"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {}
					}
				}
			},
			"CreatePatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"GlobalFilters": {
							"shape": "S2m"
						},
						"ApprovalRules": {
							"shape": "S2s"
						},
						"ApprovedPatches": {
							"shape": "S2w"
						},
						"RejectedPatches": {
							"shape": "S2w"
						},
						"Description": {},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {}
					}
				}
			},
			"DeleteActivation": {
				"input": {
					"type": "structure",
					"required": [
						"ActivationId"
					],
					"members": {
						"ActivationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteAssociation": {
				"input": {
					"type": "structure",
					"members": {
						"Name": {},
						"InstanceId": {},
						"AssociationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeleteMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {}
					}
				}
			},
			"DeleteParameter": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeletePatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {}
					}
				}
			},
			"DeregisterManagedInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"DeregisterPatchBaselineForPatchGroup": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId",
						"PatchGroup"
					],
					"members": {
						"BaselineId": {},
						"PatchGroup": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"PatchGroup": {}
					}
				}
			},
			"DeregisterTargetFromMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"WindowTargetId"
					],
					"members": {
						"WindowId": {},
						"WindowTargetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"WindowTargetId": {}
					}
				}
			},
			"DeregisterTaskFromMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"WindowTaskId"
					],
					"members": {
						"WindowId": {},
						"WindowTaskId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"WindowTaskId": {}
					}
				}
			},
			"DescribeActivations": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FilterKey": {},
									"FilterValues": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ActivationList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"ActivationId": {},
									"Description": {},
									"DefaultInstanceName": {},
									"IamRole": {},
									"RegistrationLimit": {
										"type": "integer"
									},
									"RegistrationsCount": {
										"type": "integer"
									},
									"ExpirationDate": {
										"type": "timestamp"
									},
									"Expired": {
										"type": "boolean"
									},
									"CreatedDate": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAssociation": {
				"input": {
					"type": "structure",
					"members": {
						"Name": {},
						"InstanceId": {},
						"AssociationId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationDescription": {
							"shape": "S16"
						}
					}
				}
			},
			"DescribeAutomationExecutions": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Values"
								],
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AutomationExecutionMetadataList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AutomationExecutionId": {},
									"DocumentName": {},
									"DocumentVersion": {},
									"AutomationExecutionStatus": {},
									"ExecutionStartTime": {
										"type": "timestamp"
									},
									"ExecutionEndTime": {
										"type": "timestamp"
									},
									"ExecutedBy": {},
									"LogFile": {},
									"Outputs": {
										"shape": "S4h"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeAvailablePatches": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "S4m"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Patches": {
							"type": "list",
							"member": {
								"shape": "S4u"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"DocumentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Document": {
							"shape": "S1u"
						}
					}
				}
			},
			"DescribeDocumentPermission": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"PermissionType"
					],
					"members": {
						"Name": {},
						"PermissionType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AccountIds": {
							"shape": "S5b"
						}
					}
				}
			},
			"DescribeEffectiveInstanceAssociations": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Associations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AssociationId": {},
									"InstanceId": {},
									"Content": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeEffectivePatchesForPatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"EffectivePatches": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Patch": {
										"shape": "S4u"
									},
									"PatchStatus": {
										"type": "structure",
										"members": {
											"DeploymentStatus": {},
											"ApprovalDate": {
												"type": "timestamp"
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstanceAssociationsStatus": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceAssociationStatusInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"AssociationId": {},
									"Name": {},
									"DocumentVersion": {},
									"InstanceId": {},
									"ExecutionDate": {
										"type": "timestamp"
									},
									"Status": {},
									"DetailedStatus": {},
									"ExecutionSummary": {},
									"ErrorCode": {},
									"OutputUrl": {
										"type": "structure",
										"members": {
											"S3OutputUrl": {
												"type": "structure",
												"members": {
													"OutputUrl": {}
												}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstanceInformation": {
				"input": {
					"type": "structure",
					"members": {
						"InstanceInformationFilterList": {
							"type": "list",
							"member": {
								"locationName": "InstanceInformationFilter",
								"type": "structure",
								"required": [
									"key",
									"valueSet"
								],
								"members": {
									"key": {},
									"valueSet": {
										"shape": "S61"
									}
								}
							}
						},
						"Filters": {
							"type": "list",
							"member": {
								"locationName": "InstanceInformationStringFilter",
								"type": "structure",
								"required": [
									"Key",
									"Values"
								],
								"members": {
									"Key": {},
									"Values": {
										"shape": "S61"
									}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceInformationList": {
							"type": "list",
							"member": {
								"locationName": "InstanceInformation",
								"type": "structure",
								"members": {
									"InstanceId": {},
									"PingStatus": {},
									"LastPingDateTime": {
										"type": "timestamp"
									},
									"AgentVersion": {},
									"IsLatestVersion": {
										"type": "boolean"
									},
									"PlatformType": {},
									"PlatformName": {},
									"PlatformVersion": {},
									"ActivationId": {},
									"IamRole": {},
									"RegistrationDate": {
										"type": "timestamp"
									},
									"ResourceType": {},
									"Name": {},
									"IPAddress": {},
									"ComputerName": {},
									"AssociationStatus": {},
									"LastAssociationExecutionDate": {
										"type": "timestamp"
									},
									"LastSuccessfulAssociationExecutionDate": {
										"type": "timestamp"
									},
									"AssociationOverview": {
										"type": "structure",
										"members": {
											"DetailedStatus": {},
											"InstanceAssociationStatusAggregatedCount": {
												"type": "map",
												"key": {},
												"value": {
													"type": "integer"
												}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstancePatchStates": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceIds"
					],
					"members": {
						"InstanceIds": {
							"shape": "Sb"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstancePatchStates": {
							"type": "list",
							"member": {
								"shape": "S6l"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstancePatchStatesForPatchGroup": {
				"input": {
					"type": "structure",
					"required": [
						"PatchGroup"
					],
					"members": {
						"PatchGroup": {},
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Key",
									"Values",
									"Type"
								],
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									},
									"Type": {}
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstancePatchStates": {
							"type": "list",
							"member": {
								"shape": "S6l"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeInstancePatches": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId"
					],
					"members": {
						"InstanceId": {},
						"Filters": {
							"shape": "S4m"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Patches": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Title",
									"KBId",
									"Classification",
									"Severity",
									"State",
									"InstalledTime"
								],
								"members": {
									"Title": {},
									"KBId": {},
									"Classification": {},
									"Severity": {},
									"State": {},
									"InstalledTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowExecutionTaskInvocations": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId",
						"TaskId"
					],
					"members": {
						"WindowExecutionId": {},
						"TaskId": {},
						"Filters": {
							"shape": "S7f"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionTaskInvocationIdentities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowExecutionId": {},
									"TaskExecutionId": {},
									"InvocationId": {},
									"ExecutionId": {},
									"Parameters": {
										"type": "string",
										"sensitive": true
									},
									"Status": {},
									"StatusDetails": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"OwnerInformation": {
										"shape": "S6n"
									},
									"WindowTargetId": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowExecutionTasks": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId"
					],
					"members": {
						"WindowExecutionId": {},
						"Filters": {
							"shape": "S7f"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionTaskIdentities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowExecutionId": {},
									"TaskExecutionId": {},
									"Status": {},
									"StatusDetails": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									},
									"TaskArn": {},
									"TaskType": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowExecutions": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {},
						"Filters": {
							"shape": "S7f"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"WindowExecutionId": {},
									"Status": {},
									"StatusDetails": {},
									"StartTime": {
										"type": "timestamp"
									},
									"EndTime": {
										"type": "timestamp"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowTargets": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {},
						"Filters": {
							"shape": "S7f"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Targets": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"WindowTargetId": {},
									"ResourceType": {},
									"Targets": {
										"shape": "Su"
									},
									"OwnerInformation": {
										"shape": "S6n"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindowTasks": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {},
						"Filters": {
							"shape": "S7f"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tasks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"WindowTaskId": {},
									"TaskArn": {},
									"Type": {},
									"Targets": {
										"shape": "Su"
									},
									"TaskParameters": {
										"shape": "S8d"
									},
									"Priority": {
										"type": "integer"
									},
									"LoggingInfo": {
										"shape": "S8j"
									},
									"ServiceRoleArn": {},
									"MaxConcurrency": {},
									"MaxErrors": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeMaintenanceWindows": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "S7f"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowIdentities": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"WindowId": {},
									"Name": {},
									"Enabled": {
										"type": "boolean"
									},
									"Duration": {
										"type": "integer"
									},
									"Cutoff": {
										"type": "integer"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribeParameters": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Values"
								],
								"members": {
									"Key": {},
									"Values": {
										"type": "list",
										"member": {}
									}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Parameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Type": {},
									"KeyId": {},
									"LastModifiedDate": {
										"type": "timestamp"
									},
									"LastModifiedUser": {},
									"Description": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePatchBaselines": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "S4m"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineIdentities": {
							"type": "list",
							"member": {
								"shape": "S96"
							}
						},
						"NextToken": {}
					}
				}
			},
			"DescribePatchGroupState": {
				"input": {
					"type": "structure",
					"required": [
						"PatchGroup"
					],
					"members": {
						"PatchGroup": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Instances": {
							"type": "integer"
						},
						"InstancesWithInstalledPatches": {
							"type": "integer"
						},
						"InstancesWithInstalledOtherPatches": {
							"type": "integer"
						},
						"InstancesWithMissingPatches": {
							"type": "integer"
						},
						"InstancesWithFailedPatches": {
							"type": "integer"
						},
						"InstancesWithNotApplicablePatches": {
							"type": "integer"
						}
					}
				}
			},
			"DescribePatchGroups": {
				"input": {
					"type": "structure",
					"members": {
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Mappings": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"PatchGroup": {},
									"BaselineIdentity": {
										"shape": "S96"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetAutomationExecution": {
				"input": {
					"type": "structure",
					"required": [
						"AutomationExecutionId"
					],
					"members": {
						"AutomationExecutionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AutomationExecution": {
							"type": "structure",
							"members": {
								"AutomationExecutionId": {},
								"DocumentName": {},
								"DocumentVersion": {},
								"ExecutionStartTime": {
									"type": "timestamp"
								},
								"ExecutionEndTime": {
									"type": "timestamp"
								},
								"AutomationExecutionStatus": {},
								"StepExecutions": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"StepName": {},
											"Action": {},
											"ExecutionStartTime": {
												"type": "timestamp"
											},
											"ExecutionEndTime": {
												"type": "timestamp"
											},
											"StepStatus": {},
											"ResponseCode": {},
											"Inputs": {
												"type": "map",
												"key": {},
												"value": {}
											},
											"Outputs": {
												"shape": "S4h"
											},
											"Response": {},
											"FailureMessage": {}
										}
									}
								},
								"Parameters": {
									"shape": "S4h"
								},
								"Outputs": {
									"shape": "S4h"
								},
								"FailureMessage": {}
							}
						}
					}
				}
			},
			"GetCommandInvocation": {
				"input": {
					"type": "structure",
					"required": [
						"CommandId",
						"InstanceId"
					],
					"members": {
						"CommandId": {},
						"InstanceId": {},
						"PluginName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CommandId": {},
						"InstanceId": {},
						"Comment": {},
						"DocumentName": {},
						"PluginName": {},
						"ResponseCode": {
							"type": "integer"
						},
						"ExecutionStartDateTime": {},
						"ExecutionElapsedTime": {},
						"ExecutionEndDateTime": {},
						"Status": {},
						"StatusDetails": {},
						"StandardOutputContent": {},
						"StandardOutputUrl": {},
						"StandardErrorContent": {},
						"StandardErrorUrl": {}
					}
				}
			},
			"GetDefaultPatchBaseline": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {}
					}
				}
			},
			"GetDeployablePatchSnapshotForInstance": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"SnapshotId"
					],
					"members": {
						"InstanceId": {},
						"SnapshotId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"InstanceId": {},
						"SnapshotId": {},
						"SnapshotDownloadUrl": {}
					}
				}
			},
			"GetDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"DocumentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Name": {},
						"DocumentVersion": {},
						"Content": {},
						"DocumentType": {}
					}
				}
			},
			"GetInventory": {
				"input": {
					"type": "structure",
					"members": {
						"Filters": {
							"shape": "Sa4"
						},
						"ResultAttributes": {
							"type": "list",
							"member": {
								"locationName": "ResultAttribute",
								"type": "structure",
								"required": [
									"TypeName"
								],
								"members": {
									"TypeName": {}
								}
							}
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Entities": {
							"type": "list",
							"member": {
								"locationName": "Entity",
								"type": "structure",
								"members": {
									"Id": {},
									"Data": {
										"type": "map",
										"key": {},
										"value": {
											"type": "structure",
											"required": [
												"TypeName",
												"SchemaVersion",
												"Content"
											],
											"members": {
												"TypeName": {},
												"SchemaVersion": {},
												"CaptureTime": {},
												"ContentHash": {},
												"Content": {
													"shape": "San"
												}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetInventorySchema": {
				"input": {
					"type": "structure",
					"members": {
						"TypeName": {},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Schemas": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"TypeName",
									"Attributes"
								],
								"members": {
									"TypeName": {},
									"Version": {},
									"Attributes": {
										"type": "list",
										"member": {
											"locationName": "Attribute",
											"type": "structure",
											"required": [
												"Name",
												"DataType"
											],
											"members": {
												"Name": {},
												"DataType": {}
											}
										}
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"Name": {},
						"Schedule": {},
						"Duration": {
							"type": "integer"
						},
						"Cutoff": {
							"type": "integer"
						},
						"AllowUnassociatedTargets": {
							"type": "boolean"
						},
						"Enabled": {
							"type": "boolean"
						},
						"CreatedDate": {
							"type": "timestamp"
						},
						"ModifiedDate": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetMaintenanceWindowExecution": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId"
					],
					"members": {
						"WindowExecutionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionId": {},
						"TaskIds": {
							"type": "list",
							"member": {}
						},
						"Status": {},
						"StatusDetails": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetMaintenanceWindowExecutionTask": {
				"input": {
					"type": "structure",
					"required": [
						"WindowExecutionId",
						"TaskId"
					],
					"members": {
						"WindowExecutionId": {},
						"TaskId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowExecutionId": {},
						"TaskExecutionId": {},
						"TaskArn": {},
						"ServiceRole": {},
						"Type": {},
						"TaskParameters": {
							"type": "list",
							"member": {
								"shape": "S8d"
							},
							"sensitive": true
						},
						"Priority": {
							"type": "integer"
						},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"Status": {},
						"StatusDetails": {},
						"StartTime": {
							"type": "timestamp"
						},
						"EndTime": {
							"type": "timestamp"
						}
					}
				}
			},
			"GetParameterHistory": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"WithDecryption": {
							"type": "boolean"
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Parameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Type": {},
									"KeyId": {},
									"LastModifiedDate": {
										"type": "timestamp"
									},
									"LastModifiedUser": {},
									"Description": {},
									"Value": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"GetParameters": {
				"input": {
					"type": "structure",
					"required": [
						"Names"
					],
					"members": {
						"Names": {
							"shape": "Sbf"
						},
						"WithDecryption": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Parameters": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"Type": {},
									"Value": {}
								}
							}
						},
						"InvalidParameters": {
							"shape": "Sbf"
						}
					}
				}
			},
			"GetPatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"Name": {},
						"GlobalFilters": {
							"shape": "S2m"
						},
						"ApprovalRules": {
							"shape": "S2s"
						},
						"ApprovedPatches": {
							"shape": "S2w"
						},
						"RejectedPatches": {
							"shape": "S2w"
						},
						"PatchGroups": {
							"type": "list",
							"member": {}
						},
						"CreatedDate": {
							"type": "timestamp"
						},
						"ModifiedDate": {
							"type": "timestamp"
						},
						"Description": {}
					}
				}
			},
			"GetPatchBaselineForPatchGroup": {
				"input": {
					"type": "structure",
					"required": [
						"PatchGroup"
					],
					"members": {
						"PatchGroup": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"PatchGroup": {}
					}
				}
			},
			"ListAssociations": {
				"input": {
					"type": "structure",
					"members": {
						"AssociationFilterList": {
							"type": "list",
							"member": {
								"locationName": "AssociationFilter",
								"type": "structure",
								"required": [
									"key",
									"value"
								],
								"members": {
									"key": {},
									"value": {}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Associations": {
							"type": "list",
							"member": {
								"locationName": "Association",
								"type": "structure",
								"members": {
									"Name": {},
									"InstanceId": {},
									"AssociationId": {},
									"DocumentVersion": {},
									"Targets": {
										"shape": "Su"
									},
									"LastExecutionDate": {
										"type": "timestamp"
									},
									"Overview": {
										"shape": "S1c"
									},
									"ScheduleExpression": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListCommandInvocations": {
				"input": {
					"type": "structure",
					"members": {
						"CommandId": {},
						"InstanceId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"Filters": {
							"shape": "Sby"
						},
						"Details": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CommandInvocations": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"CommandId": {},
									"InstanceId": {},
									"InstanceName": {},
									"Comment": {},
									"DocumentName": {},
									"RequestedDateTime": {
										"type": "timestamp"
									},
									"Status": {},
									"StatusDetails": {},
									"TraceOutput": {},
									"StandardOutputUrl": {},
									"StandardErrorUrl": {},
									"CommandPlugins": {
										"type": "list",
										"member": {
											"type": "structure",
											"members": {
												"Name": {},
												"Status": {},
												"StatusDetails": {},
												"ResponseCode": {
													"type": "integer"
												},
												"ResponseStartDateTime": {
													"type": "timestamp"
												},
												"ResponseFinishDateTime": {
													"type": "timestamp"
												},
												"Output": {},
												"StandardOutputUrl": {},
												"StandardErrorUrl": {},
												"OutputS3Region": {},
												"OutputS3BucketName": {},
												"OutputS3KeyPrefix": {}
											}
										}
									},
									"ServiceRole": {},
									"NotificationConfig": {
										"shape": "Scb"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListCommands": {
				"input": {
					"type": "structure",
					"members": {
						"CommandId": {},
						"InstanceId": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {},
						"Filters": {
							"shape": "Sby"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Commands": {
							"type": "list",
							"member": {
								"shape": "Scj"
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListDocumentVersions": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentVersions": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Name": {},
									"DocumentVersion": {},
									"CreatedDate": {
										"type": "timestamp"
									},
									"IsDefaultVersion": {
										"type": "boolean"
									}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListDocuments": {
				"input": {
					"type": "structure",
					"members": {
						"DocumentFilterList": {
							"type": "list",
							"member": {
								"locationName": "DocumentFilter",
								"type": "structure",
								"required": [
									"key",
									"value"
								],
								"members": {
									"key": {},
									"value": {}
								}
							}
						},
						"MaxResults": {
							"type": "integer"
						},
						"NextToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentIdentifiers": {
							"type": "list",
							"member": {
								"locationName": "DocumentIdentifier",
								"type": "structure",
								"members": {
									"Name": {},
									"Owner": {},
									"PlatformTypes": {
										"shape": "S28"
									},
									"DocumentVersion": {},
									"DocumentType": {},
									"SchemaVersion": {}
								}
							}
						},
						"NextToken": {}
					}
				}
			},
			"ListInventoryEntries": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"TypeName"
					],
					"members": {
						"InstanceId": {},
						"TypeName": {},
						"Filters": {
							"shape": "Sa4"
						},
						"NextToken": {},
						"MaxResults": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TypeName": {},
						"InstanceId": {},
						"SchemaVersion": {},
						"CaptureTime": {},
						"Entries": {
							"shape": "San"
						},
						"NextToken": {}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId"
					],
					"members": {
						"ResourceType": {},
						"ResourceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TagList": {
							"shape": "S4"
						}
					}
				}
			},
			"ModifyDocumentPermission": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"PermissionType"
					],
					"members": {
						"Name": {},
						"PermissionType": {},
						"AccountIdsToAdd": {
							"shape": "S5b"
						},
						"AccountIdsToRemove": {
							"shape": "S5b"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"PutInventory": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"Items"
					],
					"members": {
						"InstanceId": {},
						"Items": {
							"type": "list",
							"member": {
								"locationName": "Item",
								"type": "structure",
								"required": [
									"TypeName",
									"SchemaVersion",
									"CaptureTime"
								],
								"members": {
									"TypeName": {},
									"SchemaVersion": {},
									"CaptureTime": {},
									"ContentHash": {},
									"Content": {
										"shape": "San"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"PutParameter": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"Value",
						"Type"
					],
					"members": {
						"Name": {},
						"Description": {},
						"Value": {},
						"Type": {},
						"KeyId": {},
						"Overwrite": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"RegisterDefaultPatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {}
					}
				}
			},
			"RegisterPatchBaselineForPatchGroup": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId",
						"PatchGroup"
					],
					"members": {
						"BaselineId": {},
						"PatchGroup": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"PatchGroup": {}
					}
				}
			},
			"RegisterTargetWithMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"ResourceType",
						"Targets"
					],
					"members": {
						"WindowId": {},
						"ResourceType": {},
						"Targets": {
							"shape": "Su"
						},
						"OwnerInformation": {
							"shape": "S6n"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowTargetId": {}
					}
				}
			},
			"RegisterTaskWithMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId",
						"Targets",
						"TaskArn",
						"ServiceRoleArn",
						"TaskType",
						"MaxConcurrency",
						"MaxErrors"
					],
					"members": {
						"WindowId": {},
						"Targets": {
							"shape": "Su"
						},
						"TaskArn": {},
						"ServiceRoleArn": {},
						"TaskType": {},
						"TaskParameters": {
							"shape": "S8d"
						},
						"Priority": {
							"type": "integer"
						},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"LoggingInfo": {
							"shape": "S8j"
						},
						"ClientToken": {
							"idempotencyToken": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowTaskId": {}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceType",
						"ResourceId",
						"TagKeys"
					],
					"members": {
						"ResourceType": {},
						"ResourceId": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"SendCommand": {
				"input": {
					"type": "structure",
					"required": [
						"DocumentName"
					],
					"members": {
						"InstanceIds": {
							"shape": "Sb"
						},
						"Targets": {
							"shape": "Su"
						},
						"DocumentName": {},
						"DocumentHash": {},
						"DocumentHashType": {},
						"TimeoutSeconds": {
							"type": "integer"
						},
						"Comment": {},
						"Parameters": {
							"shape": "Sq"
						},
						"OutputS3Region": {},
						"OutputS3BucketName": {},
						"OutputS3KeyPrefix": {},
						"MaxConcurrency": {},
						"MaxErrors": {},
						"ServiceRoleArn": {},
						"NotificationConfig": {
							"shape": "Scb"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Command": {
							"shape": "Scj"
						}
					}
				}
			},
			"StartAutomationExecution": {
				"input": {
					"type": "structure",
					"required": [
						"DocumentName"
					],
					"members": {
						"DocumentName": {},
						"DocumentVersion": {},
						"Parameters": {
							"shape": "S4h"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AutomationExecutionId": {}
					}
				}
			},
			"StopAutomationExecution": {
				"input": {
					"type": "structure",
					"required": [
						"AutomationExecutionId"
					],
					"members": {
						"AutomationExecutionId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdateAssociation": {
				"input": {
					"type": "structure",
					"required": [
						"AssociationId"
					],
					"members": {
						"AssociationId": {},
						"Parameters": {
							"shape": "Sq"
						},
						"DocumentVersion": {},
						"ScheduleExpression": {},
						"OutputLocation": {
							"shape": "S10"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationDescription": {
							"shape": "S16"
						}
					}
				}
			},
			"UpdateAssociationStatus": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"InstanceId",
						"AssociationStatus"
					],
					"members": {
						"Name": {},
						"InstanceId": {},
						"AssociationStatus": {
							"shape": "S18"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"AssociationDescription": {
							"shape": "S16"
						}
					}
				}
			},
			"UpdateDocument": {
				"input": {
					"type": "structure",
					"required": [
						"Content",
						"Name"
					],
					"members": {
						"Content": {},
						"Name": {},
						"DocumentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"DocumentDescription": {
							"shape": "S1u"
						}
					}
				}
			},
			"UpdateDocumentDefaultVersion": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"DocumentVersion"
					],
					"members": {
						"Name": {},
						"DocumentVersion": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Description": {
							"type": "structure",
							"members": {
								"Name": {},
								"DefaultVersion": {}
							}
						}
					}
				}
			},
			"UpdateMaintenanceWindow": {
				"input": {
					"type": "structure",
					"required": [
						"WindowId"
					],
					"members": {
						"WindowId": {},
						"Name": {},
						"Schedule": {},
						"Duration": {
							"type": "integer"
						},
						"Cutoff": {
							"type": "integer"
						},
						"AllowUnassociatedTargets": {
							"type": "boolean"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WindowId": {},
						"Name": {},
						"Schedule": {},
						"Duration": {
							"type": "integer"
						},
						"Cutoff": {
							"type": "integer"
						},
						"AllowUnassociatedTargets": {
							"type": "boolean"
						},
						"Enabled": {
							"type": "boolean"
						}
					}
				}
			},
			"UpdateManagedInstanceRole": {
				"input": {
					"type": "structure",
					"required": [
						"InstanceId",
						"IamRole"
					],
					"members": {
						"InstanceId": {},
						"IamRole": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {}
				}
			},
			"UpdatePatchBaseline": {
				"input": {
					"type": "structure",
					"required": [
						"BaselineId"
					],
					"members": {
						"BaselineId": {},
						"Name": {},
						"GlobalFilters": {
							"shape": "S2m"
						},
						"ApprovalRules": {
							"shape": "S2s"
						},
						"ApprovedPatches": {
							"shape": "S2w"
						},
						"RejectedPatches": {
							"shape": "S2w"
						},
						"Description": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"BaselineId": {},
						"Name": {},
						"GlobalFilters": {
							"shape": "S2m"
						},
						"ApprovalRules": {
							"shape": "S2s"
						},
						"ApprovedPatches": {
							"shape": "S2w"
						},
						"RejectedPatches": {
							"shape": "S2w"
						},
						"CreatedDate": {
							"type": "timestamp"
						},
						"ModifiedDate": {
							"type": "timestamp"
						},
						"Description": {}
					}
				}
			}
		},
		"shapes": {
			"S4": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"Sb": {
				"type": "list",
				"member": {}
			},
			"Sq": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {}
				}
			},
			"Su": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S10": {
				"type": "structure",
				"members": {
					"S3Location": {
						"type": "structure",
						"members": {
							"OutputS3Region": {},
							"OutputS3BucketName": {},
							"OutputS3KeyPrefix": {}
						}
					}
				}
			},
			"S16": {
				"type": "structure",
				"members": {
					"Name": {},
					"InstanceId": {},
					"Date": {
						"type": "timestamp"
					},
					"LastUpdateAssociationDate": {
						"type": "timestamp"
					},
					"Status": {
						"shape": "S18"
					},
					"Overview": {
						"shape": "S1c"
					},
					"DocumentVersion": {},
					"Parameters": {
						"shape": "Sq"
					},
					"AssociationId": {},
					"Targets": {
						"shape": "Su"
					},
					"ScheduleExpression": {},
					"OutputLocation": {
						"shape": "S10"
					},
					"LastExecutionDate": {
						"type": "timestamp"
					},
					"LastSuccessfulExecutionDate": {
						"type": "timestamp"
					}
				}
			},
			"S18": {
				"type": "structure",
				"required": [
					"Date",
					"Name",
					"Message"
				],
				"members": {
					"Date": {
						"type": "timestamp"
					},
					"Name": {},
					"Message": {},
					"AdditionalInfo": {}
				}
			},
			"S1c": {
				"type": "structure",
				"members": {
					"Status": {},
					"DetailedStatus": {},
					"AssociationStatusAggregatedCount": {
						"type": "map",
						"key": {},
						"value": {
							"type": "integer"
						}
					}
				}
			},
			"S1j": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"InstanceId": {},
					"Parameters": {
						"shape": "Sq"
					},
					"DocumentVersion": {},
					"Targets": {
						"shape": "Su"
					},
					"ScheduleExpression": {},
					"OutputLocation": {
						"shape": "S10"
					}
				}
			},
			"S1u": {
				"type": "structure",
				"members": {
					"Sha1": {},
					"Hash": {},
					"HashType": {},
					"Name": {},
					"Owner": {},
					"CreatedDate": {
						"type": "timestamp"
					},
					"Status": {},
					"DocumentVersion": {},
					"Description": {},
					"Parameters": {
						"type": "list",
						"member": {
							"locationName": "DocumentParameter",
							"type": "structure",
							"members": {
								"Name": {},
								"Type": {},
								"Description": {},
								"DefaultValue": {}
							}
						}
					},
					"PlatformTypes": {
						"shape": "S28"
					},
					"DocumentType": {},
					"SchemaVersion": {},
					"LatestVersion": {},
					"DefaultVersion": {}
				}
			},
			"S28": {
				"type": "list",
				"member": {
					"locationName": "PlatformType"
				}
			},
			"S2m": {
				"type": "structure",
				"required": [
					"PatchFilters"
				],
				"members": {
					"PatchFilters": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"Key",
								"Values"
							],
							"members": {
								"Key": {},
								"Values": {
									"type": "list",
									"member": {}
								}
							}
						}
					}
				}
			},
			"S2s": {
				"type": "structure",
				"required": [
					"PatchRules"
				],
				"members": {
					"PatchRules": {
						"type": "list",
						"member": {
							"type": "structure",
							"required": [
								"PatchFilterGroup",
								"ApproveAfterDays"
							],
							"members": {
								"PatchFilterGroup": {
									"shape": "S2m"
								},
								"ApproveAfterDays": {
									"type": "integer"
								}
							}
						}
					}
				}
			},
			"S2w": {
				"type": "list",
				"member": {}
			},
			"S4h": {
				"type": "map",
				"key": {},
				"value": {
					"type": "list",
					"member": {}
				}
			},
			"S4m": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S4u": {
				"type": "structure",
				"members": {
					"Id": {},
					"ReleaseDate": {
						"type": "timestamp"
					},
					"Title": {},
					"Description": {},
					"ContentUrl": {},
					"Vendor": {},
					"ProductFamily": {},
					"Product": {},
					"Classification": {},
					"MsrcSeverity": {},
					"KbNumber": {},
					"MsrcNumber": {},
					"Language": {}
				}
			},
			"S5b": {
				"type": "list",
				"member": {
					"locationName": "AccountId"
				}
			},
			"S61": {
				"type": "list",
				"member": {
					"locationName": "InstanceInformationFilterValue"
				}
			},
			"S6l": {
				"type": "structure",
				"required": [
					"InstanceId",
					"PatchGroup",
					"BaselineId",
					"OperationStartTime",
					"OperationEndTime",
					"Operation"
				],
				"members": {
					"InstanceId": {},
					"PatchGroup": {},
					"BaselineId": {},
					"SnapshotId": {},
					"OwnerInformation": {
						"shape": "S6n"
					},
					"InstalledCount": {
						"type": "integer"
					},
					"InstalledOtherCount": {
						"type": "integer"
					},
					"MissingCount": {
						"type": "integer"
					},
					"FailedCount": {
						"type": "integer"
					},
					"NotApplicableCount": {
						"type": "integer"
					},
					"OperationStartTime": {
						"type": "timestamp"
					},
					"OperationEndTime": {
						"type": "timestamp"
					},
					"Operation": {}
				}
			},
			"S6n": {
				"type": "string",
				"sensitive": true
			},
			"S7f": {
				"type": "list",
				"member": {
					"type": "structure",
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"S8d": {
				"type": "map",
				"key": {},
				"value": {
					"type": "structure",
					"members": {
						"Values": {
							"type": "list",
							"member": {
								"type": "string",
								"sensitive": true
							},
							"sensitive": true
						}
					},
					"sensitive": true
				},
				"sensitive": true
			},
			"S8j": {
				"type": "structure",
				"required": [
					"S3BucketName",
					"S3Region"
				],
				"members": {
					"S3BucketName": {},
					"S3KeyPrefix": {},
					"S3Region": {}
				}
			},
			"S96": {
				"type": "structure",
				"members": {
					"BaselineId": {},
					"BaselineName": {},
					"BaselineDescription": {},
					"DefaultBaseline": {
						"type": "boolean"
					}
				}
			},
			"Sa4": {
				"type": "list",
				"member": {
					"locationName": "InventoryFilter",
					"type": "structure",
					"required": [
						"Key",
						"Values"
					],
					"members": {
						"Key": {},
						"Values": {
							"type": "list",
							"member": {
								"locationName": "FilterValue"
							}
						},
						"Type": {}
					}
				}
			},
			"San": {
				"type": "list",
				"member": {
					"type": "map",
					"key": {},
					"value": {}
				}
			},
			"Sbf": {
				"type": "list",
				"member": {}
			},
			"Sby": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"key",
						"value"
					],
					"members": {
						"key": {},
						"value": {}
					}
				}
			},
			"Scb": {
				"type": "structure",
				"members": {
					"NotificationArn": {},
					"NotificationEvents": {
						"type": "list",
						"member": {}
					},
					"NotificationType": {}
				}
			},
			"Scj": {
				"type": "structure",
				"members": {
					"CommandId": {},
					"DocumentName": {},
					"Comment": {},
					"ExpiresAfter": {
						"type": "timestamp"
					},
					"Parameters": {
						"shape": "Sq"
					},
					"InstanceIds": {
						"shape": "Sb"
					},
					"Targets": {
						"shape": "Su"
					},
					"RequestedDateTime": {
						"type": "timestamp"
					},
					"Status": {},
					"StatusDetails": {},
					"OutputS3Region": {},
					"OutputS3BucketName": {},
					"OutputS3KeyPrefix": {},
					"MaxConcurrency": {},
					"MaxErrors": {},
					"TargetCount": {
						"type": "integer"
					},
					"CompletedCount": {
						"type": "integer"
					},
					"ErrorCount": {
						"type": "integer"
					},
					"ServiceRole": {},
					"NotificationConfig": {
						"shape": "Scb"
					}
				}
			}
		}
	};

/***/ },
/* 764 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeInstanceInformation": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "InstanceInformationList"
			},
			"ListAssociations": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "Associations"
			},
			"ListCommandInvocations": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "CommandInvocations"
			},
			"ListCommands": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "Commands"
			},
			"ListDocuments": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "DocumentIdentifiers"
			},
			"DescribeActivations": {
				"input_token": "NextToken",
				"output_token": "NextToken",
				"limit_key": "MaxResults",
				"result_key": "ActivationList"
			}
		}
	};

/***/ },
/* 765 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2013-06-30",
			"endpointPrefix": "storagegateway",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceFullName": "AWS Storage Gateway",
			"signatureVersion": "v4",
			"targetPrefix": "StorageGateway_20130630",
			"uid": "storagegateway-2013-06-30"
		},
		"operations": {
			"ActivateGateway": {
				"input": {
					"type": "structure",
					"required": [
						"ActivationKey",
						"GatewayName",
						"GatewayTimezone",
						"GatewayRegion"
					],
					"members": {
						"ActivationKey": {},
						"GatewayName": {},
						"GatewayTimezone": {},
						"GatewayRegion": {},
						"GatewayType": {},
						"TapeDriveType": {},
						"MediumChangerType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"AddCache": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"DiskIds"
					],
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sc"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"AddTagsToResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"Tags"
					],
					"members": {
						"ResourceARN": {},
						"Tags": {
							"shape": "Sh"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceARN": {}
					}
				}
			},
			"AddUploadBuffer": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"DiskIds"
					],
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sc"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"AddWorkingStorage": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"DiskIds"
					],
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sc"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"CancelArchival": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeARN"
					],
					"members": {
						"GatewayARN": {},
						"TapeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"CancelRetrieval": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeARN"
					],
					"members": {
						"GatewayARN": {},
						"TapeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"CreateCachediSCSIVolume": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"VolumeSizeInBytes",
						"TargetName",
						"NetworkInterfaceId",
						"ClientToken"
					],
					"members": {
						"GatewayARN": {},
						"VolumeSizeInBytes": {
							"type": "long"
						},
						"SnapshotId": {},
						"TargetName": {},
						"SourceVolumeARN": {},
						"NetworkInterfaceId": {},
						"ClientToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {},
						"TargetARN": {}
					}
				}
			},
			"CreateNFSFileShare": {
				"input": {
					"type": "structure",
					"required": [
						"ClientToken",
						"GatewayARN",
						"Role",
						"LocationARN"
					],
					"members": {
						"ClientToken": {},
						"NFSFileShareDefaults": {
							"shape": "S15"
						},
						"GatewayARN": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"Role": {},
						"LocationARN": {},
						"DefaultStorageClass": {},
						"ClientList": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {}
					}
				}
			},
			"CreateSnapshot": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN",
						"SnapshotDescription"
					],
					"members": {
						"VolumeARN": {},
						"SnapshotDescription": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {},
						"SnapshotId": {}
					}
				}
			},
			"CreateSnapshotFromVolumeRecoveryPoint": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN",
						"SnapshotDescription"
					],
					"members": {
						"VolumeARN": {},
						"SnapshotDescription": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SnapshotId": {},
						"VolumeARN": {},
						"VolumeRecoveryPointTime": {}
					}
				}
			},
			"CreateStorediSCSIVolume": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"DiskId",
						"PreserveExistingData",
						"TargetName",
						"NetworkInterfaceId"
					],
					"members": {
						"GatewayARN": {},
						"DiskId": {},
						"SnapshotId": {},
						"PreserveExistingData": {
							"type": "boolean"
						},
						"TargetName": {},
						"NetworkInterfaceId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {},
						"VolumeSizeInBytes": {
							"type": "long"
						},
						"TargetARN": {}
					}
				}
			},
			"CreateTapeWithBarcode": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeSizeInBytes",
						"TapeBarcode"
					],
					"members": {
						"GatewayARN": {},
						"TapeSizeInBytes": {
							"type": "long"
						},
						"TapeBarcode": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"CreateTapes": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeSizeInBytes",
						"ClientToken",
						"NumTapesToCreate",
						"TapeBarcodePrefix"
					],
					"members": {
						"GatewayARN": {},
						"TapeSizeInBytes": {
							"type": "long"
						},
						"ClientToken": {},
						"NumTapesToCreate": {
							"type": "integer"
						},
						"TapeBarcodePrefix": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARNs": {
							"shape": "S1y"
						}
					}
				}
			},
			"DeleteBandwidthRateLimit": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"BandwidthType"
					],
					"members": {
						"GatewayARN": {},
						"BandwidthType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"DeleteChapCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"TargetARN",
						"InitiatorName"
					],
					"members": {
						"TargetARN": {},
						"InitiatorName": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TargetARN": {},
						"InitiatorName": {}
					}
				}
			},
			"DeleteFileShare": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARN"
					],
					"members": {
						"FileShareARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {}
					}
				}
			},
			"DeleteGateway": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"DeleteSnapshotSchedule": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN"
					],
					"members": {
						"VolumeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {}
					}
				}
			},
			"DeleteTape": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"TapeARN"
					],
					"members": {
						"GatewayARN": {},
						"TapeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"DeleteTapeArchive": {
				"input": {
					"type": "structure",
					"required": [
						"TapeARN"
					],
					"members": {
						"TapeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"DeleteVolume": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN"
					],
					"members": {
						"VolumeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {}
					}
				}
			},
			"DescribeBandwidthRateLimit": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"AverageUploadRateLimitInBitsPerSec": {
							"type": "long"
						},
						"AverageDownloadRateLimitInBitsPerSec": {
							"type": "long"
						}
					}
				}
			},
			"DescribeCache": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sc"
						},
						"CacheAllocatedInBytes": {
							"type": "long"
						},
						"CacheUsedPercentage": {
							"type": "double"
						},
						"CacheDirtyPercentage": {
							"type": "double"
						},
						"CacheHitPercentage": {
							"type": "double"
						},
						"CacheMissPercentage": {
							"type": "double"
						}
					}
				}
			},
			"DescribeCachediSCSIVolumes": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARNs"
					],
					"members": {
						"VolumeARNs": {
							"shape": "S2p"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"CachediSCSIVolumes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeARN": {},
									"VolumeId": {},
									"VolumeType": {},
									"VolumeStatus": {},
									"VolumeSizeInBytes": {
										"type": "long"
									},
									"VolumeProgress": {
										"type": "double"
									},
									"SourceSnapshotId": {},
									"VolumeiSCSIAttributes": {
										"shape": "S2x"
									},
									"CreatedDate": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeChapCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"TargetARN"
					],
					"members": {
						"TargetARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChapCredentials": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TargetARN": {},
									"SecretToAuthenticateInitiator": {},
									"InitiatorName": {},
									"SecretToAuthenticateTarget": {}
								}
							}
						}
					}
				}
			},
			"DescribeGatewayInformation": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"GatewayId": {},
						"GatewayName": {},
						"GatewayTimezone": {},
						"GatewayState": {},
						"GatewayNetworkInterfaces": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"Ipv4Address": {},
									"MacAddress": {},
									"Ipv6Address": {}
								}
							}
						},
						"GatewayType": {},
						"NextUpdateAvailabilityDate": {},
						"LastSoftwareUpdate": {}
					}
				}
			},
			"DescribeMaintenanceStartTime": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"HourOfDay": {
							"type": "integer"
						},
						"MinuteOfHour": {
							"type": "integer"
						},
						"DayOfWeek": {
							"type": "integer"
						},
						"Timezone": {}
					}
				}
			},
			"DescribeNFSFileShares": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARNList"
					],
					"members": {
						"FileShareARNList": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NFSFileShareInfoList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"NFSFileShareDefaults": {
										"shape": "S15"
									},
									"FileShareARN": {},
									"FileShareId": {},
									"FileShareStatus": {},
									"GatewayARN": {},
									"KMSEncrypted": {
										"type": "boolean"
									},
									"KMSKey": {},
									"Path": {},
									"Role": {},
									"LocationARN": {},
									"DefaultStorageClass": {},
									"ClientList": {
										"shape": "S1d"
									}
								}
							}
						}
					}
				}
			},
			"DescribeSnapshotSchedule": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN"
					],
					"members": {
						"VolumeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {},
						"StartAt": {
							"type": "integer"
						},
						"RecurrenceInHours": {
							"type": "integer"
						},
						"Description": {},
						"Timezone": {}
					}
				}
			},
			"DescribeStorediSCSIVolumes": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARNs"
					],
					"members": {
						"VolumeARNs": {
							"shape": "S2p"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StorediSCSIVolumes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeARN": {},
									"VolumeId": {},
									"VolumeType": {},
									"VolumeStatus": {},
									"VolumeSizeInBytes": {
										"type": "long"
									},
									"VolumeProgress": {
										"type": "double"
									},
									"VolumeDiskId": {},
									"SourceSnapshotId": {},
									"PreservedExistingData": {
										"type": "boolean"
									},
									"VolumeiSCSIAttributes": {
										"shape": "S2x"
									},
									"CreatedDate": {
										"type": "timestamp"
									}
								}
							}
						}
					}
				}
			},
			"DescribeTapeArchives": {
				"input": {
					"type": "structure",
					"members": {
						"TapeARNs": {
							"shape": "S1y"
						},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeArchives": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TapeARN": {},
									"TapeBarcode": {},
									"TapeCreatedDate": {
										"type": "timestamp"
									},
									"TapeSizeInBytes": {
										"type": "long"
									},
									"CompletionTime": {
										"type": "timestamp"
									},
									"RetrievedTo": {},
									"TapeStatus": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeTapeRecoveryPoints": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"TapeRecoveryPointInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TapeARN": {},
									"TapeRecoveryPointTime": {
										"type": "timestamp"
									},
									"TapeSizeInBytes": {
										"type": "long"
									},
									"TapeStatus": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeTapes": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"TapeARNs": {
							"shape": "S1y"
						},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Tapes": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TapeARN": {},
									"TapeBarcode": {},
									"TapeCreatedDate": {
										"type": "timestamp"
									},
									"TapeSizeInBytes": {
										"type": "long"
									},
									"TapeStatus": {},
									"VTLDevice": {},
									"Progress": {
										"type": "double"
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeUploadBuffer": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sc"
						},
						"UploadBufferUsedInBytes": {
							"type": "long"
						},
						"UploadBufferAllocatedInBytes": {
							"type": "long"
						}
					}
				}
			},
			"DescribeVTLDevices": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"VTLDeviceARNs": {
							"type": "list",
							"member": {}
						},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"VTLDevices": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VTLDeviceARN": {},
									"VTLDeviceType": {},
									"VTLDeviceVendor": {},
									"VTLDeviceProductIdentifier": {},
									"DeviceiSCSIAttributes": {
										"type": "structure",
										"members": {
											"TargetARN": {},
											"NetworkInterfaceId": {},
											"NetworkInterfacePort": {
												"type": "integer"
											},
											"ChapEnabled": {
												"type": "boolean"
											}
										}
									}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"DescribeWorkingStorage": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"DiskIds": {
							"shape": "Sc"
						},
						"WorkingStorageUsedInBytes": {
							"type": "long"
						},
						"WorkingStorageAllocatedInBytes": {
							"type": "long"
						}
					}
				}
			},
			"DisableGateway": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"ListFileShares": {
				"input": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"Limit": {
							"type": "integer"
						},
						"Marker": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Marker": {},
						"NextMarker": {},
						"FileShareInfoList": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"FileShareARN": {},
									"FileShareId": {},
									"FileShareStatus": {},
									"GatewayARN": {}
								}
							}
						}
					}
				}
			},
			"ListGateways": {
				"input": {
					"type": "structure",
					"members": {
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Gateways": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"GatewayId": {},
									"GatewayARN": {},
									"GatewayType": {},
									"GatewayOperationalState": {},
									"GatewayName": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListLocalDisks": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"Disks": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"DiskId": {},
									"DiskPath": {},
									"DiskNode": {},
									"DiskStatus": {},
									"DiskSizeInBytes": {
										"type": "long"
									},
									"DiskAllocationType": {},
									"DiskAllocationResource": {}
								}
							}
						}
					}
				}
			},
			"ListTagsForResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN"
					],
					"members": {
						"ResourceARN": {},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceARN": {},
						"Marker": {},
						"Tags": {
							"shape": "Sh"
						}
					}
				}
			},
			"ListTapes": {
				"input": {
					"type": "structure",
					"members": {
						"TapeARNs": {
							"shape": "S1y"
						},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"TapeARN": {},
									"TapeBarcode": {},
									"TapeSizeInBytes": {
										"type": "long"
									},
									"TapeStatus": {},
									"GatewayARN": {}
								}
							}
						},
						"Marker": {}
					}
				}
			},
			"ListVolumeInitiators": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN"
					],
					"members": {
						"VolumeARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Initiators": {
							"type": "list",
							"member": {}
						}
					}
				}
			},
			"ListVolumeRecoveryPoints": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"VolumeRecoveryPointInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeARN": {},
									"VolumeSizeInBytes": {
										"type": "long"
									},
									"VolumeUsageInBytes": {
										"type": "long"
									},
									"VolumeRecoveryPointTime": {}
								}
							}
						}
					}
				}
			},
			"ListVolumes": {
				"input": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"Marker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"Marker": {},
						"VolumeInfos": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"VolumeARN": {},
									"VolumeId": {},
									"GatewayARN": {},
									"GatewayId": {},
									"VolumeType": {},
									"VolumeSizeInBytes": {
										"type": "long"
									}
								}
							}
						}
					}
				}
			},
			"RemoveTagsFromResource": {
				"input": {
					"type": "structure",
					"required": [
						"ResourceARN",
						"TagKeys"
					],
					"members": {
						"ResourceARN": {},
						"TagKeys": {
							"type": "list",
							"member": {}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ResourceARN": {}
					}
				}
			},
			"ResetCache": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"RetrieveTapeArchive": {
				"input": {
					"type": "structure",
					"required": [
						"TapeARN",
						"GatewayARN"
					],
					"members": {
						"TapeARN": {},
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"RetrieveTapeRecoveryPoint": {
				"input": {
					"type": "structure",
					"required": [
						"TapeARN",
						"GatewayARN"
					],
					"members": {
						"TapeARN": {},
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TapeARN": {}
					}
				}
			},
			"SetLocalConsolePassword": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"LocalConsolePassword"
					],
					"members": {
						"GatewayARN": {},
						"LocalConsolePassword": {
							"type": "string",
							"sensitive": true
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"ShutdownGateway": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"StartGateway": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"UpdateBandwidthRateLimit": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"AverageUploadRateLimitInBitsPerSec": {
							"type": "long"
						},
						"AverageDownloadRateLimitInBitsPerSec": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"UpdateChapCredentials": {
				"input": {
					"type": "structure",
					"required": [
						"TargetARN",
						"SecretToAuthenticateInitiator",
						"InitiatorName"
					],
					"members": {
						"TargetARN": {},
						"SecretToAuthenticateInitiator": {},
						"InitiatorName": {},
						"SecretToAuthenticateTarget": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"TargetARN": {},
						"InitiatorName": {}
					}
				}
			},
			"UpdateGatewayInformation": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {},
						"GatewayName": {},
						"GatewayTimezone": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {},
						"GatewayName": {}
					}
				}
			},
			"UpdateGatewaySoftwareNow": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN"
					],
					"members": {
						"GatewayARN": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"UpdateMaintenanceStartTime": {
				"input": {
					"type": "structure",
					"required": [
						"GatewayARN",
						"HourOfDay",
						"MinuteOfHour",
						"DayOfWeek"
					],
					"members": {
						"GatewayARN": {},
						"HourOfDay": {
							"type": "integer"
						},
						"MinuteOfHour": {
							"type": "integer"
						},
						"DayOfWeek": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"GatewayARN": {}
					}
				}
			},
			"UpdateNFSFileShare": {
				"input": {
					"type": "structure",
					"required": [
						"FileShareARN"
					],
					"members": {
						"FileShareARN": {},
						"KMSEncrypted": {
							"type": "boolean"
						},
						"KMSKey": {},
						"NFSFileShareDefaults": {
							"shape": "S15"
						},
						"DefaultStorageClass": {},
						"ClientList": {
							"shape": "S1d"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"FileShareARN": {}
					}
				}
			},
			"UpdateSnapshotSchedule": {
				"input": {
					"type": "structure",
					"required": [
						"VolumeARN",
						"StartAt",
						"RecurrenceInHours"
					],
					"members": {
						"VolumeARN": {},
						"StartAt": {
							"type": "integer"
						},
						"RecurrenceInHours": {
							"type": "integer"
						},
						"Description": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VolumeARN": {}
					}
				}
			},
			"UpdateVTLDeviceType": {
				"input": {
					"type": "structure",
					"required": [
						"VTLDeviceARN",
						"DeviceType"
					],
					"members": {
						"VTLDeviceARN": {},
						"DeviceType": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"VTLDeviceARN": {}
					}
				}
			}
		},
		"shapes": {
			"Sc": {
				"type": "list",
				"member": {}
			},
			"Sh": {
				"type": "list",
				"member": {
					"type": "structure",
					"required": [
						"Key",
						"Value"
					],
					"members": {
						"Key": {},
						"Value": {}
					}
				}
			},
			"S15": {
				"type": "structure",
				"members": {
					"FileMode": {},
					"DirectoryMode": {},
					"GroupId": {
						"type": "long"
					},
					"OwnerId": {
						"type": "long"
					}
				}
			},
			"S1d": {
				"type": "list",
				"member": {}
			},
			"S1y": {
				"type": "list",
				"member": {}
			},
			"S2p": {
				"type": "list",
				"member": {}
			},
			"S2x": {
				"type": "structure",
				"members": {
					"TargetARN": {},
					"NetworkInterfaceId": {},
					"NetworkInterfacePort": {
						"type": "integer"
					},
					"LunNumber": {
						"type": "integer"
					},
					"ChapEnabled": {
						"type": "boolean"
					}
				}
			}
		}
	};

/***/ },
/* 766 */
/***/ function(module, exports) {

	module.exports = {
		"pagination": {
			"DescribeCachediSCSIVolumes": {
				"result_key": "CachediSCSIVolumes"
			},
			"DescribeStorediSCSIVolumes": {
				"result_key": "StorediSCSIVolumes"
			},
			"DescribeTapeArchives": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "TapeArchives"
			},
			"DescribeTapeRecoveryPoints": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "TapeRecoveryPointInfos"
			},
			"DescribeTapes": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "Tapes"
			},
			"DescribeVTLDevices": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "VTLDevices"
			},
			"ListGateways": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "Gateways"
			},
			"ListLocalDisks": {
				"result_key": "Disks"
			},
			"ListVolumeRecoveryPoints": {
				"result_key": "VolumeRecoveryPointInfos"
			},
			"ListVolumes": {
				"input_token": "Marker",
				"limit_key": "Limit",
				"output_token": "Marker",
				"result_key": "VolumeInfos"
			}
		}
	};

/***/ },
/* 767 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2012-08-10",
			"endpointPrefix": "streams.dynamodb",
			"jsonVersion": "1.0",
			"protocol": "json",
			"serviceFullName": "Amazon DynamoDB Streams",
			"signatureVersion": "v4",
			"signingName": "dynamodb",
			"targetPrefix": "DynamoDBStreams_20120810",
			"uid": "streams-dynamodb-2012-08-10"
		},
		"operations": {
			"DescribeStream": {
				"input": {
					"type": "structure",
					"required": [
						"StreamArn"
					],
					"members": {
						"StreamArn": {},
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartShardId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"StreamDescription": {
							"type": "structure",
							"members": {
								"StreamArn": {},
								"StreamLabel": {},
								"StreamStatus": {},
								"StreamViewType": {},
								"CreationRequestDateTime": {
									"type": "timestamp"
								},
								"TableName": {},
								"KeySchema": {
									"type": "list",
									"member": {
										"type": "structure",
										"required": [
											"AttributeName",
											"KeyType"
										],
										"members": {
											"AttributeName": {},
											"KeyType": {}
										}
									}
								},
								"Shards": {
									"type": "list",
									"member": {
										"type": "structure",
										"members": {
											"ShardId": {},
											"SequenceNumberRange": {
												"type": "structure",
												"members": {
													"StartingSequenceNumber": {},
													"EndingSequenceNumber": {}
												}
											},
											"ParentShardId": {}
										}
									}
								},
								"LastEvaluatedShardId": {}
							}
						}
					}
				}
			},
			"GetRecords": {
				"input": {
					"type": "structure",
					"required": [
						"ShardIterator"
					],
					"members": {
						"ShardIterator": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Records": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"eventID": {},
									"eventName": {},
									"eventVersion": {},
									"eventSource": {},
									"awsRegion": {},
									"dynamodb": {
										"type": "structure",
										"members": {
											"ApproximateCreationDateTime": {
												"type": "timestamp"
											},
											"Keys": {
												"shape": "Sr"
											},
											"NewImage": {
												"shape": "Sr"
											},
											"OldImage": {
												"shape": "Sr"
											},
											"SequenceNumber": {},
											"SizeBytes": {
												"type": "long"
											},
											"StreamViewType": {}
										}
									}
								}
							}
						},
						"NextShardIterator": {}
					}
				}
			},
			"GetShardIterator": {
				"input": {
					"type": "structure",
					"required": [
						"StreamArn",
						"ShardId",
						"ShardIteratorType"
					],
					"members": {
						"StreamArn": {},
						"ShardId": {},
						"ShardIteratorType": {},
						"SequenceNumber": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ShardIterator": {}
					}
				}
			},
			"ListStreams": {
				"input": {
					"type": "structure",
					"members": {
						"TableName": {},
						"Limit": {
							"type": "integer"
						},
						"ExclusiveStartStreamArn": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Streams": {
							"type": "list",
							"member": {
								"type": "structure",
								"members": {
									"StreamArn": {},
									"TableName": {},
									"StreamLabel": {}
								}
							}
						},
						"LastEvaluatedStreamArn": {}
					}
				}
			}
		},
		"shapes": {
			"Sr": {
				"type": "map",
				"key": {},
				"value": {
					"shape": "St"
				}
			},
			"St": {
				"type": "structure",
				"members": {
					"S": {},
					"N": {},
					"B": {
						"type": "blob"
					},
					"SS": {
						"type": "list",
						"member": {}
					},
					"NS": {
						"type": "list",
						"member": {}
					},
					"BS": {
						"type": "list",
						"member": {
							"type": "blob"
						}
					},
					"M": {
						"type": "map",
						"key": {},
						"value": {
							"shape": "St"
						}
					},
					"L": {
						"type": "list",
						"member": {
							"shape": "St"
						}
					},
					"NULL": {
						"type": "boolean"
					},
					"BOOL": {
						"type": "boolean"
					}
				}
			}
		}
	};

/***/ },
/* 768 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"apiVersion": "2011-06-15",
			"endpointPrefix": "sts",
			"globalEndpoint": "sts.amazonaws.com",
			"protocol": "query",
			"serviceAbbreviation": "AWS STS",
			"serviceFullName": "AWS Security Token Service",
			"signatureVersion": "v4",
			"uid": "sts-2011-06-15",
			"xmlNamespace": "https://sts.amazonaws.com/doc/2011-06-15/"
		},
		"operations": {
			"AssumeRole": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"RoleSessionName"
					],
					"members": {
						"RoleArn": {},
						"RoleSessionName": {},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						},
						"ExternalId": {},
						"SerialNumber": {},
						"TokenCode": {}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						},
						"AssumedRoleUser": {
							"shape": "Sf"
						},
						"PackedPolicySize": {
							"type": "integer"
						}
					}
				}
			},
			"AssumeRoleWithSAML": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"PrincipalArn",
						"SAMLAssertion"
					],
					"members": {
						"RoleArn": {},
						"PrincipalArn": {},
						"SAMLAssertion": {},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleWithSAMLResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						},
						"AssumedRoleUser": {
							"shape": "Sf"
						},
						"PackedPolicySize": {
							"type": "integer"
						},
						"Subject": {},
						"SubjectType": {},
						"Issuer": {},
						"Audience": {},
						"NameQualifier": {}
					}
				}
			},
			"AssumeRoleWithWebIdentity": {
				"input": {
					"type": "structure",
					"required": [
						"RoleArn",
						"RoleSessionName",
						"WebIdentityToken"
					],
					"members": {
						"RoleArn": {},
						"RoleSessionName": {},
						"WebIdentityToken": {},
						"ProviderId": {},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "AssumeRoleWithWebIdentityResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						},
						"SubjectFromWebIdentityToken": {},
						"AssumedRoleUser": {
							"shape": "Sf"
						},
						"PackedPolicySize": {
							"type": "integer"
						},
						"Provider": {},
						"Audience": {}
					}
				}
			},
			"DecodeAuthorizationMessage": {
				"input": {
					"type": "structure",
					"required": [
						"EncodedMessage"
					],
					"members": {
						"EncodedMessage": {}
					}
				},
				"output": {
					"resultWrapper": "DecodeAuthorizationMessageResult",
					"type": "structure",
					"members": {
						"DecodedMessage": {}
					}
				}
			},
			"GetCallerIdentity": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"resultWrapper": "GetCallerIdentityResult",
					"type": "structure",
					"members": {
						"UserId": {},
						"Account": {},
						"Arn": {}
					}
				}
			},
			"GetFederationToken": {
				"input": {
					"type": "structure",
					"required": [
						"Name"
					],
					"members": {
						"Name": {},
						"Policy": {},
						"DurationSeconds": {
							"type": "integer"
						}
					}
				},
				"output": {
					"resultWrapper": "GetFederationTokenResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						},
						"FederatedUser": {
							"type": "structure",
							"required": [
								"FederatedUserId",
								"Arn"
							],
							"members": {
								"FederatedUserId": {},
								"Arn": {}
							}
						},
						"PackedPolicySize": {
							"type": "integer"
						}
					}
				}
			},
			"GetSessionToken": {
				"input": {
					"type": "structure",
					"members": {
						"DurationSeconds": {
							"type": "integer"
						},
						"SerialNumber": {},
						"TokenCode": {}
					}
				},
				"output": {
					"resultWrapper": "GetSessionTokenResult",
					"type": "structure",
					"members": {
						"Credentials": {
							"shape": "Sa"
						}
					}
				}
			}
		},
		"shapes": {
			"Sa": {
				"type": "structure",
				"required": [
					"AccessKeyId",
					"SecretAccessKey",
					"SessionToken",
					"Expiration"
				],
				"members": {
					"AccessKeyId": {},
					"SecretAccessKey": {},
					"SessionToken": {},
					"Expiration": {
						"type": "timestamp"
					}
				}
			},
			"Sf": {
				"type": "structure",
				"required": [
					"AssumedRoleId",
					"Arn"
				],
				"members": {
					"AssumedRoleId": {},
					"Arn": {}
				}
			}
		}
	};

/***/ },
/* 769 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2.0",
		"metadata": {
			"uid": "waf-2015-08-24",
			"apiVersion": "2015-08-24",
			"endpointPrefix": "waf",
			"jsonVersion": "1.1",
			"protocol": "json",
			"serviceAbbreviation": "WAF",
			"serviceFullName": "AWS WAF",
			"signatureVersion": "v4",
			"targetPrefix": "AWSWAF_20150824"
		},
		"operations": {
			"CreateByteMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ByteMatchSet": {
							"shape": "S5"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateIPSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IPSet": {
							"shape": "Sh"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateRule": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"MetricName",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"MetricName": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rule": {
							"shape": "Sp"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateSizeConstraintSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SizeConstraintSet": {
							"shape": "Sw"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateSqlInjectionMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SqlInjectionMatchSet": {
							"shape": "S13"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateWebACL": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"MetricName",
						"DefaultAction",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"MetricName": {},
						"DefaultAction": {
							"shape": "S17"
						},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WebACL": {
							"shape": "S1a"
						},
						"ChangeToken": {}
					}
				}
			},
			"CreateXssMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"Name",
						"ChangeToken"
					],
					"members": {
						"Name": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"XssMatchSet": {
							"shape": "S1g"
						},
						"ChangeToken": {}
					}
				}
			},
			"DeleteByteMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"ByteMatchSetId",
						"ChangeToken"
					],
					"members": {
						"ByteMatchSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteIPSet": {
				"input": {
					"type": "structure",
					"required": [
						"IPSetId",
						"ChangeToken"
					],
					"members": {
						"IPSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId",
						"ChangeToken"
					],
					"members": {
						"RuleId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteSizeConstraintSet": {
				"input": {
					"type": "structure",
					"required": [
						"SizeConstraintSetId",
						"ChangeToken"
					],
					"members": {
						"SizeConstraintSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteSqlInjectionMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"SqlInjectionMatchSetId",
						"ChangeToken"
					],
					"members": {
						"SqlInjectionMatchSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteWebACL": {
				"input": {
					"type": "structure",
					"required": [
						"WebACLId",
						"ChangeToken"
					],
					"members": {
						"WebACLId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"DeleteXssMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"XssMatchSetId",
						"ChangeToken"
					],
					"members": {
						"XssMatchSetId": {},
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"GetByteMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"ByteMatchSetId"
					],
					"members": {
						"ByteMatchSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ByteMatchSet": {
							"shape": "S5"
						}
					}
				}
			},
			"GetChangeToken": {
				"input": {
					"type": "structure",
					"members": {}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"GetChangeTokenStatus": {
				"input": {
					"type": "structure",
					"required": [
						"ChangeToken"
					],
					"members": {
						"ChangeToken": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeTokenStatus": {}
					}
				}
			},
			"GetIPSet": {
				"input": {
					"type": "structure",
					"required": [
						"IPSetId"
					],
					"members": {
						"IPSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"IPSet": {
							"shape": "Sh"
						}
					}
				}
			},
			"GetRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId"
					],
					"members": {
						"RuleId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"Rule": {
							"shape": "Sp"
						}
					}
				}
			},
			"GetSampledRequests": {
				"input": {
					"type": "structure",
					"required": [
						"WebAclId",
						"RuleId",
						"TimeWindow",
						"MaxItems"
					],
					"members": {
						"WebAclId": {},
						"RuleId": {},
						"TimeWindow": {
							"shape": "S29"
						},
						"MaxItems": {
							"type": "long"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SampledRequests": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Request",
									"Weight"
								],
								"members": {
									"Request": {
										"type": "structure",
										"members": {
											"ClientIP": {},
											"Country": {},
											"URI": {},
											"Method": {},
											"HTTPVersion": {},
											"Headers": {
												"type": "list",
												"member": {
													"type": "structure",
													"members": {
														"Name": {},
														"Value": {}
													}
												}
											}
										}
									},
									"Weight": {
										"type": "long"
									},
									"Timestamp": {
										"type": "timestamp"
									},
									"Action": {}
								}
							}
						},
						"PopulationSize": {
							"type": "long"
						},
						"TimeWindow": {
							"shape": "S29"
						}
					}
				}
			},
			"GetSizeConstraintSet": {
				"input": {
					"type": "structure",
					"required": [
						"SizeConstraintSetId"
					],
					"members": {
						"SizeConstraintSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SizeConstraintSet": {
							"shape": "Sw"
						}
					}
				}
			},
			"GetSqlInjectionMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"SqlInjectionMatchSetId"
					],
					"members": {
						"SqlInjectionMatchSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"SqlInjectionMatchSet": {
							"shape": "S13"
						}
					}
				}
			},
			"GetWebACL": {
				"input": {
					"type": "structure",
					"required": [
						"WebACLId"
					],
					"members": {
						"WebACLId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"WebACL": {
							"shape": "S1a"
						}
					}
				}
			},
			"GetXssMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"XssMatchSetId"
					],
					"members": {
						"XssMatchSetId": {}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"XssMatchSet": {
							"shape": "S1g"
						}
					}
				}
			},
			"ListByteMatchSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"ByteMatchSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"ByteMatchSetId",
									"Name"
								],
								"members": {
									"ByteMatchSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListIPSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"IPSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"IPSetId",
									"Name"
								],
								"members": {
									"IPSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListRules": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Rules": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"RuleId",
									"Name"
								],
								"members": {
									"RuleId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListSizeConstraintSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"SizeConstraintSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"SizeConstraintSetId",
									"Name"
								],
								"members": {
									"SizeConstraintSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListSqlInjectionMatchSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"SqlInjectionMatchSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"SqlInjectionMatchSetId",
									"Name"
								],
								"members": {
									"SqlInjectionMatchSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListWebACLs": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"WebACLs": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"WebACLId",
									"Name"
								],
								"members": {
									"WebACLId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"ListXssMatchSets": {
				"input": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"Limit": {
							"type": "integer"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"NextMarker": {},
						"XssMatchSets": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"XssMatchSetId",
									"Name"
								],
								"members": {
									"XssMatchSetId": {},
									"Name": {}
								}
							}
						}
					}
				}
			},
			"UpdateByteMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"ByteMatchSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"ByteMatchSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"ByteMatchTuple"
								],
								"members": {
									"Action": {},
									"ByteMatchTuple": {
										"shape": "S8"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateIPSet": {
				"input": {
					"type": "structure",
					"required": [
						"IPSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"IPSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"IPSetDescriptor"
								],
								"members": {
									"Action": {},
									"IPSetDescriptor": {
										"shape": "Sj"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateRule": {
				"input": {
					"type": "structure",
					"required": [
						"RuleId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"RuleId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"Predicate"
								],
								"members": {
									"Action": {},
									"Predicate": {
										"shape": "Sr"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateSizeConstraintSet": {
				"input": {
					"type": "structure",
					"required": [
						"SizeConstraintSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"SizeConstraintSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"SizeConstraint"
								],
								"members": {
									"Action": {},
									"SizeConstraint": {
										"shape": "Sy"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateSqlInjectionMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"SqlInjectionMatchSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"SqlInjectionMatchSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"SqlInjectionMatchTuple"
								],
								"members": {
									"Action": {},
									"SqlInjectionMatchTuple": {
										"shape": "S15"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateWebACL": {
				"input": {
					"type": "structure",
					"required": [
						"WebACLId",
						"ChangeToken"
					],
					"members": {
						"WebACLId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"ActivatedRule"
								],
								"members": {
									"Action": {},
									"ActivatedRule": {
										"shape": "S1c"
									}
								}
							}
						},
						"DefaultAction": {
							"shape": "S17"
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			},
			"UpdateXssMatchSet": {
				"input": {
					"type": "structure",
					"required": [
						"XssMatchSetId",
						"ChangeToken",
						"Updates"
					],
					"members": {
						"XssMatchSetId": {},
						"ChangeToken": {},
						"Updates": {
							"type": "list",
							"member": {
								"type": "structure",
								"required": [
									"Action",
									"XssMatchTuple"
								],
								"members": {
									"Action": {},
									"XssMatchTuple": {
										"shape": "S1i"
									}
								}
							}
						}
					}
				},
				"output": {
					"type": "structure",
					"members": {
						"ChangeToken": {}
					}
				}
			}
		},
		"shapes": {
			"S5": {
				"type": "structure",
				"required": [
					"ByteMatchSetId",
					"ByteMatchTuples"
				],
				"members": {
					"ByteMatchSetId": {},
					"Name": {},
					"ByteMatchTuples": {
						"type": "list",
						"member": {
							"shape": "S8"
						}
					}
				}
			},
			"S8": {
				"type": "structure",
				"required": [
					"FieldToMatch",
					"TargetString",
					"TextTransformation",
					"PositionalConstraint"
				],
				"members": {
					"FieldToMatch": {
						"shape": "S9"
					},
					"TargetString": {
						"type": "blob"
					},
					"TextTransformation": {},
					"PositionalConstraint": {}
				}
			},
			"S9": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"Type": {},
					"Data": {}
				}
			},
			"Sh": {
				"type": "structure",
				"required": [
					"IPSetId",
					"IPSetDescriptors"
				],
				"members": {
					"IPSetId": {},
					"Name": {},
					"IPSetDescriptors": {
						"type": "list",
						"member": {
							"shape": "Sj"
						}
					}
				}
			},
			"Sj": {
				"type": "structure",
				"required": [
					"Type",
					"Value"
				],
				"members": {
					"Type": {},
					"Value": {}
				}
			},
			"Sp": {
				"type": "structure",
				"required": [
					"RuleId",
					"Predicates"
				],
				"members": {
					"RuleId": {},
					"Name": {},
					"MetricName": {},
					"Predicates": {
						"type": "list",
						"member": {
							"shape": "Sr"
						}
					}
				}
			},
			"Sr": {
				"type": "structure",
				"required": [
					"Negated",
					"Type",
					"DataId"
				],
				"members": {
					"Negated": {
						"type": "boolean"
					},
					"Type": {},
					"DataId": {}
				}
			},
			"Sw": {
				"type": "structure",
				"required": [
					"SizeConstraintSetId",
					"SizeConstraints"
				],
				"members": {
					"SizeConstraintSetId": {},
					"Name": {},
					"SizeConstraints": {
						"type": "list",
						"member": {
							"shape": "Sy"
						}
					}
				}
			},
			"Sy": {
				"type": "structure",
				"required": [
					"FieldToMatch",
					"TextTransformation",
					"ComparisonOperator",
					"Size"
				],
				"members": {
					"FieldToMatch": {
						"shape": "S9"
					},
					"TextTransformation": {},
					"ComparisonOperator": {},
					"Size": {
						"type": "long"
					}
				}
			},
			"S13": {
				"type": "structure",
				"required": [
					"SqlInjectionMatchSetId",
					"SqlInjectionMatchTuples"
				],
				"members": {
					"SqlInjectionMatchSetId": {},
					"Name": {},
					"SqlInjectionMatchTuples": {
						"type": "list",
						"member": {
							"shape": "S15"
						}
					}
				}
			},
			"S15": {
				"type": "structure",
				"required": [
					"FieldToMatch",
					"TextTransformation"
				],
				"members": {
					"FieldToMatch": {
						"shape": "S9"
					},
					"TextTransformation": {}
				}
			},
			"S17": {
				"type": "structure",
				"required": [
					"Type"
				],
				"members": {
					"Type": {}
				}
			},
			"S1a": {
				"type": "structure",
				"required": [
					"WebACLId",
					"DefaultAction",
					"Rules"
				],
				"members": {
					"WebACLId": {},
					"Name": {},
					"MetricName": {},
					"DefaultAction": {
						"shape": "S17"
					},
					"Rules": {
						"type": "list",
						"member": {
							"shape": "S1c"
						}
					}
				}
			},
			"S1c": {
				"type": "structure",
				"required": [
					"Priority",
					"RuleId",
					"Action"
				],
				"members": {
					"Priority": {
						"type": "integer"
					},
					"RuleId": {},
					"Action": {
						"shape": "S17"
					}
				}
			},
			"S1g": {
				"type": "structure",
				"required": [
					"XssMatchSetId",
					"XssMatchTuples"
				],
				"members": {
					"XssMatchSetId": {},
					"Name": {},
					"XssMatchTuples": {
						"type": "list",
						"member": {
							"shape": "S1i"
						}
					}
				}
			},
			"S1i": {
				"type": "structure",
				"required": [
					"FieldToMatch",
					"TextTransformation"
				],
				"members": {
					"FieldToMatch": {
						"shape": "S9"
					},
					"TextTransformation": {}
				}
			},
			"S29": {
				"type": "structure",
				"required": [
					"StartTime",
					"EndTime"
				],
				"members": {
					"StartTime": {
						"type": "timestamp"
					},
					"EndTime": {
						"type": "timestamp"
					}
				}
			}
		}
	};

/***/ },
/* 770 */
/***/ function(module, exports) {

	module.exports = {
		"rules": {
			"*/*": {
				"endpoint": "{service}.{region}.amazonaws.com"
			},
			"cn-*/*": {
				"endpoint": "{service}.{region}.amazonaws.com.cn"
			},
			"*/budgets": "globalSSL",
			"*/cloudfront": "globalSSL",
			"*/iam": "globalSSL",
			"*/sts": "globalSSL",
			"*/importexport": {
				"endpoint": "{service}.amazonaws.com",
				"signatureVersion": "v2",
				"globalEndpoint": true
			},
			"*/route53": {
				"endpoint": "https://{service}.amazonaws.com",
				"signatureVersion": "v3https",
				"globalEndpoint": true
			},
			"*/waf": "globalSSL",
			"us-gov-*/iam": "globalGovCloud",
			"us-gov-*/sts": {
				"endpoint": "{service}.{region}.amazonaws.com"
			},
			"us-gov-west-1/s3": "s3dash",
			"us-west-1/s3": "s3dash",
			"us-west-2/s3": "s3dash",
			"eu-west-1/s3": "s3dash",
			"ap-southeast-1/s3": "s3dash",
			"ap-southeast-2/s3": "s3dash",
			"ap-northeast-1/s3": "s3dash",
			"sa-east-1/s3": "s3dash",
			"us-east-1/s3": {
				"endpoint": "{service}.amazonaws.com",
				"signatureVersion": "s3"
			},
			"us-east-1/sdb": {
				"endpoint": "{service}.amazonaws.com",
				"signatureVersion": "v2"
			},
			"*/sdb": {
				"endpoint": "{service}.{region}.amazonaws.com",
				"signatureVersion": "v2"
			}
		},
		"patterns": {
			"globalSSL": {
				"endpoint": "https://{service}.amazonaws.com",
				"globalEndpoint": true
			},
			"globalGovCloud": {
				"endpoint": "{service}.us-gov.amazonaws.com"
			},
			"s3dash": {
				"endpoint": "{service}-{region}.amazonaws.com",
				"signatureVersion": "s3"
			}
		}
	};

/***/ },
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/courtyardstone_landscape_logo.ab69f6d.png";

/***/ },
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(630)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(381),
	  /* template */
	  __webpack_require__(862),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(625)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(382),
	  /* template */
	  __webpack_require__(857),
	  /* scopeId */
	  "data-v-3b38506c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(624)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(383),
	  /* template */
	  __webpack_require__(856),
	  /* scopeId */
	  "data-v-35146ad5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(617)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(384),
	  /* template */
	  __webpack_require__(849),
	  /* scopeId */
	  "data-v-09046f97",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(631)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(385),
	  /* template */
	  __webpack_require__(863),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(622)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(387),
	  /* template */
	  __webpack_require__(854),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(618)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(388),
	  /* template */
	  __webpack_require__(850),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(632)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(389),
	  /* template */
	  __webpack_require__(864),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(629)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(390),
	  /* template */
	  __webpack_require__(861),
	  /* scopeId */
	  "data-v-c7c9e4ee",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(615)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(391),
	  /* template */
	  __webpack_require__(847),
	  /* scopeId */
	  "data-v-04eb75c5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(619)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(393),
	  /* template */
	  __webpack_require__(851),
	  /* scopeId */
	  "data-v-1102ed4b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(623)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(394),
	  /* template */
	  __webpack_require__(855),
	  /* scopeId */
	  "data-v-34a8bb68",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(621)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(395),
	  /* template */
	  __webpack_require__(853),
	  /* scopeId */
	  "data-v-1dffcc04",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(620)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(396),
	  /* template */
	  __webpack_require__(852),
	  /* scopeId */
	  "data-v-1af44a5a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(628)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(397),
	  /* template */
	  __webpack_require__(860),
	  /* scopeId */
	  "data-v-982b3c40",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(627)
	
	var Component = __webpack_require__(15)(
	  /* script */
	  __webpack_require__(398),
	  /* template */
	  __webpack_require__(859),
	  /* scopeId */
	  "data-v-76d4032a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ },
/* 847 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "login"
	    }
	  }, [_c('div', {
	    staticClass: "page_text container"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-8  col-xs-offset-2"
	  }, [_c('g-signin-button', {
	    staticClass: "csp-login btn z-depth-3 goog-login",
	    attrs: {
	      "params": _vm.googleSignInParams
	    },
	    on: {
	      "success": _vm.onGoogleSignInSuccess,
	      "error": _vm.onGoogleSignInError
	    }
	  }, [_vm._v("\n          Log in with Google\n        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-8  col-xs-offset-2"
	  }, [_c('fb-signin-button', {
	    staticClass: "csp-login btn z-depth-3 fb-login",
	    attrs: {
	      "params": _vm.facebookSignInParams
	    },
	    on: {
	      "success": _vm.onFacebookSignInSuccess,
	      "error": _vm.onFacebookSignInError
	    }
	  }, [_vm._v("\n          Log in with Facebook\n        ")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-8  col-xs-offset-2"
	  }, [_c('amz-signin-button', {
	    staticClass: "csp-login btn z-depth-3 amz-login",
	    attrs: {
	      "params": _vm.amazonSignInParams
	    },
	    on: {
	      "success": _vm.onAmazonSignInSuccess,
	      "error": _vm.onAmazonSigninError
	    }
	  }, [_vm._v("\n          Log in with Amazon\n        ")])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row csp-open-block csp-row-bot-h1r"
	  }, [_c('div', {
	    staticClass: "csp-title-id col-xs-1 col-xs-offset-2"
	  }, [_c('span', [_vm._v("Client Service Portal")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row csp-row-bot-1r"
	  }, [_c('div', {
	    staticClass: " csp-title-text col-xs-5  col-xs-offset-2"
	  }, [_c('span', [_vm._v("Please login with your prefered account below.")])])])
	}]}

/***/ },
/* 848 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row csp-card",
	    attrs: {
	      "id": "Workflow"
	    }
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [(_vm.heading !== undefined) ? _c('div', {
	    staticClass: "row csp-margin-top"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 "
	  }, [_c('p', {
	    staticClass: "csp-account-id"
	  }, [_vm._v(_vm._s(_vm.heading))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-block container-fluid"
	  }, [(_vm.backRoute !== undefined) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 csp-back-link-container"
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-left",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "csp-back-link-text",
	    attrs: {
	      "to": _vm.backRoute
	    }
	  }, [_vm._v(_vm._s(_vm.backNavLink))])], 1)]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 "
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.allInputValid || _vm.loading),
	      expression: "!allInputValid || loading"
	    }],
	    staticClass: "btn btn-disabled csp-btn-continue"
	  }, [_c('span', [_vm._v(_vm._s(_vm.navButton))])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.allInputValid && !_vm.loading),
	      expression: "allInputValid && !loading"
	    }]
	  }, [_c('router-link', {
	    staticClass: "btn btn-primary primary-color csp-btn-continue",
	    attrs: {
	      "to": _vm.nextRoute
	    }
	  }, [_vm._v(_vm._s(_vm.navButton))])], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('progress-dots', {
	    attrs: {
	      "totalSteps": _vm.workflowSteps,
	      "currentStep": _vm.currentStep
	    }
	  }), _vm._v(" "), _c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  })], 1)], 1)])])])])])
	},staticRenderFns: []}

/***/ },
/* 849 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "ProgressDots"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-offset-2 col-xs-8"
	  }, [_c('div', {
	    staticClass: "csp-progress-group"
	  }, _vm._l((_vm.totalSteps), function(n) {
	    return _c('div', {
	      staticClass: "csp-progress-dot",
	      class: {
	        'primary-color': n == _vm.currentStep
	      }
	    })
	  }))])])
	},staticRenderFns: []}

/***/ },
/* 850 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    on: {
	      "click": _vm.clicked
	    }
	  }, [_c('div', {
	    staticClass: " col-xs-8 col-xs-offset-2 csp-no-pad"
	  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.facebookSigninLoading) ? _c('div', {
	    staticClass: "col-xs-2 csp-no-pad"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Loading...")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 851 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "AddressInfo"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', [_c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.line1),
	      expression: "line1"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "type": "text",
	      "id": "csp_address_line1",
	      "name": "address-line1",
	      "autocomplete": "address-line1"
	    },
	    domProps: {
	      "value": (_vm.line1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.line1 = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.line1
	    },
	    attrs: {
	      "for": "csp_address_line1"
	    }
	  }, [_vm._v("Address Line 1")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.line2),
	      expression: "line2"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "type": "text",
	      "id": "csp_address_line2",
	      "name": "address-line2",
	      "autocomplete": "address-line2"
	    },
	    domProps: {
	      "value": (_vm.line2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.line2 = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.line2
	    },
	    attrs: {
	      "for": "csp_address_line2"
	    }
	  }, [_vm._v("Address Line 2")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.city),
	      expression: "city"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "type": "text",
	      "id": "csp_city",
	      "name": "address-level2",
	      "autocomplete": "address-level2"
	    },
	    domProps: {
	      "value": (_vm.city)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.city = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.city
	    },
	    attrs: {
	      "for": "csp_city"
	    }
	  }, [_vm._v("City")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.state),
	      expression: "state"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "type": "text",
	      "id": "csp_state",
	      "name": "address-level1",
	      "autocomplete": "address-level1"
	    },
	    domProps: {
	      "value": (_vm.state)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.state = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.state
	    },
	    attrs: {
	      "for": "csp_state"
	    }
	  }, [_vm._v("State")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ({
	        mask: _vm.zipMask,
	        jitMasking: true,
	        placeholder: ' '
	      }),
	      expression: "{ mask: zipMask, jitMasking: true, placeholder: ' '}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "csp_zip",
	      "name": "postal-code",
	      "autocomplete": "postal-code"
	    },
	    domProps: {
	      "value": _vm.zip
	    },
	    on: {
	      "maskinput": _vm.updateZip
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.zip
	    },
	    attrs: {
	      "for": "csp_zip"
	    }
	  }, [_vm._v("Zip Code")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('h4', {
	    staticClass: "col-xs-12 card-title csp-card-title"
	  }, [_vm._v("Address Information")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 "
	  }, [_c('p', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v("Go ahead and make any changes you need!")])])])
	}]}

/***/ },
/* 852 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "ServiceNotes"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', [_c('div', {
	    staticClass: "md-form"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.notes),
	      expression: "notes",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "md-textarea",
	    attrs: {
	      "type": "text",
	      "id": "csp-notes"
	    },
	    domProps: {
	      "value": (_vm.notes)
	    },
	    on: {
	      "change": function($event) {
	        _vm.notes = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.notes
	    },
	    attrs: {
	      "for": "csp-notes"
	    }
	  }, [_vm._v("Notes")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('h4', {
	    staticClass: "col-xs-12 card-title csp-card-title"
	  }, [_vm._v("Any Notes for Us?")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 "
	  }, [_c('p', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v("If you have any notes for us or our team or if you’d like us to reach out to you, please let us know below. Once you’re finished, just press “Submit” and that’s all you need to do!")])])])
	}]}

/***/ },
/* 853 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "ServiceChoices"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-3"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.springCleanup),
	      expression: "springCleanup"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "csp-service1"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.springCleanup) ? _vm._i(_vm.springCleanup, null) > -1 : (_vm.springCleanup)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.springCleanup,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.springCleanup = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.springCleanup = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.springCleanup = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "csp-service1"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-3"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.summerMaintenance),
	      expression: "summerMaintenance"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "csp-service2",
	      "disabled": !_vm.springCleanup
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.summerMaintenance) ? _vm._i(_vm.summerMaintenance, null) > -1 : (_vm.summerMaintenance)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.summerMaintenance,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.summerMaintenance = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.summerMaintenance = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.summerMaintenance = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "csp-service2"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_vm._m(4), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-3"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.fallCleanup),
	      expression: "fallCleanup"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "csp-service3",
	      "disabled": !_vm.summerMaintenance
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.fallCleanup) ? _vm._i(_vm.fallCleanup, null) > -1 : (_vm.fallCleanup)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.fallCleanup,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.fallCleanup = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.fallCleanup = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.fallCleanup = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "csp-service3"
	    }
	  })])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('h4', {
	    staticClass: "col-xs-12 card-title csp-card-title"
	  }, [_vm._v("2017 Service Choices")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 "
	  }, [_c('p', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v("We recommend our full three-step service package, but if you want to choose only spring cleanup and/or summer maintenance, please do so here.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-9"
	  }, [_c('div', {
	    staticClass: "md-form"
	  }, [_c('p', {
	    staticClass: "csp-service-id"
	  }, [_vm._v("Step 1 - Spring Cleanup")]), _vm._v(" "), _c('p', {
	    staticClass: "csp-service-text"
	  }, [_vm._v("Once the snow is gone, we will clean up winter debris, edge beds, turn mulch, cut perennials left over from winter, fertilize roses & hydrangeas, and apply pre-emergent to reduce weed growth.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-9"
	  }, [_c('div', {
	    staticClass: "md-form"
	  }, [_c('p', {
	    staticClass: "csp-service-id"
	  }, [_vm._v("Step 2 - Summer Maintenance")]), _vm._v(" "), _c('p', {
	    staticClass: " csp-service-text"
	  }, [_vm._v("Depending on the weather, at the end of May or in June, we will prune, edge, mulch, and apply another round of pre-emergent.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-9"
	  }, [_c('div', {
	    staticClass: "md-form"
	  }, [_c('p', {
	    staticClass: "csp-service-id"
	  }, [_vm._v("Step 3 - Fall Cleanup")]), _vm._v(" "), _c('p', {
	    staticClass: "csp-service-text"
	  }, [_vm._v("In the fall months, we will cut perennials, touch up any pruning,  and apply one last round of pre-emergent.")])])])
	}]}

/***/ },
/* 854 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "amazon-root"
	    },
	    on: {
	      "click": _vm.clicked
	    }
	  }, [_c('div', {
	    staticClass: " col-xs-8 col-xs-offset-2 csp-no-pad"
	  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.amazonSigninLoading) ? _c('div', {
	    staticClass: "col-xs-2 csp-no-pad"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Loading...")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 855 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "SendMessage"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', [_c('div', {
	    staticClass: "md-form"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.message),
	      expression: "message"
	    }],
	    staticClass: "md-textarea",
	    attrs: {
	      "type": "text",
	      "id": "csp-message"
	    },
	    domProps: {
	      "value": (_vm.message)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.message = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    attrs: {
	      "for": "csp-message"
	    }
	  }, [_vm._v("Message")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 "
	  }, [_c('p', {
	    staticClass: "card-text csp-banner-text csp-margin-top"
	  }, [_vm._v("\n      If you have any questions or need to change any information, \n      please send us a message using the form below. Thank you!")])])])
	}]}

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "masthead"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-12",
	    attrs: {
	      "id": "header_home"
	    }
	  }, [_c('div', {
	    staticClass: "row row-flat"
	  }, [_c('div', {
	    staticClass: "col-xs-offset-1"
	  }, [_c('a', {
	    attrs: {
	      "href": "index.html"
	    }
	  }, [_c('img', {
	    staticClass: "logo-csl",
	    attrs: {
	      "src": __webpack_require__(775),
	      "alt": "Couryard Stone & Landscape Logo"
	    }
	  })])])])])])
	}]}

/***/ },
/* 857 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "Loading"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "col-xs-2 csp-loading"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o-notch fa-spin fa-2"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Loading...")])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ },
/* 858 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "trailer"
	    }
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 csp-text-center"
	  }, [_c('span', {
	    staticClass: "csp-trailer-text"
	  }, [_vm._v("\n      © " + _vm._s(_vm.copyrightYear) + " "), _c('a', {
	    staticClass: "csp-router-link-text",
	    attrs: {
	      "href": _vm.website
	    }
	  }, [_vm._v(_vm._s(_vm.company))]), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": _vm.phonelink
	    }
	  }, [_vm._v(_vm._s(_vm._f("phone")(_vm.companyPhoneNumber)))]), _vm._v(" "), (_vm.socialIcons) ? _c('ul', {
	    staticClass: "social"
	  }, _vm._l((_vm.socialLinks), function(object, name) {
	    return _c('li', [_c('social-icon', {
	      attrs: {
	        "object": object,
	        "name": name
	      }
	    })], 1)
	  })) : _vm._e()])])])
	},staticRenderFns: []}

/***/ },
/* 859 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "Welcome"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('h4', {
	    staticClass: "col-xs-12 card-title csp-card-title"
	  }, [_vm._v("Welcome " + _vm._s(_vm.givenName || _vm.authName))])]), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 "
	  }, [_c('p', {
	    staticClass: "card-text csp-welcome-text"
	  }, [_vm._v("Since this is your first time logging in to Courtyard Stone & Landscape’s client service portal this year, we’d like to ask you to validate your information to make sure our records are accurate.")])])])
	}]}

/***/ },
/* 860 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "UserInfo"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('form', [_c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.givenName),
	      expression: "givenName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "type": "text",
	      "id": "csp_fname",
	      "name": "fname",
	      "autocomplete": "given-name"
	    },
	    domProps: {
	      "value": (_vm.givenName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.givenName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.givenName
	    },
	    attrs: {
	      "for": "csp_fname"
	    }
	  }, [_vm._v("First Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.surName),
	      expression: "surName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "type": "text",
	      "id": "csp_lname",
	      "name": "lname",
	      "autocomplete": "family-name"
	    },
	    domProps: {
	      "value": (_vm.surName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.surName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.surName
	    },
	    attrs: {
	      "for": "csp_lname"
	    }
	  }, [_vm._v("Last Name")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.emailAddress),
	      expression: "emailAddress"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "type": "email",
	      "id": "csp_email",
	      "name": "email",
	      "autocomplete": "email"
	    },
	    domProps: {
	      "value": (_vm.emailAddress)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.emailAddress = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.emailAddress
	    },
	    attrs: {
	      "for": "csp_email"
	    }
	  }, [_vm._v("Email Address")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ({
	        mask: _vm.phoneNumberMask,
	        jitMasking: true,
	        placeholder: ' ',
	        returnUnmasked: true
	      }),
	      expression: "{mask: phoneNumberMask, jitMasking: true, placeholder: ' ', returnUnmasked: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "required": "",
	      "type": "tel",
	      "id": "csp_tel_home",
	      "name": "tel",
	      "autocomplete": "tel"
	    },
	    domProps: {
	      "value": _vm.homePhoneNumber
	    },
	    on: {
	      "maskinput": _vm.updateHomePhoneNumber
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.homePhoneNumber
	    },
	    attrs: {
	      "for": "csp_tel_home"
	    }
	  }, [_vm._v("Phone Number (Home)")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-form"
	  }, [_c('input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ({
	        mask: _vm.phoneNumberMask,
	        jitMasking: true,
	        placeholder: ' ',
	        returnUnmasked: true
	      }),
	      expression: "{mask: phoneNumberMask, jitMasking: true, placeholder: ' ', returnUnmasked: true}"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "tel",
	      "id": "csp_tel_mobile",
	      "name": "tel",
	      "autocomplete": "tel"
	    },
	    domProps: {
	      "value": _vm.mobilePhoneNumber
	    },
	    on: {
	      "maskinput": _vm.updateMobilePhoneNumber
	    }
	  }), _vm._v(" "), _c('label', {
	    class: {
	      active: _vm.mobilePhoneNumber
	    },
	    attrs: {
	      "for": "csp_tel_mobile"
	    }
	  }, [_vm._v("Phone Number (Mobile)")])]), _vm._v(" "), _c('div', {
	    staticClass: "md-form"
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('h4', {
	    staticClass: "col-xs-12 card-title csp-card-title"
	  }, [_vm._v("Contact Information")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 "
	  }, [_c('p', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v("Go ahead and make any change you need!")])])])
	}]}

/***/ },
/* 861 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "Account"
	    }
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-block container-fluid"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('h4', {
	    staticClass: "col-xs-12 card-title csp-card-title"
	  }, [_vm._v(_vm._s(_vm.user.fullName))])]), _vm._v(" "), _c('div', {
	    staticClass: "row csp-margin-bottom"
	  }, [_c('div', {
	    staticClass: "col-xs-12 "
	  }, [_c('span', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v(_vm._s(_vm.user.emailAddress))]), _c('br'), _vm._v(" "), (_vm.user.phoneNumberHome) ? _c('div', [_c('span', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v(_vm._s(_vm._f("phone")(_vm.user.phoneNumberHome)))]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.user.phoneNumberMobile) ? _c('div', [_c('span', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v(_vm._s(_vm._f("phone")(_vm.user.phoneNumberMobile)))])]) : _vm._e()])])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 "
	  }, [_c('div', {
	    staticClass: "card"
	  }, [_c('div', {
	    staticClass: "card-block container-fluid"
	  }, [_c('div', {
	    staticClass: "row csp-margin-bottom"
	  }, [_c('h4', {
	    staticClass: "col-xs-12 card-title csp-card-title"
	  }, [_vm._v(_vm._s(_vm.address.line1))]), _vm._v(" "), _c('span', {
	    staticClass: "col-xs-12 card-title csp-card-title"
	  }, [_vm._v(_vm._s(_vm.address.line2))]), _vm._v(" "), _c('span', {
	    staticClass: "col-xs-12 card-title csp-card-title",
	    class: {
	      hidden: !_vm.ready
	    }
	  }, [_vm._v(_vm._s(_vm.address.city) + ", " + _vm._s(_vm.address.state) + " " + _vm._s(_vm.address.zip))])]), _vm._v(" "), _c('div', {
	    staticClass: "row csp-margin-bottom"
	  }, [_c('div', {
	    staticClass: "col-xs-11 col-xs-offset-1 "
	  }, [_c('hr', {
	    staticClass: "csp-account-margin"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v(_vm._s(_vm.service.serviceYear) + " Service Choices:")]), _c('br'), _vm._v(" "), (_vm.service.springCleanup) ? _c('div', [_c('span', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v("Step 1 - Spring Cleanup")]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.service.summerMaintenance) ? _c('div', [_c('span', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v("Step 2 - Summer Maintenance")]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.service.fallCleanup) ? _c('div', [_c('span', {
	    staticClass: "card-text csp-banner-text"
	  }, [_vm._v("Step 3 - Fall Cleanup")]), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.service.selected.length === 0) ? _c('div', [_c('span', {
	    staticClass: "card-text csp-banner-text csp-data-missing"
	  }, [_vm._v("(No Services Selected)")])]) : _vm._e(), _vm._v(" "), _c('hr', {
	    staticClass: "csp-account-margin"
	  })])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row csp-margin-top"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 csp-text-center"
	  }, [_c('p', {
	    staticClass: "csp-title-text"
	  }, [_vm._v("If you have any questions or need to change any information, please \n        "), _c('router-link', {
	    staticClass: "csp-router-link-text",
	    attrs: {
	      "to": "/SendMessage"
	    }
	  }, [_vm._v("send us a message")]), _vm._v(".")], 1)])]), _vm._v(" "), _c('trailer')], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row csp-margin-top"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
	  }, [_c('p', {
	    staticClass: "csp-account-id"
	  }, [_vm._v("Your Account")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row csp-margin-top"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
	  }, [_c('p', {
	    staticClass: "csp-account-id"
	  }, [_vm._v("Your Services")])])])
	}]}

/***/ },
/* 862 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container-fluid",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('masthead'), _vm._v(" "), _c('div', {
	    staticClass: "bg_image"
	  }), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 863 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": _vm.link,
	      "target": "_blank",
	      "alt": _vm.alt,
	      "title": _vm.title
	    }
	  }, [_c('i', {
	    class: _vm.fa_class
	  })])
	},staticRenderFns: []}

/***/ },
/* 864 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "GSignInBtn",
	    staticClass: "g-signin-button row",
	    on: {
	      "click": function($event) {
	        _vm.googleSigninLoading = true
	      }
	    }
	  }, [_c('div', {
	    staticClass: " col-xs-8 col-xs-offset-2 csp-no-pad"
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.googleSigninLoading) ? _c('div', {
	    staticClass: "col-xs-2 csp-no-pad"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Loading...")])]) : _vm._e()])], 1)
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.c68d76a7aedc031824f2.js